/*!
 * maptalks v1.12.1
 * LICENSE : BSD-3-Clause
 * (c) 2016-2026 maptalks.org
 */
var version = "1.12.1";

var IS_NODE = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]' && !process.versions['electron'] && !process.versions['nw'] && !process.versions['node-webkit'];
function getGlobalThis() {
  return typeof globalThis !== 'undefined' ? globalThis : global || self;
}
function checkMTKVersion(version) {
  var mtkversion = getGlobalThis().maptalksversion;
  if (mtkversion) {
    throw new Error("Disallow duplicate imports of maptalks version " + version + " and " + mtkversion);
  } else {
    getGlobalThis().maptalksversion = version;
  }
}

var GlobalConfig = {
  isTest: false,
  idleLog: false,
  idleForceTimeThreshold: 48,
  workerCount: getGlobalThis().MAPTALKS_WORKER_COUNT || 0,
  messagePostRatioPerWorker: 0.3,
  maxFPS: 0,
  crsMaxNativeZoom: 22
};

function now() {
  return Date.now();
}
function extend$2(dest, ...args) {
  for (var i = 0; i < args.length; i++) {
    var src = args[i];
    for (var k in src) {
      dest[k] = src[k];
    }
  }
  return dest;
}
function isNil(obj) {
  return obj == null;
}
function isNumber(val) {
  return typeof val === 'number' && !isNaN(val);
}
function isInteger(n) {
  return (n | 0) === n;
}
function isObject$1(obj) {
  return typeof obj === 'object' && !!obj;
}
function isString(obj) {
  if (isNil(obj)) {
    return false;
  }
  return typeof obj === 'string' || obj.constructor !== null && obj.constructor === String;
}
function isFunction(obj) {
  if (isNil(obj)) {
    return false;
  }
  return typeof obj === 'function' || obj.constructor !== null && obj.constructor === Function;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function join(arr, seperator) {
  if (arr.join) {
    return arr.join(seperator || ',');
  } else {
    return Array.prototype.join.call(arr, seperator || ',');
  }
}
function isEmpty(object) {
  var property;
  for (property in object) {
    return false;
  }
  return !property;
}
var pi = Math.PI / 180;
function toRadian(d) {
  return d * pi;
}
function toDegree(r) {
  return r / pi;
}
var warned = new Set();
function warnOnce(message) {
  if (!warned.has(message)) {
    console.warn(message);
    warned.add(message);
  }
}

var Browser = {};
function getDevicePixelRatio() {
  return window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;
}
if (!IS_NODE) {
  var ua = navigator.userAgent.toLowerCase(),
    doc = document.documentElement || {
      style: {}
    },
    ie = 'ActiveXObject' in window,
    webkit = ua.indexOf('webkit') !== -1,
    phantomjs = ua.indexOf('phantom') !== -1,
    android23 = ua.search('android [23]') !== -1,
    chrome = ua.indexOf('chrome') !== -1,
    gecko = ua.indexOf('gecko') !== -1 && !webkit && !window.opera && !ie,
    iosWeixin = /iphone/i.test(ua) && /micromessenger/i.test(ua),
    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
    msPointer = !window.PointerEvent && window.MSPointerEvent,
    pointer = window.PointerEvent && navigator.pointerEnabled || msPointer,
    ie3d = ie && 'transition' in doc.style,
    webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23,
    gecko3d = 'MozPerspective' in doc.style,
    opera12 = 'OTransition' in doc.style,
    any3d = (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,
    imageBitMap = typeof window !== 'undefined' && isFunction(window.createImageBitmap),
    resizeObserver$1 = typeof window !== 'undefined' && isFunction(window.ResizeObserver),
    btoa$1 = typeof window !== 'undefined' && isFunction(window.btoa),
    proxy = typeof window !== 'undefined' && isFunction(window.Proxy),
    requestIdleCallback$1 = typeof window !== 'undefined' && isFunction(window.requestIdleCallback),
    scheduler = typeof globalThis.scheduler !== 'undefined' && typeof globalThis.scheduler == 'object',
    roundRect = typeof CanvasRenderingContext2D !== 'undefined' && isFunction(CanvasRenderingContext2D.prototype.roundRect);
  var chromeVersion = 0;
  if (chrome) {
    chromeVersion = ua.match(/chrome\/([\d.]+)/)[1];
  }
  var touch = !phantomjs && (pointer || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
  var webgl = typeof window !== 'undefined' && 'WebGLRenderingContext' in window;
  var devicePixelRatio = getDevicePixelRatio();
  var decodeImageInWorker = false;
  try {
    var offCanvas = new OffscreenCanvas(2, 2);
    offCanvas.getContext('2d');
    decodeImageInWorker = true;
  } catch (err) {
    decodeImageInWorker = false;
  }
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
  } catch (e) {}
  Browser = {
    IS_NODE: IS_NODE,
    isTest: false,
    ie: ie,
    ielt9: ie && !document.addEventListener,
    edge: 'msLaunchUri' in navigator && !('documentMode' in document),
    webkit: webkit,
    gecko: gecko,
    android: ua.indexOf('android') !== -1,
    android23: android23,
    chrome: chrome,
    chromeVersion: chromeVersion,
    safari: !chrome && ua.indexOf('safari') !== -1,
    phantomjs: phantomjs,
    ie3d: ie3d,
    webkit3d: webkit3d,
    gecko3d: gecko3d,
    opera12: opera12,
    any3d: any3d,
    iosWeixin: iosWeixin,
    mobile: mobile,
    mobileWebkit: mobile && webkit,
    mobileWebkit3d: mobile && webkit3d,
    mobileOpera: mobile && window.opera,
    mobileGecko: mobile && gecko,
    touch: !!touch,
    msPointer: !!msPointer,
    pointer: !!pointer,
    retina: devicePixelRatio > 1,
    devicePixelRatio: devicePixelRatio,
    language: navigator.browserLanguage ? navigator.browserLanguage : navigator.language,
    ie9: ie && document.documentMode === 9,
    ie10: ie && document.documentMode === 10,
    webgl: webgl,
    imageBitMap: imageBitMap,
    roundRect: roundRect,
    resizeObserver: resizeObserver$1,
    btoa: btoa$1,
    decodeImageInWorker: decodeImageInWorker,
    monitorDPRChange: true,
    supportsPassive: supportsPassive,
    proxy: proxy,
    requestIdleCallback: requestIdleCallback$1,
    scheduler: scheduler,
    checkDevicePixelRatio: function checkDevicePixelRatio() {
      if (typeof window !== 'undefined' && Browser.monitorDPRChange) {
        var _devicePixelRatio = getDevicePixelRatio();
        var changed = _devicePixelRatio !== Browser.devicePixelRatio;
        if (changed) {
          Browser.devicePixelRatio = _devicePixelRatio;
        }
        return changed;
      }
      return false;
    }
  };
  if (!Browser.roundRect) {
    console.warn('current env the canvas not support roundRect');
  }
}
var Browser$1 = Browser;

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e  ) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r );
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

var Position = function () {
  function Position(x, y, z) {
    if (!isNil(x) && !isNil(y)) {
      this.x = +x;
      this.y = +y;
      this.z = z;
    } else if (!isNil(x.x) && !isNil(x.y)) {
      this.x = +x.x;
      this.y = +x.y;
      this.z = x.z;
    } else if (Array.isArray(x)) {
      this.x = +x[0];
      this.y = +x[1];
      this.z = x[2];
    }
    if (this._isNaN()) {
      throw new Error('Position is NaN');
    }
  }
  var _proto = Position.prototype;
  _proto.set = function set(x, y, z) {
    this.x = x;
    this.y = y;
    this.z = z || 0;
    return this;
  };
  _proto._abs = function _abs() {
    this.x = Math.abs(this.x);
    this.y = Math.abs(this.y);
    return this;
  };
  _proto._round = function _round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  };
  _proto._ceil = function _ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  };
  _proto.distanceTo = function distanceTo(point) {
    var x = point.x - this.x,
      y = point.y - this.y;
    return Math.sqrt(x * x + y * y);
  };
  _proto.mag = function mag() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  };
  _proto._floor = function _floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  };
  _proto._add = function _add(x, y) {
    if (!isNil(x.x)) {
      this.x += x.x;
      this.y += x.y;
    } else if (!isNil(x[0])) {
      this.x += x[0];
      this.y += x[1];
    } else {
      this.x += x;
      this.y += y;
    }
    return this;
  };
  _proto._sub = function _sub(x, y) {
    if (!isNil(x.x)) {
      this.x -= x.x;
      this.y -= x.y;
    } else if (!isNil(x[0])) {
      this.x -= x[0];
      this.y -= x[1];
    } else {
      this.x -= x;
      this.y -= y;
    }
    return this;
  };
  _proto._substract = function _substract(x, y) {
    if (isNumber(y)) {
      return this._sub(x, y);
    }
    return this._sub(x);
  };
  _proto.substract = function substract(x, y) {
    return this.sub(x, y);
  };
  _proto._multi = function _multi(ratio) {
    this.x *= ratio;
    this.y *= ratio;
    return this;
  };
  _proto.div = function div(n) {
    return this.multi(1 / n);
  };
  _proto._div = function _div(n) {
    return this._multi(1 / n);
  };
  _proto._isNaN = function _isNaN() {
    return isNaN(this.x) || isNaN(this.y) || isNumber(this.z) && isNaN(this.z);
  };
  _proto.isZero = function isZero() {
    return this.x === 0 && this.y === 0;
  };
  _proto.toArray = function toArray() {
    if (isNumber(this.z)) {
      return [this.x, this.y, this.z];
    }
    return [this.x, this.y];
  };
  _proto.toJSON = function toJSON() {
    var json = {
      x: this.x,
      y: this.y
    };
    if (isNumber(this.z)) {
      json.z = this.z;
    }
    return json;
  };
  return Position;
}();

var Point = function (_Position) {
  function Point() {
    return _Position.apply(this, arguments) || this;
  }
  _inheritsLoose(Point, _Position);
  var _proto = Point.prototype;
  _proto.closeTo = function closeTo(p, delta) {
    if (!delta) {
      delta = 0;
    }
    return this.x >= p.x - delta && this.x <= p.x + delta && this.y >= p.y - delta && this.y <= p.y + delta;
  };
  _proto.unit = function unit() {
    return this.copy()._unit();
  };
  _proto._unit = function _unit() {
    this._div(this.mag());
    return this;
  };
  _proto.perp = function perp() {
    return this.copy()._perp();
  };
  _proto._perp = function _perp() {
    [this.x, this.y] = [-this.y, this.x];
    return this;
  };
  _proto.angleWith = function angleWith(b) {
    return this.angleWithSep(b.x, b.y);
  };
  _proto.angleWithSep = function angleWithSep(x, y) {
    return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
  };
  _proto._rotate = function _rotate(angle) {
    var cos = Math.cos(angle),
      sin = Math.sin(angle),
      x = cos * this.x - sin * this.y,
      y = sin * this.x + cos * this.y;
    this.x = x;
    this.y = y;
    return this;
  };
  _proto.rotate = function rotate(a) {
    return this.copy()._rotate(a);
  };
  _proto.abs = function abs() {
    return new Point(Math.abs(this.x), Math.abs(this.y));
  };
  _proto.round = function round() {
    return new Point(Math.round(this.x), Math.round(this.y));
  };
  _proto.ceil = function ceil() {
    return new Point(Math.ceil(this.x), Math.ceil(this.y));
  };
  _proto.floor = function floor() {
    return new Point(Math.floor(this.x), Math.floor(this.y));
  };
  _proto.copy = function copy() {
    return new Point(this.x, this.y, this.z);
  };
  _proto.toFixed = function toFixed(n) {
    return new Point(this.x.toFixed(n), this.y.toFixed(n), isNumber(this.z) ? this.z.toFixed(n) : undefined);
  };
  _proto.add = function add(x, y) {
    var nx, ny;
    if (!isNil(x.x)) {
      nx = this.x + x.x;
      ny = this.y + x.y;
    } else if (!isNil(x[0])) {
      nx = this.x + x[0];
      ny = this.y + x[1];
    } else {
      nx = this.x + x;
      ny = this.y + y;
    }
    return new Point(nx, ny);
  };
  _proto.sub = function sub(x, y) {
    var nx, ny;
    if (!isNil(x.x)) {
      nx = this.x - x.x;
      ny = this.y - x.y;
    } else if (!isNil(x[0])) {
      nx = this.x - x[0];
      ny = this.y - x[1];
    } else {
      nx = this.x - x;
      ny = this.y - y;
    }
    return new Point(nx, ny);
  };
  _proto.multi = function multi(ratio) {
    return new Point(this.x * ratio, this.y * ratio);
  };
  _proto.equals = function equals(c) {
    if (!(c instanceof this.constructor)) {
      return false;
    }
    return this.x === c.x && this.y === c.y && this.z === c.z;
  };
  return Point;
}(Position);

var requestAnimFrame, cancelAnimFrame;
(function () {
  if (IS_NODE) {
    requestAnimFrame = function requestAnimFrame(fn) {
      return setTimeout(fn, 16);
    };
    cancelAnimFrame = clearTimeout;
    return;
  }
  requestAnimFrame = function requestAnimFrame(callback) {
    return requestAnimationFrame(callback);
  };
  cancelAnimFrame = function cancelAnimFrame(handle) {
    return cancelAnimationFrame(handle);
  };
})();
function isSVG(url) {
  var prefix = 'data:image/svg+xml';
  if (url.length > 4 && url.slice(-4) === '.svg') {
    return 1;
  } else if (url.slice(0, prefix.length) === prefix) {
    return 2;
  }
  return 0;
}
function loadImage(img, imgDesc) {
  if (IS_NODE && loadImage.node) {
    loadImage.node(img, imgDesc);
    return;
  }
  img.src = imgDesc[0];
}
var uid = 0;
function UID() {
  return uid++;
}
var GUID = UID;
function parseJSON(str) {
  if (!str || !isString(str)) {
    return str;
  }
  return JSON.parse(str);
}
function pushIn(...args) {
  var dest = args[0];
  for (var i = 1; i < args.length; i++) {
    var src = args[i];
    if (src && src.length) {
      for (var ii = 0, ll = src.length; ii < ll; ii++) {
        dest.push(src[ii]);
      }
    }
  }
  return dest.length;
}
function mergeArray(...args) {
  var dest = [];
  var idx = -1;
  for (var i = 0; i < args.length; i++) {
    var src = args[i];
    if (src && src.length) {
      for (var ii = 0, ll = src.length; ii < ll; ii++) {
        dest[++idx] = src[ii];
      }
    }
  }
  return dest;
}
function removeFromArray(obj, array) {
  var i = array.indexOf(obj);
  if (i > -1) {
    array.splice(i, 1);
  }
}
function forEachCoord(arr, fn, context) {
  if (!Array.isArray(arr)) {
    return context ? fn.call(context, arr) : fn(arr);
  }
  var result = [];
  var p, pp;
  for (var i = 0, len = arr.length; i < len; i++) {
    p = arr[i];
    if (isNil(p)) {
      result.push(null);
      continue;
    }
    if (Array.isArray(p)) {
      result.push(forEachCoord(p, fn, context));
    } else {
      pp = context ? fn.call(context, p) : fn(p);
      result.push(pp);
    }
  }
  return result;
}
function getValueOrDefault(v, d) {
  return v === undefined ? d : v;
}
function sign(x) {
  if (Math.sign) {
    return Math.sign(x);
  }
  x = +x;
  if (x === 0 || isNaN(x)) {
    return Number(x);
  }
  return x > 0 ? 1 : -1;
}
function log2(x) {
  if (Math.log2) {
    return Math.log2(x);
  }
  var v = Math.log(x) * Math.LOG2E;
  var rounded = Math.round(v);
  if (Math.abs(rounded - v) < 1E-14) {
    return rounded;
  } else {
    return v;
  }
}
function interpolate$3(a, b, t) {
  return a * (1 - t) + b * t;
}
function wrap(n, min, max) {
  if (n === max || n === min) {
    return n;
  }
  var d = max - min;
  var w = ((n - min) % d + d) % d + min;
  return w;
}
function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}
function isArrayHasData(obj) {
  return Array.isArray(obj) && obj.length > 0;
}
var urlPattern = /^([a-z][a-z\d+\-.]*:)?\/\//i;
function isURL(url) {
  return urlPattern.test(url);
}
var cssUrlReWithQuote = /^url\((['"])(.+)\1\)$/i;
var cssUrlRe = /^url\(([^'"].*[^'"])\)$/i;
function isCssUrl(str) {
  if (!isString(str)) {
    return 0;
  }
  if (cssUrlRe.test(str)) {
    return 1;
  }
  if (cssUrlReWithQuote.test(str)) {
    return 2;
  }
  return 3;
}
function extractCssUrl(str) {
  var test = isCssUrl(str);
  var matches;
  if (test === 3) {
    return str;
  } else if (test === 1) {
    matches = cssUrlRe.exec(str);
    return matches[1];
  } else if (test === 2) {
    matches = cssUrlReWithQuote.exec(str);
    return matches[2];
  } else {
    return str;
  }
}
var b64chrs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function btoa(input) {
  if (Browser$1.btoa) {
    return window.btoa(input);
  }
  var str = String(input);
  var output = '';
  for (var block, charCode, idx = 0, map = b64chrs; str.charAt(idx | 0) || (map = '=', idx % 1); output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new Error('\'btoa\' failed: The string to be encoded contains characters outside of the Latin1 range.');
    }
    block = block << 8 | charCode;
  }
  return output;
}
function b64toBlob(b64Data, contentType) {
  var byteCharacters = atob(b64Data);
  var arraybuffer = new ArrayBuffer(byteCharacters.length);
  var view = new Uint8Array(arraybuffer);
  for (var i = 0; i < byteCharacters.length; i++) {
    view[i] = byteCharacters.charCodeAt(i) & 0xff;
  }
  var blob = new Blob([arraybuffer], {
    type: contentType
  });
  return blob;
}
function computeDegree(x0, y0, x1, y1) {
  var dx = x1 - x0;
  var dy = y1 - y0;
  return Math.atan2(dy, dx);
}
var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
function equalMapView(obj1, obj2) {
  if (!obj1 && !obj2) {
    return true;
  } else if (!obj1 || !obj2) {
    return false;
  }
  for (var p in obj1) {
    if (p === 'center') {
      if (!obj2[p] || !approx(obj1[p][0], obj2[p][0]) || !approx(obj1[p][1], obj2[p][1])) {
        return false;
      }
    } else if (obj1[p] !== obj2[p]) {
      return false;
    }
  }
  return true;
}
function approx(val, expected, delta) {
  if (delta == null) {
    delta = 1e-6;
  }
  return val >= expected - delta && val <= expected + delta;
}
function flash(interval = 100, count = 4, cb = null, context = null) {
  if (!interval) {
    interval = 100;
  }
  if (!count) {
    count = 4;
  }
  var me = this;
  var initVisible = this.isVisible();
  count *= 2;
  if (this._flashTimeout) {
    clearTimeout(this._flashTimeout);
  }
  function flashGeo() {
    if (count === 0) {
      if (initVisible) {
        me.show();
      } else {
        me.hide();
      }
      if (cb) {
        if (context) {
          cb.call(context);
        } else {
          cb();
        }
      }
      return;
    }
    if (count % 2 === 0) {
      me.hide();
    } else {
      me.show();
    }
    count--;
    me._flashTimeout = setTimeout(flashGeo, interval);
  }
  this._flashTimeout = setTimeout(flashGeo, interval);
  return this;
}
function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);
    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }
  return obj;
}
function getPointsResultPts(points = [], ptKey = '_pt') {
  var resultPoints = [];
  var idx = -1;
  var hasKey = ptKey + "Has";
  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];
    if (!point) {
      resultPoints[++idx] = null;
      continue;
    }
    if (!point[hasKey]) {
      point[hasKey] = true;
      point[ptKey] = new Point(0, 0);
    }
    var pt = point[ptKey];
    pt.x = 0;
    pt.y = 0;
    resultPoints[++idx] = pt;
  }
  return resultPoints;
}
function getImageBitMap(data, cb) {
  cb(data.data);
}
function getAbsoluteURL(url) {
  if (url && url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
    return url;
  }
  var a = document.createElement('a');
  a.href = url;
  url = a.href;
  a = null;
  return url;
}
var CANVAS_SIZE_TEMP = {
  cssWidth: '1px',
  cssHeight: '1px',
  width: 1,
  height: 1
};
function calCanvasSize(size, devicePixelRatio = 1) {
  var {
    width: width,
    height: height
  } = size;
  CANVAS_SIZE_TEMP.cssWidth = width + 'px';
  CANVAS_SIZE_TEMP.cssHeight = height + 'px';
  CANVAS_SIZE_TEMP.width = Math.round(width * devicePixelRatio);
  CANVAS_SIZE_TEMP.height = Math.round(height * devicePixelRatio);
  return CANVAS_SIZE_TEMP;
}
function isNoContentHttpCode(code) {
  return code === 204 || code >= 400 && code < 500 || code === 501;
}

var INTERNAL_LAYER_PREFIX = '_maptalks__internal_layer_';
var GEOMETRY_COLLECTION_TYPES = ['MultiPoint', 'MultiLineString', 'MultiPolygon', 'GeometryCollection'];
var GEOJSON_TYPES = ['FeatureCollection', 'Feature', 'Point', 'LineString', 'Polygon'].concat(GEOMETRY_COLLECTION_TYPES);
var RESOURCE_PROPERTIES = ['markerFile', 'polygonPatternFile', 'linePatternFile', 'markerFillPatternFile', 'markerLinePatternFile'];
var RESOURCE_SIZE_PROPERTIES = [['markerWidth', 'markerHeight'], [], [null, 'lineWidth'], [], [null, 'markerLineWidth']];
var NUMERICAL_PROPERTIES = {
  'lineWidth': 1,
  'lineOpacity': 1,
  'lineDx': 1,
  'lineDy': 1,
  'polygonOpacity': 1,
  'markerWidth': 1,
  'markerHeight': 1,
  'markerDx': 1,
  'markerDy': 1,
  'markerOpacity': 1,
  'markerFillOpacity': 1,
  'markerLineWidth': 1,
  'markerLineOpacity': 1,
  'textSize': 1,
  'textOpacity': 1,
  'textHaloRadius': 1,
  'textWrapWidth': 1,
  'textLineSpacing': 1,
  'textDx': 1,
  'textDy': 1
};
var COLOR_PROPERTIES = ['lineColor', 'polygonFill', 'markerFill', 'markerLineColor', 'textFill'];
var DEFAULT_TEXT_SIZE = 14;

var Size = function () {
  function Size(width, height) {
    if (isNumber(width) && isNumber(height)) {
      this.width = width;
      this.height = height;
    } else if (isNumber(width['width'])) {
      this.width = width.width;
      this.height = width.height;
    } else if (Array.isArray(width)) {
      this.width = width[0];
      this.height = width[1];
    }
  }
  var _proto = Size.prototype;
  _proto.copy = function copy() {
    return new Size(this['width'], this['height']);
  };
  _proto.add = function add(x, y) {
    var w, h;
    if (x instanceof Size) {
      w = this.width + x.width;
      h = this.height + x.height;
    } else {
      w = this.width + x;
      h = this.height + y;
    }
    return new Size(w, h);
  };
  _proto.equals = function equals(size) {
    return this['width'] === size['width'] && this['height'] === size['height'];
  };
  _proto.multi = function multi(ratio) {
    return new Size(this['width'] * ratio, this['height'] * ratio);
  };
  _proto._multi = function _multi(ratio) {
    this['width'] *= ratio;
    this['height'] *= ratio;
    return this;
  };
  _proto._round = function _round() {
    this['width'] = Math.round(this['width']);
    this['height'] = Math.round(this['height']);
    return this;
  };
  _proto.toPoint = function toPoint() {
    return new Point(this['width'], this['height']);
  };
  _proto.toArray = function toArray() {
    return [this['width'], this['height']];
  };
  _proto.toJSON = function toJSON() {
    return {
      'width': this['width'],
      'height': this['height']
    };
  };
  return Size;
}();

var EMPTY_STRING$1 = '';
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
function replaceAll(str, key, value) {
  if (!str) {
    return str;
  }
  while (str.indexOf(key) > -1) {
    str = str.replace(key, value);
  }
  return str;
}
var specialPattern = /[\b\t\r\v\f]/igm;
function escapeSpecialChars(str) {
  if (!isString(str)) {
    return str;
  }
  return str.replace(specialPattern, EMPTY_STRING$1);
}
function splitWords(chr) {
  return trim(chr).split(/\s+/);
}
var rulerCtx = typeof document !== 'undefined' ? document.createElement('canvas').getContext('2d') : null;
function stringWidth(text, font) {
  if (stringWidth.node) {
    return stringWidth.node(text, font);
  }
  rulerCtx.font = font;
  return rulerCtx.measureText(text).width;
}
function stringLength(text, font, size) {
  var w = stringWidth(text, font);
  return new Size(w, size || DEFAULT_TEXT_SIZE);
}
function splitContent(content, font, wrapWidth, textWidth) {
  if (!content || content.length === 0) {
    return [{
      'text': '',
      'width': 0
    }];
  }
  var width = isNil(textWidth) ? stringWidth(content, font) : textWidth;
  var chrWidth = width / content.length,
    minChrCount = Math.floor(wrapWidth / chrWidth / 2);
  if (chrWidth >= wrapWidth || minChrCount <= 0) {
    return [{
      'text': '',
      'width': wrapWidth
    }];
  }
  if (width <= wrapWidth) return [{
    'text': content,
    'width': width
  }];
  var result = [];
  var testStr = content.substring(0, minChrCount),
    prew = chrWidth * minChrCount;
  for (var i = minChrCount, l = content.length; i < l; i++) {
    var chr = content[i];
    var w = stringWidth(testStr + chr);
    if (w >= wrapWidth) {
      result.push({
        'text': testStr,
        'width': prew
      });
      testStr = content.substring(i, minChrCount + i);
      i += minChrCount - 1;
      prew = chrWidth * minChrCount;
    } else {
      testStr += chr;
      prew = w;
    }
    if (i >= l - 1) {
      prew = stringWidth(testStr);
      result.push({
        'text': testStr,
        'width': prew
      });
    }
  }
  return result;
}
var TEMPLATE_CHARS = ['{', '}'];
function replaceVariable(str, props) {
  if (!isString(str)) {
    return str;
  }
  var [left, right] = TEMPLATE_CHARS;
  if (str.indexOf(left) === -1 && str.indexOf(right) === -1) {
    return str;
  }
  function getValue(key) {
    if (!props) {
      return EMPTY_STRING$1;
    }
    var value = props[key];
    if (isNil(value)) {
      return EMPTY_STRING$1;
    } else if (Array.isArray(value)) {
      return value.join();
    }
    return value;
  }
  var keys = templateKeys(str);
  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    var value = getValue(key);
    str = replaceAll(str, "" + left + key + right, value);
  }
  return str;
}
function templateKeys(str) {
  str += EMPTY_STRING$1;
  var [left, right] = TEMPLATE_CHARS;
  var keys = [];
  var start = false;
  var key = EMPTY_STRING$1;
  for (var i = 0, len = str.length; i < len; i++) {
    var _char = str[i];
    if (!start && _char === left) {
      start = true;
    }
    if (_char === left && start) {
      key = EMPTY_STRING$1;
    }
    if (start && _char !== left && _char !== right) {
      key += _char;
    }
    if (_char === right && key) {
      start = false;
      keys.push(key);
      key = EMPTY_STRING$1;
    }
  }
  return keys;
}
function describeText(textContent, symbol) {
  if (isNumber(textContent)) {
    textContent += '';
  }
  textContent = textContent || '';
  var maxHeight = symbol['textMaxHeight'] || 0;
  var textDesc = splitTextToRow(textContent, symbol);
  if (maxHeight && maxHeight < textDesc.size.height) {
    textDesc.size.height = maxHeight;
  }
  return textDesc;
}
function getAlignPoint(size, horizontalAlignment, verticalAlignment) {
  var width = size['width'],
    height = size['height'];
  var alignW, alignH;
  if (horizontalAlignment === 'left') {
    alignW = -width;
  } else if (horizontalAlignment === 'right') {
    alignW = 0;
  } else {
    alignW = -width / 2;
  }
  if (verticalAlignment === 'top') {
    alignH = -height;
  } else if (verticalAlignment === 'bottom') {
    alignH = 0;
  } else {
    alignH = -height / 2;
  }
  return new Point(alignW, alignH);
}
var DEFAULT_FONT = 'sans-serif';
var DEFAULT_TEXTSIZE = 14;
function getFont(style) {
  if (style['textFont']) {
    return style['textFont'];
  } else {
    var textSize = style.textSize;
    if (isNil(textSize)) {
      textSize = DEFAULT_TEXTSIZE;
    }
    return (style['textStyle'] && style['textStyle'] !== 'normal' ? style['textStyle'] + ' ' : '') + (style['textWeight'] && style['textWeight'] !== 'normal' ? style['textWeight'] + ' ' : '') + textSize + 'px ' + (style['textFaceName'] && formatFontFamily(style['textFaceName']) || DEFAULT_FONT);
  }
}
function formatFontFamily(font) {
  var fonts = font.split(',');
  for (var i = 0; i < fonts.length; i++) {
    if (fonts[i].trim) {
      fonts[i] = fonts[i].trim();
    }
    if (fonts[i].indexOf(' ') > 0 && fonts[i][0] !== '"' && fonts[i][0] !== '\'') {
      fonts[i] = '"' + fonts[i] + '"';
    }
  }
  return fonts.join(',');
}
function splitTextToRow(text, style) {
  var font = getFont(style),
    lineSpacing = style['textLineSpacing'] || 0,
    size = stringLength(text, font, style['textSize']),
    textWidth = size['width'],
    textHeight = size['height'],
    wrapChar = style['textWrapCharacter'] || '\n',
    textRows = [];
  var wrapWidth = style['textWrapWidth'];
  if (!wrapWidth || wrapWidth > textWidth) {
    wrapWidth = textWidth;
  }
  if (!isString(text)) {
    text += '';
  }
  var actualWidth = 0;
  if (wrapChar && text.indexOf(wrapChar) >= 0) {
    var texts = text.split(wrapChar);
    for (var i = 0, l = texts.length; i < l; i++) {
      var t = texts[i];
      var tWidth = stringWidth(t, font);
      if (tWidth > wrapWidth) {
        var contents = splitContent(t, font, wrapWidth, tWidth);
        for (var ii = 0, ll = contents.length; ii < ll; ii++) {
          var w = contents[ii].width;
          if (w > actualWidth) {
            actualWidth = w;
          }
          textRows.push({
            'text': contents[ii].text,
            'size': new Size(w, textHeight)
          });
        }
      } else {
        if (tWidth > actualWidth) {
          actualWidth = tWidth;
        }
        textRows.push({
          'text': t,
          'size': new Size(tWidth, textHeight)
        });
      }
    }
  } else if (textWidth > wrapWidth) {
    var _contents = splitContent(text, font, wrapWidth, textWidth);
    for (var _i = 0; _i < _contents.length; _i++) {
      var _w = _contents[_i].width;
      if (_w > actualWidth) {
        actualWidth = _w;
      }
      textRows.push({
        'text': _contents[_i].text,
        'size': new Size(_w, textHeight)
      });
    }
  } else {
    if (textWidth > actualWidth) {
      actualWidth = textWidth;
    }
    textRows.push({
      'text': text,
      'size': size
    });
  }
  var rowNum = textRows.length;
  var textSize = new Size(actualWidth, textHeight * rowNum + lineSpacing * (rowNum - 1));
  return {
    'total': rowNum,
    'size': textSize,
    'rows': textRows,
    'rawSize': size
  };
}
function hashCode(s) {
  var hash = 0;
  var strlen = s && s.length || 0;
  if (!strlen) {
    return hash;
  }
  var c;
  for (var i = 0; i < strlen; i++) {
    c = s.charCodeAt(i);
    hash = (hash << 5) - hash + c;
    hash = hash & hash;
  }
  return hash;
}

var strings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_FONT: DEFAULT_FONT,
  DEFAULT_TEXTSIZE: DEFAULT_TEXTSIZE,
  EMPTY_STRING: EMPTY_STRING$1,
  describeText: describeText,
  escapeSpecialChars: escapeSpecialChars,
  getAlignPoint: getAlignPoint,
  getFont: getFont,
  hashCode: hashCode,
  replaceAll: replaceAll,
  replaceVariable: replaceVariable,
  splitContent: splitContent,
  splitTextToRow: splitTextToRow,
  splitWords: splitWords,
  stringLength: stringLength,
  stringWidth: stringWidth,
  trim: trim
});

var first = function first(props) {
  return props[0];
};
var testProp = IS_NODE ? first : function (props) {
  var style = document.documentElement && document.documentElement.style || {};
  for (var i = 0; i < props.length; i++) {
    if (props[i] in style) {
      return props[i];
    }
  }
  return false;
};
var TRANSFORM = testProp(['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
var TRANSFORMORIGIN = testProp(['transformOrigin', 'WebkitTransformOrigin', 'OTransformOrigin', 'MozTransformOrigin', 'msTransformOrigin']);
var TRANSITION = testProp(['transition', 'WebkitTransition', 'OTransition', 'MozTransition', 'msTransition']);
var CSSFILTER = testProp(['filter', 'WebkitFilter', 'OFilter', 'MozFilter', 'msFilter']);
function createEl(tagName, className) {
  var el = document.createElement(tagName);
  if (className) {
    setClass(el, className);
  }
  return el;
}
function createElOn(tagName, style, container) {
  var el = createEl(tagName);
  if (style) {
    setStyle(el, style);
  }
  if (container) {
    container.appendChild(el);
  }
  return el;
}
function removeDomNode(node) {
  if (!node) {
    return this;
  }
  if (Browser$1.ielt9 || Browser$1.ie9) {
    var d = createEl('div');
    d.appendChild(node);
    d.innerHTML = '';
    d = null;
  } else if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
  return this;
}
function addDomEvent(obj, typeArr, handler, context) {
  if (!obj || !obj.addEventListener || !typeArr || !handler) {
    return this;
  }
  var eventHandler = function eventHandler(e) {
    if (!e) {
      e = window.event;
    }
    handler.call(context || obj, e);
    return;
  };
  var types = typeArr.split(' ');
  for (var i = types.length - 1; i >= 0; i--) {
    var type = types[i];
    if (!type) {
      continue;
    }
    if (!obj['Z__' + type]) {
      obj['Z__' + type] = [];
    }
    var hit = listensDomEvent(obj, type, handler);
    if (hit >= 0) {
      console.warn(obj, "find '" + type + "' handler:", handler, ' The old listener function will be removed');
      removeDomEvent(obj, type, handler);
    }
    obj['Z__' + type].push({
      callback: eventHandler,
      src: handler
    });
    obj.addEventListener(type, eventHandler, Browser$1.supportsPassive ? {
      capture: false,
      passive: false
    } : false);
  }
  return this;
}
function removeDomEvent(obj, typeArr, handler) {
  function doRemove(type, callback) {
    if (type === 'mousewheel' && Browser$1.gecko) {
      type = 'DOMMouseScroll';
    }
    obj.removeEventListener(type, callback, false);
  }
  if (!obj || !obj.removeEventListener || !typeArr) {
    return this;
  }
  var types = typeArr.split(' ');
  for (var i = types.length - 1; i >= 0; i--) {
    var type = types[i];
    if (!type) {
      continue;
    }
    if (!handler && obj['Z__' + type]) {
      var handlers = obj['Z__' + type];
      for (var j = 0, jlen = handlers.length; j < jlen; j++) {
        doRemove(handlers[j].callback);
      }
      delete obj['Z__' + type];
      return this;
    }
    var hit = listensDomEvent(obj, type, handler);
    if (hit < 0) {
      return this;
    }
    var hitHandler = obj['Z__' + type][hit];
    doRemove(type, hitHandler.callback);
    obj['Z__' + type].splice(hit, 1);
  }
  return this;
}
function listensDomEvent(obj, type, handler) {
  if (!obj || !obj['Z__' + type] || !handler) {
    return -1;
  }
  var handlers = obj['Z__' + type];
  for (var i = 0, len = handlers.length; i < len; i++) {
    if (handlers[i].src === handler) {
      return i;
    }
  }
  return -1;
}
function preventDefault(event) {
  if (event.preventDefault) {
    event.preventDefault();
  } else {
    event.returnValue = false;
  }
  return this;
}
function stopPropagation(e) {
  e._cancelBubble = true;
  if (e.stopPropagation) {
    e.stopPropagation();
  } else {
    e.cancelBubble = true;
  }
  return this;
}
function preventSelection(dom) {
  dom.onselectstart = function () {
    return false;
  };
  dom.ondragstart = function () {
    return false;
  };
  dom.setAttribute('unselectable', 'on');
  return this;
}
function offsetDom(dom, offset) {
  if (!dom) {
    return null;
  }
  if (Browser$1.any3d) {
    setTransform(dom, offset);
  } else {
    dom.style.left = offset.x + 'px';
    dom.style.top = offset.y + 'px';
  }
  return offset;
}
function computeDomPosition(dom) {
  var style = window.getComputedStyle(dom);
  var padding = [parseInt(style['padding-left']), parseInt(style['padding-top'])];
  var rect = dom.getBoundingClientRect();
  var offsetWidth = dom.offsetWidth,
    offsetHeight = dom.offsetHeight;
  var scaleX = offsetWidth ? rect.width / offsetWidth : 1,
    scaleY = offsetHeight ? rect.height / offsetHeight : 1;
  dom.__position = [rect.left + padding[0], rect.top + padding[1], scaleX, scaleY];
  return dom.__position;
}
function getEventContainerPoint(ev, dom) {
  if (!ev) {
    ev = window.event;
  }
  var domPos = dom.__position;
  if (!domPos) {
    domPos = computeDomPosition(dom);
  }
  var toucheEvent = ev;
  if (toucheEvent.touches && toucheEvent.touches.length) {
    ev = toucheEvent.touches[0];
  }
  if (toucheEvent.changedTouches && toucheEvent.changedTouches.length) {
    ev = toucheEvent.changedTouches[0];
  }
  ev = ev;
  return new Point((ev.clientX - domPos[0] - dom.clientLeft) / domPos[2], (ev.clientY - domPos[1] - dom.clientTop) / domPos[3]);
}
function endsWith(str, suffix) {
  var l = str.length - suffix.length;
  return l >= 0 && str.indexOf(suffix, l) === l;
}
function setStyle(dom, strCss) {
  var cssText = dom.style.cssText;
  if (!endsWith(cssText, ';')) {
    cssText += ';';
  }
  dom.style.cssText = cssText + strCss;
  return this;
}
function hasClass(el, name) {
  if (el.classList !== undefined) {
    return el.classList.contains(name);
  }
  var className = getClass(el);
  return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
}
function addClass(el, name) {
  if (el.classList !== undefined && !hasClass(el, name)) {
    var classes = splitWords(name);
    for (var i = 0, len = classes.length; i < len; i++) {
      el.classList.add(classes[i]);
    }
  } else {
    var className = getClass(el);
    setClass(el, (className ? className + ' ' : '') + name);
  }
  return this;
}
function setClass(el, name) {
  if (isNil(el.className.baseVal)) {
    el.className = name;
  } else {
    el.className.baseVal = name;
  }
  return this;
}
function getClass(el) {
  return isNil(el.className.baseVal) ? el.className : el.className.baseVal;
}
function setOpacity(el, value) {
  el.style.opacity = value;
  return this;
}
function setTransform(el, offset) {
  var pos = offset || new Point(0, 0);
  el.style[TRANSFORM] = Browser$1.any3d ? 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0px)' : 'translate(' + pos.x + 'px,' + pos.y + 'px)';
  return this;
}
function setTransformMatrix(el, m) {
  var text = 'matrix(' + (isString(m) ? m : m.join()) + ')';
  if (el.style[TRANSFORM] !== text) {
    el.style[TRANSFORM] = text;
  }
  return this;
}
function removeTransform(el) {
  if (el.style[TRANSFORM]) {
    el.style[TRANSFORM] = '';
  }
  return this;
}
function isHTML(str) {
  return /<[a-z\][\s\S]*>/i.test(str);
}
function measureDom(parentTag, dom) {
  var ruler = getDomRuler(parentTag);
  if (isString(dom)) {
    ruler.innerHTML = dom;
  } else {
    ruler.appendChild(dom);
  }
  var result = new Size(ruler.clientWidth, ruler.clientHeight);
  removeDomNode(ruler);
  return result;
}
function getDomRuler(tag) {
  var span = document.createElement(tag);
  span.style.cssText = 'position:absolute;left:-10000px;top:-10000px;';
  document.body.appendChild(span);
  return span;
}
var on = addDomEvent;
var off = removeDomEvent;
function isMoveEvent(type) {
  return type && (type === 'mousemove' || type === 'touchmove');
}
var MOUSEMOVE_THROTTLE_TIME = 48;
function isMousemoveEventBlocked(target, mousemoveThrottleTime) {
  var currentTime = now();
  var TIME = mousemoveThrottleTime || MOUSEMOVE_THROTTLE_TIME;
  if (target._mousemoveTime && currentTime - target._mousemoveTime < TIME) {
    return true;
  }
  target._mousemoveTime = currentTime;
  return false;
}

var dom = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CSSFILTER: CSSFILTER,
  MOUSEMOVE_THROTTLE_TIME: MOUSEMOVE_THROTTLE_TIME,
  TRANSFORM: TRANSFORM,
  TRANSFORMORIGIN: TRANSFORMORIGIN,
  TRANSITION: TRANSITION,
  addClass: addClass,
  addDomEvent: addDomEvent,
  computeDomPosition: computeDomPosition,
  createEl: createEl,
  createElOn: createElOn,
  getClass: getClass,
  getDomRuler: getDomRuler,
  getEventContainerPoint: getEventContainerPoint,
  hasClass: hasClass,
  isHTML: isHTML,
  isMousemoveEventBlocked: isMousemoveEventBlocked,
  isMoveEvent: isMoveEvent,
  listensDomEvent: listensDomEvent,
  measureDom: measureDom,
  off: off,
  offsetDom: offsetDom,
  on: on,
  preventDefault: preventDefault,
  preventSelection: preventSelection,
  removeDomEvent: removeDomEvent,
  removeDomNode: removeDomNode,
  removeTransform: removeTransform,
  setClass: setClass,
  setOpacity: setOpacity,
  setStyle: setStyle,
  setTransform: setTransform,
  setTransformMatrix: setTransformMatrix,
  stopPropagation: stopPropagation
});

var Ajax = {
  jsonp: function jsonp(url, callback) {
    var name = '_maptalks_jsonp_' + UID();
    if (url.match(/\?/)) url += '&callback=' + name;else url += '?callback=' + name;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    window[name] = function (data) {
      callback(null, data);
      document.getElementsByTagName('head')[0].removeChild(script);
      script = null;
      delete window[name];
    };
    document.getElementsByTagName('head')[0].appendChild(script);
    return this;
  },
  get: function get(url, options, cb) {
    if (isFunction(options)) {
      var t = cb;
      cb = options;
      options = t;
    }
    if (IS_NODE && Ajax.get.node) {
      return Ajax.get.node(url, cb, options);
    }
    var client = Ajax._getClient(cb);
    client.open('GET', url, true);
    if (options) {
      for (var k in options.headers) {
        client.setRequestHeader(k, options.headers[k]);
      }
      client.withCredentials = options.credentials === 'include';
      if (options['responseType']) {
        client.responseType = options['responseType'];
      }
    }
    client.send(null);
    return client;
  },
  post: function post(url, options, cb) {
    var postData;
    if (!isString(url)) {
      var t = cb;
      postData = options;
      options = url;
      url = options.url;
      cb = t;
    } else {
      if (isFunction(options)) {
        var _t = cb;
        cb = options;
        options = _t;
      }
      options = options || {};
      postData = options.postData;
    }
    if (IS_NODE && Ajax.post.node) {
      options.url = url;
      return Ajax.post.node(options, postData, cb);
    }
    var client = Ajax._getClient(cb);
    client.open('POST', options.url, true);
    if (!options.headers) {
      options.headers = {};
    }
    if (!options.headers['Content-Type']) {
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    if ('setRequestHeader' in client) {
      for (var p in options.headers) {
        if (options.headers.hasOwnProperty(p)) {
          client.setRequestHeader(p, options.headers[p]);
        }
      }
    }
    if (!isString(postData)) {
      postData = JSON.stringify(postData);
    }
    client.send(postData);
    return client;
  },
  _wrapCallback: function _wrapCallback(client, cb) {
    return function () {
      if (client.readyState === 4) {
        if (client.status === 200) {
          if (client.responseType === 'arraybuffer') {
            var response = client.response;
            if (response.byteLength === 0) {
              cb(new Error('http status 200 returned without content.'));
            } else {
              cb(null, {
                data: client.response,
                cacheControl: client.getResponseHeader('Cache-Control'),
                expires: client.getResponseHeader('Expires'),
                contentType: client.getResponseHeader('Content-Type')
              });
            }
          } else {
            cb(null, client.responseText);
          }
        } else {
          cb(new Error(client.statusText + ',' + client.status));
        }
      }
    };
  },
  _getClient: function _getClient(cb) {
    var client;
    try {
      client = new XMLHttpRequest();
    } catch (e) {
      try {
        client = new ActiveXObject('Msxml2.XMLHTTP');
      } catch (e) {
        try {
          client = new ActiveXObject('Microsoft.XMLHTTP');
        } catch (e) {}
      }
    }
    client.onreadystatechange = Ajax._wrapCallback(client, cb);
    return client;
  },
  getArrayBuffer: function getArrayBuffer(url, options, cb) {
    if (isFunction(options)) {
      var t = cb;
      cb = options;
      options = t;
    }
    if (!options) {
      options = {};
    }
    options['responseType'] = 'arraybuffer';
    return Ajax.get(url, options, cb);
  },
  getImage: function getImage(img, url, options) {
    return Ajax.getArrayBuffer(url, options, function (err, imgData) {
      if (err) {
        if (img.onerror) {
          img.onerror(err);
        }
      } else if (imgData) {
        var URL = window.URL || window.webkitURL;
        var onload = img.onload;
        img.onload = function () {
          if (onload) {
            onload();
          }
          URL.revokeObjectURL(img.src);
        };
        var blob = new Blob([new Uint8Array(imgData.data)], {
          type: imgData.contentType
        });
        img.cacheControl = imgData.cacheControl;
        img.expires = imgData.expires;
        img.src = imgData.data.byteLength ? URL.createObjectURL(blob) : emptyImageUrl;
      }
    });
  },
  getJSON: function getJSON(url, options, cb) {}
};
Ajax.getJSON = function (url, options, cb) {
  if (isFunction(options)) {
    var t = cb;
    cb = options;
    options = t;
  }
  var callback = function callback(err, resp) {
    var data = resp ? parseJSON(resp) : null;
    cb(err, data);
  };
  if (options && options['jsonp']) {
    return Ajax.jsonp(url, callback);
  }
  return Ajax.get(url, options, callback);
};

var EMPTY_STRING = '';
var BASE64_REG = /data:image\/.*;base64,/;
function createCanvas() {
  var canvas;
  if (Browser$1.IS_NODE) {
    console.error('Current environment does not support canvas dom');
  } else {
    canvas = createEl('canvas');
  }
  return canvas;
}
function createOffscreenCanvas() {
  var offscreenCanvas;
  if (Browser$1.decodeImageInWorker) {
    offscreenCanvas = new OffscreenCanvas(2, 2);
  }
  return offscreenCanvas;
}
function isBase64URL(path) {
  return BASE64_REG.test(path);
}
function isBlobURL(path) {
  return path.indexOf('blob:') === 0;
}
function strContains(str1, str2) {
  if (isNumber(str1)) {
    str1 += EMPTY_STRING;
  }
  if (isNumber(str2)) {
    str2 += EMPTY_STRING;
  }
  if (!str1 || !str2) {
    return false;
  }
  if (str1.includes) {
    return str1.includes(str2);
  }
  return str1.indexOf(str2) > -1;
}
function handlerURL(path, configs = {}) {
  for (var local in configs) {
    var obj = configs[local];
    if (!obj || !obj.target) {
      continue;
    }
    if (strContains(path, local)) {
      var {
        target: target
      } = obj;
      return path.replace(local, target);
    }
  }
  return EMPTY_STRING;
}
function loadSprite(options = {
  imgUrl: '',
  jsonUrl: ''
}) {
  return new Promise(function (resolve, reject) {
    var {
      imgUrl: imgUrl,
      jsonUrl: jsonUrl
    } = options;
    if (!imgUrl || !jsonUrl) {
      reject(new Error('not find imgUrl/jsonUrl from options'));
      console.error(options);
      return;
    }
    function getCtx(canvas, width, height) {
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, width, height);
      return ctx;
    }
    function parseSprite(json = {}, image) {
      var canvas = createCanvas();
      if (!canvas) {
        reject(new Error('can not create canvas'));
        return;
      }
      var icons = [];
      for (var name in json) {
        var spriteItem = json[name];
        icons.push({
          name: name,
          spriteItem: spriteItem
        });
      }
      var offscreenCanvas = createOffscreenCanvas();
      var sourceName = options.sourceName || "";
      icons.forEach(function (icon) {
        var {
          name: name,
          spriteItem: spriteItem
        } = icon;
        var {
          x: x,
          y: y,
          width: width,
          height: height
        } = spriteItem;
        var resource;
        if (offscreenCanvas) {
          var ctx = getCtx(offscreenCanvas, width, height);
          ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
          resource = offscreenCanvas.transferToImageBitmap();
        } else {
          var _ctx = getCtx(canvas, width, height);
          _ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
          resource = canvas.toDataURL();
        }
        icon.resource = resource;
        ResourceProxy.addResource(sourceName + name, resource);
      });
      resolve(icons);
    }
    Ajax.getJSON(jsonUrl, {}, function (err, json) {
      if (err) {
        reject(err);
        return;
      }
      var img = new Image();
      img.onload = function () {
        parseSprite(json, img);
      };
      img.onerror = function (err) {
        reject(err);
        return;
      };
      Ajax.getImage(img, imgUrl, {});
    });
  });
}
function loadSvgs(svgs) {
  return new Promise(function (resolve, reject) {
    var url = '',
      symbols = [],
      fillColor = '',
      strokeColor = '',
      sourceName = '';
    if (Array.isArray(svgs) || svgs instanceof NodeList) {
      symbols = svgs;
    } else if (isObject$1(svgs)) {
      var opts = svgs;
      url = opts.url;
      symbols = opts.symbols;
      fillColor = opts.fill;
      strokeColor = opts.stroke;
      sourceName = opts.sourceName || '';
    } else if (isString(svgs)) {
      url = svgs;
    }
    if (!url && symbols && symbols.length === 0) {
      reject(new Error('not find svgs data'));
      return;
    }
    var result = [];
    var addToCache = function addToCache(name, body) {
      var paths = parseSVG(body);
      if (paths) {
        paths.forEach(function (path) {
          if (fillColor) {
            path.fill = fillColor;
          }
          if (strokeColor) {
            path.stroke = strokeColor;
          }
        });
        ResourceProxy.addResource(sourceName + name, paths);
      }
      var data = {
        name: name,
        paths: paths,
        body: body
      };
      result.push(data);
    };
    if (url && isString(url)) {
      fetch(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        json.forEach(function (svg) {
          var {
            name: name,
            body: body
          } = svg;
          addToCache(name, body);
        });
        resolve(result);
      })["catch"](function (err) {
        console.log(err);
        reject(err);
      });
      return;
    }
    if (symbols) {
      for (var i = 0, len = symbols.length; i < len; i++) {
        var symbolNode = symbols[i];
        var name = symbolNode.id;
        var html = symbolNode.innerHTML;
        var body = "<xml><svg>" + html + "</svg></xml>";
        if (name) {
          addToCache(name, body);
        }
      }
      resolve(result);
      return;
    }
    reject(new Error('not support svgs params type'));
  });
}
var ResourceProxy = {
  host: EMPTY_STRING,
  resources: {},
  proxy: {},
  origin: {},
  fromJSON: function fromJSON(json) {
    try {
      if (isString(json)) {
        json = JSON.parse(json);
      }
      if (isObject$1(json)) {
        extend$2(ResourceProxy, json);
      }
    } catch (error) {
      console.error(error);
    }
  },
  toJSON: function toJSON() {
    return {
      host: ResourceProxy.host,
      proxy: extend$2({}, ResourceProxy.proxy || {}),
      origin: extend$2({}, ResourceProxy.origin || {})
    };
  },
  getResource: function getResource(name) {
    return ResourceProxy.resources[name];
  },
  removeResource: function removeResource(name) {
    delete ResourceProxy.resources[name];
  },
  addResource: function addResource(name, res) {
    if (ResourceProxy.resources[name]) {
      console.warn(name + " resource Already exists,the " + name + " Cannot be added,the resource name Cannot repeat ");
      return;
    }
    ResourceProxy.resources[name] = res;
  },
  updateResource: function updateResource(name, res) {
    ResourceProxy.resources[name] = res;
  },
  allResource: function allResource() {
    return ResourceProxy.resources;
  },
  loadSprite: loadSprite,
  loadSvgs: loadSvgs
};
function formatResourceUrl(path) {
  if (isNumber(path)) {
    path += EMPTY_STRING;
  }
  if (!path) {
    console.error('resouce path is null,path:', path);
    return path;
  }
  if (!isString(path)) {
    return path;
  }
  if (isBase64URL(path) || isBlobURL(path)) {
    return path;
  }
  if (path[0] === '$') {
    return ResourceProxy.getResource(path.substring(1, Infinity)) || '';
  }
  var origin = ResourceProxy.origin || {};
  var isAbsoluteURL = isURL(path);
  if (isAbsoluteURL && isObject$1(origin)) {
    var url = handlerURL(path, origin);
    if (url) {
      return url;
    }
    return path;
  }
  var proxys = ResourceProxy.proxy || {};
  if (isObject$1(proxys)) {
    var _url = handlerURL(path, proxys);
    if (_url) {
      return _url;
    }
  }
  var {
    host: host
  } = ResourceProxy;
  if (!isAbsoluteURL && host && isString(host)) {
    return "" + host + path;
  }
  return getAbsoluteURL(path);
}
var parser;
function getDomParse() {
  if (!parser) {
    parser = new DOMParser();
  }
  return parser;
}
function getAttr(attributes, key) {
  if (!attributes) {
    return null;
  }
  return attributes[key] && attributes[key].value;
}
function parseSVG(str) {
  var xmlDoc = getDomParse().parseFromString(str, 'text/xml');
  var root = xmlDoc.querySelector('svg');
  if (!root) {
    return null;
  }
  var paths = root.childNodes;
  var data = [];
  var rootAttribute = root.attributes;
  var rootFill = getAttr(rootAttribute, 'fill');
  var rootFillOpacity = getAttr(rootAttribute, 'fill-opacity');
  var rootStroke = getAttr(rootAttribute, 'stroke');
  var rootStrokeOpacity = getAttr(rootAttribute, 'stroke-opacity');
  var rootStrokeWidth = getAttr(rootAttribute, 'stroke-width');
  for (var i = 0, len = paths.length; i < len; i++) {
    var dom = paths[i];
    var attributes = dom.attributes;
    if (!attributes) {
      continue;
    }
    var d = void 0;
    var tagName = dom.tagName || '';
    var isPath = tagName.toLowerCase() === 'path';
    if (!isPath) {
      d = dom;
    } else {
      d = getAttr(attributes, 'd');
    }
    if (!d) {
      continue;
    }
    var fill = getAttr(attributes, 'fill') || rootFill;
    var stroke = getAttr(attributes, 'stroke') || rootStroke;
    var pathData = {
      path: d
    };
    if (fill) {
      pathData.fill = fill;
      pathData['fill-opacity'] = getAttr(attributes, 'fill-opacity') || rootFillOpacity || 1;
    }
    if (stroke) {
      pathData.stroke = stroke;
      pathData['stroke-opacity'] = getAttr(attributes, 'stroke-opacity') || rootStrokeOpacity || 1;
      pathData['stroke-width'] = getAttr(attributes, 'stroke-width') || rootStrokeWidth || 1;
    }
    data.push(pathData);
    if (!isPath) {
      for (var p in pathData) {
        if (p === 'path') {
          continue;
        }
        if (pathData.hasOwnProperty(p)) {
          dom.setAttribute(p, pathData[p]);
        }
      }
    }
  }
  return data;
}

let canvas$1;
const OPTIONS$1 = {
    width: 100,
    height: 10
};
// const ISNODE = typeof global === 'object';

let offscreenCanvas$1 = false;
try {
    const canvas = new OffscreenCanvas(1, 1);
    const ctx = canvas.getContext('2d');
    ctx.fillText('hello', 0, 0);
    offscreenCanvas$1 = true;
} catch (err) {
    offscreenCanvas$1 = false;
}

function getCanvas$1() {
    if (!canvas$1) {
        const { width, height } = OPTIONS$1;
        if (offscreenCanvas$1) {
            canvas$1 = new OffscreenCanvas(width, height);
        } else {
            canvas$1 = document.createElement('canvas');
            canvas$1.width = width;
            canvas$1.height = height;
        }
    }
    return canvas$1;
}

let ColorIn$1 = class ColorIn {
    constructor(colors, options = {}) {
        if (!Array.isArray(colors)) {
            console.error('colors is not array');
            return;
        }
        if (colors.length < 2) {
            console.error('colors.length should >1');
            return;
        }
        this.colors = colors;
        let min = Infinity, max = -Infinity;
        for (let i = 0, len = colors.length; i < len; i++) {
            const value = colors[i][0];
            min = Math.min(value, min);
            max = Math.max(value, max);
        }
        this.min = min;
        this.max = max;
        this.valueOffset = this.max - this.min;
        this.options = Object.assign({}, OPTIONS$1, options);
        this._initImgData();
    }

    getImageData() {
        return this.imgData;
    }

    _initImgData() {
        const canvas = getCanvas$1();
        const { width, height } = this.options;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        const { colors, valueOffset } = this;
        for (let i = 0, len = colors.length; i < len; i++) {
            const [stop, color] = colors[i];
            const s = (stop - this.min) / valueOffset;
            gradient.addColorStop(s, color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }

    getColor(stop) {
        stop = Math.max(this.min, stop);
        stop = Math.min(stop, this.max);
        const s = (stop - this.min) / this.valueOffset;
        let x = Math.round(s * this.imgData.width);
        x = Math.min(x, this.imgData.width - 1);
        const idx = x * 4;
        const r = this.imgData.data[idx];
        const g = this.imgData.data[idx + 1];
        const b = this.imgData.data[idx + 2];
        const a = this.imgData.data[idx + 3];
        return [r, g, b, a];
    }
};

var isMapSupported = typeof Map === 'function';
var colorInCache;
if (isMapSupported) {
    colorInCache = new Map();
}


function isNull(value) {
    return value === null || value === undefined;
}

function isNotNull(value) {
    return !isNull(value);
}

function isEmptyString(value) {
    return value === '';
}

/*eslint-disable no-var, prefer-const*/
function createFunction(parameters, defaultType) {
    var fun;
    var isFeatureConstant, isZoomConstant;
    if (!isFunctionDefinition(parameters)) {
        fun = function () {
            return parameters;
        };
        isFeatureConstant = true;
        isZoomConstant = true;
    } else {
        var zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
        var featureDependent = zoomAndFeatureDependent || isNotNull(parameters.property);
        var zoomDependent = zoomAndFeatureDependent || !featureDependent;
        var type = parameters.type || defaultType || 'exponential';

        var innerFun;
        if (type === 'exponential') {
            innerFun = evaluateExponentialFunction;
        } else if (type === 'interval') {
            innerFun = evaluateIntervalFunction;
        } else if (type === 'categorical') {
            innerFun = evaluateCategoricalFunction;
        } else if (type === 'identity') {
            innerFun = evaluateIdentityFunction;
        } else if (type === 'color-interpolate') {
            innerFun = evaluateColorInterpolateFunction;
        } else if (type === 'calculate-expression') {
            innerFun = evaluateCalculateExpressionFunction;
        } else {
            throw new Error('Unknown function type "' + type + '"');
        }

        if (zoomAndFeatureDependent) {
            var featureFunctions = {};
            var featureFunctionStops = [];
            for (let s = 0; s < parameters.stops.length; s++) {
                var stop = parameters.stops[s];
                if (featureFunctions[stop[0].zoom] === undefined) {
                    featureFunctions[stop[0].zoom] = {
                        zoom: stop[0].zoom,
                        type: parameters.type,
                        property: parameters.property,
                        default: parameters.default,
                        stops: []
                    };
                }
                featureFunctions[stop[0].zoom].stops.push([stop[0].value, stop[1]]);
            }

            for (let z in featureFunctions) {
                featureFunctionStops.push([featureFunctions[z].zoom, createFunction(featureFunctions[z])]);
            }
            fun = function (zoom, feature) {
                const value = evaluateExponentialFunction({ stops: featureFunctionStops, base: parameters.base }, zoom)(zoom, feature);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = false;
        } else if (zoomDependent) {
            fun = function (zoom) {
                const value = innerFun(parameters, zoom);
                return typeof value === 'function' ? value(zoom) : value;
            };
            isFeatureConstant = true;
            isZoomConstant = false;
        } else {
            fun = function (zoom, feature) {
                const value = innerFun(parameters, feature ? feature[parameters.property] : null);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = true;
        }
    }
    fun.isZoomConstant = isZoomConstant;
    fun.isFeatureConstant = isFeatureConstant;
    return fun;
}

function coalesce(a, b, c) {
    if (isNotNull(a)) return a;
    if (isNotNull(b)) return b;
    if (isNotNull(c)) return c;
    return null;
}

function evaluateCategoricalFunction(parameters, input) {
    for (let i = 0; i < parameters.stops.length; i++) {
        if (input === parameters.stops[i][0]) {
            return parameters.stops[i][1];
        }
    }
    return parameters.default;
}

function evaluateIntervalFunction(parameters, input) {
    for (var i = 0; i < parameters.stops.length; i++) {
        if (input < parameters.stops[i][0]) break;
    }
    return parameters.stops[Math.max(i - 1, 0)][1];
}

function evaluateExponentialFunction(parameters, input) {
    var base = isNotNull(parameters.base) && !isEmptyString(parameters.base) ? parameters.base : 1;

    var i = 0;
    while (true) {
        if (i >= parameters.stops.length) break;
        else if (input <= parameters.stops[i][0]) break;
        else i++;
    }

    if (i === 0) {
        return parameters.stops[i][1];
    } else if (i === parameters.stops.length) {
        return parameters.stops[i - 1][1];
    } else {
        return interpolate$2(input, base, parameters.stops[i - 1][0], parameters.stops[i][0], parameters.stops[i - 1][1], parameters.stops[i][1]);
    }
}
const COLORIN_OPTIONS = {
    width: 100,
    height: 1
};
function evaluateColorInterpolateFunction(parameters, input) {
    const stops = parameters.stops;
    if (stops && stops.length > 1) {
        let colorIn;
        if (colorInCache) {
            const key = JSON.stringify(stops);
            if (!colorInCache.has(key)) {
                const colorIn = new ColorIn$1(stops, COLORIN_OPTIONS);
                colorInCache.set(key, colorIn);
            }
            colorIn = colorInCache.get(key);
        } else {
            colorIn = new ColorIn$1(stops, COLORIN_OPTIONS);
        }
        const [r, g, b, a] = colorIn.getColor(input);
        return [r / 255, g / 255, b / 255, a / 255];
    } else if (stops && stops.length === 1) {
        return stops[0][1];
    }
    return null;
}

function evaluateIdentityFunction(parameters, input) {
    return coalesce(input, parameters.default);
}
// 2添加修改计算函数
// 处理空字符串和未定义属性的函数
function evaluateCalculateExpressionFunction(parameters, input) {
    const targetVariable = String(parameters.property);
    const expression = parameters.expression;
    const newValue = input;

    // 定义函数来替换表达式中的变量
    function traverseAndAssign(expression, targetVariable, newValue) {
        const newValueAsNumber = Number(newValue);
        const targetVariableAsString = String(targetVariable);

        if (Array.isArray(expression)) {
            return expression.map(subExpr => traverseAndAssign(subExpr, targetVariableAsString, newValueAsNumber));
        } else if (expression === targetVariableAsString) {
            return newValueAsNumber;
        } else {
            return expression;
        }
    }

    // 定义函数来计算表达式的结果
    function evaluateExpression(expression) {
        if (Array.isArray(expression)) {
            const operator = expression[0];

            if (!['+', '-', '*', '/'].includes(operator)) {
                throw new Error(`Unknown operator: ${operator}`);
            }

            const operands = expression.slice(1).map(op => evaluateExpression(op));
            switch (operator) {
            case '+':
                return operands.reduce((acc, curr) => acc + curr, 0);
            case '-':
                return operands.reduce((acc, curr) => acc - curr);
            case '*':
                return operands.reduce((acc, curr) => acc * curr, 1);
            case '/':
                // 如果发现有零作为除数，返回默认值
                if (operands.some(op => op === 0)) {
                    return parameters.default;
                }
                return operands.reduce((acc, curr) => acc / curr);
            default:
                throw new Error(`Unsupported operator: ${operator}`);
            }
        } else if (typeof expression === 'number') {
            return expression;
        } else {
            throw new Error('Invalid expression format');
        }
    }

    // 使用 coalesce 函数处理结果中的默认值
    function coalesce(value) {
        return (isNull(value) || isEmptyString(value) || isNaN(value)) ? parameters.default : value;
    }

    // 如果 input 存在且大于0，则处理表达式
    if (isNotNull(input) && !isEmptyString(input) && !isNaN(input) && !(input < 0)) {
        const updatedExpression = traverseAndAssign(expression, targetVariable, newValue);
        return coalesce(evaluateExpression(updatedExpression));
    } else {
        return coalesce(parameters.default);
    }
}

function interpolate$2(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    if (typeof outputLower === 'function') {
        return function () {
            var evaluatedLower = outputLower.apply(undefined, arguments);
            var evaluatedUpper = outputUpper.apply(undefined, arguments);
            return interpolate$2(input, base, inputLower, inputUpper, evaluatedLower, evaluatedUpper);
        };
    } else if (outputLower.length) {
        return interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper);
    } else {
        return interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper);
    }
}

function interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var difference = inputUpper - inputLower;
    var progress = input - inputLower;

    var ratio;
    if (base === 1) {
        ratio = progress / difference;
    } else {
        ratio = (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }

    return outputLower * (1 - ratio) + outputUpper * ratio;
}

function interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var output = [];
    for (let i = 0; i < outputLower.length; i++) {
        output[i] = interpolateNumber(input, base, inputLower, inputUpper, outputLower[i], outputUpper[i]);
    }
    return output;
}

/**
 * Check if object is a definition of function type
 * @param  {Object}  obj object
 * @return {Boolean}
 * @memberOf MapboxUtil
 */
function isFunctionDefinition(obj) {
    return (
        obj &&
        typeof obj === 'object' &&
        (obj.stops || (obj.property && obj.type === 'identity') || (obj.expression && obj.type === 'calculate-expression'))
    );
}

// export function isFunctionDefinition(obj) {
//     return obj && typeof obj === 'object' && (obj.stops || (obj.property && obj.type === 'identity'));
// }

/**
 * Check if obj's properties has function definition
 * @param  {Object}  obj object to check
 * @return {Boolean}
 * @memberOf MapboxUtil
 */
function hasFunctionDefinition(obj) {
    for (const p in obj) {
        if (isFunctionDefinition(obj[p])) {
            return true;
        }
    }
    return false;
}

function interpolated(parameters) {
    return createFunction1(parameters, 'exponential');
}

/**
 * Load function types defined in object
 * @param  {Object[]} parameters parameters
 * @return {Object}   loaded object
 * @memberOf MapboxUtil
 */

function loadFunctionTypes(obj, argFn) {
    if (!obj) {
        return null;
    }
    var hit = false;
    if (Array.isArray(obj)) {
        var multResult = [],
            loaded;
        for (let i = 0; i < obj.length; i++) {
            loaded = loadFunctionTypes(obj[i], argFn);
            if (!loaded) {
                multResult.push(obj[i]);
            } else {
                multResult.push(loaded);
                hit = true;
            }
        }
        return hit ? multResult : obj;
    }
    var result = { '__fn_types_loaded': true },
        props = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            props.push(p);
        }
    }

    const buildFn = function (p) {
        Object.defineProperty(result, p, {
            get: function () {
                if (!this['__fn_' + p]) {
                    this['__fn_' + p] = interpolated(this['_' + p]);
                }
                return this['__fn_' + p].apply(this, argFn());
            },
            set: function (v) {
                this['_' + p] = v;
            },
            configurable: true,
            enumerable: true
        });
    };

    for (let i = 0, len = props.length; i < len; i++) {
        p = props[i];
        if (isFunctionDefinition(obj[p])) {
            hit = true;
            result['_' + p] = obj[p];
            buildFn(p);
        } else {
            result[p] = obj[p];
        }
    }
    return hit ? result : obj;
}

/**
 * Get external resources in the function type
 * @param  {Object} t Function type definition
 * @return {String[]}   resouces
 * @memberOf MapboxUtil
 */
function getFunctionTypeResources(t) {
    if (!t || !t.stops) {
        return [];
    }
    const res = [];
    for (let i = 0, l = t.stops.length; i < l; i++) {
        res.push(t.stops[i][1]);
    }
    return res;
}
/*eslint-enable no-var, prefer-const*/

function createFunction1(parameters, defaultType) {
    if (!isFunctionDefinition(parameters)) {
        return function () {
            return parameters;
        };
    }
    parameters = JSON.parse(JSON.stringify(parameters));
    let isZoomConstant = true;
    let isFeatureConstant = true;
    const stops = parameters.stops;
    if (stops) {
        for (let i = 0; i < stops.length; i++) {
            if (isFunctionDefinition(stops[i][1])) {
                const fn = createFunction1(stops[i][1], defaultType);
                isZoomConstant = isZoomConstant && fn.isZoomConstant;
                isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
                stops[i] = [stops[i][0], fn];
            }
        }
    }
    const fn = createFunction(parameters, defaultType);
    fn.isZoomConstant = isZoomConstant && fn.isZoomConstant;
    fn.isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
    return fn;
}

/*!
    Feature Filter by

    (c) mapbox 2016 and maptalks 2018
    www.mapbox.com | www.maptalks.org
    License: MIT, header required.
*/
const types$1 = ['Unknown', 'Point', 'LineString', 'Polygon', 'MultiPoint', 'MultiLineString', 'MultiPolygon', 'GeometryCollection'];

function isObject(obj) {
    return typeof obj === 'object' && !!obj;
}

/**
 * Given a filter expressed as nested arrays, return a new function
 * that evaluates whether a given feature (with a .properties or .tags property)
 * passes its test.
 *
 * @param {Array} filter mapbox gl filter
 * @returns {Function} filter-evaluating function
 */
function createFilter(filter) {
    return new Function('f', `var p = (f && f.properties || {}); return ${compile(filter)}`);
}

function isFeatureFilter(filter) {
    if (filter === true || filter === false) {
        return true;
    }
    if (!Array.isArray(filter) || filter.length === 0) {
        return false;
    }
    switch (filter[0]) {
    case 'has':
    case '!has':
        return filter.length === 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
    case 'in':
    case '!in':
        return filter.length >= 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
    case '==':
    case '!=':
    case '>':
    case '>=':
    case '<':
    case '<=':
        return filter.length === 3 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
    case 'none':
    case 'any':
    case 'all':
        for (const f of filter.slice(1)) {
            if (!isFeatureFilter(f) && typeof f !== 'boolean') {
                return false;
            }
        }
        return true;
    case 'contains':
        return true;
    default:
        return false;
    }
}

function compile(filter) {
    if (!filter) return 'true';
    const op = filter[0];
    if (filter.length <= 1) return op === 'any' ? 'false' : 'true';
    const str =
        op === '==' ? compileComparisonOp(filter[1], filter[2], '===', false) :
            op === '!=' ? compileComparisonOp(filter[1], filter[2], '!==', false) :
                op === '<' ||
                    op === '>' ||
                    op === '<=' ||
                    op === '>=' ? compileComparisonOp(filter[1], filter[2], op, true) :
                    op === 'any' ? compileLogicalOp(filter.slice(1), '||') :
                        op === 'all' ? compileLogicalOp(filter.slice(1), '&&') :
                            op === 'none' ? compileNegation(compileLogicalOp(filter.slice(1), '||')) :
                                op === 'in' ? compileInOp(filter[1], filter.slice(2)) :
                                    op === '!in' ? compileNegation(compileInOp(filter[1], filter.slice(2))) :
                                        op === 'has' ? compileHasOp(filter[1]) :
                                            op === '!has' ? compileNegation(compileHasOp(filter[1])) :
                                                // op === 'test' ? compileRegex(filter[1], filter[2]) :
                                                op === 'contains' ? compileContains(filter[1], filter[2], filter[3]) :
                                                    'true';
    return `(${str})`;
}

function compileFunction(propertyObj, value, op, checkType) {
    const property = propertyObj.property, funName = propertyObj.op;
    let left = compilePropertyReference(property);
    if (funName === 'length') {
        left = `((${left}+='').length)`;
    } else {
        // TODO
        //  other functions
        console.error(`not support ${funName} op`);
        return 'false';
    }
    return getComparisonCode(left, property, value, op, checkType);

}

function compileContains(property, str, index) {
    const prop = compilePropertyReference(property);
    if (index !== undefined) {
        return `(${prop} + '').indexOf("${str}") === ${index}`;
    } else {
        return `(${prop} + '').indexOf("${str}") >= 0`;
    }
}

// function compileRegex(property, regex) {
//     const prop = compilePropertyReference(property);
//     return `new RegExp("${regex}").test(${prop})`;
// }

function compilePropertyReference(property) {
    // const ref =
    //     property === '$type' ? 'f.type' :
    //         property === '$id' ? 'f.id' : `p[${JSON.stringify(property)}]`;
    // return ref;
    return property[0] === '$' ? 'f.' + property.substring(1) : 'p[' + JSON.stringify(property) + ']';
}

function compileComparisonOp(property, value, op, checkType) {
    if (isObject(property) && property.op) {
        return compileFunction(property, value, op, checkType);
    }
    const left = compilePropertyReference(property);
    return getComparisonCode(left, property, value, op, checkType);
}

function getComparisonCode(left, property, value, op, checkType) {
    const right = property === '$type' ? types$1.indexOf(value) : JSON.stringify(value);
    return (checkType ? `typeof ${left}=== typeof ${right}&&` : '') + left + op + right;
}

function compileLogicalOp(expressions, op) {
    return expressions.map(compile).join(op);
}

function compileInOp(property, values) {
    if (property === '$type') values = values.map((value) => {
        return types$1.indexOf(value);
    });
    const left = JSON.stringify(values.sort(compare));
    const right = compilePropertyReference(property);

    if (values.length <= 200) return `${left}.indexOf(${right}) !== -1`;

    return `function(v, a, i, j) {
        while (i <= j) { var m = (i + j) >> 1;
            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;
        }
    return false; }(${right}, ${left},0,${values.length - 1})`;
}

function compileHasOp(property) {
    return property === '$id' ? '"id" in f' : `${JSON.stringify(property)} in p`;
}

function compileNegation(expression) {
    return `!(${expression})`;
}

// Comparison function to sort numbers and strings
function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

/**
 * Get feature object from a geometry for filter functions.
 * @param  {Geometry} geometry geometry
 * @return {Object}          feature for filter functions
 */
function getFilterFeature(geometry) {
    const json = geometry._toJSON(),
        g = json['feature'];
    g['type'] = types$1.indexOf(g['geometry']['type']);
    g['subType'] = json['subType'];
    return g;
}

/**
 * Compile layer's style, styles to symbolize layer's geometries, e.g.<br>
 * <pre>
 * [
 *   {
 *     'filter' : ['==', 'foo', 'val'],
 *     'symbol' : {'markerFile':'foo.png'}
 *   }
 * ]
 * </pre>
 * @param  {Object|Object[]} styles - style to compile
 * @return {Object[]}       compiled styles
 */
function compileStyle(styles) {
    if (!Array.isArray(styles)) {
        return compileStyle([styles]);
    }
    const compiled = [];
    for (let i = 0; i < styles.length; i++) {
        let filter;
        if (styles[i]['filter'] === true) {
            filter = function () { return true; };
        } else {
            filter = createFilter(styles[i]['filter']);
        }
        compiled.push(extend$1({}, styles[i], {
            filter: filter
        }));
    }
    return compiled;
}

function extend$1(dest) { // (Object[, Object, ...]) ->
    for (let i = 1; i < arguments.length; i++) {
        const src = arguments[i];
        for (const k in src) {
            dest[k] = src[k];
        }
    }
    return dest;
}

var MapStateCache = {};
function updateMapStateCache(map) {
  if (!map) {
    return;
  }
  var mapId = map.id;
  MapStateCache[mapId] = {
    pitch: map.getPitch(),
    bearing: map.getBearing(),
    zoom: map.getZoom(),
    devicePixelRatio: map.getDevicePixelRatio(),
    resolution: map.getResolution(),
    center: map.getCenter(),
    groundExtent: map.getGroundExtent(),
    glScale: map.getGLScale(),
    glRes: map.getGLRes()
  };
}

var arr = [],
  prop = {};
function loadGeoSymbol(symbol, geo) {
  return loadFunctionTypes(symbol, function () {
    var map = geo.getMap();
    var bearing = 0,
      pitch = 0,
      zoom = 10;
    var hasMap = !!map;
    if (map) {
      var mapId = map.id;
      var cache = MapStateCache[mapId];
      if (cache) {
        bearing = cache.bearing;
        pitch = cache.pitch;
        zoom = cache.zoom;
      } else {
        bearing = map.getBearing();
        pitch = map.getPitch();
        zoom = map.getZoom();
      }
    }
    var changed = false;
    geo._funTypeProperties = geo._funTypeProperties || {};
    if (geo.propertiesDirty) {
      geo._funTypeProperties = {};
      geo.propertiesDirty = false;
      changed = true;
    } else {
      var funTypeProperties = geo._funTypeProperties;
      changed = funTypeProperties['{bearing}'] !== bearing || funTypeProperties['{pitch}'] !== pitch || funTypeProperties['{zoom}'] !== zoom;
    }
    var mergeProperties = geo._funTypeProperties;
    if (changed) {
      mergeProperties = extend$2(mergeProperties || {}, geo.getProperties(), setProp(prop, bearing, pitch, zoom));
    }
    return set$1(arr, hasMap ? zoom : 12, mergeProperties);
  });
}
function set$1(arr, a0, a1) {
  arr[0] = a0;
  arr[1] = a1;
  return arr;
}
function setProp(prop, b, p, z) {
  prop['{bearing}'] = b;
  prop['{pitch}'] = p;
  prop['{zoom}'] = z;
  return prop;
}

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  compileStyle: compileStyle,
  createFilter: createFilter,
  getFilterFeature: getFilterFeature,
  getFunctionTypeResources: getFunctionTypeResources,
  hasFunctionDefinition: hasFunctionDefinition,
  interpolated: interpolated,
  isFeatureFilter: isFeatureFilter,
  isFunctionDefinition: isFunctionDefinition,
  loadFunctionTypes: loadFunctionTypes,
  loadGeoSymbol: loadGeoSymbol
});

function translateToSVGStyles(s) {
  var result = {
    'stroke': {
      'stroke': s['markerLineColor'],
      'stroke-width': s['markerLineWidth'],
      'stroke-opacity': s['markerLineOpacity'],
      'stroke-dasharray': null,
      'stroke-linecap': 'butt',
      'stroke-linejoin': 'round'
    },
    'fill': {
      'fill': s['markerFill'],
      'fill-opacity': s['markerFillOpacity']
    }
  };
  if (result['stroke']['stroke-width'] === 0) {
    result['stroke']['stroke-opacity'] = 0;
  }
  return result;
}
function getMarkerPathBase64(symbol, width, height) {
  if (!symbol['markerPath']) {
    return null;
  }
  var op = 1;
  var styles = translateToSVGStyles(symbol);
  if (isNumber(symbol['markerOpacity'])) {
    op = symbol['markerOpacity'];
  }
  if (isNumber(symbol['opacity'])) {
    op *= symbol['opacity'];
  }
  var svgStyles = {};
  if (styles) {
    for (var p in styles['stroke']) {
      if (styles['stroke'].hasOwnProperty(p)) {
        if (!isNil(styles['stroke'][p])) {
          svgStyles[p] = styles['stroke'][p];
        }
      }
    }
    for (var _p in styles['fill']) {
      if (styles['fill'].hasOwnProperty(_p)) {
        if (!isNil(styles['fill'][_p])) {
          svgStyles[_p] = styles['fill'][_p];
        }
      }
    }
  }
  var pathes;
  var markerPath = symbol.markerPath;
  if (isString(markerPath) && markerPath[0] === '$') {
    pathes = ResourceProxy.getResource(markerPath.substring(1, Infinity)) || [];
  } else {
    pathes = Array.isArray(symbol['markerPath']) ? symbol['markerPath'] : [symbol['markerPath']];
  }
  var path;
  var pathesToRender = [];
  for (var i = 0; i < pathes.length; i++) {
    path = isString(pathes[i]) ? {
      'path': pathes[i]
    } : pathes[i];
    path = extend$2({}, svgStyles, path);
    path['d'] = path['path'];
    delete path['path'];
    pathesToRender.push(path);
  }
  var svg = ['<svg version="1.1"', 'xmlns="http://www.w3.org/2000/svg"'];
  if (op < 1) {
    svg.push('opacity="' + op + '"');
  }
  if (symbol['markerPathWidth'] && symbol['markerPathHeight']) {
    svg.push('viewBox="0 0 ' + symbol['markerPathWidth'] + ' ' + symbol['markerPathHeight'] + '"');
  }
  svg.push('preserveAspectRatio="none"');
  if (width) {
    svg.push('width="' + width + '"');
  }
  if (height) {
    svg.push('height="' + height + '"');
  }
  svg.push('><defs></defs>');
  for (var _i = 0; _i < pathesToRender.length; _i++) {
    if (pathesToRender[_i].d instanceof Element) {
      svg.push(pathesToRender[_i].d.outerHTML);
      continue;
    }
    var strPath = '<path';
    for (var _p2 in pathesToRender[_i]) {
      if (pathesToRender[_i].hasOwnProperty(_p2)) {
        strPath += ' ' + _p2 + '="' + pathesToRender[_i][_p2] + '"';
      }
    }
    strPath += '></path>';
    svg.push(strPath);
  }
  svg.push('</svg>');
  var b64 = 'data:image/svg+xml;base64,' + btoa(svg.join(' '));
  return b64;
}
function getExternalResources(symbol, toAbsolute) {
  if (!symbol) {
    return [];
  }
  var symbols = symbol;
  if (!Array.isArray(symbol)) {
    symbols = [symbol];
  }
  var resources = [];
  var props = RESOURCE_PROPERTIES;
  var res, resSizeProp;
  var w, h;
  for (var i = symbols.length - 1; i >= 0; i--) {
    symbol = symbols[i];
    if (!symbol) {
      continue;
    }
    if (toAbsolute) {
      symbol = convertResourceUrl(symbol);
    }
    for (var ii = 0; ii < props.length; ii++) {
      res = symbol[props[ii]];
      if (isFunctionDefinition(res)) {
        res = getFunctionTypeResources(res);
      }
      if (!res) {
        continue;
      }
      if (!Array.isArray(res)) {
        res = [res];
      }
      for (var iii = 0; iii < res.length; iii++) {
        if (res[iii].slice(0, 4) === 'url(') {
          res[iii] = extractCssUrl(res[iii]);
        }
        resSizeProp = RESOURCE_SIZE_PROPERTIES[ii];
        resources.push([res[iii], symbol[resSizeProp[0]], symbol[resSizeProp[1]]]);
      }
    }
    if (symbol['markerType'] === 'path' && symbol['markerPath']) {
      w = isFunctionDefinition(symbol['markerWidth']) ? 200 : symbol['markerWidth'];
      h = isFunctionDefinition(symbol['markerHeight']) ? 200 : symbol['markerHeight'];
      if (isFunctionDefinition(symbol['markerPath'])) {
        res = getFunctionTypeResources(symbol['markerPath']);
        var path = symbol['markerPath'];
        for (var _iii = 0; _iii < res.length; _iii++) {
          symbol['markerPath'] = res[_iii];
          resources.push([getMarkerPathBase64(symbol), w, h]);
        }
        symbol['markerPath'] = path;
      } else {
        resources.push([getMarkerPathBase64(symbol), w, h]);
      }
    }
  }
  return resources;
}
function convertResourceUrl(symbol) {
  if (!symbol) {
    return null;
  }
  var s = symbol;
  if (IS_NODE) {
    return s;
  }
  var props = RESOURCE_PROPERTIES;
  var res;
  for (var ii = 0, len = props.length; ii < len; ii++) {
    res = s[props[ii]];
    if (!res) {
      continue;
    }
    s[props[ii]] = _convertUrl(res);
  }
  return s;
}
function _convertUrl(res) {
  if (isFunctionDefinition(res) && res.stops) {
    var stops = res.stops;
    for (var i = 0; i < stops.length; i++) {
      stops[i][1] = _convertUrl(stops[i][1]);
    }
    return res;
  }
  if (res.slice(0, 4) === 'url(') {
    res = extractCssUrl(res);
  }
  return res;
}
function isImageBitMap(img) {
  return img && Browser$1.decodeImageInWorker && img instanceof ImageBitmap;
}

function isGradient(g) {
  return g && g['colorStops'];
}
function getGradientStamp(g) {
  var keys = [g['type']];
  if (g['places']) {
    keys.push(g['places'].join());
  }
  if (g['colorStops']) {
    var stops = [];
    for (var i = g['colorStops'].length - 1; i >= 0; i--) {
      stops.push(g['colorStops'][i].join());
    }
    keys.push(stops.join(','));
  }
  return keys.join('_');
}
function getSymbolStamp(symbol, prefix) {
  return getSymbolHash(symbol, prefix);
}
function getSymbolHash(symbol, prefix) {
  if (!symbol) {
    return 1;
  }
  var keys = [];
  if (Array.isArray(symbol)) {
    for (var i = 0; i < symbol.length; i++) {
      keys.push(getSymbolHash(symbol[i], prefix));
    }
    return keys.sort().join(',');
  }
  var sortedKeys = Object.keys(symbol).sort();
  var sortedSymbol = sortedKeys.reduce(function (accumulator, curValue) {
    if (!prefix || curValue.indexOf(prefix) === 0) {
      accumulator[curValue] = symbol[curValue];
    }
    return accumulator;
  }, {});
  var hash = hashCode(JSON.stringify(sortedSymbol));
  return hash;
}
function lowerSymbolOpacity(symbol, ratio) {
  function s(_symbol, _ratio) {
    var op = _symbol['opacity'];
    if (isNil(op)) {
      _symbol['opacity'] = _ratio;
    } else {
      _symbol['opacity'] *= _ratio;
    }
  }
  var lower;
  if (Array.isArray(symbol)) {
    lower = [];
    for (var i = 0; i < symbol.length; i++) {
      var d = extend$2({}, symbol[i]);
      s(d, ratio);
      lower.push(d);
    }
  } else {
    lower = extend$2({}, symbol);
    s(lower, ratio);
  }
  return lower;
}
function extendSymbol(...args) {
  var symbol = args[0];
  var sources = Array.prototype.slice.call(args, 1);
  if (!sources || !sources.length) {
    sources = [{}];
  }
  if (Array.isArray(symbol)) {
    var s, dest;
    var result = [];
    for (var i = 0, l = symbol.length; i < l; i++) {
      s = symbol[i];
      dest = {};
      for (var ii = 0, ll = sources.length; ii < ll; ii++) {
        if (!Array.isArray(sources[ii])) {
          extend$2(dest, s, sources[ii] ? sources[ii] : {});
        } else if (!isNil(sources[ii][i])) {
          extend$2(dest, s, sources[ii][i]);
        } else {
          extend$2(dest, s ? s : {});
        }
      }
      result.push(dest);
    }
    return result;
  } else {
    var _args = [{}, symbol];
    _args.push.apply(_args, sources);
    return extend$2.apply(this, _args);
  }
}
function parseStyleRootPath(style) {
  if (style.symbol) {
    style = [style];
  }
  if (Array.isArray(style)) {
    return style;
  }
  var root = style['$root'];
  var iconset = style['$iconset'];
  style = style.style;
  if (root || iconset) {
    if (root && root[root.length - 1] === '/') {
      root = root.substring(0, root.length - 1);
    }
    if (iconset && iconset[iconset.length - 1] === '/') {
      iconset = iconset.substring(0, iconset.length - 1);
    }
    var replacer = function replacer(match) {
      if (match === '{$root}') {
        return root;
      } else if (match === '{$iconset}') {
        return iconset;
      }
      return null;
    };
    convertStylePath(style, replacer);
  }
  return style;
}
function convertStylePath(styles, replacer) {
  for (var i = 0; i < styles.length; i++) {
    var {
      symbol: symbol
    } = styles[i];
    if (symbol) {
      parseSymbolPath(symbol, replacer);
    }
  }
}
var URL_PATTERN$1 = /(\{\$root\}|\{\$iconset\})/g;
function parseSymbolPath(symbol, replacer) {
  for (var p in symbol) {
    if (symbol.hasOwnProperty(p) && p !== 'textName') {
      if (isString(symbol[p]) && symbol[p].length > 2) {
        symbol[p] = symbol[p].replace(URL_PATTERN$1, replacer);
      } else if (isFunctionDefinition(symbol[p])) {
        symbol[p] = parseStops(symbol[p], replacer);
      } else if (isObject$1(symbol[p])) {
        parseSymbolPath(symbol[p], replacer);
      }
    }
  }
}
function parseStops(value, replacer) {
  var defaultValue = value['default'];
  if (isString(defaultValue)) {
    value['default'] = defaultValue.replace(URL_PATTERN$1, replacer);
  }
  var stops = value.stops;
  if (!stops) {
    return value;
  }
  for (var i = 0; i < stops.length; i++) {
    if (!Array.isArray(stops[i])) {
      continue;
    }
    if (isString(stops[i][1])) {
      stops[i][1] = stops[i][1].replace(URL_PATTERN$1, replacer);
    } else if (isFunctionDefinition(stops[i][1])) {
      stops[i][1] = parseStops(stops[i][1], replacer);
    }
  }
  return value;
}
function isDashLine(symbolizers = []) {
  if (!Array.isArray(symbolizers)) {
    symbolizers = [symbolizers];
  }
  var len = symbolizers.length;
  for (var i = 0; i < len; i++) {
    var symbolizer = symbolizers[i];
    if (!symbolizer.style) {
      continue;
    }
    var {
      lineDasharray: lineDasharray,
      lineWidth: lineWidth
    } = symbolizer.style;
    if (lineWidth && isNumber(lineWidth) && lineWidth > 0 && lineDasharray && Array.isArray(lineDasharray) && lineDasharray.length) {
      return true;
    }
  }
  return false;
}

function perspective(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
    nf = 1 / (near - far);
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = 2 * far * near * nf;
  out[15] = 0;
  return out;
}
function perspectiveZO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2);
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;
  if (far != null && far !== Infinity) {
    var nf = 1 / (near - far);
    out[10] = far * nf;
    out[14] = far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -near;
  }
  return out;
}
function translate(out, a, v) {
  var x = v[0],
    y = v[1],
    z = v[2],
    a00,
    a01,
    a02,
    a03,
    a10,
    a11,
    a12,
    a13,
    a20,
    a21,
    a22,
    a23;
  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }
  return out;
}
function scale$1(out, a, v) {
  var x = v[0],
    y = v[1],
    z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
function rotateX(out, a, rad) {
  var s = Math.sin(rad),
    c = Math.cos(rad),
    a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7],
    a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11];
  if (a !== out) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }
  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
function rotateZ(out, a, rad) {
  var s = Math.sin(rad),
    c = Math.cos(rad),
    a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3],
    a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7];
  if (a !== out) {
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }
  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
function multiply(out, a, b) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3],
    a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7],
    a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11],
    a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15];
  var b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
function invert(out, a) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3],
    a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7],
    a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11],
    a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15],
    b00 = a00 * a11 - a01 * a10,
    b01 = a00 * a12 - a02 * a10,
    b02 = a00 * a13 - a03 * a10,
    b03 = a01 * a12 - a02 * a11,
    b04 = a01 * a13 - a03 * a11,
    b05 = a02 * a13 - a03 * a12,
    b06 = a20 * a31 - a21 * a30,
    b07 = a20 * a32 - a22 * a30,
    b08 = a20 * a33 - a23 * a30,
    b09 = a21 * a32 - a22 * a31,
    b10 = a21 * a33 - a23 * a31,
    b11 = a22 * a33 - a23 * a32,
    det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det) {
    return null;
  }
  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
function identity$1(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function copy$1(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_FONT: DEFAULT_FONT,
  DEFAULT_TEXTSIZE: DEFAULT_TEXTSIZE,
  EMPTY_STRING: EMPTY_STRING$1,
  GUID: GUID,
  IS_NODE: IS_NODE,
  UID: UID,
  _defaults: _defaults,
  b64toBlob: b64toBlob,
  btoa: btoa,
  calCanvasSize: calCanvasSize,
  get cancelAnimFrame () { return cancelAnimFrame; },
  checkMTKVersion: checkMTKVersion,
  clamp: clamp,
  computeDegree: computeDegree,
  convertResourceUrl: convertResourceUrl,
  convertStylePath: convertStylePath,
  copy: copy$1,
  describeText: describeText,
  emptyImageUrl: emptyImageUrl,
  equalMapView: equalMapView,
  escapeSpecialChars: escapeSpecialChars,
  extend: extend$2,
  extendSymbol: extendSymbol,
  extractCssUrl: extractCssUrl,
  flash: flash,
  forEachCoord: forEachCoord,
  getAbsoluteURL: getAbsoluteURL,
  getAlignPoint: getAlignPoint,
  getExternalResources: getExternalResources,
  getFont: getFont,
  getGlobalThis: getGlobalThis,
  getGradientStamp: getGradientStamp,
  getImageBitMap: getImageBitMap,
  getMarkerPathBase64: getMarkerPathBase64,
  getPointsResultPts: getPointsResultPts,
  getSymbolHash: getSymbolHash,
  getSymbolStamp: getSymbolStamp,
  getValueOrDefault: getValueOrDefault,
  hasOwn: hasOwn,
  hashCode: hashCode,
  identity: identity$1,
  interpolate: interpolate$3,
  invert: invert,
  isArrayHasData: isArrayHasData,
  isCssUrl: isCssUrl,
  isDashLine: isDashLine,
  isEmpty: isEmpty,
  isFunction: isFunction,
  isGradient: isGradient,
  isImageBitMap: isImageBitMap,
  isInteger: isInteger,
  isNil: isNil,
  isNoContentHttpCode: isNoContentHttpCode,
  isNumber: isNumber,
  isObject: isObject$1,
  isSVG: isSVG,
  isString: isString,
  isURL: isURL,
  join: join,
  loadImage: loadImage,
  log2: log2,
  lowerSymbolOpacity: lowerSymbolOpacity,
  mergeArray: mergeArray,
  multiply: multiply,
  now: now,
  parseJSON: parseJSON,
  parseStyleRootPath: parseStyleRootPath,
  parseSymbolPath: parseSymbolPath,
  perspective: perspective,
  perspectiveZO: perspectiveZO,
  pushIn: pushIn,
  removeFromArray: removeFromArray,
  replaceAll: replaceAll,
  replaceVariable: replaceVariable,
  get requestAnimFrame () { return requestAnimFrame; },
  rotateX: rotateX,
  rotateZ: rotateZ,
  scale: scale$1,
  sign: sign,
  splitContent: splitContent,
  splitTextToRow: splitTextToRow,
  splitWords: splitWords,
  stringLength: stringLength,
  stringWidth: stringWidth,
  toDegree: toDegree,
  toRadian: toRadian,
  translate: translate,
  translateToSVGStyles: translateToSVGStyles,
  trim: trim,
  warnOnce: warnOnce,
  wrap: wrap
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lineclip_1 = lineclip;

lineclip.polyline = lineclip;
lineclip.polygon = polygonclip;


// Cohen-Sutherland line clippign algorithm, adapted to efficiently
// handle polylines rather than just segments

function lineclip(points, bbox, result) {

    var len = points.length,
        codeA = bitCode(points[0], bbox),
        part = [],
        i, a, b, codeB, lastCode;

    if (!result) result = [];

    for (i = 1; i < len; i++) {
        a = points[i - 1];
        b = points[i];
        codeB = lastCode = bitCode(b, bbox);

        while (true) {

            if (!(codeA | codeB)) { // accept
                part.push(a);

                if (codeB !== lastCode) { // segment went outside
                    part.push(b);

                    if (i < len - 1) { // start a new line
                        result.push(part);
                        part = [];
                    }
                } else if (i === len - 1) {
                    part.push(b);
                }
                break;

            } else if (codeA & codeB) { // trivial reject
                break;

            } else if (codeA) { // a outside, intersect with clip edge
                a = intersect(a, b, codeA, bbox);
                codeA = bitCode(a, bbox);

            } else { // b outside
                b = intersect(a, b, codeB, bbox);
                codeB = bitCode(b, bbox);
            }
        }

        codeA = lastCode;
    }

    if (part.length) result.push(part);

    return result;
}

// Sutherland-Hodgeman polygon clipping algorithm

function polygonclip(points, bbox) {

    var result, edge, prev, prevInside, i, p, inside;

    // clip against each side of the clip rectangle
    for (edge = 1; edge <= 8; edge *= 2) {
        result = [];
        prev = points[points.length - 1];
        prevInside = !(bitCode(prev, bbox) & edge);

        for (i = 0; i < points.length; i++) {
            p = points[i];
            inside = !(bitCode(p, bbox) & edge);

            // if segment goes through the clip window, add an intersection
            if (inside !== prevInside) result.push(intersect(prev, p, edge, bbox));

            if (inside) result.push(p); // add a point if it's inside

            prev = p;
            prevInside = inside;
        }

        points = result;

        if (!points.length) break;
    }

    return result;
}

// intersect a segment against one of the 4 lines that make up the bbox

function intersect(a, b, edge, bbox) {
    return edge & 8 ? [a[0] + (b[0] - a[0]) * (bbox[3] - a[1]) / (b[1] - a[1]), bbox[3]] : // top
           edge & 4 ? [a[0] + (b[0] - a[0]) * (bbox[1] - a[1]) / (b[1] - a[1]), bbox[1]] : // bottom
           edge & 2 ? [bbox[2], a[1] + (b[1] - a[1]) * (bbox[2] - a[0]) / (b[0] - a[0])] : // right
           edge & 1 ? [bbox[0], a[1] + (b[1] - a[1]) * (bbox[0] - a[0]) / (b[0] - a[0])] : // left
           null;
}

// bit code reflects the point position relative to the bbox:

//         left  mid  right
//    top  1001  1000  1010
//    mid  0001  0000  0010
// bottom  0101  0100  0110

function bitCode(p, bbox) {
    var code = 0;

    if (p[0] < bbox[0]) code |= 1; // left
    else if (p[0] > bbox[2]) code |= 2; // right

    if (p[1] < bbox[1]) code |= 4; // bottom
    else if (p[1] > bbox[3]) code |= 8; // top

    return code;
}

var lineclip$1 = /*@__PURE__*/getDefaultExportFromCjs(lineclip_1);

var minx = Infinity,
  miny = Infinity,
  maxx = -Infinity,
  maxy = -Infinity;
function getDefaultBBOX() {
  return [minx, miny, maxx, maxy];
}
var BBOX_TEMP = getDefaultBBOX();
function resetBBOX(bbox) {
  bbox[0] = minx;
  bbox[1] = miny;
  bbox[2] = maxx;
  bbox[3] = maxy;
}
function pointsBBOX(points, out) {
  if (!points) {
    return;
  }
  if (Array.isArray(points[0])) {
    for (var i = 0, len = points.length; i < len; i++) {
      pointsBBOX(points[i], out);
    }
  } else if (Array.isArray(points)) {
    for (var _i = 0, _len = points.length; _i < _len; _i++) {
      var {
        x: x,
        y: y
      } = points[_i];
      out[0] = Math.min(x, out[0]);
      out[1] = Math.min(y, out[1]);
      out[2] = Math.max(x, out[2]);
      out[3] = Math.max(y, out[3]);
    }
  } else {
    var {
      x: _x,
      y: _y
    } = points;
    out[0] = Math.min(_x, out[0]);
    out[1] = Math.min(_y, out[1]);
    out[2] = Math.max(_x, out[2]);
    out[3] = Math.max(_y, out[3]);
  }
}
function setBBOX(bbox, x1, y1, x2, y2) {
  if (x1 !== 0 && !x1) {
    return;
  }
  if (Array.isArray(x1)) {
    y1 = x1[1];
    x2 = x1[2];
    y2 = x1[3];
    x1 = x1[0];
  }
  bbox[0] = Math.min(x1, bbox[0]);
  bbox[1] = Math.min(y1, bbox[1]);
  bbox[2] = Math.max(x2, bbox[2]);
  bbox[3] = Math.max(y2, bbox[3]);
}
function validateBBOX(bbox) {
  return bbox && bbox[0] !== Infinity && bbox[0] !== undefined;
}
function bufferBBOX(bbox, bufferSize = 0) {
  bbox[0] -= bufferSize;
  bbox[1] -= bufferSize;
  bbox[2] += bufferSize;
  bbox[3] += bufferSize;
}
function bboxIntersect(bbox1, bbox2) {
  if (bbox1[2] < bbox2[0]) {
    return false;
  }
  if (bbox1[1] > bbox2[3]) {
    return false;
  }
  if (bbox1[0] > bbox2[2]) {
    return false;
  }
  if (bbox1[3] < bbox2[1]) {
    return false;
  }
  return true;
}
function bboxInBBOX(bbox1, bbox2) {
  var [x1, y1, x2, y2] = bbox1;
  return x1 >= bbox2[0] && x2 <= bbox2[2] && y1 >= bbox2[1] && y2 <= bbox2[3];
}
function bboxInMask(bbox, maskGeoJSON) {
  var maskBBOX = maskGeoJSON.bbox;
  if (!maskBBOX) {
    console.error('maskGeoJSON bbox is null:', maskGeoJSON);
    return false;
  }
  if (!bboxIntersect(maskBBOX, bbox)) {
    return false;
  } else {
    var geometry = maskGeoJSON.geometry;
    if (!geometry) {
      console.error('maskGeoJSON is error,not find geometry.', maskGeoJSON);
      return false;
    }
    var {
      coordinates: coordinates
    } = geometry;
    var type = geometry.type;
    if (type === 'Polygon') {
      coordinates = [coordinates];
    }
    for (var i = 0, len = coordinates.length; i < len; i++) {
      var rings = coordinates[i];
      var outRing = rings[0];
      var result = lineclip$1.polygon(outRing, bbox);
      if (result.length > 0) {
        var _minx = Infinity,
          _maxx = -Infinity,
          _miny = Infinity,
          _maxy = -Infinity;
        for (var j = 0, len1 = result.length; j < len1; j++) {
          var [x, y] = result[j];
          _minx = Math.min(x, _minx);
          _miny = Math.min(y, _miny);
          _maxx = Math.max(x, _maxx);
          _maxy = Math.max(y, _maxy);
        }
        if (_minx !== _maxx && _miny !== _maxy) {
          return true;
        }
      }
    }
    return false;
  }
}

var bbox = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BBOX_TEMP: BBOX_TEMP,
  bboxInBBOX: bboxInBBOX,
  bboxInMask: bboxInMask,
  bboxIntersect: bboxIntersect,
  bufferBBOX: bufferBBOX,
  getDefaultBBOX: getDefaultBBOX,
  pointsBBOX: pointsBBOX,
  resetBBOX: resetBBOX,
  setBBOX: setBBOX,
  validateBBOX: validateBBOX
});

var ResourceCacheMap = function () {
  function ResourceCacheMap() {
    this.resources = new Map();
    this._errors = new Map();
  }
  var _proto = ResourceCacheMap.prototype;
  _proto.addResource = function addResource(url, img) {
    var _this = this;
    var imgUrl = this._getImgUrl(url);
    this.resources.set(imgUrl, {
      image: img,
      width: +url[1],
      height: +url[2],
      refCnt: 0
    });
    if (img && img.width && img.height && !img.close && Browser$1.imageBitMap && !Browser$1.safari && !Browser$1.iosWeixin) {
      if (img.src && isSVG(img.src)) {
        return;
      }
      createImageBitmap(img).then(function (imageBitmap) {
        if (!_this.resources.has(imgUrl)) {
          return;
        }
        _this.resources.get(imgUrl).image = imageBitmap;
      });
    }
  };
  _proto.isResourceLoaded = function isResourceLoaded(url, checkSVG) {
    if (!url) {
      return false;
    }
    var imgUrl = this._getImgUrl(url);
    if (this._errors.has(imgUrl)) {
      return true;
    }
    var img = this.resources.get(imgUrl);
    if (!img) {
      return false;
    }
    if (checkSVG && isSVG(url[0]) && (+url[1] > img.width || +url[2] > img.height)) {
      return false;
    }
    return true;
  };
  _proto.login = function login(url) {
    var res = this.resources.get(url);
    if (res) {
      res.refCnt++;
    }
  };
  _proto.logout = function logout(url) {
    var res = this.resources.get(url);
    if (res && res.refCnt-- <= 0) {
      if (res.image && res.image.close) {
        res.image.close();
      }
      this.resources["delete"](url);
    }
  };
  _proto.getImage = function getImage(url) {
    var imgUrl = this._getImgUrl(url);
    if (!this.isResourceLoaded(url) || this._errors.has(imgUrl)) {
      return null;
    }
    return this.resources.get(imgUrl).image;
  };
  _proto.markErrorResource = function markErrorResource(url) {
    var imgUrl = this._getImgUrl(url);
    this._errors.set(imgUrl, 1);
  };
  _proto.merge = function merge(res) {
    var _this2 = this;
    if (!res) {
      return this;
    }
    var otherResource = res.resources;
    if (otherResource) {
      otherResource.forEach(function (value, key) {
        var img = value;
        _this2.addResource([key, img.width, img.height], img.image);
      });
    }
    return this;
  };
  _proto.forEach = function forEach(fn) {
    if (!this.resources) {
      return this;
    }
    this.resources.forEach(function (value, key) {
      fn(key, value);
    });
    return this;
  };
  _proto._getImgUrl = function _getImgUrl(url) {
    if (isImageBitMap(url)) {
      return url;
    }
    if (!Array.isArray(url)) {
      return url;
    }
    return url[0];
  };
  _proto.remove = function remove() {
    if (!this.resources) {
      return this;
    }
    this.resources.forEach(function (value) {
      if (value && value.image && value.image.close) {
        value.image.close();
      }
    });
    this.resources.clear();
    return this;
  };
  return ResourceCacheMap;
}();
var ResourceCache = function () {
  function ResourceCache() {
    this.resources = {};
    this._errors = {};
  }
  var _proto2 = ResourceCache.prototype;
  _proto2.addResource = function addResource(url, img) {
    var _this3 = this;
    this.resources[url[0]] = {
      image: img,
      width: +url[1],
      height: +url[2],
      refCnt: 0
    };
    if (img && img.width && img.height && !img.close && Browser$1.imageBitMap && !Browser$1.safari && !Browser$1.iosWeixin) {
      if (img.src && isSVG(img.src)) {
        return;
      }
      createImageBitmap(img).then(function (imageBitmap) {
        if (!_this3.resources[url[0]]) {
          return;
        }
        _this3.resources[url[0]].image = imageBitmap;
      });
    }
  };
  _proto2.isResourceLoaded = function isResourceLoaded(url, checkSVG) {
    if (!url) {
      return false;
    }
    var imgUrl = this._getImgUrl(url);
    if (this._errors[imgUrl]) {
      return true;
    }
    var img = this.resources[imgUrl];
    if (!img) {
      return false;
    }
    if (checkSVG && isSVG(url[0]) && (+url[1] > img.width || +url[2] > img.height)) {
      return false;
    }
    return true;
  };
  _proto2.login = function login(url) {
    var res = this.resources[url];
    if (res) {
      res.refCnt++;
    }
  };
  _proto2.logout = function logout(url) {
    var res = this.resources[url];
    if (res && res.refCnt-- <= 0) {
      if (res.image && res.image.close) {
        res.image.close();
      }
      delete this.resources[url];
    }
  };
  _proto2.getImage = function getImage(url) {
    var imgUrl = this._getImgUrl(url);
    if (!this.isResourceLoaded(url) || this._errors[imgUrl]) {
      return null;
    }
    return this.resources[imgUrl].image;
  };
  _proto2.markErrorResource = function markErrorResource(url) {
    this._errors[this._getImgUrl(url)] = 1;
  };
  _proto2.merge = function merge(res) {
    if (!res) {
      return this;
    }
    for (var p in res.resources) {
      var img = res.resources[p];
      this.addResource([p, img.width, img.height], img.image);
    }
    return this;
  };
  _proto2.forEach = function forEach(fn) {
    if (!this.resources) {
      return this;
    }
    for (var p in this.resources) {
      if (hasOwn(this.resources, p)) {
        fn(p, this.resources[p]);
      }
    }
    return this;
  };
  _proto2._getImgUrl = function _getImgUrl(url) {
    if (!Array.isArray(url)) {
      return url;
    }
    return url[0];
  };
  _proto2.remove = function remove() {
    for (var p in this.resources) {
      var res = this.resources[p];
      if (res && res.image && res.image.close) {
        res.image.close();
      }
    }
    this.resources = {};
  };
  return ResourceCache;
}();
function getResouceCacheInstance() {
  if (Browser$1.decodeImageInWorker) {
    return new ResourceCacheMap();
  }
  return new ResourceCache();
}

function set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
function sub(out, a, b) {
  return subtract(out, a, b);
}
function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
function length(a) {
  var x = a[0],
    y = a[1],
    z = a[2];
  return Math.sqrt(x * x + y * y + z * z);
}
function normalize(out, a) {
  var x = a[0],
    y = a[1],
    z = a[2];
  var len = x * x + y * y + z * z;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
  }
  return out;
}
function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
function cross(out, a, b) {
  var ax = a[0],
    ay = a[1],
    az = a[2],
    bx = b[0],
    by = b[1],
    bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot ? Math.hypot(x, y, z) : hypot$1(x, y, z);
}
function transformMat4(out, a, m) {
  var x = a[0],
    y = a[1],
    z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
function hypot$1(...args) {
  var y = 0;
  var i = args.length;
  while (i--) y += args[i] * args[i];
  return Math.sqrt(y);
}
function angle(a, b) {
  normalize(a, a);
  normalize(b, b);
  var cosine = dot(a, b);
  if (cosine > 1.0) {
    return 0;
  } else if (cosine < -1.0) {
    return Math.PI;
  } else {
    return Math.acos(cosine);
  }
}

var Plane = function () {
  function Plane(normal, constant) {
    this.normal = normal;
    this.constant = constant;
  }
  var _proto = Plane.prototype;
  _proto.distanceToPoint = function distanceToPoint(point) {
    return dot(this.normal, point) + this.constant;
  };
  return Plane;
}();

var scaledDir = [0, 0, 0];
var _edge1 = [0, 0, 0];
var _edge2 = [0, 0, 0];
var _normal = [0, 0, 0];
var _diff = [0, 0, 0];
var Ground = new Plane([0, 0, 1], 0);
var Ray = function () {
  function Ray(from, to) {
    this.setFromTo(from, to);
  }
  var _proto = Ray.prototype;
  _proto.setFromTo = function setFromTo(from, to) {
    this.origin = from;
    var direction = this.direction || [0, 0, 0];
    this.direction = normalize(direction, sub(direction, to, from));
  };
  _proto.distanceToPlane = function distanceToPlane(plane) {
    var denominator = dot(plane.normal, this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    var t = -(dot(this.origin, plane.normal) + plane.constant) / denominator;
    return t >= 0 ? t : null;
  };
  _proto.intersectGround = function intersectGround(target) {
    return this.intersectPlane(Ground, target);
  };
  _proto.distanceToGround = function distanceToGround() {
    return this.distanceToPlane(Ground);
  };
  _proto.intersectPlane = function intersectPlane(plane, target) {
    var t = this.distanceToPlane(plane);
    if (t === null) {
      return null;
    }
    return this.at(t, target);
  };
  _proto.intersectBox = function intersectBox(box, target) {
    var tmin, tmax, tymin, tymax, tzmin, tzmax;
    var invdirx = 1 / this.direction[0],
      invdiry = 1 / this.direction[1],
      invdirz = 1 / this.direction[2];
    var origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box[0][0] - origin[0]) * invdirx;
      tmax = (box[1][0] - origin[0]) * invdirx;
    } else {
      tmin = (box[1][0] - origin[0]) * invdirx;
      tmax = (box[0][0] - origin[0]) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box[0][1] - origin[1]) * invdiry;
      tymax = (box[1][1] - origin[1]) * invdiry;
    } else {
      tymin = (box[1][1] - origin[1]) * invdiry;
      tymax = (box[0][1] - origin[1]) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return null;
    if (tymin > tmin || isNaN(tmin)) tmin = tymin;
    if (tymax < tmax || isNaN(tmax)) tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box[0][2] - origin[2]) * invdirz;
      tzmax = (box[1][2] - origin[2]) * invdirz;
    } else {
      tzmin = (box[1][2] - origin[2]) * invdirz;
      tzmax = (box[0][2] - origin[2]) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return null;
    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    if (tmax < 0) return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  };
  _proto.intersectTriangle = function intersectTriangle(a, b, c, backfaceCulling, target) {
    sub(_edge1, b, a);
    sub(_edge2, c, a);
    cross(_normal, _edge1, _edge2);
    var DdN = dot(this.direction, _normal);
    var sign;
    if (DdN > 0) {
      if (backfaceCulling) return null;
      sign = 1;
    } else if (DdN < 0) {
      sign = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    sub(_diff, this.origin, a);
    cross(_edge2, _diff, _edge2);
    var DdQxE2 = sign * dot(this.direction, _edge2);
    if (DdQxE2 < 0) {
      return null;
    }
    cross(_edge1, _edge1, _diff);
    var DdE1xQ = sign * dot(this.direction, _edge1);
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    var QdN = -sign * dot(_diff, _normal);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  };
  _proto.at = function at(t, target) {
    copy(target, this.origin);
    return add(target, target, scale(scaledDir, this.direction, t));
  };
  return Ray;
}();

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Plane: Plane,
  Ray: Ray
});

var imageFetchWorkerKey = 'core-fetch-image';
var globalWorkerPool$1;
function setWorkerPool(pool) {
  globalWorkerPool$1 = pool;
}
function getWorkerPool() {
  return globalWorkerPool$1;
}
var workersCreated = false;
function setWorkersCreated() {
  workersCreated = true;
}
function workersHasCreated() {
  return workersCreated;
}
var ADAPTER_CREATED_LIST = [];
function adapterHasCreated(workerKey) {
  return ADAPTER_CREATED_LIST.indexOf(workerKey) > -1;
}
function pushAdapterCreated(workerKey) {
  if (!adapterHasCreated(workerKey)) {
    ADAPTER_CREATED_LIST.push(workerKey);
  }
}

var adapters = {};
function registerWorkerAdapter(workerKey, adapter) {
  adapters[workerKey] = adapter;
}
var header = "\n    var adapters = {};\n    // Dynamic Create Adapter\n    function createAdapter(key,code){\n        if(adapters[key]||!code){\n            return;\n        }\n        var func=new Function('exports',code+'(exports)');\n        var workerExports={};\n        func(workerExports,self);\n        adapters[key]=workerExports;\n        workerExports.initialize && workerExports.initialize(self);\n\n    }\n    onmessage = function (msg) {\n        msg = msg.data;\n        //createAdapter\n        if (msg.messageType === 'createAdapter') {\n           var key=msg.key;\n           var code=msg.code;\n           createAdapter(key,code);\n           postMessage({adapterName:key});\n           return;\n        }\n        // postMessage when main thread idle\n        if(msg.messageType==='idle'){\n            var messageRatio = msg.messageRatio;\n            handleMessageQueue(messageRatio);\n            return;\n        }\n        if (msg.messageType === 'batch') {\n            const messages = msg.messages;\n            if (messages) {\n                for (let i = 0; i < messages.length; i++) {\n                    dispatch(messages[i]);\n                }\n            }\n        } else {\n            dispatch(msg);\n        }\n    };\n\n    function dispatch(msg) {\n        var workerKey = msg.workerKey;\n        var adapter = adapters[workerKey];\n        if (!adapter) {\n            post(msg.callback, 'Unregistered worker adapters for ' + workerKey);\n            return;\n        }\n        try {\n            adapter.onmessage(msg, wrap(msg.callback));\n        } catch (err) {\n            post(msg.callback, workerKey + ':' + err.message);\n            console.error(err);\n            throw err;\n        }\n    }\n\n    var messageResultQueue = [];\n\n    function handleMessageQueue(messageRatio){\n       if(messageResultQueue.length===0){\n          return;\n       }\n       var count = Math.ceil((messageRatio || 1) * messageResultQueue.length);\n       var queues = messageResultQueue.slice(0, count);\n       queues.forEach(function(queue){\n          post(queue.callback,queue.err,queue.data,queue.buffers);\n       });\n       messageResultQueue=messageResultQueue.slice(count, Infinity);\n    }\n\n    function post(callback, err, data, buffers) {\n        var msg = {\n            callback : callback\n        };\n        if (err) {\n            msg.error = err;\n        } else {\n            msg.data = data;\n        }\n        if (buffers && buffers.length > 0) {\n            postMessage(msg, buffers);\n        } else {\n            postMessage(msg);\n        }\n    }\n\n    function joinQueue(callback,err,data,buffers){\n        messageResultQueue.push({\n            callback:callback,\n            err:err,\n            data:data,\n            buffers:buffers\n        });\n    }\n\n    function wrap(callback) {\n        return function (err, data, buffers) {\n            joinQueue(callback, err, data, buffers);\n        };\n    }\n    var workerExports;\n";
var footer = "\n    workerExports = null;\n";
function compileWorkerSource() {
  var source = header;
  for (var p in adapters) {
    var adapter = adapters[p];
    pushAdapterCreated(p);
    if (isFunction(adapter)) {
      if (adapter.length === 0) {
        adapter = adapter();
      }
    }
    source += "\n    workerExports = {};\n    (" + adapter + ")(workerExports, self);\n    adapters['" + p + "'] = workerExports";
    source += "\n    workerExports.initialize && workerExports.initialize(self);\n        ";
  }
  source += footer;
  return source;
}
var url;
function getWorkerSourcePath() {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!url) {
    var source = compileWorkerSource();
    url = window.URL.createObjectURL(new Blob([source], {
      type: 'text/javascript'
    }));
    adapters = {};
  }
  return url;
}
function createAdapter(key, cb) {
  if (!adapters[key]) {
    console.error("not find " + key + " adapter");
    return;
  }
  var adapter = adapters[key];
  if (isFunction(adapter)) {
    if (adapter.length === 0) {
      adapter = adapter();
    }
  }
  adapter = "(" + adapter + ")";
  var workerPool = getWorkerPool();
  if (!workerPool) {
    return;
  }
  var workers = workerPool.workers || [];
  if (workers.length === 0) {
    console.error('workerpool workers count is 0');
  }
  var count = 0;
  var _messageCB = function messageCB(msg) {
    msg = msg.data || {};
    if (msg.adapterName === key) {
      count++;
      if (count === workers.length) {
        workers.forEach(function (worker) {
          worker.removeEventListener('message', _messageCB);
        });
        delete adapters[key];
        cb();
      }
    }
  };
  workers.forEach(function (worker) {
    worker.addEventListener('message', _messageCB);
    worker.postMessage({
      key: key,
      code: adapter,
      messageType: 'createAdapter'
    });
  });
}

var hardwareConcurrency = typeof window !== 'undefined' ? window.navigator.hardwareConcurrency || 4 : 0;
var hardwareWorkerCount = Math.max(Math.floor(hardwareConcurrency / 2), 1);
var MessageBatch = function () {
  function MessageBatch(limit = 50) {
    this._limit = limit;
    this._messages = [];
    this.buffers = [];
  }
  var _proto = MessageBatch.prototype;
  _proto.addMessage = function addMessage(msg, buffers) {
    this._messages.push(msg);
    if (!Array.isArray(buffers)) {
      return;
    }
    for (var i = 0; i < buffers.length; i++) {
      if (this.buffers.indexOf(buffers[i]) < 0) {
        this.buffers.push(buffers[i]);
      }
    }
  };
  _proto.isFull = function isFull() {
    return this._messages.length >= this._limit;
  };
  _proto.getMessage = function getMessage() {
    return {
      messageType: 'batch',
      messages: this._messages
    };
  };
  return MessageBatch;
}();
var WorkerPool = function () {
  function WorkerPool() {
    this.active = {};
    this.workerCount = typeof window !== 'undefined' ? GlobalConfig.workerCount || hardwareWorkerCount : 0;
    this._messages = [];
    this._messageBuffers = [];
  }
  var _proto2 = WorkerPool.prototype;
  _proto2.acquire = function acquire(id) {
    if (!this.workers) {
      this.workers = [];
      var url = getWorkerSourcePath();
      for (var i = 0; i < this.workerCount; i++) {
        var worker = new Worker(url);
        worker.id = i;
        this.workers.push(worker);
      }
      URL.revokeObjectURL(url);
      setWorkersCreated();
    }
    this.active[id] = true;
    return this.workers.slice();
  };
  _proto2.release = function release(id) {
    delete this.active[id];
    if (Object.keys(this.active).length === 0) {
      this.workers.forEach(function (w) {
        w.terminate();
      });
      this.workers = null;
    }
  };
  _proto2.addMessage = function addMessage(workerId, data, buffers) {
    var batches = this._messages[workerId];
    if (!batches || !batches.length) {
      batches = this._messages[workerId] = [new MessageBatch()];
    }
    var batch = batches[batches.length - 1];
    if (batch.isFull()) {
      batch = new MessageBatch();
      this._messages[workerId].push(batch);
    }
    batch.addMessage(data, buffers);
  };
  _proto2.commit = function commit() {
    if (!this.workers) {
      return;
    }
    if (this._messages.length) {
      for (var i = 0; i < this._messages.length; i++) {
        if (!this._messages[i] || !this._messages[i].length) {
          continue;
        }
        var batch = this._messages[i].shift();
        this.workers[i].postMessage(batch.getMessage(), batch.buffers);
      }
    }
  };
  _proto2.getWorkers = function getWorkers() {
    return this.workers || [];
  };
  _proto2.broadcastIdleMessage = function broadcastIdleMessage(messageRatio) {
    var workers = this.getWorkers();
    workers.forEach(function (worker) {
      worker.postMessage({
        messageType: 'idle',
        messageRatio: messageRatio
      });
    });
    return this;
  };
  return WorkerPool;
}();
var globalWorkerPool;
function getGlobalWorkerPool() {
  if (!globalWorkerPool) {
    globalWorkerPool = new WorkerPool();
    setWorkerPool(globalWorkerPool);
  }
  return globalWorkerPool;
}

var tasks = [];
var loopHooks = [];
function runTaskAsync(task) {
  startTasks();
  var promise = new Promise(function (resolve, reject) {
    if (!task) {
      reject(new Error('task is null'));
      return;
    }
    if (isFunction(task)) {
      task = {
        count: 1,
        run: task
      };
    }
    if (!task.run) {
      reject(new Error('task.run is null'));
      return;
    }
    if (isNil(task.count)) {
      task.count = 1;
    }
    task.count = Math.ceil(task.count);
    if (!isNumber(task.count)) {
      reject(new Error('task.count is not number'));
      return;
    }
    var taskItem = task;
    taskItem.results = [];
    tasks.push(taskItem);
    taskItem.resolve = resolve;
  });
  return promise;
}
function executeMicroTasks() {
  if (tasks.length === 0) {
    return;
  }
  var runingTasks = [],
    endTasks = [];
  var len = tasks.length;
  for (var i = 0; i < len; i++) {
    var task = tasks[i];
    task.count--;
    if (task.count === -1) {
      endTasks.push(task);
    } else {
      runingTasks.push(task);
      var result = task.run();
      task.results.push(result);
    }
  }
  tasks = runingTasks;
  len = endTasks.length;
  for (var _i = 0; _i < len; _i++) {
    var _task = endTasks[_i];
    if (_task.resolve) {
      _task.resolve(_task.results);
    }
  }
}
function loop(isBusy) {
  var messageRatio = GlobalConfig.messagePostRatioPerWorker * (isBusy ? 0.5 : 1);
  getGlobalWorkerPool().commit();
  getGlobalWorkerPool().broadcastIdleMessage(messageRatio);
  executeMicroTasks();
  loopHooks.forEach(function (func) {
    func();
  });
}
var idleCallTime = now();
function idleFrameLoop() {
  loop();
  idleCallTime = now();
  requestIdleCallback(idleFrameLoop);
}
function animFrameLoop() {
  if (Browser$1.requestIdleCallback) {
    var {
      idleForceTimeThreshold: idleForceTimeThreshold,
      idleLog: idleLog
    } = GlobalConfig;
    var time = now();
    if (time - idleCallTime > idleForceTimeThreshold) {
      loop(true);
      idleCallTime = now();
      if (idleLog) {
        console.warn("did not apply for availability, forced run idle");
      }
    }
  } else {
    loop();
  }
  requestAnimFrame(animFrameLoop);
}
var started = false;
function startTasks() {
  if (started) {
    return;
  }
  started = true;
  if (Browser$1.requestIdleCallback) {
    requestIdleCallback(idleFrameLoop);
  }
  requestAnimFrame(animFrameLoop);
}
function pushLoopHook(func) {
  if (loopHooks.indexOf(func) > -1) {
    return;
  }
  if (isFunction(func)) {
    loopHooks.push(func);
  }
}

var MicroTask = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pushLoopHook: pushLoopHook,
  runTaskAsync: runTaskAsync,
  startTasks: startTasks
});

var LRUCache = function () {
  function LRUCache(max, onRemove) {
    var nullOnRemove = function nullOnRemove() {};
    this.max = max;
    this.onRemove = onRemove || nullOnRemove;
    this.reset();
  }
  var _proto = LRUCache.prototype;
  _proto.reset = function reset() {
    if (this.data) {
      var values = this.data.values();
      for (var _iterator = _createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;) {
        var p = _step.value;
        this.onRemove(p);
      }
    }
    this.data = new Map();
    return this;
  };
  _proto.clear = function clear() {
    this.reset();
    delete this.onRemove;
  };
  _proto.add = function add(key, data) {
    if (!data) {
      return this;
    }
    if (this.has(key)) {
      this.data["delete"](key);
      this.data.set(key, data);
    } else {
      this.data.set(key, data);
    }
    return this;
  };
  _proto.keys = function keys() {
    var keys = new Array(this.data.size);
    var i = 0;
    var iterator = this.data.keys();
    for (var _iterator2 = _createForOfIteratorHelperLoose(iterator), _step2; !(_step2 = _iterator2()).done;) {
      var k = _step2.value;
      keys[i++] = k;
    }
    return keys;
  };
  _proto.shrink = function shrink() {
    var iterator = this.data.keys();
    var item = iterator.next();
    while (this.data.size > this.max) {
      var removedData = this.getAndRemove(item.value);
      if (removedData) {
        this.onRemove(removedData);
      }
      item = iterator.next();
    }
  };
  _proto.has = function has(key) {
    return this.data.has(key);
  };
  _proto.getAndRemove = function getAndRemove(key) {
    if (!this.has(key)) {
      return null;
    }
    var data = this.data.get(key);
    this.data["delete"](key);
    return data;
  };
  _proto.get = function get(key) {
    if (!this.has(key)) {
      return null;
    }
    var data = this.data.get(key);
    return data;
  };
  _proto.remove = function remove(key) {
    if (!this.has(key)) {
      return this;
    }
    var data = this.data.get(key);
    this.data["delete"](key);
    this.onRemove(data);
    return this;
  };
  _proto.setMaxSize = function setMaxSize(max) {
    this.max = max;
    if (this.data.size > this.max) {
      this.shrink();
    }
    return this;
  };
  return LRUCache;
}();

var rbush$2 = {exports: {}};

var quickselect$1 = {exports: {}};

(function (module, exports) {
	(function (global, factory) {
		module.exports = factory() ;
	}(commonjsGlobal, (function () {
	function quickselect(arr, k, left, right, compare) {
	    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);
	}

	function quickselectStep(arr, k, left, right, compare) {

	    while (right > left) {
	        if (right - left > 600) {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	            quickselectStep(arr, k, newLeft, newRight, compare);
	        }

	        var t = arr[k];
	        var i = left;
	        var j = right;

	        swap(arr, left, k);
	        if (compare(arr[right], t) > 0) swap(arr, left, right);

	        while (i < j) {
	            swap(arr, i, j);
	            i++;
	            j--;
	            while (compare(arr[i], t) < 0) i++;
	            while (compare(arr[j], t) > 0) j--;
	        }

	        if (compare(arr[left], t) === 0) swap(arr, left, j);
	        else {
	            j++;
	            swap(arr, j, right);
	        }

	        if (j <= k) left = j + 1;
	        if (k <= j) right = j - 1;
	    }
	}

	function swap(arr, i, j) {
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}

	function defaultCompare(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	}

	return quickselect;

	}))); 
} (quickselect$1));

var quickselectExports = quickselect$1.exports;

rbush$2.exports = rbush;
rbush$2.exports.default = rbush;

var quickselect = quickselectExports;

function rbush(maxEntries, format) {
    if (!(this instanceof rbush)) return new rbush(maxEntries, format);

    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));

    if (format) {
        this._initFormat(format);
    }

    this.clear();
}

rbush.prototype = {

    all: function () {
        return this._all(this.data, []);
    },

    search: function (bbox) {

        var node = this.data,
            result = [],
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return result;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return result;
    },

    collides: function (bbox) {

        var node = this.data,
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return false;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return false;
    },

    load: function (data) {
        if (!(data && data.length)) return this;

        if (data.length < this._minEntries) {
            for (var i = 0, len = data.length; i < len; i++) {
                this.insert(data[i]);
            }
            return this;
        }

        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);

        if (!this.data.children.length) {
            // save as is if tree is empty
            this.data = node;

        } else if (this.data.height === node.height) {
            // split root if trees have the same height
            this._splitRoot(this.data, node);

        } else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }

            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }

        return this;
    },

    insert: function (item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },

    clear: function () {
        this.data = createNode([]);
        return this;
    },

    remove: function (item, equalsFn) {
        if (!item) return this;

        var node = this.data,
            bbox = this.toBBox(item),
            path = [],
            indexes = [],
            i, parent, index, goingUp;

        // depth-first iterative tree traversal
        while (node || path.length) {

            if (!node) { // go up
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }

            if (node.leaf) { // check current node
                index = findItem(item, node.children, equalsFn);

                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }

            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];

            } else if (parent) { // go right
                i++;
                node = parent.children[i];
                goingUp = false;

            } else node = null; // nothing found
        }

        return this;
    },

    toBBox: function (item) { return item; },

    compareMinX: compareNodeMinX,
    compareMinY: compareNodeMinY,

    toJSON: function () { return this.data; },

    fromJSON: function (data) {
        this.data = data;
        return this;
    },

    _all: function (node, result) {
        var nodesToSearch = [];
        while (node) {
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);

            node = nodesToSearch.pop();
        }
        return result;
    },

    _build: function (items, left, right, height) {

        var N = right - left + 1,
            M = this._maxEntries,
            node;

        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }

        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));

            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }

        node = createNode([]);
        node.leaf = false;
        node.height = height;

        // split the items into M mostly square tiles

        var N2 = Math.ceil(N / M),
            N1 = N2 * Math.ceil(Math.sqrt(M)),
            i, j, right2, right3;

        multiSelect(items, left, right, N1, this.compareMinX);

        for (i = left; i <= right; i += N1) {

            right2 = Math.min(i + N1 - 1, right);

            multiSelect(items, i, right2, N2, this.compareMinY);

            for (j = i; j <= right2; j += N2) {

                right3 = Math.min(j + N2 - 1, right2);

                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }

        calcBBox(node, this.toBBox);

        return node;
    },

    _chooseSubtree: function (bbox, node, level, path) {

        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;

        while (true) {
            path.push(node);

            if (node.leaf || path.length - 1 === level) break;

            minArea = minEnlargement = Infinity;

            for (i = 0, len = node.children.length; i < len; i++) {
                child = node.children[i];
                area = bboxArea(child);
                enlargement = enlargedArea(bbox, child) - area;

                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;

                } else if (enlargement === minEnlargement) {
                    // otherwise choose one with the smallest area
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }

            node = targetNode || node.children[0];
        }

        return node;
    },

    _insert: function (item, level, isNode) {

        var toBBox = this.toBBox,
            bbox = isNode ? item : toBBox(item),
            insertPath = [];

        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);

        // put the item into the node
        node.children.push(item);
        extend(node, bbox);

        // split on node overflow; propagate upwards if necessary
        while (level >= 0) {
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }

        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },

    // split overflowed node into two
    _split: function (insertPath, level) {

        var node = insertPath[level],
            M = node.children.length,
            m = this._minEntries;

        this._chooseSplitAxis(node, m, M);

        var splitIndex = this._chooseSplitIndex(node, m, M);

        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;

        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);

        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },

    _splitRoot: function (node, newNode) {
        // split root node
        this.data = createNode([node, newNode]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    },

    _chooseSplitIndex: function (node, m, M) {

        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;

        minOverlap = minArea = Infinity;

        for (i = m; i <= M - m; i++) {
            bbox1 = distBBox(node, 0, i, this.toBBox);
            bbox2 = distBBox(node, i, M, this.toBBox);

            overlap = intersectionArea(bbox1, bbox2);
            area = bboxArea(bbox1) + bboxArea(bbox2);

            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;

                minArea = area < minArea ? area : minArea;

            } else if (overlap === minOverlap) {
                // otherwise choose distribution with minimum area
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }

        return index;
    },

    // sorts node children by the best axis for split
    _chooseSplitAxis: function (node, m, M) {

        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
            xMargin = this._allDistMargin(node, m, M, compareMinX),
            yMargin = this._allDistMargin(node, m, M, compareMinY);

        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },

    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function (node, m, M, compare) {

        node.children.sort(compare);

        var toBBox = this.toBBox,
            leftBBox = distBBox(node, 0, m, toBBox),
            rightBBox = distBBox(node, M - m, M, toBBox),
            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
            i, child;

        for (i = m; i < M - m; i++) {
            child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }

        for (i = M - m - 1; i >= m; i--) {
            child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }

        return margin;
    },

    _adjustParentBBoxes: function (bbox, path, level) {
        // adjust bboxes along the given tree path
        for (var i = level; i >= 0; i--) {
            extend(path[i], bbox);
        }
    },

    _condense: function (path) {
        // go through the path, removing empty nodes and updating bboxes
        for (var i = path.length - 1, siblings; i >= 0; i--) {
            if (path[i].children.length === 0) {
                if (i > 0) {
                    siblings = path[i - 1].children;
                    siblings.splice(siblings.indexOf(path[i]), 1);

                } else this.clear();

            } else calcBBox(path[i], this.toBBox);
        }
    },

    _initFormat: function (format) {
        // data format (minX, minY, maxX, maxY accessors)

        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls

        var compareArr = ['return a', ' - b', ';'];

        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));

        this.toBBox = new Function('a',
            'return {minX: a' + format[0] +
            ', minY: a' + format[1] +
            ', maxX: a' + format[2] +
            ', maxY: a' + format[3] + '};');
    }
};

function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);

    for (var i = 0; i < items.length; i++) {
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}

// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}

// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;

    for (var i = k, child; i < p; i++) {
        child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }

    return destNode;
}

function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}

function compareNodeMinX(a, b) { return a.minX - b.minX; }
function compareNodeMinY(a, b) { return a.minY - b.minY; }

function bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }
function bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }

function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}

function intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX),
        minY = Math.max(a.minY, b.minY),
        maxX = Math.min(a.maxX, b.maxX),
        maxY = Math.min(a.maxY, b.maxY);

    return Math.max(0, maxX - minX) *
           Math.max(0, maxY - minY);
}

function contains(a, b) {
    return a.minX <= b.minX &&
           a.minY <= b.minY &&
           b.maxX <= a.maxX &&
           b.maxY <= a.maxY;
}

function intersects(a, b) {
    return b.minX <= a.maxX &&
           b.minY <= a.maxY &&
           b.maxX >= a.minX &&
           b.maxY >= a.minY;
}

function createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}

// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach

function multiSelect(arr, left, right, n, compare) {
    var stack = [left, right],
        mid;

    while (stack.length) {
        right = stack.pop();
        left = stack.pop();

        if (right - left <= n) continue;

        mid = left + Math.ceil((right - left) / n / 2) * n;
        quickselect(arr, mid, left, right, compare);

        stack.push(left, mid, mid, right);
    }
}

var rbushExports = rbush$2.exports;
var rbush$1 = /*@__PURE__*/getDefaultExportFromCjs(rbushExports);

var search = {};
var CollisionIndex = function () {
  function CollisionIndex() {
    this._tree = rbush$1(9, ['[0]', '[1]', '[2]', '[3]']);
  }
  var _proto = CollisionIndex.prototype;
  _proto.collides = function collides(box) {
    [search.minX, search.minY, search.maxX, search.maxY] = box;
    return this._tree.collides(search);
  };
  _proto.insertBox = function insertBox(box) {
    var tree = this._tree;
    tree.insert(box);
    return this;
  };
  _proto.bulkInsertBox = function bulkInsertBox(boxes) {
    this._tree.load(boxes);
    return this;
  };
  _proto.clear = function clear() {
    this._tree.clear();
    return this;
  };
  return CollisionIndex;
}();

var charTextureLRUCache = new LRUCache(50000);
function getCharTexture(tempCtx, style, _char) {
  var font = tempCtx.font;
  var fillStyle = tempCtx.fillStyle;
  var strokeStyle = tempCtx.strokeStyle;
  var textHaloFill = style.textHaloFill || DEFAULT_STROKE_COLOR;
  var textHaloRadius = style.textHaloRadius || 0;
  var textHaloOpacity = style.textHaloOpacity;
  if (!isNumber(textHaloOpacity)) {
    textHaloOpacity = 1;
  }
  var key = font + "_" + fillStyle + "_" + textHaloFill + "_" + textHaloRadius + "_" + textHaloOpacity + "_" + _char;
  var texture = charTextureLRUCache.get(key);
  if (!texture) {
    var drawHalo = textHaloOpacity !== 0 && textHaloRadius !== 0;
    var textSize = ((style.textSize || 14) * 1.2 + textHaloRadius) * 2;
    var canvas = Canvas.createCanvas(textSize, textSize);
    canvas.style.width = textSize / 2 + "px";
    canvas.style.height = textSize / 2 + "px";
    var x = textSize / 4,
      y = textSize / 4;
    var ctx = Canvas.getCanvas2DContext(canvas);
    ctx.scale(2, 2);
    ctx.font = font;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    if (drawHalo) {
      ctx.strokeStyle = strokeStyle;
      ctx.lineWidth = textHaloRadius * 2;
      ctx.globalAlpha = 1;
      ctx.globalAlpha *= textHaloOpacity;
      ctx.strokeText(_char, x, y);
      ctx.globalAlpha = 1;
    }
    ctx.fillStyle = fillStyle;
    ctx.fillText(_char, x, y);
    texture = canvas;
    charTextureLRUCache.add(key, texture);
  }
  return texture;
}
var DEFAULT_STROKE_COLOR = '#000';
var DEFAULT_FILL_COLOR = 'rgba(255,255,255,0)';
var DEFAULT_TEXT_COLOR = '#000';
var hitTesting = false;
var TEMP_CANVAS = null;
var RADIAN$1 = Math.PI / 180;
var textOffsetY = 1;
var TEXT_BASELINE = 'top';
var textCharsCollisionIndex = new CollisionIndex();
var textPathsCollisionIndex = new CollisionIndex();
function getDefaultCharacterSet() {
  var charSet = {};
  for (var i = 32; i < 128; i++) {
    var _char2 = String.fromCharCode(i);
    charSet[_char2] = _char2;
  }
  return charSet;
}
var defaultChars = getDefaultCharacterSet();
function textIsDefaultChars(chars) {
  for (var i = 0, len = chars.length; i < len; i++) {
    var _char3 = chars[i];
    if (!defaultChars[_char3]) {
      return false;
    }
  }
  return true;
}
function reverseChars(chars) {
  if (chars.toReversed) {
    return chars.toReversed();
  }
  var newChars = [];
  for (var i = 0, len = chars.length - 1; i <= len; i++) {
    newChars[i] = chars[len - i];
  }
  return newChars;
}
function getCharRotation(p1, p2, _char4, direction, isDefaultChars) {
  var x0 = p1.x,
    y0 = p1.y;
  var x1 = p2.x,
    y1 = p2.y;
  var dx = x1 - x0;
  var dy = y1 - y0;
  var rad = Math.atan2(dy, dx);
  var degree = rad / Math.PI * 180;
  if (direction === 'left') {
    degree += 180;
    rad = degree / 180 * Math.PI;
    return rad;
  }
  if (direction === 'down' && !isDefaultChars) {
    degree -= 90;
    rad = degree / 180 * Math.PI;
    return rad;
  }
  if (direction === 'up' && !isDefaultChars) {
    degree += 90;
    rad = degree / 180 * Math.PI;
    return rad;
  }
  return rad;
}
function measureCharSize(_char5, fontSize) {
  var w = fontSize,
    h = fontSize;
  if (defaultChars[_char5]) {
    w = fontSize / 4;
    h = fontSize;
  }
  var d = Math.sqrt(w * w + h * h);
  return d;
}
function measureTextLength(textName, fontSize) {
  var textLen = 0;
  for (var i = 0, len = textName.length; i < len; i++) {
    var _char6 = textName[i];
    textLen += measureCharSize(_char6, fontSize);
  }
  return textLen;
}
function getPercentPoint(segment, dis) {
  var {
    distance: distance,
    p1: p1,
    p2: p2
  } = segment;
  var dx = p2.x - p1.x,
    dy = p2.y - p1.y,
    dh = (p2.z || 0) - (p1.z || 0);
  var percent = dis / distance;
  var x = p1.x + percent * dx;
  var y = p1.y + percent * dy;
  var z = (p1.z || 0) + percent * dh;
  return new Point(x, y, z);
}
function lineSeg(points, options) {
  options = Object.assign({
    segDistance: 1,
    isGeo: true
  }, options);
  var segDistance = Math.max(options.segDistance, 0.00000000000000001);
  var segments = [];
  var totalLen = 0,
    idx = 0;
  for (var i = 0, _len = points.length; i < _len - 1; i++) {
    var p1 = points[i],
      p2 = points[i + 1];
    var dis = p2.distanceTo(p1);
    segments[idx] = {
      p1: p1,
      distance: dis,
      p2: p2
    };
    idx++;
    totalLen += dis;
  }
  if (totalLen <= segDistance) {
    return [{
      distance: totalLen,
      points: points
    }];
  }
  var len = segments.length;
  var first = segments[0];
  idx = 0;
  var currentPoint;
  var currentLen = 0;
  var lines = [];
  var tempLine = [first.p1];
  while (idx < len) {
    var {
      distance: distance,
      p2: _p
    } = segments[idx];
    currentLen += distance;
    if (currentLen < segDistance) {
      tempLine.push(_p);
      idx++;
      continue;
    }
    if (currentLen === segDistance) {
      tempLine.push(_p);
      currentLen = 0;
      lines.push(tempLine);
      tempLine = [_p];
      idx++;
      continue;
    }
    if (currentLen > segDistance) {
      var offsetLen = segDistance - (currentLen - distance);
      currentPoint = getPercentPoint(segments[idx], offsetLen);
      tempLine.push(currentPoint);
      lines.push(tempLine);
      currentLen = 0;
      segments[idx].p1 = currentPoint;
      segments[idx].distance = distance - offsetLen;
      tempLine = [currentPoint];
    }
  }
  if (tempLine.length) {
    lines.push(tempLine);
  }
  var result = [];
  for (var _i = 0, _len2 = lines.length; _i < _len2; _i++) {
    var line = lines[_i];
    result[_i] = {
      points: line,
      distance: pathDistance(line)
    };
  }
  return result;
}
function textPathDirection(path) {
  var len = path.length;
  var first = path[0].point,
    last = path[len - 1].point;
  var bbox = getDefaultBBOX();
  for (var i = 0, _len3 = path.length; i < _len3; i++) {
    var point = path[i].point;
    pointsBBOX(point, bbox);
  }
  var [minx, miny, maxx, maxy] = bbox;
  var dx = maxx - minx,
    dy = maxy - miny;
  var ishorizontal = true;
  if (dy > dx) {
    ishorizontal = false;
  }
  if (ishorizontal) {
    if (first.x < last.x) {
      return 'right';
    }
    return 'left';
  } else {
    if (first.y < last.y) {
      return 'down';
    }
    return 'up';
  }
}
function getTextPath(chunk, chars, fontSize, globalCollisonIndex) {
  var total = pathDistance(chunk);
  var result = [];
  var tempLen = 0;
  var hasCollision = false;
  textCharsCollisionIndex.clear();
  var idx = 1;
  for (var i = 0, len = chars.length; i < len; i++) {
    var _char7 = chars[i];
    var charSize = measureCharSize(_char7, fontSize);
    var d = charSize + tempLen;
    for (var j = idx, len1 = chunk.length; j < len1; j++) {
      var p1 = chunk[j - 1];
      var p2 = chunk[j];
      if (p2.distance < d) {
        continue;
      }
      idx = j;
      var dDistance = d - p1.distance;
      var percent = dDistance / (p2.distance - p1.distance);
      var dx = p2.x - p1.x,
        dy = p2.y - p1.y;
      var point = new Point(p1.x + dx * percent, p1.y + dy * percent);
      var {
        x: x,
        y: y
      } = point;
      var bufferSize = charSize / 3;
      var bbox = [x - bufferSize, y - bufferSize, x + bufferSize, y + bufferSize];
      if (globalCollisonIndex && globalCollisonIndex.collides(bbox)) {
        hasCollision = true;
        break;
      }
      if (textCharsCollisionIndex.collides(bbox)) {
        hasCollision = true;
        break;
      } else {
        textCharsCollisionIndex.insertBox(bbox);
      }
      bufferSize = charSize / 2;
      result.push({
        "char": _char7,
        charSize: charSize,
        point: point,
        bbox: [x - bufferSize, y - bufferSize, x + bufferSize, y + bufferSize]
      });
      tempLen += charSize;
      break;
    }
    if (hasCollision) {
      break;
    }
  }
  if (hasCollision) {
    return [];
  }
  if (total < tempLen) {
    return [];
  }
  return result;
}
function interpolate$1(t0, t1, x1, y1, bx1, by1, bx2, by2, x2, y2) {
  var u0 = 1.0 - t0;
  var u1 = 1.0 - t1;
  var qxa = x1 * u0 * u0 + bx1 * 2 * t0 * u0 + bx2 * t0 * t0;
  var qxb = x1 * u1 * u1 + bx1 * 2 * t1 * u1 + bx2 * t1 * t1;
  var qxc = bx1 * u0 * u0 + bx2 * 2 * t0 * u0 + x2 * t0 * t0;
  var qxd = bx1 * u1 * u1 + bx2 * 2 * t1 * u1 + x2 * t1 * t1;
  var qya = y1 * u0 * u0 + by1 * 2 * t0 * u0 + by2 * t0 * t0;
  var qyb = y1 * u1 * u1 + by1 * 2 * t1 * u1 + by2 * t1 * t1;
  var qyc = by1 * u0 * u0 + by2 * 2 * t0 * u0 + y2 * t0 * t0;
  var qyd = by1 * u1 * u1 + by2 * 2 * t1 * u1 + y2 * t1 * t1;
  var xb = qxa * u1 + qxc * t1;
  var xc = qxb * u0 + qxd * t0;
  var xd = qxb * u1 + qxd * t1;
  var yb = qya * u1 + qyc * t1;
  var yc = qyb * u0 + qyd * t0;
  var yd = qyb * u1 + qyd * t1;
  return [xb, yb, xc, yc, xd, yd];
}
function getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, t) {
  var xc1 = (x0 + x1) / 2.0,
    yc1 = (y0 + y1) / 2.0;
  var xc2 = (x1 + x2) / 2.0,
    yc2 = (y1 + y2) / 2.0;
  var xc3 = (x2 + x3) / 2.0,
    yc3 = (y2 + y3) / 2.0;
  var len1 = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
  var len2 = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  var len3 = Math.sqrt((x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2));
  var k1 = len1 / (len1 + len2);
  var k2 = len2 / (len2 + len3);
  var xm1 = xc1 + (xc2 - xc1) * k1,
    ym1 = yc1 + (yc2 - yc1) * k1;
  var xm2 = xc2 + (xc3 - xc2) * k2,
    ym2 = yc2 + (yc3 - yc2) * k2;
  var ctrl1X = xm1 + (xc2 - xm1) * smoothValue + x1 - xm1,
    ctrl1Y = ym1 + (yc2 - ym1) * smoothValue + y1 - ym1,
    ctrl2X = xm2 + (xc2 - xm2) * smoothValue + x2 - xm2,
    ctrl2Y = ym2 + (yc2 - ym2) * smoothValue + y2 - ym2;
  var ctrlPoints = [ctrl1X, ctrl1Y, ctrl2X, ctrl2Y];
  if (t < 1) {
    return interpolate$1(0, t, x1, y1, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y, x2, y2);
  } else {
    return ctrlPoints;
  }
}
function pathDistance(points) {
  if (points.length < 2) {
    return 0;
  }
  var total = 0;
  points[0].distance = 0;
  for (var i = 1, len = points.length; i < len; i++) {
    var p1 = points[i - 1],
      p2 = points[i];
    var distance = p1.distanceTo(p2);
    p2.distance = distance + p1.distance;
    total += distance;
  }
  return total;
}
function getColorInMinStep(colorIn) {
  if (isNumber(colorIn.minStep)) {
    return colorIn.minStep;
  }
  var colors = colorIn.colors || [];
  var len = colors.length;
  var steps = [];
  for (var i = 0; i < len; i++) {
    steps[i] = colors[i][0];
  }
  steps.sort(function (a, b) {
    return a - b;
  });
  var min = Infinity;
  for (var _i2 = 1; _i2 < len; _i2++) {
    var step1 = steps[_i2 - 1],
      step2 = steps[_i2];
    var stepOffset = step2 - step1;
    min = Math.min(min, stepOffset);
  }
  colorIn.minStep = min;
  return min;
}
function getSegmentPercentPoint(p1, p2, percent) {
  var x1 = p1.x,
    y1 = p1.y,
    x2 = p2.x,
    y2 = p2.y;
  var dx = x2 - x1,
    dy = y2 - y1;
  return new Point(x1 + dx * percent, y1 + dy * percent);
}
function rgbaToCSSRGBA(r, g, b, a) {
  return "rgba(" + r + ", " + g + ", " + b + ", " + a / 255 + ")";
}
var TEMP_LAYER_CANVAS;
var Canvas = {
  getTempCanvas: function getTempCanvas() {
    if (!TEMP_LAYER_CANVAS) {
      TEMP_LAYER_CANVAS = Canvas.createCanvas(1, 1);
    }
    return TEMP_LAYER_CANVAS;
  },
  getCanvas2DPerformanceContext: function getCanvas2DPerformanceContext(canvas) {
    return canvas.getContext('2d', {});
  },
  getCanvas2DContext: function getCanvas2DContext(canvas) {
    return canvas.getContext('2d', {
      willReadFrequently: true
    });
  },
  setHitTesting: function setHitTesting(testing) {
    hitTesting = testing;
  },
  createCanvas: function createCanvas(width, height, canvasClass) {
    var canvas;
    if (!IS_NODE) {
      canvas = createEl('canvas');
      canvas.width = width;
      canvas.height = height;
    } else {
      canvas = new canvasClass(width, height);
    }
    return canvas;
  },
  prepareCanvasFont: function prepareCanvasFont(ctx, style, font) {
    if (ctx.textBaseline !== TEXT_BASELINE) {
      ctx.textBaseline = TEXT_BASELINE;
    }
    font = font || getFont(style);
    if (ctx.font !== font) {
      ctx.font = font;
    }
    var fill = style['textFill'];
    if (!fill) {
      fill = DEFAULT_TEXT_COLOR;
    }
    var fillStyle = Canvas.getRgba(fill, style['textOpacity']);
    if (ctx.fillStyle !== fillStyle) {
      ctx.fillStyle = fillStyle;
    }
  },
  prepareCanvas: function prepareCanvas(ctx, style, resources, testing) {
    if (!style) {
      return;
    }
    var strokeWidth = style['lineWidth'];
    if (!isNil(strokeWidth) && ctx.lineWidth !== strokeWidth) {
      ctx.lineWidth = strokeWidth;
    }
    var strokePattern = style['linePatternFile'];
    var strokeColor = style['lineColor'] || DEFAULT_STROKE_COLOR;
    var lineStrokeColor = style['lineStrokeColor'];
    var lineStrokeWidth = style['lineStrokeWidth'];
    ctx.lineStrokeColor = null;
    ctx.lineStrokeWidth = null;
    if (lineStrokeColor) {
      if (Array.isArray(lineStrokeColor)) {
        lineStrokeColor = Canvas.normalizeColorToRGBA(lineStrokeColor);
      }
      ctx.lineStrokeColor = lineStrokeColor;
    }
    if (lineStrokeWidth && lineStrokeWidth > 0) {
      ctx.lineStrokeWidth = lineStrokeWidth;
    }
    if (testing) {
      ctx.strokeStyle = '#000';
    } else if (strokePattern && resources) {
      var patternOffset;
      if (style['linePatternDx'] || style['linePatternDy']) {
        patternOffset = [style['linePatternDx'], style['linePatternDy']];
      }
      Canvas._setStrokePattern(ctx, strokePattern, strokeWidth, patternOffset, resources);
      style['lineDasharray'] = [];
    } else if (isGradient(strokeColor)) {
      if (style['lineGradientExtent']) {
        ctx.strokeStyle = Canvas._createGradient(ctx, strokeColor, style['lineGradientExtent']);
      } else {
        ctx.strokeStyle = DEFAULT_STROKE_COLOR;
      }
    } else {
        if (Array.isArray(strokeColor)) {
          strokeColor = Canvas.normalizeColorToRGBA(strokeColor);
        }
        ctx.strokeStyle = strokeColor;
      }
    if (style['lineJoin']) {
      ctx.lineJoin = style['lineJoin'];
    }
    if (style['lineCap']) {
      ctx.lineCap = style['lineCap'];
    }
    if (ctx.setLineDash && isArrayHasData(style['lineDasharray'])) {
      ctx.setLineDash(style['lineDasharray']);
    }
    var polygonPattern = style['polygonPatternFile'];
    var fill = style['polygonFill'] || DEFAULT_FILL_COLOR;
    if (testing) {
      ctx.fillStyle = '#000';
    } else if (polygonPattern && resources) {
      var fillImgUrl = extractImageUrl(polygonPattern);
      var fillTexture = resources.getImage([fillImgUrl, null, null]);
      if (!fillTexture) {
        fillTexture = resources.getImage([fillImgUrl + '-texture', null, strokeWidth]);
      }
      if (isSVG(fillImgUrl) && fillTexture instanceof Image && (Browser$1.edge || Browser$1.ie)) {
        var w = fillTexture.width || 20,
          h = fillTexture.height || 20;
        var canvas = Canvas.createCanvas(w, h);
        Canvas.image(canvas.getContext('2d'), fillTexture, 0, 0, w, h);
        fillTexture = canvas;
      }
      if (!fillTexture) {
        if (typeof console !== 'undefined') {
          console.warn('img not found for', fillImgUrl);
        }
      } else {
        ctx.fillStyle = ctx.createPattern(fillTexture, 'repeat');
        if (style['polygonPatternDx'] || style['polygonPatternDy']) {
          ctx.fillStyle['polygonPatternOffset'] = [style['polygonPatternDx'], style['polygonPatternDy']];
        }
      }
    } else if (isGradient(fill)) {
      if (style['polygonGradientExtent']) {
        ctx.fillStyle = Canvas._createGradient(ctx, fill, style['polygonGradientExtent']);
      } else {
        ctx.fillStyle = 'rgba(255,255,255,0)';
      }
    } else {
        if (Array.isArray(fill)) {
          fill = Canvas.normalizeColorToRGBA(fill);
        }
        ctx.fillStyle = fill;
      }
  },
  _createGradient: function _createGradient(ctx, g, extent) {
    var gradient = null,
      places = g['places'];
    var min = extent.getMin(),
      max = extent.getMax(),
      width = extent.getWidth(),
      height = extent.getHeight();
    var bearing = extent.bearing || 0;
    if (!g['type'] || g['type'] === 'linear') {
      if (!places) {
        places = [min.x, min.y, max.x, min.y];
      } else {
        if (places.length !== 4) {
          throw new Error('A linear gradient\'s places should have 4 numbers.');
        }
        places = [min.x + places[0] * width, min.y + places[1] * height, min.x + places[2] * width, min.y + places[3] * height];
      }
      if (bearing !== 0 && !g['places']) {
        var bearing1 = 180 - bearing;
        var bearing2 = bearing1 + 180;
        var {
          xmin: xmin,
          ymin: ymin,
          xmax: xmax,
          ymax: ymax
        } = extent;
        var cx = (xmin + xmax) / 2,
          cy = (ymin + ymax) / 2;
        var r = Math.sqrt(width * width + height * height) / 2;
        var rad1 = bearing1 / 180 * Math.PI;
        var rad2 = bearing2 / 180 * Math.PI;
        var tx1 = Math.cos(rad1) * r + cx;
        var ty1 = Math.sin(rad1) * r + cy;
        var tx2 = Math.cos(rad2) * r + cx;
        var ty2 = Math.sin(rad2) * r + cy;
        places = [tx1, ty1, tx2, ty2];
      }
      gradient = ctx.createLinearGradient.apply(ctx, places);
    } else if (g['type'] === 'radial') {
      if (!places) {
        var c = extent.getCenter()._round();
        places = [c.x, c.y, Math.abs(c.x - min.x), c.x, c.y, 0];
      } else {
        if (places.length !== 6) {
          throw new Error('A radial gradient\'s places should have 6 numbers.');
        }
        places = [min.x + places[0] * width, min.y + places[1] * height, width * places[2], min.x + places[3] * width, min.y + places[4] * height, width * places[5]];
      }
      gradient = ctx.createRadialGradient.apply(ctx, places);
    }
    g['colorStops'].forEach(function (stop) {
      gradient.addColorStop.apply(gradient, stop);
    });
    return gradient;
  },
  _setStrokePattern: function _setStrokePattern(ctx, strokePattern, strokeWidth, linePatternOffset, resources) {
    var imgUrl = extractImageUrl(strokePattern);
    var imageTexture;
    if (IS_NODE) {
      imageTexture = resources.getImage([imgUrl, null, strokeWidth]);
    } else {
      var key = imgUrl + '-texture-' + strokeWidth;
      imageTexture = resources.getImage(key);
      if (!imageTexture) {
        var imageRes = resources.getImage([imgUrl, null, null]);
        if (imageRes) {
          var w;
          if (!imageRes.width || !imageRes.height) {
            w = strokeWidth;
          } else {
            w = Math.round(imageRes.width * strokeWidth / imageRes.height);
          }
          var patternCanvas = Canvas.createCanvas(w, strokeWidth, ctx.canvas.constructor);
          Canvas.image(patternCanvas.getContext('2d'), imageRes, 0, 0, w, strokeWidth);
          resources.addResource([key, null, strokeWidth], patternCanvas);
          imageTexture = patternCanvas;
        }
      }
    }
    if (imageTexture) {
      ctx.strokeStyle = ctx.createPattern(imageTexture, 'repeat');
      ctx.strokeStyle['linePatternOffset'] = linePatternOffset;
    } else if (typeof console !== 'undefined') {
      console.warn('img not found for', imgUrl);
    }
  },
  clearRect: function clearRect(ctx, x1, y1, x2, y2) {
    ctx.canvas._drawn = false;
    ctx.clearRect(x1, y1, x2, y2);
  },
  fillCanvas: function fillCanvas(ctx, fillOpacity, x, y) {
    if (hitTesting) {
      fillOpacity = 1;
    }
    ctx.canvas._drawn = true;
    if (fillOpacity === 0) {
      return;
    }
    var isPattern = Canvas._isPattern(ctx.fillStyle);
    var offset = ctx.fillStyle && ctx.fillStyle['polygonPatternOffset'];
    var dx = offset ? offset[0] : 0,
      dy = offset ? offset[1] : 0;
    if (isNil(fillOpacity)) {
      fillOpacity = 1;
    }
    var alpha;
    if (fillOpacity < 1) {
      alpha = ctx.globalAlpha;
      ctx.globalAlpha *= fillOpacity;
    }
    if (isPattern) {
      x = x || 0;
      y = y || 0;
      ctx.translate(x + dx, y + dy);
    }
    ctx.fill();
    if (isPattern) {
      ctx.translate(-x - dx, -y - dy);
    }
    if (fillOpacity < 1) {
      ctx.globalAlpha = alpha;
    }
  },
  getRgba: function getRgba(color, op) {
    if (isNil(op)) {
      op = 1;
    }
    if (color[0] === '#' && op === 1) {
      return color;
    }
    if (color[0] !== '#') {
      if (Array.isArray(color)) {
        color = Canvas.normalizeColorToRGBA(color, op);
      }
      return color;
    }
    var r, g, b;
    if (color.length === 7) {
      r = parseInt(color.substring(1, 3), 16);
      g = parseInt(color.substring(3, 5), 16);
      b = parseInt(color.substring(5, 7), 16);
    } else {
      r = parseInt(color.substring(1, 2), 16) * 17;
      g = parseInt(color.substring(2, 3), 16) * 17;
      b = parseInt(color.substring(3, 4), 16) * 17;
    }
    return 'rgba(' + r + ',' + g + ',' + b + ',' + op + ')';
  },
  normalizeColorToRGBA: function normalizeColorToRGBA(fill, opacity = 1) {
    return "rgba(" + fill[0] * 255 + ", " + fill[1] * 255 + ", " + fill[2] * 255 + ", " + (fill.length === 4 ? fill[3] : 1) * opacity + ")";
  },
  image: function image(ctx, img, x, y, width, height) {
    ctx.canvas._drawn = true;
    try {
      if (isNumber(width) && isNumber(height)) {
        ctx.drawImage(img, x, y, width, height);
      } else {
        ctx.drawImage(img, x, y);
      }
    } catch (error) {
      if (console) {
        console.warn('error when drawing image on canvas:', error);
        console.warn(img);
      }
    }
  },
  text: function text(ctx, _text, pt, style, textDesc) {
    return Canvas._textOnMultiRow(ctx, textDesc['rows'], style, pt, textDesc['size'], textDesc['rawSize']);
  },
  _textOnMultiRow: function _textOnMultiRow(ctx, texts, style, point, splitTextSize, textSize) {
    var ptAlign = getAlignPoint(splitTextSize, style['textHorizontalAlignment'], style['textVerticalAlignment']),
      lineHeight = textSize['height'] + style['textLineSpacing'],
      basePoint = point.add(0, ptAlign.y),
      maxHeight = style['textMaxHeight'];
    var text,
      rowAlign,
      height = 0;
    resetBBOX(BBOX_TEMP);
    for (var i = 0, len = texts.length; i < len; i++) {
      text = texts[i]['text'];
      rowAlign = getAlignPoint(texts[i]['size'], style['textHorizontalAlignment'], style['textVerticalAlignment']);
      var _point = basePoint.add(rowAlign.x, i * lineHeight);
      Canvas._textOnLine(ctx, text, _point, style['textHaloRadius'], style['textHaloFill'], style['textHaloOpacity']);
      var _textSize = texts[i].size;
      var minx = _point.x,
        miny = _point.y,
        maxx = minx + _textSize.width,
        maxy = miny + _textSize.height;
      setBBOX(BBOX_TEMP, minx, miny, maxx, maxy);
      if (maxHeight > 0) {
        height += lineHeight;
        if (height + _textSize['height'] >= maxHeight) {
          break;
        }
      }
    }
    return BBOX_TEMP;
  },
  _textOnLine: function _textOnLine(ctx, text, pt, textHaloRadius, textHaloFill, textHaloAlpha) {
    if (hitTesting) {
      textHaloAlpha = 1;
    }
    var drawHalo = textHaloAlpha !== 0 && textHaloRadius !== 0;
    ctx.textBaseline = 'top';
    var gco, fill;
    var shadowBlur = ctx.shadowBlur,
      shadowOffsetX = ctx.shadowOffsetX,
      shadowOffsetY = ctx.shadowOffsetY;
    if (drawHalo) {
      var alpha = ctx.globalAlpha;
      ctx.globalAlpha *= textHaloAlpha;
      ctx.miterLimit = 2;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.lineWidth = textHaloRadius * 2;
      if (Array.isArray(textHaloFill)) {
        textHaloFill = Canvas.normalizeColorToRGBA(textHaloFill);
      }
      ctx.strokeStyle = textHaloFill;
      ctx.strokeText(text, pt.x, pt.y + textOffsetY);
      ctx.miterLimit = 10;
      ctx.globalAlpha = alpha;
      gco = ctx.globalCompositeOperation;
      ctx.globalCompositeOperation = 'destination-out';
      fill = ctx.fillStyle;
      ctx.fillStyle = '#000';
    }
    if (shadowBlur && drawHalo) {
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    Canvas.fillText(ctx, text, pt);
    if (gco) {
      ctx.globalCompositeOperation = gco;
      Canvas.fillText(ctx, text, pt, fill);
      if (shadowBlur) {
        ctx.shadowBlur = shadowBlur;
        ctx.shadowOffsetX = shadowOffsetX;
        ctx.shadowOffsetY = shadowOffsetY;
      }
    }
  },
  fillText: function fillText(ctx, text, pt, rgba) {
    ctx.canvas._drawn = true;
    if (rgba) {
      ctx.fillStyle = rgba;
    }
    ctx.fillText(text, pt.x, pt.y + textOffsetY);
  },
  textAlongLine: function textAlongLine(ctx, text, paths, style, textDesc, globalCollisonIndex) {
    if (!text) {
      return;
    }
    var fontSize = style.textSize || 14;
    var textSpacing = style.textSpacing || 0;
    var textLen = measureTextLength(text, fontSize);
    if (textSpacing < textLen) {
      return;
    }
    if (!Array.isArray(paths[0])) {
      paths = [paths];
    }
    var textBaseline = ctx.textBaseline;
    var textAlign = ctx.textAlign;
    var strokeStyle = ctx.strokeStyle;
    var globalAlpha = ctx.globalAlpha;
    var lineWidth = ctx.lineWidth;
    var textAlongDebug = style.textAlongDebug;
    var textHaloFill = style.textHaloFill || DEFAULT_STROKE_COLOR;
    var textHaloRadius = style.textHaloRadius || 0;
    var textHaloOpacity = style.textHaloOpacity;
    if (!isNumber(textHaloOpacity)) {
      textHaloOpacity = 1;
    }
    var drawHalo = textHaloOpacity !== 0 && textHaloRadius !== 0;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    if (drawHalo) {
      if (Array.isArray(textHaloFill)) {
        textHaloFill = Canvas.normalizeColorToRGBA(textHaloFill);
      }
      ctx.strokeStyle = textHaloFill;
      ctx.lineWidth = textHaloRadius * 2;
    }
    textPathsCollisionIndex.clear();
    var charsBBOX = getDefaultBBOX();
    var charArray = text.split('');
    var isDefaultChars = textIsDefaultChars(charArray);
    paths.forEach(function (path) {
      var pathLen = pathDistance(path);
      if (pathLen < textLen) {
        return;
      }
      var lines = lineSeg(path, {
        segDistance: textSpacing
      });
      if (!lines || !lines.length) {
        return;
      }
      for (var m = 0, len1 = lines.length; m < len1; m++) {
        var chunk = lines[m];
        var chunkDistance = chunk.distance;
        if (chunkDistance < textLen) {
          continue;
        }
        var points = chunk.points;
        if (textAlongDebug) {
          var fillStyle = ctx.fillStyle;
          ctx.fillStyle = 'red';
          var {
            x: x,
            y: y
          } = points[0];
          ctx.beginPath();
          ctx.fillRect(x - 2, y - 2, 4, 4);
          ctx.fillStyle = fillStyle;
        }
        var chars = charArray;
        var items = getTextPath(points, chars, fontSize, globalCollisonIndex);
        if (!items.length) {
          continue;
        }
        var direction = textPathDirection(items);
        if (direction === 'left') {
          chars = reverseChars(chars);
          items = getTextPath(points, chars, fontSize, globalCollisonIndex);
        }
        if (direction === 'up' && !isDefaultChars) {
          chars = reverseChars(chars);
          items = getTextPath(points, chars, fontSize, globalCollisonIndex);
        }
        var hasCollision = false;
        for (var i = 0, len = items.length; i < len; i++) {
          var {
            bbox: bbox
          } = items[i];
          if (textPathsCollisionIndex.collides(bbox)) {
            hasCollision = true;
            break;
          }
          if (globalCollisonIndex && globalCollisonIndex.collides(bbox)) {
            hasCollision = true;
            break;
          }
        }
        if (hasCollision) {
          continue;
        }
        for (var _i3 = 0, _len4 = items.length; _i3 < _len4; _i3++) {
          var p1 = void 0,
            p2 = void 0;
          if (_i3 === 0) {
            p1 = items[_i3].point;
            p2 = items[1].point;
          } else if (_i3 === _len4 - 1) {
            p1 = items[_len4 - 2].point;
            p2 = items[_len4 - 1].point;
          } else {
            p1 = items[_i3 - 1].point;
            p2 = items[_i3].point;
          }
          var _char8 = chars[_i3];
          var {
            point: point,
            bbox: _bbox
          } = items[_i3];
          textPathsCollisionIndex.insertBox(_bbox);
          globalCollisonIndex && globalCollisonIndex.insertBox(_bbox);
          var {
            x: _x,
            y: _y
          } = point;
          var rad = getCharRotation(p1, p2, _char8, direction, isDefaultChars);
          ctx.save();
          ctx.translate(_x, _y);
          ctx.rotate(rad);
          var texture = getCharTexture(ctx, style, _char8);
          var {
            width: width,
            height: height
          } = texture;
          ctx.drawImage(texture, -width / 4, -height / 4, width / 2, height / 2);
          ctx.restore();
          setBBOX(charsBBOX, _bbox);
          if (textAlongDebug) {
            var _strokeStyle = ctx.strokeStyle;
            var _lineWidth = ctx.lineWidth;
            ctx.strokeStyle = 'red';
            ctx.lineWidth = 0.5;
            var [minx, miny, maxx, maxy] = _bbox;
            ctx.beginPath();
            ctx.rect(minx, miny, maxx - minx, maxy - miny);
            ctx.stroke();
            ctx.lineWidth = _lineWidth;
            ctx.strokeStyle = _strokeStyle;
          }
        }
      }
    });
    ctx.textBaseline = textBaseline;
    ctx.textAlign = textAlign;
    ctx.strokeStyle = strokeStyle;
    ctx.globalAlpha = globalAlpha;
    ctx.lineWidth = lineWidth;
    if (!validateBBOX(charsBBOX)) {
      return;
    }
    return charsBBOX;
  },
  _stroke: function _stroke(ctx, strokeOpacity, x, y) {
    if (hitTesting) {
      strokeOpacity = 1;
    }
    ctx.canvas._drawn = true;
    if (strokeOpacity === 0) {
      return;
    }
    var drawLineBorder = function drawLineBorder() {
      if (ctx.lineStrokeColor && ctx.lineStrokeWidth && ctx.lineStrokeWidth > 0) {
        var lineStrokeColor = ctx.lineStrokeColor;
        var lineStrokeWidth = ctx.lineStrokeWidth;
        var _alpha = ctx.globalAlpha;
        var strokeStyle = ctx.strokeStyle;
        var lineWidth = ctx.lineWidth;
        if (isNumber(strokeOpacity) && strokeOpacity < 1) {
          ctx.globalAlpha = 1;
          ctx.globalAlpha *= strokeOpacity;
        }
        ctx.lineWidth = lineWidth + lineStrokeWidth * 2;
        ctx.strokeStyle = lineStrokeColor;
        ctx.stroke();
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = strokeStyle;
        ctx.globalAlpha = _alpha;
      }
    };
    drawLineBorder();
    var offset = ctx.strokeStyle && ctx.strokeStyle['linePatternOffset'];
    var dx = offset ? offset[0] : 0,
      dy = offset ? offset[1] : 0;
    var isPattern = Canvas._isPattern(ctx.strokeStyle) && (!isNil(x) && !isNil(y) || !isNil(dx) && !isNil(dy));
    if (isNil(strokeOpacity)) {
      strokeOpacity = 1;
    }
    var alpha;
    if (strokeOpacity < 1) {
      alpha = ctx.globalAlpha;
      ctx.globalAlpha *= strokeOpacity;
    }
    if (isPattern) {
      x = x || 0;
      y = y || 0;
      ctx.translate(x + dx, y + dy);
    }
    ctx.stroke();
    if (isPattern) {
      ctx.translate(-x - dx, -y - dy);
    }
    if (strokeOpacity < 1) {
      ctx.globalAlpha = alpha;
    }
  },
  _gradientPath: function _gradientPath(ctx, points, lineDashArray, lineOpacity, isRing = false) {
    if (!isNumber(lineOpacity)) {
      lineOpacity = 1;
    }
    if (hitTesting) {
      lineOpacity = 1;
    }
    if (lineOpacity === 0 || ctx.lineWidth === 0) {
      return;
    }
    var alpha = ctx.globalAlpha;
    ctx.globalAlpha *= lineOpacity;
    var colorIn = ctx.lineColorIn;
    var minStep = getColorInMinStep(colorIn);
    var distance = pathDistance(points);
    var step = 0;
    var preColor, color;
    var preX, preY, currentX, currentY, nextPoint;
    var [r, g, b, a] = colorIn.getColor(0);
    preColor = rgbaToCSSRGBA(r, g, b, a);
    var firstPoint = points[0];
    preX = firstPoint.x;
    preY = firstPoint.y;
    if (isRing) {
      var len = points.length;
      var lastPoint = points[len - 1];
      if (!firstPoint.equals(lastPoint)) {
        points.push(firstPoint);
      }
    }
    var dashArrayEnable = lineDashArray && Array.isArray(lineDashArray) && lineDashArray.length > 1;
    var drawSegment = function drawSegment() {
      if (!dashArrayEnable && nextPoint) {
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(preX, preY);
        ctx.lineTo(currentX, currentY);
        ctx.lineTo(nextPoint.x, nextPoint.y);
        ctx.stroke();
      }
      var grad = ctx.createLinearGradient(preX, preY, currentX, currentY);
      grad.addColorStop(0, preColor);
      grad.addColorStop(1, color);
      ctx.strokeStyle = grad;
      ctx.beginPath();
      ctx.moveTo(preX, preY);
      ctx.lineTo(currentX, currentY);
      ctx.stroke();
      preColor = color;
      preX = currentX;
      preY = currentY;
    };
    for (var i = 1, _len5 = points.length; i < _len5; i++) {
      var prePoint = points[i - 1],
        currentPoint = points[i];
      nextPoint = points[i + 1];
      var x = currentPoint.x,
        y = currentPoint.y;
      var dis = currentPoint.distanceTo(prePoint);
      var percent = dis / distance;
      if (percent <= minStep) {
        var [_r, _g, _b, _a] = colorIn.getColor(step + percent);
        color = rgbaToCSSRGBA(_r, _g, _b, _a);
        currentX = x;
        currentY = y;
        drawSegment();
      } else {
        var segments = Math.ceil(percent / minStep);
        nextPoint = currentPoint;
        for (var n = 1; n <= segments; n++) {
          var tempStep = Math.min(n * minStep, percent);
          var [_r2, _g2, _b2, _a2] = colorIn.getColor(step + tempStep);
          color = rgbaToCSSRGBA(_r2, _g2, _b2, _a2);
          if (color === preColor) {
            continue;
          }
          var point = getSegmentPercentPoint(prePoint, currentPoint, tempStep / percent);
          currentX = point.x;
          currentY = point.y;
          drawSegment();
        }
      }
      step += percent;
    }
    ctx.globalAlpha = alpha;
  },
  _path: function _path(ctx, points, lineDashArray, lineOpacity, ignoreStrokePattern) {
    if (!isArrayHasData(points)) {
      return;
    }
    function fillWithPattern(p1, p2) {
      var degree = computeDegree(p1.x, p1.y, p2.x, p2.y);
      ctx.save();
      var cosd = Math.cos(degree);
      if (Math.abs(cosd) < 1E-7) {
        ctx.translate(p1.x - ctx.lineWidth / 2, p1.y);
      } else {
        ctx.translate(p1.x, p1.y - ctx.lineWidth / 2 / cosd);
      }
      ctx.rotate(degree);
      Canvas._stroke(ctx, lineOpacity);
      ctx.restore();
    }
    var isDashed = isArrayHasData(lineDashArray);
    var isPatternLine = ignoreStrokePattern === true ? false : Canvas._isPattern(ctx.strokeStyle);
    var point, prePoint, nextPoint;
    for (var i = 0, len = points.length; i < len; i++) {
      point = points[i];
      if (!isDashed || ctx.setLineDash) {
        ctx.lineTo(point.x, point.y);
        if (isPatternLine && i > 0) {
          prePoint = points[i - 1];
          fillWithPattern(prePoint, point);
          ctx.beginPath();
          ctx.moveTo(point.x, point.y);
        }
      } else if (isDashed) {
        if (i === len - 1) {
          break;
        }
        nextPoint = points[i + 1];
        drawDashLine(ctx, point, nextPoint, lineDashArray);
      }
    }
  },
  path: function path(ctx, points, lineOpacity, fillOpacity, lineDashArray) {
    if (!isArrayHasData(points)) {
      return;
    }
    if (ctx.lineColorIn) {
      Canvas._gradientPath(ctx, points, lineDashArray, lineOpacity);
    } else {
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      Canvas._path(ctx, points, lineDashArray, lineOpacity);
    }
    Canvas._stroke(ctx, lineOpacity);
  },
  roundRect: function roundRect(ctx, points, lineOpacity, fillOpacity) {
    if (!Browser$1.roundRect) {
      return;
    }
    var minx = Infinity,
      miny = Infinity,
      maxx = -Infinity,
      maxy = -Infinity;
    for (var i = 0, len = points.length; i < len; i++) {
      var p = points[i];
      var {
        x: x,
        y: y
      } = p;
      minx = Math.min(minx, x);
      miny = Math.min(miny, y);
      maxx = Math.max(maxx, x);
      maxy = Math.max(maxy, y);
    }
    var width = Math.abs(maxx - minx),
      height = Math.abs(maxy - miny);
    if (width * height <= 0) {
      return;
    }
    var min = Math.min(width, height);
    ctx.roundRect(minx, miny, width, height, min / 4);
    var globalAlpha = ctx.globalAlpha;
    if (isNumber(fillOpacity) && fillOpacity < 1) {
      ctx.globalAlpha = 1;
      ctx.globalAlpha *= fillOpacity;
    }
    ctx.fill();
    ctx.globalAlpha = globalAlpha;
    if (isNumber(lineOpacity) && lineOpacity < 1) {
      ctx.globalAlpha = 1;
      ctx.globalAlpha *= lineOpacity;
    }
    ctx.stroke();
    ctx.globalAlpha = globalAlpha;
  },
  _multiClip: function _multiClip(ctx, points) {
    if (!points || points.length === 0) return;
    points.forEach(function (pts) {
      for (var i = 0, len = pts.length; i < len; i++) {
        var point = pts[i];
        var x = point.x,
          y = point.y;
        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
        if (i === len - 1) {
          x = pts[0].x;
          y = pts[0].y;
          ctx.lineTo(x, y);
        }
      }
    });
  },
  polygon: function polygon(ctx, points, lineOpacity, fillOpacity, lineDashArray, smoothness) {
    if (ctx.isMultiClip) {
      Canvas._multiClip(ctx, points);
      return;
    }
    if (ctx.isClip) {
      Canvas._multiClip(ctx, Array.isArray(points[0]) ? points : [points]);
      return;
    }
    if (!isArrayHasData(points)) {
      return;
    }
    var isPatternLine = Canvas._isPattern(ctx.strokeStyle),
      fillFirst = isArrayHasData(lineDashArray) && !ctx.setLineDash || isPatternLine && !smoothness;
    if (!isArrayHasData(points[0])) {
      points = [points];
    }
    var savedCtx = ctx;
    var dpr = ctx.dpr || 1;
    var needScale = dpr !== 1;
    if (points.length > 1 && !IS_NODE) {
      if (!TEMP_CANVAS) {
        TEMP_CANVAS = Canvas.createCanvas(1, 1);
      }
      ctx.canvas._drawn = false;
      TEMP_CANVAS.width = ctx.canvas.width;
      TEMP_CANVAS.height = ctx.canvas.height;
      ctx = TEMP_CANVAS.getContext('2d');
      setLineDash(ctx, []);
      setLineDash(ctx, lineDashArray);
      copyProperties(ctx, savedCtx);
      if (needScale) {
        ctx.scale(dpr, dpr);
      }
    }
    var lineColorIn = ctx.lineColorIn;
    var lineWidth = ctx.lineWidth;
    var op, i, len;
    if (fillFirst) {
      ctx.save();
      for (i = 0, len = points.length; i < len; i++) {
        if (!isArrayHasData(points[i])) {
          continue;
        }
        if (lineColorIn) {
          ctx.lineWidth = 0.1;
        }
        Canvas._ring(ctx, points[i], null, 0, true);
        op = fillOpacity;
        if (i > 0) {
          ctx.globalCompositeOperation = 'destination-out';
          op = 1;
        }
        Canvas.fillCanvas(ctx, op, points[i][0].x, points[i][0].y);
        if (i > 0) {
          ctx.globalCompositeOperation = 'source-over';
        } else if (len > 1) {
          ctx.fillStyle = '#fff';
        }
        Canvas._stroke(ctx, 0);
        ctx.lineWidth = lineWidth;
        if (lineColorIn) {
          Canvas._gradientPath(ctx, points, null, 0, true);
        }
      }
      ctx.restore();
    }
    var fillStyle = ctx.fillStyle;
    for (i = 0, len = points.length; i < len; i++) {
      if (!isArrayHasData(points[i])) {
        continue;
      }
      if (lineColorIn) {
        ctx.lineWidth = 0.1;
      }
      if (smoothness) {
        Canvas.paintSmoothLine(ctx, points[i], lineOpacity, smoothness, true);
        ctx.closePath();
      } else {
        Canvas._ring(ctx, points[i], lineDashArray, lineOpacity);
      }
      if (!fillFirst) {
        op = fillOpacity;
        if (i > 0) {
          ctx.globalCompositeOperation = 'destination-out';
          op = 1;
        }
        Canvas.fillCanvas(ctx, op, points[i][0].x, points[i][0].y);
        if (i > 0) {
          ctx.globalCompositeOperation = 'source-over';
        } else if (len > 1) {
          ctx.fillStyle = '#fff';
        }
      }
      Canvas._stroke(ctx, lineOpacity);
      ctx.lineWidth = lineWidth;
      if (lineColorIn) {
        Canvas._gradientPath(ctx, points[i], lineDashArray, lineOpacity, true);
      }
    }
    if (ctx.fillStyle !== fillStyle) {
      ctx.fillStyle = fillStyle;
    }
    if (points.length > 1 && !IS_NODE) {
      if (needScale) {
        var rScale = 1 / dpr;
        savedCtx.scale(rScale, rScale);
      }
      savedCtx.drawImage(TEMP_CANVAS, 0, 0);
      if (needScale) {
        savedCtx.scale(dpr, dpr);
      }
      savedCtx.canvas._drawn = ctx.canvas._drawn;
      copyProperties(savedCtx, ctx);
    }
  },
  _ring: function _ring(ctx, ring, lineDashArray, lineOpacity, ignorePattern) {
    var isPattern = Canvas._isPattern(ctx.strokeStyle);
    if (!ignorePattern && isPattern && !ring[0].equals(ring[ring.length - 1])) {
      ring = ring.concat([ring[0]]);
    }
    ctx.beginPath();
    ctx.moveTo(ring[0].x, ring[0].y);
    Canvas._path(ctx, ring, lineDashArray, lineOpacity, ignorePattern);
    if (!isPattern) {
      ctx.closePath();
    }
  },
  paintSmoothLine_bak: function paintSmoothLine_bak(ctx, points, lineOpacity, smoothValue, close, tailIdx, tailRatio) {
    if (!points) {
      return;
    }
    if (points.length <= 2 || !smoothValue) {
      Canvas.path(ctx, points, lineOpacity);
      return;
    }
    var count = points.length;
    var l = close ? count : count - 1;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    if (tailRatio !== undefined) l -= Math.max(l - tailIdx - 1, 0);
    var preCtrlPoints;
    for (var i = 0; i < l; i++) {
      var x1 = points[i].x,
        y1 = points[i].y;
      var x0 = void 0,
        y0 = void 0,
        x2 = void 0,
        y2 = void 0,
        x3 = void 0,
        y3 = void 0;
      if (i - 1 < 0) {
        if (!close) {
          x0 = points[i + 1].x;
          y0 = points[i + 1].y;
        } else {
          x0 = points[l - 1].x;
          y0 = points[l - 1].y;
        }
      } else {
        x0 = points[i - 1].x;
        y0 = points[i - 1].y;
      }
      if (i + 1 < count) {
        x2 = points[i + 1].x;
        y2 = points[i + 1].y;
      } else {
        x2 = points[i + 1 - count].x;
        y2 = points[i + 1 - count].y;
      }
      if (i + 2 < count) {
        x3 = points[i + 2].x;
        y3 = points[i + 2].y;
      } else if (!close) {
        x3 = points[i].x;
        y3 = points[i].y;
      } else {
        x3 = points[i + 2 - count].x;
        y3 = points[i + 2 - count].y;
      }
      var ctrlPoints = getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, i === l - 1 ? tailRatio : 1);
      if (i === l - 1 && tailRatio >= 0 && tailRatio < 1) {
        ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], ctrlPoints[4], ctrlPoints[5]);
        points.splice(l - 1, count - (l - 1) - 1);
        var lastPoint = new Point(ctrlPoints[4], ctrlPoints[5]);
        lastPoint.prevCtrlPoint = new Point(ctrlPoints[2], ctrlPoints[3]);
        points.push(lastPoint);
        count = points.length;
      } else {
        ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], x2, y2);
      }
      points[i].nextCtrlPoint = ctrlPoints.slice(0, 2);
      points[i].prevCtrlPoint = preCtrlPoints ? preCtrlPoints.slice(2) : null;
      preCtrlPoints = ctrlPoints;
    }
    if (!close && points[1].prevCtrlPoint) {
      points[0].nextCtrlPoint = points[1].prevCtrlPoint;
      delete points[0].prevCtrlPoint;
    }
    if (!points[count - 1].prevCtrlPoint) {
      points[count - 1].prevCtrlPoint = points[count - 2].nextCtrlPoint;
    }
    Canvas._stroke(ctx, lineOpacity);
  },
  paintSmoothLine: function paintSmoothLine(ctx, points, lineOpacity, smoothValue, close, tailIdx, tailRatio) {
    if (!points) {
      return;
    }
    if (points.length <= 2 || !smoothValue) {
      Canvas.path(ctx, points, lineOpacity);
      return;
    }
    var count = points.length;
    var l = close ? count : count - 1;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    if (tailRatio !== undefined) l -= Math.max(l - tailIdx - 1, 0);
    var preX, preY;
    for (var i = 0; i < l; i++) {
      var x1 = points[i].x,
        y1 = points[i].y;
      var x0 = void 0,
        y0 = void 0,
        x2 = void 0,
        y2 = void 0,
        x3 = void 0,
        y3 = void 0;
      if (i - 1 < 0) {
        if (!close) {
          x0 = points[i + 1].x;
          y0 = points[i + 1].y;
        } else {
          x0 = points[l - 1].x;
          y0 = points[l - 1].y;
        }
      } else {
        x0 = points[i - 1].x;
        y0 = points[i - 1].y;
      }
      if (i + 1 < count) {
        x2 = points[i + 1].x;
        y2 = points[i + 1].y;
      } else {
        x2 = points[i + 1 - count].x;
        y2 = points[i + 1 - count].y;
      }
      if (i + 2 < count) {
        x3 = points[i + 2].x;
        y3 = points[i + 2].y;
      } else if (!close) {
        x3 = points[i].x;
        y3 = points[i].y;
      } else {
        x3 = points[i + 2 - count].x;
        y3 = points[i + 2 - count].y;
      }
      var point = points[i];
      var ctrlPoints = getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, i === l - 1 ? tailRatio : 1);
      if (i === l - 1 && tailRatio >= 0 && tailRatio < 1) {
        ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], ctrlPoints[4], ctrlPoints[5]);
        points.splice(l - 1, count - (l - 1) - 1);
        var lastPoint = new Point(ctrlPoints[4], ctrlPoints[5]);
        points.push(lastPoint);
        count = points.length;
      } else {
        ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], x2, y2);
      }
      if (i === 0) {
        point.arrowNextPoint = point.arrowNextPoint || new Point(0, 0);
        preX = ctrlPoints[2];
        preY = ctrlPoints[3];
        point.arrowNextPoint.x = preX;
        point.arrowNextPoint.y = preY;
      } else {
        point.arrowPrePoint = point.arrowPrePoint || new Point(0, 0);
        point.arrowPrePoint.x = preX;
        point.arrowPrePoint.y = preY;
        preX = ctrlPoints[2];
        preY = ctrlPoints[3];
        if (i === l - 1 && points[i + 1]) {
          points[i + 1].arrowPrePoint = points[i + 1].arrowPrePoint || new Point(0, 0);
          points[i + 1].arrowPrePoint.x = ctrlPoints[0];
          points[i + 1].arrowPrePoint.y = ctrlPoints[1];
        }
      }
    }
    Canvas._stroke(ctx, lineOpacity);
  },
  _arcBetween: function _arcBetween(ctx, p1, p2, degree) {
    var a = Math.abs(degree),
      dist = p1.distanceTo(p2),
      r = Math.abs(dist / 2 / Math.sin(a / 2));
    var p1p2 = Math.asin((p2.y - p1.y) / dist);
    if (p1.x > p2.x) {
      p1p2 = Math.PI - p1p2;
    }
    var cp2 = 90 * RADIAN$1 - a / 2,
      da = p1p2 - cp2;
    var dx = Math.cos(da) * r,
      dy = Math.sin(da) * r;
    var cx = p1.x + dx,
      cy = p1.y + dy;
    var startAngle = Math.asin((p2.y - cy) / r);
    if (cx > p2.x) {
      startAngle = Math.PI - startAngle;
    }
    var endAngle = startAngle + a;
    if (degree < 0) {
      startAngle += Math.PI;
      endAngle += Math.PI;
      var middleX = (p1.x + p2.x) / 2,
        middleY = (p1.y + p2.y) / 2;
      var _dx = cx - middleX,
        _dy = cy - middleY;
      cx = middleX - _dx;
      cy = middleY - _dy;
    }
    ctx.beginPath();
    ctx.arc(cx, cy, r, startAngle, endAngle);
    var aAngle = (endAngle - startAngle) / 100;
    var x1 = Math.cos(startAngle + aAngle) * r + cx;
    var y1 = Math.sin(startAngle + aAngle) * r + cy;
    var x2 = Math.cos(endAngle - aAngle) * r + cx;
    var y2 = Math.sin(endAngle - aAngle) * r + cy;
    p1.arrowNextPoint = p1.arrowNextPoint || new Point(0, 0);
    p2.arrowPrePoint = p2.arrowPrePoint || new Point(0, 0);
    if (degree < 0) {
      p1.arrowNextPoint.x = x1;
      p1.arrowNextPoint.y = y1;
      p2.arrowPrePoint.x = x2;
      p2.arrowPrePoint.y = y2;
    } else {
      p1.arrowNextPoint.x = x2;
      p1.arrowNextPoint.y = y2;
      p2.arrowPrePoint.x = x1;
      p2.arrowPrePoint.y = y1;
    }
    return [cx, cy];
  },
  _lineTo: function _lineTo(ctx, p) {
    ctx.lineTo(p.x, p.y);
  },
  bezierCurveAndFill: function bezierCurveAndFill(ctx, points, lineOpacity, fillOpacity) {
    ctx.beginPath();
    var start = points[0];
    ctx.moveTo(start.x, start.y);
    var args = [ctx];
    args.push.apply(args, points.splice(1));
    Canvas._bezierCurveTo.apply(Canvas, args);
    Canvas.fillCanvas(ctx, fillOpacity);
    Canvas._stroke(ctx, lineOpacity);
  },
  _bezierCurveTo: function _bezierCurveTo(ctx, p1, p2, p3) {
    ctx.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
  },
  ellipse: function ellipse(ctx, pt, width, heightTop, heightBottom, lineOpacity, fillOpacity) {
    function bezierEllipse(x, y, a, b, b1) {
      var k = 0.5522848,
        ox = a * k,
        oy = b * k,
        oy1 = b1 * k;
      ctx.moveTo(x - a, y);
      ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
      ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
      ctx.bezierCurveTo(x + a, y + oy1, x + ox, y + b1, x, y + b1);
      ctx.bezierCurveTo(x - ox, y + b1, x - a, y + oy1, x - a, y);
      ctx.closePath();
    }
    ctx.beginPath();
    if (width === heightTop && width === heightBottom) {
      ctx.arc(pt.x, pt.y, width, 0, 2 * Math.PI);
    } else if (ctx.ellipse) {
      if (heightTop !== heightBottom) {
        ctx.ellipse(pt.x, pt.y, width, heightTop, 0, RADIAN$1 * 180, RADIAN$1 * 360, false);
        ctx.ellipse(pt.x, pt.y, width, heightBottom, 0, 0, RADIAN$1 * 180, false);
      } else {
        ctx.ellipse(pt.x, pt.y, width, heightTop, 0, 0, RADIAN$1 * 360, false);
      }
    } else {
      bezierEllipse(pt.x, pt.y, width, heightTop, heightBottom);
    }
    Canvas.fillCanvas(ctx, fillOpacity, pt.x - width, pt.y - heightTop);
    Canvas._stroke(ctx, lineOpacity, pt.x - width, pt.y - heightTop);
  },
  rectangle: function rectangle(ctx, pt, size, lineOpacity, fillOpacity) {
    var {
      x: x,
      y: y
    } = pt;
    ctx.beginPath();
    ctx.rect(x, y, size['width'], size['height']);
    Canvas.fillCanvas(ctx, fillOpacity, x, y);
    Canvas._stroke(ctx, lineOpacity, x, y);
  },
  sector: function sector(ctx, pt, size, angles, lineOpacity, fillOpacity) {
    var rad = RADIAN$1;
    var startAngle = angles[0],
      endAngle = angles[1];
    function sector(ctx, x, y, radius, startAngle, endAngle) {
      var sDeg = rad * -endAngle;
      var eDeg = rad * -startAngle;
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.arc(x, y, radius, sDeg, eDeg);
      ctx.lineTo(x, y);
      Canvas.fillCanvas(ctx, fillOpacity, x - radius, y - radius);
      Canvas._stroke(ctx, lineOpacity, x - radius, y - radius);
    }
    sector(ctx, pt.x, pt.y, size, startAngle, endAngle);
  },
  _isPattern: function _isPattern(style) {
    return !isString(style) && !('addColorStop' in style);
  },
  drawCross: function drawCross(ctx, x, y, lineWidth, color) {
    ctx.canvas._drawn = true;
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.beginPath();
    ctx.moveTo(x - 5, y);
    ctx.lineTo(x + 5, y);
    ctx.moveTo(x, y - 5);
    ctx.lineTo(x, y + 5);
    ctx.stroke();
  },
  copy: function copy(canvas, c) {
    var target = c || createEl('canvas');
    target.width = canvas.width;
    target.height = canvas.height;
    target.getContext('2d').drawImage(canvas, 0, 0);
    return target;
  },
  pixelRect: function pixelRect(ctx, point, lineOpacity, fillOpacity) {
    var lineWidth = ctx.lineWidth;
    var alpha = ctx.globalAlpha;
    var isStroke = false;
    if (lineWidth > 0 && lineOpacity > 0) {
      isStroke = true;
      if (lineOpacity < 1) {
        ctx.globalAlpha *= lineOpacity;
      }
    } else if (fillOpacity > 0) {
      if (fillOpacity < 1) {
        ctx.globalAlpha *= fillOpacity;
      }
    } else {
      return;
    }
    ctx.canvas._drawn = true;
    if (isStroke) {
      ctx.strokeRect(point[0], point[1], 1, 1);
    } else {
      ctx.fillRect(point[0], point[1], 1, 1);
    }
    if (ctx.globalAlpha !== alpha) {
      ctx.globalAlpha = alpha;
    }
  }
};
function drawDashLine(ctx, startPoint, endPoint, dashArray) {
  var fromX = startPoint.x,
    fromY = startPoint.y,
    toX = endPoint.x,
    toY = endPoint.y;
  var pattern = dashArray;
  var lt = function lt(a, b) {
    return a <= b;
  };
  var gt = function gt(a, b) {
    return a >= b;
  };
  var capmin = function capmin(a, b) {
    return Math.min(a, b);
  };
  var capmax = function capmax(a, b) {
    return Math.max(a, b);
  };
  var checkX = {
    thereYet: gt,
    cap: capmin
  };
  var checkY = {
    thereYet: gt,
    cap: capmin
  };
  if (fromY - toY > 0) {
    checkY.thereYet = lt;
    checkY.cap = capmax;
  }
  if (fromX - toX > 0) {
    checkX.thereYet = lt;
    checkX.cap = capmax;
  }
  ctx.moveTo(fromX, fromY);
  var offsetX = fromX;
  var offsetY = fromY;
  var idx = 0,
    dash = true;
  var ang, len;
  while (!(checkX.thereYet(offsetX, toX) && checkY.thereYet(offsetY, toY))) {
    ang = Math.atan2(toY - fromY, toX - fromX);
    len = pattern[idx];
    offsetX = checkX.cap(toX, offsetX + Math.cos(ang) * len);
    offsetY = checkY.cap(toY, offsetY + Math.sin(ang) * len);
    if (dash) {
      ctx.lineTo(offsetX, offsetY);
    } else {
      ctx.moveTo(offsetX, offsetY);
    }
    idx = (idx + 1) % pattern.length;
    dash = !dash;
  }
}
var prefix = 'data:image/';
function extractImageUrl(url) {
  if (url.substring(0, prefix.length) === prefix) {
    return url;
  }
  return extractCssUrl(url);
}
function copyProperties(ctx, savedCtx) {
  ctx.filter = savedCtx.filter;
  ctx.fillStyle = savedCtx.fillStyle;
  ctx.globalAlpha = savedCtx.globalAlpha;
  ctx.lineCap = savedCtx.lineCap;
  ctx.lineDashOffset = savedCtx.lineDashOffset;
  ctx.lineJoin = savedCtx.lineJoin;
  ctx.lineWidth = savedCtx.lineWidth;
  ctx.shadowBlur = savedCtx.shadowBlur;
  ctx.shadowColor = savedCtx.shadowColor;
  ctx.shadowOffsetX = savedCtx.shadowOffsetX;
  ctx.shadowOffsetY = savedCtx.shadowOffsetY;
  ctx.strokeStyle = savedCtx.strokeStyle;
  ctx.lineColorIn = savedCtx.lineColorIn;
  ctx.lineStrokeColor = savedCtx.lineStrokeColor;
  ctx.lineStrokeWidth = savedCtx.lineStrokeWidth;
}
function setLineDash(ctx, lineDashArray) {
  if (!lineDashArray || !ctx.setLineDash || !Array.isArray(lineDashArray)) {
    return;
  }
  ctx.setLineDash(lineDashArray);
}

function generateWrapKey(eventType) {
  return 'Z__' + eventType;
}
function Eventable (Base) {
  return function (_Base) {
    function EventableMixin() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(EventableMixin, _Base);
    var _proto = EventableMixin.prototype;
    _proto.on = function on(eventsOn, handler, context) {
      if (!eventsOn) {
        return this;
      }
      if (!isString(eventsOn)) {
        return this._switch('on', eventsOn, handler);
      }
      if (!handler) {
        return this;
      }
      if (!this._eventMap) {
        this._eventMap = {};
      }
      eventsOn = eventsOn;
      var eventTypes = eventsOn.toLowerCase().split(' ');
      var evtType;
      if (!context) {
        context = this;
      }
      var isAdd = isNumber(handler._id);
      handler._id = UID();
      var handlerChain;
      for (var ii = 0, ll = eventTypes.length; ii < ll; ii++) {
        evtType = eventTypes[ii];
        var wrapKey = generateWrapKey(evtType);
        if (handler[wrapKey]) {
          handler[wrapKey]._id = handler._id;
        }
        handlerChain = this._eventMap[evtType];
        if (!handlerChain) {
          handlerChain = [];
          this._eventMap[evtType] = handlerChain;
        }
        if (!isAdd) {
          handlerChain.push({
            handler: handler,
            context: context
          });
          continue;
        }
        var l = handlerChain.length;
        if (l > 0) {
          for (var i = 0; i < l; i++) {
            if (handler === handlerChain[i].handler && handlerChain[i].context === context) {
              if (!GlobalConfig.isTest) {
                console.warn(this, "find '" + eventsOn + "' handler:", handler, ' The old listener function will be removed');
              }
              return this;
            }
          }
        }
        handlerChain.push({
          handler: handler,
          context: context
        });
      }
      return this;
    };
    _proto.addEventListener = function addEventListener(...args) {
      return this.on.call(this, ...args);
    };
    _proto.once = function once(eventTypes, handler, context) {
      if (!isString(eventTypes)) {
        eventTypes = eventTypes;
        var _once = {};
        for (var p in eventTypes) {
          if (eventTypes.hasOwnProperty(p)) {
            _once[p] = this._wrapOnceHandler(p, eventTypes[p], handler);
          }
        }
        return this._switch('on', _once);
      }
      eventTypes = eventTypes;
      var evetTypes = eventTypes.split(' ');
      for (var i = 0, l = evetTypes.length; i < l; i++) {
        this.on(evetTypes[i], this._wrapOnceHandler(evetTypes[i], handler, context));
      }
      return this;
    };
    _proto.off = function off(eventsOff, handler, context) {
      if (!this._eventMap || !eventsOff) {
        return this;
      }
      if (!isString(eventsOff)) {
        return this._switch('off', eventsOff, handler);
      }
      if (!handler) {
        return this;
      }
      if (!isNumber(handler._id)) {
        return this;
      }
      eventsOff = eventsOff;
      var eventTypes = eventsOff.split(' ');
      var eventType, listeners, wrapKey;
      if (!context) {
        context = this;
      }
      for (var j = 0, jl = eventTypes.length; j < jl; j++) {
        eventType = eventTypes[j].toLowerCase();
        wrapKey = generateWrapKey(eventType);
        listeners = this._eventMap[eventType];
        if (!listeners) {
          continue;
        }
        for (var i = listeners.length - 1; i >= 0; i--) {
          var listener = listeners[i];
          if ((handler === listener.handler || handler === listener.handler[wrapKey]) && listener.context === context) {
            delete listener.handler[wrapKey];
            listeners.splice(i, 1);
          }
        }
        if (!listeners.length) {
          delete this._eventMap[eventType];
        }
      }
      return this;
    };
    _proto.removeEventListener = function removeEventListener(...args) {
      return this.off.call(this, ...args);
    };
    _proto.listens = function listens(eventType, handler, context) {
      if (!this._eventMap || !isString(eventType)) {
        return 0;
      }
      var handlerChain = this._eventMap[eventType.toLowerCase()];
      if (!handlerChain || !handlerChain.length) {
        return 0;
      }
      if (!handler) {
        return handlerChain.length;
      }
      for (var i = 0, len = handlerChain.length; i < len; i++) {
        if (handler === handlerChain[i].handler && (isNil(context) || handlerChain[i].context === context)) {
          return 1;
        }
      }
      return 0;
    };
    _proto.getListeningEvents = function getListeningEvents() {
      if (!this._eventMap) {
        return [];
      }
      return Object.keys(this._eventMap);
    };
    _proto.copyEventListeners = function copyEventListeners(target) {
      var eventMap = target._eventMap;
      if (!eventMap) {
        return this;
      }
      var handlerChain;
      for (var eventType in eventMap) {
        handlerChain = eventMap[eventType];
        for (var i = 0, len = handlerChain.length; i < len; i++) {
          this.on(eventType, handlerChain[i].handler, handlerChain[i].context);
        }
      }
      return this;
    };
    _proto.fire = function fire(eventType, param) {
      if (this._eventParent) {
        return this._eventParent.fire.call(this._eventParent, eventType, param);
      }
      return this._fire.call(this, eventType, param);
    };
    _proto._wrapOnceHandler = function _wrapOnceHandler(evtType, handler, context) {
      var key = generateWrapKey(evtType);
      var called = false;
      var fn = function onceHandler(...args) {
        if (called) {
          return;
        }
        delete fn[key];
        called = true;
        if (context) {
          handler.call(context, ...args);
        } else {
          handler.call(this, ...args);
        }
        onceHandler._called = true;
      };
      fn[key] = handler;
      return fn;
    };
    _proto._switch = function _switch(to, eventRecords, context) {
      for (var p in eventRecords) {
        if (eventRecords.hasOwnProperty(p)) {
          this[to](p, eventRecords[p], context);
        }
      }
      return this;
    };
    _proto._clearListeners = function _clearListeners(eventType) {
      if (!this._eventMap || !isString(eventType)) {
        return;
      }
      var handlerChain = this._eventMap[eventType.toLowerCase()];
      if (!handlerChain) {
        return;
      }
      this._eventMap[eventType] = null;
    };
    _proto._clearAllListeners = function _clearAllListeners() {
      this._eventMap = null;
    };
    _proto._setEventParent = function _setEventParent(parent) {
      this._eventParent = parent;
      return this;
    };
    _proto._setEventTarget = function _setEventTarget(target) {
      this._eventTarget = target;
      return this;
    };
    _proto._fire = function _fire(eventType, param) {
      if (!this._eventMap) {
        return this;
      }
      eventType = eventType.toLowerCase();
      var handlerChain = this._eventMap[eventType];
      if (!handlerChain) {
        return this;
      }
      if (!param) {
        param = {
          type: eventType,
          target: this._eventTarget || this
        };
      }
      param['type'] = eventType;
      param['target'] = this._eventTarget || this;
      var queue = handlerChain.slice(0);
      var context, bubble, passed;
      for (var i = 0, len = queue.length; i < len; i++) {
        if (!queue[i]) {
          continue;
        }
        var handler = queue[i].handler;
        if (handler._called) {
          continue;
        }
        context = queue[i].context;
        bubble = true;
        passed = extend$2({}, param);
        if (context) {
          bubble = queue[i].handler.call(context, passed);
        } else {
          bubble = queue[i].handler(passed);
        }
        if (bubble === false) {
          if (param['domEvent']) {
            stopPropagation(param['domEvent']);
          }
        }
      }
      var eventQueue = this._eventMap[eventType];
      if (eventQueue) {
        var queueExcludeOnce = [];
        for (var _i = 0, _len = eventQueue.length; _i < _len; _i++) {
          var _handler = eventQueue[_i].handler;
          if (!_handler._called) {
            queueExcludeOnce.push(eventQueue[_i]);
          }
        }
        this._eventMap[eventType] = queueExcludeOnce;
      }
      return this;
    };
    return EventableMixin;
  }(Base);
}

var Base$1 = function Base() {};
var Handler = function (_Eventable) {
  function Handler(target) {
    var _this;
    _this = _Eventable.call(this) || this;
    _this._enabled = false;
    _this.target = target;
    return _this;
  }
  _inheritsLoose(Handler, _Eventable);
  var _proto = Handler.prototype;
  _proto.enable = function enable() {
    if (this._enabled) {
      return this;
    }
    this._enabled = true;
    this.addHooks();
    return this;
  };
  _proto.disable = function disable() {
    if (!this._enabled) {
      return this;
    }
    this._enabled = false;
    this.removeHooks();
    return this;
  };
  _proto.enabled = function enabled() {
    return !!this._enabled;
  };
  _proto.remove = function remove() {
    this.disable();
    delete this.target;
    delete this.dom;
  };
  return Handler;
}(Eventable(Base$1));

var Class = function () {
  function Class(options) {
    if (!this || !this._setOptions) {
      throw new Error('Class instance is being created without "new" operator.');
    }
    this._setOptions(options);
    this.callInitHooks();
    this._isUpdatingOptions = false;
  }
  var _proto = Class.prototype;
  _proto.proxyOptions = function proxyOptions() {
    var _this = this;
    if (!Browser$1.proxy) {
      return this;
    }
    this.options = new Proxy(this.options, {
      set: function set(target, key, value) {
        key = key;
        if (target[key] === value) {
          return true;
        }
        target[key] = value;
        if (_this._isUpdatingOptions) {
          return true;
        }
        var opts = {};
        opts[key] = value;
        _this.config(opts);
        return true;
      }
    });
    return this;
  };
  _proto.callInitHooks = function callInitHooks() {
    var proto = Object.getPrototypeOf(this);
    this._visitInitHooks(proto);
    return this;
  };
  _proto._setOptions = function _setOptions(options) {
    if (!this.hasOwnProperty('options') || isNil(this.options)) {
      this.options = this.options ? Object.create(this.options) : {};
    }
    if (!options) {
      return this;
    }
    for (var i in options) {
      this.options[i] = options[i];
    }
    return this;
  };
  _proto.setOptions = function setOptions(options) {
    console.warn('setOptions(options) It is a private method and deprecated, please use _setOptions(options) instead. If you want to update options, please use config(options) instead.');
    return this._setOptions(options);
  };
  _proto.config = function config(conf, value) {
    this._isUpdatingOptions = true;
    if (!conf) {
      var _config = {};
      for (var p in this.options) {
        if (this.options.hasOwnProperty(p)) {
          _config[p] = this.options[p];
        }
      }
      this._isUpdatingOptions = false;
      return _config;
    } else {
      if (arguments.length === 2 && typeof conf === 'string') {
        var t = {};
        t[conf] = value;
        conf = t;
      }
      conf = conf;
      for (var i in conf) {
        this.options[i] = conf[i];
        if (this[i] && this[i] instanceof Handler) {
          if (conf[i]) {
            this[i].enable();
          } else {
            this[i].disable();
          }
        }
      }
      this.onConfig(conf);
      this._isUpdatingOptions = false;
    }
    return this;
  };
  _proto.onConfig = function onConfig(conf) {};
  _proto._visitInitHooks = function _visitInitHooks(proto) {
    if (this._initHooksCalled) {
      return;
    }
    var parentProto = Object.getPrototypeOf(proto);
    if (parentProto._visitInitHooks) {
      parentProto._visitInitHooks.call(this, parentProto);
    }
    this._initHooksCalled = true;
    var hooks = proto._initHooks;
    if (hooks && hooks !== parentProto._initHooks) {
      for (var i = 0; i < hooks.length; i++) {
        hooks[i].call(this);
      }
    }
  };
  Class.addInitHook = function addInitHook(fn, ...args) {
    var init = typeof fn === 'function' ? fn : function () {
      this[fn].call(this, ...args);
    };
    var proto = this.prototype;
    var parentProto = Object.getPrototypeOf(proto);
    if (!proto._initHooks || proto._initHooks === parentProto._initHooks) {
      proto._initHooks = [];
    }
    proto._initHooks.push(init);
    return this;
  };
  Class.include = function include(...sources) {
    for (var i = 0; i < sources.length; i++) {
      extend$2(this.prototype, sources[i]);
    }
    return this;
  };
  Class.mergeOptions = function mergeOptions(options) {
    var proto = this.prototype;
    var parentProto = Object.getPrototypeOf(proto);
    if (!proto.options || proto.options === parentProto.options) {
      proto.options = proto.options ? Object.create(proto.options) : {};
    }
    extend$2(proto.options, options);
    return this;
  };
  return Class;
}();

var Base = function Base() {};
var GlobalEventable = function (_Eventable) {
  function GlobalEventable() {
    return _Eventable.apply(this, arguments) || this;
  }
  _inheritsLoose(GlobalEventable, _Eventable);
  return GlobalEventable;
}(Eventable(Base));
var GlobalEvent = new GlobalEventable();
var EVENT_DPR_CHANGE = 'dprchange';
var EVENT_DOC_VISIBILITY_CHANGE = 'docvisibilitychange';
var EVENT_DOC_DRAGSTART = 'dragstart';
var EVENT_DOC_DRAGEND = 'dragend';
if (typeof window !== 'undefined' && window.matchMedia) {
  for (var i$1 = 1; i$1 < 500; i$1++) {
    var dpi = (i$1 * 0.01).toFixed(2);
    var screen$1 = window.matchMedia("screen and (resolution: " + dpi + "dppx)");
    if (screen$1) {
      if (screen$1.addEventListener) {
        screen$1.addEventListener('change', Browser$1.checkDevicePixelRatio);
      } else if (screen$1.addListener) {
        screen$1.addListener(Browser$1.checkDevicePixelRatio);
      }
    }
  }
}
if (Browser$1.devicePixelRatio) {
  var tempDPI = Browser$1.devicePixelRatio;
  Object.defineProperty(Browser$1, 'devicePixelRatio', {
    get: function get() {
      return tempDPI;
    },
    set: function set(value) {
      if (value === tempDPI) {
        return;
      }
      tempDPI = value;
      if (!Browser$1.monitorDPRChange) {
        return;
      }
      GlobalEvent.fire(EVENT_DPR_CHANGE, {
        devicePixelRatio: value
      });
    }
  });
}
if (Browser$1.webgl && typeof document !== 'undefined') {
  addDomEvent(document, 'visibilitychange', function () {
    GlobalEvent.fire(EVENT_DOC_VISIBILITY_CHANGE, {
      visibilityState: document.visibilityState
    });
  });
  addDomEvent(document, 'dragstart', function () {
    GlobalEvent.fire(EVENT_DOC_DRAGSTART);
  });
  addDomEvent(document, 'dragend', function () {
    GlobalEvent.fire(EVENT_DOC_DRAGEND);
  });
}

var registeredTypes = {};
function JSONAble (Base) {
  return function (_Base) {
    function JSONAble() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(JSONAble, _Base);
    JSONAble.registerJSONType = function registerJSONType(type) {
      if (!type) {
        return;
      }
      if (registeredTypes[type]) {
        console.error(type + " has register. please use Different name for:", this);
        return;
      }
      registeredTypes[type] = this;
      return;
    };
    JSONAble.getJSONClass = function getJSONClass(type) {
      if (!type) {
        return null;
      }
      return registeredTypes[type];
    };
    var _proto = JSONAble.prototype;
    _proto.getJSONType = function getJSONType() {
      if (this._jsonType === undefined) {
        var clazz = Object.getPrototypeOf(this).constructor;
        for (var p in registeredTypes) {
          if (registeredTypes[p] === clazz) {
            this._jsonType = p;
            break;
          }
        }
      }
      if (!this._jsonType) {
        throw new Error('Found an unregistered Layer/Geometry class!');
      }
      return this._jsonType;
    };
    return JSONAble;
  }(Base);
}

function Handlerable (Base) {
  return function (_Base) {
    function Handlerable() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(Handlerable, _Base);
    var _proto = Handlerable.prototype;
    _proto.addHandler = function addHandler(name, handlerClass) {
      if (!handlerClass) {
        return this;
      }
      if (!this._handlers) {
        this._handlers = [];
      }
      if (this[name]) {
        this[name].enable();
        return this;
      }
      var handler = this[name] = new handlerClass(this);
      this._handlers.push(handler);
      if (this.options[name]) {
        handler.enable();
      }
      return this;
    };
    _proto.removeHandler = function removeHandler(name) {
      if (!name) {
        return this;
      }
      var handler = this[name];
      if (handler) {
        var hit = this._handlers.indexOf(handler);
        if (hit >= 0) {
          this._handlers.splice(hit, 1);
        }
        this[name].remove();
        delete this[name];
      }
      return this;
    };
    _proto._clearHandlers = function _clearHandlers() {
      for (var i = 0, len = this._handlers.length; i < len; i++) {
        this._handlers[i].remove();
      }
      this._handlers = [];
    };
    return Handlerable;
  }(Base);
}

var START_EVENTS = 'touchstart mousedown';
var MOVE_EVENTS = {
  mousedown: 'mousemove',
  touchstart: 'touchmove',
  pointerdown: 'touchmove',
  MSPointerDown: 'touchmove'
};
var END_EVENTS = {
  mousedown: 'mouseup',
  touchstart: 'touchend',
  pointerdown: 'touchend',
  MSPointerDown: 'touchend'
};
var DragHandler = function (_Handler) {
  function DragHandler(dom, options = {}) {
    var _this;
    _this = _Handler.call(this, null) || this;
    _this.dom = dom;
    _this.options = options;
    return _this;
  }
  _inheritsLoose(DragHandler, _Handler);
  var _proto = DragHandler.prototype;
  _proto.addHooks = function addHooks() {};
  _proto.removeHooks = function removeHooks() {};
  _proto.enable = function enable() {
    if (!this.dom) {
      return this;
    }
    this._onMouseDown = function (e) {
      return this.onMouseDown(e);
    };
    on(this.dom, START_EVENTS, this._onMouseDown, this);
    return this;
  };
  _proto.disable = function disable() {
    if (!this.dom) {
      return this;
    }
    this._offEvents();
    off(this.dom, START_EVENTS, this._onMouseDown);
    delete this._onMouseDown;
    return this;
  };
  _proto.onMouseDown = function onMouseDown(event) {
    if (!this.options['rightclick'] && event.button === 2) {
      return;
    }
    var toucheEvent = event;
    if (toucheEvent.touches && toucheEvent.touches.length > 1) {
      return;
    }
    if (this.options['cancelOn'] && this.options['cancelOn'](event) === true) {
      return;
    }
    var dom = this.dom;
    if (dom.setCapture) {
      dom.setCapture();
    } else if (window.captureEvents) {
      window.captureEvents();
    }
    dom['ondragstart'] = function () {
      return false;
    };
    delete this.moved;
    var actual = toucheEvent.touches ? toucheEvent.touches[0] : event;
    this.startPos = new Point(actual.clientX, actual.clientY);
    off(document, MOVE_EVENTS[event.type], this.onMouseMove);
    off(document, END_EVENTS[event.type], this.onMouseUp);
    on(document, MOVE_EVENTS[event.type], this.onMouseMove, this);
    on(document, END_EVENTS[event.type], this.onMouseUp, this);
    if (!this.options['ignoreMouseleave']) {
      off(this.dom, 'mouseleave', this.onMouseUp);
      on(this.dom, 'mouseleave', this.onMouseUp, this);
    }
    this.fire('mousedown', {
      'domEvent': event,
      'mousePos': new Point(actual.clientX, actual.clientY)
    });
  };
  _proto.onMouseMove = function onMouseMove(event) {
    var toucheEvent = event;
    if (toucheEvent.touches && toucheEvent.touches.length > 1) {
      if (this.moved) {
        this.interupted = true;
        this.onMouseUp(event);
      }
      return;
    }
    var actual = toucheEvent.touches ? toucheEvent.touches[0] : event;
    var newPos = new Point(actual.clientX, actual.clientY),
      offset = newPos.sub(this.startPos);
    if (!offset.x && !offset.y) {
      return;
    }
    if (!this.moved) {
      this.fire('dragstart', {
        'domEvent': event,
        'mousePos': this.startPos.copy()
      });
      this.moved = true;
    } else {
      this.fire('dragging', {
        'domEvent': event,
        'mousePos': new Point(actual.clientX, actual.clientY)
      });
    }
  };
  _proto.onMouseUp = function onMouseUp(event) {
    var toucheEvent = event;
    var actual = toucheEvent.changedTouches ? toucheEvent.changedTouches[0] : event;
    this._offEvents();
    var param = {
      'domEvent': event
    };
    if (isNumber(actual.clientX)) {
      param['mousePos'] = new Point(parseInt(actual.clientX + '', 0), parseInt(actual.clientY + '', 0));
    }
    if (this.moved) {
      param.interupted = this.interupted;
      this.fire('dragend', param);
      delete this.interupted;
      delete this.moved;
    }
    this.fire('mouseup', param);
  };
  _proto._offEvents = function _offEvents() {
    var dom = this.dom;
    off(dom, 'mouseleave', this.onMouseUp);
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }
    for (var i in MOVE_EVENTS) {
      off(document, MOVE_EVENTS[i], this.onMouseMove);
      off(document, END_EVENTS[i], this.onMouseUp);
    }
    if (dom['releaseCapture']) {
      dom['releaseCapture']();
    } else if (window.captureEvents) {
      window.captureEvents();
    }
  };
  return DragHandler;
}(Handler);

var Coordinate = function (_Position) {
  function Coordinate() {
    return _Position.apply(this, arguments) || this;
  }
  _inheritsLoose(Coordinate, _Position);
  Coordinate.toNumberArrays = function toNumberArrays(coordinates) {
    if (!Array.isArray(coordinates)) {
      return coordinates.toArray();
    }
    return forEachCoord(coordinates, function (coord) {
      return coord.toArray();
    });
  };
  Coordinate.toCoordinates = function toCoordinates(coordinates) {
    if (isNumber(coordinates[0]) && isNumber(coordinates[1])) {
      return new Coordinate(coordinates);
    }
    if (coordinates instanceof Coordinate) {
      return coordinates;
    }
    var result = [];
    for (var i = 0, len = coordinates.length; i < len; i++) {
      var child = coordinates[i];
      if (Array.isArray(child)) {
        if (isNumber(child[0])) {
          result.push(new Coordinate(child));
        } else {
          result.push(Coordinate.toCoordinates(child));
        }
      } else if (child instanceof Coordinate) {
        result.push(child);
      } else {
        result.push(new Coordinate(child));
      }
    }
    return result;
  };
  var _proto = Coordinate.prototype;
  _proto.closeTo = function closeTo(p, delta) {
    if (!delta) {
      delta = 0;
    }
    return this.x >= p.x - delta && this.x <= p.x + delta && this.y >= p.y - delta && this.y <= p.y + delta;
  };
  _proto.abs = function abs() {
    return new Coordinate(Math.abs(this.x), Math.abs(this.y));
  };
  _proto.round = function round() {
    return new Coordinate(Math.round(this.x), Math.round(this.y));
  };
  _proto.ceil = function ceil() {
    return new Coordinate(Math.ceil(this.x), Math.ceil(this.y));
  };
  _proto.floor = function floor() {
    return new Coordinate(Math.floor(this.x), Math.floor(this.y));
  };
  _proto.copy = function copy() {
    return new Coordinate(this.x, this.y, this.z);
  };
  _proto.toFixed = function toFixed(n) {
    return new Coordinate(this.x.toFixed(n), this.y.toFixed(n), isNumber(this.z) ? this.z.toFixed(n) : undefined);
  };
  _proto.add = function add(x, y, z) {
    var nx,
      ny,
      nz = this.z;
    if (!isNil(x.x)) {
      nx = this.x + x.x;
      ny = this.y + x.y;
      if (!isNil(x.z)) {
        nz = (this.z || 0) + x.z;
      }
    } else if (!isNil(x[0])) {
      nx = this.x + x[0];
      ny = this.y + x[1];
      if (!isNil(x[2])) {
        nz = (this.z || 0) + x[2];
      }
    } else {
      nx = this.x + x;
      ny = this.y + y;
      if (!isNil(z)) {
        nz = (this.z || 0) + z;
      }
    }
    return new Coordinate(nx, ny, nz);
  };
  _proto.sub = function sub(x, y, z) {
    var nx,
      ny,
      nz = this.z;
    if (!isNil(x.x)) {
      nx = this.x - x.x;
      ny = this.y - x.y;
      if (!isNil(x.z)) {
        nz = (this.z || 0) - x.z;
      }
    } else if (!isNil(x[0])) {
      nx = this.x - x[0];
      ny = this.y - x[1];
      if (!isNil(x[2])) {
        nz = (this.z || 0) - x[2];
      }
    } else {
      nx = this.x - x;
      ny = this.y - y;
      if (!isNil(z)) {
        nz = (this.z || 0) - z;
      }
    }
    return new Coordinate(nx, ny, nz);
  };
  _proto.multi = function multi(ratio) {
    return new Coordinate(this.x * ratio, this.y * ratio, isNil(this.z) ? this.z : this.z * ratio);
  };
  _proto.equals = function equals(c) {
    if (!(c instanceof this.constructor)) {
      return false;
    }
    return this.x === c.x && this.y === c.y && this.z === c.z;
  };
  return Coordinate;
}(Position);

var CRS = function () {
  function CRS(type, properties) {
    this.type = type;
    this.properties = properties;
  }
  CRS.createProj4 = function createProj4(proj) {
    return new CRS('proj4', {
      'proj': proj
    });
  };
  CRS.fromProjectionCode = function fromProjectionCode(code) {
    if (!code) {
      return null;
    }
    code = code.toUpperCase().replace(':', '');
    return CRS[code] || null;
  };
  return CRS;
}();
CRS.WGS84 = CRS.createProj4('+proj=longlat +datum=WGS84 +no_defs');
CRS.EPSG3857 = CRS.createProj4('+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs');
CRS.IDENTITY = CRS.createProj4('+proj=identity +no_defs');
CRS.CGCS2000 = CRS.createProj4('+proj=longlat +datum=CGCS2000');
CRS.EPSG4490 = CRS.CGCS2000;
CRS.BD09LL = CRS.createProj4('+proj=longlat +datum=BD09');
CRS.GCJ02 = CRS.createProj4('+proj=longlat +datum=GCJ02');

var TEMP_POINT0$4 = new Point(0, 0);
var TEMP_COORD0$1 = new Coordinate(0, 0);
var TEMP_COORD1$1 = new Coordinate(0, 0);
var TEMP_COORD2 = new Coordinate(0, 0);
var TEMP_COORD3 = new Coordinate(0, 0);
var TEMP_COORD4 = new Coordinate(0, 0);
var TEMP_COORD5 = new Coordinate(0, 0);
var TEMP_COORD6 = new Coordinate(0, 0);
var TEMP_COORD7 = new Coordinate(0, 0);
var MINMAX = [];
var TEMP_EXTENT$9;
var TEMP_COMBINE = [];
var Extent = function () {
  function Extent(...args) {
    this._clazz = Coordinate;
    var l = args.length;
    var proj = l > 0 ? args[l - 1] : null;
    if (proj && proj.unproject) {
      this.projection = args[l - 1];
    }
    this._dirty = true;
    this.antiMeridian = false;
    this._initialize(args[0], args[1], args[2], args[3]);
  }
  var _proto = Extent.prototype;
  _proto._initialize = function _initialize(p1, p2, p3, p4) {
    this.xmin = null;
    this.xmax = null;
    this.ymin = null;
    this.ymax = null;
    if (isNil(p1)) {
      return;
    }
    var projection = this.projection;
    if (isNumber(p1) && isNumber(p2) && isNumber(p3) && isNumber(p4)) {
      if (projection) {
        this.set(p1, p2, p3, p4);
      } else {
        this.set(Math.min(p1, p3), Math.min(p2, p4), Math.max(p1, p3), Math.max(p2, p4));
      }
      return;
    } else if (Array.isArray(p1)) {
      if (projection) {
        this.set(p1[0], p1[1], p1[2], p1[3]);
      } else {
        this.set(Math.min(p1[0], p1[2]), Math.min(p1[1], p1[3]), Math.max(p1[0], p1[2]), Math.max(p1[1], p1[3]));
      }
    } else if (isNumber(p1.x) && isNumber(p2.x) && isNumber(p1.y) && isNumber(p2.y)) {
      var tp1 = p1;
      var tp2 = p2;
      if (projection) {
        this.set(tp1.x, tp1.y, tp2.x, tp2.y);
      } else {
        if (tp1.x > tp2.x) {
          this['xmin'] = tp2.x;
          this['xmax'] = tp1.x;
        } else {
          this['xmin'] = tp1.x;
          this['xmax'] = tp2.x;
        }
        if (tp1.y > tp2.y) {
          this['ymin'] = tp2.y;
          this['ymax'] = tp1.y;
        } else {
          this['ymin'] = tp1.y;
          this['ymax'] = tp2.y;
        }
      }
    } else if (isNumber(p1['xmin']) && isNumber(p1['xmax']) && isNumber(p1['ymin']) && isNumber(p1['ymax'])) {
      this.set(p1['xmin'], p1['ymin'], p1['xmax'], p1['ymax']);
    }
  };
  _proto._add = function _add(p) {
    this._dirty = true;
    if (!isNil(p.x)) {
      this['xmin'] += p.x;
      this['ymin'] += p.y;
      this['xmax'] += p.x;
      this['ymax'] += p.y;
    } else if (!isNil(p.xmin)) {
      this['xmin'] += p.xmin;
      this['ymin'] += p.ymin;
      this['xmax'] += p.xmax;
      this['ymax'] += p.ymax;
    } else if (!isNil(p[0])) {
      this['xmin'] += p[0];
      this['ymin'] += p[1];
      this['xmax'] += p[0];
      this['ymax'] += p[1];
    }
    return this;
  };
  _proto.add = function add(p) {
    var e = new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
    return e._add(p);
  };
  _proto._scale = function _scale(s) {
    this._dirty = true;
    this['xmin'] *= s;
    this['ymin'] *= s;
    this['xmax'] *= s;
    this['ymax'] *= s;
    return this;
  };
  _proto._sub = function _sub(p) {
    this._dirty = true;
    if (!isNil(p.x)) {
      this['xmin'] -= p.x;
      this['ymin'] -= p.y;
      this['xmax'] -= p.x;
      this['ymax'] -= p.y;
    } else if (!isNil(p.xmin)) {
      this['xmin'] -= p.xmin;
      this['ymin'] -= p.ymin;
      this['xmax'] -= p.xmax;
      this['ymax'] -= p.ymax;
    } else if (!isNil(p[0])) {
      this['xmin'] -= p[0];
      this['ymin'] -= p[1];
      this['xmax'] -= p[0];
      this['ymax'] -= p[1];
    }
    return this;
  };
  _proto._substract = function _substract(p) {
    return this._sub(p);
  };
  _proto.sub = function sub(p) {
    var e = new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
    return e._sub(p);
  };
  _proto.substract = function substract(p) {
    return this.sub(p);
  };
  _proto.round = function round() {
    return new this.constructor(Math.round(this['xmin']), Math.round(this['ymin']), Math.round(this['xmax']), Math.round(this['ymax']), this.projection);
  };
  _proto._round = function _round() {
    this._dirty = true;
    this['xmin'] = Math.round(this['xmin']);
    this['ymin'] = Math.round(this['ymin']);
    this['xmax'] = Math.round(this['xmax']);
    this['ymax'] = Math.round(this['ymax']);
    return this;
  };
  _proto.getMin = function getMin(out) {
    if (out) {
      out.set(this['xmin'], this['ymin']);
      return out;
    }
    return new this._clazz(this['xmin'], this['ymin']);
  };
  _proto.getMax = function getMax(out) {
    if (out) {
      out.set(this['xmax'], this['ymax']);
      return out;
    }
    return new this._clazz(this['xmax'], this['ymax']);
  };
  _proto.getCenter = function getCenter(out) {
    var x = (this['xmin'] + this['xmax']) / 2;
    var y = (this['ymin'] + this['ymax']) / 2;
    if (out) {
      out.set(x, y);
      return out;
    }
    return new this._clazz(x, y);
  };
  _proto.isValid = function isValid() {
    return !isNil(this['xmin']) && !isNil(this['ymin']) && !isNil(this['xmax']) && !isNil(this['ymax']);
  };
  _proto.equals = function equals(ext2) {
    return this['xmin'] === ext2['xmin'] && this['xmax'] === ext2['xmax'] && this['ymin'] === ext2['ymin'] && this['ymax'] === ext2['ymax'];
  };
  _proto.intersects = function intersects(ext2) {
    this._project(this);
    this._project(ext2);
    var rxmin = Math.max(this['pxmin'], ext2['pxmin']);
    var rymin = Math.max(this['pymin'], ext2['pymin']);
    var rxmax = Math.min(this['pxmax'], ext2['pxmax']);
    var rymax = Math.min(this['pymax'], ext2['pymax']);
    return !(rxmin > rxmax || rymin > rymax);
  };
  _proto.within = function within(extent) {
    this._project(this);
    this._project(extent);
    return this.pxmin >= extent.pxmin && this.pxmax <= extent.pxmax && this.pymin >= extent.pymin && this.pymax <= extent.pymax;
  };
  _proto.contains = function contains(c) {
    if (!c) {
      return false;
    }
    this._project(this);
    var proj = this.projection;
    if (proj) {
      var coord = TEMP_COORD0$1;
      if (Array.isArray(c)) {
        coord.x = c[0];
        coord.y = c[1];
        c = proj.project(coord, coord);
      } else if (c.x !== undefined) {
        coord.x = c.x;
        coord.y = c.y;
        c = proj.project(coord, coord);
      } else if (c.xmin !== undefined) {
        this._project(c);
      }
    }
    return (c.x || c.pxmin || 0) >= this.pxmin && (c.x || c.pxmax || 0) <= this.pxmax && (c.y || c.pymin || 0) >= this.pymin && (c.y || c.pymax || 0) <= this.pymax;
  };
  _proto.getWidth = function getWidth() {
    return Math.abs(this['xmax'] - this['xmin']);
  };
  _proto.getHeight = function getHeight() {
    return Math.abs(this['ymax'] - this['ymin']);
  };
  _proto.getSize = function getSize() {
    return new Size(this.getWidth(), this.getHeight());
  };
  _proto.set = function set(xmin, ymin, xmax, ymax) {
    this.xmin = xmin;
    this.ymin = ymin;
    this.xmax = xmax;
    this.ymax = ymax;
    this._dirty = true;
    return this;
  };
  _proto.__combine = function __combine(extent) {
    if (extent.x !== undefined) {
      TEMP_EXTENT$9.xmin = TEMP_EXTENT$9.xmax = extent.x;
      TEMP_EXTENT$9.ymin = TEMP_EXTENT$9.ymax = extent.y;
      TEMP_EXTENT$9._dirty = true;
      extent = TEMP_EXTENT$9;
    }
    this._project(extent);
    this._project(this);
    var inited = isNumber(this.pxmin);
    var xmin, ymin, xmax, ymax;
    if (!inited) {
      xmin = extent['pxmin'];
      ymin = extent['pymin'];
      xmax = extent['pxmax'];
      ymax = extent['pymax'];
    } else {
      xmin = Math.min(this['pxmin'], extent['pxmin']);
      ymin = Math.min(this['pymin'], extent['pymin']);
      xmax = Math.max(this['pxmax'], extent['pxmax']);
      ymax = Math.max(this['pymax'], extent['pymax']);
    }
    var proj = this.projection;
    if (proj) {
      TEMP_COORD1$1.set(xmin, ymin);
      TEMP_COORD2.set(xmax, ymax);
      var min = proj.unproject(TEMP_COORD1$1, TEMP_COORD1$1),
        max = proj.unproject(TEMP_COORD2, TEMP_COORD2);
      xmin = min.x;
      ymin = min.y;
      xmax = max.x;
      ymax = max.y;
    }
    TEMP_COMBINE[0] = xmin;
    TEMP_COMBINE[1] = ymin;
    TEMP_COMBINE[2] = xmax;
    TEMP_COMBINE[3] = ymax;
    return TEMP_COMBINE;
  };
  _proto._combine = function _combine(extent) {
    if (!extent || extent.isValid && !extent.isValid()) {
      return this;
    }
    var ext = this.__combine(extent);
    this.set(ext[0], ext[1], ext[2], ext[3]);
    this._dirty = true;
    return this;
  };
  _proto.combine = function combine(extent) {
    if (!extent || extent.isValid && !extent.isValid()) {
      return this;
    }
    var ext = this.__combine(extent);
    return new this.constructor(ext[0], ext[1], ext[2], ext[3], this.projection);
  };
  _proto.intersection = function intersection(extent) {
    if (!this.intersects(extent)) {
      return null;
    }
    TEMP_COORD3.x = Math.max(this['pxmin'], extent['pxmin']);
    TEMP_COORD3.y = Math.max(this['pymin'], extent['pymin']);
    TEMP_COORD4.x = Math.min(this['pxmax'], extent['pxmax']);
    TEMP_COORD4.y = Math.min(this['pymax'], extent['pymax']);
    var min = TEMP_COORD3,
      max = TEMP_COORD4;
    var proj = this.projection;
    if (proj) {
      min = proj.unproject(min, min);
      max = proj.unproject(max, max);
    }
    return new this.constructor(min, max, proj);
  };
  _proto.expand = function expand(distance) {
    var w, h;
    if (!isNumber(distance)) {
      w = distance['width'] || distance['x'] || distance[0] || 0;
      h = distance['height'] || distance['y'] || distance[1] || 0;
    } else {
      w = h = distance;
    }
    return new this.constructor(this['xmin'] - w, this['ymin'] - h, this['xmax'] + w, this['ymax'] + h, this.projection);
  };
  _proto._expand = function _expand(distance) {
    var w, h;
    if (!isNumber(distance)) {
      w = distance['width'] || distance['x'] || distance[0] || 0;
      h = distance['height'] || distance['y'] || distance[1] || 0;
    } else {
      w = h = distance;
    }
    this['xmin'] -= w;
    this['ymin'] -= h;
    this['xmax'] += w;
    this['ymax'] += h;
    this._dirty = true;
    return this;
  };
  _proto.toJSON = function toJSON() {
    return {
      'xmin': this['xmin'],
      'ymin': this['ymin'],
      'xmax': this['xmax'],
      'ymax': this['ymax']
    };
  };
  _proto.toArray = function toArray(out) {
    var xmin = this['xmin'],
      ymin = this['ymin'],
      xmax = this['xmax'],
      ymax = this['ymax'];
    if (!out) {
      return [new this._clazz([xmin, ymax]), new this._clazz([xmax, ymax]), new this._clazz([xmax, ymin]), new this._clazz([xmin, ymin]), new this._clazz([xmin, ymax])];
    } else {
      out[0].x = xmin;
      out[0].y = ymax;
      out[1].x = xmax;
      out[1].y = ymax;
      out[2].x = xmax;
      out[2].y = ymin;
      out[3].x = xmin;
      out[3].y = ymin;
      out[4].x = xmin;
      out[4].y = ymax;
      return out;
    }
  };
  _proto.toBBOX = function toBBOX() {
    return [this.xmin, this.ymin, this.xmax, this.ymax];
  };
  _proto.toString = function toString() {
    return this.xmin + "," + this.ymin + "," + this.xmax + "," + this.ymax;
  };
  _proto.copy = function copy() {
    return new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
  };
  _proto.convertTo = function convertTo(fn, out) {
    if (!this.isValid()) {
      return null;
    }
    var e = out || new this.constructor();
    if (out) {
      e.set(null, null, null, null);
    }
    var coord;
    if (this._clazz === Coordinate) {
      coord = TEMP_COORD5;
    } else if (this._clazz === Point) {
      coord = TEMP_POINT0$4;
    }
    coord.x = this.xmin;
    coord.y = this.ymax;
    e._combine(fn(coord));
    coord.x = this.xmax;
    e._combine(fn(coord));
    coord.y = this.ymin;
    e._combine(fn(coord));
    coord.x = this.xmin;
    e._combine(fn(coord));
    return e;
  };
  _proto._project = function _project(ext) {
    if (!ext || !ext.isValid()) {
      if (ext) {
        ext.pxmin = ext.pxmax = ext.pymin = ext.pymax = null;
      }
      return;
    }
    var proj = this.projection;
    if (proj) {
      if (ext._dirty) {
        TEMP_COORD6.set(ext.xmin, ext.ymin);
        TEMP_COORD7.set(ext.xmax, ext.ymax);
        MINMAX[0] = TEMP_COORD6;
        MINMAX[1] = TEMP_COORD7;
        var minmax = proj.projectCoords(MINMAX, this.antiMeridian);
        var min = minmax[0],
          max = minmax[1];
        ext.pxmin = Math.min(min.x, max.x);
        ext.pymin = Math.min(min.y, max.y);
        ext.pxmax = Math.max(min.x, max.x);
        ext.pymax = Math.max(min.y, max.y);
      }
      delete ext._dirty;
    } else {
      ext.pxmin = ext.xmin;
      ext.pxmax = ext.xmax;
      ext.pymin = ext.ymin;
      ext.pymax = ext.ymax;
    }
  };
  return Extent;
}();
TEMP_EXTENT$9 = new Extent(0, 0, 0, 0);
function minValue(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return Math.min(a, b);
  } else if (isNumber(a)) {
    return a;
  } else if (isNumber(b)) {
    return b;
  }
}
function maxValue(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return Math.max(a, b);
  } else if (isNumber(a)) {
    return a;
  } else if (isNumber(b)) {
    return b;
  }
}
function combineExtentAltitude(extent1, extent2) {
  if (!extent2) {
    return extent1;
  }
  var min1 = extent1.zmin;
  var max1 = extent1.zmax;
  var min2 = extent2.zmin;
  var max2 = extent2.zmax;
  extent1.zmin = minValue(min1, min2);
  extent1.zmax = maxValue(max1, max2);
  return extent1;
}

var PointExtent = function (_Extent) {
  function PointExtent(...args) {
    var _this;
    _this = _Extent.call(this, ...args) || this;
    _this._clazz = Point;
    return _this;
  }
  _inheritsLoose(PointExtent, _Extent);
  return PointExtent;
}(Extent);

var Transformation = function () {
  function Transformation(matrix) {
    this.matrix = matrix;
  }
  var _proto = Transformation.prototype;
  _proto.transform = function transform(coordinates, scale, out) {
    var x = this.matrix[0] * (coordinates.x - this.matrix[2]) / scale;
    var y = -this.matrix[1] * (coordinates.y - this.matrix[3]) / scale;
    if (out) {
      out.x = x;
      out.y = y;
      return out;
    }
    return new Point(x, y);
  };
  _proto.untransform = function untransform(point, scale, out) {
    var x = point.x * scale / this.matrix[0] + this.matrix[2];
    var y = point.y * scale / -this.matrix[1] + this.matrix[3];
    if (out) {
      out.x = x;
      out.y = y;
      return out;
    }
    return new Coordinate(x, y);
  };
  return Transformation;
}();

var CommonProjection = {
  code: '',
  is: function is(code) {
    if (this.code === code) {
      return true;
    }
    if (!this.aliases) {
      return false;
    }
    for (var i = 0; i < this.aliases.length; i++) {
      if (this.aliases[i] === code) {
        return true;
      }
    }
    return false;
  },
  project: function project(p) {
    return p;
  },
  unproject: function unproject(p) {
    return p;
  },
  projectCoords: function projectCoords(coordinates, antiMeridian) {
    var _this = this;
    if (!coordinates) {
      return [];
    }
    if (!Array.isArray(coordinates)) {
      return this.project(coordinates);
    }
    if (coordinates.length === 0) {
      return [];
    }
    if (!this.isSphere()) {
      return forEachCoord(coordinates, this.project, this);
    }
    if (Array.isArray(coordinates[0])) {
      return coordinates.map(function (coords) {
        return _this.projectCoords(coords, antiMeridian);
      });
    } else {
      var antiMeridianEnable = antiMeridian;
      var circum = this.getCircum();
      var extent = this.getSphereExtent();
      var sy = extent.sy;
      var wrapY;
      var pre = coordinates[0],
        current,
        dx,
        dy,
        p;
      var prj = [this.project(pre)];
      for (var i = 1, l = coordinates.length; i < l; i++) {
        current = coordinates[i];
        dx = current.x - pre.x;
        dy = current.y - pre.y;
        p = this.project(current);
        var isAntiMeridian = false;
        if (Math.abs(dx) > 180 && antiMeridianEnable) {
          if (dx < 0) {
            current.x = 180 + 180 - Math.abs(current.x);
          } else {
            current.x = -180 - (180 - Math.abs(current.x));
          }
          isAntiMeridian = true;
        }
        if (Math.abs(dy) > 90 && antiMeridianEnable) {
          if (wrapY === undefined) {
            wrapY = current.y < pre.y;
          }
          if (wrapY) {
            p._add(0, -circum.y * sign(dy) * sy);
            current._add(0, -180 * sign(dy));
          }
        }
        if (isAntiMeridian) {
          p = this.project(current);
        }
        pre = current;
        prj.push(p);
      }
      return prj;
    }
  },
  unprojectCoords: function unprojectCoords(projCoords) {
    if (!projCoords) {
      return [];
    }
    if (!Array.isArray(projCoords)) {
      return this.unproject(projCoords);
    }
    return forEachCoord(projCoords, this.unproject, this);
  },
  isSphere: function isSphere() {
    return !!this.sphere;
  },
  isOutSphere: function isOutSphere(pcoord) {
    if (!this.isSphere()) {
      return false;
    }
    var extent = this.getSphereExtent();
    return !extent.contains(pcoord);
  },
  wrapCoord: function wrapCoord(pcoord) {
    if (!this.isSphere()) {
      return pcoord;
    }
    var extent = this.getSphereExtent();
    var wrapped = new Coordinate(pcoord);
    if (!extent.contains(wrapped)) {
      wrapped.x = wrap(pcoord.x, extent.xmin, extent.xmax);
      wrapped.y = wrap(pcoord.y, extent.ymin, extent.ymax);
    }
    return wrapped;
  },
  getCircum: function getCircum() {
    if (!this.circum && this.isSphere()) {
      var extent = this.getSphereExtent();
      this.circum = {
        x: extent.getWidth(),
        y: extent.getHeight()
      };
    }
    return this.circum;
  },
  getSphereExtent: function getSphereExtent() {
    if (!this.extent && this.isSphere()) {
      var max = this.project(new Coordinate(180, 90)),
        min = this.project(new Coordinate(-180, -90));
      this.extent = new Extent(min, max, this);
      this.extent.sx = max.x > min.x ? 1 : -1;
      this.extent.sy = max.y > min.y ? 1 : -1;
    }
    return this.extent;
  }
};

var common = {
  measureLength: function measureLength(c1, c2) {
    if (!Array.isArray(c1)) {
      return this.measureLenBetween(c1, c2);
    }
    var len = 0;
    for (var i = 0, l = c1.length; i < l - 1; i++) {
      len += this.measureLenBetween(c1[i], c1[i + 1]);
    }
    return len;
  }
};

var identity = {
  'measure': 'IDENTITY',
  measureLenBetween: function measureLenBetween(c1, c2, ignoreAltitude = false) {
    if (!c1 || !c2) {
      return 0;
    }
    try {
      var distance = Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
      if (ignoreAltitude) {
        return distance;
      }
      var z1 = c1.z || 0,
        z2 = c2.z || 0;
      var dz = z1 - z2;
      if (dz === 0) {
        return distance;
      }
      return Math.sqrt(distance * distance + dz * dz);
    } catch (err) {
      return 0;
    }
  },
  measureArea: function measureArea(coordinates) {
    if (!Array.isArray(coordinates)) {
      return 0;
    }
    var area = 0;
    for (var i = 0, len = coordinates.length; i < len; i++) {
      var c1 = coordinates[i];
      var c2 = null;
      if (i === len - 1) {
        c2 = coordinates[0];
      } else {
        c2 = coordinates[i + 1];
      }
      area += c1.x * c2.y - c1.y * c2.x;
    }
    return Math.abs(area / 2);
  },
  locate: function locate(c, xDist, yDist, out) {
    out = out || new Coordinate(0, 0);
    out.set(c.x, c.y);
    return this._locate(out, xDist, yDist);
  },
  _locate: function _locate(c, xDist, yDist) {
    if (!c) {
      return null;
    }
    if (!xDist) {
      xDist = 0;
    }
    if (!yDist) {
      yDist = 0;
    }
    if (!xDist && !yDist) {
      return c;
    }
    c.x = c.x + xDist;
    c.y = c.y + yDist;
    return c;
  },
  rotate: function rotate(c, pivot, angle) {
    c = new Coordinate(c.x, c.y);
    return this._rotate(c, pivot, angle);
  },
  _rotate: function () {
    var tmp = new Point(0, 0);
    return function (c, pivot, angle) {
      tmp.x = c.x - pivot.x;
      tmp.y = c.y - pivot.y;
      tmp._rotate(angle * Math.PI / 180);
      c.x = pivot.x + tmp.x;
      c.y = pivot.y + tmp.y;
      return c;
    };
  }()
};
var extended = extend$2(identity, common);

var Sphere = function () {
  function Sphere(radius) {
    this.radius = radius;
  }
  var _proto = Sphere.prototype;
  _proto.measureLenBetween = function measureLenBetween(c1, c2, ignoreAltitude = false) {
    if (!c1 || !c2) {
      return 0;
    }
    var b = toRadian(c1.y);
    var d = toRadian(c2.y),
      e = b - d,
      f = toRadian(c1.x) - toRadian(c2.x);
    b = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(e / 2), 2) + Math.cos(b) * Math.cos(d) * Math.pow(Math.sin(f / 2), 2)));
    b *= this.radius;
    var distance = b;
    if (ignoreAltitude) {
      return distance;
    }
    var z1 = c1.z || 0,
      z2 = c2.z || 0;
    var dz = z1 - z2;
    if (dz === 0) {
      return distance;
    }
    return Math.sqrt(distance * distance + dz * dz);
  };
  _proto.measureArea = function measureArea(coordinates) {
    var a = toRadian(this.radius);
    var b = 0;
    var c = coordinates;
    var d = c.length;
    if (d < 3) {
      return 0;
    }
    var i;
    for (i = 0; i < d - 1; i++) {
      var _e = c[i],
        _f = c[i + 1];
      b += _e.x * a * Math.cos(toRadian(_e.y)) * _f.y * a - _f.x * a * Math.cos(toRadian(_f.y)) * _e.y * a;
    }
    var e = c[i];
    var f = c[0];
    b += e.x * a * Math.cos(toRadian(e.y)) * f.y * a - f.x * a * Math.cos(toRadian(f.y)) * e.y * a;
    return 0.5 * Math.abs(b);
  };
  _proto.locate = function locate(c, xDist, yDist, out) {
    out = out || new Coordinate(0, 0);
    out.set(c.x, c.y);
    return this._locate(out, xDist, yDist);
  };
  _proto._locate = function _locate(c, xDist, yDist) {
    if (!c) {
      return null;
    }
    if (!xDist) {
      xDist = 0;
    }
    if (!yDist) {
      yDist = 0;
    }
    if (!xDist && !yDist) {
      return c;
    }
    var x, y;
    var ry = toRadian(c.y);
    if (yDist !== 0) {
      var dy = Math.abs(yDist);
      var sy = Math.sin(dy / (2 * this.radius)) * 2;
      ry = ry + sy * (yDist > 0 ? 1 : -1);
      y = wrap(ry * 180 / Math.PI, -90, 90);
    } else {
      y = c.y;
    }
    if (xDist !== 0) {
      var dx = Math.abs(xDist);
      var rx = toRadian(c.x);
      var sx = 2 * Math.sqrt(Math.pow(Math.sin(dx / (2 * this.radius)), 2) / Math.pow(Math.cos(ry), 2));
      rx = rx + sx * (xDist > 0 ? 1 : -1);
      x = wrap(rx * 180 / Math.PI, -180, 180);
    } else {
      x = c.x;
    }
    c.x = x;
    c.y = y;
    return c;
  };
  _proto.rotate = function rotate(c, pivot, angle) {
    var coordinate = new Coordinate(c);
    return this._rotate(coordinate, pivot, angle);
  };
  _proto._rotate = function _rotate(c, pivot, angle) {
    var initialAngle = rhumbBearing(pivot, c);
    var finalAngle = initialAngle - angle;
    var distance = this.measureLenBetween(pivot, c, true);
    c.x = pivot.x;
    c.y = pivot.y;
    return calculateRhumbDestination(c, distance, finalAngle, this.radius);
  };
  return Sphere;
}();
function rhumbBearing(start, end, options = {}) {
  var bear360;
  if (options["final"]) bear360 = calculateRhumbBearing(end, start);else bear360 = calculateRhumbBearing(start, end);
  return bear360 > 180 ? -(360 - bear360) : bear360;
}
function calculateRhumbBearing(from, to) {
  var phi1 = toRadian(from.y);
  var phi2 = toRadian(to.y);
  var deltaLambda = toRadian(to.x - from.x);
  if (deltaLambda > Math.PI) deltaLambda -= 2 * Math.PI;
  if (deltaLambda < -Math.PI) deltaLambda += 2 * Math.PI;
  var deltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
  var theta = Math.atan2(deltaLambda, deltaPsi);
  return (toDegree(theta) + 360) % 360;
}
function calculateRhumbDestination(origin, distance, bearing, radius) {
  var delta = distance / radius;
  var lambda1 = origin.x * Math.PI / 180;
  var phi1 = toRadian(origin.y);
  var theta = toRadian(bearing);
  var DeltaPhi = delta * Math.cos(theta);
  var phi2 = phi1 + DeltaPhi;
  if (Math.abs(phi2) > Math.PI / 2) phi2 = phi2 > 0 ? Math.PI - phi2 : -Math.PI - phi2;
  var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
  var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
  var DeltaLambda = delta * Math.sin(theta) / q;
  var lambda2 = lambda1 + DeltaLambda;
  origin.x = (lambda2 * 180 / Math.PI + 540) % 360 - 180;
  origin.y = phi2 * 180 / Math.PI;
  return origin;
}
var wgs84 = {
  'measure': 'EPSG:4326',
  sphere: new Sphere(6378137),
  measureLenBetween: function measureLenBetween(c1, c2) {
    return this.sphere.measureLenBetween(c1, c2);
  },
  measureArea: function measureArea(coordinates) {
    return this.sphere.measureArea.call(this.sphere, coordinates);
  },
  _locate: function _locate(c, xDist, yDist) {
    return this.sphere._locate.call(this.sphere, c, xDist, yDist);
  },
  locate: function locate(c, xDist, yDist, out) {
    return this.sphere.locate.call(this.sphere, c, xDist, yDist, out);
  },
  _rotate: function _rotate(c, pivot, angle) {
    return this.sphere._rotate.call(this.sphere, c, pivot, angle);
  },
  rotate: function rotate(c, pivot, angle) {
    return this.sphere.rotate.call(this.sphere, c, pivot, angle);
  }
};
var WGS84Sphere = extend$2(wgs84, common);
var baidu = {
  'measure': 'BAIDU',
  sphere: new Sphere(6370996.81),
  measureLenBetween: function measureLenBetween(c1, c2) {
    return this.sphere.measureLenBetween.call(this.sphere, c1, c2);
  },
  measureArea: function measureArea(coordinates) {
    return this.sphere.measureArea.call(this.sphere, coordinates);
  },
  _locate: function _locate(c, xDist, yDist) {
    return this.sphere._locate.call(this.sphere, c, xDist, yDist);
  },
  locate: function locate(c, xDist, yDist, out) {
    return this.sphere.locate.call(this.sphere, c, xDist, yDist, out);
  },
  _rotate: function _rotate(c, pivot, angle) {
    return this.sphere._rotate.call(this.sphere, c, pivot, angle);
  },
  rotate: function rotate(c, pivot, angle) {
    return this.sphere.rotate.call(this.sphere, c, pivot, angle);
  }
};
var BaiduSphere = extend$2(baidu, common);

var DEFAULT$1 = WGS84Sphere;
var measurers = {};
function registerMeasurer(m) {
  measurers[m.measure] = m;
}
registerMeasurer(extended);
registerMeasurer(WGS84Sphere);
registerMeasurer(BaiduSphere);
var Measurer = {
  getInstance: function getInstance(name) {
    if (!name) {
      return DEFAULT$1;
    }
    for (var p in measurers) {
      if (hasOwn(measurers, p)) {
        var mName = measurers[p]['measure'];
        if (!mName) {
          continue;
        }
        if (name.toLowerCase() === mName.toLowerCase()) {
          return measurers[p];
        }
      }
    }
    return null;
  }
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BaiduSphere: BaiduSphere,
  DEFAULT: DEFAULT$1,
  Identity: extended,
  Measurer: Measurer,
  WGS84Sphere: WGS84Sphere
});

var delta = 1E-7;
var EPSG3857Projection = {
  code: 'EPSG:3857',
  rad: Math.PI / 180,
  metersPerDegree: 6378137 * Math.PI / 180,
  maxLatitude: 85.0511287798,
  project: function project(lnglat, out) {
    var rad = this.rad,
      metersPerDegree = this.metersPerDegree,
      max = this.maxLatitude;
    var lng = lnglat.x,
      lat = Math.max(Math.min(max, lnglat.y), -max);
    var c;
    if (lat === 0) {
      c = 0;
    } else {
      c = Math.log(Math.tan((90 + lat) * rad / 2)) / rad;
    }
    var x = lng * metersPerDegree;
    var y = c * metersPerDegree;
    var z = lnglat.z;
    if (out) {
      out.x = x;
      out.y = y;
      out.z = z;
      return out;
    }
    return new Coordinate(x, y, z);
  },
  unproject: function unproject(pLnglat, out) {
    var rad = this.rad;
    var metersPerDegree = this.metersPerDegree;
    var x = pLnglat.x / metersPerDegree;
    var y = pLnglat.y;
    var c;
    if (y === 0) {
      c = 0;
    } else {
      c = y / metersPerDegree;
      c = (2 * Math.atan(Math.exp(c * rad)) - Math.PI / 2) / rad;
    }
    if (Math.abs(Math.abs(x) - 180) < delta) {
      x = sign(x) * 180;
    }
    if (Math.abs(Math.abs(c) - this.maxLatitude) < delta) {
      c = sign(c) * this.maxLatitude;
    }
    var rx = x;
    var ry = c;
    var rz = pLnglat.z;
    if (out) {
      out.x = rx;
      out.y = ry;
      out.z = rz;
      return out;
    }
    return new Coordinate(rx, ry, rz);
  }
};
var EPSG3857 = extend$2({}, CommonProjection, EPSG3857Projection, WGS84Sphere);

var EPSG4326Projection = {
  code: 'EPSG:4326',
  aliases: ['EPSG:4490'],
  project: function project(p, out) {
    if (out) {
      out.x = p.x;
      out.y = p.y;
      out.z = p.z;
      return out;
    }
    return new Coordinate(p);
  },
  unproject: function unproject(p, out) {
    if (out) {
      out.x = p.x;
      out.y = p.y;
      out.z = p.z;
      return out;
    }
    return new Coordinate(p);
  }
};
var Projection_EPSG4326 = extend$2({}, CommonProjection, EPSG4326Projection, WGS84Sphere);

var fabs = Math.abs,
  sin = Math.sin,
  cos = Math.cos,
  tan = Math.tan,
  atan = Math.atan,
  atan2 = Math.atan2,
  sqrt = Math.sqrt,
  log = Math.log,
  hypot = Math.hypot,
  sinh = Math.sinh,
  cosh = Math.cosh;
var HUGE_VAL = Infinity;
function pj_etmerc(P) {
  var cgb = [],
    cbg = [],
    utg = [],
    gtu = [],
    Qn,
    Zb,
    f,
    n,
    np,
    Z;
  if (P.es <= 0) ;
  f = P.es / (1 + sqrt(1 - P.es));
  np = n = f / (2 - f);
  cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
  cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
  np *= n;
  cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
  cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
  np *= n;
  cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
  cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));
  np *= n;
  cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
  cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * (-24832 / 14175)));
  np *= n;
  cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
  cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
  np *= n;
  cgb[5] = np * (601676 / 22275);
  cbg[5] = np * (444337 / 155925);
  np = n * n;
  Qn = P.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
  utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
  gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
  utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
  gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
  np *= n;
  utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
  gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
  np *= n;
  utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
  gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
  np *= n;
  utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
  gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
  np *= n;
  utg[5] = np * (-20648693 / 638668800);
  gtu[5] = np * (212378941 / 319334400);
  Z = gatg(cbg, P.phi0);
  Zb = -Qn * (Z + clens(gtu, 2 * Z));
  P.fwd = e_fwd;
  P.inv = e_inv;
  function e_fwd(lp, xy) {
    var sin_Cn, cos_Cn, cos_Ce, sin_Ce, tmp;
    var Cn = lp.phi,
      Ce = lp.lam;
    Cn = gatg(cbg, Cn);
    sin_Cn = sin(Cn);
    cos_Cn = cos(Cn);
    sin_Ce = sin(Ce);
    cos_Ce = cos(Ce);
    Cn = atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
    Ce = asinhy(tan(Ce));
    tmp = clenS(gtu, 2 * Cn, 2 * Ce);
    Cn += tmp[0];
    Ce += tmp[1];
    if (fabs(Ce) <= 2.623395162778) {
      xy.y = Qn * Cn + Zb;
      xy.x = Qn * Ce;
    } else {
      xy.x = xy.y = HUGE_VAL;
    }
  }
  function e_inv(xy, lp) {
    var sin_Cn, cos_Cn, cos_Ce, sin_Ce, tmp;
    var Cn = xy.y,
      Ce = xy.x;
    Cn = (Cn - Zb) / Qn;
    Ce = Ce / Qn;
    if (fabs(Ce) <= 2.623395162778) {
      tmp = clenS(utg, 2 * Cn, 2 * Ce);
      Cn += tmp[0];
      Ce += tmp[1];
      Ce = atan(sinh(Ce));
      sin_Cn = sin(Cn);
      cos_Cn = cos(Cn);
      sin_Ce = sin(Ce);
      cos_Ce = cos(Ce);
      Ce = atan2(sin_Ce, cos_Ce * cos_Cn);
      Cn = atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
      lp.phi = gatg(cgb, Cn);
      lp.lam = Ce;
    } else {
      lp.phi = lp.lam = HUGE_VAL;
    }
  }
  function log1py(x) {
    var y = 1 + x,
      z = y - 1;
    return z === 0 ? x : x * log(y) / z;
  }
  function asinhy(x) {
    var y = fabs(x);
    y = log1py(y * (1 + y / (hypot(1, y) + 1)));
    return x < 0 ? -y : y;
  }
  function gatg(pp, B) {
    var cos_2B = 2 * cos(2 * B),
      i = pp.length - 1,
      h1 = pp[i],
      h2 = 0,
      h;
    while (--i >= 0) {
      h = -h2 + cos_2B * h1 + pp[i];
      h2 = h1;
      h1 = h;
    }
    return B + h * sin(2 * B);
  }
  function clens(pp, arg_r) {
    var r = 2 * cos(arg_r),
      i = pp.length - 1,
      hr1 = pp[i],
      hr2 = 0,
      hr;
    while (--i >= 0) {
      hr = -hr2 + r * hr1 + pp[i];
      hr2 = hr1;
      hr1 = hr;
    }
    return sin(arg_r) * hr;
  }
  function clenS(pp, arg_r, arg_i) {
    var sin_arg_r = sin(arg_r),
      cos_arg_r = cos(arg_r),
      sinh_arg_i = sinh(arg_i),
      cosh_arg_i = cosh(arg_i),
      r = 2 * cos_arg_r * cosh_arg_i,
      i = -2 * sin_arg_r * sinh_arg_i,
      j = pp.length - 1,
      hr = pp[j],
      hi1 = 0,
      hr1 = 0,
      hi = 0,
      hr2,
      hi2;
    while (--j >= 0) {
      hr2 = hr1;
      hi2 = hi1;
      hr1 = hr;
      hi1 = hi;
      hr = -hr2 + r * hr1 - i * hi1 + pp[j];
      hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [r * hr - i * hi, r * hi + i * hr];
  }
}

var RAD_TO_DEG = 57.295779513082321,
  DEG_TO_RAD = 0.017453292519943296;
var SRS_WGS84_SEMIMAJOR = 6378137;
var SRS_WGS84_ESQUARED = 0.0066943799901413165;
var aliases = ['Traverse_Mercator'];
var EPSG9807Projection = {
  code: 'EPSG:9807',
  aliases: aliases,
  centralMeridian: 0,
  create: function create(params) {
    var P = {
      a: SRS_WGS84_SEMIMAJOR,
      es: SRS_WGS84_ESQUARED,
      x0: isNil(params.falseEasting) ? 500000 : params.falseEasting,
      y0: isNil(params.falseNorthing) ? 0 : params.falseNorthing,
      k0: params.scaleFactor || 0.9996,
      lam0: (params.centralMeridian || 0) * DEG_TO_RAD,
      phi0: (params.latitudeOfOrigin || 0) * DEG_TO_RAD,
      originLam0: params.startLongtitude || 0,
      originPhi0: params.startLatitude || 0
    };
    pj_etmerc(P);
    var lp = {
      lam: 0,
      phi: 0
    };
    var xy = {};
    var originX = 0;
    var originY = 0;
    if (P.originLam0 || P.originPhi0) {
      lp.lam = P.originLam0 * DEG_TO_RAD - P.lam0;
      lp.phi = P.originPhi0 * DEG_TO_RAD;
      P.fwd(lp, xy);
      originX = P.a * xy.x + P.x0;
      originY = P.a * xy.y + P.y0;
    }
    var methods = {
      code: 'EPSG:9807',
      aliases: aliases,
      centralMeridian: params.centralMeridian,
      project: function project(p, out) {
        lp.lam = p.x * DEG_TO_RAD - P.lam0;
        lp.phi = p.y * DEG_TO_RAD;
        P.fwd(lp, xy);
        var x = P.a * xy.x + P.x0 - originX;
        var y = P.a * xy.y + P.y0 - originY;
        var z = p.z;
        if (out) {
          out.x = x;
          out.y = y;
          out.z = z;
          return out;
        }
        return new Coordinate(x, y, z);
      },
      unproject: function unproject(p, out) {
        xy.x = (p.x - P.x0 + originX) / P.a;
        xy.y = (p.y - P.y0 + originY) / P.a;
        P.inv(xy, lp);
        var x = (lp.lam + P.lam0) * RAD_TO_DEG;
        var y = lp.phi * RAD_TO_DEG;
        var z = p.z;
        if (out) {
          out.x = x;
          out.y = y;
          out.z = z;
          return out;
        }
        return new Coordinate(x, y, z);
      }
    };
    return extend$2({}, CommonProjection, methods, WGS84Sphere);
  }
};
var EPSG9807 = extend$2({}, CommonProjection, EPSG9807Projection);

var UTMProjection = {
  code: 'utm',
  aliases: [],
  create: function create(params) {
    var P = {};
    var zone = parseInt(params.zone);
    P.falseNorthing = params.south ? 10000000 : 0;
    P.falseEasting = 500000;
    if (zone > 0 && zone <= 60) {
      zone--;
    } else {
      throw new Error('zone must be > 0 and <= 60.');
    }
    P.centralMeridian = (zone + 0.5) * 6 - 180;
    P.scaleFactor = 0.9996;
    return EPSG9807.create(P);
  }
};
var Projection_UTM = extend$2({}, EPSG9807, UTMProjection);

var ProjectionMethods = {
  EARTHRADIUS: 6370996.81,
  MCBAND: [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0],
  LLBAND: [75, 60, 45, 30, 15, 0],
  MC2LL: [[1.410526172116255e-8, 0.00000898305509648872, -1.9939833816331, 200.9824383106796, -187.2403703815547, 91.6087516669843, -23.38765649603339, 2.57121317296198, -0.03801003308653, 17337981.2], [-7.435856389565537e-9, 0.000008983055097726239, -0.78625201886289, 96.32687599759846, -1.85204757529826, -59.36935905485877, 47.40033549296737, -16.50741931063887, 2.28786674699375, 10260144.86], [-3.030883460898826e-8, 0.00000898305509983578, 0.30071316287616, 59.74293618442277, 7.357984074871, -25.38371002664745, 13.45380521110908, -3.29883767235584, 0.32710905363475, 6856817.37], [-1.981981304930552e-8, 0.000008983055099779535, 0.03278182852591, 40.31678527705744, 0.65659298677277, -4.44255534477492, 0.85341911805263, 0.12923347998204, -0.04625736007561, 4482777.06], [3.09191371068437e-9, 0.000008983055096812155, 0.00006995724062, 23.10934304144901, -0.00023663490511, -0.6321817810242, -0.00663494467273, 0.03430082397953, -0.00466043876332, 2555164.4], [2.890871144776878e-9, 0.000008983055095805407, -3.068298e-8, 7.47137025468032, -0.00000353937994, -0.02145144861037, -0.00001234426596, 0.00010322952773, -0.00000323890364, 826088.5]],
  LL2MC: [[-0.0015702102444, 111320.7020616939, 1704480524535203, -10338987376042340, 26112667856603880, -35149669176653700, 26595700718403920, -10725012454188240, 1800819912950474, 82.5], [0.0008277824516172526, 111320.7020463578, 647795574.6671607, -4082003173.641316, 10774905663.51142, -15171875531.51559, 12053065338.62167, -5124939663.577472, 913311935.9512032, 67.5], [0.00337398766765, 111320.7020202162, 4481351.045890365, -23393751.19931662, 79682215.47186455, -115964993.2797253, 97236711.15602145, -43661946.33752821, 8477230.501135234, 52.5], [0.00220636496208, 111320.7020209128, 51751.86112841131, 3796837.749470245, 992013.7397791013, -1221952.21711287, 1340652.697009075, -620943.6990984312, 144416.9293806241, 37.5], [-0.0003441963504368392, 111320.7020576856, 278.2353980772752, 2485758.690035394, 6070.750963243378, 54821.18345352118, 9540.606633304236, -2710.55326746645, 1405.483844121726, 22.5], [-0.0003218135878613132, 111320.7020701615, 0.00369383431289, 823725.6402795718, 0.46104986909093, 2351.343141331292, 1.58060784298199, 8.77738589078284, 0.37238884252424, 7.45]],
  convertMC2LL: function convertMC2LL(cB, out) {
    var cE;
    for (var cD = 0, len = this.MCBAND.length; cD < len; cD++) {
      if (Math.abs(cB.y) >= this.MCBAND[cD]) {
        cE = this.MC2LL[cD];
        break;
      }
    }
    var T = this.convertor(cB, cE, out);
    return T;
  },
  convertLL2MC: function convertLL2MC(T, out) {
    var cD, cC, len;
    T.x = this.getLoop(T.x, -180, 180);
    T.y = this.getRange(T.y, -74, 74);
    var cB = new Coordinate(T.x, T.y);
    for (cC = 0, len = this.LLBAND.length; cC < len; cC++) {
      if (cB.y >= this.LLBAND[cC]) {
        cD = this.LL2MC[cC];
        break;
      }
    }
    if (!cD) {
      for (cC = this.LLBAND.length - 1; cC >= 0; cC--) {
        if (cB.y <= -this.LLBAND[cC]) {
          cD = this.LL2MC[cC];
          break;
        }
      }
    }
    var cE = this.convertor(T, cD, out);
    return cE;
  },
  convertor: function convertor(cC, cD, out) {
    if (!cC || !cD) {
      return null;
    }
    var T = cD[0] + cD[1] * Math.abs(cC.x);
    var cB = Math.abs(cC.y) / cD[9];
    var cE = cD[2] + cD[3] * cB + cD[4] * cB * cB + cD[5] * cB * cB * cB + cD[6] * cB * cB * cB * cB + cD[7] * cB * cB * cB * cB * cB + cD[8] * cB * cB * cB * cB * cB * cB;
    T *= cC.x < 0 ? -1 : 1;
    cE *= cC.y < 0 ? -1 : 1;
    var z = cC.z;
    if (out) {
      out.x = T;
      out.y = cE;
      out.z = z;
      return out;
    }
    return new Coordinate(T, cE, z);
  },
  toRadians: function toRadians(T) {
    return Math.PI * T / 180;
  },
  toDegrees: function toDegrees(T) {
    return 180 * T / Math.PI;
  },
  getRange: function getRange(cC, cB, T) {
    if (cB != null) {
      cC = Math.max(cC, cB);
    }
    if (T != null) {
      cC = Math.min(cC, T);
    }
    return cC;
  },
  getLoop: function getLoop(cC, cB, T) {
    if (cC === Infinity) {
      return T;
    } else if (cC === -Infinity) {
      return cB;
    }
    while (cC > T) {
      cC -= T - cB;
    }
    while (cC < cB) {
      cC += T - cB;
    }
    return cC;
  }
};
var BAIDUProjection = {
  code: 'BAIDU',
  project: function project(p, out) {
    return this.convertLL2MC(p, out);
  },
  unproject: function unproject(p, out) {
    return this.convertMC2LL(p, out);
  }
};
var Projection_Baidu = extend$2({}, CommonProjection, BAIDUProjection, BaiduSphere, ProjectionMethods);

var IdentityProjection = {
  code: 'IDENTITY',
  project: function project(p, out) {
    if (out) {
      out.x = p.x;
      out.y = p.y;
      out.z = p.z;
      return out;
    }
    return p.copy();
  },
  unproject: function unproject(p, out) {
    if (out) {
      out.x = p.x;
      out.y = p.y;
      out.z = p.z;
      return out;
    }
    return p.copy();
  }
};
var Projection_IDENTITY = extend$2({}, CommonProjection, IdentityProjection, extended);

var DEFAULT = EPSG3857;

var projections = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BAIDU: Projection_Baidu,
  Common: CommonProjection,
  DEFAULT: DEFAULT,
  EPSG3857: EPSG3857,
  EPSG4326: Projection_EPSG4326,
  EPSG9807: EPSG9807,
  IDENTITY: Projection_IDENTITY,
  UTM: Projection_UTM
});

function Renderable (Base) {
  return function (_Base) {
    function _class() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(_class, _Base);
    _class.registerRenderer = function registerRenderer(name, clazz) {
      var proto = this.prototype;
      var parentProto = Object.getPrototypeOf(proto);
      if (!proto._rendererClasses || proto._rendererClasses === parentProto._rendererClasses) {
        proto._rendererClasses = proto._rendererClasses ? Object.create(proto._rendererClasses) : {};
      }
      proto._rendererClasses[name.toLowerCase()] = clazz;
      return this;
    };
    _class.getRendererClass = function getRendererClass(name) {
      var proto = this.prototype;
      if (!proto._rendererClasses) {
        return null;
      }
      return proto._rendererClasses[name.toLowerCase()];
    };
    return _class;
  }(Base);
}

var DEFAULT_MARKER_SYMBOLS = {
  markerWidth: 10,
  markerHeight: 10,
  markerLineWidth: 1
};
var TEMP_DXDYPOINT = new Point(0, 0);
function getDxDyRad(dxdy) {
  if (!dxdy) {
    return 0;
  }
  var {
    x: x,
    y: y
  } = dxdy;
  if (x === 0 && y === 0) {
    return 0;
  }
  if (x === 0 || !x) {
    if (y < 0) {
      return -Math.PI / 2;
    }
    if (y > 0) {
      return Math.PI / 2;
    }
  }
  var tan = y / x;
  if (y < 0 && x < 0) {
    return Math.atan(tan) - Math.PI;
  } else if (y > 0 && x < 0) {
    return Math.atan(tan) + Math.PI;
  }
  return Math.atan(tan);
}
function getImageRotateBBOX(width, height, rad) {
  var rad2 = Math.PI / 2 + rad;
  var rad3 = Math.PI / 4 + rad;
  var rad4 = rad;
  var r2 = height;
  var r3 = Math.sqrt(width * width + height * height);
  var r4 = width;
  var p1x = 0,
    p1y = 0;
  var p2x = Math.cos(rad2) * r2,
    p2y = Math.sin(rad2) * r2;
  var p3x = Math.cos(rad3) * r3,
    p3y = Math.sin(rad3) * r3;
  var p4x = Math.cos(rad4) * r4,
    p4y = Math.sin(rad4) * r4;
  var minx = Math.min(p2x, p3x, p4x, p1x);
  var miny = Math.min(p2y, p3y, p4y, p1y);
  var maxx = Math.max(p2x, p3x, p4x, p1x);
  var maxy = Math.max(p2y, p3y, p4y, p1y);
  return [minx, miny, maxx - minx, maxy - miny];
}
function getMarkerRotationExtent(out, rad, width, height, dxdy, alignPoint) {
  var x = dxdy.x + alignPoint.x,
    y = dxdy.y + alignPoint.y;
  TEMP_DXDYPOINT.x = x;
  TEMP_DXDYPOINT.y = y;
  var dxdyRad = getDxDyRad(TEMP_DXDYPOINT);
  var radius = Math.sqrt(x * x + y * y);
  var rx = Math.cos(rad + dxdyRad) * radius,
    ry = Math.sin(rad + dxdyRad) * radius;
  var minx = 0,
    miny = 0;
  minx += rx;
  miny += ry;
  var [offsetX, offsetY, w, h] = getImageRotateBBOX(width, height, rad);
  minx += offsetX;
  miny += offsetY;
  var maxx = minx + Math.max(width, w),
    maxy = miny + Math.max(height, h);
  out.set(minx, miny, maxx, maxy);
  return out;
}
function getVectorPadding() {
  return 0.5;
}
var DXDY = new Point(0, 0);
function getFixedExtent(out, dx, dy, rotation, alignPoint, w, h) {
  var dxdy = DXDY.set(dx, dy);
  if (rotation) {
    return getMarkerRotationExtent(out, rotation, w, h, dxdy, alignPoint);
  }
  var result = out.set(dxdy.x, dxdy.y, dxdy.x + w, dxdy.y + h);
  result._add(alignPoint);
  if (rotation) {
    rotateExtent(result, rotation);
  }
  return result;
}
var SIZE = [];
function getVectorMarkerFixedExtent(out, symbol, size) {
  size = size || calVectorMarkerSize(SIZE, symbol);
  if (size && (size[0] === 0 || size[1] === 0)) {
    emptyExtent(out);
    return out;
  }
  var alignPoint = getVectorMarkerAnchor(symbol, size[0], size[1]);
  return getFixedExtent(out, symbol['markerDx'] || 0, symbol['markerDy'] || 0, getMarkerRotation(symbol), alignPoint, size[0], size[1]);
}
function getDefaultHAlign(markerType) {
  if (markerType === 'rectangle' || markerType === 'roundrectangle') {
    return 'right';
  } else {
    return 'middle';
  }
}
function getDefaultVAlign(markerType) {
  if (markerType === 'bar' || markerType === 'pie' || markerType === 'pin') {
    return 'top';
  } else if (markerType === 'rectangle' || markerType === 'roundrectangle') {
    return 'bottom';
  } else {
    return 'middle';
  }
}
var TEMP_SIZE$1 = new Size(0, 0);
function getVectorMarkerAnchor(symbol, w, h) {
  var padding = getVectorPadding();
  var shadow = 2 * (symbol['shadowBlur'] || 0),
    margin = shadow + padding;
  TEMP_SIZE$1.width = w;
  TEMP_SIZE$1.height = h;
  var markerType = symbol['markerType'];
  var p = getAlignPoint(TEMP_SIZE$1, symbol['markerHorizontalAlignment'] || getDefaultHAlign(markerType), symbol['markerVerticalAlignment'] || getDefaultVAlign(markerType));
  if (p.x !== -w / 2) {
    p.x -= sign(p.x + w / 2) * margin;
  }
  if (p.y !== -h / 2) {
    p.y -= sign(p.y + h / 2) * margin;
  }
  return p;
}
function calVectorMarkerSize(out, symbol) {
  var padding = getVectorPadding();
  var width = getValueOrDefault(symbol['markerWidth'], DEFAULT_MARKER_SYMBOLS.markerWidth);
  var height = getValueOrDefault(symbol['markerHeight'], DEFAULT_MARKER_SYMBOLS.markerHeight);
  if (width === 0 || height === 0) {
    out[0] = 0;
    out[1] = 0;
    return out;
  }
  var lineWidth = getValueOrDefault(symbol['markerLineWidth'], DEFAULT_MARKER_SYMBOLS.markerLineWidth),
    shadow = 2 * ((symbol['shadowBlur'] || 0) + Math.max(Math.abs(symbol['shadowOffsetX'] || 0) + Math.abs(symbol['shadowOffsetY'] || 0))),
    w = Math.round(width + lineWidth + shadow + padding * 2),
    h = Math.round(height + lineWidth + shadow + padding * 2);
  out[0] = w;
  out[1] = h;
  return out;
}
var ROTATE_EXTENT = new PointExtent();
function rotateExtent(fixedExtent, angle) {
  var {
    xmin: xmin,
    ymin: ymin,
    xmax: xmax,
    ymax: ymax
  } = fixedExtent;
  ROTATE_EXTENT.set(xmin, ymin, xmax, ymax);
  return ROTATE_EXTENT.convertTo(function (p) {
    return p._rotate(angle);
  }, fixedExtent);
}
function getMarkerRotation(symbol, prop = 'markerRotation') {
  var r = symbol[prop];
  if (!isNumber(r)) {
    return 0;
  }
  return -r * Math.PI / 180;
}
function getImageMarkerFixedExtent(out, symbol, resources) {
  var url = symbol['markerFile'],
    img = resources ? resources.getImage(url) : null;
  var width = symbol['markerWidth'] || (img ? img.width : 0),
    height = symbol['markerHeight'] || (img ? img.height : 0);
  TEMP_SIZE$1.width = width;
  TEMP_SIZE$1.height = height;
  if (symbol['markerWidth'] === 0 || symbol['markerHeight'] === 0) {
    emptyExtent(out);
    return out;
  }
  var alignPoint = getAlignPoint(TEMP_SIZE$1, symbol['markerHorizontalAlignment'] || 'middle', symbol['markerVerticalAlignment'] || 'top');
  return getFixedExtent(out, symbol['markerDx'] || 0, symbol['markerDy'] || 0, getMarkerRotation(symbol), alignPoint, width, height);
}
function getTextMarkerFixedExtent(out, symbol, textDesc) {
  var size = textDesc['size'];
  if (size && (size.width === 0 || size.height === 0)) {
    emptyExtent(out);
    return out;
  }
  var alignPoint = getAlignPoint(size, symbol['textHorizontalAlignment'], symbol['textVerticalAlignment']);
  var textHaloRadius = symbol.textHaloRadius || 0;
  var extent = getFixedExtent(out, symbol['textDx'] || 0, symbol['textDy'] || 0, getMarkerRotation(symbol, 'textRotation'), alignPoint, size.width, size.height);
  extent.xmin -= textHaloRadius;
  extent.xmax += textHaloRadius;
  extent.ymin -= textHaloRadius;
  extent.ymax += textHaloRadius;
  return extent;
}
var FIXED_EXTENT = new PointExtent();
function getMarkerFixedExtent(out, symbol, resources, textDesc) {
  var extent = out || new PointExtent();
  if (Array.isArray(symbol)) {
    var symbols = symbol;
    for (var i = 0; i < symbols.length; i++) {
      getMarkerFixedExtent(extent, symbols[i], resources, textDesc[i]);
    }
    return extent;
  }
  if (isTextSymbol(symbol)) {
    extent._combine(getTextMarkerFixedExtent(FIXED_EXTENT, symbol, textDesc));
  }
  if (isImageSymbol(symbol)) {
    extent._combine(getImageMarkerFixedExtent(FIXED_EXTENT, symbol, resources));
  }
  if (isVectorSymbol(symbol)) {
    extent._combine(getVectorMarkerFixedExtent(FIXED_EXTENT, symbol));
  }
  if (isPathSymbol(symbol)) {
    extent._combine(getImageMarkerFixedExtent(FIXED_EXTENT, symbol));
  }
  return extent;
}
function isTextSymbol(symbol) {
  if (!symbol) {
    return false;
  }
  if (!isNil(symbol['textName'])) {
    return true;
  }
  return false;
}
function isImageSymbol(symbol) {
  if (!symbol) {
    return false;
  }
  if (!isNil(symbol['markerFile'])) {
    return true;
  }
  return false;
}
function isVectorSymbol(symbol) {
  if (!symbol) {
    return false;
  }
  if (isNil(symbol['markerFile']) && !isNil(symbol['markerType']) && symbol['markerType'] !== 'path') {
    return true;
  }
  return false;
}
function isPathSymbol(symbol) {
  if (!symbol) {
    return false;
  }
  if (isNil(symbol['markerFile']) && symbol['markerType'] === 'path') {
    return true;
  }
  return false;
}
var DYNAMIC_SYMBOL_PROPS = ['markerWidth', 'markerHeight', 'markerHorizontalAlignment', 'markerVerticalAlignment', 'markerDx', 'markerDy', 'markerRotation', 'textName', 'textSize', 'textDx', 'textDy', 'textVerticalAlignment', 'textHorizontalAlignment', 'textRotation', 'textWrapWidth'];
var SIZE_SYMBOL_PROPS = ['textName', 'markerType', 'markerFile', 'textHaloRadius', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textWrapWidth'];
function emptyExtent(extent) {
  if (!extent) {
    return;
  }
  extent.xmin = Infinity;
  extent.ymin = Infinity;
  extent.xmax = -Infinity;
  extent.ymax = -Infinity;
}

function clipLine(points, bounds, round, noCut) {
  var min = bounds.getMin(),
    max = bounds.getMax();
  var parts = [];
  var k = 0,
    segment;
  for (var j = 0, l = points.length; j < l - 1; j++) {
    segment = clipSegment(points[j], points[j + 1], min, max, j, round, noCut);
    if (!segment) {
      continue;
    }
    parts[k] = parts[k] || [];
    parts[k].push({
      'point': segment[0],
      'index': j
    });
    if (segment[1] !== points[j + 1] || j === l - 2) {
      parts[k].push({
        'point': segment[1],
        'index': j + 1
      });
      k++;
    }
  }
  return parts;
}
var _lastCode;
function clipSegment(a, b, min, max, useLastCode, round, noCut) {
  var codeA = useLastCode ? _lastCode : _getBitCode(a, min, max),
    codeB = _getBitCode(b, min, max),
    codeOut,
    p,
    newCode;
  _lastCode = codeB;
  while (true) {
    if (!(codeA | codeB)) {
      return [a, b];
    }
    if (codeA & codeB) {
      return false;
    }
    if (noCut) {
      return [a, b];
    }
    codeOut = codeA || codeB;
    p = _getEdgeIntersection(a, b, codeOut, min, max, round);
    newCode = _getBitCode(p, min, max);
    if (codeOut === codeA) {
      a = p;
      codeA = newCode;
    } else {
      b = p;
      codeB = newCode;
    }
  }
}
function clipPolygon(points, bounds, round) {
  var edges = [1, 4, 2, 8];
  var clippedPoints, i, j, k, a, b, len, edge, p;
  var min = bounds.getMin(),
    max = bounds.getMax();
  for (i = 0, len = points.length; i < len; i++) {
    points[i]._code = _getBitCode(points[i], min, max);
  }
  for (k = 0; k < 4; k++) {
    edge = edges[k];
    clippedPoints = [];
    for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
      a = points[i];
      b = points[j];
      if (!(a._code & edge)) {
        if (b._code & edge) {
          p = _getEdgeIntersection(b, a, edge, min, max, round);
          p._code = _getBitCode(p, min, max);
          clippedPoints.push(p);
        }
        clippedPoints.push(a);
      } else if (!(b._code & edge)) {
        p = _getEdgeIntersection(b, a, edge, min, max, round);
        p._code = _getBitCode(p, min, max);
        clippedPoints.push(p);
      }
    }
    points = clippedPoints;
  }
  return points;
}
function _getEdgeIntersection(a, b, code, min, max, round) {
  var dx = b.x - a.x,
    dy = b.y - a.y;
  var x, y;
  if (code & 8) {
    x = a.x + dx * (max.y - a.y) / dy;
    y = max.y;
  } else if (code & 4) {
    x = a.x + dx * (min.y - a.y) / dy;
    y = min.y;
  } else if (code & 2) {
    x = max.x;
    y = a.y + dy * (max.x - a.x) / dx;
  } else if (code & 1) {
    x = min.x;
    y = a.y + dy * (min.x - a.x) / dx;
  }
  var p = new Point(x, y);
  if (round) {
    p._round();
  }
  return p;
}
function _getBitCode(p, min, max) {
  var code = 0;
  if (p.x < min.x) {
    code |= 1;
  } else if (p.x > max.x) {
    code |= 2;
  }
  if (p.y < min.y) {
    code |= 4;
  } else if (p.y > max.y) {
    code |= 8;
  }
  return code;
}
function withInEllipse(point, center, southeast, tolerance) {
  point = new Point(point);
  var a = Math.abs(southeast.x - center.x),
    b = Math.abs(southeast.y - center.y),
    c = Math.sqrt(Math.abs(a * a - b * b)),
    xfocus = a >= b;
  var f1, f2, d;
  if (xfocus) {
    f1 = new Point(center.x - c, center.y);
    f2 = new Point(center.x + c, center.y);
    d = a * 2;
  } else {
    f1 = new Point(center.x, center.y - c);
    f2 = new Point(center.x, center.y + c);
    d = b * 2;
  }
  return point.distanceTo(f1) + point.distanceTo(f2) <= d + 2 * tolerance;
}
function getMinMaxAltitude(altitude) {
  if (!altitude) {
    return [0, 0];
  }
  var min = Infinity,
    max = -Infinity;
  if (isNumber(altitude)) {
    min = max = altitude;
    return [min, max];
  }
  var pathMinMax = function pathMinMax(alts) {
    for (var i = 0, len = alts.length; i < len; i++) {
      var alt = alts[i];
      min = Math.min(min, alt);
      max = Math.max(max, alt);
    }
  };
  if (!Array.isArray(altitude[0])) {
    pathMinMax(altitude);
    return [min, max];
  }
  if (!Array.isArray(altitude[0][0])) {
    for (var i = 0, len = altitude.length; i < len; i++) {
      var alts = altitude[i];
      pathMinMax(alts);
    }
    return [min, max];
  }
  for (var _i = 0, _len = altitude.length; _i < _len; _i++) {
    var _alts = altitude[_i];
    for (var j = 0, len1 = _alts.length; j < len1; j++) {
      var alt = _alts[j];
      pathMinMax(alt);
    }
  }
  return [min, max];
}
function pointLeftSegment(p, p1, p2) {
  var x1 = p1.x,
    y1 = p1.y;
  var x2 = p2.x,
    y2 = p2.y;
  var x = p.x,
    y = p.y;
  return (y1 - y2) * x + (x2 - x1) * y + x1 * y2 - x2 * y1 > 0;
}
function pointRightSegment(p, p1, p2) {
  return !pointLeftSegment(p, p1, p2);
}
function pointInQuadrilateral(p, LT, RT, RB, LB) {
  var a = pointRightSegment(p, LT, RT);
  var b = pointRightSegment(p, RT, RB);
  var c = pointRightSegment(p, RB, LB);
  var d = pointRightSegment(p, LB, LT);
  return a && b && c && d;
}
function lineIntersection(p1, p2, p3, p4) {
  var dx1 = p2.x - p1.x,
    dy1 = p2.y - p1.y;
  var dx2 = p4.x - p3.x,
    dy2 = p4.y - p3.y;
  if (dx1 === 0 && dx2 === 0) {
    return null;
  }
  if (dy1 === 0 && dy2 === 0) {
    return null;
  }
  var k1 = dy1 / dx1;
  var k2 = dy2 / dx2;
  if (Math.abs(k1) === Math.abs(k2)) {
    return null;
  }
  var b1 = p1.y - k1 * p1.x;
  var b2 = p3.y - k2 * p3.x;
  var x, y;
  if (dx1 === 0) {
    x = p1.x;
    y = k2 * x + b2;
  } else if (dx2 === 0) {
    x = p3.x;
    y = k1 * x + b1;
  } else if (dy1 === 0) {
    y = p1.y;
    x = (y - b2) / k2;
  } else if (dy2 === 0) {
    y = p3.y;
    x = (y - b1) / k1;
  } else {
    x = (b2 - b1) / (k1 - k2);
    y = k1 * x + b1;
  }
  return new Point(x, y);
}
function altitudesHasData(altitudes) {
  if (isNumber(altitudes)) {
    return altitudes !== 0;
  } else if (Array.isArray(altitudes) && altitudes.length > 0) {
    for (var i = 0, len = altitudes.length; i < len; i++) {
      if (isNumber(altitudes[i]) && altitudes[i] !== 0) {
        return true;
      }
    }
  }
  return false;
}

var Symbolizer = function () {
  function Symbolizer() {
    this.bbox = getDefaultBBOX();
  }
  var _proto = Symbolizer.prototype;
  _proto._setBBOX = function _setBBOX(ctx, x1, y1, x2, y2) {
    if (!ctx.isHitTesting) {
      setBBOX(this.bbox, x1, y1, x2, y2);
    }
    return this;
  };
  _proto._bufferBBOX = function _bufferBBOX(ctx, bufferSize) {
    if (!ctx.isHitTesting) {
      bufferBBOX(this.bbox, bufferSize);
    }
    return this;
  };
  _proto.getMap = function getMap() {
    return this.geometry.getMap();
  };
  _proto.getPainter = function getPainter() {
    return this.painter;
  };
  _proto.isDynamicSize = function isDynamicSize() {
    return false;
  };
  _proto.isVisible = function isVisible() {
    if (!this.style) {
      return true;
    }
    var visible = this.style.visible;
    if (visible === false || visible === 0) {
      return false;
    }
    var opacity = this.style.opacity;
    if (opacity <= 0) {
      return false;
    }
    return true;
  };
  Symbolizer.testColor = function testColor(prop) {
    if (!prop || !isString(prop)) {
      return false;
    }
    if (COLOR_PROPERTIES.indexOf(prop) >= 0) {
      return true;
    }
    return false;
  };
  return Symbolizer;
}();

var CanvasSymbolizer = function (_Symbolizer) {
  function CanvasSymbolizer() {
    return _Symbolizer.apply(this, arguments) || this;
  }
  _inheritsLoose(CanvasSymbolizer, _Symbolizer);
  var _proto = CanvasSymbolizer.prototype;
  _proto._prepareContext = function _prepareContext(ctx) {
    if (isFunctionDefinition(this.symbol['opacity'])) {
      if (!this._opacityFn) {
        this._opacityFn = interpolated(this.symbol['opacity']);
      }
    } else {
      delete this._opacityFn;
    }
    if (isNumber(this.symbol['opacity'])) {
      if (ctx.globalAlpha !== this.symbol['opacity']) {
        ctx.globalAlpha = this.symbol['opacity'];
      }
    } else if (this._opacityFn) {
      var map = this.getMap();
      var cache = MapStateCache[map.id];
      var zoom = cache ? cache.zoom : map.getZoom();
      ctx.globalAlpha = this._opacityFn(zoom);
    } else if (ctx.globalAlpha !== 1) {
      ctx.globalAlpha = 1;
    }
  };
  _proto.prepareCanvas = function prepareCanvas(ctx, style, resources) {
    if (ctx.setLineDash && isArrayHasData(style['lineDasharray'])) {
      ctx.setLineDash(style['lineDasharray']);
    }
    var isHitTesting = this.getPainter().isHitTesting();
    Canvas.prepareCanvas(ctx, style, resources, isHitTesting);
  };
  _proto.remove = function remove() {};
  _proto.setZIndex = function setZIndex() {};
  _proto.show = function show() {};
  _proto.hide = function hide() {};
  _proto._defineStyle = function _defineStyle(style) {
    if (this.symbol) {
      style.visible = this.symbol.visible;
      style.opacity = this.symbol.opacity;
    }
    return loadGeoSymbol(style, this.geometry);
  };
  return CanvasSymbolizer;
}(Symbolizer);

function getImage(resources, url) {
  var img = resources && resources.getImage(url);
  return img || null;
}
function drawVectorMarker(ctx, point, symbol, resources, bbox) {
  var strokeAndFill = translateMarkerLineAndFill(symbol);
  var style = symbol,
    markerType = style['markerType'].toLowerCase(),
    vectorArray = getVectorMarkerPoints(markerType, style['markerWidth'], style['markerHeight']),
    lineOpacity = strokeAndFill['lineOpacity'],
    fillOpacity = strokeAndFill['polygonOpacity'];
  var gradient = isGradient(strokeAndFill['polygonFill']);
  if (gradient) {
    var gradientExtent;
    if (isGradient(strokeAndFill['polygonFill'])) {
      if (!gradientExtent) {
        gradientExtent = getGraidentExtent(point, style.markerWidth, style.markerHeight);
      }
      strokeAndFill['polygonGradientExtent'] = gradientExtent;
    }
  }
  Canvas.prepareCanvas(ctx, strokeAndFill, resources);
  var width = style['markerWidth'],
    height = style['markerHeight'],
    lineWidth = style['markerLineWidth'] || 0,
    hLineWidth = lineWidth / 2;
  if (markerType === 'ellipse') {
    Canvas.ellipse(ctx, point, width / 2, height / 2, height / 2, lineOpacity, fillOpacity);
  } else if (markerType === 'cross' || markerType === 'x') {
    for (var j = vectorArray.length - 1; j >= 0; j--) {
      vectorArray[j]._add(point);
    }
    Canvas.path(ctx, vectorArray.slice(0, 2), lineOpacity);
    Canvas.path(ctx, vectorArray.slice(2, 4), lineOpacity);
  } else if (markerType === 'diamond' || markerType === 'bar' || markerType === 'square' || markerType === 'rectangle' || markerType === 'triangle' || markerType === 'roundrectangle') {
    if (markerType === 'bar') {
      point = point.add(0, -hLineWidth);
    } else if (markerType === 'rectangle' || markerType === 'roundrectangle') {
      point = point.add(hLineWidth, hLineWidth);
    }
    for (var _j = vectorArray.length - 1; _j >= 0; _j--) {
      vectorArray[_j]._add(point);
    }
    if (markerType === 'roundrectangle') {
      Canvas.roundRect(ctx, vectorArray, lineOpacity, fillOpacity);
    } else {
      Canvas.polygon(ctx, vectorArray, lineOpacity, fillOpacity);
    }
  } else if (markerType === 'pin') {
    point = point.add(0, -hLineWidth);
    for (var _j2 = vectorArray.length - 1; _j2 >= 0; _j2--) {
      vectorArray[_j2]._add(point);
    }
    var lineCap = ctx.lineCap;
    ctx.lineCap = 'round';
    Canvas.bezierCurveAndFill(ctx, vectorArray, lineOpacity, fillOpacity);
    ctx.lineCap = lineCap;
  } else if (markerType === 'pie') {
    point = point.add(0, -hLineWidth);
    var angle = Math.atan(width / 2 / height) * 180 / Math.PI;
    var _lineCap = ctx.lineCap;
    ctx.lineCap = 'round';
    Canvas.sector(ctx, point, height, [90 - angle, 90 + angle], lineOpacity, fillOpacity);
    ctx.lineCap = _lineCap;
  } else {
    throw new Error('unsupported markerType: ' + markerType);
  }
  if (bbox) {
    var {
      x: x,
      y: y
    } = point;
    bbox[0] = x - width / 2 - lineWidth;
    bbox[1] = y - height / 2 - lineWidth;
    bbox[2] = x + width / 2 + lineWidth;
    bbox[3] = y + height / 2 + lineWidth;
  }
  return ctx.canvas;
}
function getGraidentExtent(point, w, h) {
  var e = new PointExtent();
  e._combine(point);
  e['xmin'] += -w / 2;
  e['ymin'] += -h / 2;
  e['xmax'] += w / 2;
  e['ymax'] += h / 2;
  return e;
}
function translateMarkerLineAndFill(s) {
  var result = {
    'lineColor': s['markerLineColor'],
    'linePatternFile': s['markerLinePatternFile'],
    'lineWidth': s['markerLineWidth'],
    'lineOpacity': s['markerLineOpacity'],
    'lineDasharray': s['markerLineDasharray'],
    'lineCap': 'butt',
    'lineJoin': 'round',
    'polygonFill': s['markerFill'],
    'polygonPatternFile': s['markerFillPatternFile'],
    'polygonOpacity': s['markerFillOpacity']
  };
  if (result['lineWidth'] === 0) {
    result['lineOpacity'] = 0;
  }
  return result;
}
function getVectorMarkerPoints(markerType, width, height) {
  var hh = height / 2,
    hw = width / 2;
  var left = 0,
    top = 0;
  var v0, v1, v2, v3;
  if (markerType === 'triangle') {
    v0 = new Point(left, top - hh);
    v1 = new Point(left - hw, top + hh);
    v2 = new Point(left + hw, top + hh);
    return [v0, v1, v2];
  } else if (markerType === 'cross') {
    v0 = new Point(left - hw, top);
    v1 = new Point(left + hw, top);
    v2 = new Point(left, top - hh);
    v3 = new Point(left, top + hh);
    return [v0, v1, v2, v3];
  } else if (markerType === 'diamond') {
    v0 = new Point(left - hw, top);
    v1 = new Point(left, top - hh);
    v2 = new Point(left + hw, top);
    v3 = new Point(left, top + hh);
    return [v0, v1, v2, v3];
  } else if (markerType === 'square') {
    v0 = new Point(left - hw, top + hh);
    v1 = new Point(left + hw, top + hh);
    v2 = new Point(left + hw, top - hh);
    v3 = new Point(left - hw, top - hh);
    return [v0, v1, v2, v3];
  } else if (markerType === 'rectangle' || markerType === 'roundrectangle') {
    v0 = new Point(left, top);
    v1 = v0.add(width, 0);
    v2 = v0.add(width, height);
    v3 = v0.add(0, height);
    return [v0, v1, v2, v3];
  } else if (markerType === 'x') {
    v0 = new Point(left - hw, top + hh);
    v1 = new Point(left + hw, top - hh);
    v2 = new Point(left + hw, top + hh);
    v3 = new Point(left - hw, top - hh);
    return [v0, v1, v2, v3];
  } else if (markerType === 'bar') {
    v0 = new Point(left - hw, top - height);
    v1 = new Point(left + hw, top - height);
    v2 = new Point(left + hw, top);
    v3 = new Point(left - hw, top);
    return [v0, v1, v2, v3];
  } else if (markerType === 'pin' || markerType === 'pie') {
    var extWidth = height * Math.atan(hw / hh);
    v0 = new Point(left, top);
    v1 = new Point(left - extWidth, top - height);
    v2 = new Point(left + extWidth, top - height);
    v3 = new Point(left, top);
    return [v0, v1, v2, v3];
  }
  return [];
}

var TEMP_POINT0$3 = new Point(0, 0);
var TEMP_POINT1$2 = new Point(0, 0);
var TEMP_POINT2$2 = new Point(0, 0);
var TEMP_POINT3$1 = new Point(0, 0);
var PointSymbolizer = function (_CanvasSymbolizer) {
  function PointSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _CanvasSymbolizer.call(this) || this;
    _this.symbol = symbol;
    _this.geometry = geometry;
    _this.painter = painter;
    _this.rotations = [];
    return _this;
  }
  _inheritsLoose(PointSymbolizer, _CanvasSymbolizer);
  var _proto = PointSymbolizer.prototype;
  _proto.get2DExtent = function get2DExtent() {
    var map = this.getMap();
    var glRes = map.getGLRes();
    var extent = new PointExtent();
    var renderPoints = this._getRenderPoints()[0];
    for (var i = renderPoints.length - 1; i >= 0; i--) {
      if (renderPoints[i]) {
        extent._combine(map._pointAtResToPoint(renderPoints[i], glRes));
      }
    }
    return extent;
  };
  _proto.isDynamicSize = function isDynamicSize() {
    var symbol = this.symbol;
    return isFunctionDefinition(symbol['markerWidth']) || isFunctionDefinition(symbol['markerHeight']) || isFunctionDefinition(symbol['textSize']);
  };
  _proto._rotateExtent = function _rotateExtent(fixedExtent, angle) {
    return fixedExtent.convertTo(function (p) {
      return p._rotate(angle);
    });
  };
  _proto._getRenderPoints = function _getRenderPoints() {
    var painter = this.getPainter();
    var placement = painter.isSpriting() ? 'center' : this.getPlacement();
    return this.getPainter().getRenderPoints(placement);
  };
  _proto._getRenderContainerPoints = function _getRenderContainerPoints(ignoreAltitude) {
    var painter = this.getPainter();
    if (painter.isSpriting()) {
      return this._getRenderPoints()[0];
    }
    var geometry = this.geometry;
    var dxdy = this.getDxDy();
    var cpoints;
    if (geometry._cPoint && !ignoreAltitude) {
      var p = ignoreAltitude ? TEMP_POINT2$2 : TEMP_POINT3$1;
      p.set(geometry._cPoint.x, geometry._cPoint.y);
      var containerOffset = painter.containerOffset;
      p._sub(containerOffset);
      var dx = dxdy.x,
        dy = dxdy.y;
      if (dx || dy) {
        p._add(dx || 0, dy || 0);
      }
      cpoints = [p];
    } else {
      var points = this._getRenderPoints()[0];
      cpoints = this.painter._pointContainerPoints(points, dxdy.x, dxdy.y, ignoreAltitude, true, this.getPlacement());
    }
    if (!cpoints || !Array.isArray(cpoints[0])) {
      return cpoints;
    }
    var flat = [];
    for (var i = 0, l = cpoints.length; i < l; i++) {
      for (var ii = 0, ll = cpoints[i].length; ii < ll; ii++) {
        flat.push(cpoints[i][ii]);
      }
    }
    return flat;
  };
  _proto.getPlacement = function getPlacement() {
    return this.symbol['markerPlacement'];
  };
  _proto.getRotation = function getRotation() {
    return getMarkerRotation(this.style);
  };
  _proto.getDxDy = function getDxDy() {
    var s = this.style;
    var dx = s['markerDx'],
      dy = s['markerDy'];
    return new Point(dx, dy);
  };
  _proto._getRotationAt = function _getRotationAt(i) {
    var r = this.getRotation();
    if (!r) {
      r = 0;
    }
    var rotations = this._getRenderPoints()[1];
    if (!rotations || !rotations[i]) {
      return r;
    }
    var map = this.getMap();
    var p0 = rotations[i][0],
      p1 = rotations[i][1];
    if (!p0 || !p1) {
      return r;
    }
    if (map.isTransforming()) {
      var glRes = map.getGLRes();
      p0 = map._pointAtResToContainerPoint(rotations[i][0], glRes, 0, TEMP_POINT0$3);
      p1 = map._pointAtResToContainerPoint(rotations[i][1], glRes, 0, TEMP_POINT1$2);
      return r + computeDegree(p0.x, p0.y, p1.x, p1.y);
    } else {
      return r + -computeDegree(p0.x, p0.y, p1.x, p1.y);
    }
  };
  _proto._rotate = function _rotate(ctx, origin, rotation) {
    if (rotation) {
      var dxdy = this.getDxDy();
      var p = origin.sub(dxdy);
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(rotation);
      return dxdy;
    }
    return null;
  };
  return PointSymbolizer;
}(CanvasSymbolizer);

var DebugSymbolizer = function (_PointSymbolizer) {
  function DebugSymbolizer() {
    return _PointSymbolizer.apply(this, arguments) || this;
  }
  _inheritsLoose(DebugSymbolizer, _PointSymbolizer);
  var _proto = DebugSymbolizer.prototype;
  _proto.getPlacement = function getPlacement() {
    return 'point';
  };
  _proto.getDxDy = function getDxDy() {
    return new Point(0, 0);
  };
  _proto.symbolize = function symbolize(ctx) {
    var geometry = this.geometry,
      layer = geometry.getLayer();
    if (!geometry.options['debug'] && layer && !layer.options['debug']) {
      return;
    }
    var map = this.getMap();
    if (!map || map.isZooming()) {
      return;
    }
    var color = layer.options['debugOutline'],
      op = 1;
    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.lineWidth = 1;
    ctx.font = '18px  serif';
    var outline = geometry.getContainerExtent().toArray();
    Canvas.polygon(ctx, [outline], op, 0);
    var points = this._getRenderContainerPoints(),
      id = this.geometry.getId(),
      cross = getVectorMarkerPoints('cross', 10, 10);
    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      if (!isNil(id)) {
        Canvas.fillText(ctx, id, p.add(8, -4), color);
      }
      var c = [];
      for (var ii = 0; ii < cross.length; ii++) {
        c.push(cross[ii].add(p));
      }
      Canvas.path(ctx, c.slice(0, 2), op);
      Canvas.path(ctx, c.slice(2, 4), op);
    }
  };
  return DebugSymbolizer;
}(PointSymbolizer);

var TEMP_SIZE = new Size(1, 1);
var TEMP_EXTENT$8 = new PointExtent();
var ImageMarkerSymbolizer = function (_PointSymbolizer) {
  function ImageMarkerSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
    _this.style = _this._defineStyle(_this.translate());
    return _this;
  }
  _inheritsLoose(ImageMarkerSymbolizer, _PointSymbolizer);
  ImageMarkerSymbolizer.test = function test(symbol) {
    return isImageSymbol(symbol);
  };
  var _proto = ImageMarkerSymbolizer.prototype;
  _proto.symbolize = function symbolize(ctx, resources) {
    if (!this.isVisible()) {
      return;
    }
    var style = this.style;
    if (!this.painter.isHitTesting() && (style['markerWidth'] === 0 || style['markerHeight'] === 0 || style['markerOpacity'] === 0)) {
      return;
    }
    var cookedPoints = this._getRenderContainerPoints();
    if (!isArrayHasData(cookedPoints)) {
      return;
    }
    if (!style.markerFile && !this._url) {
      console.warn('not find icon url:', style);
      return;
    }
    var img = this._getImage(resources);
    if (!img) {
      if (typeof console !== 'undefined') {
        console.warn('no img found for ' + (this.style['markerFile'] || this._url[0]));
      }
      return;
    }
    this._prepareContext(ctx);
    var width = style['markerWidth'];
    var height = style['markerHeight'];
    if (!isNumber(width) || !isNumber(height)) {
      width = img.width;
      height = img.height;
      style['markerWidth'] = width;
      style['markerHeight'] = height;
      var imgURL = style['markerFile'];
      if (!resources.isResourceLoaded(imgURL)) {
        resources.addResource(imgURL, img);
      }
      var painter = this.getPainter();
      if (!painter.isSpriting()) {
        painter.removeCache();
      }
    }
    var alpha;
    if (this.symbol['markerType'] !== 'path' && isNumber(style['markerOpacity']) && style['markerOpacity'] < 1) {
      alpha = ctx.globalAlpha;
      ctx.globalAlpha *= style['markerOpacity'];
    }
    TEMP_SIZE.width = width;
    TEMP_SIZE.height = height;
    var alignPoint = getAlignPoint(TEMP_SIZE, style['markerHorizontalAlignment'], style['markerVerticalAlignment']);
    this.rotations = [];
    for (var i = 0, len = cookedPoints.length; i < len; i++) {
      var p = cookedPoints[i];
      var origin = this._rotate(ctx, p, this._getRotationAt(i));
      var extent = void 0;
      if (origin) {
        var pixel = p.sub(origin);
        p = origin;
        var rad = this._getRotationAt(i);
        extent = getMarkerRotationExtent(TEMP_EXTENT$8, rad, width, height, p, alignPoint);
        extent._add(pixel);
        this.rotations.push(rad);
      }
      var x = p.x + alignPoint.x,
        y = p.y + alignPoint.y;
      Canvas.image(ctx, img, x, y, width, height);
      if (origin) {
        ctx.restore();
      }
      if (origin) {
        this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
      } else {
        this._setBBOX(ctx, x, y, x + width, y + height);
      }
    }
    if (alpha !== undefined) {
      ctx.globalAlpha = alpha;
    }
  };
  _proto._getImage = function _getImage(resources) {
    return getImage(resources, this.style['markerFile']);
  };
  _proto.getFixedExtent = function getFixedExtent(resources) {
    this._fixedExtent = this._fixedExtent || new PointExtent();
    return getImageMarkerFixedExtent(this._fixedExtent, this.style, resources);
  };
  _proto.translate = function translate() {
    var s = this.symbol;
    return {
      markerFile: s['markerFile'],
      markerOpacity: getValueOrDefault(s['markerOpacity'], 1),
      markerWidth: getValueOrDefault(s['markerWidth'], null),
      markerHeight: getValueOrDefault(s['markerHeight'], null),
      markerRotation: getValueOrDefault(s['markerRotation'], 0),
      markerDx: getValueOrDefault(s['markerDx'], 0),
      markerDy: getValueOrDefault(s['markerDy'], 0),
      markerHorizontalAlignment: getValueOrDefault(s['markerHorizontalAlignment'], 'middle'),
      markerVerticalAlignment: getValueOrDefault(s['markerVerticalAlignment'], 'top')
    };
  };
  return ImageMarkerSymbolizer;
}(PointSymbolizer);

let canvas;
const OPTIONS = {
    width: 100,
    height: 10
};
// const ISNODE = typeof global === 'object';

let offscreenCanvas = false;
try {
    const canvas = new OffscreenCanvas(1, 1);
    const ctx = canvas.getContext('2d');
    ctx.fillText('hello', 0, 0);
    offscreenCanvas = true;
} catch (err) {
    offscreenCanvas = false;
}

function getCanvas() {
    if (!canvas) {
        const { width, height } = OPTIONS;
        if (offscreenCanvas) {
            canvas = new OffscreenCanvas(width, height);
        } else {
            canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
        }
    }
    return canvas;
}

class ColorIn {
    constructor(colors, options = {}) {
        if (!Array.isArray(colors)) {
            console.error('colors is not array');
            return;
        }
        if (colors.length < 2) {
            console.error('colors.length should >1');
            return;
        }
        this.colors = colors;
        let min = Infinity, max = -Infinity;
        for (let i = 0, len = colors.length; i < len; i++) {
            const value = colors[i][0];
            min = Math.min(value, min);
            max = Math.max(value, max);
        }
        this.min = min;
        this.max = max;
        this.valueOffset = this.max - this.min;
        this.options = Object.assign({}, OPTIONS, options);
        this._initImgData();
    }

    getImageData() {
        return this.imgData;
    }

    _initImgData() {
        const canvas = getCanvas();
        const { width, height } = this.options;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        const { colors, valueOffset } = this;
        for (let i = 0, len = colors.length; i < len; i++) {
            const [stop, color] = colors[i];
            const s = (stop - this.min) / valueOffset;
            gradient.addColorStop(s, color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }

    getColor(stop) {
        stop = Math.max(this.min, stop);
        stop = Math.min(stop, this.max);
        const s = (stop - this.min) / this.valueOffset;
        let x = Math.round(s * this.imgData.width);
        x = Math.min(x, this.imgData.width - 1);
        const idx = x * 4;
        const r = this.imgData.data[idx];
        const g = this.imgData.data[idx + 1];
        const b = this.imgData.data[idx + 2];
        const a = this.imgData.data[idx + 3];
        return [r, g, b, a];
    }
}

var TEMP_COORD0 = new Coordinate(0, 0);
var TEMP_COORD1 = new Coordinate(0, 0);
var StrokeAndFillSymbolizer = function (_CanvasSymbolizer) {
  function StrokeAndFillSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _CanvasSymbolizer.call(this) || this;
    _this.symbol = symbol;
    _this.geometry = geometry;
    _this.painter = painter;
    if (geometry.isPoint) {
      return _assertThisInitialized(_this);
    }
    _this.style = _this._defineStyle(_this.translate());
    return _this;
  }
  _inheritsLoose(StrokeAndFillSymbolizer, _CanvasSymbolizer);
  StrokeAndFillSymbolizer.test = function test(symbol, geometry) {
    if (!symbol) {
      return false;
    }
    if (geometry && geometry.isPoint) {
      return false;
    }
    for (var p in symbol) {
      var f = p.slice(0, 4);
      if (f === 'line' || f === 'poly') {
        return true;
      }
    }
    return false;
  };
  var _proto = StrokeAndFillSymbolizer.prototype;
  _proto.symbolize = function symbolize(ctx, resources) {
    if (!this.isVisible()) {
      return;
    }
    var style = this.style;
    if (style['polygonOpacity'] === 0 && style['lineOpacity'] === 0 && !this.painter.isHitTesting()) {
      return;
    }
    var paintParams = this._getPaintParams();
    if (!paintParams) {
      return;
    }
    this._prepareContext(ctx);
    var isGradient$1 = isGradient(style['lineColor']) || style['lineGradientProperty'],
      isPath = this.geometry.getJSONType() === 'Polygon' || this.geometry.type === 'LineString';
    if (isGradient$1 && (style['lineColor']['places'] || !isPath)) {
      style['lineGradientExtent'] = this.geometry.getContainerExtent()._expand(style['lineWidth']);
    }
    if (isGradient(style['polygonFill'])) {
      style['polygonGradientExtent'] = this.geometry.getContainerExtent();
      var map = this.getMap();
      if (map) {
        var cache = MapStateCache[map.id];
        var bearing = cache ? cache.bearing : map.getBearing();
        style['polygonGradientExtent'].bearing = bearing;
      }
    }
    var geometryEventTolerance = this.geometry.getLayer().options['geometryEventTolerance'] || 0;
    var tolerance = this.geometry._hitTestTolerance() + geometryEventTolerance;
    var points = paintParams[0],
      isSplitted = this.geometry.getJSONType() === 'Polygon' && points.length > 0 && Array.isArray(points[0][0]) || this.geometry.type === 'LineString' && points.length > 0 && Array.isArray(points[0]);
    if (isSplitted) {
      for (var i = 0; i < points.length; i++) {
        this.prepareCanvas(ctx, style, resources);
        if (isGradient$1 && isPath && !style['lineColor']['places']) {
          this._createGradient(ctx, points[i], style['lineColor']);
        }
        var params = [ctx, points[i]];
        if (paintParams.length > 1) {
          params.push(...paintParams.slice(1));
        }
        params.push(style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
        if (isGradient$1) {
          params.push(this._lineColorIn);
        }
        var bbox = this.geometry._paintOn(...params);
        this._setBBOX(ctx, bbox);
        this._bufferBBOX(ctx, tolerance);
      }
    } else {
      this.prepareCanvas(ctx, style, resources);
      if (isGradient$1 && isPath && !style['lineColor']['places']) {
        this._createGradient(ctx, points, style['lineColor']);
      }
      var _params = [ctx];
      _params.push(...paintParams);
      _params.push(style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
      if (isGradient$1) {
        _params.push(this._lineColorIn);
      }
      var _bbox = this.geometry._paintOn(..._params);
      this._setBBOX(ctx, _bbox);
      this._bufferBBOX(ctx, tolerance);
    }
    if (ctx.setLineDash && Array.isArray(style['lineDasharray'])) {
      ctx.setLineDash([]);
    }
    this._tempRenderPoints = points;
  };
  _proto.get2DExtent = function get2DExtent() {
    var map = this.getMap();
    var extent = this.geometry._getPrjExtent();
    if (!extent) {
      return null;
    }
    if (!this._extMin || !this._extMax) {
      this._extMin = new Coordinate(0, 0);
      this._extMax = new Coordinate(0, 0);
    }
    this._extMin.x = extent['xmin'];
    this._extMin.y = extent['ymin'];
    this._extMax.x = extent['xmax'];
    this._extMax.y = extent['ymax'];
    var min = map._prjToPoint(this._extMin, undefined, TEMP_COORD0),
      max = map._prjToPoint(this._extMax, undefined, TEMP_COORD1);
    if (!this._pxExtent) {
      this._pxExtent = new PointExtent(min, max);
    } else {
      this._pxExtent.set(Math.min(min.x, max.x), Math.min(min.y, max.y), Math.max(min.x, max.x), Math.max(min.y, max.y));
    }
    return this._pxExtent;
  };
  _proto.getFixedExtent = function getFixedExtent() {
    var t = this.style['lineWidth'] / 2;
    return new PointExtent(-t, -t, t, t);
  };
  _proto._getPaintParams = function _getPaintParams() {
    return this.getPainter().getPaintParams(this.style['lineDx'], this.style['lineDy']);
  };
  _proto.translate = function translate() {
    var s = this.symbol;
    var result = {
      lineColor: getValueOrDefault(s['lineColor'], '#000'),
      lineWidth: getValueOrDefault(s['lineWidth'], 2),
      lineOpacity: getValueOrDefault(s['lineOpacity'], 1),
      lineDasharray: getValueOrDefault(s['lineDasharray'], []),
      lineCap: getValueOrDefault(s['lineCap'], 'butt'),
      lineJoin: getValueOrDefault(s['lineJoin'], 'miter'),
      linePatternFile: getValueOrDefault(s['linePatternFile'], null),
      lineDx: getValueOrDefault(s['lineDx'], 0),
      lineDy: getValueOrDefault(s['lineDy'], 0),
      polygonFill: getValueOrDefault(s['polygonFill'], null),
      polygonOpacity: getValueOrDefault(s['polygonOpacity'], 1),
      polygonPatternFile: getValueOrDefault(s['polygonPatternFile'], null),
      polygonPatternDx: getValueOrDefault(s['polygonPatternDx'], 0),
      polygonPatternDy: getValueOrDefault(s['polygonPatternDy'], 0),
      linePatternDx: getValueOrDefault(s['linePatternDx'], 0),
      linePatternDy: getValueOrDefault(s['linePatternDy'], 0),
      lineGradientProperty: getValueOrDefault(s['lineGradientProperty'], null),
      lineStrokeColor: getValueOrDefault(s['lineStrokeColor'], null),
      lineStrokeWidth: getValueOrDefault(s['lineStrokeWidth'], null)
    };
    if (result['lineWidth'] === 0) {
      result['lineOpacity'] = 0;
    }
    if (this.geometry.type === 'LineString' && !result['polygonFill']) {
      result['polygonFill'] = result['lineColor'];
    }
    return result;
  };
  _proto._createGradient = function _createGradient(ctx, points, lineColor) {
    if (!Array.isArray(points) || !points.length) {
      return;
    }
    var [p1, p2] = getGradientPoints(points);
    if (!p1 || !p2) {
      console.error('unable create canvas LinearGradient,error data:', points);
      return;
    }
    var colorStops;
    if (lineColor['colorStops']) {
      colorStops = lineColor['colorStops'];
    }
    if (!colorStops) {
      var properties = this.geometry.properties || {};
      var style = this.style || {};
      colorStops = properties[style['lineGradientProperty']];
    }
    if (!colorStops || !Array.isArray(colorStops) || colorStops.length < 2) {
      return;
    }
    if (!Array.isArray(colorStops[0])) {
      var colorStopsArray = [];
      var _colors = [];
      var idx = 0;
      for (var i = 0, len = colorStops.length; i < len; i += 2) {
        _colors[0] = colorStops[i];
        _colors[1] = colorStops[i + 1];
        colorStopsArray[idx] = _colors;
        idx++;
        _colors = [];
      }
      colorStops = colorStopsArray;
    }
    var grad = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y);
    colorStops.forEach(function (stop) {
      grad.addColorStop(...stop);
    });
    ctx.strokeStyle = grad;
    var key = JSON.stringify(colorStops);
    if (key === this._lineColorStopsKey) {
      return;
    }
    this._lineColorStopsKey = key;
    var colors = colorStops.map(function (c) {
      return [parseFloat(c[0]), c[1]];
    });
    this._lineColorIn = new ColorIn(colors, {
      height: 1,
      width: 100
    });
  };
  return StrokeAndFillSymbolizer;
}(CanvasSymbolizer);
function getGradientPoints(points) {
  var pts;
  var isLine = true;
  if (Array.isArray(points[0])) {
    pts = points[0];
    isLine = false;
  } else {
    pts = points;
  }
  var len = pts.length;
  if (isLine) {
    return [pts[0], pts[len - 1]];
  }
  var p1 = pts[0];
  var distance = 0,
    p2;
  for (var i = 1; i < len; i++) {
    var p = pts[i];
    var dis = p1.distanceTo(p);
    if (dis > distance) {
      distance = dis;
      p2 = p;
    }
  }
  return [p1, p2];
}

var TEMP_EXTENT$7 = new PointExtent();
function filterPathByMapSize(paths, mapSize) {
  var {
    width: width,
    height: height
  } = mapSize;
  var buffer = 0;
  var minx = -buffer,
    miny = -buffer,
    maxx = width + buffer,
    maxy = height + buffer;
  TEMP_EXTENT$7.xmin = minx;
  TEMP_EXTENT$7.ymin = miny;
  TEMP_EXTENT$7.xmax = maxx;
  TEMP_EXTENT$7.ymax = maxy;
  if (!Array.isArray(paths[0])) {
    paths = [paths];
  }
  var result = [];
  paths.forEach(function (path) {
    var hasDirty = false;
    for (var i = 0, len = path.length; i < len; i++) {
      var {
        x: x,
        y: y
      } = path[i];
      if (x < minx || x > maxx || y < miny || y > maxy) {
        hasDirty = true;
        break;
      }
    }
    if (hasDirty) {
      var parts = clipLine(path, TEMP_EXTENT$7, false, false);
      parts.forEach(function (part) {
        var line = [];
        for (var j = 0, len1 = part.length; j < len1; j++) {
          line[j] = part[j].point;
        }
        result.push(line);
      });
    } else {
      result.push(path);
    }
  });
  return result;
}
var TextMarkerSymbolizer = function (_PointSymbolizer) {
  function TextMarkerSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
    var style = _this.translate();
    _this._dynamic = hasFunctionDefinition(style);
    _this.style = _this._defineStyle(style);
    if (_this.style['textWrapWidth'] === 0) {
      return _assertThisInitialized(_this);
    }
    _this.strokeAndFill = _this._defineStyle(_this.translateLineAndFill(_this.style));
    return _this;
  }
  _inheritsLoose(TextMarkerSymbolizer, _PointSymbolizer);
  TextMarkerSymbolizer.test = function test(symbol) {
    return isTextSymbol(symbol);
  };
  var _proto = TextMarkerSymbolizer.prototype;
  _proto.isAlongLine = function isAlongLine() {
    var placement = this.getPlacement();
    var textSpacing = this.style.textSpacing;
    return placement === 'line' && isNumber(textSpacing) && textSpacing > 0;
  };
  _proto.symbolize = function symbolize(ctx, resources) {
    if (!this.isVisible()) {
      return;
    }
    var style = this.style;
    if (!this.painter.isHitTesting() && (style['textSize'] === 0 || !style['textOpacity'] && (!style['textHaloRadius'] || !style['textHaloOpacity']) || style['textWrapWidth'] === 0)) {
      return;
    }
    var strokeAndFill = this.strokeAndFill;
    var textContent = replaceVariable(this.style['textName'], this.geometry.getProperties());
    if (this._dynamic) {
      delete this._textDesc;
    }
    var textDesc = this._textDesc = this._textDesc || describeText(textContent, this.style);
    this._prepareContext(ctx);
    this.prepareCanvas(ctx, strokeAndFill, resources);
    if (!this._textFont) {
      this._textFont = getFont(style);
    }
    Canvas.prepareCanvasFont(ctx, style, !this._dynamic ? this._textFont : null);
    var textHaloRadius = style.textHaloRadius || 0;
    this.rotations = [];
    if (this.isAlongLine()) {
      var painter = this.getPainter();
      var paths = painter.getPathTempRenderPoints();
      if (!paths) {
        return;
      }
      var map = this.getMap();
      paths = filterPathByMapSize(paths, map.getSize());
      if (paths) {
        var layer = this.geometry.getLayer();
        var bbox = Canvas.textAlongLine(ctx, textContent, paths, style, textDesc, layer.options.collision ? layer.getCollisionIndex() : null);
        if (bbox) {
          this._setBBOX(ctx, bbox);
          this._bufferBBOX(ctx, textHaloRadius);
        }
      }
    } else {
      var cookedPoints = this._getRenderContainerPoints();
      if (!isArrayHasData(cookedPoints)) {
        return;
      }
      for (var i = 0, len = cookedPoints.length; i < len; i++) {
        var p = cookedPoints[i];
        var origin = this._rotate(ctx, p, this._getRotationAt(i));
        var extent = void 0;
        if (origin) {
          var pixel = p.sub(origin);
          p = origin;
          var rad = this._getRotationAt(i);
          var {
            width: width,
            height: height
          } = textDesc.size || {
            width: 0,
            height: 0
          };
          var alignPoint = getAlignPoint(textDesc.size, style['textHorizontalAlignment'], style['textVerticalAlignment']);
          extent = getMarkerRotationExtent(TEMP_EXTENT$7, rad, width, height, p, alignPoint);
          extent._add(pixel);
          this.rotations.push(rad);
        }
        var _bbox = Canvas.text(ctx, textContent, p, style, textDesc);
        if (origin) {
          this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
          ctx.restore();
        } else {
          this._setBBOX(ctx, _bbox);
        }
        this._bufferBBOX(ctx, textHaloRadius);
      }
    }
  };
  _proto.getPlacement = function getPlacement() {
    return this.symbol['textPlacement'];
  };
  _proto.getRotation = function getRotation() {
    var r = this.style['textRotation'];
    if (!isNumber(r)) {
      return null;
    }
    return -r * Math.PI / 180;
  };
  _proto.getDxDy = function getDxDy() {
    var s = this.style;
    return new Point(s['textDx'], s['textDy']);
  };
  _proto.getFixedExtent = function getFixedExtent() {
    var textDesc = this.geometry.getTextDesc();
    if (Array.isArray(textDesc)) {
      textDesc = textDesc[this._index];
    }
    this._fixedExtent = this._fixedExtent || new PointExtent();
    if (!textDesc) {
      return this._fixedExtent;
    }
    return getTextMarkerFixedExtent(this._fixedExtent, this.style, textDesc);
  };
  _proto.translate = function translate() {
    var s = this.symbol;
    var result = {
      textName: s['textName'],
      textFaceName: getValueOrDefault(s['textFaceName'], 'monospace'),
      textWeight: getValueOrDefault(s['textWeight'], 'normal'),
      textStyle: getValueOrDefault(s['textStyle'], 'normal'),
      textSize: getValueOrDefault(s['textSize'], DEFAULT_TEXT_SIZE),
      textFont: getValueOrDefault(s['textFont'], null),
      textFill: getValueOrDefault(s['textFill'], '#000'),
      textOpacity: getValueOrDefault(s['textOpacity'], 1),
      textHaloFill: getValueOrDefault(s['textHaloFill'], '#ffffff'),
      textHaloRadius: getValueOrDefault(s['textHaloRadius'], 0),
      textHaloOpacity: getValueOrDefault(s['textHaloOpacity'], 1),
      textWrapWidth: getValueOrDefault(s['textWrapWidth'], null),
      textWrapCharacter: getValueOrDefault(s['textWrapCharacter'], '\n'),
      textLineSpacing: getValueOrDefault(s['textLineSpacing'], 0),
      textDx: getValueOrDefault(s['textDx'], 0),
      textDy: getValueOrDefault(s['textDy'], 0),
      textHorizontalAlignment: getValueOrDefault(s['textHorizontalAlignment'], 'middle'),
      textVerticalAlignment: getValueOrDefault(s['textVerticalAlignment'], 'middle'),
      textAlign: getValueOrDefault(s['textAlign'], 'center'),
      textRotation: getValueOrDefault(s['textRotation'], 0),
      textMaxWidth: getValueOrDefault(s['textMaxWidth'], 0),
      textMaxHeight: getValueOrDefault(s['textMaxHeight'], 0),
      textSpacing: getValueOrDefault(s['textSpacing'], 0),
      textAlongDebug: getValueOrDefault(s['textAlongDebug'], false)
    };
    if (result['textMaxWidth'] > 0 && (!result['textWrapWidth'] || result['textWrapWidth'] > result['textMaxWidth'])) {
      if (!result['textWrapWidth']) {
        result['textMaxHeight'] = 1;
      }
      result['textWrapWidth'] = result['textMaxWidth'];
    }
    return result;
  };
  _proto.translateLineAndFill = function translateLineAndFill(s) {
    return {
      lineColor: s['textHaloRadius'] ? s['textHaloFill'] : s['textFill'],
      lineWidth: s['textHaloRadius'],
      lineOpacity: s['textOpacity'],
      lineDasharray: null,
      lineCap: 'butt',
      lineJoin: 'round',
      polygonFill: s['textFill'],
      polygonOpacity: s['textOpacity']
    };
  };
  return TextMarkerSymbolizer;
}(PointSymbolizer);

var MARKER_SIZE = [0, 0];
var TEMP_EXTENT$6 = new PointExtent();
var DEFAULT_ANCHOR = new Point(0, 0);
var TEMP_BBOX$1 = getDefaultBBOX();
var VectorMarkerSymbolizer = function (_PointSymbolizer) {
  function VectorMarkerSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
    var style = _this.translate();
    _this._dynamic = hasFunctionDefinition(style);
    _this.style = _this._defineStyle(style);
    _this.strokeAndFill = _this._defineStyle(translateMarkerLineAndFill(_this.style));
    _this.padding = 0;
    return _this;
  }
  _inheritsLoose(VectorMarkerSymbolizer, _PointSymbolizer);
  VectorMarkerSymbolizer.test = function test(symbol) {
    return isVectorSymbol(symbol);
  };
  var _proto = VectorMarkerSymbolizer.prototype;
  _proto.symbolize = function symbolize(ctx, resources) {
    if (!this.isVisible()) {
      return;
    }
    var style = this.style;
    if (!this.painter.isHitTesting() && (style['markerWidth'] === 0 || style['markerHeight'] === 0 || style['polygonOpacity'] === 0 && style['lineOpacity'] === 0)) {
      return;
    }
    var cookedPoints = this._getRenderContainerPoints();
    if (!isArrayHasData(cookedPoints)) {
      return;
    }
    this._prepareContext(ctx);
    if (this.getPainter().isSpriting() || this.geometry.getLayer().getMask() === this.geometry || this._dynamic || this.geometry.getLayer().options['cacheVectorOnCanvas'] === false) {
      this._drawMarkersWithDynamic(ctx, cookedPoints, resources);
    } else {
      this._drawMarkersWithCache(ctx, cookedPoints, resources);
    }
  };
  _proto._drawMarkersWithDynamic = function _drawMarkersWithDynamic(ctx, cookedPoints, resources) {
    for (var i = cookedPoints.length - 1; i >= 0; i--) {
      var point = cookedPoints[i];
      var size = calVectorMarkerSize(MARKER_SIZE, this.style);
      var [width, height] = size;
      var origin = this._rotate(ctx, point, this._getRotationAt(i));
      this.rotations = [];
      var extent = void 0;
      if (origin) {
        var pixel = point.sub(origin);
        point = origin;
        var rad = this._getRotationAt(i);
        extent = getMarkerRotationExtent(TEMP_EXTENT$6, rad, width, height, point, DEFAULT_ANCHOR);
        extent._add(pixel);
        this.rotations.push(rad);
      }
      var bbox = this._drawVectorMarker(ctx, point, resources);
      if (origin) {
        ctx.restore();
        this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
      } else {
        if (bbox) {
          this._setBBOX(ctx, bbox[0], bbox[1], bbox[2], bbox[3]);
        } else {
          var {
            x: x,
            y: y
          } = point;
          this._setBBOX(ctx, x, y, x + width, y + height);
        }
      }
    }
  };
  _proto._drawMarkersWithCache = function _drawMarkersWithCache(ctx, cookedPoints, resources) {
    var stamp = this._stampSymbol();
    var image = resources.getImage(stamp);
    if (!image) {
      image = this._createMarkerImage(ctx, resources);
      resources.addResource([stamp, image.width, image.height], image);
    }
    var anchor = getVectorMarkerAnchor(this.style, image.width, image.height);
    for (var i = cookedPoints.length - 1; i >= 0; i--) {
      var point = cookedPoints[i];
      var origin = this._rotate(ctx, point, this._getRotationAt(i));
      this.rotations = [];
      var extent = void 0;
      if (origin) {
        var pixel = point.sub(origin);
        point = origin;
        var rad = this._getRotationAt(i);
        extent = getMarkerRotationExtent(TEMP_EXTENT$6, rad, image.width, image.height, point, anchor);
        extent._add(pixel);
        this.rotations.push(rad);
      }
      var x = point.x + anchor.x,
        y = point.y + anchor.y;
      Canvas.image(ctx, image, x, y);
      if (origin) {
        ctx.restore();
        this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
      } else {
        this._setBBOX(ctx, x, y, x + image.width, y + image.height);
      }
    }
  };
  _proto._createMarkerImage = function _createMarkerImage(ctx, resources) {
    var canvasClass = ctx.canvas.constructor,
      size = calVectorMarkerSize(MARKER_SIZE, this.style),
      canvas = Canvas.createCanvas(size[0], size[1], canvasClass),
      point = this._getCacheImageAnchor(size[0], size[1]);
    var context = canvas.getContext('2d');
    this._drawVectorMarker(context, point, resources);
    return canvas;
  };
  _proto._stampSymbol = function _stampSymbol() {
    if (!this._stamp) {
      this._stamp = hashCode([this.style['markerType'], isGradient(this.style['markerFill']) ? getGradientStamp(this.style['markerFill']) : this.style['markerFill'], this.style['markerFillOpacity'], this.style['markerFillPatternFile'], isGradient(this.style['markerLineColor']) ? getGradientStamp(this.style['markerLineColor']) : this.style['markerLineColor'], this.style['markerLineWidth'], this.style['markerLineOpacity'], this.style['markerLineDasharray'] ? this.style['markerLineDasharray'].join(',') : '', this.style['markerLinePatternFile'], this.style['markerWidth'], this.style['markerHeight'], this.style['markerHorizontalAlignment'], this.style['markerVerticalAlignment']].join('_'));
    }
    return this._stamp;
  };
  _proto._getCacheImageAnchor = function _getCacheImageAnchor(w, h) {
    var shadow = 2 * (this.symbol['shadowBlur'] || 0),
      margin = shadow + this.padding;
    var markerType = this.style['markerType'];
    if (markerType === 'bar' || markerType === 'pie' || markerType === 'pin') {
      return new Point(w / 2, h - margin);
    } else if (markerType === 'rectangle' || markerType === 'roundrectangle') {
      return new Point(margin, margin);
    } else {
      return new Point(w / 2, h / 2);
    }
  };
  _proto._getGraidentExtent = function _getGraidentExtent(points) {
    var e = new PointExtent(),
      dxdy = this.getDxDy(),
      m = this.getFixedExtent();
    if (Array.isArray(points)) {
      for (var i = points.length - 1; i >= 0; i--) {
        e._combine(points[i]);
      }
    } else {
      e._combine(points);
    }
    e['xmin'] += m['xmin'] - dxdy.x;
    e['ymin'] += m['ymin'] - dxdy.y;
    e['xmax'] += m['xmax'] - dxdy.x;
    e['ymax'] += m['ymax'] - dxdy.y;
    return e;
  };
  _proto._drawVectorMarker = function _drawVectorMarker(ctx, point, resources) {
    resetBBOX(TEMP_BBOX$1);
    drawVectorMarker(ctx, point, this.style, resources, TEMP_BBOX$1);
    return TEMP_BBOX$1;
  };
  _proto.getFixedExtent = function getFixedExtent() {
    this._fixedExtent = this._fixedExtent || new PointExtent();
    return getVectorMarkerFixedExtent(this._fixedExtent, this.style, null);
  };
  _proto.translate = function translate() {
    var s = this.symbol;
    var result = {
      markerType: getValueOrDefault(s['markerType'], 'ellipse'),
      markerFill: getValueOrDefault(s['markerFill'], '#00f'),
      markerFillOpacity: getValueOrDefault(s['markerFillOpacity'], 1),
      markerFillPatternFile: getValueOrDefault(s['markerFillPatternFile'], null),
      markerLineColor: getValueOrDefault(s['markerLineColor'], '#000'),
      markerLineWidth: getValueOrDefault(s['markerLineWidth'], DEFAULT_MARKER_SYMBOLS.markerLineWidth),
      markerLineOpacity: getValueOrDefault(s['markerLineOpacity'], 1),
      markerLineDasharray: getValueOrDefault(s['markerLineDasharray'], []),
      markerLinePatternFile: getValueOrDefault(s['markerLinePatternFile'], null),
      markerDx: getValueOrDefault(s['markerDx'], 0),
      markerDy: getValueOrDefault(s['markerDy'], 0),
      markerWidth: getValueOrDefault(s['markerWidth'], DEFAULT_MARKER_SYMBOLS.markerWidth),
      markerHeight: getValueOrDefault(s['markerHeight'], DEFAULT_MARKER_SYMBOLS.markerHeight),
      markerRotation: getValueOrDefault(s['markerRotation'], 0),
      shadowBlur: getValueOrDefault(s['shadowBlur'], 0),
      shadowOffsetX: getValueOrDefault(s['shadowOffsetX'], 0),
      shadowOffsetY: getValueOrDefault(s['shadowOffsetY'], 0)
    };
    var markerType = result['markerType'];
    var ha = getDefaultHAlign(markerType);
    var va = getDefaultVAlign(markerType);
    result['markerHorizontalAlignment'] = getValueOrDefault(s['markerHorizontalAlignment'], ha);
    result['markerVerticalAlignment'] = getValueOrDefault(s['markerVerticalAlignment'], va);
    if (isNumber(s['markerOpacity'])) {
      if (isNumber(s['markerFillOpacity'])) {
        result['markerFillOpacity'] *= s['markerOpacity'];
      }
      if (isNumber(s['markerLineOpacity'])) {
        result['markerLineOpacity'] *= s['markerOpacity'];
      }
    }
    return result;
  };
  return VectorMarkerSymbolizer;
}(PointSymbolizer);

var VectorPathMarkerSymbolizer = function (_ImageMarkerSymbolize) {
  function VectorPathMarkerSymbolizer(symbol, geometry, painter) {
    var _this;
    if (isNil(symbol['markerWidth'])) {
      symbol['markerWidth'] = 80;
    }
    if (isNil(symbol['markerHeight'])) {
      symbol['markerHeight'] = 80;
    }
    _this = _ImageMarkerSymbolize.call(this, symbol, geometry, painter) || this;
    symbol = extend$2({}, symbol, _this.translate());
    var style = _this.style = _this._defineStyle(symbol);
    if (Browser$1.gecko) {
      _this._url = [getMarkerPathBase64(style, style['markerWidth'], style['markerHeight']), style['markerWidth'], style['markerHeight']];
    } else {
      _this._url = [getMarkerPathBase64(style), style['markerWidth'], style['markerHeight']];
    }
    return _this;
  }
  _inheritsLoose(VectorPathMarkerSymbolizer, _ImageMarkerSymbolize);
  VectorPathMarkerSymbolizer.test = function test(symbol) {
    return isPathSymbol(symbol);
  };
  var _proto = VectorPathMarkerSymbolizer.prototype;
  _proto._prepareContext = function _prepareContext() {};
  _proto._getImage = function _getImage(resources) {
    var _this2 = this;
    if (resources && resources.isResourceLoaded(this._url)) {
      return resources.getImage(this._url);
    }
    var painter = this.painter;
    var image = new Image();
    image.onload = function () {
      var renderer = painter.getLayer() && painter.getLayer().getRenderer();
      if (renderer) {
        renderer.setToRedraw();
      }
    };
    image.onerror = function (err) {
      if (err && typeof console !== 'undefined') {
        console.warn(err);
      }
      resources.markErrorResource(_this2._url);
    };
    image.src = this._url[0];
    if (resources) {
      resources.addResource(this._url, image);
    }
    return image;
  };
  return VectorPathMarkerSymbolizer;
}(ImageMarkerSymbolizer);

var defaultSymbol$1 = {
  lineWidth: 1,
  polygonFill: '#fff',
  polygonOpacity: 0.5
};
var DrawAltitudeSymbolizer = function (_PointSymbolizer) {
  function DrawAltitudeSymbolizer(symbol, geometry, painter) {
    var _this;
    _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
    _this.style = geometry.getLayer().options['drawAltitude'];
    if (!_this.style || !isObject$1(_this.style)) {
      _this.style = {
        lineWidth: 2
      };
    }
    if (!_this.style['lineWidth']) {
      _this.style['lineWidth'] = 0;
    }
    _this.dxdy = _this._defineStyle({
      dx: symbol['textDx'] || symbol['markerDx'],
      dy: symbol['textDy'] || symbol['markerDy']
    });
    return _this;
  }
  _inheritsLoose(DrawAltitudeSymbolizer, _PointSymbolizer);
  DrawAltitudeSymbolizer.test = function test(symbol, geometry) {
    var layer = geometry.getLayer();
    if (!layer) {
      return false;
    }
    var type = geometry.getJSONType();
    return type === 'Marker' || type === 'LineString';
  };
  var _proto = DrawAltitudeSymbolizer.prototype;
  _proto.groundClip = function groundClip(ctx) {
    var groundClip = this.geometry.options['groundClip'];
    var cliped = false;
    if (groundClip) {
      var map = this.getMap();
      var cache = MapStateCache[map.id];
      var groundExtent = cache ? cache.groundExtent : map.getGroundExtent();
      if (groundExtent.ymin > 0) {
        ctx.save();
        var {
          ymin: ymin,
          ymax: ymax,
          xmin: xmin,
          xmax: xmax
        } = groundExtent;
        ctx.beginPath();
        ctx.rect(xmin, ymin, xmax - xmin, ymax - ymin);
        ctx.clip();
        cliped = true;
      }
    }
    return cliped;
  };
  _proto.symbolize = function symbolize(ctx) {
    var layer = this.geometry.getLayer();
    if (!layer.options['drawAltitude']) {
      return;
    }
    if (!this.geometry.hasAltitude()) {
      return;
    }
    var style = this._getStyle();
    this._prepareContext(ctx);
    if (this.geometry.type === 'LineString') {
      var paintParams = this._getPaintParams(style['lineDx'], style['lineDy']);
      if (!paintParams) {
        return;
      }
      var groundPoints = this.getPainter().getPaintParams(style['lineDx'], style['lineDy'], true, true, '_groundpt', true)[0];
      var cliped = this.groundClip(ctx);
      this._drawLineAltitude(ctx, paintParams[0], groundPoints);
      if (cliped) {
        ctx.restore();
      }
    } else {
      var point = this._getRenderContainerPoints(),
        groundPoint = this._getRenderContainerPoints(true);
      if (!point || point.length === 0 || !groundPoint || groundPoint.length === 0) {
        return;
      }
      var y1 = point[0].y;
      var y2 = groundPoint[0].y;
      var map = this.getMap();
      var cache = MapStateCache[map.id];
      var groundExtent = cache ? cache.groundExtent : map.getGroundExtent();
      if (y1 < groundExtent.ymin && y2 < groundExtent.ymin) {
        return;
      }
      this._drawMarkerAltitude(ctx, point[0], groundPoint[0]);
    }
  };
  _proto.getDxDy = function getDxDy() {
    var s = this.dxdy;
    return new Point(s['dx'] || 0, s['dy'] || 0);
  };
  _proto.get2DExtent = function get2DExtent() {
    if (this.geometry.type === 'LineString') {
      return StrokeAndFillSymbolizer.prototype.get2DExtent.apply(this);
    } else {
      return _PointSymbolizer.prototype.get2DExtent.call(this);
    }
  };
  _proto.getPlacement = function getPlacement() {
    return 'point';
  };
  _proto._getPaintParams = function _getPaintParams(dx, dy) {
    return this.getPainter().getPaintParams(dx || 0, dy || 0, null, true, '_altpt', true);
  };
  _proto._drawMarkerAltitude = function _drawMarkerAltitude(ctx, point, groundPoint) {
    var style = this._getStyle();
    this.prepareCanvas(ctx, style);
    Canvas.path(ctx, [point, groundPoint], style['lineOpacity'], null, style['lineDasharray']);
  };
  _proto._drawLineAltitude = function _drawLineAltitude(ctx, points, groundPoints) {
    var style = this._getStyle();
    var isSplitted = points.length > 0 && Array.isArray(points[0]);
    if (isSplitted) {
      for (var i = 0; i < points.length; i++) {
        this._drawLine(ctx, points[i], groundPoints[i]);
      }
    } else {
      this._drawLine(ctx, points, groundPoints);
    }
    if (ctx.setLineDash && Array.isArray(style['lineDasharray'])) {
      ctx.setLineDash([]);
    }
  };
  _proto._drawLine = function _drawLine(ctx, points, groundPoints) {
    var style = this._getStyle();
    this.prepareCanvas(ctx, style);
    for (var i = 0, l = points.length - 1; i < l; i++) {
      Canvas.polygon(ctx, [points[i], points[i + 1], groundPoints[i + 1], groundPoints[i]], style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
    }
  };
  _proto._getStyle = function _getStyle() {
    var layer = this.geometry.getLayer();
    var style = layer.options['drawAltitude'];
    if (Array.isArray(style)) {
      var geos = layer.getGeometries() || [];
      var index = geos.indexOf(this.geometry);
      if (index >= 0) {
        style = style[index] || defaultSymbol$1;
      }
    }
    if (!isObject$1(style)) {
      style = defaultSymbol$1;
    }
    if (!style['lineWidth']) {
      style['lineWidth'] = 0;
      style['lineOpacity'] = 0;
    }
    return style;
  };
  return DrawAltitudeSymbolizer;
}(PointSymbolizer);

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CanvasSymbolizer: CanvasSymbolizer,
  DebugSymbolizer: DebugSymbolizer,
  DrawAltitudeSymbolizer: DrawAltitudeSymbolizer,
  ImageMarkerSymbolizer: ImageMarkerSymbolizer,
  PointSymbolizer: PointSymbolizer,
  StrokeAndFillSymbolizer: StrokeAndFillSymbolizer,
  Symbolizer: Symbolizer,
  TextMarkerSymbolizer: TextMarkerSymbolizer,
  VectorMarkerSymbolizer: VectorMarkerSymbolizer,
  VectorPathMarkerSymbolizer: VectorPathMarkerSymbolizer
});

var registerSymbolizers = [DrawAltitudeSymbolizer, StrokeAndFillSymbolizer, ImageMarkerSymbolizer, VectorPathMarkerSymbolizer, VectorMarkerSymbolizer, TextMarkerSymbolizer];
var testCanvas;
var TEMP_POINT0$2 = new Point(0, 0);
var TEMP_PAINT_EXTENT = new PointExtent();
var TEMP_FIXED_EXTENT = new PointExtent();
var TEMP_CLIP_EXTENT0 = new PointExtent();
var TEMP_CLIP_EXTENT1 = new PointExtent();
var TEMP_CLIP_EXTENT2 = new PointExtent();
var PROJECTION = {
  code: undefined
};
var TEMP_BBOX = {
  minx: Infinity,
  miny: Infinity,
  maxx: -Infinity,
  maxy: -Infinity
};
var TEMP_CANVAS_CTX = [];
var Painter = function (_Class) {
  function Painter(geometry) {
    var _this;
    _this = _Class.call(this) || this;
    _this.geometry = geometry;
    _this.symbolizers = _this._createSymbolizers();
    _this._altAtGL = _this._getGeometryAltitude();
    _this.bbox = getDefaultBBOX();
    _this._drawTime = 0;
    return _this;
  }
  _inheritsLoose(Painter, _Class);
  var _proto = Painter.prototype;
  _proto._setDrawTime = function _setDrawTime(time) {
    this._drawTime = time;
    return this;
  };
  _proto.getRenderBBOX = function getRenderBBOX() {
    var layer = this.getLayer();
    if (layer && layer._drawTime !== this._drawTime) {
      return null;
    }
    resetBBOX(this.bbox);
    var hasDirty = false;
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      var symbolizer = this.symbolizers[i];
      if (symbolizer instanceof DrawAltitudeSymbolizer || symbolizer instanceof DebugSymbolizer) {
        continue;
      }
      var bbox = symbolizer.bbox;
      if (!validateBBOX(bbox)) {
        hasDirty = true;
        break;
      }
      setBBOX(this.bbox, bbox);
    }
    if (hasDirty) {
      return null;
    }
    if (validateBBOX(this.bbox)) {
      return this.bbox;
    }
    return null;
  };
  _proto.getMap = function getMap() {
    return this.geometry.getMap();
  };
  _proto.getLayer = function getLayer() {
    return this.geometry && this.geometry.getLayer();
  };
  _proto._createSymbolizers = function _createSymbolizers() {
    var geoSymbol = this.getSymbol(),
      symbolizers = [],
      regSymbolizers = registerSymbolizers;
    var symbols = geoSymbol;
    if (!Array.isArray(geoSymbol)) {
      symbols = [geoSymbol];
    }
    for (var ii = symbols.length - 1; ii >= 0; ii--) {
      var symbol = symbols[ii];
      for (var i = regSymbolizers.length - 1; i >= 0; i--) {
        if (regSymbolizers[i].test(symbol, this.geometry)) {
          var symbolizer = new regSymbolizers[i](symbol, this.geometry, this);
          symbolizer._index = ii;
          symbolizers.push(symbolizer);
          if (symbolizer instanceof PointSymbolizer) {
            this._hasPoint = true;
          }
        }
      }
    }
    if (!symbolizers.length) {
      if (console) {
        var id = this.geometry.getId();
        console.warn('invalid symbol for geometry(' + (this.geometry ? this.geometry.getType() + (id ? ':' + id : '') : '') + ') to draw : ' + JSON.stringify(geoSymbol));
      }
    }
    this._debugSymbolizer = new DebugSymbolizer(geoSymbol, this.geometry, this);
    return symbolizers;
  };
  _proto.hasPoint = function hasPoint() {
    return !!this._hasPoint;
  };
  _proto.getRenderPoints = function getRenderPoints(placement) {
    this._verifyProjection();
    if (!this._renderPoints) {
      this._renderPoints = {};
    }
    if (!placement) {
      placement = 'center';
    }
    if (!this._renderPoints[placement]) {
      this._renderPoints[placement] = this.geometry._getRenderPoints(placement);
    }
    return this._renderPoints[placement];
  };
  _proto.getPaintParams = function getPaintParams(dx, dy, ignoreAltitude, disableClip, ptkey = '_pt', isGround) {
    var renderer = this.getLayer()._getRenderer();
    var rendererStateCache = renderer.rendererStateCache;
    var resolution, pitch, bearing, glScale, containerExtent;
    var map = this.getMap();
    if (rendererStateCache && !this._hitPoint) {
      resolution = rendererStateCache.resolution;
      pitch = rendererStateCache.pitch;
      bearing = rendererStateCache.bearing;
      glScale = rendererStateCache.glScale;
      containerExtent = rendererStateCache.containerExtent;
    } else {
      var cache = MapStateCache[map.id];
      resolution = map.getResolution();
      pitch = cache ? cache.pitch : map.getPitch();
      bearing = cache ? cache.bearing : map.getBearing();
      glScale = map.getGLScale();
      containerExtent = map.getGroundExtent();
    }
    var geometry = this.geometry,
      res = resolution,
      pitched = pitch !== 0,
      rotated = bearing !== 0;
    var params = this._cachedParams;
    var paintAsPath = geometry._paintAsPath && geometry._paintAsPath();
    if (paintAsPath && this._unsimpledParams && res <= this._unsimpledParams._res) {
      params = this._unsimpledParams;
    } else if (!params || params._res !== resolution || this._pitched !== pitched && geometry._redrawWhenPitch() || this._rotated !== rotated && geometry._redrawWhenRotate()) {
      params = geometry._getPaintParams();
      if (!params) {
        return null;
      }
      params._res = res;
      if (!geometry._simplified && paintAsPath) {
        if (!this._unsimpledParams) {
          this._unsimpledParams = params;
        }
        if (res > this._unsimpledParams._res) {
          this._unsimpledParams._res = res;
        }
      }
      this._cachedParams = params;
    }
    if (!params) {
      return null;
    }
    this._pitched = pitched;
    this._rotated = rotated;
    var zoomScale = glScale,
      tr = [],
      points = params[0];
    var mapExtent = containerExtent;
    var isPolygon = !!geometry.getHoles;
    var cPoints = this._pointContainerPoints(points, dx, dy, ignoreAltitude, disableClip || this._hitPoint && !mapExtent.contains(this._hitPoint), null, ptkey, isPolygon, isGround);
    if (!cPoints) {
      return null;
    }
    tr.push(cPoints);
    for (var i = 1, l = params.length; i < l; i++) {
      if (isNumber(params[i]) || params[i] instanceof Size) {
        if (isNumber(params[i])) {
          tr.push(params[i] / zoomScale);
        } else {
          tr.push(params[i].multi(1 / zoomScale));
        }
      } else {
        tr.push(params[i]);
      }
    }
    return tr;
  };
  _proto._pointContainerPoints = function _pointContainerPoints(points, dx, dy, ignoreAltitude, disableClip, pointPlacement, ptkey = '_pt', isPolygon, isGround) {
    if (this._aboveCamera()) {
      return null;
    }
    var layer = this.getLayer();
    var renderer = layer._getRenderer();
    var rendererStateCache = renderer.rendererStateCache;
    var map = this.getMap(),
      geometry = this.geometry,
      containerOffset = this.containerOffset;
    var glRes, containerExtent;
    if (rendererStateCache) {
      glRes = rendererStateCache.glRes;
      containerExtent = rendererStateCache.containerExtent;
    } else {
      glRes = map.getGLRes();
      containerExtent = map.getGroundExtent();
    }
    var cPoints;
    var roundPoint = layer.options['roundPoint'];
    var minx = Infinity,
      miny = Infinity,
      maxx = -Infinity,
      maxy = -Infinity;
    var needClip = !disableClip;
    var clipBBoxBufferSize = layer.options['clipBBoxBufferSize'] || 3;
    var symbolizers = this.symbolizers;
    var enableClip = geometry.options.enableClip;
    var strictClip = geometry.options.strictClip;
    var groundClip = geometry.options.groundClip;
    var isPoint = geometry.isPoint;
    function pointsContainerPoints(viewPoints = [], alts = []) {
      var filterPoints = viewPoints;
      if (strictClip && map._currentViewGLInfo && viewPoints.length > 1 && !altitudesHasData(alts)) {
        filterPoints = [];
        var {
          lt: lt,
          rt: rt,
          rb: rb,
          lb: lb,
          RB: RB,
          LB: LB
        } = map._currentViewGLInfo;
        for (var i = 0, len = viewPoints.length; i < len; i++) {
          var point = viewPoints[i];
          var needLimit = !pointInQuadrilateral(point, lt, rt, rb, lb) && pointLeftSegment(point, RB, LB);
          if (!needLimit) {
            filterPoints.push(point);
            continue;
          }
          var pre = viewPoints[i - 1] || (isPolygon ? viewPoints[len - 1] : viewPoints[1]);
          var next = viewPoints[i + 1] || (isPolygon ? viewPoints[0] : viewPoints[len - 2]);
          if (!pre || !next) {
            filterPoints.push(point);
            continue;
          }
          var a = pointLeftSegment(pre, RB, LB);
          var b = pointLeftSegment(next, RB, LB);
          if (a && b) {
            filterPoints.push(point);
            continue;
          }
          var hasCross = false;
          if (!a) {
            var cross = lineIntersection(pre, point, RB, LB);
            if (cross) {
              filterPoints.push(cross);
              hasCross = true;
            }
          }
          if (!b) {
            var _cross = lineIntersection(next, point, RB, LB);
            if (_cross) {
              filterPoints.push(_cross);
              hasCross = true;
            }
          }
          if (!hasCross) {
            filterPoints.push(point);
          }
        }
      }
      var pts = getPointsResultPts(filterPoints, ptkey);
      pts = map._pointsAtResToContainerPoints(filterPoints, glRes, alts, pts);
      for (var _i = 0, _len = pts.length; _i < _len; _i++) {
        var p = pts[_i];
        p._sub(containerOffset);
        if (dx || dy) {
          p._add(dx || 0, dy || 0);
        }
        if (roundPoint) {
          p.x = Math.ceil(p.x);
          p.y = Math.ceil(p.y);
        }
        minx = Math.min(p.x, minx);
        miny = Math.min(p.y, miny);
        maxx = Math.max(p.x, maxx);
        maxy = Math.max(p.y, maxy);
      }
      var clipByGround = !isGround && !isPoint && (groundClip || enableClip && needClip && isDashLine(symbolizers));
      if (clipByGround) {
        TEMP_CLIP_EXTENT2.ymin = containerExtent.ymin;
        if (TEMP_CLIP_EXTENT2.ymin < clipBBoxBufferSize) {
          TEMP_CLIP_EXTENT2.ymin = containerExtent.ymin - clipBBoxBufferSize;
        }
        TEMP_CLIP_EXTENT2.xmin = containerExtent.xmin - clipBBoxBufferSize;
        TEMP_CLIP_EXTENT2.xmax = containerExtent.xmax + clipBBoxBufferSize;
        TEMP_CLIP_EXTENT2.ymax = containerExtent.ymax + clipBBoxBufferSize;
        if (geometry.getShell && geometry.getHoles) {
          return clipPolygon(pts, TEMP_CLIP_EXTENT2);
        }
        var clipPts = clipLine(pts, TEMP_CLIP_EXTENT2, false);
        if (!clipPts.length) {
          return [];
        }
        var _points = [];
        clipPts.forEach(function (clipPt) {
          var path = [];
          for (var _i2 = 0, _len2 = clipPt.length; _i2 < _len2; _i2++) {
            path[_i2] = clipPt[_i2].point;
          }
          _points.push(path);
        });
        return _points;
      }
      return pts;
    }
    var altitude = this.getAltitude();
    if (Array.isArray(points)) {
      var _geometry = this.geometry;
      var clipped;
      if (!disableClip && _geometry.options['enableClip']) {
        clipped = this._clip(points, altitude);
        if (clipped.inView) {
          needClip = false;
        }
      } else {
        clipped = {
          points: points,
          altitude: altitude
        };
      }
      var clipPoints = clipped.points;
      altitude = clipped.altitude;
      if (ignoreAltitude) {
        altitude = 0;
      }
      var alt = altitude;
      cPoints = [];
      var alts = [];
      var altitudeIsNumber = isNumber(altitude);
      for (var i = 0, l = clipPoints.length; i < l; i++) {
        var c = clipPoints[i];
        if (Array.isArray(c)) {
          if (altitudeIsNumber) {
            var _cring = pointsContainerPoints(c, altitude);
            Array.isArray(_cring[0]) ? cPoints.push(..._cring) : cPoints.push(_cring);
            continue;
          }
          var altArray = [];
          for (var ii = 0, ll = c.length; ii < ll; ii++) {
            if (Array.isArray(altitude)) {
              if (altitude[i]) {
                alt = altitude[i][ii];
              } else {
                alt = 0;
              }
            }
            altArray.push(alt);
          }
          var cring = pointsContainerPoints(c, altArray);
          Array.isArray(cring[0]) ? cPoints.push(...cring) : cPoints.push(cring);
        } else {
          if (Array.isArray(altitude)) {
            if (pointPlacement === 'vertex-last') {
              alt = altitude[altitude.length - 1 - i];
            } else if (pointPlacement === 'line') {
              alt = (altitude[i] + altitude[i + 1]) / 2;
            } else {
              alt = altitude[i];
            }
          }
          alts.push(alt);
        }
      }
      if (alts.length) {
        cPoints = pointsContainerPoints(clipPoints, alts);
      }
    } else if (points instanceof Point) {
      if (ignoreAltitude) {
        altitude = 0;
      }
      cPoints = map._pointAtResToContainerPoint(points, glRes, altitude)._sub(containerOffset);
      if (dx || dy) {
        cPoints._add(dx, dy);
      }
    }
    TEMP_BBOX.minx = minx;
    TEMP_BBOX.miny = miny;
    TEMP_BBOX.maxx = maxx;
    TEMP_BBOX.maxy = maxy;
    this._containerBbox = TEMP_BBOX;
    return cPoints;
  };
  _proto._clip = function _clip(points, altitude) {
    if (altitudesHasData(altitude)) {
      return {
        points: points,
        altitude: altitude
      };
    }
    var map = this.getMap(),
      geometry = this.geometry;
    var lineWidth = this.getSymbol()['lineWidth'];
    if (!isNumber(lineWidth)) {
      lineWidth = 4;
    }
    var renderer = this.getLayer()._getRenderer();
    var rendererStateCache = renderer.rendererStateCache;
    var _2DExtent, glExtent, pitch;
    if (rendererStateCache) {
      _2DExtent = rendererStateCache._2DExtent;
      glExtent = rendererStateCache.glExtent;
      pitch = rendererStateCache.pitch;
    } else {
      _2DExtent = map.get2DExtent();
      glExtent = map.get2DExtentAtRes(map.getGLRes());
      var cache = MapStateCache[map.id];
      pitch = cache ? cache.pitch : map.getPitch();
    }
    var extent2D = _2DExtent._expand(lineWidth);
    if (pitch > 0 && altitude) {
      var c = map.cameraLookAt;
      var pos = map.cameraPosition;
      TEMP_POINT0$2.set(pos[0], pos[1]);
      extent2D = extent2D._combine(TEMP_POINT0$2._add(sign(c[0] - pos[0]), sign(c[1] - pos[1])));
    }
    var e = this.get2DExtent(null, TEMP_CLIP_EXTENT1);
    var clipPoints = points;
    if (e.within(extent2D)) {
      return {
        points: clipPoints,
        altitude: altitude,
        inView: true
      };
    }
    var glExtent2D = glExtent._expand(lineWidth * map.getGLScale());
    TEMP_CLIP_EXTENT0.xmin = glExtent2D.xmin;
    TEMP_CLIP_EXTENT0.xmax = glExtent2D.xmax;
    TEMP_CLIP_EXTENT0.ymin = glExtent2D.ymin;
    TEMP_CLIP_EXTENT0.ymax = glExtent2D.ymax;
    var smoothness = geometry.options['smoothness'];
    if (geometry.getShell && this.geometry.getHoles && !smoothness) {
      var {
        xmin: xmin,
        ymin: ymin,
        xmax: xmax,
        ymax: ymax
      } = glExtent2D;
      var dx = Math.abs(xmax - xmin),
        dy = Math.abs(ymax - ymin);
      var r = Math.sqrt(dx * dx + dy * dy);
      var rx = (r - dx) / 2,
        ry = (r - dy) / 2;
      TEMP_CLIP_EXTENT0.xmin = glExtent2D.xmin - rx;
      TEMP_CLIP_EXTENT0.xmax = glExtent2D.xmax + rx;
      TEMP_CLIP_EXTENT0.ymin = glExtent2D.ymin - ry;
      TEMP_CLIP_EXTENT0.ymax = glExtent2D.ymax + ry;
      if (!Array.isArray(points[0])) {
        clipPoints = clipPolygon(points, TEMP_CLIP_EXTENT0);
      } else {
        clipPoints = [];
        for (var i = 0; i < points.length; i++) {
          var part = clipPolygon(points[i], TEMP_CLIP_EXTENT0);
          if (part.length) {
            clipPoints.push(part);
          }
        }
      }
    } else if (geometry.getJSONType() === 'LineString' && !smoothness) {
      if (!Array.isArray(points[0])) {
        clipPoints = clipLine(points, TEMP_CLIP_EXTENT0, false, !!smoothness);
      } else {
        clipPoints = [];
        for (var _i3 = 0; _i3 < points.length; _i3++) {
          pushIn(clipPoints, clipLine(points[_i3], TEMP_CLIP_EXTENT0, false, !!smoothness));
        }
      }
      return this._interpolateSegAlt(clipPoints, points, altitude);
    }
    return {
      points: clipPoints,
      altitude: altitude
    };
  };
  _proto._interpolateSegAlt = function _interpolateSegAlt(clipSegs, orig, altitude) {
    if (!Array.isArray(altitude)) {
      var fn = function fn(cc) {
        return cc.point;
      };
      return {
        points: clipSegs.map(function (c) {
          if (Array.isArray(c)) {
            return c.map(fn);
          }
          return c.point;
        }),
        altitude: altitude
      };
    }
    var segsWithAlt = interpolateAlt(clipSegs, orig, altitude);
    altitude = [];
    var points = segsWithAlt.map(function (p) {
      if (Array.isArray(p)) {
        var alt = [];
        var cp = p.map(function (pp) {
          alt.push(pp.altitude);
          return pp.point;
        });
        altitude.push(alt);
        return cp;
      }
      altitude.push(p.altitude);
      return p.point;
    });
    return {
      points: points,
      altitude: altitude
    };
  };
  _proto.getSymbol = function getSymbol() {
    return this.geometry._getInternalSymbol();
  };
  _proto._resetSymbolizersBBOX = function _resetSymbolizersBBOX() {
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      var symbolizer = this.symbolizers[i];
      var bbox = symbolizer.bbox;
      resetBBOX(bbox);
    }
    return this;
  };
  _proto.paint = function paint(extent, context, offset) {
    if (!this.symbolizers) {
      return;
    }
    var layer = this.getLayer();
    var renderer = layer._getRenderer();
    if (!renderer || !renderer.context && !context) {
      return;
    }
    var rendererStateCache = renderer.rendererStateCache || {
      offset: undefined
    };
    if (!this.geometry._isCheck) {
      if (extent && !extent.intersects(this.get2DExtent(renderer.resources, TEMP_PAINT_EXTENT))) {
        return;
      }
    }
    if (this._aboveCamera()) {
      return;
    }
    this.containerOffset = offset || rendererStateCache.offset;
    if (!this.containerOffset) {
      var map = this.getMap();
      this.containerOffset = map._pointToContainerPoint(renderer.middleWest)._add(0, -map.height / 2);
    }
    this._beforePaint();
    var ctx = context || renderer.context;
    if (!ctx.isHitTesting) {
      this._resetSymbolizersBBOX();
    }
    TEMP_CANVAS_CTX[0] = ctx;
    TEMP_CANVAS_CTX[1] = renderer.resources;
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      if (ctx.shadowBlur || this.symbolizers[i].symbol['shadowBlur']) {
        this._prepareShadow(ctx, this.symbolizers[i].symbol);
      }
      this.symbolizers[i].symbolize(...TEMP_CANVAS_CTX);
    }
    this._afterPaint();
    this._painted = true;
    var isClip = ctx.isClip || ctx.isMultiClip;
    if (!isClip && (this.geometry.options['debug'] || layer.options['debug'])) {
      this._debugSymbolizer.symbolize(ctx);
    }
  };
  _proto.getSprite = function getSprite(resources, canvasClass) {
    if (!this.geometry.isPoint) {
      return null;
    }
    this._spriting = true;
    if (!this._sprite && this.symbolizers.length > 0) {
      var extent = new PointExtent();
      this.symbolizers.forEach(function (s) {
        var markerExtent = s.getFixedExtent(resources);
        extent._combine(markerExtent);
      });
      var origin = extent.getMin().multi(-1);
      var clazz = canvasClass || (this.getMap() ? this.getMap().CanvasClass : null);
      var canvas = Canvas.createCanvas(extent.getWidth(), extent.getHeight(), clazz);
      var bak;
      if (this._renderPoints) {
        bak = this._renderPoints;
      }
      var ctx = canvas.getContext('2d');
      var contexts = [ctx, resources];
      for (var i = this.symbolizers.length - 1; i >= 0; i--) {
        var dxdy = this.symbolizers[i].getDxDy();
        this._renderPoints = {
          'center': [[origin.add(dxdy)]]
        };
        this._prepareShadow(ctx, this.symbolizers[i].symbol);
        this.symbolizers[i].symbolize(...contexts);
      }
      if (bak) {
        this._renderPoints = bak;
      }
      this._sprite = {
        'canvas': canvas,
        'offset': extent.getCenter()
      };
    }
    this._spriting = false;
    return this._sprite;
  };
  _proto.isSpriting = function isSpriting() {
    return !!this._spriting;
  };
  _proto.hitTest = function hitTest(cp, tolerance) {
    if (!tolerance || tolerance < 0.5) {
      tolerance = 0.5;
    }
    this._hitPoint = cp.sub(tolerance, tolerance);
    if (!testCanvas) {
      var canvasClass = this.getMap() ? this.getMap().CanvasClass : null;
      testCanvas = Canvas.createCanvas(1, 1, canvasClass);
    }
    Canvas.setHitTesting(true);
    testCanvas.width = testCanvas.height = 2 * tolerance;
    var ctx = Canvas.getCanvas2DContext(testCanvas);
    ctx.isHitTesting = true;
    try {
      this.paint(null, ctx, this._hitPoint);
    } finally {
      Canvas.setHitTesting(false);
    }
    delete this._hitPoint;
    try {
      var imgData = ctx.getImageData(0, 0, testCanvas.width, testCanvas.height).data;
      for (var i = 3, l = imgData.length; i < l; i += 4) {
        if (imgData[i] > 0) {
          return true;
        }
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };
  _proto.isHitTesting = function isHitTesting() {
    return !!this._hitPoint;
  };
  _proto._prepareShadow = function _prepareShadow(ctx, symbol) {
    if (symbol['shadowBlur']) {
      ctx.shadowBlur = this.isHitTesting() ? 0 : symbol['shadowBlur'];
      ctx.shadowColor = symbol['shadowColor'] || '#000';
      ctx.shadowOffsetX = symbol['shadowOffsetX'] || 0;
      ctx.shadowOffsetY = symbol['shadowOffsetY'] || 0;
    } else if (ctx.shadowBlur) {
      ctx.shadowBlur = null;
      ctx.shadowColor = null;
      ctx.shadowOffsetX = null;
      ctx.shadowOffsetY = null;
    }
  };
  _proto._eachSymbolizer = function _eachSymbolizer(fn, context) {
    if (!this.symbolizers) {
      return;
    }
    if (!context) {
      context = this;
    }
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      fn.apply(context, [this.symbolizers[i]]);
    }
  };
  _proto.get2DExtent = function get2DExtent(resources, out) {
    this._verifyProjection();
    var map = this.getMap();
    resources = resources || this.getLayer()._getRenderer().resources;
    var cache = MapStateCache[map.id];
    var zoom = cache ? cache.zoom : map.getZoom();
    var isDynamicSize = this._isDynamicSize();
    if (!this._extent2D || this._extent2D._zoom !== zoom || !this._fixedExtent) {
      if (this._extent2D && this._extent2D._zoom !== zoom) {
        delete this._extent2D;
      }
      if (this.symbolizers) {
        if (!this._extent2D) {
          this._extent2D = this._computeExtent2D(new PointExtent());
          this._extent2D._zoom = zoom;
        }
        if (!this._fixedExtent) {
          this._fixedExtent = this._computeFixedExtent(resources, new PointExtent());
        }
      }
    }
    if (!this._extent2D) {
      if (isDynamicSize) {
        delete this._fixedExtent;
      }
      return null;
    }
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = this._fixedExtent;
    if (isDynamicSize) {
      delete this._fixedExtent;
    }
    TEMP_FIXED_EXTENT.set(xmin, -ymax, xmax, -ymin);
    if (out) {
      out.set(this._extent2D['xmin'], this._extent2D['ymin'], this._extent2D['xmax'], this._extent2D['ymax']);
      out._add(TEMP_FIXED_EXTENT);
      return out;
    }
    return this._extent2D.add(TEMP_FIXED_EXTENT);
  };
  _proto._computeExtent2D = function _computeExtent2D(extent) {
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      var symbolizer = this.symbolizers[i];
      extent._combine(symbolizer.get2DExtent());
    }
    return extent;
  };
  _proto._computeFixedExtent = function _computeFixedExtent(resources, extent) {
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      var symbolizer = this.symbolizers[i];
      if (symbolizer.getFixedExtent) {
        extent._combine(symbolizer.getFixedExtent(resources));
      }
    }
    return extent;
  };
  _proto._isDynamicSize = function _isDynamicSize() {
    for (var i = this.symbolizers.length - 1; i >= 0; i--) {
      var symbolizer = this.symbolizers[i];
      if (symbolizer.isDynamicSize()) {
        return true;
      }
    }
    return false;
  };
  _proto._aboveCamera = function _aboveCamera() {
    var altitude = this.getMinAltitude();
    var map = this.getMap();
    var glRes = map.getGLRes();
    altitude = map.altitudeToPoint(altitude, glRes) * sign(altitude);
    var frustumAlt = map.getFrustumAltitude();
    return altitude && frustumAlt && frustumAlt < altitude;
  };
  _proto.getFixedExtent = function getFixedExtent() {
    var map = this.getMap();
    var cache = MapStateCache[map.id];
    var zoom = cache ? cache.zoom : map.getZoom();
    if (this._isDynamicSize()) {
      return this._computeFixedExtent(null, new PointExtent());
    }
    if (!this._extent2D || this._extent2D._zoom !== zoom) {
      this.get2DExtent(null, TEMP_FIXED_EXTENT);
    }
    return this._fixedExtent;
  };
  _proto.setZIndex = function setZIndex(change) {
    this._eachSymbolizer(function (symbolizer) {
      symbolizer.setZIndex(change);
    });
  };
  _proto.show = function show() {
    if (!this._painted) {
      var layer = this.getLayer();
      if (!layer.isCanvasRender()) {
        this.paint();
      }
    } else {
      this.removeCache();
      this._eachSymbolizer(function (symbolizer) {
        symbolizer.show();
      });
    }
  };
  _proto.hide = function hide() {
    this._eachSymbolizer(function (symbolizer) {
      symbolizer.hide();
    });
  };
  _proto.repaint = function repaint() {
    this._altAtGL = this._getGeometryAltitude();
    this.removeCache();
    var layer = this.getLayer();
    if (!layer) {
      return;
    }
    var renderer = layer.getRenderer();
    if (!renderer || !renderer.setToRedraw()) {
      return;
    }
    renderer.setToRedraw();
  };
  _proto.refreshSymbol = function refreshSymbol() {
    this.removeCache();
    this._removeSymbolizers();
    this.symbolizers = this._createSymbolizers();
  };
  _proto.remove = function remove() {
    this.removeCache();
    this._removeSymbolizers();
  };
  _proto._removeSymbolizers = function _removeSymbolizers() {
    this._eachSymbolizer(function (symbolizer) {
      delete symbolizer.painter;
      symbolizer.remove();
    });
    delete this.symbolizers;
  };
  _proto.removeCache = function removeCache() {
    delete this._renderPoints;
    delete this._paintParams;
    delete this._sprite;
    delete this._extent2D;
    delete this._fixedExtent;
    delete this._cachedParams;
    delete this._unsimpledParams;
  };
  _proto.getAltitude = function getAltitude() {
    var propAlt = this.geometry._getAltitude();
    if (propAlt !== this._propAlt) {
      this._altAtGL = this._getGeometryAltitude();
    }
    if (!this._altAtGL) {
      return 0;
    }
    return this._altAtGL;
  };
  _proto.getMinAltitude = function getMinAltitude() {
    if (!this.minAltitude) {
      return 0;
    }
    return this.minAltitude;
  };
  _proto.getMaxAltitude = function getMaxAltitude() {
    if (!this.maxAltitude) {
      return 0;
    }
    return this.maxAltitude;
  };
  _proto._getGeometryAltitude = function _getGeometryAltitude() {
    var map = this.getMap();
    if (!map) {
      return 0;
    }
    var altitude = this.geometry._getAltitude();
    this._propAlt = altitude;
    var [min, max] = getMinMaxAltitude(altitude);
    this.minAltitude = min;
    this.maxAltitude = max;
    if (!altitude) {
      return 0;
    }
    var center = this.geometry.getCenter();
    if (!center) {
      return 0;
    }
    return altitude;
  };
  _proto._verifyProjection = function _verifyProjection() {
    var projection = this.geometry._getProjection() || PROJECTION;
    if (this._projCode && this._projCode !== projection.code) {
      this.removeCache();
    }
    this._projCode = projection.code;
  };
  _proto._beforePaint = function _beforePaint() {};
  _proto._afterPaint = function _afterPaint() {};
  _proto.getPathTempRenderPoints = function getPathTempRenderPoints() {
    var symbolizers = this.symbolizers || [];
    for (var i = 0, len = symbolizers.length; i < len; i++) {
      var symbolizer = this.symbolizers[i];
      if (symbolizer instanceof StrokeAndFillSymbolizer && symbolizer._tempRenderPoints) {
        return symbolizer._tempRenderPoints;
      }
    }
  };
  return Painter;
}(Class);
function interpolateAlt(points, orig, altitude) {
  if (!Array.isArray(altitude)) {
    return points;
  }
  var parts = [];
  for (var i = 0, l = points.length; i < l; i++) {
    if (Array.isArray(points[i])) {
      parts.push(interpolateAlt(points[i], orig, altitude));
    } else {
      var p = points[i];
      if (!p.point.equals(orig[p.index])) {
        var w0 = void 0,
          w1 = void 0;
        if (p.index === 0) {
          w0 = p.index;
          w1 = p.index + 1;
        } else {
          w0 = p.index - 1;
          w1 = p.index;
        }
        var t0 = p.point.distanceTo(orig[w1]);
        var t = t0 / (t0 + orig[w0].distanceTo(p.point));
        var alt = interpolate$3(altitude[w0], altitude[w1], 1 - t);
        p.altitude = alt;
        parts.push(p);
      } else {
        p.altitude = altitude[p.index];
        parts.push(p);
      }
    }
  }
  return parts;
}

var TEMP_EXTENT$5 = new PointExtent();
var CollectionPainter = function (_Class) {
  function CollectionPainter(geometry, isMask) {
    var _this;
    _this = _Class.call(this) || this;
    _this.geometry = geometry;
    _this.isMask = isMask;
    _this.bbox = getDefaultBBOX();
    _this._drawTime = 0;
    return _this;
  }
  _inheritsLoose(CollectionPainter, _Class);
  var _proto = CollectionPainter.prototype;
  _proto._setDrawTime = function _setDrawTime(time) {
    this._drawTime = time;
    this._eachPainter(function (painter) {
      painter._setDrawTime(time);
    });
    return this;
  };
  _proto.getRenderBBOX = function getRenderBBOX() {
    var _this2 = this;
    var layer = this.getLayer();
    if (layer && layer._drawTime !== this._drawTime) {
      return null;
    }
    resetBBOX(this.bbox);
    var hasDirty = false;
    this._eachPainter(function (painter) {
      var bbox = painter.getRenderBBOX();
      if (!validateBBOX(bbox)) {
        hasDirty = true;
        return;
      }
      setBBOX(_this2.bbox, bbox);
    });
    if (hasDirty) {
      return null;
    }
    if (validateBBOX(this.bbox)) {
      return this.bbox;
    }
    return null;
  };
  _proto._eachPainter = function _eachPainter(fn) {
    var geometries = this.geometry.getGeometries();
    var painter;
    for (var i = 0, len = geometries.length; i < len; i++) {
      painter = this.isMask ? geometries[i]._getMaskPainter() : geometries[i]._getPainter();
      if (!painter) {
        continue;
      }
      if (painter) {
        if (fn.call(this, painter) === false) {
          break;
        }
      }
    }
  };
  _proto.getLayer = function getLayer() {
    return this.geometry && this.geometry.getLayer();
  };
  _proto.paint = function paint(extent) {
    if (!this.geometry) {
      return;
    }
    this._eachPainter(function (painter) {
      painter.paint(extent);
    });
  };
  _proto.get2DExtent = function get2DExtent(resources, out) {
    if (out) {
      out.set(null, null, null, null);
    }
    var extent = out || new PointExtent();
    this._eachPainter(function (painter) {
      extent = extent._combine(painter.get2DExtent(resources, TEMP_EXTENT$5));
    });
    return extent;
  };
  _proto.remove = function remove() {
    this._eachPainter(function (painter) {
      painter.remove();
    });
  };
  _proto.setZIndex = function setZIndex(index) {
    this._eachPainter(function (painter) {
      painter.setZIndex(index);
    });
  };
  _proto.show = function show() {
    this._eachPainter(function (painter) {
      painter.show();
    });
  };
  _proto.hide = function hide() {
    this._eachPainter(function (painter) {
      painter.hide();
    });
  };
  _proto.repaint = function repaint() {
    this._eachPainter(function (painter) {
      painter.repaint();
    });
  };
  _proto.refreshSymbol = function refreshSymbol() {
    this._eachPainter(function (painter) {
      painter.refreshSymbol();
    });
  };
  _proto.hasPoint = function hasPoint() {
    var result = false;
    this._eachPainter(function (painter) {
      if (painter.hasPoint()) {
        result = true;
        return false;
      }
      return true;
    });
    return result;
  };
  _proto.getMinAltitude = function getMinAltitude() {
    var first = true;
    var result = 0;
    this._eachPainter(function (painter) {
      var alt = painter.getMinAltitude();
      if (first || alt < result) {
        first = false;
        result = alt;
      }
    });
    return result;
  };
  _proto.getMaxAltitude = function getMaxAltitude() {
    var result = 0;
    this._eachPainter(function (painter) {
      var alt = painter.getMaxAltitude();
      if (alt > result) {
        result = alt;
      }
    });
    return result;
  };
  return CollectionPainter;
}(Class);

function getProjectionCode(code) {
  var newcode = '';
  var codeArray = code.split('');
  for (var len = codeArray.length, i = len - 1; i >= 0; i--) {
    if (!isNaN(codeArray[i])) {
      newcode = codeArray[i] + newcode;
    } else {
      break;
    }
  }
  return newcode;
}
function getProjection(projection) {
  var prj = projection.indexOf('EPSG') > -1 ? projection : 'EPSG:' + projection;
  prj = strReplace(prj, [['4490', '4326'], ['102100', '3857'], ['900913', '3857']]);
  return prj;
}
function strReplace(str, repArray = []) {
  repArray.forEach(function (rep) {
    var [template, value] = rep;
    str = str.replace(template, value);
  });
  return str;
}
function getTransformValue(options) {
  var {
    projection: projection,
    isArcgis: isArcgis,
    isGeoServer: isGeoServer,
    isSuperMap: isSuperMap
  } = options;
  var transformValue = 0.0002645833333333333;
  if (isArcgis || isGeoServer || isSuperMap) {
    transformValue = 0.00028;
  }
  if (projection && projection.indexOf('4326') > -1) {
    transformValue = 2.3767925226029154e-9;
    if (isArcgis || isSuperMap) {
      transformValue = 2.518101729011901e-9;
    }
    if (isGeoServer) {
      transformValue = 2.51528279553466e-9;
    }
  }
  return transformValue;
}
var ns = 'wmts';
function getElementsByTagName(element, localName) {
  var result = element.getElementsByTagName(localName);
  if (result && result.length) {
    return result;
  }
  var name = ns + ':' + localName;
  return element.getElementsByTagName(name);
}
function getTileMatrixSet(TileMatrixSets, TileMatrixSetLink) {
  for (var i = 0; i < TileMatrixSets.length; i++) {
    var TileMatrixSet = TileMatrixSets[i];
    TileMatrixSet = TileMatrixSet.getElementsByTagName('ows:Identifier')[0];
    if (TileMatrixSet) {
      if (TileMatrixSet.textContent === TileMatrixSetLink) {
        return TileMatrixSets[i];
      }
    }
  }
  return null;
}
function parseWMTSXML(str, requestUrl, options) {
  var serviceType = ["isArcgis", "isSuperMap", "isGeoServer"];
  if (serviceType.every(function (key) {
    return options[key] == null;
  })) {
    console.warn("Please specify the server type, such as isArcgis, isSuperMap, isGeoServer, Otherwise, the system will determine by itself");
  }
  if (options.isArcgis == null) {
    options.isArcgis = ["arcgis", "geoscene"].some(function (key) {
      return str.indexOf(key) > -1;
    });
  }
  if (options.isSuperMap == null) {
    options.isSuperMap = str.indexOf('supermap') > -1;
  }
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(str, 'text/xml');
  var content = xmlDoc.querySelectorAll('Contents')[0];
  if (!content) {
    return [];
  }
  var layers = getElementsByTagName(content, 'Layer');
  if (!layers.length) {
    return [];
  }
  var TileMatrixSets = [];
  for (var i = 0, len = content.childNodes.length; i < len; i++) {
    if (content.childNodes[i].localName === 'TileMatrixSet') {
      TileMatrixSets.push(content.childNodes[i]);
    }
  }
  if (!TileMatrixSets.length) {
    return [];
  }
  var result = [];
  for (var _i = 0, _len = layers.length; _i < _len; _i++) {
    var layer = layers[_i];
    var style = layer.querySelectorAll('Style')[0];
    if (style) {
      style = style.getElementsByTagName('ows:Identifier')[0];
      if (style) {
        style = style.textContent;
      }
    }
    var layerName = layer.getElementsByTagName('ows:Identifier')[0];
    if (layerName) {
      layerName = layerName.textContent;
    }
    var tileMatrixSetLinks = getElementsByTagName(layer, 'TileMatrixSetLink');
    if (tileMatrixSetLinks.length === 0) {
      continue;
    }
    for (var j = 0, len1 = tileMatrixSetLinks.length; j < len1; j++) {
      var tileMatrixSetLink = tileMatrixSetLinks[j];
      tileMatrixSetLink = getElementsByTagName(tileMatrixSetLink, 'TileMatrixSet')[0];
      if (tileMatrixSetLink) {
        tileMatrixSetLink = tileMatrixSetLink.textContent;
      }
      var tileMatrixSet = getTileMatrixSet(TileMatrixSets, tileMatrixSetLink);
      if (!tileMatrixSet) {
        continue;
      }
      var resourceURL = layer.querySelectorAll('ResourceURL')[0];
      var url = '';
      if (resourceURL) {
        url = resourceURL.attributes.template.value;
      }
      var {
        resolutions: resolutions,
        tileSize: tileSize,
        tileSystem: tileSystem,
        projection: projection,
        TileMatrixSet: TileMatrixSet,
        isGeoServer: isGeoServer,
        levelStr: levelStr
      } = parseTileMatrixSet(tileMatrixSet, options);
      if (!url.length) {
        url = requestUrl.substr(0, requestUrl.lastIndexOf('?'));
        url += '?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER={LAYER}&STYLE={Style}&TILEMATRIXSET={TileMatrixSet}&FORMAT={tiles}&TILEMATRIX={TileMatrix}&TILEROW={TileRow}&TILECOL={TileCol}';
      }
      var urlTemplate = strReplace(url, [['{LAYER}', layerName], ['{Layer}', layerName], ['{layer}', layerName], ['{STYLE}', style], ['{Style}', style], ['{style}', style], ['{TileMatrixSet}', TileMatrixSet], ['{TileMatrix}', isGeoServer ? levelStr + ":{z}" : '{z}'], ['{TileRow}', '{y}'], ['{TileCol}', '{x}'], ['{tiles}', isGeoServer ? 'image/png' : 'tiles']]);
      result.push({
        tileSize: tileSize,
        tileSystem: tileSystem,
        spatialReference: {
          resolutions: resolutions,
          projection: projection
        },
        urlTemplate: urlTemplate,
        info: {
          layerName: layerName,
          TileMatrixSet: TileMatrixSet,
          style: style,
          tileSize: tileSize,
          tileSystem: tileSystem,
          resolutions: resolutions,
          projection: projection,
          urlTemplate: urlTemplate
        }
      });
    }
  }
  return result;
}
function parseTileMatrixSet(TileMatrixSet, options = {}) {
  var TileMatrixs = getElementsByTagName(TileMatrixSet, 'TileMatrix');
  var resolutions = [],
    tileSystem = [],
    tileSize = [];
  var projection,
    tset,
    isGeoServer = false,
    levelStr;
  if (!projection) {
    var supportedCRS = TileMatrixSet.getElementsByTagName('ows:SupportedCRS')[0];
    if (supportedCRS) {
      projection = supportedCRS.textContent;
      projection = projection.split('EPSG')[1];
      projection = getProjectionCode(projection);
      projection = getProjection(projection);
    }
  }
  if (!tset) {
    tset = TileMatrixSet.getElementsByTagName('ows:Identifier')[0];
    if (tset) {
      tset = tset.textContent;
    }
  }
  options.projection = projection;
  var minLevel = Infinity;
  for (var index = 0; index < TileMatrixs.length; index++) {
    var TileMatrix = TileMatrixs[index];
    var level = TileMatrix.getElementsByTagName('ows:Identifier')[0].textContent;
    if (isNaN(parseInt(level))) {
      levelStr = level.substr(0, level.lastIndexOf(':'));
      level = level.split(':');
      level = level[level.length - 1];
      level = parseInt(level);
      isGeoServer = true;
      options.isGeoServer = true;
    } else {
      level = parseInt(level);
    }
    minLevel = Math.min(minLevel, level);
    var ScaleDenominator = getElementsByTagName(TileMatrix, 'ScaleDenominator')[0].textContent;
    var TopLeftCorner = getElementsByTagName(TileMatrix, 'TopLeftCorner')[0].textContent;
    var TileWidth = getElementsByTagName(TileMatrix, 'TileWidth')[0].textContent;
    var TileHeight = getElementsByTagName(TileMatrix, 'TileHeight')[0].textContent;
    if (tileSize.length === 0) {
      tileSize.push(parseInt(TileWidth), parseInt(TileHeight));
    }
    if (tileSystem.length === 0) {
      var [x, y] = TopLeftCorner.split(' ').filter(function (s) {
        return s !== '';
      }).map(function (v) {
        return parseFloat(v);
      });
      if (x > 0) {
        tileSystem.push(1, -1, y, x);
      } else {
        tileSystem.push(1, -1, x, y);
      }
    }
    var transformValue = getTransformValue(options);
    var res = parseFloat(ScaleDenominator) * transformValue;
    resolutions.push(res);
  }
  if (minLevel > 0) {
    var _res = resolutions[0];
    for (var i = minLevel - 1; i >= 0; i--) {
      _res = _res * 2;
      resolutions.splice(0, 0, _res);
    }
  }
  return {
    resolutions: resolutions,
    tileSize: tileSize,
    tileSystem: tileSystem,
    projection: projection,
    TileMatrixSet: tset,
    isGeoServer: isGeoServer,
    levelStr: levelStr
  };
}
var loadWMTS = function loadWMTS(url, cb, options = {
  'jsonp': true
}) {
  if (isString(url)) {
    Ajax.get(url, function (err, xml) {
      if (err) {
        cb(err);
        return;
      }
      var layers = parseWMTSXML(xml, url, options);
      cb(null, layers);
    }, options);
  }
};

function parse(arcConf) {
  var tileInfo = arcConf['tileInfo'],
    tileSize = [tileInfo['cols'], tileInfo['rows']],
    resolutions = [],
    lods = tileInfo['lods'];
  for (var i = 0, len = lods.length; i < len; i++) {
    resolutions.push(lods[i]['resolution']);
  }
  var fullExtent = arcConf['fullExtent'],
    origin = tileInfo['origin'],
    tileSystem = [1, -1, origin['x'], origin['y']];
  delete fullExtent['spatialReference'];
  return {
    'spatialReference': {
      'resolutions': resolutions,
      'fullExtent': fullExtent
    },
    'tileSystem': tileSystem,
    'tileSize': tileSize
  };
}
var loadArcgis = function loadArcgis(url, cb, options = {
  'jsonp': true
}) {
  if (isString(url) && url.substring(0, 1) !== '{') {
    Ajax.getJSON(url, function (err, json) {
      if (err) {
        cb(err);
        return;
      }
      var spatialRef = parse(json);
      cb(null, spatialRef);
    }, options);
  } else {
    if (isString(url)) {
      url = parseJSON(url);
    }
    var spatialRef = parse(url);
    cb(null, spatialRef);
  }
};

var DEFAULT_CRS;
function createOrGetDefaultSpatialReferences() {
  if (!DEFAULT_CRS) {
    var crsMaxNativeZoom = Math.round(GlobalConfig.crsMaxNativeZoom || 22);
    DEFAULT_CRS = {
      'EPSG:3857': {
        'projection': 'EPSG:3857',
        'resolutions': function () {
          var resolutions = [];
          var d = 2 * 6378137 * Math.PI;
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = d / (256 * Math.pow(2, i));
          }
          return resolutions;
        }(),
        'fullExtent': {
          'top': 6378137 * Math.PI,
          'left': -6378137 * Math.PI,
          'bottom': -6378137 * Math.PI,
          'right': 6378137 * Math.PI
        }
      },
      'EPSG:4326': {
        'projection': 'EPSG:4326',
        'fullExtent': {
          'top': 90,
          'left': -180,
          'bottom': -90,
          'right': 180
        },
        'resolutions': function () {
          var resolutions = [];
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = 180 / (Math.pow(2, i) * 128);
          }
          return resolutions;
        }()
      },
      'BAIDU': {
        'projection': 'baidu',
        'resolutions': function () {
          var res = Math.pow(2, 18);
          var resolutions = [];
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = res;
            res *= 0.5;
          }
          return resolutions;
        }(),
        'fullExtent': {
          'top': 33554432,
          'left': -33554432,
          'bottom': -33554432,
          'right': 33554432
        }
      },
      'IDENTITY': {
        'projection': 'identity',
        'resolutions': function () {
          var res = Math.pow(2, 8);
          var resolutions = [];
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = res;
            res *= 0.5;
          }
          return resolutions;
        }(),
        'fullExtent': {
          'top': 200000,
          'left': -200000,
          'bottom': -200000,
          'right': 200000
        }
      },
      'PRESET-VT-3857': {
        'projection': 'EPSG:3857',
        'resolutions': function () {
          var resolutions = [];
          var d = 6378137 * Math.PI;
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = d / (256 * Math.pow(2, i));
          }
          return resolutions;
        }(),
        'fullExtent': {
          'top': 6378137 * Math.PI,
          'left': -6378137 * Math.PI,
          'bottom': -6378137 * Math.PI,
          'right': 6378137 * Math.PI
        }
      },
      'PRESET-VT-4326': {
        'projection': 'EPSG:4326',
        'fullExtent': {
          'top': 90,
          'left': -180,
          'bottom': -90,
          'right': 180
        },
        'resolutions': function () {
          var resolutions = [];
          for (var i = 0; i <= crsMaxNativeZoom; i++) {
            resolutions[i] = 180 / 4 / (Math.pow(2, i) * 128);
          }
          return resolutions;
        }()
      }
    };
    DEFAULT_CRS['EPSG:4490'] = DEFAULT_CRS['EPSG:4326'];
    DEFAULT_CRS['PRESET-3857-512'] = DEFAULT_CRS['PRESET-VT-3857'];
    DEFAULT_CRS['PRESET-4326-512'] = DEFAULT_CRS['PRESET-VT-4326'];
    DEFAULT_CRS['PRESET-4490-512'] = DEFAULT_CRS['PRESET-VT-4326'];
  }
  return DEFAULT_CRS;
}
var SpatialReference = function () {
  function SpatialReference(options = {}) {
    this.options = options;
    this._initSpatialRef();
  }
  SpatialReference.registerPreset = function registerPreset(name, value) {
    name = name && name.toUpperCase();
    var defaultRefs = createOrGetDefaultSpatialReferences();
    if (defaultRefs[name]) {
      console.warn("Spatial reference " + name + " already registered.");
    }
    defaultRefs[name] = value;
  };
  SpatialReference.getPreset = function getPreset(preset) {
    return createOrGetDefaultSpatialReferences()[preset.toUpperCase()];
  };
  SpatialReference.getAllPresets = function getAllPresets() {
    return Object.keys(createOrGetDefaultSpatialReferences());
  };
  SpatialReference.loadArcgis = function loadArcgis$1(url, cb, options) {
    loadArcgis(url, cb, options);
    return this;
  };
  SpatialReference.loadWMTS = function loadWMTS$1(url, cb, options) {
    loadWMTS(url, cb, options);
    return this;
  };
  SpatialReference.getProjectionInstance = function getProjectionInstance(projection) {
    var proj;
    if (!projection) {
      return null;
    }
    if (isString(projection)) {
      proj = {
        code: projection
      };
    } else {
      proj = projection;
    }
    if (proj.project) {
      if (!proj.locate) {
        proj = extend$2({}, proj);
        if (proj.measure === 'identity') {
          extend$2(proj, Measurer.getInstance('IDENTITY'));
        } else {
          extend$2(proj, Measurer.getInstance('EPSG:4326'));
        }
      }
      return proj;
    }
    var prjName = (proj.code + '').toLowerCase();
    for (var p in projections) {
      if (hasOwn(projections, p)) {
        var names = projections[p].aliases || [];
        var code = projections[p]['code'];
        if (code) {
          names.push(code);
        }
        for (var i = 0; i < names.length; i++) {
          if (names[i].toLowerCase() === prjName) {
            if (projections[p].create) {
              var instance = projections[p].create(projection);
              instance.code = names[i];
              return instance;
            } else {
              if (projections[p].code === names[i]) {
                return projections[p];
              }
              var _instance = extend$2({}, projections[p]);
              _instance.code = names[i];
              return _instance;
            }
          }
        }
      }
    }
    return null;
  };
  SpatialReference.equals = function equals(sp1, sp2) {
    if (isString(sp1) || isString(sp2)) {
      return sp1 === sp2;
    }
    if (!sp1 && !sp2) {
      return true;
    } else if (!sp1 || !sp2) {
      return false;
    }
    if (sp1.projection !== sp2.projection) {
      return false;
    }
    var f1 = sp1.fullExtent,
      f2 = sp2.fullExtent;
    if (f1 && !f2 || !f1 && f2) {
      return false;
    }
    if (f1 && f2) {
      if (f1.top !== f2.top || f1.bottom !== f2.bottom || f1.left !== f2.left || f1.right !== f2.right) {
        return false;
      }
    }
    var r1 = sp1.resolutions,
      r2 = sp2.resolutions;
    if (r1 && r2) {
      if (r1.length !== r2.length) {
        return false;
      }
      for (var i = 0; i < r1.length; i++) {
        if (r1[i] !== r2[i]) {
          return false;
        }
      }
    } else if (r1 || r2) {
      return false;
    }
    return true;
  };
  var _proto = SpatialReference.prototype;
  _proto._initSpatialRef = function _initSpatialRef() {
    var projection;
    if (this.options['projection']) {
      projection = SpatialReference.getProjectionInstance(this.options['projection']);
    } else {
      projection = DEFAULT;
    }
    if (!projection) {
      throw new Error('must provide a valid projection in map\'s spatial reference.');
    }
    projection = extend$2({}, CommonProjection, projection);
    if (!projection.measureLength) {
      extend$2(projection, DEFAULT$1);
    }
    this._projection = projection;
    var systemSpatialRefs = createOrGetDefaultSpatialReferences();
    var defaultSpatialRef,
      resolutions = this.options['resolutions'];
    if (!resolutions) {
      if (projection['code']) {
        defaultSpatialRef = systemSpatialRefs[projection['code'].toUpperCase()];
        if (defaultSpatialRef) {
          resolutions = defaultSpatialRef['resolutions'];
          this.isEPSG = projection['code'] !== 'IDENTITY';
        }
      }
      if (!resolutions) {
        throw new Error('must provide valid resolutions in map\'s spatial reference.');
      }
    }
    this._resolutions = resolutions;
    this._pyramid = true;
    if (this._pyramid) {
      var delta = 1E4;
      for (var i = 0; i < resolutions.length; i++) {
        if (resolutions[i] && resolutions[i - 1]) {
          if (Math.round(resolutions[i - 1] / resolutions[i] * delta) / delta !== 2) {
            this._pyramid = false;
            break;
          }
        }
      }
    }
    var fullExtent = this.options['fullExtent'];
    if (!fullExtent) {
      if (projection['code']) {
        defaultSpatialRef = systemSpatialRefs[projection['code'].toUpperCase()];
        if (defaultSpatialRef) {
          fullExtent = defaultSpatialRef['fullExtent'];
        }
      }
      if (!fullExtent) {
        throw new Error('must provide a valid fullExtent in map\'s spatial reference.');
      }
    }
    if (!isNil(fullExtent['left'])) {
      this._fullExtent = new Extent(new Coordinate(fullExtent['left'], fullExtent['top']), new Coordinate(fullExtent['right'], fullExtent['bottom']));
    } else {
      this._fullExtent = new Extent(fullExtent);
      fullExtent['left'] = fullExtent['xmin'];
      fullExtent['right'] = fullExtent['xmax'];
      fullExtent['top'] = fullExtent['ymax'];
      fullExtent['bottom'] = fullExtent['ymin'];
    }
    if (isNil(fullExtent['top']) || isNil(fullExtent['bottom']) || isNil(fullExtent['left']) || isNil(fullExtent['right'])) {
      throw new Error('must provide valid top/bottom/left/right in fullExtent.');
    }
    extend$2(this._fullExtent, fullExtent);
    this._projection.fullExtent = fullExtent;
    var a = fullExtent['right'] >= fullExtent['left'] ? 1 : -1,
      b = fullExtent['top'] >= fullExtent['bottom'] ? -1 : 1;
    this._transformation = new Transformation([a, b, 0, 0]);
  };
  _proto.getResolutions = function getResolutions() {
    return this._resolutions || [];
  };
  _proto.getResolution = function getResolution(zoom) {
    var z = zoom | 0;
    if (z < 0) {
      z = 0;
    } else if (z > this._resolutions.length - 1) {
      z = this._resolutions.length - 1;
    }
    var res = this._resolutions[z];
    if (z !== zoom && zoom > 0 && z < this._resolutions.length - 1) {
      var next = this._resolutions[z + 1];
      return res + (next - res) * (zoom - z);
    }
    return res;
  };
  _proto.getProjection = function getProjection() {
    return this._projection;
  };
  _proto.getFullExtent = function getFullExtent() {
    return this._fullExtent;
  };
  _proto.getTransformation = function getTransformation() {
    return this._transformation;
  };
  _proto.getMinZoom = function getMinZoom() {
    for (var i = 0; i < this._resolutions.length; i++) {
      if (!isNil(this._resolutions[i])) {
        return i;
      }
    }
    return 0;
  };
  _proto.getMaxZoom = function getMaxZoom() {
    for (var i = this._resolutions.length - 1; i >= 0; i--) {
      if (!isNil(this._resolutions[i])) {
        return i;
      }
    }
    return this._resolutions.length - 1;
  };
  _proto.getZoomDirection = function getZoomDirection() {
    return sign(this._resolutions[this.getMinZoom()] - this._resolutions[this.getMaxZoom()]);
  };
  _proto.toJSON = function toJSON() {
    if (!this.json) {
      this.json = {
        'resolutions': this._resolutions,
        'fullExtent': {
          'top': this._fullExtent.top,
          'left': this._fullExtent.left,
          'bottom': this._fullExtent.bottom,
          'right': this._fullExtent.right
        },
        'projection': this._projection.code
      };
    }
    return this.json;
  };
  _proto.isPyramid = function isPyramid() {
    return this._pyramid;
  };
  return SpatialReference;
}();
function getDefaultSpatialReference() {
  return JSON.parse(JSON.stringify(createOrGetDefaultSpatialReferences()));
}

var TEMP_POINT0$1 = new Point(0, 0);
var TEMP_EXTENT$4 = new PointExtent();
var TEMP_PROPERTIES = {};
function validateExtent(extent) {
  if (!extent) {
    return false;
  }
  var {
    xmin: xmin,
    ymin: ymin,
    xmax: xmax,
    ymax: ymax
  } = extent;
  return xmax - xmin > 0 && ymax - ymin > 0;
}
var options$D = {
  'id': null,
  'visible': true,
  'interactive': true,
  'editable': true,
  'cursor': null,
  'antiMeridian': false,
  'defaultProjection': 'EPSG:4326'
};
var Geometry = function (_JSONAble) {
  function Geometry(options) {
    var _this;
    var opts = extend$2({}, options);
    var symbol = opts['symbol'];
    var properties = opts['properties'];
    var id = opts['id'];
    delete opts['symbol'];
    delete opts['id'];
    delete opts['properties'];
    _this = _JSONAble.call(this, opts) || this;
    _this.propertiesDirty = false;
    if (symbol) {
      _this.setSymbol(symbol);
    } else {
      _this._genSizeSymbol();
    }
    if (properties) {
      _this.setProperties(properties);
    }
    if (!isNil(id)) {
      _this.setId(id);
    }
    if (options && isNumber(options.rotateAngle)) {
      _this._dirtyRotate = true;
    }
    return _this;
  }
  _inheritsLoose(Geometry, _JSONAble);
  Geometry.fromJSON = function fromJSON(json) {
    return json;
  };
  var _proto = Geometry.prototype;
  _proto.getFirstCoordinate = function getFirstCoordinate() {
    if (this.type === 'GeometryCollection') {
      var geometries = this.getGeometries();
      if (!geometries.length) {
        return null;
      }
      return geometries[0].getFirstCoordinate();
    }
    var coordinates = this.getCoordinates();
    if (!Array.isArray(coordinates)) {
      return coordinates;
    }
    do {
      coordinates = coordinates[0];
    } while (Array.isArray(coordinates) && coordinates.length > 0);
    return coordinates;
  };
  _proto.getLastCoordinate = function getLastCoordinate() {
    if (this.type === 'GeometryCollection') {
      var geometries = this.getGeometries();
      if (!geometries.length) {
        return null;
      }
      return geometries[geometries.length - 1].getLastCoordinate();
    }
    var coordinates = this.getCoordinates();
    if (!Array.isArray(coordinates)) {
      return coordinates;
    }
    do {
      coordinates = coordinates[coordinates.length - 1];
    } while (Array.isArray(coordinates) && coordinates.length > 0);
    return coordinates;
  };
  _proto.addTo = function addTo(layer, fitview) {
    layer.addGeometry(this, fitview);
    return this;
  };
  _proto.getLayer = function getLayer() {
    if (!this._layer) {
      return null;
    }
    return this._layer;
  };
  _proto.getMap = function getMap() {
    if (!this._layer) {
      return null;
    }
    return this._layer.getMap();
  };
  _proto.getId = function getId() {
    return this._id;
  };
  _proto.setId = function setId(id) {
    var oldId = this.getId();
    this._id = id;
    this._fireEvent('idchange', {
      'old': oldId,
      'new': id
    });
    return this;
  };
  _proto.getProperties = function getProperties() {
    if (!this.properties) {
      if (this._getParent()) {
        return this._getParent().getProperties();
      }
      return null;
    }
    return this.properties;
  };
  _proto.setProperties = function setProperties(properties) {
    this.propertiesDirty = true;
    var old = this.properties;
    this.properties = isObject$1(properties) ? extend$2({}, properties) : properties;
    var children = this.getGeometries ? this.getGeometries() : [];
    children.forEach(function (child) {
      var subPro = child.getProperties ? child.getProperties() || {} : {};
      var mergePro = extend$2(subPro, properties || {});
      if (child.setProperties) {
        child.setProperties(mergePro);
      }
    });
    this._clearAltitudeCache();
    this._repaint();
    this._fireEvent('propertieschange', {
      'old': old,
      'new': properties
    });
    return this;
  };
  _proto.getType = function getType() {
    return this.type;
  };
  _proto.getSymbol = function getSymbol() {
    var s = this._symbol;
    if (s) {
      if (!Array.isArray(s)) {
        return extend$2({}, s);
      } else {
        return extendSymbol(s);
      }
    }
    return null;
  };
  _proto.setSymbol = function setSymbol(symbol) {
    this._symbolUpdated = symbol;
    this._symbol = this._prepareSymbol(symbol);
    this.onSymbolChanged();
    delete this._compiledSymbol;
    delete this._symbolHash;
    return this;
  };
  _proto.getSymbolHash = function getSymbolHash$1() {
    if (!this._symbolHash) {
      this._symbolHash = getSymbolHash(this._symbolUpdated);
    }
    return this._symbolHash;
  };
  _proto.updateSymbol = function updateSymbol(props) {
    if (!props) {
      return this;
    }
    var s = this._getSymbol();
    var propsIsArray = Array.isArray(props);
    if (!s) {
      s = this._getInternalSymbol() || {};
    }
    if (!Array.isArray(s) && propsIsArray) {
      props = props[0] || {};
    }
    if (Array.isArray(s)) {
      if (!propsIsArray) {
        props = [props];
        while (props.length < s.length) {
          props.push({});
        }
      }
      for (var i = 0; i < props.length; i++) {
        if (isTextSymbol(props[i])) {
          delete this._textDesc;
        }
        if (s[i] && props[i]) {
          s[i] = extendSymbol(s[i], props[i]);
        }
      }
    } else if (Array.isArray(props)) {
      console.error('Geometry\'s symbol is object but the update symbol is array.');
      console.error('Geometry\'s symbol and update symbol:', s, props);
      return this;
    } else {
      if (isTextSymbol(s)) {
        delete this._textDesc;
      }
      if (s) {
        s = extendSymbol(s, props);
      } else {
        s = extendSymbol(this._getInternalSymbol(), props);
      }
    }
    this._eventSymbolProperties = props;
    delete this._compiledSymbol;
    return this.setSymbol(s);
  };
  _proto.getTextContent = function getTextContent() {
    var symbol = this._getInternalSymbol();
    if (Array.isArray(symbol)) {
      var contents = [];
      var has = false;
      for (var i = 0; i < symbol.length; i++) {
        contents[i] = replaceVariable(symbol[i] && symbol[i]['textName'], this.getProperties());
        if (!isNil(contents[i])) {
          has = true;
        }
      }
      return has ? contents : null;
    }
    return replaceVariable(symbol && symbol['textName'], this.getProperties());
  };
  _proto.getTextDesc = function getTextDesc() {
    if (!this._textDesc) {
      var textContent = this.getTextContent();
      var symbol = this._sizeSymbol;
      var isArray = Array.isArray(textContent);
      if (Array.isArray(symbol)) {
        this._textDesc = symbol.map(function (s, i) {
          return describeText(isArray ? textContent[i] : '', s);
        });
      } else {
        this._textDesc = describeText(textContent, symbol);
      }
    }
    return this._textDesc;
  };
  _proto.getCenter = function getCenter() {
    return this._computeCenter(this._getMeasurer());
  };
  _proto.getExtent = function getExtent() {
    var prjExt = this._getPrjExtent();
    var projection = this._getProjection();
    var extent;
    if (prjExt && projection) {
      var min = projection.unproject(new Coordinate(prjExt['xmin'], prjExt['ymin'])),
        max = projection.unproject(new Coordinate(prjExt['xmax'], prjExt['ymax']));
      extent = new Extent(min, max, projection);
    } else {
      extent = this._computeExtent(this._getMeasurer());
    }
    if (extent) {
      var altitudes = this._getAltitude();
      var [minAlt, maxAlt] = getMinMaxAltitude(altitudes);
      extent.zmin = minAlt;
      extent.zmax = maxAlt;
    }
    return extent;
  };
  _proto.getContainerExtent = function getContainerExtent(out) {
    var extent2d = this.get2DExtent();
    if (!extent2d || !extent2d.isValid()) {
      return null;
    }
    var map = this.getMap();
    var glRes = map.getGLRes();
    var minAltitude = this.getMinAltitude();
    var extent = extent2d.convertTo(function (c) {
      return map._pointAtResToContainerPoint(c, glRes, minAltitude, TEMP_POINT0$1);
    }, out);
    var maxAltitude = this.getMaxAltitude();
    if (maxAltitude !== minAltitude) {
      var extent2 = extent2d.convertTo(function (c) {
        return map._pointAtResToContainerPoint(c, glRes, maxAltitude, TEMP_POINT0$1);
      }, TEMP_EXTENT$4);
      extent._combine(extent2);
    }
    var layer = this.getLayer();
    if (layer && this.type === 'LineString' && maxAltitude && layer.options['drawAltitude']) {
      var groundExtent = extent2d.convertTo(function (c) {
        return map._pointAtResToContainerPoint(c, glRes, 0, TEMP_POINT0$1);
      }, TEMP_EXTENT$4);
      extent._combine(groundExtent);
    }
    if (extent) {
      var fixedExtent = this._getFixedExtent();
      if (validateExtent(fixedExtent)) {
        extent._add(fixedExtent);
      }
    }
    var smoothness = this.options['smoothness'];
    if (smoothness) {
      extent._expand(extent.getWidth() * 0.15);
    }
    return extent;
  };
  _proto._getFixedExtent = function _getFixedExtent() {
    if (!this._fixedExtent) {
      this._fixedExtent = new PointExtent();
    }
    var symbol = this._sizeSymbol;
    var t = (symbol && symbol['lineWidth'] || 1) / 2;
    var border = symbol && symbol['lineStrokeWidth'] || 0;
    t += border;
    this._fixedExtent.set(-t, -t, t, t);
    var dx = symbol && symbol['lineDx'] || 0;
    this._fixedExtent._add([dx, 0]);
    var dy = symbol && symbol['lineDy'] || 0;
    this._fixedExtent._add([0, dy]);
    return this._fixedExtent;
  };
  _proto.get2DExtent = function get2DExtent() {
    var map = this.getMap();
    if (!map) {
      return null;
    }
    if (this._extent2d) {
      return this._extent2d;
    }
    var extent = this._getPrjExtent();
    if (!extent || !extent.isValid()) {
      return null;
    }
    var min = extent.getMin();
    var max = extent.getMax();
    var glRes = map.getGLRes();
    map._prjToPointAtRes(min, glRes, min);
    map._prjToPointAtRes(max, glRes, max);
    this._extent2d = new PointExtent(min, max);
    var cache = MapStateCache[map.id];
    var zoom = cache ? cache.zoom : map.getZoom();
    this._extent2d.z = zoom;
    return this._extent2d;
  };
  _proto.getSize = function getSize() {
    var extent = this.getContainerExtent();
    return extent ? extent.getSize() : null;
  };
  _proto.containsPoint = function containsPoint(containerPoint, t) {
    if (!this.getMap()) {
      throw new Error('The geometry is required to be added on a map to perform "containsPoint".');
    }
    if (containerPoint instanceof Coordinate) {
      containerPoint = this.getMap().coordToContainerPoint(containerPoint);
    }
    return this._containsPoint(containerPoint, t);
  };
  _proto._containsPoint = function _containsPoint(containerPoint, t) {
    var painter = this._getPainter();
    if (!painter) {
      return false;
    }
    t = t || 0;
    if (this._hitTestTolerance) {
      t += this._hitTestTolerance();
    }
    return painter.hitTest(containerPoint, t);
  };
  _proto.show = function show() {
    this.options['visible'] = true;
    if (this.getMap()) {
      var painter = this._getPainter();
      if (painter) {
        painter.show();
      }
      this._fireEvent('show');
    }
    return this;
  };
  _proto.hide = function hide() {
    this.options['visible'] = false;
    if (this.getMap()) {
      this.onHide();
      var painter = this._getPainter();
      if (painter) {
        painter.hide();
      }
      this._fireEvent('hide');
    }
    return this;
  };
  _proto.isVisible = function isVisible() {
    if (!this.options['visible']) {
      return false;
    }
    var symbol = this._getInternalSymbol();
    if (!symbol) {
      return true;
    }
    if (!this.symbolIsVisible()) {
      return false;
    }
    if (Array.isArray(symbol)) {
      if (!symbol.length) {
        return true;
      }
      for (var i = 0, l = symbol.length; i < l; i++) {
        if (isNil(symbol[i]['opacity']) || symbol[i]['opacity'] > 0) {
          return true;
        }
      }
      return false;
    } else {
      return isNil(symbol['opacity']) || isObject$1(symbol['opacity']) || isNumber(symbol['opacity']) && symbol['opacity'] > 0;
    }
  };
  _proto.symbolIsVisible = function symbolIsVisible() {
    var symbols = this._getCompiledSymbol();
    if (!symbols) {
      return true;
    }
    if (!Array.isArray(symbols)) {
      symbols = [symbols];
    }
    for (var i = 0, len = symbols.length; i < len; i++) {
      var symbol = symbols[i];
      if (!symbol) {
        continue;
      }
      var isVisible = symbol.visible;
      if (isVisible !== false && isVisible !== 0) {
        return true;
      }
    }
    return false;
  };
  _proto.getZIndex = function getZIndex() {
    return this.options['zIndex'] || 0;
  };
  _proto.setZIndex = function setZIndex(zIndex) {
    var old = this.options['zIndex'];
    this.options['zIndex'] = zIndex;
    this._fireEvent('zindexchange', {
      'old': old,
      'new': zIndex
    });
    return this;
  };
  _proto.setZIndexSilently = function setZIndexSilently(zIndex) {
    this.options['zIndex'] = zIndex;
    return this;
  };
  _proto.bringToFront = function bringToFront() {
    var layer = this.getLayer();
    if (!layer || !layer.getGeoMaxZIndex) {
      return this;
    }
    var topZ = layer.getGeoMaxZIndex();
    this.setZIndex(topZ + 1);
    return this;
  };
  _proto.bringToBack = function bringToBack() {
    var layer = this.getLayer();
    if (!layer || !layer.getGeoMinZIndex) {
      return this;
    }
    var bottomZ = layer.getGeoMinZIndex();
    this.setZIndex(bottomZ - 1);
    return this;
  };
  _proto.translate = function translate(x, y, z) {
    if (isNil(x)) {
      return this;
    }
    var offset = new Coordinate(x, y, z);
    if (offset.x === 0 && offset.y === 0 && (isNil(offset.z) || offset.z === 0)) {
      return this;
    }
    var coordinates = this.getCoordinates();
    this._silence = true;
    if (coordinates) {
      if (Array.isArray(coordinates)) {
        var translated = forEachCoord(coordinates, function (coord) {
          return coord.add(offset);
        });
        this.setCoordinates(translated);
      } else {
        this.setCoordinates(coordinates.add(offset));
      }
    }
    this._silence = false;
    this._fireEvent('positionchange');
    return this;
  };
  _proto._translateRotatePivot = function _translateRotatePivot(newCoordinate) {
    if (!this._pivot || !newCoordinate) {
      return this;
    }
    if (this.options.rotatePivot) {
      var oldCoordinate = this.getCoordinates();
      if (!oldCoordinate) {
        return this;
      }
      if (!(newCoordinate instanceof Coordinate)) {
        newCoordinate = new Coordinate(newCoordinate);
      }
      var offset = newCoordinate.sub(oldCoordinate);
      if (offset.x === 0 && offset.y === 0) {
        return this;
      }
      this._pivot._add(offset);
      this.options.rotatePivot = this._pivot.toArray();
    }
    return this;
  };
  _proto.flash = function flash$1(interval, count, cb, context) {
    return flash.call(this, interval, count, cb, context);
  };
  _proto.copy = function copy() {
    var json = this.toJSON();
    var ret = Geometry.fromJSON(json);
    ret.options['visible'] = true;
    return ret;
  };
  _proto.remove = function remove() {
    var layer = this.getLayer();
    if (!layer) {
      return this;
    }
    this._fireEvent('removestart');
    this._unbind();
    this._fireEvent('removeend');
    this._fireEvent('remove');
    return this;
  };
  _proto.toGeoJSONGeometry = function toGeoJSONGeometry() {
    var gJson = this._exportGeoJSONGeometry();
    return gJson;
  };
  _proto.toGeoJSON = function toGeoJSON(opts) {
    if (!opts) {
      opts = {};
    }
    var feature = {
      'type': 'Feature',
      'geometry': null
    };
    if (isNil(opts['geometry']) || opts['geometry']) {
      var geoJSON = this._exportGeoJSONGeometry();
      feature['geometry'] = geoJSON;
    }
    var id = this.getId();
    if (!isNil(id)) {
      feature['id'] = id;
    }
    var properties;
    if (isNil(opts['properties']) || opts['properties']) {
      properties = this._exportProperties();
    }
    feature['properties'] = properties;
    return feature;
  };
  _proto.toJSON = function toJSON(options) {
    if (!options) {
      options = {};
    }
    var json = this._toJSON(options);
    var other = this._exportGraphicOptions(options);
    extend$2(json, other);
    return json;
  };
  _proto.getLength = function getLength() {
    return this._computeGeodesicLength(this._getMeasurer());
  };
  _proto.getArea = function getArea() {
    return this._computeGeodesicArea(this._getMeasurer());
  };
  _proto.rotate = function rotate(angle, pivot) {
    if (!isNumber(angle)) {
      console.error("angle:" + angle + " is not number");
      return this;
    }
    if (!this._painter) {
      this._dirtyRotate = true;
    }
    if (this.type === 'GeometryCollection') {
      var geometries = this.getGeometries();
      geometries.forEach(function (g) {
        return g.rotate(angle, pivot);
      });
      return this;
    }
    if (!pivot) {
      pivot = this.getCenter();
    } else {
      pivot = new Coordinate(pivot);
    }
    this._angle = angle;
    this._pivot = pivot;
    var measurer = this._getMeasurer();
    var coordinates = this.getCoordinates();
    if (!Array.isArray(coordinates)) {
      if ((pivot.x !== coordinates.x || pivot.y !== coordinates.y) && !this.getShell) {
        var c = measurer._rotate(coordinates, pivot, angle);
        this.setCoordinates(c);
      } else {
        this.onPositionChanged();
      }
      if (this.getShell) {
        this.options.rotateAngle = angle;
        this.options.rotatePivot = pivot.toArray();
      }
      return this;
    }
    forEachCoord(coordinates, function (c) {
      return measurer._rotate(c, pivot, angle);
    });
    this.setCoordinates(coordinates);
    return this;
  };
  _proto._rotatePrjCoordinates = function _rotatePrjCoordinates(coordinates) {
    if (!coordinates || this._angle === 0 || !this._pivot) {
      return coordinates;
    }
    var projection = this._getProjection();
    if (!projection) {
      return coordinates;
    }
    var offsetAngle = 0;
    var isArray = Array.isArray(coordinates);
    var coord = isArray ? coordinates : [coordinates];
    var rotatePrjCoordinates = [];
    var cx, cy;
    if (this.getRotateOffsetAngle) {
      offsetAngle = this.getRotateOffsetAngle();
      var center = coord[coord.length - 1];
      cx = center.x;
      cy = center.y;
    } else {
      var bbox = getDefaultBBOX();
      pointsBBOX(coord, bbox);
      var [minx, miny, maxx, maxy] = bbox;
      cx = (minx + maxx) / 2;
      cy = (miny + maxy) / 2;
    }
    for (var i = 0, len = coord.length; i < len; i++) {
      var c = coord[i];
      var {
        x: x,
        y: y
      } = c;
      var dx = x - cx,
        dy = y - cy;
      var r = Math.sqrt(dx * dx + dy * dy);
      var sAngle = getSegmentAngle(cx, cy, x, y);
      var rad = (sAngle - this._angle + offsetAngle) / 180 * Math.PI;
      var _rx = Math.cos(rad) * r,
        _ry = Math.sin(rad) * r;
      var rc = new Coordinate(cx + _rx, cy + _ry);
      rotatePrjCoordinates.push(rc);
    }
    var prjCenter = projection.project(this._pivot);
    var rx = prjCenter.x,
      ry = prjCenter.y;
    var translateX = cx - rx,
      translateY = cy - ry;
    for (var _i = 0, _len = rotatePrjCoordinates.length; _i < _len; _i++) {
      var _c = rotatePrjCoordinates[_i];
      _c.x -= translateX;
      _c.y -= translateY;
    }
    if (isArray) {
      return rotatePrjCoordinates;
    }
    return rotatePrjCoordinates[0];
  };
  _proto.isRotated = function isRotated() {
    return !!(isNumber(this._angle) && this._pivot);
  };
  _proto._getConnectPoints = function _getConnectPoints() {
    return [this.getCenter()];
  };
  _proto._initOptions = function _initOptions(options) {
    var opts = extend$2({}, options);
    var symbol = opts['symbol'];
    var properties = opts['properties'];
    var id = opts['id'];
    delete opts['symbol'];
    delete opts['id'];
    delete opts['properties'];
    this._setOptions(opts);
    if (symbol) {
      this.setSymbol(symbol);
    }
    if (properties) {
      this.setProperties(properties);
    }
    if (!isNil(id)) {
      this.setId(id);
    }
  };
  _proto._bindLayer = function _bindLayer(layer) {
    if (layer === this.getLayer()) {
      return;
    }
    if (this.getLayer()) {
      throw new Error('Geometry cannot be added to two or more layers at the same time.');
    }
    this._layer = layer;
    this._clearCache();
    this._bindInfoWindow();
    this._bindMenu();
  };
  _proto._prepareSymbol = function _prepareSymbol(symbol) {
    if (Array.isArray(symbol)) {
      var cookedSymbols = [];
      for (var i = 0; i < symbol.length; i++) {
        cookedSymbols.push(convertResourceUrl(this._checkAndCopySymbol(symbol[i])));
      }
      return cookedSymbols;
    } else if (symbol) {
      symbol = this._checkAndCopySymbol(symbol);
      return convertResourceUrl(symbol);
    }
    return null;
  };
  _proto._checkAndCopySymbol = function _checkAndCopySymbol(symbol) {
    var s = {};
    for (var i in symbol) {
      if (NUMERICAL_PROPERTIES[i] && isString(symbol[i])) {
        s[i] = +symbol[i];
      } else {
        s[i] = symbol[i];
      }
    }
    return s;
  };
  _proto._getSymbol = function _getSymbol() {
    return this._symbol;
  };
  _proto._setExternSymbol = function _setExternSymbol(symbol) {
    this._eventSymbolProperties = symbol;
    if (!this._symbol) {
      delete this._textDesc;
    }
    this._externSymbol = this._prepareSymbol(symbol);
    this.onSymbolChanged();
    return this;
  };
  _proto._getInternalSymbol = function _getInternalSymbol() {
    if (this._symbol) {
      return this._symbol;
    } else if (this._externSymbol) {
      return this._externSymbol;
    } else if (this.options['symbol']) {
      return this.options['symbol'];
    }
    return null;
  };
  _proto._getPrjExtent = function _getPrjExtent() {
    var p = this._getProjection();
    this._verifyProjection();
    if (!this._extent && p) {
      this._extent = this._computePrjExtent(p);
    }
    return this._extent;
  };
  _proto._unbind = function _unbind() {
    var layer = this.getLayer();
    if (!layer) {
      return;
    }
    if (this._animPlayer) {
      this._animPlayer.finish();
    }
    this._unbindMenu();
    this._unbindInfoWindow();
    if (this.isEditing()) {
      this.endEdit();
    }
    this._removePainter();
    if (this.onRemove) {
      this.onRemove();
    }
    if (layer.onRemoveGeometry) {
      layer.onRemoveGeometry(this);
    }
    delete this._layer;
    delete this._internalId;
    delete this._extent;
  };
  _proto._getInternalId = function _getInternalId() {
    return this._internalId;
  };
  _proto._setInternalId = function _setInternalId(id) {
    this._internalId = id;
  };
  _proto._getMeasurer = function _getMeasurer() {
    if (this._getProjection()) {
      return this._getProjection();
    }
    return SpatialReference.getProjectionInstance(this.options['defaultProjection']);
  };
  _proto._getProjection = function _getProjection() {
    var map = this.getMap();
    if (map) {
      return map.getProjection();
    }
    return null;
  };
  _proto._verifyProjection = function _verifyProjection() {
    var projection = this._getProjection();
    if (this._projCode && projection && this._projCode !== projection.code) {
      this._clearProjection();
    }
    this._projCode = projection ? projection.code : this._projCode;
  };
  _proto._getExternalResources = function _getExternalResources() {
    var symbol = this._getInternalSymbol();
    return getExternalResources(symbol);
  };
  _proto._getPainter = function _getPainter() {
    if (this._painter) {
      return this._painter;
    }
    var layer = this.getLayer();
    if (layer) {
      if (GEOMETRY_COLLECTION_TYPES.indexOf(this.type) !== -1) {
        if (layer.constructor.getCollectionPainterClass) {
          var clazz = layer.constructor.getCollectionPainterClass();
          if (clazz) {
            this._painter = new clazz(this);
          }
        }
      } else if (layer.constructor.getPainterClass) {
        var _clazz = layer.constructor.getPainterClass();
        if (_clazz) {
          this._painter = new _clazz(this);
        }
      }
    }
    return this._painter;
  };
  _proto._getMaskPainter = function _getMaskPainter() {
    if (this._maskPainter) {
      return this._maskPainter;
    }
    this._maskPainter = this.getGeometries && this.getGeometries() ? new CollectionPainter(this, true) : new Painter(this);
    return this._maskPainter;
  };
  _proto._removePainter = function _removePainter() {
    if (this._painter) {
      this._painter.remove();
    }
    delete this._painter;
  };
  _proto._paint = function _paint(extent) {
    if (!this.symbolIsVisible()) {
      return;
    }
    if (this._painter) {
      if (this._dirtyCoords) {
        delete this._dirtyCoords;
        var projection = this._getProjection();
        if (projection) {
          this._pcenter = projection.project(this._coordinates);
          this._clearCache();
        }
      }
      if (this._dirtyRotate && isNumber(this.options.rotateAngle)) {
        this.rotate(this.options.rotateAngle, this.options.rotatePivot);
      }
      this._dirtyRotate = false;
      this._painter.paint(extent);
    }
  };
  _proto._clearCache = function _clearCache() {
    delete this._extent;
    delete this._extent2d;
    this._clearAltitudeCache();
    if (this._parent) {
      delete this._parent._extent;
      delete this._parent._extent2d;
      this._parent._clearAltitudeCache();
    }
  };
  _proto._clearProjection = function _clearProjection() {
    delete this._extent;
    delete this._extent2d;
    if (this._parent) {
      delete this._parent._extent;
      delete this._parent._extent2d;
    }
  };
  _proto._repaint = function _repaint() {
    if (this._painter) {
      this._painter.repaint();
    }
  };
  _proto.onHide = function onHide() {
    this.closeMenu();
    this.closeInfoWindow();
  };
  _proto.onShapeChanged = function onShapeChanged() {
    this._clearCache();
    this._repaint();
    this._fireEvent('shapechange');
  };
  _proto.onPositionChanged = function onPositionChanged() {
    this._clearCache();
    this._repaint();
    this._fireEvent('positionchange');
  };
  _proto.onSymbolChanged = function onSymbolChanged() {
    if (this._painter) {
      this._painter.refreshSymbol();
    }
    var e = {};
    if (this._eventSymbolProperties) {
      e.properties = JSON.parse(JSON.stringify(this._eventSymbolProperties));
      delete this._eventSymbolProperties;
    } else {
      delete this._textDesc;
    }
    this._genSizeSymbol();
    this._fireEvent('symbolchange', e);
  };
  _proto._genSizeSymbol = function _genSizeSymbol() {
    var symbol = this._getInternalSymbol();
    if (!symbol) {
      delete this._sizeSymbol;
      return;
    }
    if (Array.isArray(symbol)) {
      this._sizeSymbol = [];
      var dynamicSize = false;
      for (var i = 0; i < symbol.length; i++) {
        var s = this._sizeSymbol[i] = this._getSizeSymbol(symbol[i]);
        if (!dynamicSize && s && s._dynamic) {
          dynamicSize = true;
        }
      }
      this._sizeSymbol._dynamic = dynamicSize;
    } else {
      this._sizeSymbol = this._getSizeSymbol(symbol);
    }
  };
  _proto._getSizeSymbol = function _getSizeSymbol(symbol) {
    var symbolSize = loadGeoSymbol({
      lineWidth: symbol['lineWidth'],
      lineDx: symbol['lineDx'],
      lineDy: symbol['lineDy']
    }, this);
    if (isFunctionDefinition(symbol['lineWidth']) || isFunctionDefinition(symbol['lineDx']) || isFunctionDefinition(symbol['lineDy'])) {
      symbolSize._dynamic = true;
    }
    return symbolSize;
  };
  _proto._getCompiledSymbol = function _getCompiledSymbol() {
    if (this._compiledSymbol) {
      return this._compiledSymbol;
    }
    this._compiledSymbol = loadGeoSymbol(this._getInternalSymbol(), this);
    return this._compiledSymbol;
  };
  _proto.onConfig = function onConfig(conf) {
    var properties;
    if (conf['properties']) {
      properties = conf['properties'];
      delete conf['properties'];
    }
    var needRepaint = false;
    for (var p in conf) {
      if (conf.hasOwnProperty(p)) {
        var prefix = p.slice(0, 5);
        if (prefix === 'arrow' || prefix === 'smoot') {
          needRepaint = true;
          break;
        }
      }
    }
    if (properties) {
      this.setProperties(properties);
      this._repaint();
    } else if (needRepaint) {
      this._repaint();
    }
  };
  _proto._setParent = function _setParent(geometry) {
    if (geometry) {
      this._parent = geometry;
    }
  };
  _proto._getParent = function _getParent() {
    return this._parent;
  };
  _proto._fireEvent = function _fireEvent(eventName, param) {
    if (this._silence) {
      return;
    }
    if (this.getLayer() && this.getLayer()._onGeometryEvent) {
      if (!param) {
        param = {};
      }
      param['type'] = eventName;
      param['target'] = this;
      this.getLayer()._onGeometryEvent(param);
    }
    this.fire(eventName, param);
  };
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options)
    };
  };
  _proto._recordVisible = function _recordVisible() {
    var visible = this.options.visible;
    if (isNil(visible)) {
      visible = true;
    }
    this._savedVisible = visible;
  };
  _proto._recoveryVisible = function _recoveryVisible() {
    delete this._savedVisible;
  };
  _proto._exportGraphicOptions = function _exportGraphicOptions(options) {
    var json = {};
    if (isNil(options['options']) || options['options']) {
      json['options'] = this.config();
    }
    if (json['options'] && this.isEditing && this.isEditing()) {
      json['options'].visible = this._savedVisible;
    }
    if (isNil(options['symbol']) || options['symbol']) {
      json['symbol'] = this.getSymbol();
    }
    if (isNil(options['infoWindow']) || options['infoWindow']) {
      if (this._infoWinOptions) {
        json['infoWindow'] = this._infoWinOptions;
      }
    }
    return json;
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var points = this.getCoordinates();
    var coordinates = Coordinate.toNumberArrays(points);
    return {
      'type': this.getType(),
      'coordinates': coordinates
    };
  };
  _proto._exportProperties = function _exportProperties() {
    var properties = null;
    var geoProperties = this.getProperties();
    if (!isNil(geoProperties)) {
      if (isObject$1(geoProperties)) {
        properties = extend$2({}, geoProperties);
      } else {
        properties = geoProperties;
      }
    }
    return properties;
  };
  _proto._hitTestTolerance = function _hitTestTolerance() {
    return 0;
  };
  _proto._getAltitude = function _getAltitude() {
    var layer = this.getLayer();
    if (!layer) {
      return 0;
    }
    var layerOpts = layer.options;
    var layerAltitude = layer.getAltitude ? layer.getAltitude() : 0;
    var enableAltitude = layerOpts['enableAltitude'];
    if (!enableAltitude && layer.isVectorLayer) {
      return layerAltitude;
    }
    var altitudeProperty = getAltitudeProperty(layer);
    var properties = this.properties || TEMP_PROPERTIES;
    var altitude = properties[altitudeProperty];
    if (isNil(altitude)) {
      var alts = getGeometryCoordinatesAlts(this, layerAltitude, enableAltitude);
      if (!isNil(alts)) {
        return alts;
      }
      return layerAltitude;
    }
    if (Array.isArray(altitude)) {
      return altitude.map(function (alt) {
        return alt + layerAltitude;
      });
    }
    return altitude + layerAltitude;
  };
  _proto.getAltitude = function getAltitude() {
    var layer = this.getLayer();
    var altitudeProperty = getAltitudeProperty(layer);
    var properties = this.properties || TEMP_PROPERTIES;
    var altitude = properties[altitudeProperty];
    if (!isNil(altitude)) {
      return altitude;
    }
    var alts = getGeometryCoordinatesAlts(this, 0, false);
    if (!isNil(alts)) {
      return alts;
    }
    return 0;
  };
  _proto.hasAltitude = function hasAltitude() {
    this._genMinMaxAlt();
    return !!this._minAlt || !!this._maxAlt;
  };
  _proto.setAltitude = function setAltitude(alt) {
    if (!isNumber(alt)) {
      return this;
    }
    var layer = this.getLayer();
    var altitudeProperty = getAltitudeProperty(layer);
    var properties = this.properties || TEMP_PROPERTIES;
    var altitude = properties[altitudeProperty];
    if (!isNil(altitude)) {
      if (Array.isArray(altitude)) {
        for (var i = 0, len = altitude.length; i < len; i++) {
          altitude[i] = alt;
        }
      } else {
        properties[altitudeProperty] = alt;
      }
    }
    var coordinates = this.getCoordinates ? this.getCoordinates() : null;
    if (!coordinates) {
      return this;
    }
    setCoordinatesAlt(coordinates, alt);
    if (layer) {
      var renderer = layer.getRenderer();
      if (renderer && (renderer.gl || renderer.device)) {
        this.setCoordinates(coordinates);
      } else if (renderer) {
        this._repaint();
      }
    }
    this._clearAltitudeCache();
    this.onPositionChanged();
    return this;
  };
  _proto._genMinMaxAlt = function _genMinMaxAlt() {
    if (this._minAlt === undefined || this._maxAlt === undefined) {
      var altitude = this._getAltitude();
      var [min, max] = getMinMaxAltitude(altitude);
      this._minAlt = min;
      this._maxAlt = max;
    }
  };
  _proto.getMinAltitude = function getMinAltitude() {
    this._genMinMaxAlt();
    return this._minAlt;
  };
  _proto.getMaxAltitude = function getMaxAltitude() {
    this._genMinMaxAlt();
    return this._maxAlt;
  };
  _proto._clearAltitudeCache = function _clearAltitudeCache() {
    this._minAlt = undefined;
    this._maxAlt = undefined;
    return this;
  };
  _proto._getEditCenter = function _getEditCenter() {
    var center = this.getCenter().copy();
    center.z = 0;
    var altitude = this.getAltitude();
    if (isNumber(altitude)) {
      center.z = altitude;
      return center;
    }
    var total = 0,
      count = 0;
    var _checkArray = function checkArray(altitudeArray) {
      for (var i = 0, len = altitudeArray.length; i < len; i++) {
        if (Array.isArray(altitudeArray[i])) {
          _checkArray(altitudeArray[i]);
        } else {
          count++;
          total += altitudeArray[i];
        }
      }
    };
    if (Array.isArray(altitude)) {
      _checkArray(altitude);
      center.z = total / count;
    }
    return center;
  };
  return Geometry;
}(JSONAble(Eventable(Handlerable(Class))));
Geometry.mergeOptions(options$D);
function getAltitudeProperty(layer) {
  var altitudeProperty = 'altitude';
  if (layer) {
    if (!layer.isVectorLayer) {
      return null;
    }
    var layerOpts = layer.options;
    altitudeProperty = layerOpts['altitudeProperty'];
  }
  return altitudeProperty;
}
function getGeometryCoordinatesAlts(geometry, layerAlt, enableAltitude) {
  var coordinates = geometry.getCoordinates ? geometry.getCoordinates() : null;
  if (coordinates) {
    var tempAlts = [];
    coordinatesHasAlt(coordinates, tempAlts);
    if (tempAlts.length) {
      var alts = getCoordinatesAlts(coordinates, layerAlt, enableAltitude);
      return alts;
    }
  }
  return null;
}
function setCoordinatesAlt(coordinates, alt) {
  if (Array.isArray(coordinates)) {
    for (var i = 0, len = coordinates.length; i < len; i++) {
      setCoordinatesAlt(coordinates[i], alt);
    }
  } else {
    coordinates.z = alt;
  }
}
function coordinatesHasAlt(coordinates, tempAlts) {
  if (tempAlts.length) {
    return;
  }
  if (Array.isArray(coordinates)) {
    for (var i = 0, len = coordinates.length; i < len; i++) {
      coordinatesHasAlt(coordinates[i], tempAlts);
    }
  } else if (isNumber(coordinates.z)) {
    tempAlts.push(coordinates.z);
  }
}
function getCoordinatesAlts(coordinates, layerAlt, enableAltitude) {
  if (Array.isArray(coordinates)) {
    var alts = [];
    for (var i = 0, len = coordinates.length; i < len; i++) {
      alts.push(getCoordinatesAlts(coordinates[i], layerAlt, enableAltitude));
    }
    return alts;
  }
  if (isNumber(coordinates.z)) {
    return enableAltitude ? layerAlt + coordinates.z : coordinates.z;
  } else if (enableAltitude) {
    return layerAlt;
  } else {
    return 0;
  }
}
function getSegmentAngle(cx, cy, x, y) {
  if (cx === x) {
    if (y > cy) {
      return -90;
    }
    return 90;
  }
  x -= cx;
  y -= cy;
  y = -y;
  var rad = Math.atan2(y, x);
  return rad / Math.PI * 180;
}

var CHECK_FPS_WORKER_KEY = 'check_browser_max_fps';
var CHECK_FPS_WORKER_CODE = "function (exports) {\n    exports.initialize = function () {};\n    function now(){\n        return new Date().getTime();\n    }\n    function checkFPS(cb) {\n        if (typeof(requestAnimationFrame) === 'undefined') {\n            cb(-1);\n            return;\n        }\n        const count = 100;\n        let idx = 0;\n        let id;\n        let startTime;\n        function loop() {\n            idx++;\n            if (idx === count) {\n                cancelAnimationFrame(id);\n                const endTime = now();\n                const timePerFPS = (endTime - startTime) / count;\n                const fps = Math.floor(1000 / timePerFPS);\n                cb(fps);\n            } else {\n                id = requestAnimationFrame(loop);\n            }\n        }\n        startTime = now();\n        id = requestAnimationFrame(loop);\n    }\n    //recive message\n    exports.onmessage = function (msg, postResponse) {\n        checkFPS((fps) => {\n            if (fps <= -1) {\n                postResponse('check fps fail');\n            } else {\n                postResponse(null, { fps });\n            }\n        })\n    }\n}";
registerWorkerAdapter(CHECK_FPS_WORKER_KEY, function () {
  return CHECK_FPS_WORKER_CODE;
});

var dedicatedWorker = 0;
var EMPTY_BUFFERS = [];
var Actor = function () {
  function Actor(workerKey) {
    var _this = this;
    startTasks();
    this._delayMessages = [];
    this.initializing = false;
    var hasCreated = adapterHasCreated(workerKey);
    if (workersHasCreated() && !hasCreated) {
      this.initializing = true;
      console.log("Injecting codes in worker with worker key: :" + workerKey);
      createAdapter(workerKey, function () {
        _this.initializing = false;
        _this.created();
      });
    }
    this.workerKey = workerKey;
    this.workerPool = getGlobalWorkerPool();
    this.currentActor = 0;
    this.actorId = UID();
    this.workers = this.workerPool.acquire(this.actorId);
    this.callbacks = {};
    this.callbackID = 0;
    this.receiveFn = this.receive.bind(this);
    this.workers.forEach(function (w) {
      w.addEventListener('message', _this.receiveFn, false);
    });
    pushAdapterCreated(workerKey);
  }
  var _proto = Actor.prototype;
  _proto.created = function created() {
    var _this2 = this;
    this._delayMessages.forEach(function (message) {
      var {
        command: command,
        data: data,
        buffers: buffers,
        cb: cb,
        workerId: workerId
      } = message;
      _this2[command](data, buffers, cb, workerId);
    });
    this._delayMessages = [];
  };
  _proto.isActive = function isActive() {
    return !!this.workers;
  };
  _proto.broadcast = function broadcast(data, buffers, cb) {
    var _this3 = this;
    if (this.initializing) {
      this._delayMessages.push({
        command: 'broadcast',
        data: data,
        buffers: buffers,
        cb: cb
      });
      return this;
    }
    cb = cb || function () {};
    asyncAll(this.workers, function (worker, done) {
      _this3.send(data, buffers, done, worker.id);
    }, cb);
    return this;
  };
  _proto.send = function send(data, buffers, cb, workerId) {
    if (this.initializing) {
      this._delayMessages.push({
        command: 'send',
        data: data,
        buffers: buffers,
        cb: cb,
        workerId: workerId
      });
      return this;
    }
    var id = cb ? this.actorId + ":" + this.callbackID++ : null;
    if (cb) this.callbacks[id] = cb;
    this.post({
      data: data,
      callback: String(id)
    }, buffers, workerId);
    return this;
  };
  _proto.receive = function receive(message) {
    var _this4 = this;
    var data = message.data,
      id = data.callback;
    var callback = this.callbacks[id];
    delete this.callbacks[id];
    if (data.type === '<request>') {
      if (this.actorId === data.actorId) {
        this[data.command](data.params, function (err, cbData, buffers) {
          var message = {
            type: '<response>',
            callback: data.callback
          };
          if (err) {
            message.error = err.message;
          } else {
            message.data = cbData;
          }
          _this4.post(message, buffers || EMPTY_BUFFERS, data.workerId);
        });
      }
    } else if (callback && data.error) {
      callback(data.error);
    } else if (callback) {
      callback(null, data.data);
    }
  };
  _proto.remove = function remove() {
    var _this5 = this;
    this.workers.forEach(function (w) {
      w.removeEventListener('message', _this5.receiveFn, false);
    });
    delete this.receiveFn;
    delete this.workers;
    delete this.callbacks;
    delete this.workerPool;
  };
  _proto.post = function post(data, buffers, targetID) {
    if (typeof targetID !== 'number' || isNaN(targetID)) {
      targetID = this.currentActor = (this.currentActor + 1) % this.workerPool.workerCount;
    }
    data.workerId = targetID;
    data.workerKey = this.workerKey;
    data.actorId = this.actorId;
    this.workerPool.addMessage(targetID, data, buffers || EMPTY_BUFFERS);
    return targetID;
  };
  _proto.getDedicatedWorker = function getDedicatedWorker() {
    dedicatedWorker = (dedicatedWorker + 1) % this.workerPool.workerCount;
    return dedicatedWorker;
  };
  return Actor;
}();
function asyncAll(array, fn, callback) {
  if (!array.length) {
    callback(null, []);
  }
  var remaining = array.length;
  var results = new Array(array.length);
  var error = null;
  array.forEach(function (item, i) {
    fn(item, function (err, result) {
      if (err) error = err;
      results[i] = result;
      if (--remaining === 0) callback(error, results);
    });
  });
}
var actor;
var FPSCheckActor = function (_Actor) {
  function FPSCheckActor() {
    return _Actor.call(this, CHECK_FPS_WORKER_KEY) || this;
  }
  _inheritsLoose(FPSCheckActor, _Actor);
  return FPSCheckActor;
}(Actor);
var fpsChecked = false;
function checkFPS(cb) {
  if (!actor) {
    actor = new FPSCheckActor();
  }
  actor.send({}, [], function (err, data) {
    if (err) {
      if (!fpsChecked) {
        console.error(err);
        fpsChecked = true;
      }
      cb();
    } else {
      cb(data.fps);
    }
  });
}
var checkFPSing = false;
function checkBrowserMaxFPS() {
  if (checkFPSing) {
    return;
  }
  if (GlobalConfig.maxFPS <= 0) {
    checkFPSing = true;
    checkFPS(function (fps) {
      if (isNumber(fps) && fps > 0 && GlobalConfig.maxFPS <= 0) {
        GlobalConfig.maxFPS = fps;
      }
      checkFPSing = false;
    });
  }
}
pushLoopHook(checkBrowserMaxFPS);

var EMPTY_ARRAY$2 = [];
var ResourceWorkerConnection = function (_Actor) {
  function ResourceWorkerConnection() {
    return _Actor.call(this, imageFetchWorkerKey) || this;
  }
  _inheritsLoose(ResourceWorkerConnection, _Actor);
  var _proto = ResourceWorkerConnection.prototype;
  _proto.fetchImage = function fetchImage(url, cb) {
    var data = {
      url: url
    };
    this.send(data, EMPTY_ARRAY$2, cb);
  };
  return ResourceWorkerConnection;
}(Actor);
var GL_CLEAR = {
  depth: 1,
  stencil: 0
};
var CANVAS_CLEAR = {
  color: [0, 0, 0, 0],
  depth: 1,
  stencil: 0
};
var LayerAbstractRenderer = function (_Class) {
  function LayerAbstractRenderer(layer) {
    var _this;
    _this = _Class.call(this) || this;
    _this.layer = layer;
    _this._painted = false;
    _this._drawTime = 0;
    if (Browser$1.decodeImageInWorker && !Browser$1.safari && !Browser$1.iosWeixin) {
      _this._resWorkerConn = new ResourceWorkerConnection();
    }
    _this.setToRedraw();
    return _this;
  }
  _inheritsLoose(LayerAbstractRenderer, _Class);
  var _proto2 = LayerAbstractRenderer.prototype;
  _proto2.render = function render(framestamp) {
    this.prepareRender();
    if (!this.getMap() || !this.layer.isVisible()) {
      return;
    }
    if (!this.resources) {
      this.resources = getResouceCacheInstance();
    }
    this.checkAndDraw(this._tryToDraw, framestamp);
    this._frameTime = framestamp;
  };
  _proto2.getFrameTimestamp = function getFrameTimestamp() {
    return this._frameTime || 0;
  };
  _proto2.checkAndDraw = function checkAndDraw(drawFn, ...args) {
    var _this2 = this;
    this._toRedraw = false;
    if (this.checkResources) {
      var resources = this.checkResources();
      if (resources.length > 0) {
        this._loadingResource = true;
        this.loadResources(resources).then(function () {
          _this2._loadingResource = false;
          if (_this2.layer) {
            _this2.layer.fire('resourceload');
            var map = _this2.layer.getMap();
            _this2.setToRedraw();
            map.getRenderer().callInNextFrame(function () {
              _this2.setToRedraw();
            });
          }
        });
      } else {
        drawFn.call(this, ...args);
      }
    } else {
      drawFn.call(this, ...args);
    }
  };
  _proto2.testIfNeedRedraw = function testIfNeedRedraw() {
    var map = this.getMap();
    if (this._loadingResource) {
      return false;
    }
    if (this._toRedraw) {
      return true;
    }
    if (map.isInteracting() && !this.drawOnInteracting) {
      return false;
    }
    if (this.needToRedraw()) {
      return true;
    }
    return false;
  };
  _proto2.needToRedraw = function needToRedraw() {
    var map = this.getMap();
    if (map.isInteracting() || map.getRenderer().isViewChanged()) {
      return true;
    }
    return false;
  };
  _proto2.onSkipDrawOnInteracting = function onSkipDrawOnInteracting() {};
  _proto2.isLoadingResource = function isLoadingResource() {
    return this._loadingResource;
  };
  _proto2.isRenderComplete = function isRenderComplete() {
    return !!this._renderComplete;
  };
  _proto2.mustRenderOnInteracting = function mustRenderOnInteracting() {
    return !this._painted;
  };
  _proto2.setToRedraw = function setToRedraw() {
    this._toRedraw = true;
    return this;
  };
  _proto2.remove = function remove() {
    this.onRemove();
    delete this._loadingResource;
    delete this.middleWest;
    delete this.canvas;
    delete this.context;
    delete this.canvasExtent2D;
    delete this._extent2D;
    if (this.resources) {
      this.resources.remove();
    }
    delete this.resources;
    if (this._resWorkerConn) {
      this._resWorkerConn.remove();
      delete this._resWorkerConn;
    }
    delete this.layer;
  };
  _proto2.onRemove = function onRemove() {};
  _proto2.onAdd = function onAdd() {};
  _proto2.getMap = function getMap() {
    if (!this.layer) {
      return null;
    }
    return this.layer.getMap();
  };
  _proto2.clear = function clear() {
    this.clearContext();
    this.setToRedraw();
  };
  _proto2.isBlank = function isBlank() {
    return !this._painted;
  };
  _proto2.show = function show() {
    this.setToRedraw();
  };
  _proto2.hide = function hide() {
    this.clear();
    this.setToRedraw();
  };
  _proto2.setZIndex = function setZIndex(_z) {
    this.setToRedraw();
  };
  _proto2.screenshotRenderResult = function screenshotRenderResult(x, y, width, height) {
    if (this.canvas) {
      var tempCanvas = Canvas.getTempCanvas();
      tempCanvas.width = width;
      tempCanvas.height = height;
      var context = Canvas.getCanvas2DContext(tempCanvas);
      context.clearRect(0, 0, width, height);
      context.drawImage(this.canvas, x, y, width, height, 0, 0, width, height);
      return context;
    } else {
      console.warn('not find layer canvas for screenshotRenderResult,the layerId:', this.layer.getId());
    }
  };
  _proto2.hitDetect = function hitDetect(point) {
    if (!this.context || this.layer.isEmpty && this.layer.isEmpty() || this.isBlank() || this._errorThrown || this.layer.isVisible && !this.layer.isVisible()) {
      return false;
    }
    var map = this.getMap();
    var r = this.mapDPR || map.getDevicePixelRatio();
    var size = map.getSize();
    if (point.x < 0 || point.x > size['width'] * r || point.y < 0 || point.y > size['height'] * r) {
      return false;
    }
    var x = Math.round(r * point.x),
      y = Math.round(r * point.y);
    var imageData = this.getImageData && this.getImageData();
    if (imageData) {
      var idx = y * imageData.width * 4 + x * 4;
      return imageData.data[idx + 3] > 0;
    }
    try {
      var ctx = this.screenshotRenderResult(x, y, 2, 2);
      if (ctx) {
        var imgData = ctx.getImageData(x, y, 1, 1).data;
        if (imgData[3] > 0) {
          return true;
        }
      }
    } catch (error) {
      if (!this._errorThrown) {
        if (console) {
          console.warn('hit detect failed with tainted canvas, some geometries have external resources in another domain:\n', error);
        }
        this._errorThrown = true;
      }
      return false;
    }
    return false;
  };
  _proto2.loadResources = function loadResources(resourceUrls) {
    if (!this.resources) {
      this.resources = new ResourceCache();
    }
    var resources = this.resources,
      promises = [];
    if (isArrayHasData(resourceUrls)) {
      var cache = {};
      for (var i = resourceUrls.length - 1; i >= 0; i--) {
        var url = resourceUrls[i];
        if (!url || !url.length) {
          continue;
        }
        var key = url.join('-');
        if (!isImageBitMap(url[0])) {
          if (cache[key]) {
            continue;
          }
          cache[key] = 1;
        }
        if (!resources.isResourceLoaded(url, true)) {
          promises.push(new Promise(this._promiseResource(url)));
        }
      }
    }
    return Promise.all(promises);
  };
  _proto2.prepareRender = function prepareRender() {
    delete this._renderComplete;
    var map = this.getMap();
    this._renderZoom = map.getZoom();
    this.canvasExtent2D = this._extent2D = map.get2DExtent();
    this.middleWest = map._containerPointToPoint(new Point(0, map.height / 2));
  };
  _proto2.prepareCanvas = function prepareCanvas() {
    var parent = this.layer.parent;
    var {
      canvas: mapCanvas,
      context: mapContext
    } = parent.getRenderer();
    var isMapCanvasRenderer = mapContext instanceof CanvasRenderingContext2D;
    if (!this.context) {
      if (isMapCanvasRenderer) {
        this.createContext();
      } else {
        this.canvas = mapCanvas;
        this.context = mapContext;
        var {
          gl: gl,
          regl: regl,
          reglGL: reglGL,
          device: device
        } = mapContext;
        this.gl = gl;
        this.regl = regl;
        this.reglGL = reglGL;
        this.device = device;
      }
      this.initContext();
      this.layer.fire('contextinit', {
        'context': this.context
      });
    } else if (isMapCanvasRenderer) {
      this.clearContext();
    }
    this.resizeCanvas();
    this.prepareContext();
    delete this._maskExtent;
    var mask = this.layer.getMask();
    if (!mask) {
      this.layer.fire('renderstart', {
        'context': this.context
      });
      return null;
    }
    var maskExtent2D = this._maskExtent = mask._getMaskPainter().get2DExtent();
    if (maskExtent2D && this._extent2D && !maskExtent2D.intersects(this._extent2D)) {
      this.layer.fire('renderstart', {
        'context': this.context
      });
      return maskExtent2D;
    }
    this.layer.fire('renderstart', {
      'context': this.context
    });
    return maskExtent2D;
  };
  _proto2.initContext = function initContext() {};
  _proto2.prepareContext = function prepareContext() {};
  _proto2.clearContext = function clearContext() {
    if (this.device) {
      var mapRenderer = this.getMap().getRenderer();
      if (mapRenderer.isWebGL() || mapRenderer.isWebGPU()) {
        this.device.clear(GL_CLEAR);
      } else {
        this.device.clear(CANVAS_CLEAR);
      }
    }
  };
  _proto2.createContext = function createContext() {
    throw new Error('createContext not implemented');
  };
  _proto2.getViewExtent = function getViewExtent() {
    return {
      'extent': this._extent2D,
      'maskExtent': this._maskExtent,
      'zoom': this._renderZoom,
      'middleWest': this.middleWest
    };
  };
  _proto2.completeRender = function completeRender() {
    if (this.getMap()) {
      this._renderComplete = true;
      this.layer.fire('renderend', {
        'context': this.context
      });
      this.setCanvasUpdated();
    }
  };
  _proto2.getEvents = function getEvents() {
    return {
      '_zoomstart': this.onZoomStart,
      '_zooming': this.onZooming,
      '_zoomend': this.onZoomEnd,
      '_resize': this.onResize,
      '_movestart': this.onMoveStart,
      '_moving': this.onMoving,
      '_moveend': this.onMoveEnd,
      '_dragrotatestart': this.onDragRotateStart,
      '_dragrotating': this.onDragRotating,
      '_dragrotateend': this.onDragRotateEnd,
      '_spatialreferencechange': this.onSpatialReferenceChange
    };
  };
  _proto2.onZoomStart = function onZoomStart(param) {};
  _proto2.onZoomEnd = function onZoomEnd(param) {
    this.setToRedraw();
  };
  _proto2.onZooming = function onZooming(param) {};
  _proto2.onMoveStart = function onMoveStart(param) {};
  _proto2.onMoving = function onMoving(param) {};
  _proto2.onMoveEnd = function onMoveEnd(param) {
    this.setToRedraw();
  };
  _proto2.onResize = function onResize(param) {
    delete this._extent2D;
    this.setToRedraw();
  };
  _proto2.onDragRotateStart = function onDragRotateStart(param) {};
  _proto2.onDragRotating = function onDragRotating(param) {};
  _proto2.onDragRotateEnd = function onDragRotateEnd(param) {
    this.setToRedraw();
  };
  _proto2.onSpatialReferenceChange = function onSpatialReferenceChange(param) {};
  _proto2.getDrawTime = function getDrawTime() {
    return this._drawTime;
  };
  _proto2._tryToDraw = function _tryToDraw(framestamp) {
    this._toRedraw = false;
    if (!this.canvas && this.layer.isEmpty && this.layer.isEmpty()) {
      this._renderComplete = true;
      return;
    }
    this._drawAndRecord(framestamp);
  };
  _proto2._drawAndRecord = function _drawAndRecord(framestamp) {
    var map = this.getMap();
    if (!map) {
      return;
    }
    var painted = this._painted;
    this._painted = true;
    var t = now();
    this.mapDPR = map.getDevicePixelRatio();
    this.draw(framestamp);
    t = now() - t;
    this._drawTime = painted ? t : t / 2;
    if (painted && this.layer && this.layer.options['logDrawTime']) {
      console.log(this.layer.getId(), 'frameTimeStamp:', framestamp, 'drawTime:', this._drawTime);
    }
  };
  _proto2._promiseResource = function _promiseResource(url) {
    var _this3 = this;
    var layer = this.layer;
    var resources = this.resources;
    var crossOrigin = layer.options['crossOrigin'];
    var renderer = layer.options['renderer'] || '';
    return function (resolve) {
      if (resources.isResourceLoaded(url, true)) {
        resolve(url);
        return;
      }
      var imageURL = formatResourceUrl(url[0]);
      if (isImageBitMap(imageURL)) {
        createImageBitmap(imageURL).then(function (newbitmap) {
          _this3._cacheResource(url, newbitmap);
          resolve(url);
        })["catch"](function (err) {
          console.error(err);
          resolve(url);
        });
        return;
      }
      var fetchInWorker = !isSVG(url[0]) && _this3._resWorkerConn && (layer.options['renderer'] !== 'canvas' || layer.options['decodeImageInWorker']);
      if (fetchInWorker) {
        _this3._resWorkerConn.fetchImage(imageURL, function (err, data) {
          if (err) {
            if (err && typeof console !== 'undefined') {
              console.warn(err);
            }
            resolve(url);
            return;
          }
          getImageBitMap(data, function (bitmap) {
            _this3._cacheResource(url, bitmap);
            resolve(url);
          });
        });
      } else {
        var img = new Image();
        if (!isNil(crossOrigin)) {
          img['crossOrigin'] = crossOrigin;
        } else if (renderer !== 'canvas') {
          img['crossOrigin'] = '';
        }
        if (isSVG(url[0]) && !IS_NODE) {
          if (url[1]) {
            url[1] *= 2;
          }
          if (url[2]) {
            url[2] *= 2;
          }
        }
        img.onload = function () {
          _this3._cacheResource(url, img);
          resolve(url);
        };
        img.onabort = function (err) {
          if (console) {
            console.warn('image loading aborted: ' + url[0]);
          }
          if (err) {
            if (console) {
              console.warn(err);
            }
          }
          resolve(url);
        };
        img.onerror = function (err) {
          if (err && typeof console !== 'undefined') {
            console.warn(err);
          }
          resources.markErrorResource(url);
          resolve(url);
        };
        loadImage(img, [imageURL]);
      }
    };
  };
  _proto2._cacheResource = function _cacheResource(url, img) {
    if (!this.layer || !this.resources) {
      return;
    }
    var w = url[1],
      h = url[2];
    if (this.layer.options['cacheSvgOnCanvas'] && isSVG(url[0]) === 1 && (Browser$1.edge || Browser$1.ie)) {
      if (isNil(w)) {
        w = img.width || this.layer.options['defaultIconSize'][0];
      }
      if (isNil(h)) {
        h = img.height || this.layer.options['defaultIconSize'][1];
      }
      var canvas = Canvas.createCanvas(w, h);
      Canvas.image(canvas.getContext('2d'), img, 0, 0, w, h);
      img = canvas;
    }
    this.resources.addResource(url, img);
  };
  _proto2.setCanvasUpdated = function setCanvasUpdated() {
    this._canvasUpdated = true;
    return this;
  };
  _proto2.isCanvasUpdated = function isCanvasUpdated() {
    return !!this._canvasUpdated;
  };
  _proto2.getCanvasImage = function getCanvasImage() {
    var map = this.getMap();
    this._canvasUpdated = false;
    if (this._renderZoom !== map.getZoom() || !this.canvas || !this._extent2D) {
      return null;
    }
    if (this.isBlank()) {
      return null;
    }
    if (this.layer.isEmpty && this.layer.isEmpty()) {
      return null;
    }
    var containerPoint = map._pointToContainerPoint(this.middleWest)._add(0, -map.height / 2);
    return {
      'image': this.canvas,
      'layer': this.layer,
      'point': containerPoint
    };
  };
  _proto2.clearCanvas = function clearCanvas() {
    this.clearContext();
  };
  _proto2.createCanvas = function createCanvas() {
    if (this.canvas) {
      return;
    }
    var map = this.getMap();
    var size = map.getSize();
    var r = map.getDevicePixelRatio(),
      w = Math.round(r * size.width),
      h = Math.round(r * size.height);
    if (this.layer._canvas) {
      var canvas = this.layer._canvas;
      canvas.width = w;
      canvas.height = h;
      if (canvas.style) {
        canvas.style.width = size.width + 'px';
        canvas.style.height = size.height + 'px';
      }
      this.canvas = this.layer._canvas;
    } else {
      this.canvas = Canvas.createCanvas(w, h, map.CanvasClass);
    }
    this.onCanvasCreate();
  };
  _proto2.onCanvasCreate = function onCanvasCreate() {};
  _proto2.resizeCanvas = function resizeCanvas(canvasSize) {
    var canvas = this.canvas;
    var map = this.getMap();
    if (!canvas || canvas === map.canvas) {
      return;
    }
    var size = canvasSize || map.getSize();
    var r = map.getDevicePixelRatio();
    var {
      width: width,
      height: height,
      cssWidth: cssWidth,
      cssHeight: cssHeight
    } = calCanvasSize(size, r);
    if (this.layer._canvas && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
      canvas.style.width = cssWidth;
      canvas.style.height = cssHeight;
    }
    if (canvas.width === width && canvas.height === height) {
      return;
    }
    canvas.height = height;
    canvas.width = width;
    if (this.context) {
      this.context.dpr = 1;
    }
    if (r !== 1 && this.context) {
      this._canvasContextScale(this.context, r);
    }
  };
  _proto2.clipCanvas = function clipCanvas(context) {
    var mask = this.layer.getMask();
    if (!mask) {
      return false;
    }
    if (!this.layer.options.maskClip) {
      return false;
    }
    var old = this.middleWest;
    var map = this.getMap();
    this.middleWest = map._containerPointToPoint(new Point(0, map.height / 2));
    var alpha = context.globalAlpha;
    context.save();
    var dpr = this.mapDPR || map.getDevicePixelRatio();
    if (dpr !== 1) {
      context.save();
      this._canvasContextScale(context, dpr);
    }
    if (mask.getGeometries) {
      context.isMultiClip = true;
      var masks = mask.getGeometries() || [];
      context.beginPath();
      masks.forEach(function (_mask) {
        var painter = _mask._getMaskPainter();
        painter.paint(null, context);
      });
      context.stroke();
      context.isMultiClip = false;
    } else {
      context.isClip = true;
      context.beginPath();
      var painter = mask._getMaskPainter();
      painter.paint(null, context);
      context.isClip = false;
    }
    if (dpr !== 1) {
      context.restore();
    }
    try {
      context.clip('evenodd');
    } catch (error) {
      console.error(error);
    }
    this.middleWest = old;
    context.globalAlpha = alpha;
    return true;
  };
  _proto2._canvasContextScale = function _canvasContextScale(context, dpr) {
    if (!context.scale) {
      return this;
    }
    context.scale(dpr, dpr);
    context.dpr = dpr;
    return this;
  };
  return LayerAbstractRenderer;
}(Class);
var workerSource = "\nfunction (exports) {\n    exports.onmessage = function (msg, postResponse) {\n        var url = msg.data.url;\n        var fetchOptions = msg.data.fetchOptions;\n        requestImageOffscreen(url, function (err, data) {\n            var buffers = [];\n            if (data && data.data) {\n                buffers.push(data.data);\n            }\n            postResponse(err, data, buffers);\n        }, fetchOptions);\n    };\n\n    function requestImageOffscreen(url, cb, fetchOptions) {\n        fetch(url, fetchOptions ? fetchOptions : {})\n            .then(response => response.arrayBuffer())\n            .then(arrayBuffer => {\n                const blob=new Blob([arrayBuffer]);\n                return createImageBitmap(blob);\n            })\n            .then(bitmap => {\n                cb(null, {data:bitmap});\n            }).catch(err => {\n                console.error('error when loading tile:', url);\n                console.error(err);\n                cb(err);\n            });\n    }\n}";
function registerWorkerSource() {
  if (!Browser$1.decodeImageInWorker) {
    return;
  }
  registerWorkerAdapter(imageFetchWorkerKey, function () {
    return workerSource;
  });
}
registerWorkerSource();

var options$C = {
  'attribution': null,
  'minZoom': null,
  'maxZoom': null,
  'visible': true,
  'opacity': 1,
  'globalCompositeOperation': null,
  'renderer': 'canvas',
  'debugOutline': '#0f0',
  'cssFilter': null,
  'forceRenderOnMoving': false,
  'forceRenderOnZooming': false,
  'forceRenderOnRotating': false,
  'collision': false,
  'collisionScope': 'layer',
  'hitDetect': function () {
    return !Browser$1.mobile;
  }(),
  'maskClip': true
};
var Layer = function (_JSONAble) {
  function Layer(id, options) {
    var _this;
    var canvas;
    if (options) {
      canvas = options.canvas;
      delete options.canvas;
    }
    _this = _JSONAble.call(this, options) || this;
    _this._canvas = canvas;
    _this.setId(id);
    if (options) {
      _this.setZIndex(options.zIndex);
      if (options.mask) {
        _this.setMask(Geometry.fromJSON(options.mask));
      }
    }
    _this.proxyOptions();
    return _this;
  }
  _inheritsLoose(Layer, _JSONAble);
  var _proto = Layer.prototype;
  _proto.load = function load() {
    if (!this.getMap()) {
      return this;
    }
    if (this.onLoad()) {
      this._initRenderer();
      var zIndex = this.getZIndex();
      if (!isNil(zIndex)) {
        if (this._renderer) {
          this._renderer.setZIndex(zIndex);
          if (!this.isCanvasRender()) {
            this._renderer.render();
          }
        }
      }
      this.onLoadEnd();
    }
    return this;
  };
  _proto.getId = function getId() {
    return this._id;
  };
  _proto.setId = function setId(id) {
    var old = this._id;
    if (!isNil(id)) {
      id = id + '';
    }
    this._id = id;
    this.fire('idchange', {
      'type': 'idchange',
      'target': this,
      'old': old,
      'new': id
    });
    return this;
  };
  _proto.addTo = function addTo(map) {
    map.addLayer(this);
    return this;
  };
  _proto.setZIndex = function setZIndex(zIndex) {
    this._zIndex = zIndex;
    if (isNil(zIndex)) {
      delete this.options['zIndex'];
    } else {
      this.options.zIndex = zIndex;
    }
    if (this.map) {
      this.map._sortLayersByZIndex();
    }
    if (this._renderer) {
      this._renderer.setZIndex(zIndex);
    }
    this.fire('setzindex', {
      'type': 'setzindex',
      'target': this,
      zIndex: zIndex
    });
    return this;
  };
  _proto.getZIndex = function getZIndex() {
    return this._zIndex || 0;
  };
  _proto.getMinZoom = function getMinZoom() {
    var map = this.getMap();
    var minZoom = this.options['minZoom'];
    return map ? Math.max(map.getMinZoom(), minZoom || 0) : minZoom;
  };
  _proto.getMaxZoom = function getMaxZoom() {
    var map = this.getMap();
    var maxZoom = this.options['maxZoom'];
    return map ? Math.min(map.getMaxZoom(), isNil(maxZoom) ? Infinity : maxZoom) : maxZoom;
  };
  _proto.getOpacity = function getOpacity() {
    return this.options['opacity'];
  };
  _proto.setOpacity = function setOpacity(op) {
    this.config('opacity', op);
    this.fire('setopacity', {
      type: 'setopacity',
      target: this,
      opacity: op
    });
    return this;
  };
  _proto.isCanvasRender = function isCanvasRender() {
    var renderer = this._getRenderer();
    return renderer && renderer instanceof LayerAbstractRenderer;
  };
  _proto.getMap = function getMap() {
    if (this.map) {
      return this.map;
    }
    return null;
  };
  _proto.getProjection = function getProjection() {
    var map = this.getMap();
    return map ? map.getProjection() : null;
  };
  _proto.bringToFront = function bringToFront() {
    var layers = this._getLayerList();
    if (!layers.length) {
      return this;
    }
    var topLayer = layers[layers.length - 1];
    if (layers.length === 1 || topLayer === this) {
      return this;
    }
    var max = topLayer.getZIndex();
    this.setZIndex(max + 1);
    return this;
  };
  _proto.bringToBack = function bringToBack() {
    var layers = this._getLayerList();
    if (!layers.length) {
      return this;
    }
    var bottomLayer = layers[0];
    if (layers.length === 1 || bottomLayer === this) {
      return this;
    }
    var min = bottomLayer.getZIndex();
    this.setZIndex(min - 1);
    return this;
  };
  _proto.show = function show() {
    var _this2 = this;
    if (!this.options['visible']) {
      this.options['visible'] = true;
      var renderer = this.getRenderer();
      if (renderer) {
        renderer.show();
      }
      var map = this.getMap();
      if (renderer && map && map.getRenderer()) {
        map.getRenderer().callInNextFrame(function () {
          map.getRenderer().callInNextFrame(function () {
            _this2.fire('show');
          });
        });
      } else {
        this.fire('show');
      }
    }
    return this;
  };
  _proto.hide = function hide() {
    var _this3 = this;
    if (this.options['visible']) {
      this.options['visible'] = false;
      var renderer = this.getRenderer();
      if (renderer) {
        renderer.hide();
      }
      var map = this.getMap();
      if (renderer && map && map.getRenderer()) {
        map.getRenderer().callInNextFrame(function () {
          map.getRenderer().callInNextFrame(function () {
            _this3.fire('hide');
          });
        });
      } else {
        this.fire('hide');
      }
    }
    return this;
  };
  _proto.isVisible = function isVisible() {
    var opacity = this.options['opacity'];
    if (isNumber(opacity) && opacity <= 0) {
      return false;
    }
    var {
      minZoom: minZoom,
      maxZoom: maxZoom
    } = this.options;
    if (isNumber(minZoom) || isNumber(maxZoom)) {
      var map = this.map;
      if (map) {
        var cache = MapStateCache[map.id];
        var zoom = cache ? cache.zoom : map.getZoom();
        if (!isNil(maxZoom) && maxZoom < zoom || !isNil(minZoom) && minZoom > zoom) {
          return false;
        }
      }
    }
    if (isNil(this.options['visible'])) {
      this.options['visible'] = true;
    }
    return this.options['visible'];
  };
  _proto.remove = function remove() {
    if (this.map) {
      var renderer = this.map.getRenderer();
      this.map.removeLayer(this);
      if (renderer) {
        renderer.setToRedraw();
      }
    } else {
      this.fire('remove');
    }
    return this;
  };
  _proto.getMask = function getMask() {
    return this._mask;
  };
  _proto.setMask = function setMask(mask) {
    if (!(mask.type === 'Point' && mask._isVectorMarker() || mask.type === 'Polygon' || mask.type === 'MultiPolygon')) {
      throw new Error('Mask for a layer must be a marker with vector marker symbol or a Polygon(MultiPolygon).');
    }
    mask._bindLayer(this);
    if (mask.type === 'Point') {
      mask.updateSymbol({
        'markerLineColor': 'rgba(0, 0, 0, 0)',
        'markerFillOpacity': 0
      });
    } else {
      mask.setSymbol({
        'lineColor': 'rgba(0, 0, 0, 0)',
        'polygonOpacity': 0
      });
    }
    this._mask = mask;
    if (mask && mask.toGeoJSON) {
      try {
        this._maskGeoJSON = mask.toGeoJSON();
      } catch (error) {
        delete this._maskGeoJSON;
        console.error(error);
      }
    }
    this.options.mask = mask.toJSON();
    if (!this.getMap() || this.getMap().isZooming()) {
      return this;
    }
    var renderer = this._getRenderer();
    if (renderer && renderer.setToRedraw) {
      this._getRenderer().setToRedraw();
    }
    return this;
  };
  _proto.removeMask = function removeMask() {
    delete this._mask;
    delete this._maskGeoJSON;
    delete this.options.mask;
    if (!this.getMap() || this.getMap().isZooming()) {
      return this;
    }
    var renderer = this._getRenderer();
    if (renderer && renderer.setToRedraw) {
      this._getRenderer().setToRedraw();
    }
    return this;
  };
  _proto.onLoad = function onLoad() {
    return true;
  };
  _proto.onLoadEnd = function onLoadEnd() {};
  _proto.isLoaded = function isLoaded() {
    return !!this._loaded;
  };
  _proto.getCollisionIndex = function getCollisionIndex() {
    if (this.options['collisionScope'] === 'layer') {
      if (!this._collisionIndex) {
        this._collisionIndex = new CollisionIndex();
      }
      return this._collisionIndex;
    }
    var map = this.getMap();
    if (!map) {
      return null;
    }
    return map.getCollisionIndex();
  };
  _proto.clearCollisionIndex = function clearCollisionIndex() {
    if (this.options['collisionScope'] === 'layer' && this._collisionIndex) {
      this._collisionIndex.clear();
    }
    return this;
  };
  _proto.getRenderer = function getRenderer() {
    return this._getRenderer();
  };
  _proto.onConfig = function onConfig(conf) {
    var needUpdate = conf && Object.keys && Object.keys(conf).length > 0;
    if (needUpdate && isNil(conf['animation'])) {
      if (this._optionsHook && isFunction(this._optionsHook)) {
        this._optionsHook(conf);
      }
      if (this._silentConfig) {
        return;
      }
      var renderer = this.getRenderer();
      if (renderer && renderer.setToRedraw) {
        renderer.setToRedraw();
      }
      if ('attribution' in conf) {
        var map = this.getMap();
        if (map && map.attributionControl && map.attributionControl._update) {
          map.attributionControl._update();
        }
      }
    }
  };
  _proto.onAdd = function onAdd() {};
  _proto.onRendererCreate = function onRendererCreate() {};
  _proto.onCanvasCreate = function onCanvasCreate() {};
  _proto.onRemove = function onRemove() {};
  _proto._bindMap = function _bindMap(parent, zIndex) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    if (parent.isMap) {
      this.map = parent;
    } else {
      this.map = parent.getMap();
    }
    if (!isNil(zIndex)) {
      this.setZIndex(zIndex);
    }
    this._switchEvents('on', this);
    this.onAdd();
    this.fire('add');
  };
  _proto._initRenderer = function _initRenderer() {
    var renderer = this.options['renderer'];
    if (!this.constructor.getRendererClass || !renderer) {
      return;
    }
    renderer = this.getRendererOption();
    var clazz = this.constructor.getRendererClass(renderer);
    if (!clazz) {
      throw new Error('Invalid renderer for Layer(' + this.getId() + '):' + renderer);
    }
    this._renderer = new clazz(this);
    this._renderer.layer = this;
    this._renderer.setZIndex(this.getZIndex());
    this._switchEvents('on', this._renderer);
    if (this._renderer.onAdd) {
      this._renderer.onAdd();
    }
    this.onRendererCreate();
    this.fire('renderercreate', {
      'type': 'renderercreate',
      'target': this,
      'renderer': this._renderer
    });
  };
  _proto.getRendererOption = function getRendererOption() {
    var renderer = this.options['renderer'];
    var mapRenderer = this.getMap().getRenderer();
    if (renderer !== 'dom') {
      if (mapRenderer.isWebGL()) {
        renderer = 'gl';
      } else if (mapRenderer.isWebGPU()) {
        renderer = 'gpu';
      }
    }
    return renderer;
  };
  _proto._doRemove = function _doRemove() {
    this._loaded = false;
    this._switchEvents('off', this);
    this.onRemove();
    if (this._renderer) {
      this._switchEvents('off', this._renderer);
      this._renderer.remove();
      delete this._renderer;
    }
    delete this.map;
    delete this._collisionIndex;
  };
  _proto._switchEvents = function _switchEvents(to, emitter) {
    if (emitter && emitter.getEvents && this.getMap()) {
      this.getMap()[to](emitter.getEvents(), emitter);
    }
  };
  _proto._getRenderer = function _getRenderer() {
    return this._renderer;
  };
  _proto._getLayerList = function _getLayerList() {
    if (!this.map) {
      return [];
    }
    var beginIndex = +!!this.map.getBaseLayer();
    return this.map.getLayers().slice(beginIndex);
  };
  _proto._getMask2DExtent = function _getMask2DExtent() {
    if (!this._mask || !this.getMap()) {
      return null;
    }
    var painter = this._mask._getMaskPainter();
    if (!painter) {
      return null;
    }
    return painter.get2DExtent();
  };
  _proto.toJSON = function toJSON(options) {
    return {
      type: 'Layer',
      id: this.getId(),
      options: options || this.config()
    };
  };
  Layer.fromJSON = function fromJSON(layerJSON) {
    if (!layerJSON) {
      return null;
    }
    var layerType = layerJSON['type'];
    var clazz = Layer.getJSONClass(layerType);
    if (!clazz || !clazz.fromJSON) {
      throw new Error('unsupported layer type:' + layerType);
    }
    return clazz.fromJSON(layerJSON);
  };
  _proto.identify = function identify(_coordinate, _options) {};
  _proto.identifyAtPoint = function identifyAtPoint(_containerPoint, _options) {};
  return Layer;
}(JSONAble(Eventable(Renderable(Class))));
Layer.mergeOptions(options$C);
var fire = Layer.prototype.fire;
Layer.prototype.fire = function (eventType, param) {
  if (eventType === 'layerload') {
    this._loaded = true;
  }
  if (this.map) {
    if (!param) {
      param = {
        'type': null,
        'target': null
      };
    }
    param['type'] = eventType;
    param['target'] = this;
    this.map._onLayerEvent(param);
  }
  fire.apply(this, arguments);
  if (['show', 'hide'].indexOf(eventType) > -1) {
    this.fire('visiblechange', Object.assign({}, param, {
      visible: this.options.visible
    }));
  }
  return this;
};

/*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/

var planes = [];
for (var i = 0; i < 6; i++) {
    planes[i] = [];
}

var p = [];

function intersectsBox(matrix, box, mask) {
    setPlanes(matrix);
    for (var i = 0; i < 6; i++) {
        var plane = planes[i];
        // corner at max distance
        p[0] = plane[0] > 0 ? box[1][0] : box[0][0];
        p[1] = plane[1] > 0 ? box[1][1] : box[0][1];
        p[2] = plane[2] > 0 ? box[1][2] : box[0][2];

        if (distanceToPoint(plane, p) < 0) {
            return false;
        }
    }

    return true;
}

function setPlanes(m) {
    var me = m;
    var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];

    //right
    setComponents(planes[0], me3 - me0, me7 - me4, me11 - me8, me15 - me12);
    //left
    setComponents(planes[1], me3 + me0, me7 + me4, me11 + me8, me15 + me12);
    //bottom
    setComponents(planes[2], me3 + me1, me7 + me5, me11 + me9, me15 + me13);
    //top
    setComponents(planes[3], me3 - me1, me7 - me5, me11 - me9, me15 - me13);
    //z-far
    setComponents(planes[4], me3 - me2, me7 - me6, me11 - me10, me15 - me14);
    //z-near
    setComponents(planes[5], me3 + me2, me7 + me6, me11 + me10, me15 + me14);
}

var normalLength = 1.0 / 6;
function setComponents(out, x, y, z, w) {
    out[0] = x * normalLength;
    out[1] = y * normalLength;
    out[2] = z * normalLength;
    out[3] = w * normalLength;
    return out;
}

function distanceToPoint(plane, p) {
    return plane[0] * p[0] + plane[1] * p[1] + plane[2] * p[2] + plane[3];
}

var TEMP_COORD$2 = new Coordinate(0, 0);
var TEMP_POINT$5 = new Point(0, 0);
var REDRAW_OPTIONS_PROPERTIES = ['centerCross', 'fog', 'fogColor', 'debugSky'];
var SKYBOX3 = [[0, 0, 0], [0, 0, 0]];
var options$B = {
  'maxVisualPitch': 70,
  'maxPitch': 80,
  'centerCross': false,
  'zoomable': true,
  'zoomInCenter': false,
  'zoomOrigin': null,
  'zoomAnimation': function () {
    return !IS_NODE;
  }(),
  'zoomAnimationDuration': 330,
  'tileBackgroundLimitPerFrame': 3,
  'panAnimation': function () {
    return !IS_NODE;
  }(),
  'panAnimationDuration': 600,
  'rotateAnimation': function () {
    return !IS_NODE;
  }(),
  'enableInfoWindow': true,
  'hitDetect': function () {
    return !Browser$1.mobile;
  }(),
  'hitDetectLimit': 5,
  'fpsOnInteracting': 25,
  'layerCanvasLimitOnInteracting': -1,
  'maxZoom': null,
  'minZoom': null,
  'maxExtent': null,
  'limitExtentOnMaxExtent': false,
  'fixCenterOnResize': true,
  'checkSize': true,
  'checkSizeInterval': 1000,
  'renderer': ['canvas', 'gl', 'gpu'],
  'cascadePitches': [10, 60],
  'renderable': true,
  'clickTimeThreshold': 280,
  'stopRenderOnOffscreen': true,
  'preventWheelScroll': true,
  'preventTouch': true,
  'supportPluginEvent': true,
  'switchDragButton': false,
  'mousemoveThrottleTime': MOUSEMOVE_THROTTLE_TIME,
  'mousemoveThrottleEnable': true,
  'maxFPS': 0,
  'debug': false,
  'cameraFarUndergroundInMeter': 2000,
  'cameraNearScale': 1,
  'onlyWebGL1': false,
  'forceRedrawPerFrame': false,
  'preserveDrawingBuffer': true,
  'extensions': [],
  'optionalExtensions': ['ANGLE_instanced_arrays', 'OES_element_index_uint', 'OES_standard_derivatives', 'OES_vertex_array_object', 'OES_texture_half_float', 'OES_texture_half_float_linear', 'OES_texture_float', 'OES_texture_float_linear', 'WEBGL_depth_texture', 'EXT_shader_texture_lod', 'EXT_frag_depth', 'EXT_texture_filter_anisotropic', 'WEBGL_compressed_texture_astc', 'WEBGL_compressed_texture_etc', 'WEBGL_compressed_texture_etc1', 'WEBGL_compressed_texture_pvrtc', 'WEBGL_compressed_texture_s3tc', 'WEBGL_compressed_texture_s3tc_srgb']
};
var Map$1 = function (_Handlerable) {
  function Map(container, options) {
    var _this;
    if (!options) {
      throw new Error('Invalid options when creating map.');
    }
    if (!options['center']) {
      throw new Error('Invalid center when creating map.');
    }
    var opts = extend$2({}, options);
    var zoom = opts['zoom'];
    delete opts['zoom'];
    var center = new Coordinate(opts['center']);
    delete opts['center'];
    var baseLayer = opts['baseLayer'];
    delete opts['baseLayer'];
    var layers = opts['layers'];
    delete opts['layers'];
    _this = _Handlerable.call(this, opts) || this;
    _this.isMap = true;
    _this.VERSION = Map.VERSION;
    Object.defineProperty(_this, 'id', {
      value: UID(),
      writable: false
    });
    _this._loaded = false;
    _this._initContainer(container);
    _this._panels = {};
    _this._baseLayer = null;
    _this._layers = [];
    _this._zoomLevel = zoom;
    _this._center = center;
    _this.setSpatialReference(opts['spatialReference'] || opts['view']);
    _this._mapViewPoint = new Point(0, 0);
    _this._initRenderer();
    _this._updateMapSize(_this._getContainerDomSize());
    if (baseLayer) {
      _this.setBaseLayer(baseLayer);
    }
    if (layers) {
      _this.addLayer(layers);
    }
    _this.setMaxExtent(opts['maxExtent']);
    _this._Load();
    _this.proxyOptions();
    return _this;
  }
  _inheritsLoose(Map, _Handlerable);
  Map.addOnLoadHook = function addOnLoadHook(fn, ...args) {
    var onload = typeof fn === 'function' ? fn : function () {
      this[fn].call(this, ...args);
    };
    this.prototype._onLoadHooks = this.prototype._onLoadHooks || [];
    this.prototype._onLoadHooks.push(onload);
    return this;
  };
  var _proto = Map.prototype;
  _proto.isLoaded = function isLoaded() {
    return !!this._loaded;
  };
  _proto.getContainer = function getContainer() {
    return this._containerDOM;
  };
  _proto.getSpatialReference = function getSpatialReference() {
    return this._spatialReference;
  };
  _proto.setSpatialReference = function setSpatialReference(ref) {
    var oldRef = this.options['spatialReference'];
    if (this._loaded && SpatialReference.equals(oldRef, ref)) {
      return this;
    }
    this._updateSpatialReference(ref, oldRef);
    return this;
  };
  _proto._updateSpatialReference = function _updateSpatialReference(ref, oldRef) {
    if (isString(ref)) {
      ref = SpatialReference.getPreset(ref);
    }
    ref = extend$2({}, ref);
    this._center = this.getCenter();
    this.options['spatialReference'] = ref;
    this._spatialReference = new SpatialReference(ref);
    var projection = this._spatialReference.getProjection();
    if (this.options['spatialReference'] && isFunction(this.options['spatialReference']['projection'])) {
      this.options['spatialReference']['projection'] = projection['code'];
    }
    this._resetMapStatus();
    if (EPSG9807.is(projection.code)) {
      this._originLng = projection.centralMeridian;
      this._altitudeOriginDirty = true;
    }
    this._fireEvent('spatialreferencechange', {
      'old': oldRef,
      'new': extend$2({}, this.options['spatialReference'])
    });
    return this;
  };
  _proto.onConfig = function onConfig(conf) {
    var ref = conf['spatialReference'] || conf['view'];
    if (!isNil(ref)) {
      this._updateSpatialReference(ref, null);
    }
    if (this.options.renderer === 'canvas') {
      var needUpdate = false;
      for (var i = 0, len = REDRAW_OPTIONS_PROPERTIES.length; i < len; i++) {
        var key = REDRAW_OPTIONS_PROPERTIES[i];
        if (!isNil(conf[key])) {
          needUpdate = true;
          break;
        }
      }
      if (!needUpdate) {
        return this;
      }
    }
    var renderer = this.getRenderer();
    if (renderer) {
      renderer.setToRedraw();
    }
    return this;
  };
  _proto.getProjection = function getProjection() {
    if (!this._spatialReference) {
      return null;
    }
    return this._spatialReference.getProjection();
  };
  _proto.getFullExtent = function getFullExtent() {
    if (!this._spatialReference) {
      return null;
    }
    return this._spatialReference.getFullExtent();
  };
  _proto.setCursor = function setCursor(cursor) {
    delete this._cursor;
    this._trySetCursor(cursor);
    this._cursor = cursor;
    return this;
  };
  _proto.resetCursor = function resetCursor() {
    return this.setCursor(null);
  };
  _proto.getCenter = function getCenter() {
    if (!this._loaded || !this._prjCenter) {
      return this._center;
    }
    var projection = this.getProjection();
    var center = projection.unproject(this._prjCenter);
    center.x = Math.round(center.x * 1E8) / 1E8;
    center.y = Math.round(center.y * 1E8) / 1E8;
    if (this.centerAltitude) {
      center.z = this.centerAltitude;
    }
    return center;
  };
  _proto.setCenter = function setCenter(center, padding) {
    if (!center) {
      return this;
    }
    center = new Coordinate(center);
    if (padding) {
      center = this._getCenterByPadding(center, this.getZoom(), padding);
    }
    var projection = this.getProjection();
    var pcenter = projection.project(center);
    if (!this._verifyExtent(pcenter) && !this.options.limitExtentOnMaxExtent) {
      return this;
    }
    if (!this._loaded) {
      this._center = center;
      return this;
    }
    this.onMoveStart();
    this._setPrjCenter(pcenter);
    this.onMoveEnd(this._parseEventFromCoord(this.getCenter()));
    return this;
  };
  _proto.getSize = function getSize() {
    if (isNil(this.width) || isNil(this.height)) {
      return this._getContainerDomSize();
    }
    return new Size(this.width, this.height);
  };
  _proto.getContainerExtent = function getContainerExtent() {
    var visualHeight = this.height;
    var pitch = this.getPitch(),
      maxVisualPitch = this.options['maxVisualPitch'];
    if (maxVisualPitch && pitch > maxVisualPitch) {
      visualHeight = this._getVisualHeight(maxVisualPitch);
    }
    return new PointExtent(0, this.height - visualHeight, this.width, this.height);
  };
  _proto.getGroundExtent = function getGroundExtent() {
    var _this2 = this;
    var extent = this.getContainerExtent();
    var {
      ymin: ymin
    } = extent;
    if (ymin > 0 || this.getPitch() > 60) {
      var halfh = this.height / 2;
      var halfw = this.width / 2;
      var box = SKYBOX3;
      var p1 = new Point(halfw, ymin);
      var p2 = p1.copy();
      var glRes = this.getGLRes();
      var scale = this.getScale();
      var calBox = function calBox() {
        var p3 = _this2['_containerPointToPointAtRes'](p1, glRes);
        var p4 = _this2['_containerPointToPointAtRes'](p2, glRes);
        box[0][0] = Math.min(p3.x, p4.x);
        box[0][1] = Math.min(p3.y, p4.y);
        box[1][0] = Math.max(p3.x, p4.x);
        box[1][1] = Math.max(p3.y, p4.y);
      };
      if (scale > 15) {
        for (var y = ymin; y <= halfh; y++) {
          p1.y = y;
          p2.y = y + 1;
          calBox();
          if (intersectsBox(this.projViewMatrix, box)) {
            extent.ymin = y;
            break;
          }
        }
      } else {
        for (var _y = ymin; _y >= 0; _y--) {
          p1.y = _y;
          p2.y = _y - 1;
          calBox();
          if (!intersectsBox(this.projViewMatrix, box)) {
            extent.ymin = _y;
            break;
          }
        }
      }
    }
    return extent;
  };
  _proto._getVisualHeight = function _getVisualHeight(visualPitch) {
    visualPitch = visualPitch || 1E-2;
    var pitch = (90 - this.getPitch()) * Math.PI / 180;
    var fov = this.getFov() * Math.PI / 180;
    visualPitch *= Math.PI / 180;
    var cameraToCenter = this.cameraCenterDistance / this.getGLScale();
    var tanB = Math.tan(fov / 2);
    var tanP = Math.tan(visualPitch);
    var visualDistance = cameraToCenter * tanB / (1 / tanP - tanB) / Math.sin(visualPitch);
    var x = cameraToCenter * (Math.sin(pitch) * visualDistance / (cameraToCenter + Math.cos(pitch) * visualDistance));
    return this.height / 2 + x;
  };
  _proto.getExtent = function getExtent() {
    return this.pointToExtent(this.get2DExtent());
  };
  _proto.getProjExtent = function getProjExtent() {
    var extent2D = this.get2DExtent();
    return new Extent(this._pointToPrj(extent2D.getMin()), this._pointToPrj(extent2D.getMax()));
  };
  _proto.getPrjExtent = function getPrjExtent() {
    return this.getProjExtent();
  };
  _proto.getMaxExtent = function getMaxExtent() {
    if (!this.options['maxExtent']) {
      return null;
    }
    return new Extent(this.options['maxExtent'], this.getProjection());
  };
  _proto.setMaxExtent = function setMaxExtent(extent) {
    if (extent) {
      var maxExt = new Extent(extent, this.getProjection());
      this.options['maxExtent'] = maxExt;
      var projection = this.getProjection();
      this._prjMaxExtent = maxExt.convertTo(function (c) {
        return projection.project(c);
      });
      if (!this._verifyExtent(this._getPrjCenter())) {
        if (this._loaded) {
          this._panTo(this._prjMaxExtent.getCenter());
        } else {
          this._center = projection.unproject(this._prjMaxExtent.getCenter());
        }
      }
    } else {
      delete this.options['maxExtent'];
      delete this._prjMaxExtent;
    }
    return this;
  };
  _proto.getZoom = function getZoom() {
    return this._zoomLevel;
  };
  _proto.getZoomForScale = function getZoomForScale(scale, fromZoom, isFraction) {
    var zoom = this.getZoom();
    if (isNil(fromZoom)) {
      fromZoom = zoom;
    }
    if (scale === 1 && fromZoom === zoom) {
      return zoom;
    }
    var res = this._getResolution(fromZoom),
      targetRes = res / scale;
    var scaleZoom = this.getZoomFromRes(targetRes);
    if (isFraction) {
      return scaleZoom;
    } else {
      var delta = 1E-6;
      return this.getSpatialReference().getZoomDirection() < 0 ? Math.ceil(scaleZoom - delta) : Math.floor(scaleZoom + delta);
    }
  };
  _proto.getZoomFromRes = function getZoomFromRes(res) {
    var resolutions = this._getResolutions(),
      minRes = this._getResolution(this.getMinZoom()),
      maxRes = this._getResolution(this.getMaxZoom());
    if (minRes <= maxRes) {
      if (res <= minRes) {
        return this.getMinZoom();
      } else if (res >= maxRes) {
        return this.getMaxZoom();
      }
    } else if (res >= minRes) {
      return this.getMinZoom();
    } else if (res <= maxRes) {
      return this.getMaxZoom();
    }
    var l = resolutions.length;
    for (var i = 0; i < l - 1; i++) {
      if (!resolutions[i]) {
        continue;
      }
      var gap = resolutions[i + 1] - resolutions[i];
      var test = res - resolutions[i];
      if (sign(gap) === sign(test) && Math.abs(gap) >= Math.abs(test)) {
        return i + test / gap;
      }
    }
    return l - 1;
  };
  _proto.setZoom = function setZoom(zoom, options = {
    'animation': true
  }) {
    if (isNaN(zoom) || isNil(zoom)) {
      return this;
    }
    zoom = +zoom;
    if (this._loaded && this.options['zoomAnimation'] && options['animation']) {
      this._zoomAnimation(zoom);
    } else {
      this._zoom(zoom);
    }
    return this;
  };
  _proto.getMaxZoom = function getMaxZoom() {
    if (!isNil(this.options['maxZoom'])) {
      return this.options['maxZoom'];
    }
    return this.getMaxNativeZoom();
  };
  _proto.setMaxZoom = function setMaxZoom(maxZoom) {
    var viewMaxZoom = this.getMaxNativeZoom();
    if (maxZoom > viewMaxZoom) {
      maxZoom = viewMaxZoom;
    }
    if (maxZoom !== null && maxZoom < this._zoomLevel) {
      this.setZoom(maxZoom);
      maxZoom = +maxZoom;
    }
    this.options['maxZoom'] = maxZoom;
    return this;
  };
  _proto.getMinZoom = function getMinZoom() {
    if (!isNil(this.options['minZoom'])) {
      return this.options['minZoom'];
    }
    return this._spatialReference.getMinZoom();
  };
  _proto.setMinZoom = function setMinZoom(minZoom) {
    if (minZoom !== null) {
      minZoom = +minZoom;
      var viewMinZoom = this._spatialReference.getMinZoom();
      if (minZoom < viewMinZoom) {
        minZoom = viewMinZoom;
      }
      if (minZoom > this._zoomLevel) {
        this.setZoom(minZoom);
      }
    }
    this.options['minZoom'] = minZoom;
    return this;
  };
  _proto.getMaxNativeZoom = function getMaxNativeZoom() {
    var ref = this.getSpatialReference();
    if (!ref) {
      return null;
    }
    return ref.getMaxZoom();
  };
  _proto.getGLRes = function getGLRes() {
    if (this._glRes) {
      return this._glRes;
    }
    var fullExtent = this.getSpatialReference().getFullExtent();
    this._glRes = (fullExtent.right - fullExtent.left) / Math.pow(2, 19);
    return this._glRes;
  };
  _proto.getGLScale = function getGLScale(zoom) {
    if (isNil(zoom)) {
      zoom = this.getZoom();
    }
    return this._getResolution(zoom) / this.getGLRes();
  };
  _proto.zoomIn = function zoomIn() {
    return this.setZoom(this.getZoom() + 1);
  };
  _proto.zoomOut = function zoomOut() {
    return this.setZoom(this.getZoom() - 1);
  };
  _proto.isZooming = function isZooming() {
    return !!this._zooming;
  };
  _proto.isInteracting = function isInteracting() {
    return this.isZooming() || this.isMoving() || this.isRotating();
  };
  _proto.setCenterAndZoom = function setCenterAndZoom(center, zoom) {
    if (!isNil(zoom) && this._zoomLevel !== zoom) {
      this.setCenter(center);
      this.setZoom(zoom, {
        animation: false
      });
    } else {
      this.setCenter(center);
    }
    return this;
  };
  _proto._getPaddingSize = function _getPaddingSize(options = {}) {
    if (options['paddingLeft'] || options['paddingTop'] || options['paddingRight'] || options['paddingBottom']) {
      return {
        width: (options['paddingLeft'] || 0) + (options['paddingRight'] || 0),
        height: (options['paddingTop'] || 0) + (options['paddingBottom'] || 0)
      };
    }
    return null;
  };
  _proto.getFitZoom = function getFitZoom(extent, isFraction, padding) {
    var _this3 = this;
    if (!extent || !(extent instanceof Extent)) {
      return this._zoomLevel;
    }
    if (extent['xmin'] === extent['xmax'] && extent['ymin'] === extent['ymax']) {
      return this.getMaxZoom();
    }
    var size = this.getSize();
    var paddingSize = this._getPaddingSize(padding);
    if (paddingSize) {
      var rect = {
        width: size.width - (paddingSize.width || 0),
        height: size.height - (paddingSize.height || 0)
      };
      size = new Size(rect.width, rect.height);
    }
    var containerExtent = extent.convertTo(function (p) {
      return _this3.coordToPoint(p);
    });
    var w = containerExtent.getWidth(),
      h = containerExtent.getHeight();
    var scaleX = size['width'] / w,
      scaleY = size['height'] / h;
    var scale = this.getSpatialReference().getZoomDirection() < 0 ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);
    var zoom = this.getZoomForScale(scale, null, isFraction);
    return zoom;
  };
  _proto.getView = function getView() {
    return {
      'center': this.getCenter().toArray(),
      'zoom': this.getZoom(),
      'pitch': this.getPitch(),
      'bearing': this.getBearing()
    };
  };
  _proto.stringifyView = function stringifyView() {
    return JSON.stringify(this.getView());
  };
  _proto._validateView = function _validateView(view) {
    if (!view || !isObject$1(view)) {
      return;
    }
    if (isNumber(view.bearing)) {
      var bearing = view.bearing;
      bearing = bearing % 360;
      if (bearing > 180) {
        bearing = -180 + Math.abs(bearing - 180);
      }
      if (bearing < -180) {
        bearing = 180 - Math.abs(bearing + 180);
      }
      view.bearing = bearing;
    }
    if (isNumber(view.pitch)) {
      view.pitch = Math.max(0, view.pitch);
      view.pitch = Math.min(this.options.maxPitch, view.pitch);
    }
    var maxZoom = this.getMaxZoom();
    if (isNumber(view.zoom)) {
      view.zoom = Math.max(0, view.zoom);
      view.zoom = Math.min(maxZoom, view.zoom);
    }
    return;
  };
  _proto.setView = function setView(view) {
    if (!view) {
      return this;
    }
    this._validateView(view);
    if (view['center']) {
      this.setCenter(view['center']);
    }
    if (view['zoom'] !== null && !isNaN(+view['zoom'])) {
      this.setZoom(+view['zoom'], {
        'animation': false
      });
    }
    if (view['pitch'] !== null && !isNaN(+view['pitch'])) {
      this.setPitch(+view['pitch']);
    }
    if (view['bearing'] !== null && !isNaN(+view['bearing'])) {
      this.setBearing(+view['bearing']);
    }
    return this;
  };
  _proto.getResolution = function getResolution(zoom) {
    return this._getResolution(zoom);
  };
  _proto.getScale = function getScale(zoom) {
    var z = isNil(zoom) ? this.getZoom() : zoom;
    var max = this._getResolution(this.getMaxNativeZoom()),
      res = this._getResolution(z);
    return res / max;
  };
  _proto._getCenterByPadding = function _getCenterByPadding(center, zoom, padding) {
    var point = this.coordinateToPoint(center, zoom);
    var {
      paddingLeft = 0,
      paddingRight = 0,
      paddingTop = 0,
      paddingBottom = 0
    } = padding || {};
    var pX = 0;
    var pY = 0;
    if (paddingLeft || paddingRight) {
      pX = (paddingRight - paddingLeft) / 2;
    }
    if (paddingTop || paddingBottom) {
      pY = (paddingTop - paddingBottom) / 2;
    }
    var newPoint = new Point({
      x: point.x + pX,
      y: point.y + pY
    });
    return this.pointToCoordinate(newPoint, zoom);
  };
  _proto.fitExtent = function fitExtent(extent, zoomOffset, options, step) {
    var _this4 = this;
    options = options || {};
    if (!extent) {
      return this;
    }
    var syncExtent = new Extent(extent);
    var zoom = this.getFitZoom(syncExtent, options.isFraction || false, options) + (zoomOffset || 0);
    var containerExtent = syncExtent.convertTo(function (p) {
      return _this4.coordToPoint(p);
    });
    var center = this.pointToCoord(containerExtent.getCenter());
    if (this._getPaddingSize(options)) {
      center = this._getCenterByPadding(center, zoom, options);
    }
    var maxAltitude = extent.zmax;
    if (isNumber(maxAltitude) && maxAltitude !== 0) {
      var currentCenterZ = this.getCenter().z || 0;
      if (maxAltitude > currentCenterZ) {
        center.z = maxAltitude;
      }
    }
    if (typeof options['animation'] === 'undefined' || options['animation']) return this._animateTo({
      center: center,
      zoom: zoom
    }, {
      'duration': options['duration'] || this.options['zoomAnimationDuration'],
      'easing': options['easing'] || 'out'
    }, step);else return this.setCenterAndZoom(center, zoom);
  };
  _proto.getBaseLayer = function getBaseLayer() {
    return this._baseLayer;
  };
  _proto.setBaseLayer = function setBaseLayer(baseLayer) {
    var isChange = false;
    if (this._baseLayer) {
      isChange = true;
      this._fireEvent('baselayerchangestart');
      this._baseLayer.remove();
    }
    if (!baseLayer) {
      delete this._baseLayer;
      this._fireEvent('baselayerchangeend');
      this._fireEvent('setbaselayer');
      return this;
    }
    this._baseLayer = baseLayer;
    baseLayer._bindMap(this, -1);
    function onbaseLayerload() {
      this._fireEvent('baselayerload');
      if (isChange) {
        isChange = false;
        this._fireEvent('baselayerchangeend');
      }
    }
    this._baseLayer.on('layerload', onbaseLayerload, this);
    if (this._loaded) {
      this._baseLayer.load();
    }
    this._fireEvent('setbaselayer');
    return this;
  };
  _proto.removeBaseLayer = function removeBaseLayer() {
    if (this._baseLayer) {
      this._baseLayer.remove();
      delete this._baseLayer;
      this._fireEvent('baselayerremove');
    }
    return this;
  };
  _proto.getLayers = function getLayers(filter) {
    return this._getLayers(function (layer) {
      if (layer === this._baseLayer || layer.getId().indexOf(INTERNAL_LAYER_PREFIX) >= 0) {
        return false;
      }
      if (filter) {
        return filter(layer);
      }
      return true;
    });
  };
  _proto.getLayer = function getLayer(id) {
    if (!id) {
      return null;
    }
    var layer = this._layerCache ? this._layerCache[id] : null;
    if (layer) {
      return layer;
    }
    var baseLayer = this.getBaseLayer();
    if (baseLayer && baseLayer.getId() === id) {
      return baseLayer;
    }
    return null;
  };
  _proto.addLayer = function addLayer(layers, ...otherLayers) {
    if (!layers) {
      return this;
    }
    if (!Array.isArray(layers)) {
      layers = [layers];
    }
    if (otherLayers && otherLayers.length) {
      layers = layers.concat(otherLayers);
    }
    if (!this._layerCache) {
      this._layerCache = {};
    }
    var mapLayers = this._layers;
    for (var i = 0, len = layers.length; i < len; i++) {
      var layer = layers[i];
      var id = layer.getId();
      if (isNil(id)) {
        throw new Error('Invalid id for the layer: ' + id);
      }
      if (layer.getMap() === this) {
        continue;
      }
      if (this._layerCache[id]) {
        throw new Error('Duplicate layer id in the map: ' + id);
      }
      this._layerCache[id] = layer;
      layer._bindMap(this);
      mapLayers.push(layer);
      if (this._loaded) {
        layer.load();
      }
    }
    this._sortLayersByZIndex();
    this._fireEvent('addlayer', {
      'layers': layers
    });
    return this;
  };
  _proto.removeLayer = function removeLayer(layers) {
    if (!layers) {
      return this;
    }
    if (!Array.isArray(layers)) {
      return this.removeLayer([layers]);
    }
    var removed = [];
    for (var i = 0, len = layers.length; i < len; i++) {
      var layer = layers[i];
      if (!(layer instanceof Layer)) {
        layer = this.getLayer(layer);
      }
      if (!layer) {
        continue;
      }
      var map = layer.getMap();
      if (!map || map !== this) {
        continue;
      }
      removed.push(layer);
      this._removeLayer(layer, this._layers);
      if (this._loaded) {
        layer._doRemove();
      }
      var id = layer.getId();
      if (this._layerCache) {
        delete this._layerCache[id];
      }
    }
    if (removed.length > 0) {
      var renderer = this.getRenderer();
      if (renderer) {
        if (this.options.renderer === 'canvas') {
          renderer.setLayerCanvasUpdated();
        } else {
          renderer.setToRedraw();
        }
      }
      this.once('frameend', function () {
        removed.forEach(function (layer) {
          layer.fire('remove');
        });
      });
    }
    this._fireEvent('removelayer', {
      'layers': layers
    });
    return this;
  };
  _proto._findTerrainLayer = function _findTerrainLayer() {
    if (isTerrainLayer(this._baseLayer)) {
      return this._baseLayer;
    }
    var layers = this._getLayers() || [];
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if (isTerrainLayer(layer)) {
        return layer;
      }
    }
    return null;
  };
  _proto.sortLayers = function sortLayers(layers) {
    if (!layers || !Array.isArray(layers)) {
      return this;
    }
    var layersToOrder = [];
    var minZ = Number.MAX_VALUE;
    for (var i = 0, l = layers.length; i < l; i++) {
      var layer = layers[i];
      if (isString(layers[i])) {
        layer = this.getLayer(layer);
      }
      if (!(layer instanceof Layer) || !layer.getMap() || layer.getMap() !== this) {
        throw new Error('It must be a layer added to this map to order.');
      }
      if (layer.getZIndex() < minZ) {
        minZ = layer.getZIndex();
      }
      layersToOrder.push(layer);
    }
    for (var _i = 0, _l = layersToOrder.length; _i < _l; _i++) {
      layersToOrder[_i].setZIndex(minZ + _i);
    }
    return this;
  };
  _proto.toDataURL = function toDataURL(options) {
    if (!options) {
      options = {};
    }
    var mimeType = options['mimeType'];
    if (!mimeType) {
      mimeType = 'image/png';
    }
    var save = options['save'];
    var renderer = this._getRenderer();
    if (renderer && renderer.toDataURL) {
      var file = options['fileName'];
      if (!file) {
        file = 'export';
      }
      var dataURL = renderer.toDataURL(mimeType, options.quality || 0.92);
      if (save && dataURL) {
        var imgURL;
        if (typeof Blob !== 'undefined' && typeof atob !== 'undefined') {
          var blob = b64toBlob(dataURL.replace(/^data:image\/(png|jpeg|jpg|webp);base64,/, ''), mimeType);
          imgURL = URL.createObjectURL(blob);
        } else {
          imgURL = dataURL;
        }
        var dlLink = document.createElement('a');
        dlLink.download = file;
        dlLink.href = imgURL;
        document.body.appendChild(dlLink);
        dlLink.click();
        document.body.removeChild(dlLink);
      }
      return dataURL;
    }
    return null;
  };
  _proto.coordToPoint = function coordToPoint(coordinate, zoom, out) {
    return this.coordinateToPoint(coordinate, zoom, out);
  };
  _proto.coordToPointAtRes = function coordToPointAtRes(coordinate, res, out) {
    return this.coordinateToPointAtRes(coordinate, res, out);
  };
  _proto.pointToCoord = function pointToCoord(point, zoom, out) {
    return this.pointToCoordinate(point, zoom, out);
  };
  _proto.pointAtResToCoord = function pointAtResToCoord(point, res, out) {
    return this.pointAtResToCoordinate(point, res, out);
  };
  _proto.coordToViewPoint = function coordToViewPoint(coordinate, out, altitude) {
    return this.coordinateToViewPoint(coordinate, out, altitude);
  };
  _proto.viewPointToCoord = function viewPointToCoord(viewPoint, out) {
    return this.viewPointToCoordinate(viewPoint, out);
  };
  _proto.coordToContainerPoint = function coordToContainerPoint(coordinate, zoom, out) {
    return this.coordinateToContainerPoint(coordinate, zoom, out);
  };
  _proto.containerPointToCoord = function containerPointToCoord(containerPoint, out) {
    return this.containerPointToCoordinate(containerPoint, out);
  };
  _proto.containerPointToViewPoint = function containerPointToViewPoint(containerPoint, out) {
    if (out) {
      out.set(containerPoint.x, containerPoint.y);
    } else {
      out = containerPoint.copy();
    }
    return out._sub(this.getViewPoint());
  };
  _proto.viewPointToContainerPoint = function viewPointToContainerPoint(viewPoint, out) {
    if (out) {
      out.set(viewPoint.x, viewPoint.y);
    } else {
      out = viewPoint.copy();
    }
    return out._add(this.getViewPoint());
  };
  _proto.checkSize = function checkSize(force) {
    var justStart = now() - this._initTime < 1500 && this.width === 0 || this.height === 0;
    var watched = this._getContainerDomSize(),
      oldHeight = this.height,
      oldWidth = this.width;
    if (!force && watched['width'] === oldWidth && watched['height'] === oldHeight) {
      return this;
    }
    computeDomPosition(this._containerDOM);
    var center = this.getCenter();
    if (!this.options['fixCenterOnResize']) {
      var vh = this._getVisualHeight(this.getPitch());
      var nwCP = new Point(0, this.height - vh);
      var nwCoord = this._containerPointToPrj(nwCP);
      this._updateMapSize(watched);
      var vhAfter = this._getVisualHeight(this.getPitch());
      var nwCPAfter = new Point(0, this.height - vhAfter);
      this._setPrjCoordAtContainerPoint(nwCoord, nwCPAfter);
      this._mapViewCoord = this._getPrjCenter();
    } else {
      this._updateMapSize(watched);
    }
    var hided = watched['width'] === 0 || watched['height'] === 0 || oldWidth === 0 || oldHeight === 0;
    if (justStart || hided) {
      this._eventSilence = true;
      this.setCenter(center);
      delete this._eventSilence;
    }
    this._fireEvent('resize');
    return this;
  };
  _proto.locate = function locate(coordinate, dx, dy) {
    return this.getProjection()._locate(new Coordinate(coordinate), dx, dy);
  };
  _proto.getMainPanel = function getMainPanel() {
    var renderer = this._getRenderer();
    if (!renderer) {
      return null;
    }
    return renderer.getMainPanel();
  };
  _proto.getPanels = function getPanels() {
    return this._panels;
  };
  _proto.remove = function remove() {
    var _this5 = this;
    if (this.isRemoved()) {
      return this;
    }
    this._fireEvent('removestart');
    var animationPlayerList = [this._animPlayer, this._mapAnimPlayer];
    animationPlayerList.forEach(function (player) {
      if (player && player.finish) {
        _this5._stopAnim(player);
      }
    });
    this._removeDomEvents();
    this._clearHandlers();
    this.removeBaseLayer();
    var layers = this.getLayers();
    for (var i = 0; i < layers.length; i++) {
      layers[i].remove();
    }
    if (this._getRenderer()) {
      this._getRenderer().remove();
    }
    if (this._containerDOM.childNodes && this._containerDOM.childNodes.length > 0) {
      Array.prototype.slice.call(this._containerDOM.childNodes, 0).filter(function (node) {
        return node.className === 'maptalks-wrapper';
      }).forEach(function (node) {
        return _this5._containerDOM.removeChild(node);
      });
    }
    delete this._panels;
    delete this._containerDOM;
    delete this._renderer;
    this._fireEvent('removeend');
    this._clearAllListeners();
    return this;
  };
  _proto.isRemoved = function isRemoved() {
    return !this._containerDOM;
  };
  _proto.isMoving = function isMoving() {
    return !!this._moving;
  };
  _proto.onMoveStart = function onMoveStart(param) {
    if (this._mapAnimPlayer) {
      this._stopAnim(this._mapAnimPlayer);
    }
    var prjCenter = this._getPrjCenter();
    if (!this._originCenter || this._verifyExtent(prjCenter)) {
      this._originCenter = prjCenter;
    }
    this._moving = true;
    this._trySetCursor('move');
    this._fireEvent('movestart', this._parseEvent(param ? param['domEvent'] : null, 'movestart'));
  };
  _proto.onMoving = function onMoving(param) {
    this._fireEvent('moving', this._parseEvent(param ? param['domEvent'] : null, 'moving'));
    this._limitMaxExtent();
  };
  _proto.onMoveEnd = function onMoveEnd(param) {
    this._moving = false;
    if (!this._suppressRecenter) {
      this._recenterOnTerrain();
    }
    this._trySetCursor('default');
    this._fireEvent('moveend', param && param['domEvent'] ? this._parseEvent(param['domEvent'], 'moveend') : param);
    if (!this._verifyExtent(this._getPrjCenter()) && this._originCenter && !this.options.limitExtentOnMaxExtent) {
      var moveTo = this._originCenter;
      this._panTo(moveTo);
    }
    this._limitMaxExtent();
  };
  _proto.onDragRotateStart = function onDragRotateStart(param) {
    this._dragRotating = true;
    this._fireEvent('dragrotatestart', this._parseEvent(param ? param['domEvent'] : null, 'dragrotatestart'));
  };
  _proto.onDragRotating = function onDragRotating(param) {
    this._fireEvent('dragrotating', this._parseEvent(param ? param['domEvent'] : null, 'dragrotating'));
  };
  _proto.onDragRotateEnd = function onDragRotateEnd(param) {
    this._dragRotating = false;
    this._fireEvent('dragrotateend', this._parseEvent(param ? param['domEvent'] : null, 'dragrotateend'));
  };
  _proto.isDragRotating = function isDragRotating() {
    return !!this._dragRotating;
  };
  _proto.isOffscreen = function isOffscreen(box, viewportPadding = 0) {
    var {
      width: width,
      height: height
    } = this;
    var screenRightBoundary = width + viewportPadding;
    var screenBottomBoundary = height + viewportPadding;
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = box;
    if (Array.isArray(box)) {
      [xmin, ymin, xmax, ymax] = box;
    }
    return xmax < viewportPadding || xmin >= screenRightBoundary || ymax < viewportPadding || ymin > screenBottomBoundary;
  };
  _proto.getRenderer = function getRenderer() {
    return this._getRenderer();
  };
  _proto.getDevicePixelRatio = function getDevicePixelRatio() {
    return this.options['devicePixelRatio'] || Browser$1.devicePixelRatio || 1;
  };
  _proto.setDevicePixelRatio = function setDevicePixelRatio(dpr) {
    if (isNumber(dpr) && dpr > 0 && dpr !== this.options['devicePixelRatio']) {
      this.options['devicePixelRatio'] = dpr;
      this.checkSize(true);
    }
    return this;
  };
  _proto._initContainer = function _initContainer(container) {
    var _a, _b;
    if (isString(container)) {
      this._containerDOM = document.getElementById(container);
      if (!this._containerDOM) {
        throw new Error('Invalid container when creating map: \'' + container + '\'');
      }
    } else {
      this._containerDOM = container;
      if (IS_NODE) {
        this.CanvasClass = this._containerDOM.constructor;
      }
    }
    if (((_b = (_a = this._containerDOM) === null || _a === void 0 ? void 0 : _a.childNodes) === null || _b === void 0 ? void 0 : _b.length) > 0) {
      var firstChild = this._containerDOM.childNodes[0];
      if (firstChild instanceof HTMLElement && firstChild.classList.contains('maptalks-wrapper')) {
        throw new Error('Container is already loaded with another map instance, use map.remove() to clear it.');
      }
    }
  };
  _proto._trySetCursor = function _trySetCursor(cursor) {
    if (!this._cursor && !this._priorityCursor) {
      if (!cursor) {
        cursor = 'default';
      }
      this._setCursorToPanel(cursor);
    }
    return this;
  };
  _proto._setPriorityCursor = function _setPriorityCursor(cursor) {
    if (!cursor) {
      var hasCursor = false;
      if (this._priorityCursor) {
        hasCursor = true;
      }
      delete this._priorityCursor;
      if (hasCursor) {
        this.setCursor(this._cursor);
      }
    } else {
      this._priorityCursor = cursor;
      this._setCursorToPanel(cursor);
    }
    return this;
  };
  _proto._setCursorToPanel = function _setCursorToPanel(cursor) {
    var panel = this.getMainPanel();
    if (panel && panel.style && panel.style.cursor !== cursor) {
      panel.style.cursor = cursor;
    }
  };
  _proto._removeLayer = function _removeLayer(layer, layerList) {
    if (!layer || !layerList) {
      return;
    }
    var index = layerList.indexOf(layer);
    if (index > -1) {
      layerList.splice(index, 1);
    }
  };
  _proto._sortLayersByZIndex = function _sortLayersByZIndex() {
    if (!this._layers) {
      return;
    }
    for (var i = 0, l = this._layers.length; i < l; i++) {
      var layer = this._layers[i];
      layer._order = i;
      if (layer.sortLayersByZIndex) {
        layer.sortLayersByZIndex();
      }
    }
    this._layers.sort(function (a, b) {
      var c = a.getZIndex() - b.getZIndex();
      if (c === 0) {
        return a._order - b._order;
      }
      return c;
    });
  };
  _proto._fireEvent = function _fireEvent(eventName, param) {
    if (this._eventSilence) {
      return;
    }
    var underline = '_';
    if (eventName[0] !== underline) {
      this.fire(underline + eventName, param);
    }
    this.fire(eventName, param);
  };
  _proto._Load = function _Load() {
    this._resetMapStatus();
    if (this.options['pitch']) {
      this.setPitch(this.options['pitch']);
      delete this.options['pitch'];
    }
    if (this.options['bearing']) {
      this.setBearing(this.options['bearing']);
      delete this.options['bearing'];
    }
    delete this._glRes;
    this._loadAllLayers();
    this._getRenderer().onLoad();
    this._loaded = true;
    this._callOnLoadHooks();
    this._initTime = now();
  };
  _proto._initRenderer = function _initRenderer() {
    var renderer = this.options['renderer'];
    if (!Array.isArray(renderer)) {
      renderer = [renderer];
    }
    for (var i = 0; i < renderer.length; i++) {
      var clazz = Map.getRendererClass(renderer[i]);
      if (clazz) {
        this._renderer = new clazz(this);
        this._renderer.load();
        break;
      }
    }
    if (!this._renderer) {
      throw new Error('Invalid map.options.renderer: ' + this.options['renderer']);
    }
  };
  _proto._getRenderer = function _getRenderer() {
    return this._renderer;
  };
  _proto._loadAllLayers = function _loadAllLayers() {
    function loadLayer(layer) {
      if (layer) {
        layer.load();
      }
    }
    if (this._baseLayer) {
      this._baseLayer.load();
    }
    this._eachLayer(loadLayer, this.getLayers());
  };
  _proto._getLayers = function _getLayers(filter) {
    var layers = this._baseLayer ? [this._baseLayer].concat(this._layers) : this._layers;
    var result = [];
    for (var i = 0; i < layers.length; i++) {
      if (!filter || filter.call(this, layers[i])) {
        result.push(layers[i]);
      }
    }
    return result;
  };
  _proto._eachLayer = function _eachLayer(fn, ...layerLists) {
    if (arguments.length < 2) {
      return;
    }
    if (layerLists && !Array.isArray(layerLists)) {
      layerLists = [layerLists];
    }
    var layers = [];
    for (var i = 0, len = layerLists.length; i < len; i++) {
      layers = layers.concat(layerLists[i]);
    }
    for (var j = 0, jlen = layers.length; j < jlen; j++) {
      fn.call(fn, layers[j]);
    }
  };
  _proto._onLayerEvent = function _onLayerEvent(param) {
    if (!param) {
      return;
    }
    if (param['type'] === 'idchange') {
      delete this._layerCache[param['old']];
      this._layerCache[param['new']] = param['target'];
    }
  };
  _proto._resetMapStatus = function _resetMapStatus() {
    var maxZoom = this.getMaxZoom(),
      minZoom = this.getMinZoom();
    var viewMaxZoom = this._spatialReference.getMaxZoom(),
      viewMinZoom = this._spatialReference.getMinZoom();
    if (isNil(maxZoom) || maxZoom === -1 || maxZoom > viewMaxZoom) {
      this.setMaxZoom(viewMaxZoom);
    }
    if (isNil(minZoom) || minZoom === -1 || minZoom < viewMinZoom) {
      this.setMinZoom(viewMinZoom);
    }
    maxZoom = this.getMaxZoom();
    minZoom = this.getMinZoom();
    if (maxZoom < minZoom) {
      this.setMaxZoom(minZoom);
    }
    if (isNil(this._zoomLevel) || this._zoomLevel > maxZoom) {
      this._zoomLevel = maxZoom;
    }
    if (this._zoomLevel < minZoom) {
      this._zoomLevel = minZoom;
    }
    delete this._prjCenter;
    delete this._glRes;
    var projection = this.getProjection();
    this._prjCenter = projection.project(this._center);
    this._prjCenter.z = this._center.z;
    this._calcMatrices();
    var renderer = this._getRenderer();
    if (renderer) {
      renderer.resetContainer();
    }
  };
  _proto.setContainerDomRect = function setContainerDomRect(domRect) {
    this._containerDomContentRect = domRect;
  };
  _proto._getContainerDomSize = function _getContainerDomSize() {
    if (!this._containerDOM) {
      return null;
    }
    var containerDOM = this._containerDOM;
    var width, height;
    if (this._containerDomContentRect) {
      width = this._containerDomContentRect.width;
      height = this._containerDomContentRect.height;
      return new Size(width, height);
    }
    var canvasDom = containerDOM;
    if (!isNil(canvasDom.width) && !isNil(canvasDom.height)) {
      width = canvasDom.width;
      height = canvasDom.height;
      var dpr = this.getDevicePixelRatio();
      if (dpr !== 1 && containerDOM['layer']) {
        width /= dpr;
        height /= dpr;
      }
    } else if (!isNil(containerDOM.clientWidth) && !isNil(containerDOM.clientHeight)) {
      width = parseInt(containerDOM.clientWidth + '', 0);
      height = parseInt(containerDOM.clientHeight + '', 0);
    } else {
      throw new Error('can not get size of container');
    }
    return new Size(width, height);
  };
  _proto._updateMapSize = function _updateMapSize(mSize) {
    this.width = mSize['width'];
    this.height = mSize['height'];
    var renderer = this._getRenderer();
    if (renderer) {
      renderer.updateMapSize(mSize);
    }
    this._calcMatrices();
    return this;
  };
  _proto._getPrjCenter = function _getPrjCenter() {
    return this._prjCenter;
  };
  _proto._setPrjCenter = function _setPrjCenter(pcenter) {
    if (pcenter && this._prjCenter) {
      if (!isNumber(pcenter.z) && isNumber(this._prjCenter.z)) {
        var altitude = this._prjCenter.z;
        pcenter.z = altitude;
      }
    }
    this._prjCenter = pcenter;
    if (this.isInteracting() && !this.isMoving()) {
      this._mapViewCoord = pcenter;
    }
    this._calcMatrices();
  };
  _proto._setPrjCoordAtContainerPoint = function _setPrjCoordAtContainerPoint(coordinate, point) {
    if (!this.centerAltitude && point.x === this.width / 2 && point.y === this.height / 2) {
      return this;
    }
    var p = this._containerPointToPoint(point);
    var t = p._sub(this._prjToPoint(this._getPrjCenter()));
    var pcenter = this._pointToPrj(this._prjToPoint(coordinate)._sub(t));
    this._setPrjCenter(pcenter);
    return this;
  };
  _proto._setPrjCoordAtOffsetToCenter = function _setPrjCoordAtOffsetToCenter(prjCoord, offset) {
    var pcenter = this._pointToPrj(this._prjToPoint(prjCoord)._sub(offset));
    this._setPrjCenter(pcenter);
    return this;
  };
  _proto._verifyExtent = function _verifyExtent(prjCenter) {
    if (!prjCenter) {
      return false;
    }
    var maxExt = this._prjMaxExtent;
    if (!maxExt) {
      return true;
    }
    return maxExt.contains(prjCenter);
  };
  _proto._limitMaxExtent = function _limitMaxExtent() {
    var _this6 = this;
    if (this._limitMaxExtenting || !this.options.limitExtentOnMaxExtent) {
      return this;
    }
    var maxPrjExtent = this._prjMaxExtent;
    var maxExtent = this.getMaxExtent();
    if (!maxPrjExtent || !maxExtent) {
      return this;
    }
    var prjCoords = maxPrjExtent.toArray();
    var points = prjCoords.map(function (prjCoord) {
      return _this6.prjToContainerPoint(prjCoord);
    });
    var maxExtentBBOX = getDefaultBBOX();
    pointsBBOX(points, maxExtentBBOX);
    var {
      width: width,
      height: height
    } = this.getSize();
    var mapBBOX = [0, 0, width, height];
    if (bboxInBBOX(mapBBOX, maxExtentBBOX)) {
      return this;
    }
    if (bboxInBBOX(maxExtentBBOX, mapBBOX)) {
      return this;
    }
    var translateX = 0,
      translateY = 0;
    var offsetleft = 0,
      offsetright = 0,
      offsettop = 0,
      offsetbottom = 0;
    var abs = Math.abs;
    var [left, top, right, bottom] = maxExtentBBOX;
    if (left > 0 && right > width) {
      translateX = offsetleft = abs(left);
    }
    if (left < 0 && right < width) {
      translateX = offsetleft = -abs(left);
    }
    if (left < 0 && right < width) {
      translateX = offsetright = -abs(width - right);
    }
    if (left > 0 && right > width) {
      translateX = offsetright = abs(width - right);
    }
    if (top > 0 && bottom > height) {
      translateY = offsettop = abs(top);
    }
    if (top < 0 && bottom < height) {
      translateY = offsettop = -abs(top);
    }
    if (top < 0 && bottom < height) {
      translateY = offsetbottom = -abs(height - bottom);
    }
    if (top > 0 && bottom > height) {
      translateY = offsetbottom = abs(height - bottom);
    }
    if (offsetleft !== 0 && offsetright !== 0) {
      translateX = offsetleft;
      if (abs(offsetright) < abs(offsetleft)) {
        translateX = offsetright;
      }
    }
    if (offsettop !== 0 && offsetbottom !== 0) {
      translateY = offsettop;
      if (abs(offsetbottom) < abs(offsettop)) {
        translateY = offsetbottom;
      }
    }
    if (translateX !== 0 || translateY !== 0) {
      var point = new Point(width / 2 + translateX, height / 2 + translateY);
      var center = this.containerPointToCoord(point);
      this._limitMaxExtenting = true;
      this.setCenter(center);
      this._limitMaxExtenting = false;
    }
    return this;
  };
  _proto._offsetCenterByPixel = function _offsetCenterByPixel(pixel) {
    var pos = TEMP_POINT$5.set(this.width / 2 - pixel.x, this.height / 2 - pixel.y);
    var coord = this._containerPointToPrj(pos, TEMP_COORD$2);
    var containerCenter = TEMP_POINT$5.set(this.width / 2, this.height / 2);
    this._setPrjCoordAtContainerPoint(coord, containerCenter);
  };
  _proto.offsetPlatform = function offsetPlatform(offset) {
    if (!offset) {
      return this._mapViewPoint;
    } else {
      this._getRenderer().offsetPlatform(offset);
      this._mapViewCoord = this._getPrjCenter();
      this._mapViewPoint = this._mapViewPoint.add(offset);
      return this._mapViewPoint;
    }
  };
  _proto.getViewPoint = function getViewPoint() {
    var offset = this.getViewPointFrameOffset();
    var panelOffset = this.offsetPlatform();
    if (offset) {
      panelOffset = panelOffset.add(offset);
    }
    return panelOffset;
  };
  _proto._resetMapViewPoint = function _resetMapViewPoint() {
    this._mapViewPoint = new Point(0, 0);
    this._mapViewCoord = this._getPrjCenter();
  };
  _proto._getResolution = function _getResolution(zoom) {
    if ((zoom === undefined || zoom === this._zoomLevel) && this._mapRes !== undefined) {
      return this._mapRes;
    }
    if (isNil(zoom)) {
      zoom = this._zoomLevel;
    }
    return this._spatialReference.getResolution(zoom);
  };
  _proto._getResolutions = function _getResolutions() {
    return this._spatialReference.getResolutions();
  };
  _proto._prjToPoint = function _prjToPoint(pCoord, zoom, out) {
    zoom = isNil(zoom) ? this.getZoom() : zoom;
    var res = this._getResolution(zoom);
    return this._prjToPointAtRes(pCoord, res, out);
  };
  _proto._prjToPointAtRes = function _prjToPointAtRes(pCoord, res, out) {
    return this._spatialReference.getTransformation().transform(pCoord, res, out);
  };
  _proto._prjsToPointsAtRes = function _prjsToPointsAtRes(pCoords, res, resultPoints = []) {
    var transformation = this._spatialReference.getTransformation();
    var pts = [];
    for (var i = 0, len = pCoords.length; i < len; i++) {
      var pt = transformation.transform(pCoords[i], res, resultPoints[i]);
      pts.push(pt);
    }
    return pts;
  };
  _proto._pointToPrj = function _pointToPrj(point, zoom, out) {
    zoom = isNil(zoom) ? this.getZoom() : zoom;
    var res = this._getResolution(zoom);
    return this._pointToPrjAtRes(point, res, out);
  };
  _proto._pointToPrjAtRes = function _pointToPrjAtRes(point, res, out) {
    return this._spatialReference.getTransformation().untransform(point, res, out);
  };
  _proto._pointToPoint = function _pointToPoint(point, zoom, out) {
    if (!isNil(zoom)) {
      return this._pointAtResToPoint(point, this._getResolution(zoom), out);
    }
    if (out) {
      out.x = point.x;
      out.y = point.y;
    } else {
      out = point.copy();
    }
    return out;
  };
  _proto._pointAtResToPoint = function _pointAtResToPoint(point, res, out) {
    if (out) {
      out.x = point.x;
      out.y = point.y;
    } else {
      out = point.copy();
    }
    return out._multi(res / this._getResolution());
  };
  _proto._pointToPointAtRes = function _pointToPointAtRes(point, res, out) {
    if (out) {
      out.x = point.x;
      out.y = point.y;
    } else {
      out = point.copy();
    }
    return out._multi(this._getResolution() / res);
  };
  _proto._containerPointToPrj = function _containerPointToPrj(containerPoint, out) {
    return this._pointToPrj(this._containerPointToPoint(containerPoint, undefined, out), undefined, out);
  };
  _proto._callOnLoadHooks = function _callOnLoadHooks() {
    var proto = Map.prototype;
    if (!proto._onLoadHooks) {
      return;
    }
    for (var i = 0, l = proto._onLoadHooks.length; i < l; i++) {
      proto._onLoadHooks[i].call(this);
    }
  };
  _proto._fixPrjOnWorldWide = function _fixPrjOnWorldWide(prjCoord) {
    var projection = this.getProjection();
    if (projection && projection.fullExtent && prjCoord) {
      var {
        left: left,
        bottom: bottom,
        top: top,
        right: right
      } = projection.fullExtent || {};
      if (isNumber(left)) {
        prjCoord.x = Math.max(left, prjCoord.x);
      }
      if (isNumber(right)) {
        prjCoord.x = Math.min(right, prjCoord.x);
      }
      if (isNumber(bottom)) {
        prjCoord.y = Math.max(bottom, prjCoord.y);
      }
      if (isNumber(top)) {
        prjCoord.y = Math.min(top, prjCoord.y);
      }
    }
    return this;
  };
  _proto.toJSON = function toJSON(options) {
    if (!options) {
      options = {};
    }
    var json = {
      'jsonVersion': this['JSON_VERSION'],
      'version': this.VERSION,
      'extent': this.getExtent().toJSON()
    };
    json['options'] = this.config();
    json['options']['center'] = this.getCenter();
    json['options']['zoom'] = this.getZoom();
    json['options']['bearing'] = this.getBearing();
    json['options']['pitch'] = this.getPitch();
    var baseLayer = this.getBaseLayer();
    if ((isNil(options['baseLayer']) || options['baseLayer']) && baseLayer) {
      json['baseLayer'] = baseLayer.toJSON(options['baseLayer']);
    }
    var extraLayerOptions = {};
    if (options['clipExtent']) {
      if (options['clipExtent'] === true) {
        extraLayerOptions['clipExtent'] = this.getExtent();
      } else {
        extraLayerOptions['clipExtent'] = options['clipExtent'];
      }
    }
    var layersJSON = [];
    if (isNil(options['layers']) || options['layers'] && !Array.isArray(options['layers'])) {
      var layers = this.getLayers();
      for (var i = 0, len = layers.length; i < len; i++) {
        if (!layers[i].toJSON) {
          continue;
        }
        var opts = extend$2({}, isObject$1(options['layers']) ? options['layers'] : {}, extraLayerOptions);
        layersJSON.push(layers[i].toJSON(opts));
      }
      json['layers'] = layersJSON;
    } else if (isArrayHasData(options['layers'])) {
      var _layers = options['layers'];
      for (var _i2 = 0; _i2 < _layers.length; _i2++) {
        var exportOption = _layers[_i2];
        var layer = this.getLayer(exportOption['id']);
        if (!layer.toJSON) {
          continue;
        }
        var _opts = extend$2({}, exportOption['options'], extraLayerOptions);
        layersJSON.push(layer.toJSON(_opts));
      }
      json['layers'] = layersJSON;
    } else {
      json['layers'] = [];
    }
    return json;
  };
  Map.fromJSON = function fromJSON(container, profile, options) {
    if (!container || !profile) {
      return null;
    }
    if (!options) {
      options = {};
    }
    var map = new Map(container, profile['options']);
    if (isNil(options['baseLayer']) || options['baseLayer']) {
      var baseLayer = Layer.fromJSON(profile['baseLayer']);
      if (baseLayer) {
        map.setBaseLayer(baseLayer);
      }
    }
    if (isNil(options['layers']) || options['layers']) {
      var layers = [];
      var layerJSONs = profile['layers'];
      for (var i = 0; i < layerJSONs.length; i++) {
        var layer = Layer.fromJSON(layerJSONs[i]);
        layers.push(layer);
      }
      map.addLayer(layers);
    }
    return map;
  };
  return Map;
}(Handlerable(Eventable(Renderable(Class))));
Map$1.mergeOptions(options$B);
function isTerrainLayer(layer) {
  return layer && layer.queryTerrainAtPoint && layer.getTerrainLayer && layer.getTerrainLayer();
}
function mapViewEqual(view1, view2, strict) {
  if (view1 === view2) {
    return true;
  }
  if (!view1 || !view2) {
    return false;
  }
  try {
    var str1 = JSON.stringify(view1);
    var str2 = JSON.stringify(view2);
    if (str1 === str2) {
      return true;
    }
  } catch (e) {
    console.error('stringify map view error', e);
    return false;
  }
  if (strict) {
    return false;
  }
  var pow = Math.pow(10, 7);
  var roundValue = function roundValue(v) {
    v = v || 0;
    return Math.round(v * pow);
  };
  var zoom1 = view1.zoom,
    zoom2 = view2.zoom;
  var bearing1 = view1.bearing,
    bearing2 = view2.bearing;
  var pitch1 = view1.pitch,
    pitch2 = view2.pitch;
  var height1 = view1.height || 0,
    height2 = view2.height || 0;
  zoom1 = roundValue(zoom1);
  zoom2 = roundValue(zoom2);
  bearing1 = roundValue(bearing1);
  bearing2 = roundValue(bearing2);
  pitch1 = roundValue(pitch1);
  pitch2 = roundValue(pitch2);
  height1 = roundValue(height1);
  height2 = roundValue(height2);
  if (zoom1 !== zoom2) {
    return false;
  }
  if (bearing1 !== bearing2) {
    return false;
  }
  if (pitch1 !== pitch2) {
    return false;
  }
  if (height1 !== height2) {
    return false;
  }
  var centerEqual = function centerEqual(p1, p2) {
    if (p1 === p2) {
      return true;
    }
    if (!p1 || !p2) {
      return false;
    }
    var c1 = new Coordinate(p1);
    var c2 = new Coordinate(p2);
    if (c1.equals(c2)) {
      return true;
    }
    var x1 = c1.x,
      y1 = c1.y,
      z1 = c1.z || 0;
    var x2 = c2.x,
      y2 = c2.y,
      z2 = c2.z || 0;
    x1 = roundValue(x1);
    y1 = roundValue(y1);
    z1 = roundValue(z1);
    x2 = roundValue(x2);
    y2 = roundValue(y2);
    z2 = roundValue(z2);
    return x1 === x2 && y1 === y2 && z1 === z2;
  };
  if (!centerEqual(view1.center, view2.center)) {
    return false;
  }
  if (!centerEqual(view1.prjCenter, view2.prjCenter)) {
    return false;
  }
  return true;
}

var MapBaseHandler = function (_Handler) {
  function MapBaseHandler() {
    return _Handler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapBaseHandler, _Handler);
  return MapBaseHandler;
}(Handler);

var MapDoubleClickZoomHandler = function (_MapBaseHandler) {
  function MapDoubleClickZoomHandler() {
    return _MapBaseHandler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapDoubleClickZoomHandler, _MapBaseHandler);
  var _proto = MapDoubleClickZoomHandler.prototype;
  _proto.addHooks = function addHooks() {
    if (!this.target) {
      return;
    }
    this.target.on('_dblclick', this._onDoubleClick, this);
  };
  _proto.removeHooks = function removeHooks() {
    if (!this.target) {
      return;
    }
    this.target.off('_dblclick', this._onDoubleClick, this);
  };
  _proto._onDoubleClick = function _onDoubleClick(param) {
    var map = this.target;
    if (map.options['doubleClickZoom']) {
      var oldZoom = map.getZoom(),
        zoom = param['domEvent']['shiftKey'] ? Math.ceil(oldZoom) - 1 : Math.floor(oldZoom) + 1;
      map._zoomAnimation(zoom, param['containerPoint']);
    }
  };
  return MapDoubleClickZoomHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'doubleClickZoom': true
});
Map$1.addOnLoadHook('addHandler', 'doubleClickZoom', MapDoubleClickZoomHandler);

var MapDragHandler = function (_MapBaseHandler) {
  function MapDragHandler() {
    return _MapBaseHandler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapDragHandler, _MapBaseHandler);
  var _proto = MapDragHandler.prototype;
  _proto.addHooks = function addHooks() {
    var map = this.target;
    if (!map) {
      return;
    }
    var dom = map.getPanels().mapWrapper || map.getContainer();
    this._dragHandler = new DragHandler(dom, {
      'cancelOn': this._cancelOn.bind(this),
      'rightclick': true
    });
    this._dragHandler.on('mousedown', this._onMouseDown, this).on('dragstart', this._onDragStart, this).on('dragging', this._onDragging, this).on('dragend', this._onDragEnd, this).enable();
  };
  _proto.removeHooks = function removeHooks() {
    this._dragHandler.off('mousedown', this._onMouseDown, this).off('dragstart', this._onDragStart, this).off('dragging', this._onDragging, this).off('dragend', this._onDragEnd, this);
    this._dragHandler.remove();
    delete this._dragHandler;
  };
  _proto._cancelOn = function _cancelOn(domEvent) {
    if (this.target.isZooming() || this._ignore(domEvent)) {
      return true;
    }
    return false;
  };
  _proto._ignore = function _ignore(param) {
    if (!param) {
      return false;
    }
    if (param.domEvent) {
      param = param.domEvent;
    }
    return this.target._ignoreEvent(param);
  };
  _proto._onMouseDown = function _onMouseDown(param) {
    delete this.startDragTime;
    delete this._mode;
    var switchDragButton = this.target.options['switchDragButton'];
    var rotateModeButton = switchDragButton ? 0 : 2;
    var isTouch = param.domEvent.type === 'touchstart';
    var isRotatonMode = switchDragButton && isTouch || param.domEvent.button === rotateModeButton || param.domEvent.ctrlKey;
    if (isRotatonMode) {
      if (this.target.options['dragRotate'] || this.target.options['dragPitch']) {
        this._mode = 'rotatePitch';
      }
    } else if (this.target.options['dragPan']) {
      this._mode = 'move';
    }
    this.target._stopAnim(this.target._mapAnimPlayer);
    preventDefault(param['domEvent']);
  };
  _proto._onDragStart = function _onDragStart(param) {
    this.startDragTime = now();
    if (this._mode === 'move') {
      this._moveStart(param);
    } else if (this._mode === 'rotatePitch') {
      this._rotateStart(param);
    }
  };
  _proto._onDragging = function _onDragging(param) {
    if (this._mode === 'move') {
      this._moving(param);
    } else if (this._mode === 'rotatePitch') {
      this._rotating(param);
    }
  };
  _proto._onDragEnd = function _onDragEnd(param) {
    if (this._mode === 'move') {
      this._moveEnd(param);
    } else if (this._mode === 'rotatePitch') {
      this._rotateEnd(param);
    }
    delete this.startDragTime;
    delete this.startBearing;
  };
  _proto._start = function _start(param) {
    this.preX = param['mousePos'].x;
    this.preY = param['mousePos'].y;
    this.startX = this.preX;
    this.startY = this.preY;
    this._startPrjCenter = this.target._getPrjCenter().copy();
  };
  _proto._moveStart = function _moveStart(param) {
    delete this.startContainerPoint;
    this._start(param);
    var map = this.target;
    map.onMoveStart(param);
    var p = getEventContainerPoint(map._getActualEvent(param.domEvent), map.getContainer());
    this.startPrjCoord = map.queryPrjCoordAtContainerPoint(p);
    if (map._isContainerPointOutOfMap(p) && this.startPrjCoord.z === undefined) {
      this.startContainerPoint = p;
    }
  };
  _proto._moving = function _moving(param) {
    if (!this.startDragTime) {
      return;
    }
    var map = this.target;
    var p = getEventContainerPoint(map._getActualEvent(param.domEvent), map.getContainer());
    if (this.startContainerPoint) {
      var _offset = p._sub(this.startContainerPoint);
      p.set(map.width / 2 + _offset.x, map.height / 2 + _offset.y);
    }
    var movingPoint = map._containerPointToPoint(p, undefined, undefined, this.startPrjCoord.z);
    var offset = movingPoint._sub(map._prjToPoint(map._getPrjCenter()));
    map._setPrjCoordAtOffsetToCenter(this.startPrjCoord, offset);
    map.onMoving(param);
  };
  _proto._moveEnd = function _moveEnd(param) {
    if (!this.startDragTime) {
      return;
    }
    var isTouch = param.domEvent.type === 'touchend';
    var map = this.target;
    var t = now() - this.startDragTime;
    var mx = param['mousePos'].x,
      my = param['mousePos'].y;
    var dx = mx - this.startX;
    var dy = my - this.startY;
    var currentCenter = map._getPrjCenter();
    var dxy = currentCenter.sub(this._startPrjCenter);
    this._clear();
    if (map.options['panAnimation'] && !param.interupted && map._verifyExtent(map._getPrjCenter()) && t < 280 && Math.abs(dy) + Math.abs(dx) > 5) {
      t = 5 * t;
      var dscale = isTouch ? 5 : 2.8;
      var targetPrjCoord = currentCenter.add(dxy._multi(dscale));
      map._panTo(targetPrjCoord, {
        'duration': isTouch ? t * 3 : t * 2,
        'easing': map.options.dragPanEasing || 'outExpo'
      });
    } else {
      map.onMoveEnd(param);
    }
  };
  _proto._rotateStart = function _rotateStart(param) {
    this._start(param);
    delete this._rotateMode;
    this.startBearing = this.target.getBearing();
    this.target.onDragRotateStart(param);
    this._db = 0;
  };
  _proto._rotating = function _rotating(param) {
    var map = this.target;
    var mx = param['mousePos'].x,
      my = param['mousePos'].y;
    var prePitch = map.getPitch(),
      preBearing = map.getBearing();
    var dx = Math.abs(mx - this.preX),
      dy = Math.abs(my - this.preY);
    if (!this._rotateMode) {
      if (map.options['dragRotatePitch']) {
        this._rotateMode = 'rotate_pitch';
      } else if (dx > dy) {
        this._rotateMode = 'rotate';
      } else if (dx < dy) {
        this._rotateMode = 'pitch';
      } else {
        this._rotateMode = 'rotate';
      }
    }
    if (this._rotateMode === 'pitch' && prePitch === 0 && dy < 10) {
      return;
    }
    if (this._rotateMode.indexOf('rotate') >= 0 && map.options['dragRotate']) {
      var factor = 0.15;
      var db = 0;
      if (map.options['dragPitch'] || dx > dy) {
        db = -factor * (this.preX - mx);
      } else if (mx > map.width / 2) {
        db = factor * (this.preY - my);
      } else {
        db = -factor * (this.preY - my);
      }
      var bearing = map.getBearing() + db;
      this._db = this._db || 0;
      this._db += db;
      map._setBearing(bearing);
    }
    if (this._rotateMode.indexOf('pitch') >= 0 && map.options['dragPitch']) {
      map._setPitch(map.getPitch() + (this.preY - my) * 0.15);
    }
    this.preX = mx;
    this.preY = my;
    if (map.getBearing() !== preBearing || map.getPitch() !== prePitch) {
      map.onDragRotating(param);
    }
  };
  _proto._rotateEnd = function _rotateEnd(param) {
    var map = this.target;
    var bearing = map.getBearing();
    this._clear();
    var t = now() - this.startDragTime;
    map.onDragRotateEnd(param);
    if (map.options['rotateAnimation'] && Math.abs(bearing - this.startBearing) > 20 && (this._rotateMode === 'rotate' || this._rotateMode === 'rotate_pitch') && !param.interupted && t < 400) {
      var _bearing = map.getBearing();
      map._animateTo({
        'bearing': _bearing + this._db / 1.5
      }, {
        'easing': 'outQuint',
        'duration': 1600
      });
    }
  };
  _proto._clear = function _clear() {
    delete this.startPrjCoord;
    delete this.preX;
    delete this.preY;
    delete this.startX;
    delete this.startY;
  };
  return MapDragHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'draggable': true,
  'dragPan': true,
  'dragRotatePitch': true,
  'dragRotate': true,
  'dragPitch': true
});
Map$1.addOnLoadHook('addHandler', 'draggable', MapDragHandler);

var EVENTS$3 = 'mousedown ' + 'mouseup ' + 'mousemove ' + 'click ' + 'dblclick ' + 'contextmenu ' + 'touchstart ' + 'touchmove ' + 'touchend ' + 'mouseout';
var MOUSEEVENT_ASSOCIATION_TABLE = {
  'mousemove': ['mousemove', 'mouseover', 'mouseout', 'mouseenter'],
  'touchend': ['touchend', 'click']
};
var isGeo = function isGeo(geometry) {
  return geometry && geometry.getLayer && geometry.on && geometry.fire;
};
var getGeoId = function getGeoId(geometry) {
  if (geometry._getInternalId) {
    return geometry._getInternalId();
  } else if (geometry.getId) {
    return geometry.getId();
  }
  return null;
};
var fireGeoEvent = function fireGeoEvent(geometry, domEvent, type) {
  if (geometry._onEvent) {
    return geometry._onEvent(domEvent, type);
  }
  var layer = geometry.getLayer();
  if (layer && layer.fireGeoEvent) {
    return layer.fireGeoEvent(geometry, domEvent, type);
  }
  return null;
};
var MapGeometryEventsHandler = function (_MapBaseHandler) {
  function MapGeometryEventsHandler() {
    return _MapBaseHandler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapGeometryEventsHandler, _MapBaseHandler);
  var _proto = MapGeometryEventsHandler.prototype;
  _proto.addHooks = function addHooks() {
    var map = this.target;
    var dom = map.getPanels().allLayers || map.getContainer();
    on(dom, EVENTS$3, this._identifyGeometryEvents, this);
  };
  _proto.removeHooks = function removeHooks() {
    var map = this.target;
    var dom = map.getPanels().allLayers || map.getContainer();
    off(dom, EVENTS$3, this._identifyGeometryEvents);
  };
  _proto._identifyGeometryEvents = function _identifyGeometryEvents(domEvent, type) {
    var map = this.target;
    if (map.isInteracting() || map._ignoreEvent(domEvent)) {
      return;
    }
    var oneMoreEvent = null;
    var eventType = type || domEvent.type;
    if (isMoveEvent(eventType) && !GlobalConfig.isTest && map.options['mousemoveThrottleEnable'] && isMousemoveEventBlocked(this, map.options['mousemoveThrottleTime'])) {
      stopPropagation(domEvent);
      return;
    }
    var isMousedown = eventType === 'mousedown' || eventType === 'touchstart' && domEvent.touches && domEvent.touches.length === 1;
    if (isMousedown) {
      this._mouseDownTime = now();
    } else if ((eventType === 'click' || eventType === 'touchend') && this._mouseDownTime) {
      var downTime = this._mouseDownTime;
      delete this._mouseDownTime;
      var time = now();
      if (time - downTime > 300) {
        if (eventType === 'click') {
          return;
        }
      } else if (eventType === 'touchend') {
        oneMoreEvent = 'click';
      }
    }
    var actual = domEvent.touches && domEvent.touches.length > 0 ? domEvent.touches[0] : domEvent.changedTouches && domEvent.changedTouches.length > 0 ? domEvent.changedTouches[0] : domEvent;
    if (!actual) {
      return;
    }
    var containerPoint = getEventContainerPoint(actual, map.getContainer());
    if (eventType === 'touchstart') {
      if (map.options['preventTouch']) {
        preventDefault(domEvent);
      }
    }
    var geometryCursorStyle = null;
    var tops = this.target.getRenderer().getTopElements();
    var topOnlyEvent = isMousedown && domEvent.button !== 2;
    for (var i = 0; i < tops.length; i++) {
      if (tops[i].hitTest(containerPoint)) {
        var cursor = tops[i].options['cursor'];
        if (cursor) {
          geometryCursorStyle = cursor;
        }
        if (topOnlyEvent || tops[i].events && tops[i].events.indexOf(eventType) >= 0) {
          var e = {
            target: map,
            type: eventType,
            domEvent: domEvent,
            containerPoint: containerPoint
          };
          if (topOnlyEvent) {
            map._setPriorityCursor(geometryCursorStyle);
            tops[i].mousedown(e);
            return;
          } else {
            tops[i].onEvent(e);
          }
        }
      }
    }
    var layers = map._getLayers(function (layer) {
      if (layer.identify && layer.options['geometryEvents']) {
        return true;
      }
      return false;
    });
    if (!layers.length) {
      return;
    }
    var eventTypes = MOUSEEVENT_ASSOCIATION_TABLE[eventType] || [eventType];
    var identifyOptions = {
      'includeInternals': true,
      'filter': function filter(geometry) {
        if (geometry instanceof Geometry) {
          var eventToFire = geometry._getEventTypeToFire(domEvent);
          if (eventType === 'mousemove') {
            if (!geometryCursorStyle && geometry.options['cursor']) {
              geometryCursorStyle = geometry.options['cursor'];
            }
            return true;
          } else if (!geometry.listens(eventToFire) && !geometry.listens(oneMoreEvent)) {
            return false;
          }
          return true;
        } else if (isGeo(geometry)) {
          return true;
        }
        return false;
      },
      'count': 1,
      'onlyVisible': map.options['onlyVisibleGeometryEvents'],
      containerPoint: containerPoint,
      layers: layers,
      eventTypes: eventTypes,
      domEvent: domEvent
    };
    var callback = fireGeometryEvent.bind(this);
    if (isMoveEvent(eventType)) {
      this._queryIdentifyTimeout = map.getRenderer().callInNextFrame(function () {
        if (map.isInteracting()) {
          return;
        }
        map.identifyAtPoint(identifyOptions, callback);
      });
    } else {
      map.identifyAtPoint(identifyOptions, callback);
    }
    function fireGeometryEvent(geometries) {
      var _this = this;
      var propagation = true;
      var getOldGeos = function getOldGeos() {
        var geos = _this._prevOverGeos && _this._prevOverGeos.geos;
        return geos || [];
      };
      var oldGeosMouseout = function oldGeosMouseout(oldTargets = [], newTargets = []) {
        if (oldTargets && oldTargets.length > 0) {
          for (var _i = oldTargets.length - 1; _i >= 0; _i--) {
            var oldTarget = oldTargets[_i];
            if (!isGeo(oldTarget)) {
              continue;
            }
            if (newTargets.indexOf(oldTarget) === -1) {
              propagation = fireGeoEvent(oldTarget, domEvent, 'mouseout');
            }
          }
        }
      };
      if (eventType === 'mouseout') {
        var oldTargets = getOldGeos();
        this._prevOverGeos = {
          'geos': [],
          'geomap': {}
        };
        oldGeosMouseout(oldTargets, []);
      } else if (eventType === 'mousemove') {
        var geoMap = {};
        if (geometries.length > 0) {
          for (var _i2 = geometries.length - 1; _i2 >= 0; _i2--) {
            var geo = geometries[_i2];
            if (!isGeo(geo)) {
              continue;
            }
            var iid = getGeoId(geo);
            geoMap[iid] = geo;
            fireGeoEvent(geo, domEvent);
            if (!this._prevOverGeos || !this._prevOverGeos.geomap[iid]) {
              fireGeoEvent(geo, domEvent, 'mouseenter');
            }
            propagation = fireGeoEvent(geo, domEvent, 'mouseover');
          }
        }
        map._setPriorityCursor(geometryCursorStyle);
        var _oldTargets = getOldGeos();
        this._prevOverGeos = {
          'geos': geometries,
          'geomap': geoMap
        };
        oldGeosMouseout(_oldTargets, geometries);
      } else {
        if (!geometries || !geometries.length) {
          return;
        }
        for (var _i3 = geometries.length - 1; _i3 >= 0; _i3--) {
          if (!isGeo(geometries[_i3])) {
            continue;
          }
          propagation = fireGeoEvent(geometries[_i3], domEvent);
          if (oneMoreEvent) {
            fireGeoEvent(geometries[_i3], domEvent, oneMoreEvent);
          }
          break;
        }
      }
      if (propagation === false) {
        stopPropagation(domEvent);
      }
    }
  };
  return MapGeometryEventsHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'geometryEvents': true,
  'onlyVisibleGeometryEvents': true
});
Map$1.addOnLoadHook('addHandler', 'geometryEvents', MapGeometryEventsHandler);

var wheelZoomDelta = 4.000244140625;
var defaultZoomRate = 1 / 100;
var wheelZoomRate = 1 / 450;
var maxScalePerFrame = 2;
var MapScrollWheelZoomHandler = function (_MapBaseHandler) {
  function MapScrollWheelZoomHandler(target) {
    var _this;
    _this = _MapBaseHandler.call(this, target) || this;
    _this._thisScrollZoom = _this._scrollZoom.bind(_this);
    _this._thisCheckIfEndZoom = _this._checkIfEndZoom.bind(_this);
    _this._wheelZoomRate = wheelZoomRate;
    _this._defaultZoomRate = defaultZoomRate;
    _this._delta = 0;
    return _this;
  }
  _inheritsLoose(MapScrollWheelZoomHandler, _MapBaseHandler);
  var _proto = MapScrollWheelZoomHandler.prototype;
  _proto.addHooks = function addHooks() {
    addDomEvent(this.target._containerDOM, 'wheel', this._onWheelScroll, this);
  };
  _proto.removeHooks = function removeHooks() {
    removeDomEvent(this.target._containerDOM, 'wheel', this._onWheelScroll);
  };
  _proto._currentZoomCanScroll = function _currentZoomCanScroll(value) {
    if (isNumber(value)) {
      var map = this.target;
      var zoom = map.getZoom();
      var minZoom = map.getMinZoom();
      var maxZoom = map.getMaxZoom();
      if (zoom === minZoom && value > 0) {
        return false;
      }
      if (zoom === maxZoom && value < 0) {
        return false;
      }
    }
    return true;
  };
  _proto._onWheelScroll = function _onWheelScroll(evt) {
    var map = this.target;
    if (map.options['preventWheelScroll']) {
      preventDefault(evt);
      stopPropagation(evt);
    }
    if (map._ignoreEvent(evt) || !map.options['zoomable']) {
      return false;
    }
    var container = map.getContainer();
    var origin = map._checkZoomOrigin(getEventContainerPoint(evt, container));
    if (map.options['seamlessZoom']) {
      if (!this._zooming) {
        this._trackPadSuspect = 0;
        this._ensureTrackpad = false;
      }
      return this._seamless(evt, origin);
    } else {
      return this._interval(evt, origin);
    }
  };
  _proto._seamless = function _seamless(evt, origin) {
    var value = evt.deltaMode === window.WheelEvent.DOM_DELTA_LINE ? evt.deltaY * 60 : evt.deltaY;
    if (value % wheelZoomDelta !== 0) {
      if (!this._ensureTrackpad) {
        if (Math.abs(value) < 60) {
          this._trackPadSuspect++;
        } else {
          this._trackPadSuspect = 0;
        }
        if (this._trackPadSuspect >= 2) {
          this._ensureTrackpad = true;
        }
      }
      if (this._ensureTrackpad) {
        value *= 14;
      }
    }
    if (evt.shiftKey && value) value = value / 4;
    this._lastWheelEvent = evt;
    if (isNil(this._delta)) {
      this._delta = 0;
    }
    this._delta -= value;
    if (!this._currentZoomCanScroll(value)) {
      return;
    }
    if (!this._zooming && this._delta) {
      var map = this.target;
      this._zoomOrigin = origin;
      map.onZoomStart(null, origin);
    }
    this._start();
  };
  _proto._start = function _start() {
    if (!this._delta) return;
    this._zooming = true;
    var map = this.target;
    if (!this._active) {
      map.getRenderer().callInNextFrame(this._thisScrollZoom);
      this._active = true;
    }
  };
  _proto._scrollZoom = function _scrollZoom() {
    this._active = false;
    if (!this._delta) {
      return;
    }
    var zoomRate = Math.abs(this._delta) > wheelZoomDelta ? this._wheelZoomRate : this._defaultZoomRate;
    var scale = maxScalePerFrame / (1 + Math.exp(-Math.abs(this._delta * zoomRate)));
    if (this._delta < 0 && scale !== 0) {
      scale = 1 / scale;
    }
    var map = this.target;
    var zoom = map.getZoom();
    var targetZoom = map.getZoomForScale(scale, zoom, true);
    this._delta = 0;
    map.onZooming(targetZoom, this._zoomOrigin);
    this._scrollTime = performance.now();
    map.getRenderer().callInNextFrame(this._thisCheckIfEndZoom);
  };
  _proto._checkIfEndZoom = function _checkIfEndZoom() {
    if (!this._zooming) {
      return;
    }
    var map = this.target;
    var currentTime = performance.now();
    if (currentTime - this._scrollTime > 210) {
      this._zooming = false;
      map.onZoomEnd(map.getZoom(), this._zoomOrigin);
    } else {
      map.getRenderer().callInNextFrame(this._thisCheckIfEndZoom);
    }
  };
  _proto._interval = function _interval(evt, origin) {
    var _this2 = this;
    var map = this.target;
    if (this._zooming) {
      this._requesting++;
      return false;
    }
    this._requesting = 0;
    var levelValue = (evt.deltaY ? evt.deltaY * -1 : evt.wheelDelta ? evt.wheelDelta : evt.detail) > 0 ? 1 : -1;
    if (evt.detail) {
      levelValue *= -1;
    }
    var zoom = map.getZoom();
    var nextZoom = zoom + levelValue;
    nextZoom = map._checkZoom(levelValue > 0 ? Math.ceil(nextZoom) : Math.floor(nextZoom));
    if (nextZoom === zoom) {
      return false;
    }
    this._zooming = true;
    if (!this._delta) {
      map.onZoomStart(null, origin);
      this._origin = origin;
      this._delta = levelValue;
      this._startZoom = map.getZoom();
    }
    var duration = 90;
    map._animateTo({
      'zoom': nextZoom - this._delta * 1 / 2,
      'around': this._origin
    }, {
      'continueOnViewChanged': true,
      'easing': 'linear',
      'duration': duration,
      'wheelZoom': true
    }, function (frame) {
      if (frame.state.playState !== 'finished') {
        if (frame.state.playState !== 'running') {
          delete _this2._zooming;
          delete _this2._requesting;
        }
        return;
      }
      if (_this2._requesting < 1 || Math.abs(nextZoom - _this2._startZoom) > 2 || nextZoom === map.getMaxZoom() || nextZoom === map.getMinZoom()) {
        map._animateTo({
          'zoom': nextZoom,
          'around': _this2._origin
        }, {
          'continueOnViewChanged': true,
          'duration': 100
        }, function (frame) {
          if (frame.state.playState !== 'running') {
            delete _this2._zooming;
            delete _this2._requesting;
          }
        });
        delete _this2._startZoom;
        delete _this2._origin;
        delete _this2._delta;
        _this2._requesting = 0;
      } else if (!isNil(_this2._requesting)) {
        delete _this2._zooming;
        _this2._onWheelScroll(evt);
      }
    });
    return false;
  };
  return MapScrollWheelZoomHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'scrollWheelZoom': true,
  'seamlessZoom': true
});
Map$1.addOnLoadHook('addHandler', 'scrollWheelZoom', MapScrollWheelZoomHandler);

var MapTouchZoomHandler = function (_MapBaseHandler) {
  function MapTouchZoomHandler() {
    return _MapBaseHandler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapTouchZoomHandler, _MapBaseHandler);
  var _proto = MapTouchZoomHandler.prototype;
  _proto.addHooks = function addHooks() {
    addDomEvent(this.target.getContainer(), 'touchstart', this._onTouchStart, this);
  };
  _proto.removeHooks = function removeHooks() {
    removeDomEvent(this.target.getContainer(), 'touchstart', this._onTouchStart);
  };
  _proto._onTouchStart = function _onTouchStart(event) {
    var map = this.target;
    if (!event.touches || event.touches.length < 2) {
      return;
    }
    var container = map.getContainer();
    var p1 = getEventContainerPoint(event.touches[0], container),
      p2 = getEventContainerPoint(event.touches[1], container);
    this.preY = p1.y;
    this._startP1 = p1;
    this._startP2 = p2;
    this._startDist = p1.distanceTo(p2);
    this._startVector = p1.sub(p2);
    this._startZoom = map.getZoom();
    this._startBearing = map.getBearing();
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'touchend', this._onTouchEnd);
    addDomEvent(document, 'touchmove', this._onTouchMove, this);
    addDomEvent(document, 'touchend', this._onTouchEnd, this);
    if (map.options['preventTouch']) {
      preventDefault(event);
    }
    map._fireEvent('touchactstart');
  };
  _proto._onTouchMove = function _onTouchMove(event) {
    var map = this.target;
    if (!event.touches || event.touches.length < 2) {
      return;
    }
    var container = map.getContainer(),
      p1 = getEventContainerPoint(event.touches[0], container),
      p2 = getEventContainerPoint(event.touches[1], container),
      d1 = p1.sub(this._startP1),
      d2 = p2.sub(this._startP2),
      vector = p1.sub(p2),
      scale = p1.distanceTo(p2) / this._startDist,
      bearing = vector.angleWith(this._startVector) * 180 / Math.PI,
      preY = this.preY || p1.y,
      pitch = (preY - p1.y) * 0.4;
    this.preY = p1.y;
    var param = {
      'domEvent': event,
      'mousePos': [p1, p2]
    };
    if (!this.mode) {
      if (map.options['touchRotate'] && Math.abs(bearing) > 8) {
        this.mode = map.options['touchZoomRotate'] ? 'rotate_zoom' : 'rotate';
      } else if (map.options['touchPitch'] && d1.y * d2.y > 0 && Math.abs(d1.y) > 10 && Math.abs(d2.y) > 10) {
        this.mode = 'pitch';
      } else if (map.options['zoomable'] && map.options['touchZoom'] && Math.abs(1 - scale) > 0.15) {
        this.mode = map.options['touchZoomRotate'] && map.options['touchRotate'] ? 'rotate_zoom' : 'zoom';
      }
      this._startTouching(param);
    }
    if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
      this._scale = scale;
      var res = map._getResolution(this._startZoom) / scale;
      var zoom = map.getZoomFromRes(res);
      map.onZooming(zoom, this._Origin);
    }
    if (this.mode === 'rotate' || this.mode === 'rotate_zoom') {
      map._setBearing(this._startBearing + bearing);
      map.onDragRotating(param);
    } else if (this.mode === 'pitch') {
      map._setPitch(map.getPitch() + pitch);
      map.onDragRotating(param);
    }
    map._fireEvent('touchactinging');
  };
  _proto._startTouching = function _startTouching(param) {
    var map = this.target;
    if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
      var size = map.getSize();
      this._Origin = new Point(size['width'] / 2, size['height'] / 2);
      map.onZoomStart(null, this._Origin);
    }
    if (this.mode === 'rotate' || this.mode === 'pitch' || this.mode === 'rotate_zoom') {
      map.onDragRotateStart(param);
    }
  };
  _proto._onTouchEnd = function _onTouchEnd(event) {
    delete this.preY;
    var map = this.target;
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'touchend', this._onTouchEnd);
    if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
      var scale = this._scale;
      var res = map._getResolution(this._startZoom) / scale;
      var zoom = map.getZoomFromRes(res);
      map.onZoomEnd(zoom, this._Origin);
    }
    if (this.mode === 'pitch' || this.mode === 'rotate' || this.mode === 'rotate_zoom') {
      map.onDragRotateEnd({
        'domEvent': event
      });
    }
    delete this.mode;
    map._fireEvent('touchactend');
  };
  return MapTouchZoomHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'touchGesture': true,
  'touchZoom': true,
  'touchPitch': true,
  'touchRotate': true,
  'touchZoomRotate': false
});
Map$1.addOnLoadHook('addHandler', 'touchGesture', MapTouchZoomHandler);

var KEY = '__anim_player';
var Easing = {
  outExpo: function outExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  },
  outQuint: function outQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  },
  "in": function _in(t) {
    return Math.pow(t, 2);
  },
  out: function out(t) {
    return 1 - Easing["in"](1 - t);
  },
  inAndOut: function inAndOut(t) {
    return 3 * t * t - 2 * t * t * t;
  },
  linear: function linear(t) {
    return t;
  },
  upAndDown: function upAndDown(t) {
    if (t < 0.5) {
      return Easing.inAndOut(2 * t);
    } else {
      return 1 - Easing.inAndOut(2 * (t - 0.5));
    }
  }
};
var Frame = function () {
  function Frame(state, styles) {
    this.state = state;
    this.styles = styles;
  }
  return _createClass(Frame, [{
    key: "playState",
    get: function get() {
      return this.state.playState;
    }
  }, {
    key: "symbol",
    get: function get() {
      return this.styles.symbol;
    }
  }]);
}();
var Player = function () {
  function Player(animation, options, onFrame, target) {
    this._animation = animation;
    this.options = options;
    this._onFrame = onFrame;
    this.playState = 'idle';
    this.ready = true;
    this.finished = false;
    this.target = target;
  }
  var _proto = Player.prototype;
  _proto._prepare = function _prepare() {
    var options = this.options;
    var duration = options['speed'] || options['duration'];
    if (isString(duration)) {
      duration = Animation.speed[duration];
      if (!duration) {
        duration = +duration;
      }
    }
    if (!duration) {
      duration = Animation.speed['normal'];
    }
    this.duration = duration;
    this._framer = options['framer'] || Animation._requestAnimFrame.bind(Animation);
  };
  _proto.play = function play() {
    if (this.playState !== 'idle' && this.playState !== 'paused' || this.target && this.target[KEY]) {
      return this;
    }
    if (this.target) {
      this.target[KEY] = 1;
    }
    if (this.playState === 'idle') {
      this.currentTime = 0;
      this._prepare();
    }
    var t = now();
    if (!this.startTime) {
      var options = this.options;
      this.startTime = options['startTime'] ? options['startTime'] : t;
    }
    this._playStartTime = Math.max(t, this.startTime);
    if (this.playState === 'paused') {
      this._playStartTime -= this.currentTime;
    }
    this.playState = 'running';
    this._run();
    return this;
  };
  _proto.pause = function pause() {
    if (this.playState === 'paused') {
      return this;
    }
    this.playState = 'paused';
    this._run();
    return this;
  };
  _proto.cancel = function cancel() {
    if (this.playState === 'idle') {
      return this;
    }
    this.playState = 'idle';
    this.finished = false;
    this._run();
    return this;
  };
  _proto.finish = function finish() {
    if (this.playState === 'finished') {
      return this;
    }
    this.playState = 'finished';
    this.finished = true;
    this._run();
    return this;
  };
  _proto.reverse = function reverse() {};
  _proto._run = function _run() {
    var _this = this;
    var onFrame = this._onFrame;
    var t = now();
    var elapsed = t - this._playStartTime;
    if (this.options['repeat'] && elapsed >= this.duration) {
      this._playStartTime = t;
      elapsed = 0;
    }
    if (this.playState !== 'running') {
      if (this.target) {
        delete this.target[KEY];
      }
      if (onFrame) {
        if (this.playState === 'finished') {
          elapsed = this.duration;
        } else if (this.playState === 'idle') {
          elapsed = 0;
        }
        var _frame = this._animation(elapsed, this.duration);
        _frame.state.playState = this.playState;
        onFrame(_frame);
      }
      return;
    }
    var frame = this._animation(elapsed, this.duration);
    this.playState = frame.state['playState'];
    if (this.playState !== 'running' && this.target) {
      delete this.target[KEY];
    }
    if (this.playState === 'idle') {
      if (this.startTime > t) {
        setTimeout(this._run.bind(this), this.startTime - t);
      }
    } else if (this.playState === 'running') {
      this.currentTime = elapsed;
      if (onFrame) {
        onFrame(frame);
      }
      this._framer(function () {
        if (_this.playState !== 'running') {
          return;
        }
        _this._run();
      });
    } else if (this.playState === 'finished') {
      this.finished = true;
      if (onFrame) {
        onFrame(frame);
      }
    }
  };
  return Player;
}();
var Animation = {
  speed: {
    'slow': 2000,
    'normal': 1000,
    'fast': 500
  },
  _resolveStyles: function _resolveStyles(styles) {
    if (!styles) {
      return null;
    }
    function resolveChild(child) {
      if (!Array.isArray(child)) {
        return Animation._resolveStyles(child);
      }
      var start = [],
        d = [],
        dest = [];
      for (var i = 0; i < child.length; i++) {
        var _styles = Animation._resolveStyles(child[i]);
        if (_styles) {
          start.push(_styles[0]);
          d.push(_styles[1]);
          dest.push(_styles[2]);
        }
      }
      if (!start.length) {
        return null;
      } else {
        return [start, d, dest];
      }
    }
    function resolveVal(val) {
      var values = val;
      var clazz;
      if (!Array.isArray(val)) {
        if (isNumber(val)) {
          values = [0, val];
        } else if (val instanceof Point || val instanceof Coordinate) {
          clazz = val.constructor;
          values = [new clazz(0, 0), val];
        } else {
          values = [val, val];
        }
      }
      var v1 = values[0],
        v2 = values[1];
      if (isNumber(v1) && isNumber(v2)) {
        if (v1 === v2) {
          return null;
        }
        return [v1, v2 - v1, v2];
      } else if (Array.isArray(v1) && isNumber(v1[0]) || v1 instanceof Coordinate || v1 instanceof Point) {
        if (Array.isArray(v1)) {
          v1 = new Coordinate(v1);
          v2 = new Coordinate(v2);
        } else {
          clazz = v1.constructor;
          v1 = new clazz(v1);
          v2 = new clazz(v2);
        }
        if (v1.equals(v2)) {
          return null;
        }
        return [v1, v2.sub(v1), v2];
      } else {
        return [v1, v2, v2];
      }
    }
    function isChild(val) {
      if (!Array.isArray(val) && val.constructor === Object) {
        return true;
      } else if (Array.isArray(val) && val[0].constructor === Object) {
        return true;
      }
      return false;
    }
    var d = {},
      start = {},
      dest = {};
    for (var p in styles) {
      if (styles.hasOwnProperty(p)) {
        var values = styles[p];
        if (!values) {
          continue;
        } else if (Array.isArray(values)) {
          if (isNil(values[0]) || isNil(values[1])) {
            continue;
          }
        }
        var childStyles = void 0;
        if (isChild(values)) {
          childStyles = resolveChild(values);
        } else {
          childStyles = resolveVal(values);
        }
        if (childStyles) {
          start[p] = childStyles[0];
          d[p] = childStyles[1];
          dest[p] = childStyles[2];
        }
      }
    }
    return [start, d, dest];
  },
  framing: function framing(styles, options) {
    if (!options) {
      options = {};
    }
    var easing;
    if (isFunction(options.easing)) {
      easing = options['easing'];
    } else {
      easing = options['easing'] ? Easing[options['easing']] : Easing.linear;
    }
    if (!easing || !isFunction(easing)) {
      easing = Easing.linear;
    }
    var dStyles, startStyles, destStyles;
    styles = Animation._resolveStyles(styles);
    if (styles) {
      startStyles = styles[0];
      dStyles = styles[1];
      destStyles = styles[2];
    }
    var _deltaStyles = function deltaStyles(delta, _startStyles, _dStyles) {
      if (!_startStyles || !_dStyles) {
        return null;
      }
      var result = {};
      for (var p in _dStyles) {
        if (_dStyles.hasOwnProperty(p)) {
          if (_startStyles[p] === destStyles[p]) {
            result[p] = _startStyles[p];
            continue;
          }
          var s = _startStyles[p],
            d = _dStyles[p];
          if (isNumber(d)) {
            result[p] = s + delta * d;
          } else if (Array.isArray(d)) {
            var children = [];
            for (var i = 0; i < d.length; i++) {
              children.push(_deltaStyles(delta, s[i], d[i]));
            }
            result[p] = children;
          } else {
            var clazz = d.constructor;
            if (clazz === Object) {
              result[p] = _deltaStyles(delta, s, d);
            } else if (s instanceof Point || s instanceof Coordinate) {
              result[p] = s.add(d.multi(delta));
            } else {
              result[p] = d;
            }
          }
        }
      }
      return result;
    };
    return function (elapsed, duration) {
      var state, d;
      if (elapsed < 0) {
        state = {
          'playState': 'idle',
          'delta': 0
        };
        d = startStyles;
      } else if (elapsed < duration) {
        var delta = easing(elapsed / duration);
        state = {
          'playState': 'running',
          'delta': delta
        };
        d = _deltaStyles(delta, startStyles, dStyles);
      } else {
        state = {
          'playState': 'finished',
          'delta': 1
        };
        d = destStyles;
      }
      state['startStyles'] = startStyles;
      state['destStyles'] = destStyles;
      state['progress'] = elapsed;
      state['remainingMs'] = duration - elapsed;
      return new Frame(state, d);
    };
  },
  _requestAnimFrame: function _requestAnimFrame(fn) {
    if (!this._frameQueue) {
      this._frameQueue = [];
    }
    this._frameQueue.push(fn);
    this._a();
  },
  _a: function _a() {
    if (!this._animationFrameId) {
      this._animationFrameId = requestAnimFrame(Animation._frameFn);
    }
  },
  _run: function _run() {
    if (this._frameQueue.length) {
      var running = this._frameQueue;
      this._frameQueue = [];
      for (var i = 0, len = running.length; i < len; i++) {
        running[i]();
      }
      if (this._frameQueue.length) {
        this._animationFrameId = requestAnimFrame(Animation._frameFn);
      } else {
        delete this._animationFrameId;
      }
    }
  },
  animate: function animate(styles, options, step, target) {
    if (!options) {
      options = {};
    }
    var animation = Animation.framing(styles, options);
    var player = new Player(animation, options, step, target);
    return player;
  },
  _frameFn: function _frameFn() {}
};
Animation._frameFn = Animation._run.bind(Animation);
var animate = Animation.animate;

var Animation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Animation: Animation,
  Easing: Easing,
  Frame: Frame,
  Player: Player,
  animate: animate
});

var simplify$1 = {exports: {}};

/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/

(function (module) {
	(function () {
	// to suit your point format, run search/replace for '.x' and '.y';
	// for 3D version, see 3d branch (configurability would draw significant performance overhead)

	// square distance between 2 points
	function getSqDist(p1, p2) {

	    var dx = p1.x - p2.x,
	        dy = p1.y - p2.y;

	    return dx * dx + dy * dy;
	}

	// square distance from a point to a segment
	function getSqSegDist(p, p1, p2) {

	    var x = p1.x,
	        y = p1.y,
	        dx = p2.x - x,
	        dy = p2.y - y;

	    if (dx !== 0 || dy !== 0) {

	        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

	        if (t > 1) {
	            x = p2.x;
	            y = p2.y;

	        } else if (t > 0) {
	            x += dx * t;
	            y += dy * t;
	        }
	    }

	    dx = p.x - x;
	    dy = p.y - y;

	    return dx * dx + dy * dy;
	}
	// rest of the code doesn't care about point format

	// basic distance-based simplification
	function simplifyRadialDist(points, sqTolerance) {

	    var prevPoint = points[0],
	        newPoints = [prevPoint],
	        point;

	    for (var i = 1, len = points.length; i < len; i++) {
	        point = points[i];

	        if (getSqDist(point, prevPoint) > sqTolerance) {
	            newPoints.push(point);
	            prevPoint = point;
	        }
	    }

	    if (prevPoint !== point) newPoints.push(point);

	    return newPoints;
	}

	function simplifyDPStep(points, first, last, sqTolerance, simplified) {
	    var maxSqDist = sqTolerance,
	        index;

	    for (var i = first + 1; i < last; i++) {
	        var sqDist = getSqSegDist(points[i], points[first], points[last]);

	        if (sqDist > maxSqDist) {
	            index = i;
	            maxSqDist = sqDist;
	        }
	    }

	    if (maxSqDist > sqTolerance) {
	        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
	        simplified.push(points[index]);
	        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
	    }
	}

	// simplification using Ramer-Douglas-Peucker algorithm
	function simplifyDouglasPeucker(points, sqTolerance) {
	    var last = points.length - 1;

	    var simplified = [points[0]];
	    simplifyDPStep(points, 0, last, sqTolerance, simplified);
	    simplified.push(points[last]);

	    return simplified;
	}

	// both algorithms combined for awesome performance
	function simplify(points, tolerance, highestQuality) {

	    if (points.length <= 2) return points;

	    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

	    points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
	    points = simplifyDouglasPeucker(points, sqTolerance);

	    return points;
	}

	// export as AMD module / Node module / browser or worker variable
	{
	    module.exports = simplify;
	    module.exports.default = simplify;
	}

	})(); 
} (simplify$1));

var simplifyExports = simplify$1.exports;
var simplify = /*@__PURE__*/getDefaultExportFromCjs(simplifyExports);

var GEOMETRY_NOT_FIND_PROJECTION = 'not find Geometry\' Projection. please add Geometry to Layer and add Layer to Map';

var options$A = {
  'smoothness': false,
  'enableClip': true,
  'enableSimplify': true,
  'simplifyTolerance': 2,
  'symbol': {
    'lineColor': '#000',
    'lineWidth': 2,
    'lineOpacity': 1,
    'polygonFill': '#fff',
    'polygonOpacity': 1,
    'opacity': 1
  }
};
var Path = function (_Geometry) {
  function Path() {
    return _Geometry.apply(this, arguments) || this;
  }
  _inheritsLoose(Path, _Geometry);
  var _proto = Path.prototype;
  _proto.animateShow = function animateShow(options = {}, cb) {
    var _this = this;
    if (this._showPlayer) {
      this._showPlayer.finish();
    }
    if (isFunction(options)) {
      options = {};
      cb = options;
    }
    var coordinates = this.getCoordinates();
    if (coordinates.length === 0) {
      return;
    }
    this._animIdx = 0;
    this._animLenSoFar = 0;
    this.show();
    var isPolygon = !!this.getShell;
    var animCoords = isPolygon ? this.getShell().concat(this.getShell()[0]) : coordinates;
    var projection = this._getProjection();
    if (!projection) {
      console.error(GEOMETRY_NOT_FIND_PROJECTION);
      return;
    }
    var prjAnimCoords = projection.projectCoords(animCoords, this.options['antiMeridian']);
    this._prjAniShowCenter = this._getPrjExtent().getCenter();
    this._aniShowCenter = projection.unproject(this._prjAniShowCenter);
    var duration = options['duration'] || 1000,
      easing = options['easing'] || 'out';
    this.setCoordinates([]);
    var length = 0;
    if (prjAnimCoords.length) {
      prjAnimCoords[0]._distance = 0;
    }
    for (var i = 1; i < prjAnimCoords.length; i++) {
      var distance = prjAnimCoords[i].distanceTo(prjAnimCoords[i - 1]);
      prjAnimCoords[i]._distance = distance;
      length += distance;
    }
    this._tempCoord = new Coordinate(0, 0);
    this._tempPrjCoord = new Point(0, 0);
    var player = this._showPlayer = Animation.animate({
      't': duration
    }, {
      'duration': duration,
      'easing': easing
    }, function (frame) {
      if (!_this.getMap()) {
        if (player.playState !== 'finished') {
          player.finish();
          if (cb) {
            var _coordinates = _this.getCoordinates();
            cb(frame, _coordinates[_coordinates.length - 1]);
          }
        }
        return;
      }
      var currentCoord = _this._drawAnimShowFrame(frame.styles.t, duration, length, animCoords, prjAnimCoords);
      if (frame.state.playState === 'finished') {
        delete _this._showPlayer;
        delete _this._aniShowCenter;
        delete _this._prjAniShowCenter;
        delete _this._animIdx;
        delete _this._animLenSoFar;
        delete _this._animTailRatio;
        delete _this._tempCoord;
        delete _this._tempPrjCoord;
        _this.setCoordinates(coordinates);
      }
      if (cb) {
        cb(frame, currentCoord);
      }
    }, this);
    setTimeout(function () {
      player.play();
    }, 1);
    return player;
  };
  _proto._drawAnimShowFrame = function _drawAnimShowFrame(t, duration, length, coordinates, prjCoords) {
    if (t === 0) {
      return coordinates[0];
    }
    var targetLength = t / duration * length;
    var segLen = 0;
    var i, l;
    for (i = this._animIdx + 1, l = prjCoords.length; i < l; i++) {
      segLen = prjCoords[i]._distance;
      if (this._animLenSoFar + segLen > targetLength) {
        break;
      }
      this._animLenSoFar += segLen;
    }
    this._animIdx = i - 1;
    if (this._animIdx >= l - 1) {
      this.setCoordinates(coordinates);
      return coordinates[coordinates.length - 1];
    }
    var idx = this._animIdx;
    var p1 = prjCoords[idx],
      p2 = prjCoords[idx + 1],
      span = targetLength - this._animLenSoFar,
      r = span / segLen;
    this._animTailRatio = r;
    var x = p1.x + (p2.x - p1.x) * r,
      y = p1.y + (p2.y - p1.y) * r;
    this._tempPrjCoord.x = x;
    this._tempPrjCoord.y = y;
    var lastCoord = this._tempPrjCoord;
    var c1 = coordinates[idx],
      c2 = coordinates[idx + 1];
    var cx = c1.x + (c2.x - c1.x) * r,
      cy = c1.y + (c2.y - c1.y) * r,
      cz = (c1.z || 0) + ((c2.z || 0) - (c1.z || 0)) * r;
    this._tempCoord.x = cx;
    this._tempCoord.y = cy;
    this._tempCoord.z = cz;
    var targetCoord = this._tempCoord;
    var isPolygon = !!this.getShell;
    if (!isPolygon && this.options['smoothness'] > 0) {
      var animCoords = [],
        prjAnimCoords = [];
      for (var _i = 0; _i <= this._animIdx; _i++) {
        animCoords.push(coordinates[_i]);
        prjAnimCoords.push(prjCoords[_i]);
      }
      animCoords.push(targetCoord, targetCoord);
      prjAnimCoords.push(lastCoord, lastCoord);
      this.setCoordinates(animCoords);
      this._setPrjCoordinates(prjAnimCoords);
    } else {
      var _animCoords = coordinates.slice(0, this._animIdx + 1);
      _animCoords.push(targetCoord);
      var _prjAnimCoords = prjCoords.slice(0, this._animIdx + 1);
      _prjAnimCoords.push(lastCoord);
      if (isPolygon) {
        this.setCoordinates([this._aniShowCenter].concat(_animCoords));
        this._setPrjCoordinates([this._prjAniShowCenter].concat(_prjAnimCoords));
      } else {
        this.setCoordinates(_animCoords);
        this._setPrjCoordinates(_prjAnimCoords);
      }
    }
    return targetCoord;
  };
  _proto._getCenterInExtent = function _getCenterInExtent(extent, coordinates, clipFn) {
    var meExtent = this.getExtent();
    if (!extent.intersects(meExtent)) {
      return null;
    }
    var clipped = clipFn(coordinates, extent);
    if (clipped.length === 0) {
      return null;
    }
    var [sumx, sumy, counter] = [0, 0, 0];
    clipped.forEach(function (part) {
      if (Array.isArray(part)) {
        part.forEach(function (c) {
          if (c.point) {
            c = c.point;
          }
          sumx += c.x;
          sumy += c.y;
          counter++;
        });
      } else {
        if (part.point) {
          part = part.point;
        }
        sumx += part.x;
        sumy += part.y;
        counter++;
      }
    });
    var c = new Coordinate(sumx, sumy)._multi(1 / counter);
    c.count = counter;
    return c;
  };
  _proto._getPath2DPoints = function _getPath2DPoints(prjCoords, disableSimplify, res) {
    if (!isArrayHasData(prjCoords)) {
      return [];
    }
    var map = this.getMap(),
      isSimplify = !disableSimplify && this._shouldSimplify(),
      tolerance = this.options['simplifyTolerance'] * map._getResolution(),
      isMulti = Array.isArray(prjCoords[0]);
    delete this._simplified;
    if (isSimplify && !isMulti) {
      var count = prjCoords.length;
      prjCoords = simplify(prjCoords, tolerance, false);
      this._simplified = prjCoords.length < count;
    }
    if (!res) {
      res = map._getResolution();
    }
    if (!Array.isArray(prjCoords)) {
      return map._prjToPointAtRes(prjCoords, res);
    } else {
      var resultPoints = [];
      var glPointKey = '_glPt';
      if (!Array.isArray(prjCoords[0])) {
        resultPoints = getPointsResultPts(prjCoords, glPointKey);
        return map._prjsToPointsAtRes(prjCoords, res, resultPoints);
      }
      var pts = [];
      for (var i = 0, len = prjCoords.length; i < len; i++) {
        var prjCoord = prjCoords[i];
        resultPoints = getPointsResultPts(prjCoord, glPointKey);
        var pt = map._prjsToPointsAtRes(prjCoord, res, resultPoints);
        pts.push(pt);
      }
      return pts;
    }
  };
  _proto._shouldSimplify = function _shouldSimplify() {
    var layer = this.getLayer();
    var hasAltitude = layer.options['enableAltitude'];
    return layer && layer.options['enableSimplify'] && !hasAltitude && this.options['enableSimplify'] && !this._showPlayer;
  };
  _proto._setPrjCoordinates = function _setPrjCoordinates(prjPoints) {
    this._prjCoords = prjPoints;
    this.onShapeChanged();
  };
  _proto._getPrjCoordinates = function _getPrjCoordinates() {
    this._verifyProjection();
    if (!this._prjCoords && this._getProjection()) {
      this._prjCoords = this._projectCoords(this._coordinates);
    }
    return this._prjCoords;
  };
  _proto._updateCache = function _updateCache() {
    this._clearCache();
    var projection = this._getProjection();
    if (!projection) {
      return;
    }
    if (this._prjCoords) {
      this._coordinates = this._unprojectCoords(this._getPrjCoordinates());
    }
  };
  _proto._clearProjection = function _clearProjection() {
    this._prjCoords = null;
    _Geometry.prototype._clearProjection.call(this);
  };
  _proto._projectCoords = function _projectCoords(points) {
    var projection = this._getProjection();
    if (projection) {
      return projection.projectCoords(points, this.options['antiMeridian']);
    }
    return [];
  };
  _proto._unprojectCoords = function _unprojectCoords(prjPoints) {
    var projection = this._getProjection();
    if (projection) {
      return projection.unprojectCoords(prjPoints);
    }
    return [];
  };
  _proto._computeCenter = function _computeCenter() {
    var ring = this._coordinates;
    if (!isArrayHasData(ring)) {
      return null;
    }
    var sumx = 0,
      sumy = 0,
      counter = 0;
    var size = ring.length;
    for (var i = 0; i < size; i++) {
      if (ring[i]) {
        if (isNumber(ring[i].x) && isNumber(ring[i].y)) {
          sumx += ring[i].x;
          sumy += ring[i].y;
          counter++;
        }
      }
    }
    return new Coordinate(sumx / counter, sumy / counter);
  };
  _proto._computeExtent = function _computeExtent(_) {
    var shell = this._coordinates;
    if (!isArrayHasData(shell)) {
      return null;
    }
    var rings = [shell];
    if (this.hasHoles && this.hasHoles()) {
      rings.push.call(rings, ...this.getHoles());
    }
    return this._coords2Extent(rings, this._getProjection());
  };
  _proto._computePrjExtent = function _computePrjExtent(_) {
    var coords = [this._getPrjCoordinates()];
    if (this.hasHoles && this.hasHoles()) {
      coords.push.call(coords, ...this._getPrjHoles());
    }
    return this._coords2Extent(coords);
  };
  _proto._get2DLength = function _get2DLength() {
    var vertexes = this._getPath2DPoints(this._getPrjCoordinates(), true);
    var len = 0;
    for (var i = 1, l = vertexes.length; i < l; i++) {
      len += vertexes[i].distanceTo(vertexes[i - 1]);
    }
    return len;
  };
  _proto._hitTestTolerance = function _hitTestTolerance() {
    var symbol = this._getInternalSymbol();
    var w,
      border = 0;
    if (Array.isArray(symbol)) {
      w = 0;
      for (var i = 0; i < symbol.length; i++) {
        if (isNumber(symbol[i]['lineWidth'])) {
          if (symbol[i]['lineWidth'] > w) {
            w = symbol[i]['lineWidth'];
          }
        }
        if (isNumber(symbol[i]['lineStrokeWidth'])) {
          border = Math.max(border, symbol[i]['lineStrokeWidth']);
        }
      }
    } else {
      w = symbol['lineWidth'];
      border = symbol['lineStrokeWidth'] || 0;
    }
    w += border * 2;
    return _Geometry.prototype._hitTestTolerance.call(this) + (isNumber(w) ? w / 2 : 1.5);
  };
  _proto._coords2Extent = function _coords2Extent(coords, proj) {
    if (!coords || coords.length === 0 || Array.isArray(coords[0]) && coords[0].length === 0) {
      return null;
    }
    var result = new Extent(proj);
    for (var i = 0, l = coords.length; i < l; i++) {
      for (var j = 0, ll = coords[i].length; j < ll; j++) {
        result._combine(coords[i][j]);
      }
    }
    return result;
  };
  return Path;
}(Geometry);
Path.mergeOptions(options$A);

var JSON_TYPE = 'Polygon';
var Polygon = function (_Path) {
  function Polygon(coordinates, options) {
    var _this;
    _this = _Path.call(this, options) || this;
    _this.type = 'Polygon';
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    return _this;
  }
  _inheritsLoose(Polygon, _Path);
  var _proto = Polygon.prototype;
  _proto.getOutline = function getOutline() {
    var painter = this._getPainter();
    if (!painter) {
      return null;
    }
    var extent = this.getExtent();
    return new Polygon(extent.toArray(), {
      symbol: {
        'lineWidth': 1,
        'lineColor': '6b707b'
      }
    });
  };
  _proto.setCoordinates = function setCoordinates(coordinates) {
    if (!coordinates) {
      this._coordinates = null;
      this._holes = null;
      this._projectRings();
      return this;
    }
    var rings = Coordinate.toCoordinates(coordinates);
    var len = rings.length;
    if (!Array.isArray(rings[0])) {
      this._coordinates = this._trimRing(rings);
    } else {
      this._coordinates = this._trimRing(rings[0]);
      if (len > 1) {
        var holes = [];
        for (var i = 1; i < len; i++) {
          if (!rings[i]) {
            continue;
          }
          holes.push(this._trimRing(rings[i]));
        }
        this._holes = holes;
      } else {
        this._holes = null;
      }
    }
    this._projectRings();
    return this;
  };
  _proto.getCoordinates = function getCoordinates() {
    if (!this._coordinates) {
      return [];
    }
    var holes = this.getHoles();
    var rings = [this._copyAndCloseRing(this._coordinates)];
    for (var i = 0, l = holes.length; i < l; i++) {
      rings.push(this._copyAndCloseRing(holes[i]));
    }
    return rings;
  };
  _proto.getCenterInExtent = function getCenterInExtent(extent) {
    return this._getCenterInExtent(extent, this.getShell(), clipPolygon);
  };
  _proto.getShell = function getShell() {
    return this._coordinates || [];
  };
  _proto.getHoles = function getHoles() {
    return this._holes || [];
  };
  _proto.hasHoles = function hasHoles() {
    return this.getHoles().length > 0;
  };
  _proto._projectRings = function _projectRings() {
    if (!this.getMap()) {
      this.onShapeChanged();
      return;
    }
    this._prjCoords = this._projectCoords(this._coordinates);
    this._prjHoles = this._projectCoords(this._holes);
    this.onShapeChanged();
  };
  _proto._setPrjCoordinates = function _setPrjCoordinates(prjCoords) {
    this._prjCoords = prjCoords;
    this.onShapeChanged();
  };
  _proto._cleanRing = function _cleanRing(ring) {
    for (var i = ring.length - 1; i >= 0; i--) {
      if (!ring[i]) {
        ring.splice(i, 1);
      }
    }
  };
  _proto._checkRing = function _checkRing(ring) {
    this._cleanRing(ring);
    if (!ring || !isArrayHasData(ring)) {
      return false;
    }
    var lastPoint = ring[ring.length - 1];
    var isClose = true;
    if (ring[0].x !== lastPoint.x || ring[0].y !== lastPoint.y) {
      isClose = false;
    }
    return isClose;
  };
  _proto._trimRing = function _trimRing(ring) {
    var isClose = this._checkRing(ring);
    if (isArrayHasData(ring) && isClose) {
      ring.splice(ring.length - 1, 1);
    }
    return ring;
  };
  _proto._copyAndCloseRing = function _copyAndCloseRing(ring) {
    ring = ring.slice(0);
    var isClose = this._checkRing(ring);
    if (isArrayHasData(ring) && !isClose) {
      ring.push(ring[0].copy());
      return ring;
    } else {
      return ring;
    }
  };
  _proto._getPrjShell = function _getPrjShell() {
    if (this.getJSONType() === JSON_TYPE) {
      return this._getPrjCoordinates();
    }
    this._verifyProjection();
    if (this._getProjection() && !this._prjShell) {
      this._prjShell = this._projectCoords(this._getShell ? this._getShell() : this.getShell());
    }
    return this._prjShell;
  };
  _proto._getPrjHoles = function _getPrjHoles() {
    var projection = this._getProjection();
    this._verifyProjection();
    if (projection && !this._prjHoles) {
      this._prjHoles = this._projectCoords(this.getHoles());
    }
    return this._prjHoles;
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength(measurer) {
    var rings = this.getCoordinates();
    if (!isArrayHasData(rings)) {
      return 0;
    }
    var result = 0;
    for (var i = 0, len = rings.length; i < len; i++) {
      result += measurer.measureLength(rings[i]);
    }
    return result;
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea(measurer) {
    var rings = this.getCoordinates();
    if (!isArrayHasData(rings)) {
      return 0;
    }
    var result = measurer.measureArea(rings[0]);
    for (var i = 1, len = rings.length; i < len; i++) {
      result -= measurer.measureArea(rings[i]);
    }
    return result;
  };
  _proto._updateCache = function _updateCache() {
    _Path.prototype._updateCache.call(this);
    if (this._prjHoles) {
      this._holes = this._unprojectCoords(this._getPrjHoles());
    }
  };
  _proto._clearCache = function _clearCache() {
    delete this._prjShell;
    return _Path.prototype._clearCache.call(this);
  };
  _proto._clearProjection = function _clearProjection() {
    if (this._prjHoles) {
      this._prjHoles = null;
    }
    if (this._prjShell) {
      this._prjShell = null;
    }
    _Path.prototype._clearProjection.call(this);
  };
  return Polygon;
}(Path);
Polygon.registerJSONType(JSON_TYPE);

function CenterMixin (Base) {
  return function (_Base) {
    function _class() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(_class, _Base);
    var _proto = _class.prototype;
    _proto.getCoordinates = function getCoordinates() {
      return this._coordinates;
    };
    _proto.setCoordinates = function setCoordinates(coordinates) {
      var center = coordinates instanceof Coordinate ? coordinates : new Coordinate(coordinates);
      this._translateRotatePivot(center);
      this._coordinates = center;
      if (!this.getMap()) {
        this._dirtyCoords = true;
        this.onPositionChanged();
        return this;
      }
      var projection = this._getProjection();
      this._setPrjCoordinates(projection.project(this._coordinates));
      return this;
    };
    _proto._getCenter2DPoint = function _getCenter2DPoint(res) {
      var map = this.getMap();
      if (!map) {
        return null;
      }
      var pcenter = this._getPrjCoordinates();
      if (!pcenter) {
        return null;
      }
      if (!res) {
        res = map._getResolution();
      }
      return map._prjToPointAtRes(pcenter, res);
    };
    _proto._getPrjCoordinates = function _getPrjCoordinates() {
      var projection = this._getProjection();
      this._verifyProjection();
      if (!this._pcenter && projection) {
        if (this._coordinates) {
          this._pcenter = projection.project(this._coordinates);
        }
      }
      return this._pcenter;
    };
    _proto._setPrjCoordinates = function _setPrjCoordinates(pcenter) {
      this._pcenter = pcenter;
      this.onPositionChanged();
    };
    _proto._updateCache = function _updateCache() {
      this._clearCache();
      var projection = this._getProjection();
      if (this._pcenter && projection) {
        this._coordinates = projection.unproject(this._pcenter);
      }
    };
    _proto._clearProjection = function _clearProjection() {
      this._pcenter = null;
      _Base.prototype._clearProjection.call(this);
    };
    _proto._computeCenter = function _computeCenter() {
      return this._coordinates ? this._coordinates.copy() : null;
    };
    return _class;
  }(Base);
}

var TEMP_EXTENT$3 = new PointExtent();
var options$z = {
  'symbol': {
    'markerType': 'path',
    'markerPath': [{
      'path': 'M8 23l0 0 0 0 0 0 0 0 0 0c-4,-5 -8,-10 -8,-14 0,-5 4,-9 8,-9l0 0 0 0c4,0 8,4 8,9 0,4 -4,9 -8,14z M3,9 a5,5 0,1,0,0,-0.9Z',
      'fill': '#DE3333'
    }],
    'markerPathWidth': 16,
    'markerPathHeight': 23,
    'markerWidth': 24,
    'markerHeight': 34
  },
  'hitTestForEvent': false,
  'collision': true
};
var Marker = function (_CenterMixin) {
  function Marker(coordinates, options) {
    var _this;
    _this = _CenterMixin.call(this, options) || this;
    _this.isPoint = true;
    _this.type = 'Point';
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    return _this;
  }
  _inheritsLoose(Marker, _CenterMixin);
  var _proto = Marker.prototype;
  _proto.getOutline = function getOutline() {
    var coord = this.getCoordinates();
    var extent = this.getContainerExtent();
    var anchor = this.getMap().coordToContainerPoint(coord);
    return new Marker(coord, {
      'symbol': {
        'markerType': 'square',
        'markerWidth': extent.getWidth(),
        'markerHeight': extent.getHeight(),
        'markerLineWidth': 1,
        'markerLineColor': '6b707b',
        'markerFill': 'rgba(0, 0, 0, 0)',
        'markerDx': extent.xmin - (anchor.x - extent.getWidth() / 2),
        'markerDy': extent.ymin - (anchor.y - extent.getHeight() / 2)
      }
    });
  };
  _proto.setSymbol = function setSymbol(symbol) {
    delete this._fixedExtent;
    return _CenterMixin.prototype.setSymbol.call(this, symbol);
  };
  _proto._getSizeSymbol = function _getSizeSymbol(symbol) {
    var s = {};
    var dynamic = false;
    var dynamicSize = false;
    for (var i = 0; i < DYNAMIC_SYMBOL_PROPS.length; i++) {
      var v = symbol[DYNAMIC_SYMBOL_PROPS[i]];
      if (isNil(v)) {
        continue;
      }
      if (!dynamic && isFunctionDefinition(v)) {
        dynamic = true;
        dynamicSize = true;
      }
      s[DYNAMIC_SYMBOL_PROPS[i]] = v;
    }
    for (var _i = 0; _i < SIZE_SYMBOL_PROPS.length; _i++) {
      var _v = symbol[SIZE_SYMBOL_PROPS[_i]];
      if (isNil(_v)) {
        continue;
      }
      if (!dynamic && isFunctionDefinition(_v)) {
        dynamic = true;
      }
      s[SIZE_SYMBOL_PROPS[_i]] = _v;
    }
    var sizeSymbol;
    if (dynamic) {
      sizeSymbol = loadGeoSymbol(s, this);
      if (dynamicSize) {
        sizeSymbol._dynamic = true;
      }
    } else {
      sizeSymbol = s;
    }
    return sizeSymbol;
  };
  _proto._setExternSymbol = function _setExternSymbol(symbol) {
    if (!this._symbol) {
      delete this._fixedExtent;
    }
    return _CenterMixin.prototype._setExternSymbol.call(this, symbol);
  };
  _proto._isDynamicSize = function _isDynamicSize() {
    return this._sizeSymbol && this._sizeSymbol._dynamic;
  };
  _proto._getFixedExtent = function _getFixedExtent() {
    if (this._fixedExtent && !this._isDynamicSize()) {
      return this._fixedExtent;
    }
    this._fixedExtent = this._fixedExtent || new PointExtent();
    this._fixedExtent.set(null, null, null, null);
    var symbol = this._sizeSymbol;
    if (!symbol) {
      return this._fixedExtent;
    }
    var renderer = this.getLayer() && this.getLayer().getRenderer();
    var resources = renderer && renderer.resources;
    var textDesc = this.getTextDesc();
    if (Array.isArray(symbol)) {
      TEMP_EXTENT$3.set(Infinity, Infinity, -Infinity, -Infinity);
      for (var i = 0; i < symbol.length; i++) {
        if (!symbol[i]) {
          continue;
        }
        this._fixedExtent._combine(getMarkerFixedExtent(TEMP_EXTENT$3, symbol[i], resources, textDesc && textDesc[i]));
      }
    } else {
      this._fixedExtent = getMarkerFixedExtent(this._fixedExtent, symbol, resources, textDesc);
    }
    return this._fixedExtent;
  };
  _proto._isVectorMarker = function _isVectorMarker() {
    var symbol = this._getInternalSymbol();
    if (Array.isArray(symbol)) {
      return false;
    }
    return isVectorSymbol(symbol);
  };
  _proto._canEdit = function _canEdit() {
    var symbol = this._getInternalSymbol();
    if (Array.isArray(symbol)) {
      return false;
    }
    return isVectorSymbol(symbol) || isPathSymbol(symbol) || isImageSymbol(symbol);
  };
  _proto._containsPoint = function _containsPoint(point, t) {
    var extent = this.getContainerExtent();
    if (t) {
      extent = extent.expand(t);
    }
    if (extent.contains(point)) {
      if (this.options['hitTestForEvent']) {
        return _CenterMixin.prototype._containsPoint.call(this, point, t);
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  _proto._computeExtent = function _computeExtent() {
    return computeExtent$1.call(this, 'getCenter');
  };
  _proto._computePrjExtent = function _computePrjExtent() {
    return computeExtent$1.call(this, '_getPrjCoordinates');
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength() {
    return 0;
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    return 0;
  };
  _proto._getSprite = function _getSprite(resources, canvasClass) {
    if (this._getPainter()) {
      return this._getPainter().getSprite(resources, canvasClass);
    }
    return new Painter(this).getSprite(resources, canvasClass);
  };
  return Marker;
}(CenterMixin(Geometry));
Marker.mergeOptions(options$z);
Marker.registerJSONType('Marker');
function computeExtent$1(fn) {
  var coordinates = this[fn]();
  if (!coordinates) {
    return null;
  }
  return new Extent(coordinates, coordinates, this._getProjection());
}

var options$y = {
  'arrowStyle': null,
  'arrowPlacement': 'vertex-last'
};
var LineString = function (_Path) {
  function LineString(coordinates, options) {
    var _this;
    _this = _Path.call(this, options) || this;
    _this.type = 'LineString';
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    return _this;
  }
  _inheritsLoose(LineString, _Path);
  var _proto = LineString.prototype;
  _proto.getOutline = function getOutline() {
    return Polygon.prototype.getOutline.call(this);
  };
  _proto.setCoordinates = function setCoordinates(coordinates) {
    if (!coordinates) {
      this._coordinates = null;
      this._setPrjCoordinates(null);
      return this;
    }
    this._coordinates = Coordinate.toCoordinates(coordinates);
    if (this.getMap()) {
      this._setPrjCoordinates(this._projectCoords(this._coordinates));
    } else {
      this.onShapeChanged();
    }
    return this;
  };
  _proto.getCoordinates = function getCoordinates() {
    return this._coordinates || [];
  };
  _proto.getCenterInExtent = function getCenterInExtent(extent) {
    return this._getCenterInExtent(extent, this.getCoordinates(), clipLine);
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength(measurer) {
    return measurer.measureLength(this.getCoordinates());
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    return 0;
  };
  return LineString;
}(Path);
LineString.mergeOptions(options$y);
LineString.registerJSONType('LineString');

var TEMP_EXTENT$2 = new PointExtent();
var GeometryCollection = function (_Geometry) {
  function GeometryCollection(geometries, opts) {
    var _this;
    _this = _Geometry.call(this, opts) || this;
    _this.type = 'GeometryCollection';
    _this._lastUndoEditIndex = 0;
    _this._lastRedoEditIndex = 0;
    _this.setGeometries(geometries);
    return _this;
  }
  _inheritsLoose(GeometryCollection, _Geometry);
  var _proto = GeometryCollection.prototype;
  _proto.getContainerExtent = function getContainerExtent(out) {
    var extent = out || new PointExtent();
    this.forEach(function (geo) {
      extent._combine(geo.getContainerExtent(TEMP_EXTENT$2));
    });
    return extent;
  };
  _proto.setGeometries = function setGeometries(_geometries) {
    var geometries = this._checkGeometries(_geometries || []);
    var symbol = this._getSymbol();
    var options = this.config();
    var properties = this.getProperties();
    for (var i = geometries.length - 1; i >= 0; i--) {
      geometries[i]._initOptions(options);
      geometries[i]._setParent(this);
      geometries[i]._setEventParent(this);
      if (symbol) {
        geometries[i].setSymbol(symbol);
      }
      if (properties) {
        geometries[i].setProperties(properties);
      }
    }
    this._geometries = geometries;
    if (this.getLayer()) {
      this._bindGeometriesToLayer();
      this.onShapeChanged();
    }
    return this;
  };
  _proto.getGeometries = function getGeometries() {
    return this._geometries || [];
  };
  _proto.forEach = function forEach(fn, context) {
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      if (!context) {
        fn(geometries[i], i);
      } else {
        fn.call(context, geometries[i], i);
      }
    }
    return this;
  };
  _proto.filter = function filter(fn, context) {
    if (!fn) {
      return new GeometryCollection();
    }
    var selected = [];
    var isFn = isFunction(fn);
    var filter = isFn ? fn : createFilter(fn);
    this.forEach(function (geometry) {
      var g = isFn ? geometry : getFilterFeature(geometry);
      if (context ? filter.call(context, g) : filter(g)) {
        selected.push(geometry);
      }
    }, this);
    return new GeometryCollection(selected);
  };
  _proto.translate = function translate(offset) {
    if (!offset) {
      return this;
    }
    if (this.isEmpty()) {
      return this;
    }
    var args = arguments;
    this.forEach(function (geometry) {
      if (geometry && geometry.translate) {
        geometry.translate.apply(geometry, args);
      }
    });
    return this;
  };
  _proto.isEmpty = function isEmpty() {
    return !isArrayHasData(this.getGeometries());
  };
  _proto.remove = function remove() {
    this.forEach(function (geometry) {
      geometry._unbind();
    });
    return Geometry.prototype.remove.apply(this, arguments);
  };
  _proto.show = function show() {
    this.options['visible'] = true;
    this.forEach(function (geometry) {
      geometry.show();
    });
    return this;
  };
  _proto.hide = function hide() {
    this.options['visible'] = false;
    this.forEach(function (geometry) {
      geometry.hide();
    });
    return this;
  };
  _proto.onConfig = function onConfig(config) {
    this.forEach(function (geometry) {
      geometry.config(config);
    });
  };
  _proto.getSymbol = function getSymbol() {
    var s = _Geometry.prototype.getSymbol.call(this);
    if (!s) {
      var symbols = [];
      var is = false;
      this.forEach(function (g) {
        var symbol = g.getSymbol();
        if (symbol && !is) {
          is = true;
        }
        symbols.push(g.getSymbol());
      });
      if (is) {
        s = {
          'children': symbols
        };
      }
    }
    return s;
  };
  _proto.setSymbol = function setSymbol(s) {
    var _this2 = this;
    if (s && s['children']) {
      this._symbol = null;
      this.forEach(function (g, i) {
        g._eventSymbolProperties = _this2._eventSymbolProperties;
        g.setSymbol(s['children'][i]);
      });
    } else {
      var symbol = this._prepareSymbol(s);
      this._symbol = symbol;
      this.forEach(function (g) {
        g._eventSymbolProperties = _this2._eventSymbolProperties;
        g.setSymbol(symbol);
      });
    }
    this.onSymbolChanged();
    return this;
  };
  _proto._setExternSymbol = function _setExternSymbol(symbol) {
    symbol = this._prepareSymbol(symbol);
    this._externSymbol = symbol;
    this.forEach(function (geometry) {
      geometry._setExternSymbol(symbol);
    });
    this.onSymbolChanged();
    return this;
  };
  _proto._bindLayer = function _bindLayer() {
    _Geometry.prototype._bindLayer.apply(this, arguments);
    this._bindGeometriesToLayer();
  };
  _proto._bindGeometriesToLayer = function _bindGeometriesToLayer() {
    var layer = this.getLayer();
    this.forEach(function (geometry) {
      geometry._bindLayer(layer);
    });
  };
  _proto._checkGeometries = function _checkGeometries(geometries) {
    var invalidGeoError = 'The geometry added to collection is invalid.';
    geometries = Array.isArray(geometries) ? geometries : [geometries];
    var filterGeometries = [];
    for (var i = 0, l = geometries.length; i < l; i++) {
      var geometry = geometries[i];
      if (!geometry) {
        continue;
      }
      if (!this._checkGeo(geometry)) {
        console.error(invalidGeoError + ' Index: ' + i);
        continue;
      }
      if (isSelf(geometry)) {
        if (!GlobalConfig.isTest) {
          console.error(geometry, ' is GeometryCollection sub class,it Cannot be placed in GeometryCollection');
        }
        continue;
      }
      filterGeometries.push(geometry);
    }
    return filterGeometries;
  };
  _proto._checkGeo = function _checkGeo(geo) {
    return geo instanceof Geometry;
  };
  _proto._updateCache = function _updateCache() {
    this._clearCache();
    if (this.isEmpty()) {
      return;
    }
    this.forEach(function (geometry) {
      if (geometry && geometry._updateCache) {
        geometry._updateCache();
      }
    });
  };
  _proto._removePainter = function _removePainter() {
    if (this._painter) {
      this._painter.remove();
    }
    delete this._painter;
    this.forEach(function (geometry) {
      geometry._removePainter();
    });
  };
  _proto._computeCenter = function _computeCenter(projection) {
    if (!projection || this.isEmpty()) {
      return null;
    }
    var sumX = 0,
      sumY = 0,
      counter = 0;
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      var center = geometries[i]._computeCenter(projection);
      if (center) {
        sumX += center.x;
        sumY += center.y;
        counter++;
      }
    }
    if (counter === 0) {
      return null;
    }
    return new Coordinate(sumX / counter, sumY / counter);
  };
  _proto._containsPoint = function _containsPoint(point, t) {
    if (this.isEmpty()) {
      return false;
    }
    delete this._pickGeometryIndex;
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (geometries[i]._containsPoint(point, t)) {
        this._pickGeometryIndex = i;
        return true;
      }
    }
    return false;
  };
  _proto._hitTestTolerance = function _hitTestTolerance() {
    var geometries = this.getGeometries();
    var hitTolerance = 0;
    for (var i = 0, len = geometries.length; i < len; i++) {
      var t = geometries[i]._hitTestTolerance();
      hitTolerance = Math.max(hitTolerance, t);
    }
    return hitTolerance;
  };
  _proto._computeExtent = function _computeExtent(projection) {
    return computeExtent.call(this, projection, '_computeExtent');
  };
  _proto._computePrjExtent = function _computePrjExtent(projection) {
    return computeExtent.call(this, projection, '_computePrjExtent');
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength(projection) {
    if (!projection || this.isEmpty()) {
      return 0;
    }
    var geometries = this.getGeometries();
    var result = 0;
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      result += geometries[i]._computeGeodesicLength(projection);
    }
    return result;
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea(projection) {
    if (!projection || this.isEmpty()) {
      return 0;
    }
    var geometries = this.getGeometries();
    var result = 0;
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      result += geometries[i]._computeGeodesicArea(projection);
    }
    return result;
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var children = [];
    if (!this.isEmpty()) {
      var geometries = this.getGeometries();
      for (var i = 0, l = geometries.length; i < l; i++) {
        if (!geometries[i]) {
          continue;
        }
        children.push(geometries[i]._exportGeoJSONGeometry());
      }
    }
    return {
      'type': 'GeometryCollection',
      'geometries': children
    };
  };
  _proto._toJSON = function _toJSON(options) {
    options = extend$2({}, options);
    var feature = {
      'type': 'Feature',
      'geometry': {
        'type': 'GeometryCollection',
        'geometries': this.getGeometries().filter(function (geo) {
          return geo && geo._toJSON;
        }).map(function (geo) {
          var json = geo._toJSON();
          if (json.subType) {
            return json;
          }
          return geo._exportGeoJSONGeometry();
        })
      }
    };
    var id = this.getId();
    if (!isNil(id)) {
      feature['id'] = id;
    }
    var properties;
    if (isNil(options['properties']) || options['properties']) {
      properties = this._exportProperties();
    }
    feature['properties'] = properties;
    options.feature = feature;
    return options;
  };
  _proto._clearProjection = function _clearProjection() {
    if (this.isEmpty()) {
      return;
    }
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      geometries[i]._clearProjection();
    }
  };
  _proto._getConnectPoints = function _getConnectPoints() {
    var extent = this.getExtent();
    var anchors = [new Coordinate(extent.xmin, extent.ymax), new Coordinate(extent.xmax, extent.ymin), new Coordinate(extent.xmin, extent.ymin), new Coordinate(extent.xmax, extent.ymax)];
    return anchors;
  };
  _proto._getExternalResources = function _getExternalResources() {
    if (this.isEmpty()) {
      return [];
    }
    var geometries = this.getGeometries(),
      resources = [];
    var cache = {};
    var symbol, res, key;
    for (var i = 0, l = geometries.length; i < l; i++) {
      if (!geometries[i]) {
        continue;
      }
      symbol = geometries[i]._getInternalSymbol();
      res = getExternalResources(symbol);
      for (var ii = 0, ll = res.length; ii < ll; ii++) {
        key = res[ii].join();
        if (!cache[key]) {
          resources.push(res[ii]);
          cache[key] = 1;
        }
      }
    }
    return resources;
  };
  _proto.startEdit = function startEdit(opts) {
    var _this3 = this;
    if (this.isEmpty()) {
      return this;
    }
    if (!opts) {
      opts = {};
    }
    if (opts['symbol']) {
      this._originalSymbol = this.getSymbol();
      this.setSymbol(opts['symbol']);
    }
    this._draggbleBeforeEdit = this.options['draggable'];
    this.config('draggable', false);
    this._recordVisible();
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      geometries[i].startEdit(opts);
    }
    this._editing = true;
    var layer = this.getLayer();
    var needShadow = layer && layer.options['renderer'] === 'canvas';
    if (needShadow) {
      this.hide();
    }
    setTimeout(function () {
      _this3.fire('editstart');
    }, 1);
    return this;
  };
  _proto.endEdit = function endEdit() {
    if (this.isEmpty()) {
      return this;
    }
    this._recoveryVisible();
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      geometries[i].endEdit();
    }
    if (this._originalSymbol) {
      this.setSymbol(this._originalSymbol);
      delete this._originalSymbol;
    }
    this._editing = false;
    this.show();
    this.config('draggable', this._draggbleBeforeEdit);
    this.fire('editend');
    return this;
  };
  _proto.isEditing = function isEditing() {
    if (!this._editing) {
      return false;
    }
    return true;
  };
  _proto.undoEdit = function undoEdit() {
    if (this.isEmpty()) {
      return this;
    }
    this._recoveryVisible();
    var geometries = this.getGeometries();
    var i = this._lastUndoEditIndex;
    for (; i < geometries.length; i++) {
      if (!geometries[i].undoEditcheck()) {
        geometries[i].undoEdit();
        this._lastUndoEditIndex = i;
        break;
      }
    }
    if (i === geometries.length) {
      this._lastUndoEditIndex = 0;
    }
    this.fire('undoedit');
    return this;
  };
  _proto.redoEdit = function redoEdit() {
    if (this.isEmpty()) {
      return this;
    }
    this._recoveryVisible();
    var geometries = this.getGeometries();
    var i = this._lastRedoEditIndex;
    for (; i < geometries.length; i++) {
      if (!geometries[i].redoEditcheck()) {
        geometries[i].redoEdit();
        this._lastRedoEditIndex = i;
        break;
      }
    }
    if (i === geometries.length) {
      this._lastRedoEditIndex = 0;
    }
    this.fire('redoedit');
    return this;
  };
  _proto.undoEditcheck = function undoEditcheck() {
    var geometries = this.getGeometries();
    for (var i = 0; i < geometries.length; i++) {
      if (!geometries[i].undoEditcheck()) {
        return false;
      }
    }
    return true;
  };
  _proto.redoEditcheck = function redoEditcheck() {
    var geometries = this.getGeometries();
    for (var i = 0; i < geometries.length; i++) {
      if (!geometries[i].redoEditcheck()) {
        return false;
      }
    }
    return true;
  };
  return GeometryCollection;
}(Geometry);
GeometryCollection.registerJSONType('GeometryCollection');
function computeExtent(projection, fn) {
  if (this.isEmpty()) {
    return null;
  }
  var extent = new Extent();
  var geometries = this.getGeometries();
  for (var i = 0, l = geometries.length; i < l; i++) {
    if (!geometries[i]) {
      continue;
    }
    var e = geometries[i][fn](projection);
    if (e) {
      extent._combine(e);
    }
  }
  return extent;
}
function isSelf(geom) {
  return geom instanceof GeometryCollection;
}

var MultiGeometry = function (_GeometryCollection) {
  function MultiGeometry(geoType, type, data, options) {
    var _this;
    _this = _GeometryCollection.call(this, null, options) || this;
    _this.GeometryType = geoType;
    _this.type = type;
    _this._initData(data);
    return _this;
  }
  _inheritsLoose(MultiGeometry, _GeometryCollection);
  var _proto = MultiGeometry.prototype;
  _proto.getCoordinates = function getCoordinates() {
    var coordinates = [];
    var geometries = this.getGeometries();
    for (var i = 0, l = geometries.length; i < l; i++) {
      var child = geometries[i];
      coordinates.push(child.getShell && child.getJSONType() !== 'Polygon' ? [child.getShell()] : child.getCoordinates());
    }
    return coordinates;
  };
  _proto.setCoordinates = function setCoordinates(coordinates) {
    coordinates = coordinates || [];
    var geometries = [];
    for (var i = 0, l = coordinates.length; i < l; i++) {
      var g = new this.GeometryType(coordinates[i], this.config());
      geometries.push(g);
    }
    this.setGeometries(geometries);
    return this;
  };
  _proto._initData = function _initData(data) {
    data = data || [];
    if (data.length) {
      if (data[0] instanceof this.GeometryType) {
        this.setGeometries(data);
      } else {
        this.setCoordinates(data);
      }
    }
  };
  _proto._checkGeo = function _checkGeo(geo) {
    return geo instanceof this.GeometryType;
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var points = this.getCoordinates();
    var coordinates = Coordinate.toNumberArrays(points);
    return {
      'type': this.getType(),
      'coordinates': coordinates
    };
  };
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options)
    };
  };
  return MultiGeometry;
}(GeometryCollection);

var MultiPoint = function (_MultiGeometry) {
  function MultiPoint(data, opts) {
    return _MultiGeometry.call(this, Marker, 'MultiPoint', data, opts) || this;
  }
  _inheritsLoose(MultiPoint, _MultiGeometry);
  var _proto = MultiPoint.prototype;
  _proto.findClosest = function findClosest(coordinate) {
    if (!coordinate) {
      return null;
    }
    var coords = this.getCoordinates();
    var hit = null;
    var max = Infinity;
    coords.forEach(function (c) {
      var dist = distanceTo(c, coordinate);
      if (dist < max) {
        hit = c;
        max = dist;
      }
    });
    return hit;
  };
  return MultiPoint;
}(MultiGeometry);
MultiPoint.registerJSONType('MultiPoint');
function distanceTo(p0, p1) {
  var x = p1.x - p0.x,
    y = p1.y - p0.y;
  return Math.sqrt(x * x + y * y);
}

var MultiPath = function (_MultiGeometry) {
  function MultiPath() {
    return _MultiGeometry.apply(this, arguments) || this;
  }
  _inheritsLoose(MultiPath, _MultiGeometry);
  var _proto = MultiPath.prototype;
  _proto.getCenterInExtent = function getCenterInExtent(extent) {
    var children = this.getGeometries();
    var [sumx, sumy, counter] = [0, 0, 0];
    children.forEach(function (l) {
      var c = l.getCenterInExtent(extent);
      if (c) {
        sumx += c.x * c.count;
        sumy += c.y * c.count;
        counter += c.count;
      }
    });
    if (counter === 0) {
      return null;
    }
    return new Coordinate(sumx, sumy)._multi(1 / counter);
  };
  return MultiPath;
}(MultiGeometry);

var MultiLineString = function (_MultiPath) {
  function MultiLineString(data, options) {
    return _MultiPath.call(this, LineString, 'MultiLineString', data, options) || this;
  }
  _inheritsLoose(MultiLineString, _MultiPath);
  return MultiLineString;
}(MultiPath);
MultiLineString.registerJSONType('MultiLineString');

var MultiPolygon = function (_MultiPath) {
  function MultiPolygon(data, opts) {
    return _MultiPath.call(this, Polygon, 'MultiPolygon', data, opts) || this;
  }
  _inheritsLoose(MultiPolygon, _MultiPath);
  return MultiPolygon;
}(MultiPath);
MultiPolygon.registerJSONType('MultiPolygon');

var types = {
  'Marker': Marker,
  'LineString': LineString,
  'Polygon': Polygon,
  'MultiPoint': MultiPoint,
  'MultiLineString': MultiLineString,
  'MultiPolygon': MultiPolygon
};
var WORKER_KEY = 'geojson-fetch-worker-page-async';
var WORKER_CODE = "\nfunction (exports) {\n    const resultMap = {};\n\n    function handleResult(msg, postResponse) {\n        const data = msg.data || {};\n        const { taskId } = data;\n        const features = resultMap[taskId];\n        if (!features) {\n            postResponse('not find geojson dataset the taskId:' + taskId);\n            return;\n        }\n        if (features.length === 0) {\n            delete resultMap[taskId];\n            postResponse(null, []);\n            return;\n        }\n        const pageSize = data.pageSize || 2000;\n        const pageFeatures = features.slice(0, pageSize);\n        resultMap[taskId] = features.slice(pageSize, Infinity);\n        postResponse(null, pageFeatures);\n    }\n    //worker init\n    exports.initialize = function () {\n        // console.log(\"geojson fetch init\");\n    };\n    //recive message\n    exports.onmessage = function (msg, postResponse) {\n        const { taskId, type, url } = msg.data || {};\n        if (!taskId) {\n            postResponse('not find task id for get geojson dataset,taskId=' + taskId);\n            return;\n        }\n        if (type === 'fetchdata') {\n            if (!url) {\n                postResponse('url is null,url=' + url);\n                return;\n            }\n            fetch(url).then(res => res.json()).then(geojson => {\n                let features;\n                if (Array.isArray(geojson)) {\n                    features = geojson;\n                } else if (geojson.features) {\n                    features = geojson.features;\n                } else {\n                    features = [geojson];\n                }\n                resultMap[taskId] = features;\n                handleResult(msg, postResponse);\n            }).catch(errror => {\n                postResponse(errror.message);\n            });\n        } else if (type === 'pagefeatures') {\n            handleResult(msg, postResponse);\n        } else {\n            postResponse('not support task type:' + type);\n        }\n    };\n}";
var GeoJSONFetchActor = function (_Actor) {
  function GeoJSONFetchActor() {
    return _Actor.call(this, WORKER_KEY) || this;
  }
  _inheritsLoose(GeoJSONFetchActor, _Actor);
  var _proto = GeoJSONFetchActor.prototype;
  _proto._sendMsg = function _sendMsg(options, featuresList, cb) {
    var _this = this;
    this.send(options, [], function (error, data) {
      if (error) {
        cb(error);
      } else {
        _this._pageFeatures(options, data, featuresList, cb);
      }
    }, options.workerId);
  };
  _proto._fetchGeoJSON = function _fetchGeoJSON(url, options, featuresList = [], cb) {
    var opts = extend$2({}, options);
    opts.type = 'fetchdata';
    opts.url = url;
    this._sendMsg(opts, featuresList, cb);
  };
  _proto._pageFeatures = function _pageFeatures(options, features, featuresList, cb) {
    featuresList.push(features);
    if (features.length === 0) {
      cb(null, featuresList);
      return;
    }
    var opts = extend$2({}, options);
    opts.type = 'pagefeatures';
    this._sendMsg(opts, featuresList, cb);
  };
  return GeoJSONFetchActor;
}(Actor);
registerWorkerAdapter(WORKER_KEY, function () {
  return WORKER_CODE;
});
var fetchActor;
var GeoJSON = {
  toGeometry: function toGeometry(geoJSON, foreachFn, filterFn) {
    if (isString(geoJSON)) {
      geoJSON = parseJSON(geoJSON);
    }
    var resultGeos;
    if (Array.isArray(geoJSON)) {
      resultGeos = [];
      for (var i = 0, len = geoJSON.length; i < len; i++) {
        var geo = GeoJSON._convert(geoJSON[i], foreachFn);
        if (Array.isArray(geo)) {
          pushIn(resultGeos, geo);
        } else {
          resultGeos.push(geo);
        }
      }
    } else {
      resultGeos = GeoJSON._convert(geoJSON, foreachFn);
    }
    if (filterFn && isFunction(filterFn) && Array.isArray(resultGeos)) {
      return resultGeos.filter(filterFn);
    } else {
      return resultGeos;
    }
  },
  toGeometryAsync: function toGeometryAsync(geoJSON, foreachFn, countPerTime, filterFn) {
    if (isString(geoJSON)) {
      geoJSON = parseJSON(geoJSON);
    }
    return new Promise(function (resolve) {
      var resultGeos = [];
      if (geoJSON && (Array.isArray(geoJSON) || Array.isArray(geoJSON.features))) {
        var pageSize = isNumber(countPerTime) ? Math.round(countPerTime) : 2000;
        var features = geoJSON.features || geoJSON;
        var count = Math.ceil(features.length / pageSize);
        var page = 1;
        var run = function run() {
          var startIndex = (page - 1) * pageSize,
            endIndex = page * pageSize;
          var fs = features.slice(startIndex, endIndex);
          var geos = GeoJSON.toGeometry(fs, foreachFn, filterFn);
          page++;
          return geos;
        };
        runTaskAsync({
          count: count,
          run: run
        }).then(function (geoList) {
          for (var i = 0, len = geoList.length; i < len; i++) {
            var geo = geoList[i];
            if (!geo) {
              continue;
            }
            if (Array.isArray(geo)) {
              pushIn(resultGeos, geo);
            } else {
              resultGeos.push(geo);
            }
          }
          resolve(resultGeos);
        });
      } else {
        var geo = GeoJSON.toGeometry(geoJSON, foreachFn);
        resolve(geo);
      }
    });
  },
  _convert: function _convert(json, foreachFn) {
    if (!json || isNil(json['type'])) {
      return null;
    }
    var type = json['type'];
    if (type === 'Feature') {
      var g = json['geometry'];
      var geometry = GeoJSON._convert(g);
      if (!geometry) {
        return null;
      }
      geometry.setId(json['id']);
      geometry.setProperties(json['properties']);
      if (foreachFn) {
        foreachFn(geometry);
      }
      return geometry;
    } else if (type === 'FeatureCollection') {
      var features = json['features'];
      if (!features) {
        return null;
      }
      return GeoJSON.toGeometry(features, foreachFn);
    } else if (['Point', 'LineString', 'Polygon', 'MultiPoint', 'MultiLineString', 'MultiPolygon'].indexOf(type) >= 0) {
      var clazz = type === 'Point' ? 'Marker' : type;
      var result = new types[clazz](json['coordinates']);
      if (foreachFn) {
        foreachFn(result);
      }
      return result;
    } else if (type === 'GeometryCollection') {
      var geometries = json['geometries'];
      if (!isArrayHasData(geometries)) {
        var _result = new GeometryCollection();
        if (foreachFn) {
          foreachFn(_result);
        }
        return _result;
      }
      var mGeos = [];
      var size = geometries.length;
      for (var i = 0; i < size; i++) {
        if (geometries[i].subType) {
          mGeos.push(Geometry.getJSONClass(geometries[i].subType).fromJSON(geometries[i]));
        } else {
          mGeos.push(GeoJSON._convert(geometries[i]));
        }
      }
      var _result2 = new GeometryCollection(mGeos);
      if (foreachFn) {
        foreachFn(_result2);
      }
      return _result2;
    }
    return null;
  },
  _isGeoJSON: function _isGeoJSON(json) {
    if (!json) {
      return false;
    }
    json = json || {};
    if (Array.isArray(json) && json.length) {
      return GeoJSON.isGeoJSON(json[0]);
    }
    var type = json.type;
    if (!type) {
      return false;
    }
    if (GEOJSON_TYPES.indexOf(type) === -1) {
      return false;
    }
    var {
      features: features,
      geometries: geometries,
      geometry: geometry,
      coordinates: coordinates
    } = json;
    if (coordinates && Array.isArray(coordinates)) {
      return true;
    }
    if (Array.isArray(geometries)) {
      return true;
    }
    if (Array.isArray(features)) {
      return true;
    }
    if (geometry) {
      var _coordinates = geometry.coordinates;
      if (_coordinates && Array.isArray(_coordinates)) {
        return true;
      }
    }
    return false;
  },
  fetch: function fetch(url, countPerTime = 2000) {
    return new Promise(function (resolve, reject) {
      if (!url || !isString(url)) {
        reject('url is error,It should be string');
        return;
      }
      var options = extend$2({
        pageSize: 2000
      }, {
        pageSize: countPerTime
      });
      url = getAbsoluteURL(url);
      if (!fetchActor) {
        fetchActor = new GeoJSONFetchActor();
      }
      var workerCount = fetchActor.workers.length;
      var workerId = Math.floor(Math.random() * workerCount);
      workerId = Math.min(workerCount - 1, workerId);
      options.workerId = workerId;
      options.taskId = GUID();
      fetchActor._fetchGeoJSON(url, options, [], function (error, featuresList) {
        if (error) {
          reject(error);
          return;
        }
        var result = [];
        featuresList.forEach(function (features) {
          for (var i = 0, len = features.length; i < len; i++) {
            result.push(features[i]);
          }
        });
        resolve({
          type: 'FeatureCollection',
          features: result
        });
      });
    });
  }
};

var options$x = {
  'numberOfShellPoints': 60
};
var Circle = function (_CenterMixin) {
  function Circle(coordinates, radius, options) {
    var _this;
    _this = _CenterMixin.call(this, null, options) || this;
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    _this._radius = radius;
    return _this;
  }
  _inheritsLoose(Circle, _CenterMixin);
  Circle.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var circle = new Circle(json['coordinates'], json['radius'], json['options']);
    circle.setProperties(feature['properties']);
    return circle;
  };
  var _proto = Circle.prototype;
  _proto.getRadius = function getRadius() {
    return this._radius;
  };
  _proto.setRadius = function setRadius(radius) {
    this._radius = radius;
    this.onShapeChanged();
    return this;
  };
  _proto.getShell = function getShell() {
    var measurer = this._getMeasurer(),
      center = this.getCoordinates(),
      numberOfPoints = this.options['numberOfShellPoints'],
      radius = this.getRadius();
    var shell = [];
    var rad, dx, dy;
    for (var i = 0, len = numberOfPoints - 1; i < len; i++) {
      rad = 360 * i / len * Math.PI / 180;
      dx = radius * Math.cos(rad);
      dy = radius * Math.sin(rad);
      var vertex = measurer.locate(center, dx, dy);
      vertex.z = center.z;
      shell.push(vertex);
    }
    shell.push(shell[0]);
    return shell;
  };
  _proto.getHoles = function getHoles() {
    return [];
  };
  _proto.animateShow = function animateShow() {
    return this.show();
  };
  _proto._containsPoint = function _containsPoint(point, tolerance) {
    var map = this.getMap();
    var cache = MapStateCache[map.id];
    var pitch = cache ? cache.pitch : map.getPitch();
    if (pitch) {
      return _CenterMixin.prototype._containsPoint.call(this, point, tolerance);
    }
    var center = map._pointToContainerPoint(this._getCenter2DPoint()),
      size = this.getSize(),
      t = this._hitTestTolerance() + (tolerance || 0),
      se = center.add(size.width / 2, size.height / 2);
    return withInEllipse(point, center, se, t);
  };
  _proto._computePrjExtent = function _computePrjExtent(projection) {
    var minmax = this._getMinMax(projection);
    if (!minmax) {
      return null;
    }
    var pcenter = this._getPrjCoordinates();
    var pminmax = minmax.map(function (c) {
      return projection.project(c);
    });
    var leftx = pminmax[0].x - pcenter.x;
    var rightx = pminmax[1].x - pcenter.x;
    var topy = pminmax[2].y - pcenter.y;
    var bottomy = pminmax[3].y - pcenter.y;
    return new Extent(pcenter.add(leftx, topy), pcenter.add(rightx, bottomy));
  };
  _proto._computeExtent = function _computeExtent(measurer) {
    var minmax = this._getMinMax(measurer);
    if (!minmax) {
      return null;
    }
    return new Extent(minmax[0].x, minmax[2].y, minmax[1].x, minmax[3].y, this._getProjection());
  };
  _proto._getMinMax = function _getMinMax(measurer) {
    if (!measurer || !this._coordinates || isNil(this._radius)) {
      return null;
    }
    var radius = this._radius;
    var p1 = measurer.locate(this._coordinates, -radius, 0),
      p2 = measurer.locate(this._coordinates, radius, 0),
      p3 = measurer.locate(this._coordinates, 0, radius),
      p4 = measurer.locate(this._coordinates, 0, -radius);
    return [p1, p2, p3, p4];
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength() {
    if (isNil(this._radius)) {
      return 0;
    }
    return Math.PI * 2 * this._radius;
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    if (isNil(this._radius)) {
      return 0;
    }
    return Math.PI * Math.pow(this._radius, 2);
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var coordinates = Coordinate.toNumberArrays([this.getShell()]);
    return {
      'type': 'Polygon',
      'coordinates': coordinates
    };
  };
  _proto._toJSON = function _toJSON(options) {
    var center = this.getCenter();
    var opts = extend$2({}, options);
    opts.geometry = false;
    var feature = this.toGeoJSON(opts);
    feature['geometry'] = {
      'type': 'Polygon'
    };
    return {
      'feature': feature,
      'subType': 'Circle',
      'coordinates': center.toArray(),
      'radius': this.getRadius()
    };
  };
  return Circle;
}(CenterMixin(Polygon));
Circle.mergeOptions(options$x);
Circle.registerJSONType('Circle');

function quarticIn(k) {
  return k * k * k * k;
}
function angleT(numberOfShellPoints) {
  var fs = [];
  var ts1 = [];
  for (var i = 0; i < numberOfShellPoints; i++) {
    ts1.push(quarticIn(i / numberOfShellPoints));
  }
  var ts2 = ts1.map(function (t) {
    return t;
  }).reverse();
  var ts = [];
  pushIn(ts, ts1, ts2, ts1, ts2);
  var sum = 0;
  for (var _i = 0, len = ts.length; _i < len; _i += 4) {
    fs.push(ts[_i]);
    sum += ts[_i];
  }
  return {
    fs: fs,
    sum: sum
  };
}
var options$w = {
  'numberOfShellPoints': 81
};
var Ellipse = function (_CenterMixin) {
  function Ellipse(coordinates, width, height, options) {
    var _this;
    _this = _CenterMixin.call(this, null, options) || this;
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    _this.width = width;
    _this.height = height;
    return _this;
  }
  _inheritsLoose(Ellipse, _CenterMixin);
  Ellipse.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var ellipse = new Ellipse(json['coordinates'], json['width'], json['height'], json['options']);
    ellipse.setProperties(feature['properties']);
    return ellipse;
  };
  var _proto = Ellipse.prototype;
  _proto.getWidth = function getWidth() {
    return this.width;
  };
  _proto.setWidth = function setWidth(width) {
    this.width = width;
    this.onShapeChanged();
    return this;
  };
  _proto.getHeight = function getHeight() {
    return this.height;
  };
  _proto.setHeight = function setHeight(height) {
    this.height = height;
    this.onShapeChanged();
    return this;
  };
  _proto.getShell = function getShell() {
    if (this.isRotated()) {
      return this.getRotatedShell();
    }
    return this._getShell();
  };
  _proto._getShell = function _getShell() {
    var measurer = this._getMeasurer(),
      center = this.getCoordinates(),
      numberOfPoints = this.options['numberOfShellPoints'] - 1,
      width = this.getWidth(),
      height = this.getHeight();
    var shell = [];
    var s = Math.pow(width / 2, 2) * Math.pow(height / 2, 2),
      sx = Math.pow(width / 2, 2),
      sy = Math.pow(height / 2, 2);
    var angles = [];
    if (Math.max(width / height, height / width) > 2) {
      var {
        fs: fs,
        sum: sum
      } = angleT(numberOfPoints);
      var dt = 360 / sum;
      var offsetAngle = 0;
      if (height > width) {
        offsetAngle = 90;
      }
      var angle = 0;
      for (var i = 0, len = fs.length; i < len; i++) {
        angle += dt * fs[i];
        angles.push(angle + offsetAngle);
      }
    } else {
      for (var _i2 = 0; _i2 < numberOfPoints; _i2++) {
        var _angle = 360 * _i2 / numberOfPoints;
        angles.push(_angle);
      }
    }
    if (this.options.debug) {
      console.log(angles);
    }
    var deg, rad, dx, dy;
    for (var _i3 = 0; _i3 < angles.length; _i3++) {
      deg = angles[_i3];
      rad = deg * Math.PI / 180;
      dx = Math.sqrt(s / (sx * Math.pow(Math.tan(rad), 2) + sy));
      dy = Math.sqrt(s / (sy * Math.pow(1 / Math.tan(rad), 2) + sx));
      if (deg > 90 && deg < 270) {
        dx *= -1;
      }
      if (deg > 180 && deg < 360) {
        dy *= -1;
      }
      var vertex = measurer.locate(center, dx, dy);
      vertex.z = center.z;
      shell.push(vertex);
    }
    shell.push(shell[0].copy());
    return shell;
  };
  _proto._getPrjShell = function _getPrjShell() {
    var shell = _CenterMixin.prototype._getPrjShell.call(this);
    return this._rotatePrjCoordinates(shell);
  };
  _proto.getHoles = function getHoles() {
    return [];
  };
  _proto.animateShow = function animateShow() {
    return this.show();
  };
  _proto._containsPoint = function _containsPoint(point, tolerance) {
    var map = this.getMap();
    if (map.isTransforming()) {
      return _CenterMixin.prototype._containsPoint.call(this, point, tolerance);
    }
    var projection = map.getProjection();
    var t = this._hitTestTolerance() + (tolerance || 0),
      pps = projection.projectCoords([this._coordinates, map.locate(this._coordinates, this.getWidth() / 2, this.getHeight() / 2)], this.options['antiMeridian']),
      p0 = map.prjToContainerPoint(pps[0]),
      p1 = map.prjToContainerPoint(pps[1]);
    return withInEllipse(point, p0, p1, t);
  };
  _proto._computePrjExtent = function _computePrjExtent() {
    if (this.isRotated()) {
      return this._computeRotatedPrjExtent();
    }
    return Circle.prototype._computePrjExtent.apply(this, arguments);
  };
  _proto._computeExtent = function _computeExtent() {
    return Circle.prototype._computeExtent.apply(this, arguments);
  };
  _proto._getMinMax = function _getMinMax(measurer) {
    if (!measurer || !this._coordinates || isNil(this.width) || isNil(this.height)) {
      return null;
    }
    var width = this.getWidth(),
      height = this.getHeight();
    var p1 = measurer.locate(this._coordinates, -width / 2, 0),
      p2 = measurer.locate(this._coordinates, width / 2, 0),
      p3 = measurer.locate(this._coordinates, 0, -height / 2),
      p4 = measurer.locate(this._coordinates, 0, height / 2);
    return [p1, p2, p3, p4];
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength() {
    if (isNil(this.width) || isNil(this.height)) {
      return 0;
    }
    var longer = this.width > this.height ? this.width : this.height;
    return 2 * Math.PI * longer / 2 - 4 * Math.abs(this.width - this.height);
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    if (isNil(this.width) || isNil(this.height)) {
      return 0;
    }
    return Math.PI * this.width * this.height / 4;
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var coordinates = Coordinate.toNumberArrays([this.getShell()]);
    return {
      'type': 'Polygon',
      'coordinates': coordinates
    };
  };
  _proto._toJSON = function _toJSON(options) {
    var opts = extend$2({}, options);
    var center = this.getCenter();
    opts.geometry = false;
    var feature = this.toGeoJSON(opts);
    feature['geometry'] = {
      'type': 'Polygon'
    };
    return {
      'feature': feature,
      'subType': 'Ellipse',
      'coordinates': center.toArray(),
      'width': this.getWidth(),
      'height': this.getHeight()
    };
  };
  return Ellipse;
}(CenterMixin(Polygon));
Ellipse.mergeOptions(options$w);
Ellipse.registerJSONType('Ellipse');

var Rectangle = function (_Polygon) {
  function Rectangle(coordinates, width, height, opts) {
    var _this;
    _this = _Polygon.call(this, null, opts) || this;
    if (coordinates) {
      _this.setCoordinates(coordinates);
    }
    _this._width = width;
    _this._height = height;
    return _this;
  }
  _inheritsLoose(Rectangle, _Polygon);
  Rectangle.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var rect = new Rectangle(json['coordinates'], json['width'], json['height'], json['options']);
    rect.setProperties(feature['properties']);
    return rect;
  };
  var _proto = Rectangle.prototype;
  _proto.getCoordinates = function getCoordinates() {
    return this._coordinates;
  };
  _proto.setCoordinates = function setCoordinates(nw) {
    var newCoordinate = nw instanceof Coordinate ? nw : new Coordinate(nw);
    this._translateRotatePivot(newCoordinate);
    this._coordinates = newCoordinate;
    if (!this._coordinates || !this.getMap()) {
      this.onPositionChanged();
      return this;
    }
    var projection = this._getProjection();
    this._setPrjCoordinates(projection.project(this._coordinates));
    return this;
  };
  _proto.getWidth = function getWidth() {
    return this._width;
  };
  _proto.setWidth = function setWidth(width) {
    this._width = width;
    this.onShapeChanged();
    return this;
  };
  _proto.getHeight = function getHeight() {
    return this._height;
  };
  _proto.setHeight = function setHeight(height) {
    this._height = height;
    this.onShapeChanged();
    return this;
  };
  _proto.getShell = function getShell() {
    if (this.isRotated()) {
      return this.getRotatedShell();
    }
    return this._getShell();
  };
  _proto._getShell = function _getShell() {
    var measurer = this._getMeasurer();
    var nw = this._coordinates;
    var map = this.getMap();
    var sx = 1,
      sy = -1;
    if (map) {
      var fExt = map.getFullExtent();
      if (fExt['left'] > fExt['right']) {
        sx = -1;
      }
      if (fExt['bottom'] > fExt['top']) {
        sy = 1;
      }
    }
    var points = [];
    points.push(nw);
    var p0 = measurer.locate(nw, sx * this._width, 0);
    p0.z = nw.z;
    points.push(p0);
    var p1 = measurer.locate(nw, sx * this._width, sy * this._height);
    p1.z = nw.z;
    points.push(p1);
    var p2 = measurer.locate(nw, 0, sy * this._height);
    points.push(p2);
    p2.z = nw.z;
    points.push(nw);
    return points;
  };
  _proto.getHoles = function getHoles() {
    return [];
  };
  _proto.animateShow = function animateShow() {
    return this.show();
  };
  _proto._getPrjCoordinates = function _getPrjCoordinates() {
    var projection = this._getProjection();
    this._verifyProjection();
    if (!this._pnw && projection) {
      if (this._coordinates) {
        this._pnw = projection.project(this._coordinates);
      }
    }
    return this._pnw;
  };
  _proto._setPrjCoordinates = function _setPrjCoordinates(pnw) {
    this._pnw = pnw;
    this.onPositionChanged();
  };
  _proto._getPrjShell = function _getPrjShell() {
    var shell = _Polygon.prototype._getPrjShell.call(this);
    var projection = this._getProjection();
    if (!projection.isSphere()) {
      return this._rotatePrjCoordinates(shell);
    }
    var sphereExtent = projection.getSphereExtent(),
      sx = sphereExtent.sx,
      sy = sphereExtent.sy;
    var circum = this._getProjection().getCircum();
    var nw = shell[0];
    for (var i = 1, l = shell.length; i < l; i++) {
      var p = shell[i];
      var dx = 0,
        dy = 0;
      if (sx * (nw.x - p.x) > 0) {
        dx = circum.x * sx;
      }
      if (sy * (nw.y - p.y) < 0) {
        dy = circum.y * sy;
      }
      shell[i]._add(dx, dy);
    }
    return this._rotatePrjCoordinates(shell);
  };
  _proto._updateCache = function _updateCache() {
    this._clearCache();
    var projection = this._getProjection();
    if (this._pnw && projection) {
      this._coordinates = projection.unproject(this._pnw);
    }
  };
  _proto._clearProjection = function _clearProjection() {
    this._pnw = null;
    _Polygon.prototype._clearProjection.call(this);
  };
  _proto._computeCenter = function _computeCenter(measurer) {
    return measurer.locate(this._coordinates, this._width / 2, -this._height / 2);
  };
  _proto._containsPoint = function _containsPoint(point, tolerance) {
    var map = this.getMap();
    if (map.isTransforming()) {
      return _Polygon.prototype._containsPoint.call(this, point, tolerance);
    }
    var t = isNil(tolerance) ? this._hitTestTolerance() : tolerance,
      r = map._getResolution() * t;
    var extent = this._getPrjExtent().expand(r);
    var p = map._containerPointToPrj(point);
    return extent.contains(p);
  };
  _proto._computePrjExtent = function _computePrjExtent(projection) {
    if (this.isRotated()) {
      return this._computeRotatedPrjExtent();
    }
    var se = this._getSouthEast(projection);
    if (!se) {
      return null;
    }
    var prjs = projection.projectCoords([new Coordinate(this._coordinates.x, se.y), new Coordinate(se.x, this._coordinates.y)], this.options['antiMeridian']);
    return new Extent(prjs[0], prjs[1]);
  };
  _proto._computeExtent = function _computeExtent(measurer) {
    var se = this._getSouthEast(measurer);
    if (!se) {
      return null;
    }
    return new Extent(this._coordinates, se, this._getProjection());
  };
  _proto._getSouthEast = function _getSouthEast(measurer) {
    if (!measurer || !this._coordinates || isNil(this._width) || isNil(this._height)) {
      return null;
    }
    var width = this.getWidth(),
      height = this.getHeight();
    var w = width,
      h = -height;
    if (measurer.fullExtent) {
      var fullExtent = measurer.fullExtent,
        sx = fullExtent.right > fullExtent.left ? 1 : -1,
        sy = fullExtent.top > fullExtent.bottom ? 1 : -1;
      w *= sx;
      h *= sy;
    }
    var rightPoint = measurer.locate(this._coordinates, w, 0);
    var bottomPoint = measurer.locate(this._coordinates, 0, h);
    rightPoint.y = bottomPoint.y;
    return rightPoint;
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength() {
    if (isNil(this._width) || isNil(this._height)) {
      return 0;
    }
    return 2 * (this._width + this._height);
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    if (isNil(this._width) || isNil(this._height)) {
      return 0;
    }
    return this._width * this._height;
  };
  _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
    var coordinates = Coordinate.toNumberArrays([this.getShell()]);
    return {
      'type': 'Polygon',
      'coordinates': coordinates
    };
  };
  _proto._toJSON = function _toJSON(options) {
    var opts = extend$2({}, options);
    var nw = this.getCoordinates();
    opts.geometry = false;
    var feature = this.toGeoJSON(opts);
    feature['geometry'] = {
      'type': 'Polygon'
    };
    return {
      'feature': feature,
      'subType': 'Rectangle',
      'coordinates': nw.toArray(),
      'width': this.getWidth(),
      'height': this.getHeight()
    };
  };
  return Rectangle;
}(Polygon);
Rectangle.registerJSONType('Rectangle');

var options$v = {
  'numberOfShellPoints': 60
};
var Sector = function (_Circle) {
  function Sector(coordinates, radius, startAngle, endAngle, opts) {
    var _this;
    _this = _Circle.call(this, coordinates, radius, opts) || this;
    _this.startAngle = startAngle;
    _this.endAngle = endAngle;
    return _this;
  }
  _inheritsLoose(Sector, _Circle);
  Sector.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var sector = new Sector(json['coordinates'], json['radius'], json['startAngle'], json['endAngle'], json['options']);
    sector.setProperties(feature['properties']);
    return sector;
  };
  var _proto = Sector.prototype;
  _proto.getStartAngle = function getStartAngle() {
    return this.startAngle;
  };
  _proto.setStartAngle = function setStartAngle(startAngle) {
    this.startAngle = startAngle;
    this.onShapeChanged();
    return this;
  };
  _proto.getEndAngle = function getEndAngle() {
    return this.endAngle;
  };
  _proto.setEndAngle = function setEndAngle(endAngle) {
    this.endAngle = endAngle;
    this.onShapeChanged();
    return this;
  };
  _proto._correctAngles = function _correctAngles() {
    var startAngle = this.getStartAngle(),
      endAngle = this.getEndAngle();
    if (endAngle < startAngle) {
      console.error('The ending angle should be greater than the starting angle ', startAngle, endAngle);
      return [0, 0];
    }
    var angle = 360;
    if (endAngle - startAngle > angle) {
      console.error('The difference between the end angle and the start angle is greater than 360 degrees ', startAngle, endAngle);
      return [0, 0];
    }
    if (startAngle < 0) {
      startAngle += angle;
      endAngle += angle;
    }
    return [startAngle, endAngle];
  };
  _proto.getShell = function getShell() {
    if (this.isRotated()) {
      return this.getRotatedShell();
    }
    return this._getShell();
  };
  _proto._getShell = function _getShell() {
    var [startAngle, endAngle] = this._correctAngles();
    var measurer = this._getMeasurer(),
      center = this.getCoordinates(),
      numberOfPoints = this.options['numberOfShellPoints'] - 2,
      radius = this.getRadius(),
      shell = [center.copy()],
      angle = endAngle - startAngle;
    var rad, dx, dy;
    for (var i = 0; i < numberOfPoints; i++) {
      rad = (angle * i / (numberOfPoints - 1) + startAngle) * Math.PI / 180;
      dx = radius * Math.cos(rad);
      dy = radius * Math.sin(rad);
      var vertex = measurer.locate(center, dx, dy);
      vertex.z = center.z;
      shell.push(vertex);
    }
    shell.push(center.copy());
    return shell;
  };
  _proto.getRotateOffsetAngle = function getRotateOffsetAngle() {
    return 90;
  };
  _proto._getPrjShell = function _getPrjShell() {
    var shell = _Circle.prototype._getPrjShell.call(this);
    return this._rotatePrjCoordinates(shell);
  };
  _proto._computePrjExtent = function _computePrjExtent() {
    if (this.isRotated()) {
      return this._computeRotatedPrjExtent();
    }
    return Circle.prototype._computePrjExtent.apply(this, arguments);
  };
  _proto._containsPoint = function _containsPoint(point, tolerance) {
    return Geometry.prototype._containsPoint.call(this, point, tolerance);
  };
  _proto._computeGeodesicLength = function _computeGeodesicLength() {
    if (isNil(this._radius)) {
      return 0;
    }
    var [startAngle, endAngle] = this._correctAngles();
    return Math.PI * 2 * this._radius * Math.abs(startAngle - endAngle) / 360 + 2 * this._radius;
  };
  _proto._computeGeodesicArea = function _computeGeodesicArea() {
    if (isNil(this._radius)) {
      return 0;
    }
    var [startAngle, endAngle] = this._correctAngles();
    return Math.PI * Math.pow(this._radius, 2) * Math.abs(startAngle - endAngle) / 360;
  };
  _proto._toJSON = function _toJSON(options) {
    var opts = extend$2({}, options);
    var center = this.getCenter();
    opts.geometry = false;
    var feature = this.toGeoJSON(opts);
    feature['geometry'] = {
      'type': 'Polygon'
    };
    return {
      'feature': feature,
      'subType': 'Sector',
      'coordinates': center.toArray(),
      'radius': this.getRadius(),
      'startAngle': this.getStartAngle(),
      'endAngle': this.getEndAngle()
    };
  };
  return Sector;
}(Circle);
Sector.mergeOptions(options$v);
Sector.registerJSONType('Sector');

var options$u = {
  'enableSimplify': false,
  'enableClip': false
};
var Curve = function (_LineString) {
  function Curve() {
    return _LineString.apply(this, arguments) || this;
  }
  _inheritsLoose(Curve, _LineString);
  var _proto = Curve.prototype;
  _proto._arc = function _arc(ctx, points, lineOpacity) {
    var arcDegree = this.options['arcDegree'];
    if (arcDegree === 0) {
      arcDegree = 1;
    }
    var degree = arcDegree * Math.PI / 180;
    for (var i = 1, l = points.length; i < l; i++) {
      Canvas._arcBetween(ctx, points[i - 1], points[i], degree);
      Canvas._stroke(ctx, lineOpacity);
    }
  };
  _proto._quadraticCurve = function _quadraticCurve(ctx, points) {
    if (points.length <= 2) {
      Canvas._path(ctx, points);
      return;
    }
    var i, l;
    for (i = 2, l = points.length; i < l; i += 2) {
      ctx.quadraticCurveTo(points[i - 1].x, points[i - 1].y, points[i].x, points[i].y);
    }
    i -= 1;
    if (i < l) {
      for (; i < l; i++) {
        ctx.lineTo(points[i].x, points[i].y);
      }
    }
  };
  _proto._bezierCurve = function _bezierCurve(ctx, points) {
    if (points.length <= 3) {
      Canvas._path(ctx, points);
      return;
    }
    var i, l;
    for (i = 1, l = points.length; i + 2 < l; i += 3) {
      ctx.bezierCurveTo(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y, points[i + 2].x, points[i + 2].y);
    }
    if (i < l) {
      for (; i < l; i++) {
        ctx.lineTo(points[i].x, points[i].y);
      }
    }
  };
  _proto._getCurveArrowPoints = function _getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, step) {
    var l = segments.length;
    var i;
    for (i = step; i < l; i += step) {
      var arrow = this._getArrowShape(segments[i - 1], segments[i], lineWidth, arrowStyle, tolerance);
      if (arrow) {
        arrows.push(arrow);
      }
    }
    i -= step;
    if (i < l - 1) {
      for (i += 1; i < l; i++) {
        var _arrow = this._getArrowShape(segments[i - 1], segments[i], lineWidth, arrowStyle, tolerance);
        if (_arrow) {
          arrows.push(_arrow);
        }
      }
    }
  };
  return Curve;
}(LineString);
Curve.mergeOptions(options$u);

var options$t = {
  'arcDegree': 90
};
var ArcCurve = function (_Curve) {
  function ArcCurve() {
    return _Curve.apply(this, arguments) || this;
  }
  _inheritsLoose(ArcCurve, _Curve);
  var _proto = ArcCurve.prototype;
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options),
      'subType': 'ArcCurve'
    };
  };
  _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
    ctx.beginPath();
    this._arc(ctx, points, lineOpacity);
    Canvas._stroke(ctx, lineOpacity);
    this._paintArrow(ctx, points, lineOpacity);
  };
  ArcCurve.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var arc = new ArcCurve(feature['geometry']['coordinates'], json['options']);
    arc.setProperties(feature['properties']);
    return arc;
  };
  return ArcCurve;
}(Curve);
ArcCurve.registerJSONType('ArcCurve');
ArcCurve.mergeOptions(options$t);

var CubicBezierCurve = function (_Curve) {
  function CubicBezierCurve() {
    return _Curve.apply(this, arguments) || this;
  }
  _inheritsLoose(CubicBezierCurve, _Curve);
  CubicBezierCurve.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var curve = new CubicBezierCurve(feature['geometry']['coordinates'], json['options']);
    curve.setProperties(feature['properties']);
    return curve;
  };
  var _proto = CubicBezierCurve.prototype;
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options),
      'subType': 'CubicBezierCurve'
    };
  };
  _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    this._bezierCurve(ctx, points);
    Canvas._stroke(ctx, lineOpacity);
    this._paintArrow(ctx, points, lineOpacity);
  };
  _proto._getArrowPoints = function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
    return this._getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, 3);
  };
  return CubicBezierCurve;
}(Curve);
CubicBezierCurve.registerJSONType('CubicBezierCurve');

var QuadBezierCurve = function (_Curve) {
  function QuadBezierCurve() {
    return _Curve.apply(this, arguments) || this;
  }
  _inheritsLoose(QuadBezierCurve, _Curve);
  QuadBezierCurve.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var curve = new QuadBezierCurve(feature['geometry']['coordinates'], json['options']);
    curve.setProperties(feature['properties']);
    return curve;
  };
  var _proto = QuadBezierCurve.prototype;
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options),
      'subType': 'QuadBezierCurve'
    };
  };
  _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    this._quadraticCurve(ctx, points, lineOpacity);
    Canvas._stroke(ctx, lineOpacity);
    this._paintArrow(ctx, points, lineOpacity);
  };
  _proto._getArrowPoints = function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
    return this._getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, 2);
  };
  return QuadBezierCurve;
}(Curve);
QuadBezierCurve.registerJSONType('QuadBezierCurve');

var defaultSymbol = {
  'textFaceName': 'monospace',
  'textSize': 12,
  'textLineSpacing': 8,
  'textWrapCharacter': '\n',
  'textHorizontalAlignment': 'middle',
  'textVerticalAlignment': 'middle'
};
var defaultBoxSymbol = {
  'markerType': 'square',
  'markerLineColor': '#000',
  'markerLineWidth': 2,
  'markerLineOpacity': 1,
  'markerFill': '#fff',
  'markerOpacity': 1
};
var TextMarker = function (_Marker) {
  function TextMarker() {
    return _Marker.apply(this, arguments) || this;
  }
  _inheritsLoose(TextMarker, _Marker);
  var _proto = TextMarker.prototype;
  _proto.getContent = function getContent() {
    return this._content;
  };
  _proto.setContent = function setContent(content) {
    var old = this._content;
    this._content = escapeSpecialChars(content);
    this._refresh();
    this._fireEvent('contentchange', {
      'old': old,
      'new': content
    });
    return this;
  };
  _proto.onAdd = function onAdd() {
    this._refresh();
  };
  _proto.toJSON = function toJSON() {
    var json = _Marker.prototype.toJSON.call(this);
    delete json['symbol'];
    return json;
  };
  _proto.setSymbol = function setSymbol(symbol) {
    if (this._refreshing || !symbol) {
      return _Marker.prototype.setSymbol.call(this, symbol);
    }
    var s = this._parseSymbol(symbol);
    if (this.setTextStyle) {
      var style = this.getTextStyle() || {};
      style.symbol = s[0];
      this.setTextStyle(style);
    } else if (this.setTextSymbol) {
      this.setTextSymbol(s[0]);
    }
    if (this.setBoxStyle) {
      var _style = this.getBoxStyle() || {};
      _style.symbol = s[1];
      this.setBoxStyle(_style);
    } else if (this.setBoxSymbol) {
      this.setBoxSymbol(s[1]);
    }
    return this;
  };
  _proto._parseSymbol = function _parseSymbol(symbol) {
    var t = {};
    var b = {};
    for (var p in symbol) {
      if (hasOwn(symbol, p)) {
        if (p.indexOf('text') === 0) {
          t[p] = symbol[p];
        } else {
          b[p] = symbol[p];
        }
      }
    }
    return [t, b];
  };
  _proto._getTextSize = function _getTextSize(symbol) {
    return splitTextToRow(this._content, symbol)['size'];
  };
  _proto._getInternalSymbol = function _getInternalSymbol() {
    return this._symbol;
  };
  _proto._getDefaultTextSymbol = function _getDefaultTextSymbol() {
    return extend$2({}, defaultSymbol);
  };
  _proto._getDefaultBoxSymbol = function _getDefaultBoxSymbol() {
    return extend$2({}, defaultBoxSymbol);
  };
  _proto._getDefaultPadding = function _getDefaultPadding() {
    return [12, 8];
  };
  return TextMarker;
}(Marker);

var options$s = {
  'textStyle': {
    'wrap': true,
    'padding': [12, 8],
    'verticalAlignment': 'middle',
    'horizontalAlignment': 'middle'
  },
  'boxSymbol': null
};
var TextBox = function (_TextMarker) {
  function TextBox(content, coordinates, width, height, options = {}) {
    var _this;
    _this = _TextMarker.call(this, coordinates, options) || this;
    _this._content = escapeSpecialChars(content);
    _this._width = isNil(width) ? 100 : width;
    _this._height = isNil(height) ? 40 : height;
    if (options.boxSymbol) {
      _this.setBoxSymbol(options.boxSymbol);
    }
    if (options.textStyle) {
      _this.setTextStyle(options.textStyle);
    }
    _this._refresh();
    return _this;
  }
  _inheritsLoose(TextBox, _TextMarker);
  var _proto = TextBox.prototype;
  _proto.getWidth = function getWidth() {
    return this._width;
  };
  _proto.setWidth = function setWidth(width) {
    this._width = width;
    this._refresh();
    return this;
  };
  _proto.getHeight = function getHeight() {
    return this._height;
  };
  _proto.setHeight = function setHeight(height) {
    this._height = height;
    this._refresh();
    return this;
  };
  _proto.getBoxSymbol = function getBoxSymbol() {
    return extend$2({}, this.options.boxSymbol);
  };
  _proto.setBoxSymbol = function setBoxSymbol(symbol) {
    this.options.boxSymbol = symbol ? extend$2({}, symbol) : symbol;
    if (this.getSymbol()) {
      this._refresh();
    }
    return this;
  };
  _proto.getTextStyle = function getTextStyle() {
    if (!this.options.textStyle) {
      return null;
    }
    return extend$2({}, this.options.textStyle);
  };
  _proto.setTextStyle = function setTextStyle(style) {
    this.options.textStyle = style ? extend$2({}, style) : style;
    if (this.getSymbol()) {
      this._refresh();
    }
    return this;
  };
  TextBox.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var textBox = new TextBox(json['content'], feature['geometry']['coordinates'], json['width'], json['height'], json['options']);
    textBox.setProperties(feature['properties']);
    textBox.setId(feature['id']);
    if (json['symbol']) {
      textBox.setSymbol(json['symbol']);
    }
    return textBox;
  };
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options),
      'width': this.getWidth(),
      'height': this.getHeight(),
      'subType': 'TextBox',
      'content': this._content
    };
  };
  _proto._refresh = function _refresh() {
    var textStyle = this.getTextStyle() || {},
      padding = textStyle['padding'] || [12, 8];
    var maxWidth, maxHeight;
    if (isFunctionDefinition(this._width)) {
      maxWidth = JSON.parse(JSON.stringify(this._width));
      var stops = maxWidth.stops;
      if (stops) {
        for (var i = 0; i < stops.length; i++) {
          stops[i][1] = stops[i][1] - 2 * padding[0];
        }
      }
    } else {
      maxWidth = this._width - 2 * padding[0];
    }
    if (isFunctionDefinition(this._height)) {
      maxHeight = JSON.parse(JSON.stringify(this._height));
      var _stops = maxHeight.stops;
      if (_stops) {
        for (var _i = 0; _i < _stops.length; _i++) {
          _stops[_i][1] = _stops[_i][1] - 2 * padding[1];
        }
      }
    } else {
      maxHeight = this._height - 2 * padding[1];
    }
    var symbol = extend$2({}, textStyle.symbol || this._getDefaultTextSymbol(), this.options.boxSymbol || this._getDefaultBoxSymbol(), {
      'textName': this._content,
      'markerWidth': this._width,
      'markerHeight': this._height,
      'textHorizontalAlignment': 'middle',
      'textVerticalAlignment': 'middle',
      'textMaxWidth': maxWidth,
      'textMaxHeight': maxHeight
    });
    if (textStyle['wrap'] && !symbol['textWrapWidth']) {
      symbol['textWrapWidth'] = maxWidth;
    }
    var hAlign = textStyle['horizontalAlignment'];
    symbol['textDx'] = symbol['markerDx'] || 0;
    var offsetX;
    if (isFunctionDefinition(this._width)) {
      offsetX = JSON.parse(JSON.stringify(this._width));
      var _stops2 = offsetX.stops;
      if (_stops2) {
        for (var _i2 = 0; _i2 < _stops2.length; _i2++) {
          _stops2[_i2][1] = _stops2[_i2][1] / 2 - padding[0];
          if (hAlign === 'left') {
            _stops2[_i2][1] *= -1;
          }
        }
      }
    } else {
      offsetX = symbol['markerWidth'] / 2 - padding[0];
      if (hAlign === 'left') {
        offsetX *= -1;
      }
    }
    if (hAlign === 'left') {
      symbol['textHorizontalAlignment'] = 'right';
      symbol['textDx'] = offsetX;
    } else if (hAlign === 'right') {
      symbol['textHorizontalAlignment'] = 'left';
      symbol['textDx'] = offsetX;
    }
    var vAlign = textStyle['verticalAlignment'];
    symbol['textDy'] = symbol['markerDy'] || 0;
    var offsetY;
    if (isFunctionDefinition(this._height)) {
      offsetY = JSON.parse(JSON.stringify(this._height));
      var _stops3 = offsetY.stops;
      if (_stops3) {
        for (var _i3 = 0; _i3 < _stops3.length; _i3++) {
          _stops3[_i3][1] = _stops3[_i3][1] / 2 - padding[1];
          if (vAlign === 'top') {
            _stops3[_i3][1] *= -1;
          }
        }
      }
    } else {
      offsetY = symbol['markerHeight'] / 2 - padding[1];
      if (vAlign === 'top') {
        offsetY *= -1;
      }
    }
    if (vAlign === 'top') {
      symbol['textVerticalAlignment'] = 'bottom';
      symbol['textDy'] = offsetY;
    } else if (vAlign === 'bottom') {
      symbol['textVerticalAlignment'] = 'top';
      symbol['textDy'] = offsetY;
    }
    this._refreshing = true;
    this.updateSymbol(symbol);
    delete this._refreshing;
  };
  _proto.startEdit = function startEdit(opts) {
    var symbol = this._getCompiledSymbol();
    if (isFunctionDefinition(this._width)) {
      var markerWidth = symbol['markerWidth'];
      this._oldWidth = this._width;
      this.setWidth(markerWidth);
    }
    if (isFunctionDefinition(this._height)) {
      var markerHeight = symbol['markerHeight'];
      this._oldHeight = this._height;
      this.setHeight(markerHeight);
    }
    return _TextMarker.prototype.startEdit.call(this, opts);
  };
  _proto.endEdit = function endEdit() {
    var map = this.getMap();
    var zoom = map && map.getZoom();
    if (this._oldWidth) {
      var markerWidth = this._width;
      var widthFn = interpolated(this._oldWidth);
      var oldExpectedWidth = widthFn(zoom);
      var scale = markerWidth / oldExpectedWidth;
      var stops = this._oldWidth.stops;
      for (var i = 0; i < stops.length; i++) {
        stops[i][1] *= scale;
      }
      this.setWidth(this._oldWidth);
      delete this._oldWidth;
    }
    if (this._oldHeight) {
      var markerHeight = this._height;
      var heightFn = interpolated(this._oldHeight);
      var oldExpectedHeight = heightFn(zoom);
      var _scale = markerHeight / oldExpectedHeight;
      var _stops4 = this._oldHeight.stops;
      for (var _i4 = 0; _i4 < _stops4.length; _i4++) {
        _stops4[_i4][1] *= _scale;
      }
      this.setHeight(this._oldHeight);
      delete this._oldHeight;
    }
    return _TextMarker.prototype.endEdit.call(this);
  };
  return TextBox;
}(TextMarker);
TextBox.mergeOptions(options$s);
TextBox.registerJSONType('TextBox');

var options$r = {
  'boxStyle': null,
  textSymbol: null
};
var Label = function (_TextMarker) {
  function Label(content, coordinates, options = {}) {
    var _this;
    _this = _TextMarker.call(this, coordinates, options) || this;
    _this._content = escapeSpecialChars(content);
    if (options.textSymbol) {
      _this.setTextSymbol(options.textSymbol);
    }
    if (options.boxStyle) {
      _this.setBoxStyle(options.boxStyle);
    }
    _this._refresh();
    return _this;
  }
  _inheritsLoose(Label, _TextMarker);
  var _proto = Label.prototype;
  _proto.getBoxStyle = function getBoxStyle() {
    if (!this.options.boxStyle) {
      return null;
    }
    return extend$2({}, this.options.boxStyle);
  };
  _proto.setBoxStyle = function setBoxStyle(style) {
    this.options.boxStyle = style ? extend$2({}, style) : style;
    this._refresh();
    return this;
  };
  _proto.getTextSymbol = function getTextSymbol() {
    return extend$2({}, this._getDefaultTextSymbol(), this.options.textSymbol);
  };
  _proto.setTextSymbol = function setTextSymbol(symbol) {
    this.options.textSymbol = symbol ? extend$2({}, symbol) : symbol;
    this._refresh();
    return this;
  };
  Label.fromJSON = function fromJSON(json) {
    var feature = json['feature'];
    var label = new Label(json['content'], feature['geometry']['coordinates'], json['options']);
    label.setProperties(feature['properties']);
    label.setId(feature['id']);
    if (json['symbol']) {
      label.setSymbol(json['symbol']);
    }
    return label;
  };
  _proto._canEdit = function _canEdit() {
    return false;
  };
  _proto._toJSON = function _toJSON(options) {
    return {
      'feature': this.toGeoJSON(options),
      'subType': 'Label',
      'content': this._content
    };
  };
  _proto._refresh = function _refresh() {
    var symbol = extend$2({}, this.getTextSymbol(), {
      'textName': this._content
    });
    var boxStyle = this.getBoxStyle();
    if (boxStyle) {
      extend$2(symbol, boxStyle.symbol);
      var sizes = this._getBoxSize(symbol),
        textSize = sizes[1],
        padding = boxStyle['padding'] || this._getDefaultPadding();
      var boxSize = sizes[0];
      symbol['markerWidth'] = boxSize['width'];
      symbol['markerHeight'] = boxSize['height'];
      var dx = symbol['textDx'] || 0,
        dy = symbol['textDy'] || 0,
        textAlignPoint = getAlignPoint(textSize, symbol['textHorizontalAlignment'], symbol['textVerticalAlignment'])._add(dx, dy);
      var hAlign = boxStyle['horizontalAlignment'] || 'middle';
      symbol['markerDx'] = textAlignPoint.x;
      if (hAlign === 'left') {
        symbol['markerDx'] += symbol['markerWidth'] / 2 - padding[0];
      } else if (hAlign === 'right') {
        symbol['markerDx'] -= symbol['markerWidth'] / 2 - textSize['width'] - padding[0];
      } else {
        symbol['markerDx'] += textSize['width'] / 2;
      }
      var vAlign = boxStyle['verticalAlignment'] || 'middle';
      symbol['markerDy'] = textAlignPoint.y;
      if (vAlign === 'top') {
        symbol['markerDy'] += symbol['markerHeight'] / 2 - padding[1];
      } else if (vAlign === 'bottom') {
        symbol['markerDy'] -= symbol['markerHeight'] / 2 - textSize['height'] - padding[1];
      } else {
        symbol['markerDy'] += textSize['height'] / 2;
      }
    }
    this._refreshing = true;
    this.updateSymbol(symbol);
    delete this._refreshing;
  };
  _proto._getBoxSize = function _getBoxSize(symbol) {
    if (!symbol['markerType']) {
      symbol['markerType'] = 'square';
    }
    var boxStyle = this.getBoxStyle();
    var size = this._getTextSize(symbol);
    var width, height;
    var padding = boxStyle['padding'] || this._getDefaultPadding();
    width = size['width'] + padding[0] * 2;
    height = size['height'] + padding[1] * 2;
    if (boxStyle['minWidth']) {
      if (!width || width < boxStyle['minWidth']) {
        width = boxStyle['minWidth'];
      }
    }
    if (boxStyle['minHeight']) {
      if (!height || height < boxStyle['minHeight']) {
        height = boxStyle['minHeight'];
      }
    }
    return [new Size(width, height), size];
  };
  return Label;
}(TextMarker);
Label.mergeOptions(options$r);
Label.registerJSONType('Label');

var Connectable = function Connectable(Base) {
  return function (_Base) {
    function _class(...args) {
      return _Base.call(this, ...args) || this;
    }
    _inheritsLoose(_class, _Base);
    _class._hasConnectors = function _hasConnectors(geometry) {
      return !isNil(geometry.__connectors) && geometry.__connectors.length > 0;
    };
    _class._getConnectors = function _getConnectors(geometry) {
      return geometry.__connectors;
    };
    var _proto = _class.prototype;
    _proto.getConnectSource = function getConnectSource() {
      return this._connSource;
    };
    _proto.setConnectSource = function setConnectSource(src) {
      var target = this._connTarget;
      this.onRemove();
      this._connSource = src;
      this._connTarget = target;
      this.onAdd();
      return this;
    };
    _proto.getConnectTarget = function getConnectTarget() {
      return this._connTarget;
    };
    _proto.setConnectTarget = function setConnectTarget(target) {
      var src = this._connSource;
      this.onRemove();
      this._connSource = src;
      this._connTarget = target;
      this._updateCoordinates();
      this._registerEvents();
      return this;
    };
    _proto._updateCoordinates = function _updateCoordinates() {
      var map = this.getMap();
      if (!map && this._connSource) {
        map = this._connSource.getMap();
      }
      if (!map && this._connTarget) {
        map = this._connTarget.getMap();
      }
      if (!map) {
        return;
      }
      if (!this._connSource || !this._connTarget) {
        return;
      }
      var srcPoints = this._connSource._getConnectPoints();
      var targetPoints = this._connTarget._getConnectPoints();
      var minDist = 0;
      var oldCoordinates = this.getCoordinates();
      var c1, c2;
      for (var i = 0, len = srcPoints.length; i < len; i++) {
        var p1 = srcPoints[i];
        for (var j = 0, length = targetPoints.length; j < length; j++) {
          var p2 = targetPoints[j];
          var dist = map.computeLength(p1, p2);
          if (i === 0 && j === 0) {
            c1 = p1;
            c2 = p2;
            minDist = dist;
          } else if (dist < minDist) {
            c1 = p1;
            c2 = p2;
          }
        }
      }
      if (!isArrayHasData(oldCoordinates) || !oldCoordinates[0].equals(c1) || !oldCoordinates[1].equals(c2)) {
        this.setCoordinates([c1, c2]);
      }
    };
    _proto.onAdd = function onAdd() {
      this._registerEvents();
      this._updateCoordinates();
    };
    _proto.onRemove = function onRemove() {
      if (this._connSource) {
        if (this._connSource.__connectors) {
          removeFromArray(this, this._connSource.__connectors);
        }
        this._connSource.off('dragging positionchange', this._updateCoordinates, this).off('remove', this.onRemove, this);
        this._connSource.off('dragstart mousedown mouseover', this._showConnect, this);
        this._connSource.off('dragend mouseup mouseout', this.hide, this);
        this._connSource.off('show', this._showConnect, this).off('hide', this.hide, this);
        delete this._connSource;
      }
      if (this._connTarget) {
        removeFromArray(this, this._connTarget.__connectors);
        this._connTarget.off('dragging positionchange', this._updateCoordinates, this).off('remove', this.onRemove, this);
        this._connTarget.off('show', this._showConnect, this).off('hide', this.hide, this);
        delete this._connTarget;
      }
      if (!(this._connSource instanceof Geometry) || !(this._connTarget instanceof Geometry)) {
        var map = this.getMap();
        if (map) {
          map.off('movestart moving moveend zoomstart zooming zoomend rotate pitch fovchange spatialreferencechange', this._updateCoordinates, this);
        }
      }
    };
    _proto._showConnect = function _showConnect() {
      if (!this._connSource || !this._connTarget) {
        return;
      }
      if (this._connSource.isVisible() && this._connTarget.isVisible()) {
        this._updateCoordinates();
        this.show();
      }
    };
    _proto._registerEvents = function _registerEvents() {
      if (!this._connSource || !this._connTarget) {
        return;
      }
      if (!this._connSource.__connectors) {
        this._connSource.__connectors = [];
      }
      if (!this._connTarget.__connectors) {
        this._connTarget.__connectors = [];
      }
      this._connSource.__connectors.push(this);
      this._connTarget.__connectors.push(this);
      this._connSource.on('dragging positionchange', this._updateCoordinates, this).on('remove', this.remove, this);
      this._connTarget.on('dragging positionchange', this._updateCoordinates, this).on('remove', this.remove, this);
      this._connSource.on('show', this._showConnect, this).on('hide', this.hide, this);
      this._connTarget.on('show', this._showConnect, this).on('hide', this.hide, this);
      var trigger = this.options['showOn'];
      this.hide();
      if (trigger === 'moving') {
        this._connSource.on('dragstart', this._showConnect, this).on('dragend', this.hide, this);
        this._connTarget.on('dragstart', this._showConnect, this).on('dragend', this.hide, this);
      } else if (trigger === 'click') {
        this._connSource.on('mousedown', this._showConnect, this).on('mouseup', this.hide, this);
        this._connTarget.on('mousedown', this._showConnect, this).on('mouseup', this.hide, this);
      } else if (trigger === 'mouseover') {
        this._connSource.on('mouseover', this._showConnect, this).on('mouseout', this.hide, this);
        this._connTarget.on('mouseover', this._showConnect, this).on('mouseout', this.hide, this);
      } else {
        this._showConnect();
      }
      if (!(this._connSource instanceof Geometry) || !(this._connTarget instanceof Geometry)) {
        var map = this.getMap();
        if (map) {
          map.on('movestart moving moveend zoomstart zooming zoomend rotate pitch fovchange spatialreferencechange', this._updateCoordinates, this);
        }
      }
    };
    return _class;
  }(Base);
};
var options$q = {
  showOn: 'always'
};
var ConnectorLine = function (_Connectable) {
  function ConnectorLine(src, target, options) {
    var _this;
    _this = _Connectable.call(this, null, options) || this;
    if (arguments.length === 1) {
      options = src;
      src = null;
      target = null;
    }
    _this._connSource = src;
    _this._connTarget = target;
    return _this;
  }
  _inheritsLoose(ConnectorLine, _Connectable);
  return ConnectorLine;
}(Connectable(LineString));
ConnectorLine.mergeOptions(options$q);
ConnectorLine.registerJSONType('ConnectorLine');
var ArcConnectorLine = function (_Connectable2) {
  function ArcConnectorLine(src, target, options) {
    var _this2;
    _this2 = _Connectable2.call(this, null, options) || this;
    if (arguments.length === 1) {
      options = src;
      src = null;
      target = null;
    }
    _this2._connSource = src;
    _this2._connTarget = target;
    return _this2;
  }
  _inheritsLoose(ArcConnectorLine, _Connectable2);
  return ArcConnectorLine;
}(Connectable(ArcCurve));
ArcConnectorLine.mergeOptions(options$q);
ArcConnectorLine.registerJSONType('ArcConnectorLine');

function isGeometry(geo) {
  return geo && geo instanceof Geometry;
}
var options$p = {
  'drawImmediate': false,
  'geometryEvents': true,
  'geometryEventTolerance': 1
};
var TMP_EVENTS_ARR = [];
var OverlayLayer = function (_Layer) {
  function OverlayLayer(id, geometries, options) {
    var _this;
    if (geometries && !isGeometry(geometries) && !Array.isArray(geometries) && GEOJSON_TYPES.indexOf(geometries.type) < 0) {
      options = geometries;
      geometries = null;
    }
    _this = _Layer.call(this, id, options) || this;
    _this._maxZIndex = 0;
    _this._minZIndex = 0;
    _this._initCache();
    if (geometries) {
      _this.addGeometry(geometries);
    }
    var style = _this.options['style'];
    if (style) {
      _this.setStyle(style);
    }
    return _this;
  }
  _inheritsLoose(OverlayLayer, _Layer);
  var _proto = OverlayLayer.prototype;
  _proto.getAltitude = function getAltitude() {
    return 0;
  };
  _proto.getGeometryById = function getGeometryById(id) {
    if (isNil(id) || id === '') {
      return null;
    }
    if (!this._geoMap[id]) {
      return null;
    }
    return this._geoMap[id];
  };
  _proto.getGeometries = function getGeometries(filter, context) {
    if (!filter) {
      return this._geoList.slice(0);
    }
    var result = [];
    var geometry, filtered;
    for (var i = 0, l = this._geoList.length; i < l; i++) {
      geometry = this._geoList[i];
      if (context) {
        filtered = filter.call(context, geometry);
      } else {
        filtered = filter(geometry);
      }
      if (filtered) {
        result.push(geometry);
      }
    }
    return result;
  };
  _proto.getFirstGeometry = function getFirstGeometry() {
    if (!this._geoList.length) {
      return null;
    }
    return this._geoList[0];
  };
  _proto.getLastGeometry = function getLastGeometry() {
    var len = this._geoList.length;
    if (len === 0) {
      return null;
    }
    return this._geoList[len - 1];
  };
  _proto.getCount = function getCount() {
    return this._geoList.length;
  };
  _proto.getExtent = function getExtent() {
    if (this.getCount() === 0) {
      return null;
    }
    var extent = new Extent(this.getProjection());
    this.forEach(function (g) {
      var geoExtent = g.getExtent();
      extent._combine(geoExtent);
      combineExtentAltitude(extent, geoExtent);
    });
    return extent;
  };
  _proto.forEach = function forEach(fn, context) {
    var copyOnWrite = this._geoList.slice(0);
    for (var i = 0, l = copyOnWrite.length; i < l; i++) {
      if (!context) {
        fn(copyOnWrite[i], i);
      } else {
        fn.call(context, copyOnWrite[i], i);
      }
    }
    return this;
  };
  _proto.filter = function filter(fn, context) {
    var selected = [];
    var isFn = isFunction(fn);
    var filter = isFn ? fn : createFilter(fn);
    this.forEach(function (geometry) {
      var g = isFn ? geometry : getFilterFeature(geometry);
      if (context ? filter.call(context, g) : filter(g)) {
        selected.push(geometry);
      }
    }, this);
    return selected;
  };
  _proto.isEmpty = function isEmpty() {
    return !this._geoList.length;
  };
  _proto.addGeometry = function addGeometry(geometries, fitView) {
    if (!geometries) {
      return this;
    }
    if (geometries.type === 'FeatureCollection') {
      return this.addGeometry(GeoJSON.toGeometry(geometries), fitView);
    } else if (!Array.isArray(geometries)) {
      var count = arguments.length;
      var last = arguments[count - 1];
      geometries = Array.prototype.slice.call(arguments, 0, count - 1);
      fitView = last;
      if (last && isObject$1(last) && ('type' in last || isGeometry(last))) {
        geometries.push(last);
        fitView = false;
      }
      return this.addGeometry(geometries, fitView);
    } else if (geometries.length === 0) {
      return this;
    }
    this._initCache();
    var extent;
    if (fitView) {
      extent = new Extent();
    }
    this._toSort = this._maxZIndex > 0;
    var geos = [];
    for (var i = 0, l = geometries.length; i < l; i++) {
      var geo = geometries[i];
      if (!(geo && (GeoJSON._isGeoJSON(geo) || isGeometry(geo)))) {
        throw new Error('Invalid geometry to add to layer(' + this.getId() + ') at index:' + i);
      }
      if (geo.getLayer && geo.getLayer() === this) {
        continue;
      }
      if (!isGeometry(geo)) {
        geo = Geometry.fromJSON(geo);
        if (Array.isArray(geo)) {
          for (var ii = 0, ll = geo.length; ii < ll; ii++) {
            this._add(geo[ii], extent, i);
            geos.push(geo[ii]);
          }
        }
      }
      if (!geo) {
        throw new Error('Invalid geometry to add to layer(' + this.getId() + ') at index:' + i);
      }
      if (!Array.isArray(geo)) {
        this._add(geo, extent, i);
        geos.push(geo);
      }
    }
    var map = this.getMap();
    if (map) {
      this._getRenderer().onGeometryAdd(geos);
      if (extent && !isNil(extent.xmin)) {
        var center = extent.getCenter();
        var z = map.getFitZoom(extent);
        if (isObject$1(fitView)) {
          var step = isFunction(fitView.step) ? fitView.step : function () {
            return undefined;
          };
          map.animateTo({
            center: center,
            zoom: z
          }, extend$2({
            duration: map.options.zoomAnimationDuration,
            easing: 'out'
          }, fitView), step);
        } else if (fitView === true) {
          map.setCenterAndZoom(center, z);
        }
      }
    }
    this.fire('addgeo', {
      'type': 'addgeo',
      'target': this,
      'geometries': geometries
    });
    return this;
  };
  _proto.getGeoMinZIndex = function getGeoMinZIndex() {
    return this._minZIndex;
  };
  _proto.getGeoMaxZIndex = function getGeoMaxZIndex() {
    return this._maxZIndex;
  };
  _proto._add = function _add(geo, extent, i) {
    if (!this._toSort) {
      this._toSort = geo.getZIndex() !== 0;
    }
    this._updateZIndex(geo.getZIndex());
    var geoId = geo.getId();
    if (!isNil(geoId)) {
      if (!isNil(this._geoMap[geoId])) {
        throw new Error('Duplicate geometry id in layer(' + this.getId() + '):' + geoId + ', at index:' + i);
      }
      this._geoMap[geoId] = geo;
    }
    var internalId = UID();
    geo._setInternalId(internalId);
    this._geoList.push(geo);
    this.onAddGeometry(geo);
    geo._bindLayer(this);
    if (geo.onAdd) {
      geo.onAdd();
    }
    if (extent) {
      var geoExtent = geo.getExtent();
      extent._combine(geoExtent);
      combineExtentAltitude(extent, geoExtent);
    }
    geo._fireEvent('add', {
      'layer': this
    });
    if (this._cookedStyles) {
      this._styleGeometry(geo);
    }
  };
  _proto.removeGeometry = function removeGeometry(geometries) {
    if (!Array.isArray(geometries)) {
      return this.removeGeometry([geometries]);
    }
    for (var i = geometries.length - 1; i >= 0; i--) {
      if (!(geometries[i] instanceof Geometry)) {
        geometries[i] = this.getGeometryById(geometries[i]);
      }
      if (!geometries[i] || this !== geometries[i].getLayer()) continue;
      geometries[i].remove();
    }
    return this;
  };
  _proto.clear = function clear() {
    this._clearing = true;
    this.forEach(function (geo) {
      geo.remove();
    });
    this._geoMap = {};
    var old = this._geoList;
    this._geoList = [];
    var renderer = this._getRenderer();
    if (renderer) {
      renderer.onGeometryRemove(old);
      if (renderer.clearImageData) {
        renderer.clearImageData();
        delete renderer._lastGeosToDraw;
      }
    }
    this._clearing = false;
    this.fire('clear');
    return this;
  };
  _proto.onRemoveGeometry = function onRemoveGeometry(geometry) {
    if (!geometry || this._clearing) {
      return;
    }
    if (this !== geometry.getLayer()) {
      return;
    }
    var internalId = geometry._getInternalId();
    if (isNil(internalId)) {
      return;
    }
    var geoId = geometry.getId();
    if (!isNil(geoId)) {
      delete this._geoMap[geoId];
    }
    var idx = this._findInList(geometry);
    if (idx >= 0) {
      this._geoList.splice(idx, 1);
    }
    if (this._getRenderer()) {
      this._getRenderer().onGeometryRemove([geometry]);
    }
  };
  _proto.getStyle = function getStyle() {
    if (!this.options['style']) {
      return null;
    }
    return this.options['style'];
  };
  _proto.setStyle = function setStyle(style) {
    this.options.style = style;
    style = parseStyleRootPath(style);
    this._cookedStyles = compileStyle(style);
    this.forEach(function (geometry) {
      this._styleGeometry(geometry);
    }, this);
    this.fire('setstyle', {
      'type': 'setstyle',
      'target': this,
      'style': style
    });
    return this;
  };
  _proto._styleGeometry = function _styleGeometry(geometry) {
    if (!this._cookedStyles) {
      return false;
    }
    var g = getFilterFeature(geometry);
    for (var i = 0, len = this._cookedStyles.length; i < len; i++) {
      if (this._cookedStyles[i]['filter'](g) === true) {
        geometry._setExternSymbol(this._cookedStyles[i]['symbol']);
        return true;
      }
    }
    return false;
  };
  _proto.removeStyle = function removeStyle() {
    if (!this.options.style) {
      return this;
    }
    delete this.options.style;
    delete this._cookedStyles;
    this.forEach(function (geometry) {
      geometry._setExternSymbol(null);
    }, this);
    this.fire('removestyle');
    return this;
  };
  _proto.onAddGeometry = function onAddGeometry(geo) {
    var style = this.getStyle();
    if (style) {
      this._styleGeometry(geo);
    }
  };
  _proto.hide = function hide() {
    for (var i = 0, l = this._geoList.length; i < l; i++) {
      this._geoList[i].onHide();
    }
    return Layer.prototype.hide.call(this);
  };
  _proto._initCache = function _initCache() {
    if (!this._geoList) {
      this._geoList = [];
      this._geoMap = {};
    }
  };
  _proto._updateZIndex = function _updateZIndex(...zIndex) {
    this._maxZIndex = Math.max(this._maxZIndex, Math.max(...zIndex));
    this._minZIndex = Math.min(this._minZIndex, Math.min(...zIndex));
  };
  _proto._sortGeometries = function _sortGeometries() {
    var _this2 = this;
    if (!this._toSort) {
      return;
    }
    this._maxZIndex = 0;
    this._minZIndex = 0;
    this._geoList.sort(function (a, b) {
      _this2._updateZIndex(a.getZIndex(), b.getZIndex());
      return _this2._compare(a, b);
    });
    this._toSort = false;
  };
  _proto._compare = function _compare(a, b) {
    if (a.getZIndex() === b.getZIndex()) {
      return a._getInternalId() - b._getInternalId();
    }
    return a.getZIndex() - b.getZIndex();
  };
  _proto._findInList = function _findInList(geo) {
    var len = this._geoList.length;
    if (len === 0) {
      return -1;
    }
    this._sortGeometries();
    var low = 0,
      high = len - 1,
      middle;
    while (low <= high) {
      middle = Math.floor((low + high) / 2);
      if (this._geoList[middle] === geo) {
        return middle;
      } else if (this._compare(this._geoList[middle], geo) > 0) {
        high = middle - 1;
      } else {
        low = middle + 1;
      }
    }
    return -1;
  };
  _proto.onGeometryEvent = function onGeometryEvent(param) {
    return this._onGeometryEvent(param);
  };
  _proto._onGeometryEvent = function _onGeometryEvent(param) {
    if (!param || !param['target']) {
      return;
    }
    var type = param['type'];
    if (type === 'idchange') {
      this._onGeometryIdChange(param);
    } else if (type === 'zindexchange') {
      this._onGeometryZIndexChange(param);
    } else if (type === 'positionchange') {
      this._onGeometryPositionChange(param);
    } else if (type === 'shapechange') {
      this._onGeometryShapeChange(param);
    } else if (type === 'symbolchange') {
      this._onGeometrySymbolChange(param);
    } else if (type === 'show') {
      this._onGeometryShow(param);
    } else if (type === 'hide') {
      this._onGeometryHide(param);
    } else if (type === 'propertieschange') {
      this._onGeometryPropertiesChange(param);
    }
  };
  _proto._onGeometryIdChange = function _onGeometryIdChange(param) {
    if (param['new'] === param['old']) {
      if (this._geoMap[param['old']] && this._geoMap[param['old']] === param['target']) {
        return;
      }
    }
    if (!isNil(param['new'])) {
      if (this._geoMap[param['new']]) {
        throw new Error('Duplicate geometry id in layer(' + this.getId() + '):' + param['new']);
      }
      this._geoMap[param['new']] = param['target'];
    }
    if (!isNil(param['old']) && param['new'] !== param['old']) {
      delete this._geoMap[param['old']];
    }
  };
  _proto._onGeometryZIndexChange = function _onGeometryZIndexChange(param) {
    if (param['old'] !== param['new']) {
      this._updateZIndex(param['new']);
      this._toSort = true;
      if (this._getRenderer()) {
        this._getRenderer().onGeometryZIndexChange(param);
      }
    }
  };
  _proto._onGeometryPositionChange = function _onGeometryPositionChange(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometryPositionChange(param);
    }
  };
  _proto._onGeometryShapeChange = function _onGeometryShapeChange(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometryShapeChange(param);
    }
  };
  _proto._onGeometrySymbolChange = function _onGeometrySymbolChange(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometrySymbolChange(param);
    }
  };
  _proto._onGeometryShow = function _onGeometryShow(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometryShow(param);
    }
  };
  _proto._onGeometryHide = function _onGeometryHide(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometryHide(param);
    }
  };
  _proto._onGeometryPropertiesChange = function _onGeometryPropertiesChange(param) {
    if (this._getRenderer()) {
      this._getRenderer().onGeometryPropertiesChange(param);
    }
  };
  _proto._hasGeoListeners = function _hasGeoListeners(eventTypes) {
    if (!eventTypes) {
      return false;
    }
    if (!Array.isArray(eventTypes)) {
      TMP_EVENTS_ARR[0] = eventTypes;
      eventTypes = TMP_EVENTS_ARR;
    }
    var geos = this.getGeometries() || [];
    for (var i = 0, len = geos.length; i < len; i++) {
      var geometry = geos[i];
      if (!geometry) {
        continue;
      }
      if (geometry.options.cursor) {
        return true;
      }
      for (var j = 0, len1 = eventTypes.length; j < len1; j++) {
        var eventType = eventTypes[j];
        var listens = geometry.listens(eventType);
        if (listens > 0) {
          return true;
        }
      }
    }
    return false;
  };
  _proto._getRenderer = function _getRenderer() {
    return _Layer.prototype._getRenderer.call(this);
  };
  return OverlayLayer;
}(Layer);
OverlayLayer.mergeOptions(options$p);

var options$o = {
  renderer: null
};
var DrawToolLayer = function (_OverlayLayer) {
  function DrawToolLayer(id, geometries, options = {}) {
    var _this;
    if (geometries && !isGeometry(geometries) && !Array.isArray(geometries) && GEOJSON_TYPES.indexOf(geometries.type) < 0) {
      options = geometries;
      geometries = null;
    }
    _this = _OverlayLayer.call(this, id, options) || this;
    var depthFunc = _this.options.depthFunc || 'always';
    options.sceneConfig = {
      depthFunc: depthFunc
    };
    _this._markerLayer = new DrawToolLayer.markerLayerClazz(id + '_____________marker', options);
    _this._lineLayer = new DrawToolLayer.lineLayerClazz(id + '_____________line', options);
    _this._polygonLayer = new DrawToolLayer.polygonLayerClazz(id + '_____________polygon', options);
    if (geometries) {
      _this.addGeometry(geometries);
    }
    _this.hide();
    return _this;
  }
  _inheritsLoose(DrawToolLayer, _OverlayLayer);
  DrawToolLayer.setLayerClass = function setLayerClass(markerLayerClass, lineLayerClass, polygonLayerClass) {
    DrawToolLayer.markerLayerClazz = markerLayerClass;
    DrawToolLayer.lineLayerClazz = lineLayerClass;
    DrawToolLayer.polygonLayerClazz = polygonLayerClass;
  };
  var _proto = DrawToolLayer.prototype;
  _proto.clear = function clear() {
    _OverlayLayer.prototype.clear.call(this);
    this._markerLayer.clear();
    this._lineLayer.clear();
    this._polygonLayer.clear();
    return this;
  };
  _proto.bringToFront = function bringToFront() {
    this._polygonLayer.bringToFront();
    this._lineLayer.bringToFront();
    this._markerLayer.bringToFront();
    return this;
  };
  _proto.addGeometry = function addGeometry(geometries) {
    if (!Array.isArray(geometries)) {
      geometries = [geometries];
    }
    pushIn(this._geoList, geometries);
    for (var i = 0; i < geometries.length; i++) {
      if (this._markerLayer.isVectorLayer) {
        this._markerLayer.addGeometry(geometries[i]);
        continue;
      }
      if (geometries[i] instanceof Marker || geometries[i] instanceof MultiPoint) {
        this._markerLayer.addGeometry(geometries[i]);
      } else if (geometries[i] instanceof LineString || geometries[i] instanceof MultiLineString) {
        this._lineLayer.addGeometry(geometries[i]);
      } else if (geometries[i] instanceof Polygon || geometries[i] instanceof MultiPolygon) {
        this._polygonLayer.addGeometry(geometries[i]);
      }
    }
  };
  _proto.getGeometryById = function getGeometryById(id) {
    if (isNil(id) || id === '') {
      return null;
    }
    return this._markerLayer.getGeometryById(id) || this._lineLayer.getGeometryById(id) || this._polygonLayer.getGeometryById(id);
  };
  _proto.removeGeometry = function removeGeometry(geometries) {
    if (!Array.isArray(geometries)) {
      geometries = [geometries];
    }
    for (var i = 0; i < geometries.length; i++) {
      var idx = this._findInList(geometries[i]);
      if (idx >= 0) {
        this._geoList.splice(idx, 1);
      }
      if (this._markerLayer.isVectorLayer) {
        this._markerLayer.removeGeometry(geometries[i]);
        continue;
      }
      if (geometries[i] instanceof Marker || geometries[i] instanceof MultiPoint) {
        this._markerLayer.removeGeometry(geometries[i]);
      } else if (geometries[i] instanceof LineString || geometries[i] instanceof MultiLineString) {
        this._lineLayer.removeGeometry(geometries[i]);
      } else if (geometries[i] instanceof Polygon || geometries[i] instanceof MultiPolygon) {
        this._polygonLayer.removeGeometry(geometries[i]);
      }
    }
  };
  _proto._onRemoveDrawToolGeo = function _onRemoveDrawToolGeo(params) {
    var geometries = params.geometries;
    for (var i = 0; i < geometries.length; i++) {
      if (geometries[i]) {
        var idx = this._findInList(geometries[i]);
        if (idx >= 0) {
          this._geoList.splice(idx, 1);
        }
      }
    }
  };
  _proto.onRemove = function onRemove() {
    this._geoList = [];
    this._markerLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
    this._lineLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
    this._polygonLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
    this._markerLayer.remove();
    this._lineLayer.remove();
    this._polygonLayer.remove();
    delete this._markerLayer;
    delete this._lineLayer;
    delete this._polygonLayer;
    return _OverlayLayer.prototype.onRemove.call(this);
  };
  _proto.onAdd = function onAdd() {
    var map = this.getMap();
    this._polygonLayer.addTo(map);
    this._lineLayer.addTo(map);
    this._markerLayer.addTo(map);
    this._markerLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
    this._lineLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
    this._polygonLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
    return _OverlayLayer.prototype.onAdd.call(this);
  };
  _proto.getRenderer = function getRenderer() {
    return this._getRenderer();
  };
  _proto._getRenderer = function _getRenderer() {
    return this._markerLayer.getRenderer();
  };
  return DrawToolLayer;
}(OverlayLayer);
DrawToolLayer.mergeOptions(options$o);

var key = '_map_tool';
var MapTool = function (_Eventable) {
  function MapTool() {
    return _Eventable.apply(this, arguments) || this;
  }
  _inheritsLoose(MapTool, _Eventable);
  var _proto = MapTool.prototype;
  _proto.addTo = function addTo(map) {
    if (!map) {
      return this;
    }
    this._map = map;
    if (map[key]) {
      map[key].disable();
    }
    if (this.onAdd) {
      this.onAdd();
    }
    this.enable();
    map[key] = this;
    this._fireEvent('add');
    return this;
  };
  _proto.getMap = function getMap() {
    return this._map;
  };
  _proto.enable = function enable() {
    var map = this._map;
    if (!map || this._enabled) {
      return this;
    }
    this._enabled = true;
    this._switchEvents('off');
    this._registerEvents();
    if (this.onEnable) {
      this.onEnable();
    }
    this._fireEvent('enable');
    return this;
  };
  _proto.disable = function disable() {
    if (!this._enabled || !this._map) {
      return this;
    }
    this._enabled = false;
    this._switchEvents('off');
    if (this.onDisable) {
      this.onDisable();
    }
    this._fireEvent('disable');
    return this;
  };
  _proto.isEnabled = function isEnabled() {
    if (!this._enabled) {
      return false;
    }
    return true;
  };
  _proto.remove = function remove() {
    if (!this._map) {
      return this;
    }
    this.disable();
    if (this._map) {
      delete this._map[key];
      delete this._map;
    }
    this._fireEvent('remove');
    return this;
  };
  _proto._registerEvents = function _registerEvents() {
    this._switchEvents('on');
  };
  _proto._switchEvents = function _switchEvents(to) {
    var events = this.getEvents();
    if (events) {
      this._map[to](events, this);
    }
  };
  _proto._fireEvent = function _fireEvent(eventName, param) {
    if (!param) {
      param = {};
    }
    this.fire(eventName, param);
  };
  return MapTool;
}(Eventable(Class));

var options$n = {
  'symbol': {
    'lineColor': '#000',
    'lineWidth': 2,
    'lineOpacity': 1,
    'polygonFill': '#fff',
    'polygonOpacity': 0.3
  },
  'doubleClickZoom': false,
  'mode': null,
  'once': false,
  'autoPanAtEdge': false,
  'ignoreMouseleave': true,
  'blockGeometryEvents': false,
  'zIndex': Number.MAX_VALUE,
  'enableAltitude': true,
  'interactive': true,
  'transformCoordinate': null
};
var registeredMode = {};
var DrawTool = function (_MapTool) {
  function DrawTool(options) {
    var _this;
    _this = _MapTool.call(this, options) || this;
    _this.id = UID();
    _this._checkMode();
    _this._events = {
      'click': _this._clickHandler,
      'mousemove touchmove': _this._mouseMoveHandler,
      'dblclick': _this._doubleClickHandler,
      'mousedown touchstart': _this._mouseDownHandler,
      'mouseup touchend': _this._mouseUpHandler,
      'mousemove': _this._mouseMoveHandler,
      'mousedown': _this._mouseDownHandler,
      'mouseup': _this._mouseUpHandler
    };
    return _this;
  }
  _inheritsLoose(DrawTool, _MapTool);
  DrawTool.registerMode = function registerMode(name, modeAction) {
    registeredMode[name.toLowerCase()] = modeAction;
  };
  DrawTool.getRegisterMode = function getRegisterMode(name) {
    return registeredMode[name.toLowerCase()];
  };
  DrawTool.getAllRegisterMode = function getAllRegisterMode() {
    return Object.assign({}, registeredMode);
  };
  var _proto = DrawTool.prototype;
  _proto.getMode = function getMode() {
    if (this.options['mode']) {
      return this.options['mode'].toLowerCase();
    }
    return null;
  };
  _proto.setMode = function setMode(mode) {
    if (this._geometry) {
      this._geometry.remove();
      delete this._geometry;
    }
    this._clearStage();
    this._switchEvents('off');
    this.options['mode'] = mode;
    this._checkMode();
    if (this.isEnabled()) {
      this._switchEvents('on');
      this._restoreMapCfg();
      this._saveMapCfg();
    }
    return this;
  };
  _proto.getSymbol = function getSymbol() {
    var symbol = this.options['symbol'];
    if (symbol) {
      return extendSymbol(symbol);
    } else {
      return extendSymbol(this.options['symbol']);
    }
  };
  _proto.setSymbol = function setSymbol(symbol) {
    if (!symbol) {
      return this;
    }
    this.options['symbol'] = symbol;
    if (this._geometry) {
      this._geometry.setSymbol(symbol);
    }
    return this;
  };
  _proto.getCurrentGeometry = function getCurrentGeometry() {
    return this._geometry;
  };
  _proto.onAdd = function onAdd() {
    this._checkMode();
  };
  _proto.onEnable = function onEnable() {
    this._saveMapCfg();
    this._drawToolLayer = this._getDrawLayer();
    this._clearStage();
    this._loadResources();
    var map = this.getMap();
    if (this.options['autoPanAtEdge']) {
      this._mapAutoPanAtEdge = map.options['autoPanAtEdge'];
      if (!this._mapAutoPanAtEdge) {
        map.config({
          autoPanAtEdge: true
        });
      }
    }
    this._geometryEvents = map.options['geometryEvents'];
    if (this.options['blockGeometryEvents']) {
      map.config('geometryEvents', false);
    }
    return this;
  };
  _proto.onDisable = function onDisable() {
    var map = this.getMap();
    this._restoreMapCfg();
    this.endDraw({
      ignoreEndEvent: true
    });
    if (this._map) {
      map.removeLayer(this._getDrawLayer());
      if (this.options['autoPanAtEdge']) {
        if (!this._mapAutoPanAtEdge) {
          map.config({
            autoPanAtEdge: false
          });
        }
      }
    }
    if (this.options['blockGeometryEvents']) {
      map.config('geometryEvents', this._geometryEvents);
    }
    return this;
  };
  _proto.undo = function undo() {
    var registerMode = this._getRegisterMode();
    var action = registerMode.action;
    if (!this._shouldRecordHistory(action) || !this._historyPointer) {
      return this;
    }
    var coords = this._clickCoords.slice(0, --this._historyPointer);
    registerMode.update(this.getMap().getProjection(), coords, this._geometry);
    return this;
  };
  _proto.redo = function redo() {
    var registerMode = this._getRegisterMode();
    var action = registerMode.action;
    if (!this._shouldRecordHistory(action) || isNil(this._historyPointer) || this._historyPointer === this._clickCoords.length) {
      return this;
    }
    var coords = this._clickCoords.slice(0, ++this._historyPointer);
    registerMode.update(this.getMap().getProjection(), coords, this._geometry);
    return this;
  };
  _proto._shouldRecordHistory = function _shouldRecordHistory(actions) {
    return Array.isArray(actions) && actions[0] === 'click' && actions[1] === 'mousemove' && actions[2] === 'dblclick';
  };
  _proto._checkMode = function _checkMode() {
    this._getRegisterMode();
  };
  _proto._saveMapCfg = function _saveMapCfg() {
    var map = this.getMap();
    this._mapDoubleClickZoom = map.options['doubleClickZoom'];
    map.config({
      'doubleClickZoom': this.options['doubleClickZoom']
    });
    var actions = this._getRegisterMode()['action'];
    var dragging = false;
    for (var i = 0; i < actions.length; i++) {
      if (actions[i].indexOf('mousedown') >= 0 || actions[i].indexOf('touchstart') >= 0) {
        dragging = true;
        break;
      }
    }
    if (dragging) {
      var _map = this.getMap();
      this._mapDraggable = _map.options['draggable'];
      _map.config({
        'draggable': false
      });
    }
  };
  _proto._restoreMapCfg = function _restoreMapCfg() {
    var map = this.getMap();
    map.config({
      'doubleClickZoom': this._mapDoubleClickZoom
    });
    if (!isNil(this._mapDraggable)) {
      map.config('draggable', this._mapDraggable);
    }
    delete this._mapDraggable;
    delete this._mapDoubleClickZoom;
  };
  _proto._loadResources = function _loadResources() {
    var symbol = this.getSymbol();
    var resources = getExternalResources(symbol);
    if (resources.length > 0) {
      this._drawToolLayer.getRenderer().loadResources(resources);
    }
  };
  _proto._getProjection = function _getProjection() {
    return this._map.getProjection();
  };
  _proto._getRegisterMode = function _getRegisterMode() {
    var mode = this.getMode();
    var registerMode = DrawTool.getRegisterMode(mode);
    if (!registerMode) {
      throw new Error(mode + ' is not a valid mode of DrawTool.');
    }
    return registerMode;
  };
  _proto.getEvents = function getEvents() {
    var action = this._getRegisterMode()['action'];
    var _events = {};
    if (Array.isArray(action)) {
      for (var i = 0; i < action.length; i++) {
        _events[action[i]] = this._events[action[i]];
      }
      return _events;
    }
    return null;
  };
  _proto._mouseDownHandler = function _mouseDownHandler(event) {
    if (!(event === null || event === void 0 ? void 0 : event.coordinate)) {
      return;
    }
    this._createGeometry(event);
  };
  _proto._mouseUpHandler = function _mouseUpHandler(event) {
    if (!(event === null || event === void 0 ? void 0 : event.coordinate)) {
      return;
    }
    this.endDraw(event);
  };
  _proto._copyMapEventOnSnapTo = function _copyMapEventOnSnapTo(mapEvent, prjCoord) {
    var map = this.getMap();
    if (!map) {
      return mapEvent;
    }
    return Object.assign({}, mapEvent, {
      containerPoint: map.prjToContainerPoint(prjCoord)
    });
  };
  _proto._clickHandler = function _clickHandler(event) {
    if (!(event === null || event === void 0 ? void 0 : event.coordinate)) {
      return;
    }
    if (!this.options.interactive) {
      return this;
    }
    event.enableAltitude = this.options.enableAltitude;
    var map = this.getMap();
    var registerMode = this._getRegisterMode();
    if (this._clickCoords && this._clickCoords.length) {
      var len = this._clickCoords.length;
      var prjCoord = map._pointToPrj(event['point2d']);
      if (this._clickCoords[len - 1].equals(prjCoord)) {
        return;
      }
    }
    if (!this._geometry) {
      this._createGeometry(event);
    } else {
      var _prjCoord = map._pointToPrj(event['point2d']);
      if (!isNil(this._historyPointer)) {
        this._clickCoords = this._clickCoords.slice(0, this._historyPointer);
      }
      var snapTo = this._geometry.snapTo;
      var copyEvent;
      if (snapTo && isFunction(snapTo)) {
        var snapResult = this._getSnapResult(snapTo, event.containerPoint);
        _prjCoord = snapResult.prjCoord;
        copyEvent = this._copyMapEventOnSnapTo(event, _prjCoord);
        this._clickCoords = this._clickCoords.concat(snapResult.effectedVertex);
        if (this._clickCoords[this._clickCoords.length - 1].equals(_prjCoord)) {
          return;
        }
      }
      this._clickCoords.push(_prjCoord);
      this._historyPointer = this._clickCoords.length;
      event.drawTool = this;
      registerMode['update'](map.getProjection(), this._clickCoords, this._geometry, copyEvent || event);
      if (this.getMode() === 'point') {
        this.endDraw(event);
        return;
      }
      if (this._clickCoords.length <= 1) {
        this._fireEvent('drawstart', event);
      } else {
        this._fireEvent('drawvertex', event);
      }
      if (registerMode['clickLimit'] && registerMode['clickLimit'] === this._historyPointer) {
        this.endDraw(event);
      }
    }
  };
  _proto._createGeometry = function _createGeometry(event) {
    var mode = this.getMode();
    var map = this.getMap();
    var registerMode = this._getRegisterMode();
    var prjCoord = map._pointToPrj(event['point2d']);
    var symbol = this.getSymbol();
    if (!this._geometry) {
      this._fireEvent('drawprepare', event);
      this._clickCoords = [prjCoord];
      event.drawTool = this;
      this._geometry = registerMode['create'](this.getMap().getProjection(), this._clickCoords, event);
      if (symbol && mode !== 'point') {
        this._geometry.setSymbol(symbol);
      } else if (this.options.hasOwnProperty('symbol')) {
        this._geometry.setSymbol(this.options['symbol']);
      }
      this._addGeometryToStage(this._geometry);
      this._fireEvent('drawstart', event);
      var snapTo = this._geometry.snapTo;
      if (snapTo && isFunction(snapTo)) {
        var snapResult = this._getSnapResult(snapTo, event.containerPoint);
        var _map2 = this.getMap();
        if (_map2 && snapResult) {
          var _prjCoord2 = snapResult.prjCoord;
          this._clickCoords = [_prjCoord2];
          if (this._geometry._firstClick) {
            this._geometry._firstClick = _prjCoord2;
          }
          var copyEvent = this._copyMapEventOnSnapTo(event, _prjCoord2);
          registerMode['update'](_map2.getProjection(), this._clickCoords, this._geometry, copyEvent);
        }
      }
    }
    if (mode === 'point' && event.type !== 'mousemove') {
      this.endDraw(event);
    }
  };
  _proto._mouseMoveHandler = function _mouseMoveHandler(event) {
    if (!(event === null || event === void 0 ? void 0 : event.coordinate)) {
      return;
    }
    if (!this.options.interactive) {
      return this;
    }
    event.enableAltitude = this.options.enableAltitude;
    var map = this.getMap();
    if (!map || map.isInteracting()) {
      return;
    }
    if (this.getMode() === 'point' && !this._geometry) {
      this._createGeometry(event);
      return;
    }
    if (!this._geometry) {
      return;
    }
    var containerPoint = this._getMouseContainerPoint(event);
    if (!this._isValidContainerPoint(containerPoint)) {
      return;
    }
    var prjCoord = map._pointToPrj(event['point2d']);
    var snapAdditionVertex = [];
    var snapTo = this._geometry.snapTo;
    var copyEvent;
    if (snapTo && isFunction(snapTo)) {
      var snapResult = this._getSnapResult(snapTo, containerPoint);
      prjCoord = snapResult.prjCoord;
      snapAdditionVertex = snapResult.effectedVertex;
      copyEvent = this._copyMapEventOnSnapTo(event, prjCoord);
    }
    var projection = map.getProjection();
    event.drawTool = this;
    var registerMode = this._getRegisterMode();
    if (this._shouldRecordHistory(registerMode.action)) {
      var path = this._clickCoords.slice(0, this._historyPointer);
      if (path && path.length > 0 && prjCoord.equals(path[path.length - 1])) {
        return;
      }
      registerMode['update'](projection, path.concat(snapAdditionVertex, [prjCoord]), this._geometry, copyEvent || event);
    } else {
      registerMode['update'](projection, prjCoord, this._geometry, copyEvent || event);
    }
    this._fireEvent('mousemove', event);
  };
  _proto._doubleClickHandler = function _doubleClickHandler(event) {
    if (!(event === null || event === void 0 ? void 0 : event.coordinate)) {
      return;
    }
    if (!this.options.interactive) {
      return this;
    }
    event.enableAltitude = this.options.enableAltitude;
    if (!this._geometry) {
      return;
    }
    var containerPoint = this._getMouseContainerPoint(event);
    if (!this._isValidContainerPoint(containerPoint)) {
      return;
    }
    var registerMode = this._getRegisterMode();
    var clickCoords = this._clickCoords;
    if (!clickCoords || clickCoords.length < 2) {
      return;
    }
    var mode = this.getMode();
    if (mode && mode.indexOf('polygon') > -1 && clickCoords.length < 3) {
      return;
    }
    var projection = this.getMap().getProjection();
    var path = [clickCoords[0]];
    for (var i = 1, len = clickCoords.length; i < len; i++) {
      if (clickCoords[i].x !== clickCoords[i - 1].x || clickCoords[i].y !== clickCoords[i - 1].y) {
        path.push(clickCoords[i]);
      }
    }
    if (path.length < 2 || this._geometry && this._geometry instanceof Polygon && path.length < 3) {
      return;
    }
    event.drawTool = this;
    registerMode['update'](projection, path, this._geometry, event);
    this.endDraw(event);
  };
  _proto._addGeometryToStage = function _addGeometryToStage(geometry) {
    var drawLayer = this._getDrawLayer();
    drawLayer.addGeometry(geometry);
  };
  _proto.endDraw = function endDraw(param) {
    if (!this._geometry || this._ending) {
      return this;
    }
    this._ending = true;
    var geometry = this._geometry;
    this._clearStage();
    param = param || {};
    this._geometry = geometry;
    if (!param.ignoreEndEvent) {
      this._fireEvent('drawend', param);
    }
    delete this._geometry;
    if (this.options['once']) {
      this.disable();
    }
    delete this._ending;
    delete this._historyPointer;
    if (this._vertexes) {
      this._vertexes = [];
    }
    return this;
  };
  _proto._clearStage = function _clearStage() {
    this._getDrawLayer().clear();
    delete this._geometry;
    delete this._clickCoords;
  };
  _proto._getMouseContainerPoint = function _getMouseContainerPoint(event) {
    var action = this._getRegisterMode()['action'];
    if (action[0].indexOf('mousedown') >= 0 || action[0].indexOf('touchstart') >= 0) {
      stopPropagation(event['domEvent']);
    }
    return event['containerPoint'];
  };
  _proto._isValidContainerPoint = function _isValidContainerPoint(containerPoint) {
    var mapSize = this._map.getSize();
    var w = mapSize['width'],
      h = mapSize['height'];
    if (containerPoint.x < 0 || containerPoint.y < 0) {
      return false;
    } else if (containerPoint.x > w || containerPoint.y > h) {
      return false;
    }
    return true;
  };
  _proto._getSnapResult = function _getSnapResult(snapTo, containerPoint) {
    var map = this.getMap();
    var lastContainerPoints = [];
    if (this.options.edgeAutoComplete) {
      var lastCoord = this._clickCoords[(this._historyPointer || 1) - 1];
      lastContainerPoints.push(map.prjToContainerPoint(lastCoord));
      var beforeLastCoord = this._clickCoords[(this._historyPointer || 1) - 2];
      if (beforeLastCoord) {
        lastContainerPoints.push(map.prjToContainerPoint(beforeLastCoord));
      }
    }
    var snapResult = snapTo(containerPoint, lastContainerPoints);
    containerPoint = (snapResult.effectedVertex ? snapResult.point : snapResult) || containerPoint;
    var prjCoord = map._containerPointToPrj(containerPoint);
    if (snapResult.effectedVertex) {
      snapResult.effectedVertex = snapResult.effectedVertex.map(function (vertex) {
        return map._containerPointToPrj(vertex);
      });
    }
    return {
      prjCoord: prjCoord,
      effectedVertex: snapResult.effectedVertex || []
    };
  };
  _proto._getDrawLayer = function _getDrawLayer() {
    var drawLayerId = INTERNAL_LAYER_PREFIX + 'drawtool' + ("" + this.id);
    var drawToolLayer = this._map.getLayer(drawLayerId);
    if (!drawToolLayer) {
      drawToolLayer = new DrawToolLayer(drawLayerId, {
        'enableSimplify': false,
        'enableAltitude': this.options['enableAltitude'],
        'zIndex': this.options.zIndex
      });
      this._map.addLayer(drawToolLayer);
    }
    this._pushLayers(drawToolLayer);
    return drawToolLayer;
  };
  _proto._fireEvent = function _fireEvent(eventName, param) {
    if (!param) {
      param = {};
    }
    param = extend$2({}, param);
    if (this._geometry) {
      param['geometry'] = this._getRegisterMode()['generate'](this._geometry, {
        drawTool: this
      });
      param.tempGeometry = this._geometry;
    }
    MapTool.prototype._fireEvent.call(this, eventName, param);
  };
  _proto._pushLayers = function _pushLayers(layers) {
    var _this2 = this;
    if (!layers) {
      return this;
    }
    if (!Array.isArray(layers)) {
      layers = [layers];
    }
    this._layers = this._layers || [];
    layers.forEach(function (layer) {
      if (_this2._layers.indexOf(layer) === -1) {
        _this2._layers.push(layer);
      }
    });
    return this;
  };
  _proto._outLayers = function _outLayers(layers) {
    var _this3 = this;
    if (!layers) {
      return this;
    }
    if (!Array.isArray(layers)) {
      layers = [layers];
    }
    this._layers = this._layers || [];
    layers.forEach(function (layer) {
      for (var i = 0, len = _this3._layers.length; i < len; i++) {
        if (layer === _this3._layers[i]) {
          _this3._layers.splice(i, 1);
          break;
        }
      }
    });
    return this;
  };
  _proto.setLayerZIndex = function setLayerZIndex(zIndex) {
    if (!isNumber(zIndex)) {
      return this;
    }
    this.options.zIndex = zIndex;
    this._layers = this._layers || [];
    this._layers.forEach(function (layer) {
      if (layer && layer.setZIndex) {
        layer.setZIndex(zIndex);
      }
    });
    return this;
  };
  _proto.addCoordinate = function addCoordinate(coordinate) {
    if (!this.isEnabled()) {
      return this;
    }
    var map = this.getMap();
    if (!map) {
      return this;
    }
    coordinate = new Coordinate(coordinate);
    var eventParam = map._parseEventFromCoord(coordinate);
    this._clickHandler(eventParam);
    return this;
  };
  _proto.getTempGeometry = function getTempGeometry() {
    return this._geometry;
  };
  return DrawTool;
}(MapTool);
DrawTool.mergeOptions(options$n);

var MapBoxZoomHander = function (_MapBaseHandler) {
  function MapBoxZoomHander(target) {
    var _this;
    _this = _MapBaseHandler.call(this, target) || this;
    _this.drawTool = new DrawTool({
      'mode': 'boxZoom',
      'ignoreMouseleave': false
    });
    return _this;
  }
  _inheritsLoose(MapBoxZoomHander, _MapBaseHandler);
  var _proto = MapBoxZoomHander.prototype;
  _proto.addHooks = function addHooks() {
    this.target.on('_mousedown', this._onMouseDown, this);
  };
  _proto.removeHooks = function removeHooks() {
    this.target.off('_mousedown', this._onMouseDown, this);
    if (this.drawTool.isEnabled()) {
      this.drawTool.remove();
    }
  };
  _proto._onMouseDown = function _onMouseDown(param) {
    if (!this.target.options['boxZoom']) {
      return;
    }
    if (param.domEvent.shiftKey) {
      this.drawTool.setSymbol(this.target.options['boxZoomSymbol']).on('drawend', this._boxZoom, this).addTo(this.target);
    }
  };
  _proto._boxZoom = function _boxZoom(param) {
    var map = this.target;
    this.drawTool.remove();
    var geometry = param.geometry,
      center = geometry.getCenter(),
      symbol = geometry.getSymbol(),
      w = symbol.markerWidth,
      h = symbol.markerHeight;
    var extent = new Extent(center, map.locateByPoint(center, w, h), map.getProjection());
    var zoom = map.getFitZoom(extent);
    map._animateTo({
      center: extent.getCenter(),
      zoom: zoom
    });
  };
  return MapBoxZoomHander;
}(MapBaseHandler);
Map$1.mergeOptions({
  'boxZoom': true,
  'boxZoomSymbol': {
    'markerType': 'rectangle',
    'markerLineWidth': 3,
    'markerLineColor': '#1bbc9b',
    'markerLineDasharray': [10, 5],
    'markerFillOpacity': 0.1,
    'markerFill': '#1bbc9b',
    'markerWidth': 1,
    'markerHeight': 1
  }
});
Map$1.addOnLoadHook('addHandler', 'boxZoom', MapBoxZoomHander);

var PANOFFSET = 30;
var MapAutoPanAtEdgeHandler = function (_MapBaseHandler) {
  function MapAutoPanAtEdgeHandler() {
    return _MapBaseHandler.apply(this, arguments) || this;
  }
  _inheritsLoose(MapAutoPanAtEdgeHandler, _MapBaseHandler);
  var _proto = MapAutoPanAtEdgeHandler.prototype;
  _proto.addHooks = function addHooks() {
    if (!this.target) {
      return;
    }
    this.target.on('_mousemove', this._onMouseMove, this);
  };
  _proto.removeHooks = function removeHooks() {
    if (!this.target) {
      return;
    }
    this.target.off('_mousemove', this._onMouseMove, this);
  };
  _proto._onMouseMove = function _onMouseMove(event) {
    var map = this.target;
    if (map.options['autoPanAtEdge']) {
      var {
        containerPoint: containerPoint
      } = event;
      var containerExtent = map.getContainerExtent();
      if (containerExtent) {
        var {
          x: x,
          y: y
        } = containerPoint;
        var {
          xmax: xmax,
          ymax: ymax
        } = containerExtent;
        var p;
        if (x < PANOFFSET) {
          p = [Math.abs(x - PANOFFSET), 0];
        }
        if (y < PANOFFSET) {
          p = [0, Math.abs(y - PANOFFSET)];
        }
        if (x + PANOFFSET > xmax) {
          p = [-Math.abs(x + PANOFFSET - xmax), 0];
        }
        if (y + PANOFFSET > ymax) {
          p = [0, -Math.abs(y + PANOFFSET - ymax)];
        }
        if (p) {
          map.panBy(p, {
            duration: 1
          });
        }
      }
    }
  };
  return MapAutoPanAtEdgeHandler;
}(MapBaseHandler);
Map$1.mergeOptions({
  'autoPanAtEdge': false
});
Map$1.addOnLoadHook('addHandler', 'autoPanAtEdge', MapAutoPanAtEdgeHandler);

function needValidateView(view, map) {
  var bearing = view.bearing;
  var currentBearing = map.getBearing();
  if (currentBearing >= 0 && bearing > 180) {
    return false;
  }
  if (currentBearing <= 0 && bearing < -180) {
    return false;
  }
  return true;
}
function reverseBearing(view, map) {
  var bearing = view.bearing;
  var currentBearing = map.getBearing();
  if (currentBearing >= 0 && bearing < 0) {
    view.bearing = 180 + (180 - Math.abs(bearing));
  }
  if (currentBearing <= 0 && bearing > 0) {
    view.bearing = -180 - (180 - Math.abs(bearing));
  }
  if (currentBearing >= 0 && bearing > 0) {
    view.bearing = -180 - (180 - Math.abs(bearing));
  }
  if (currentBearing <= 0 && bearing < 0) {
    view.bearing = 180 + (180 - Math.abs(bearing));
  }
}
Map$1.include({
  animateTo: function animateTo(view, options = {}, step) {
    var _this = this;
    view = extend$2({}, this.getView(), view);
    view.bearing = view.bearing % 360;
    if (isFunction(options)) {
      step = options;
      options = {};
    }
    if (options.counterclockwise) {
      reverseBearing(view, this);
    }
    if (needValidateView(view, this)) {
      this._validateView(view);
    }
    var projection = this.getProjection(),
      currView = this.getView(),
      props = {};
    var empty = true;
    var isEqual = mapViewEqual(view, currView);
    for (var p in view) {
      if (hasOwn(view, p) && !isNil(view[p]) && (p === 'prjCenter' || !isNil(currView[p]))) {
        empty = false;
        if (p === 'center') {
          var from = new Coordinate(currView[p]),
            to = new Coordinate(view[p]);
          if (!from.equals(to)) {
            props['center'] = [from, to];
          }
        } else if (p === 'prjCenter') {
          var _from = new Coordinate(this._getPrjCenter());
          var _to = new Coordinate(view[p]);
          if (!_from.equals(_to)) {
            props['prjCenter'] = [_from, _to];
          }
        } else if (currView[p] !== view[p] && p !== 'around') {
          props[p] = [currView[p], view[p]];
        }
      }
    }
    if (empty) {
      return null;
    }
    if (this._animPlayer) {
      if (this._isInternalAnimation) {
        if (this._animPlayer.playState === 'running') {
          this._animPlayer.pause();
          this._prevAnimPlayer = this._animPlayer;
        }
      } else {
        delete this._prevAnimPlayer;
        this._stopAnim(this._animPlayer);
      }
    }
    var zoomOrigin = view['around'] || null;
    var renderer = this._getRenderer(),
      framer = function framer(fn) {
        renderer.callInNextFrame(fn);
      };
    var player = this._animPlayer = Animation.animate(props, {
      'easing': options['easing'] || 'out',
      'duration': options['duration'] || this.options['zoomAnimationDuration'],
      'framer': framer,
      'repeat': options['repeat']
    }, function (frame) {
      if (_this.isRemoved()) {
        player.finish();
        return;
      }
      if (player.playState === 'running' && !isEqual) {
        if (frame.styles['center']) {
          var center = frame.styles['center'];
          _this._setPrjCenter(projection.project(center));
          _this.onMoving(_this._parseEventFromCoord(_this.getCenter()));
        } else if (frame.styles['prjCenter']) {
          var _center = frame.styles['prjCenter'];
          _this._setPrjCenter(_center);
          _this.onMoving(_this._parseEventFromCoord(_this.getCenter()));
        }
        if (!isNil(frame.styles['zoom'])) {
          _this.onZooming(frame.styles['zoom'], zoomOrigin);
        }
        if (!isNil(frame.styles['pitch'])) {
          _this._setPitch(frame.styles['pitch']);
        }
        if (!isNil(frame.styles['bearing'])) {
          _this._setBearing(frame.styles['bearing']);
        }
        _this._fireEvent('animating');
      } else if (player.playState !== 'paused' || player === _this._mapAnimPlayer) {
        if (!player._interupted) {
          if (props['center']) {
            _this._setPrjCenter(projection.project(props['center'][1]));
          } else if (props['prjCenter']) {
            _this._setPrjCenter(props['prjCenter'][1]);
          }
          if (!isNil(props['pitch'])) {
            _this._setPitch(props['pitch'][1]);
          }
          if (!isNil(props['bearing'])) {
            _this._setBearing(props['bearing'][1]);
          }
        }
        _this._endAnim(player, props, zoomOrigin, options);
      }
      if (step) {
        step(frame);
      }
    }, this);
    this._startAnim(props, zoomOrigin);
    return player;
  },
  _animateTo: function _animateTo(view, options = {}, step) {
    if (this._mapAnimPlayer) {
      this._stopAnim(this._mapAnimPlayer);
    }
    this._isInternalAnimation = true;
    this._mapAnimPlayer = this.animateTo(view, options, step);
    delete this._isInternalAnimation;
    return this._mapAnimPlayer;
  },
  flyTo: function flyTo(view, options = {}, step) {
    var _this2 = this;
    view = extend$2({}, this.getView(), view);
    view.bearing = view.bearing % 360;
    if (options.counterclockwise) {
      reverseBearing(view, this);
    }
    if (needValidateView(view, this)) {
      this._validateView(view);
    }
    if (this._animPlayer) {
      if (this._isInternalAnimation) {
        if (this._animPlayer.playState === 'running') {
          this._animPlayer.pause();
          this._prevAnimPlayer = this._animPlayer;
        }
      } else {
        delete this._prevAnimPlayer;
        this._stopAnim(this._animPlayer);
      }
    }
    if (isFunction(options)) {
      step = options;
      options = {};
    }
    options = extend$2({
      curve: 1.42
    }, options);
    var map = this;
    function zoomScale(z0, z1) {
      return map.getResolution(z1) / map.getResolution(z0);
    }
    var zoomOrigin = view['around'] || new Point(this.width / 2, this.height / 2);
    var minZoom = this.getMinZoom();
    var maxZoom = this.getMaxZoom();
    var projection = this.getProjection();
    var currView = this.getView();
    var startZoom = currView.zoom;
    var startBearing = currView.bearing;
    var startPitch = currView.pitch;
    var zoom = 'zoom' in view ? clamp(+view.zoom, minZoom, maxZoom) : startZoom;
    var bearing = 'bearing' in view ? +view.bearing : startBearing;
    var pitch = 'pitch' in view ? +view.pitch : startPitch;
    var center = projection.project(view.center && new Coordinate(view.center) || this.getCenter());
    var scale = zoomScale(zoom, startZoom);
    var from = projection.project(this.getCenter());
    var delta = center.sub(from);
    var rho = options.curve;
    var w0 = Math.max(this.width, this.height),
      w1 = w0 / scale,
      u1 = delta.mag();
    if ('minZoom' in options) {
      var animMinZoom = clamp(Math.min(options.minZoom, startZoom, zoom), minZoom, maxZoom);
      var wMax = w0 / zoomScale(animMinZoom, startZoom);
      rho = Math.sqrt(wMax / u1 * 2);
    }
    var rho2 = rho * rho;
    function r(i) {
      var b = (w1 * w1 - w0 * w0 + (i ? -1 : 1) * rho2 * rho2 * u1 * u1) / (2 * (i ? w1 : w0) * rho2 * u1);
      return Math.log(Math.sqrt(b * b + 1) - b);
    }
    function sinh(n) {
      return (Math.exp(n) - Math.exp(-n)) / 2;
    }
    function cosh(n) {
      return (Math.exp(n) + Math.exp(-n)) / 2;
    }
    function tanh(n) {
      return sinh(n) / cosh(n);
    }
    var r0 = r(0);
    var w = function w(s) {
      return cosh(r0) / cosh(r0 + rho * s);
    };
    var u = function u(s) {
      return w0 * ((cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2) / u1;
    };
    var S = (r(1) - r0) / rho;
    if (Math.abs(u1) < 0.000001 || !isFinite(S)) {
      if (Math.abs(w0 - w1) < 0.000001) return this.animateTo(view, options, step);
      var k = w1 < w0 ? -1 : 1;
      S = Math.abs(Math.log(w1 / w0)) / rho;
      u = function u() {
        return 0;
      };
      w = function w(s) {
        return Math.exp(k * rho * s);
      };
    }
    var renderer = this._getRenderer();
    var framer = function framer(fn) {
      renderer.callInNextFrame(fn);
    };
    var player = this._animPlayer = Animation.animate({
      k: [0, 1]
    }, {
      'easing': options['easing'] || 'out',
      'duration': options['duration'] || 8,
      'framer': framer
    }, function (frame) {
      if (_this2.isRemoved()) {
        player.finish();
        return;
      }
      var k = frame.styles.k;
      var s = k * S;
      var scale = 1 / w(s);
      var props = {};
      if (view.center) {
        var newCenter = k === 1 ? center : from.add(delta.multi(u(s)));
        props.prjCenter = [center, newCenter];
      }
      if (startZoom !== zoom) {
        var newZoom = k === 1 ? zoom : _this2.getZoomForScale(scale, startZoom, true);
        props.zoom = [startZoom, newZoom];
      }
      if (startPitch !== pitch) {
        var newPitch = interpolate(startPitch, pitch, k);
        props.pitch = [pitch, newPitch];
      }
      if (startBearing !== bearing) {
        var newBearing = interpolate(startBearing, bearing, k);
        props.bearing = [bearing, newBearing];
      }
      if (player.playState === 'running') {
        if (props['prjCenter']) {
          var _center2 = props['prjCenter'];
          _this2._setPrjCenter(_center2[1]);
          _this2.onMoving(_this2._parseEventFromCoord(_this2.getCenter()));
        }
        if (props['zoom']) {
          _this2.onZooming(props['zoom'][1], zoomOrigin);
        }
        if (props['pitch']) {
          _this2._setPitch(props['pitch'][1]);
        }
        if (props['bearing']) {
          _this2._setBearing(props['bearing'][1]);
        }
        _this2._fireEvent('animating');
      } else if (player.playState !== 'paused' || player === _this2._mapAnimPlayer) {
        if (!player._interupted) {
          if (props['prjCenter']) {
            _this2._setPrjCenter(props['prjCenter'][1]);
          }
          if (props['pitch']) {
            _this2._setPitch(props['pitch'][1]);
          }
          if (props['bearing']) {
            _this2._setBearing(props['bearing'][1]);
          }
        }
        _this2._endAnim(player, props, zoomOrigin, options);
      }
      if (step) {
        step(frame);
      }
    }, {});
    this._startAnim({
      center: view.center,
      zoom: view.zoom !== startZoom,
      pitch: pitch !== startPitch,
      bearing: bearing !== startBearing
    }, zoomOrigin);
    return this;
  },
  isAnimating: function isAnimating() {
    return !!this._animPlayer;
  },
  isRotating: function isRotating() {
    return this.isDragRotating() || !!this._animRotating;
  },
  _endAnim: function _endAnim(player, props, zoomOrigin, options) {
    delete this._animRotating;
    var evtType = player._interupted ? 'animateinterrupted' : 'animateend';
    if (player === this._animPlayer) {
      delete this._animPlayer;
    }
    if (player === this._mapAnimPlayer) {
      delete this._mapAnimPlayer;
    }
    if (props['center']) {
      var endCoord;
      if (player._interupted) {
        endCoord = this.getCenter();
      } else {
        endCoord = props['center'][1];
      }
      this.onMoveEnd(this._parseEventFromCoord(endCoord));
    } else if (props['prjCenter']) {
      var _endCoord;
      if (player._interupted) {
        _endCoord = this._getPrjCenter();
      } else {
        _endCoord = props['prjCenter'][1];
      }
      var event = this._parseEventFromCoord(this.getProjection().unproject(_endCoord));
      event['point2d'] = this._prjToPoint(_endCoord);
      this.onMoveEnd(event);
    }
    if (!isNil(props['zoom'])) {
      if (player._interupted) {
        this.onZoomEnd(this.getZoom());
      } else if (!options['wheelZoom']) {
        this.onZoomEnd(props['zoom'][1]);
      } else {
        this.onZooming(props['zoom'][1], zoomOrigin);
      }
    }
    if (evtType) {
      this._fireEvent(evtType);
    }
    if (!isNil(props['pitch']) && !this.getPitch()) {
      this.getRenderer().setToRedraw();
    }
    if (!options['wheelZoom']) {
      this._resumePrev(player);
    }
  },
  _startAnim: function _startAnim(props, zoomOrigin) {
    if (!this._animPlayer) {
      return;
    }
    if (props['center'] || props['prjCenter']) {
      this.onMoveStart();
    }
    if (props['zoom'] && !this.isZooming()) {
      this.onZoomStart(props['zoom'][1], zoomOrigin);
    }
    if (props['pitch'] || props['bearing']) {
      this._animRotating = true;
    }
    this._fireEvent('animatestart');
    this._animPlayer.play();
  },
  _stopAnim: function _stopAnim(player) {
    if (!player) {
      return;
    }
    delete this._animRotating;
    if (player.playState !== 'finished') {
      player._interupted = true;
      player.cancel();
    }
    if (player === this._animPlayer) {
      delete this._animPlayer;
    }
    if (player === this._mapAnimPlayer) {
      delete this._mapAnimPlayer;
    }
  },
  _resumePrev: function _resumePrev(player) {
    if (!this._prevAnimPlayer) {
      return;
    }
    var prevPlayer = this._prevAnimPlayer;
    if (prevPlayer.playState !== 'paused') {
      delete this._prevAnimPlayer;
    }
    if (player !== prevPlayer) {
      this._animPlayer = prevPlayer;
      prevPlayer.play();
    }
  }
});
function interpolate(a, b, t) {
  return a * (1 - t) + b * t;
}

var PITCH_TO_CHECK = [60, 120];
function dragEventHanlder(event) {
  event.stopPropagation();
  event.preventDefault();
}
var DRAGEVENTS = ['dragstart', 'dragenter', 'dragend', 'dragleave', 'dragover'].join(' ').toString();
var events = 'mousedown ' + 'mouseup ' + 'mouseover ' + 'mouseout ' + 'mouseenter ' + 'mouseleave ' + 'mousemove ' + 'click ' + 'dblclick ' + 'contextmenu ' + 'keypress ' + 'touchstart ' + 'touchmove ' + 'touchend ' + 'drop ';
Map$1.include({
  _registerDomEvents: function _registerDomEvents() {
    var dom = this._panels.mapWrapper || this._containerDOM;
    addDomEvent(dom, events, this._handleDOMEvent, this);
    addDomEvent(dom, DRAGEVENTS, dragEventHanlder, this);
  },
  _removeDomEvents: function _removeDomEvents() {
    var dom = this._panels.mapWrapper || this._containerDOM;
    removeDomEvent(dom, events, this._handleDOMEvent);
    removeDomEvent(dom, DRAGEVENTS, dragEventHanlder);
  },
  _handleDOMEvent: function _handleDOMEvent(e) {
    var _this = this;
    if (e && e.type === 'drop') {
      e.stopPropagation();
      e.preventDefault();
      var eventParam = this._parseEvent(e, e.type);
      eventParam = extend$2({}, eventParam, {
        dataTransfer: e.dataTransfer
      });
      this._fireEvent(e.type, eventParam);
      return;
    }
    var clickTimeThreshold = this.options['clickTimeThreshold'];
    var type = e.type;
    if (isMoveEvent(type) && !GlobalConfig.isTest && this.options['mousemoveThrottleEnable'] && isMousemoveEventBlocked(this, this.options['mousemoveThrottleTime'])) {
      return;
    }
    var isMouseDown = type === 'mousedown' || type === 'touchstart' && (!e.touches || e.touches.length === 1);
    if (isMouseDown) {
      this._domMouseDownTime = now();
      this._domMouseDownView = this.getView();
    }
    var isRotating = type === 'contextmenu' && isRotatingMap(this);
    if (type === 'contextmenu') {
      preventDefault(e);
      var downTime = this._domMouseDownTime;
      var time = now();
      if (time - downTime <= clickTimeThreshold && !isRotating) {
        this._fireDOMEvent(this, e, 'dom:' + e.type);
      }
    } else {
      this._fireDOMEvent(this, e, 'dom:' + e.type);
    }
    if (this._ignoreEvent(e)) {
      return;
    }
    var mimicClick = false;
    if (isMouseDown) {
      this._mouseDownTime = now();
    } else if (type === 'click' || type === 'touchend' || type === 'contextmenu') {
      if (!this._mouseDownTime) {
        return;
      } else {
        var _downTime = this._mouseDownTime;
        delete this._mouseDownTime;
        var _time = now();
        if (_time - _downTime > clickTimeThreshold) {
          if (type === 'click' || type === 'contextmenu') {
            return;
          }
        } else if (type === 'contextmenu') {
          if (isRotating) {
            return;
          }
        } else if (type === 'touchend') {
          mimicClick = true;
        }
      }
    }
    var mimicEvent;
    if (mimicClick) {
      if (this._clickTime && now() - this._clickTime <= clickTimeThreshold) {
        delete this._clickTime;
        mimicEvent = 'dblclick';
        this._fireDOMEvent(this, e, 'dom:dblclick');
      } else {
        this._clickTime = now();
        mimicEvent = 'click';
        this._fireDOMEvent(this, e, 'dom:click');
      }
    }
    if (this._ignoreEvent(e)) {
      return;
    }
    var fireClick = function fireClick(mimicEvent) {
      if (!_this._domMouseDownView) {
        _this._fireDOMEvent(_this, e, mimicEvent || type);
      } else {
        if (mapViewEqual(_this._domMouseDownView, _this.getView(), true)) {
          _this._fireDOMEvent(_this, e, mimicEvent || type);
        }
      }
    };
    if (type === 'click') {
      fireClick();
    } else {
      this._fireDOMEvent(this, e, type);
    }
    if (mimicEvent) {
      if (mimicEvent === 'click') {
        fireClick(mimicEvent);
      } else {
        this._fireDOMEvent(this, e, mimicEvent);
      }
    }
  },
  _ignoreEvent: function _ignoreEvent(domEvent) {
    if (!domEvent || !this._panels.control) {
      return false;
    }
    var target = domEvent.srcElement || domEvent.target;
    var preTarget;
    if (target) {
      while (target && target !== this._containerDOM) {
        if (target.className && target.className.indexOf && (target.className.indexOf('maptalks-control') >= 0 || target.className.indexOf('maptalks-ui') >= 0 && preTarget && !preTarget['eventsPropagation'])) {
          return true;
        }
        preTarget = target;
        target = target.parentNode;
      }
    }
    return false;
  },
  _isEventOutMap: function _isEventOutMap(domEvent) {
    var actualEvent = this._getActualEvent(domEvent);
    var cp = getEventContainerPoint(actualEvent, this._containerDOM);
    return this._isContainerPointOutOfMap(cp);
  },
  _isContainerPointOutOfMap: function () {
    var from = [0, 0, 0];
    var to = [0, 0, 0];
    var ray = new Ray(from, to);
    var rayOnGround = [0, 0, 0];
    return function (containerPoint) {
      var pitch = this.getPitch();
      if (pitch > PITCH_TO_CHECK[0] && pitch < PITCH_TO_CHECK[1]) {
        this.getContainerPointRay(from, to, containerPoint, 0, 0.5);
        ray.setFromTo(from, to);
        var intersection = ray.intersectGround(rayOnGround);
        if (!intersection) {
          return true;
        }
        var t = ray.distanceToGround();
        if (t <= 0) {
          return true;
        }
      }
      return false;
    };
  }(),
  _wrapTerrainData: function _wrapTerrainData(eventParam) {
    if (this.options['queryTerrainInMapEvents'] && eventParam.containerPoint && !eventParam.terrain && !this.isInteracting()) {
      eventParam.terrain = this._queryTerrainInfo(eventParam.containerPoint);
    }
  },
  _parseEvent: function _parseEvent(e, type) {
    if (!e) {
      return null;
    }
    var eventParam = {
      'domEvent': e
    };
    if (type !== 'keypress') {
      var actual = this._getActualEvent(e);
      if (actual && actual.clientX !== undefined) {
        var containerPoint = getEventContainerPoint(actual, this._containerDOM);
        eventParam = extend$2(eventParam, {
          'containerPoint': containerPoint,
          'viewPoint': this.containerPointToViewPoint(containerPoint)
        });
        if (!this._isContainerPointOutOfMap(containerPoint)) {
          eventParam = extend$2(eventParam, {
            'coordinate': this.containerPointToCoord(containerPoint),
            'point2d': this._containerPointToPoint(containerPoint)
          });
        }
      }
    }
    this._wrapTerrainData(eventParam);
    return eventParam;
  },
  _parseEventFromCoord: function _parseEventFromCoord(coord) {
    var containerPoint = this.coordToContainerPoint(coord),
      viewPoint = this.containerPointToViewPoint(containerPoint);
    var e = {
      'coordinate': coord,
      'containerPoint': containerPoint,
      'viewPoint': viewPoint,
      'point2d': this.coordToPoint(coord)
    };
    return e;
  },
  _getActualEvent: function _getActualEvent(e) {
    e = e;
    return e.touches && e.touches.length > 0 ? e.touches[0] : e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : e;
  },
  _fireDOMEvent: function _fireDOMEvent(target, e, type) {
    var _this2 = this;
    if (this.isRemoved()) {
      return;
    }
    var eventParam = this._parseEvent(e, type);
    if (!eventParam.coordinate && type !== 'keypress' && type.indexOf('dom:') === -1) {
      return;
    }
    this._wrapTerrainData(eventParam);
    var mousemoveHandler = function mousemoveHandler() {
      if (eventParam.domEvent && eventParam.domEvent._cancelBubble) {
        _this2._fireEvent('_' + type, eventParam);
        return;
      }
      _this2._fireEvent(type, eventParam);
    };
    if (isMoveEvent(type)) {
      if (!this.options['mousemoveThrottleEnable']) {
        mousemoveHandler();
      } else {
        this.getRenderer().callInNextFrame(function () {
          mousemoveHandler();
        });
      }
    } else {
      this._fireEvent(type, eventParam);
    }
  },
  _getEventParams: function _getEventParams(e) {
    var map = this;
    var eventParam = {
      'domEvent': e
    };
    var actual = e.touches && e.touches.length > 0 ? e.touches[0] : e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : e;
    if (actual) {
      var containerPoint = getEventContainerPoint(actual, map.getContainer());
      eventParam['coordinate'] = map.containerPointToCoordinate(containerPoint);
      eventParam['containerPoint'] = containerPoint;
      eventParam['viewPoint'] = map.containerPointToViewPoint(containerPoint);
      eventParam['point2d'] = map._containerPointToPoint(containerPoint);
    }
    this._wrapTerrainData(eventParam);
    return eventParam;
  }
});
Map$1.addOnLoadHook('_registerDomEvents');
Map$1.mergeOptions({
  'queryTerrainInMapEvents': false
});
function isRotatingMap(map) {
  if (!map._domMouseDownView) {
    return true;
  }
  var view = map.getView(),
    mouseDownView = map._domMouseDownView;
  return view.bearing !== mouseDownView.bearing || view.pitch !== mouseDownView.pitch;
}

Map$1.include({
  isFullScreen: function isFullScreen() {
    var doc = document;
    return !!(doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement || doc.fullscreenElement);
  },
  requestFullScreen: function requestFullScreen(dom) {
    this._fireEvent('fullscreenstart');
    this._requestFullScreen(dom || this._containerDOM);
    this._fireEvent('fullscreenend');
    return this;
  },
  cancelFullScreen: function cancelFullScreen() {
    this._cancelFullScreen();
    this._fireEvent('cancelfullscreen');
    return this;
  },
  _requestFullScreen: function _requestFullScreen(dom) {
    if (dom.requestFullscreen) {
      dom.requestFullscreen();
    } else if (dom.mozRequestFullScreen) {
      dom.mozRequestFullScreen();
    } else if (dom.webkitRequestFullScreen) {
      dom.webkitRequestFullScreen();
    } else if (dom.msRequestFullScreen) {
      dom.msRequestFullScreen();
    } else {
      var features = 'fullscreen=1,status=no,resizable=yes,top=0,left=0,scrollbars=no,' + 'titlebar=no,menubar=no,location=no,toolbar=no,z-look=yes,' + 'width=' + (screen.availWidth - 8) + ',height=' + (screen.availHeight - 45);
      var newWin = window.open(location.href, '_blank', features);
      if (newWin !== null) {
        window.opener = null;
        window.close();
      }
    }
  },
  _cancelFullScreen: function _cancelFullScreen() {
    var doc = document;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen();
    } else if (doc.webkitCancelFullScreen) {
      doc.webkitCancelFullScreen();
    } else {
      var features = 'fullscreen=no,status=yes,resizable=yes,scrollbars=no,' + 'titlebar=no,menubar=yes,location=yes,toolbar=yes,z-look=yes';
      var newWin = window.open(location.href, '_blank', features);
      if (newWin !== null) {
        window.opener = null;
        window.close();
      }
    }
  }
});

Map$1.include({
  panTo: function panTo(coordinate, options = {}, step) {
    if (!coordinate) {
      return this;
    }
    if (isFunction(options)) {
      step = options;
      options = {};
    }
    coordinate = new Coordinate(coordinate);
    if (typeof options['animation'] === 'undefined' || options['animation']) {
      var prjCoord = this.getProjection().project(coordinate);
      return this._panAnimation(prjCoord, options['duration'], step);
    } else {
      this.setCenter(coordinate);
    }
    return this;
  },
  _panTo: function _panTo(prjCoord, options = {}) {
    if (typeof options['animation'] === 'undefined' || options['animation']) {
      return this._panAnimation(prjCoord, options['duration']);
    } else {
      this.onMoveStart();
      this._setPrjCenter(prjCoord);
      this.onMoveEnd(this._parseEventFromCoord(this.getCenter()));
      return this;
    }
  },
  panBy: function panBy(offset, options = {}, step) {
    if (!offset) {
      return this;
    }
    if (isFunction(options)) {
      step = options;
      options = {};
    }
    offset = new Point(offset);
    var containerExtent = this.getContainerExtent();
    var ymin = containerExtent.ymin;
    if (ymin > 0 && offset.y > 30) {
      var y = offset.y;
      offset.y = 30;
      offset.x = offset.x * 30 / y;
      console.warn('offset is limited to panBy when pitch is above maxPitch');
    }
    if (typeof options['animation'] === 'undefined' || options['animation']) {
      offset = offset.multi(-1);
      var target = this._containerPointToPrj(new Point(this.width / 2 + offset.x, this.height / 2 + offset.y));
      this._panAnimation(target, options['duration'], step);
    } else {
      this.onMoveStart();
      this._offsetCenterByPixel(offset);
      var endCoord = this.containerPointToCoord(new Point(this.width / 2, this.height / 2));
      this.onMoveEnd(this._parseEventFromCoord(endCoord));
    }
    return this;
  },
  _panAnimation: function _panAnimation(target, t, cb) {
    return this._animateTo({
      'prjCenter': target
    }, {
      'duration': t || this.options['panAnimationDuration']
    }, cb);
  }
});

Map$1.include({
  computeLength: function computeLength(coord1, coord2) {
    if (!this.getProjection()) {
      return null;
    }
    var p1 = new Coordinate(coord1),
      p2 = new Coordinate(coord2);
    if (p1.equals(p2)) {
      return 0;
    }
    return this.getProjection().measureLength(p1, p2);
  },
  computeGeometryLength: function computeGeometryLength(geometry) {
    return geometry._computeGeodesicLength(this.getProjection());
  },
  computeGeometryArea: function computeGeometryArea(geometry) {
    return geometry._computeGeodesicArea(this.getProjection());
  },
  identify: function identify(opts, callback) {
    opts = opts || {};
    var coordinate = new Coordinate(opts.coordinate);
    return this._identify(opts, callback, function (layer) {
      return layer.identify(coordinate, opts);
    });
  },
  identifyAtPoint: function identifyAtPoint(opts, callback) {
    var isMapGeometryEvent = opts.includeInternals;
    var tolerance = opts.tolerance;
    opts = opts || {};
    var containerPoint = new Point(opts['containerPoint']);
    var coordinate = this.containerPointToCoord(containerPoint);
    return this._identify(opts, callback, function (layer) {
      var result;
      var containerPoint = opts.containerPoint;
      if (isMapGeometryEvent && !isNil(layer.options.geometryEventTolerance)) {
        opts.tolerance = opts.tolerance || 0;
        opts.tolerance += layer.options.geometryEventTolerance;
      }
      if (layer._hasGeoListeners && isMapGeometryEvent && opts.eventTypes.indexOf('mousemove') >= 0) {
        if (!layer._hasGeoListeners(opts.eventTypes)) {
          return [];
        }
      }
      if (layer.identifyAtPoint) {
        result = layer.identifyAtPoint(containerPoint, opts);
      } else if (coordinate && layer.identify) {
        result = layer.identify(coordinate, opts);
      } else {
        result = [];
      }
      if (isMapGeometryEvent) {
        if (isNil(tolerance)) {
          delete opts.tolerance;
        } else {
          opts.tolerance = tolerance;
        }
      }
      if (!result || !result.length) {
        layer.fire('identifyempty', opts);
        if (layer.getLayers && isFunction(layer.getLayers)) {
          var layers = (layer.getLayers() || []).filter(function (childLayer) {
            return childLayer;
          });
          layers.forEach(function (childLayer) {
            childLayer.fire('identifyempty', opts);
          });
        }
      }
      return result;
    });
  },
  _identify: function _identify(opts, callback, fn) {
    var reqLayers = opts['layers'];
    if (!isArrayHasData(reqLayers)) {
      return this;
    }
    var eventTypes = opts.eventTypes;
    var layers = [];
    for (var i = 0, len = reqLayers.length; i < len; i++) {
      if (isString(reqLayers[i])) {
        layers.push(this.getLayer(reqLayers[i]));
      } else {
        layers.push(reqLayers[i]);
      }
    }
    if (eventTypes) {
      layers = layers.filter(function (layer) {
        if (!layer._hasGeoListeners) {
          return true;
        }
        return layer._hasGeoListeners(eventTypes);
      });
    }
    var hits = [];
    for (var _i = layers.length - 1; _i >= 0; _i--) {
      if (opts['count'] && hits.length >= opts['count']) {
        break;
      }
      var layer = layers[_i];
      if (!layer || !layer.getMap() || !opts['includeInvisible'] && !layer.isVisible() || !opts['includeInternals'] && layer.getId().indexOf(INTERNAL_LAYER_PREFIX) >= 0) {
        continue;
      }
      var layerHits = fn(layer);
      var layerId = layer.getId();
      if (layerHits) {
        if (Array.isArray(layerHits)) {
          for (var _i2 = 0; _i2 < layerHits.length; _i2++) {
            if (layerHits[_i2] && !layerHits[_i2].getLayer && isNil(layerHits[_i2].layer)) {
              layerHits[_i2].layer = layerId;
            }
          }
          pushIn(hits, layerHits);
        } else {
          if (!layerHits.getLayer && isNil(layerHits.layer)) {
            layerHits.layer = layerId;
          }
          hits.push(layerHits);
        }
      }
    }
    callback.call(this, hits);
    return this;
  }
});

Map$1.include({
  _zoom: function _zoom(nextZoom, origin) {
    if (!this.options['zoomable'] || this.isZooming()) {
      return;
    }
    origin = this._checkZoomOrigin(origin);
    nextZoom = this._checkZoom(nextZoom);
    this.onZoomStart(nextZoom, origin);
    this._frameZoom = this.getZoom();
    this.onZoomEnd(nextZoom, origin);
  },
  _zoomAnimation: function _zoomAnimation(nextZoom, origin, startScale) {
    if (!this.options['zoomable'] || this.isZooming()) {
      return;
    }
    nextZoom = this._checkZoom(nextZoom);
    if (this.getZoom() === nextZoom) {
      return;
    }
    origin = this._checkZoomOrigin(origin);
    this._startZoomAnim(nextZoom, origin, startScale);
  },
  _checkZoomOrigin: function _checkZoomOrigin(origin) {
    if (!origin || this.options['zoomInCenter'] || this._isContainerPointOutOfMap(origin)) {
      origin = new Point(this.width / 2, this.height / 2);
    }
    if (this.options['zoomOrigin']) {
      origin = new Point(this.options['zoomOrigin']);
    }
    return origin;
  },
  _startZoomAnim: function _startZoomAnim(nextZoom, origin, startScale) {
    if (isNil(startScale)) {
      startScale = 1;
    }
    var endScale = this._getResolution(this._startZoomVal) / this._getResolution(nextZoom);
    var duration = this.options['zoomAnimationDuration'] * Math.abs(endScale - startScale) / Math.abs(endScale - 1);
    this._frameZoom = this._startZoomVal;
    this._animateTo({
      'zoom': nextZoom,
      'around': origin
    }, {
      'continueOnViewChanged': true,
      'duration': duration
    });
  },
  onZoomStart: function onZoomStart(nextZoom, origin) {
    if (!this.options['zoomable'] || this.isZooming()) {
      return;
    }
    if (this._mapAnimPlayer) {
      this._stopAnim(this._mapAnimPlayer);
    }
    delete this.cameraZenithDistance;
    this._zooming = true;
    this._startZoomVal = this.getZoom();
    this._startZoomCoord = origin && this._containerPointToPrj(origin);
    this._fireEvent('zoomstart', {
      'from': this._startZoomVal,
      'to': nextZoom
    });
  },
  onZooming: function onZooming(nextZoom, origin, startScale) {
    if (!this.options['zoomable']) {
      return;
    }
    var frameZoom = this._frameZoom;
    if (frameZoom === nextZoom) {
      return;
    }
    if (isNil(startScale)) {
      startScale = 1;
    }
    this._zoomTo(nextZoom, origin);
    var res = this.getResolution(nextZoom),
      fromRes = this.getResolution(this._startZoomVal),
      scale = fromRes / res / startScale,
      startPoint = this._startZoomCoord && this.prjToContainerPoint(this._startZoomCoord, this._startZoomVal);
    var offset = this.getViewPoint();
    if (!this.isRotating() && startPoint && origin && !startPoint.equals(origin) && scale !== 1) {
      var pitch = this.getPitch();
      var originOffset = startPoint._sub(origin)._multi(1 / (1 - scale));
      if (pitch) {
        originOffset.y /= Math.cos(pitch * Math.PI / 180);
      }
      origin = origin.add(originOffset);
    }
    var originX = origin && origin.x || this.width / 2;
    var originY = origin && origin.y || this.height / 2;
    var matrix = {
      'view': [scale, 0, 0, scale, (originX - offset.x) * (1 - scale), (originY - offset.y) * (1 - scale)]
    };
    var dpr = this.getDevicePixelRatio();
    matrix['container'] = [scale, 0, 0, scale, originX * dpr * (1 - scale), originY * dpr * (1 - scale)];
    this._fireEvent('zooming', {
      'from': this._startZoomVal,
      'to': nextZoom,
      'origin': new Point(originX, originY),
      'matrix': matrix
    });
    this._frameZoom = nextZoom;
  },
  onZoomEnd: function onZoomEnd(nextZoom, origin) {
    if (!this.options['zoomable']) {
      return;
    }
    var startZoomVal = this._startZoomVal;
    this._zoomTo(nextZoom, origin);
    this._zooming = false;
    this._getRenderer().onZoomEnd();
    if (!this._suppressRecenter) {
      this._recenterOnTerrain();
    }
    this._fireEvent('zoomend', {
      'from': startZoomVal,
      'to': nextZoom
    });
    if (!this._verifyExtent(this._getPrjCenter()) && !this.options.limitExtentOnMaxExtent) {
      this._panTo(this._prjMaxExtent.getCenter());
    }
  },
  _zoomTo: function _zoomTo(nextZoom, origin) {
    this._zoomLevel = nextZoom;
    this._calcMatrices();
    if (origin && this._startZoomCoord) {
      var p = this._containerPointToPoint(origin);
      var offset = p._sub(this._prjToPoint(this._getPrjCenter()));
      this._setPrjCoordAtOffsetToCenter(this._startZoomCoord, offset);
    }
  },
  _checkZoom: function _checkZoom(nextZoom) {
    var maxZoom = this.getMaxZoom(),
      minZoom = this.getMinZoom();
    if (nextZoom < minZoom) {
      nextZoom = minZoom;
    }
    if (nextZoom > maxZoom) {
      nextZoom = maxZoom;
    }
    return nextZoom;
  }
});

function applyMatrix(out, v, e) {
  var x = v[0],
    y = v[1],
    z = v[2];
  var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
  out[0] = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
  out[1] = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
  out[2] = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
  return out;
}
function matrixToQuaternion(out, te) {
  var m11 = te[0],
    m12 = te[4],
    m13 = te[8],
    m21 = te[1],
    m22 = te[5],
    m23 = te[9],
    m31 = te[2],
    m32 = te[6],
    m33 = te[10],
    trace = m11 + m22 + m33;
  var s;
  if (trace > 0) {
    s = 0.5 / Math.sqrt(trace + 1.0);
    out.w = 0.25 / s;
    out.x = (m32 - m23) * s;
    out.y = (m13 - m31) * s;
    out.z = (m21 - m12) * s;
  } else if (m11 > m22 && m11 > m33) {
    s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
    out.w = (m32 - m23) / s;
    out.x = 0.25 * s;
    out.y = (m12 + m21) / s;
    out.z = (m13 + m31) / s;
  } else if (m22 > m33) {
    s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
    out.w = (m13 - m31) / s;
    out.x = (m12 + m21) / s;
    out.y = 0.25 * s;
    out.z = (m23 + m32) / s;
  } else {
    s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
    out.w = (m21 - m12) / s;
    out.x = (m13 + m31) / s;
    out.y = (m23 + m32) / s;
    out.z = 0.25 * s;
  }
  return this;
}
function quaternionToMatrix(out, q) {
  var te = out;
  var x = q.x,
    y = q.y,
    z = q.z,
    w = q.w;
  var x2 = x + x,
    y2 = y + y,
    z2 = z + z;
  var xx = x * x2,
    xy = x * y2,
    xz = x * z2;
  var yy = y * y2,
    yz = y * z2,
    zz = z * z2;
  var wx = w * x2,
    wy = w * y2,
    wz = w * z2;
  te[0] = 1 - (yy + zz);
  te[4] = xy - wz;
  te[8] = xz + wy;
  te[1] = xy + wz;
  te[5] = 1 - (xx + zz);
  te[9] = yz - wx;
  te[2] = xz - wy;
  te[6] = yz + wx;
  te[10] = 1 - (xx + yy);
  te[3] = 0;
  te[7] = 0;
  te[11] = 0;
  te[12] = 0;
  te[13] = 0;
  te[14] = 0;
  te[15] = 1;
  return te;
}
function setPosition(out, v) {
  var te = out;
  te[12] = v[0];
  te[13] = v[1];
  te[14] = v[2];
  return out;
}
function lookAt(te, eye, target, up) {
  var x = [0, 0, 0];
  var y = [0, 0, 0];
  var z = [0, 0, 0];
  subtract(z, eye, target);
  if (length(z) === 0) {
    z[2] = 1;
  }
  normalize(z, z);
  cross(x, up, z);
  if (length(z) === 0) {
    if (Math.abs(up[2]) === 1) {
      z[0] += 0.0001;
    } else {
      z[2] += 0.0001;
    }
    normalize(z, z);
    cross(x, up, z);
  }
  normalize(x, x);
  cross(y, z, x);
  te[0] = x[0];
  te[4] = y[0];
  te[8] = z[0];
  te[1] = x[1];
  te[5] = y[1];
  te[9] = z[1];
  te[2] = x[2];
  te[6] = y[2];
  te[10] = z[2];
  return te;
}

var RADIAN = Math.PI / 180;
var DEFAULT_FOV = 0.6435011087932844;
var TEMP_COORD$1 = new Coordinate(0, 0);
var TEMP_POINT$4 = new Point(0, 0);
var SOUTH = [0, -1, 0],
  BEARING = [];
Map$1.include({
  getFov: function getFov() {
    if (!this._fov) {
      this._fov = DEFAULT_FOV;
    }
    return this._fov / RADIAN;
  },
  setFov: function setFov(fov) {
    if (this.isZooming()) {
      return this;
    }
    fov = Math.max(0.01, Math.min(60, fov));
    if (this._fov === fov) return this;
    var from = this.getFov();
    this._fov = fov * RADIAN;
    this._calcMatrices();
    this._renderLayers();
    this._fireEvent('fovchange', {
      'from': from,
      'to': this.getFov()
    });
    return this;
  },
  getBearing: function getBearing() {
    if (!this._angle) {
      return 0;
    }
    return -this._angle / RADIAN;
  },
  setBearing: function setBearing(bearing) {
    var view = {
      bearing: bearing
    };
    this._validateView(view);
    if (this._mapAnimPlayer) {
      this._stopAnim(this._mapAnimPlayer);
    }
    return this._setBearing(view.bearing);
  },
  _setBearing: function _setBearing(bearing) {
    if (Browser$1.ie9) {
      throw new Error('map can\'t rotate in IE9.');
    }
    var b = -wrap(bearing, -180, 180) * RADIAN;
    if (this._angle === b) return this;
    var from = this.getBearing();
    this._fireEvent('rotatestart', {
      'from': from,
      'to': b
    });
    this._angle = b;
    this._calcMatrices();
    this._renderLayers();
    this._fireEvent('rotate', {
      'from': from,
      'to': b
    });
    this._fireEvent('rotateend', {
      'from': from,
      'to': b
    });
    return this;
  },
  getPitch: function getPitch() {
    if (!this._pitch) {
      return 0;
    }
    return this._pitch / Math.PI * 180;
  },
  setPitch: function setPitch(pitch) {
    var view = {
      pitch: pitch
    };
    this._validateView(view);
    if (this._mapAnimPlayer) {
      this._stopAnim(this._mapAnimPlayer);
    }
    return this._setPitch(view.pitch);
  },
  _setPitch: function _setPitch(pitch) {
    if (Browser$1.ie9) {
      throw new Error('map can\'t tilt in IE9.');
    }
    var p = clamp(pitch, 0, this.options['maxPitch']) * RADIAN;
    if (this._pitch === p) return this;
    var from = this.getPitch();
    this._fireEvent('pitchstart', {
      'from': from,
      'to': p
    });
    this._pitch = p;
    this._calcMatrices();
    this._renderLayers();
    this._fireEvent('pitch', {
      'from': from,
      'to': p
    });
    this._fireEvent('pitchend', {
      'from': from,
      'to': p
    });
    return this;
  },
  setCameraMovements: function setCameraMovements(frameOptions, extraOptions) {
    var _this = this;
    if (!Array.isArray(frameOptions) || !frameOptions.length) {
      return this;
    }
    frameOptions.forEach(function (frameOption) {
      _this._validateView(frameOption);
    });
    this.setView({
      center: frameOptions[0].center,
      zoom: frameOptions[0].zoom,
      pitch: frameOptions[0].pitch,
      bearing: frameOptions[0].bearing
    });
    if (frameOptions.length === 1) return this;
    var index = 1;
    var _onFrame = function onFrame(frame) {
      if (frame.state.playState === 'finished') {
        index++;
        if (index === frameOptions.length - 1) _onFrame = null;
        var frameOption = frameOptions[index];
        frameOption.duration = frameOption.timestamp - frameOptions[index - 1].timestamp;
        if (extraOptions && extraOptions.autoRotate) {
          frameOption.bearing = calculateBearing(frameOptions[index - 1].center, frameOption.center);
        }
        _this._setCameraMovement(frameOption, _onFrame);
      }
    };
    if (frameOptions.length === 2) _onFrame = null;
    var currentBearing = this.getBearing();
    this._setCameraMovement(Object.assign({
      bearing: currentBearing,
      duration: frameOptions[index].timestamp - frameOptions[index - 1].timestamp
    }, frameOptions[index]), _onFrame);
    var play = function play() {
      _this._animPlayer.play();
    };
    var pause = function pause() {
      _this._animPlayer.pause();
    };
    var cancel = function cancel() {
      _this._animPlayer.cancel();
    };
    var finish = function finish() {
      _this._animPlayer.finish();
    };
    var reverse = function reverse() {
      _this._animPlayer.reverse();
    };
    return {
      play: play,
      pause: pause,
      cancel: cancel,
      finish: finish,
      reverse: reverse
    };
  },
  _setCameraMovement: function _setCameraMovement(frameOption, frame) {
    this.animateTo({
      zoom: frameOption.zoom,
      center: frameOption.center,
      pitch: frameOption.pitch,
      bearing: frameOption.bearing
    }, {
      duration: frameOption.duration,
      easing: 'out'
    }, frame);
  },
  lookAt: function lookAt(params) {
    var {
      coordinates: coordinates,
      bearing: bearing,
      pitch: pitch,
      distance: distance
    } = params;
    coordinates = params.center || coordinates;
    if (Array.isArray(coordinates)) {
      coordinates = new Coordinate(coordinates);
    }
    if (!coordinates.z && !distance) {
      return this.setCenter(coordinates);
    }
    var glRes = this.getGLRes();
    bearing = isNil(bearing) ? this.getBearing() : bearing;
    pitch = isNil(pitch) ? this.getPitch() : pitch;
    var radPitch = pitch * RADIAN;
    var radBearing = bearing * RADIAN;
    if (distance) {
      var distZ = distance * Math.sin(radPitch);
      var xyDist = Math.sin(radPitch) * distance;
      var distX = xyDist * Math.sin(radBearing);
      var distY = xyDist * Math.cos(radBearing);
      distZ = distZ * this._meterToGLPoint;
      xyDist = this.distanceToPointAtRes(distX, distY, glRes).mag();
      distance = Math.sqrt(xyDist * xyDist + distZ * distZ);
    }
    var point = this.coordToPointAtRes(coordinates, glRes);
    point.z = 0;
    if (coordinates.z) {
      point.z = coordinates.z * this._meterToGLPoint;
    }
    var cameraToTargetDistance = distance || this.cameraToGroundDistance || this.cameraToCenterDistance;
    var xyDistance = Math.sin(radPitch) * cameraToTargetDistance;
    var cz = cameraToTargetDistance * Math.cos(radPitch);
    var cx = point.x - xyDistance * Math.sin(radBearing);
    var cy = point.y - xyDistance * Math.cos(radBearing);
    var cameraPosition = [cx, cy, cz + point.z];
    var cameraPoint = new Point(cameraPosition);
    var cameraCoord = this.pointAtResToCoord(cameraPoint, glRes);
    var cameraAltitude = cameraPoint.z / this._meterToGLPoint;
    cameraCoord.z = cameraAltitude;
    return this.setCameraOrientation({
      position: cameraCoord.toArray(),
      bearing: bearing,
      pitch: pitch
    });
  },
  setCameraOrientation: function setCameraOrientation(params) {
    var {
      position: position
    } = params;
    this._validateView(params);
    var {
      pitch: pitch,
      bearing: bearing
    } = params;
    pitch = pitch || 0;
    bearing = bearing || 0;
    var {
      zoom: zoom,
      cameraToGroundDistance: cameraToGroundDistance
    } = this.getFitZoomForCamera(position, pitch);
    var dist = Math.sin(pitch * RADIAN) * cameraToGroundDistance;
    var wrapBearing = wrap(bearing, -180, 180);
    var bearingRadian = wrapBearing * RADIAN;
    var glRes = this.getGLRes();
    var tempCoord = new Coordinate(position[0], position[1]);
    var tempPoint = this.coordToPointAtRes(tempCoord, glRes);
    var point = new Point(0, 0);
    point.x = tempPoint.x + dist * Math.sin(bearingRadian);
    point.y = tempPoint.y + dist * Math.cos(bearingRadian);
    var prjCenter = this._pointToPrjAtRes(point, this.getGLRes());
    this._setPrjCenter(prjCenter);
    this.setView({
      bearing: bearing,
      pitch: pitch,
      zoom: zoom
    });
    return this;
  },
  setCameraPosition: function setCameraPosition(coordinate) {
    var glRes = this.getGLRes();
    var cameraPoint = this.coordToPointAtRes(coordinate, glRes);
    cameraPoint.z = this.altitudeToPoint(coordinate.z || 0, glRes);
    var center = this.getCenter();
    var centerPoint = this.coordToPointAtRes(center, glRes);
    centerPoint.z = this.altitudeToPoint(center.z, glRes);
    var direction = subtract([], cameraPoint.toArray(), centerPoint.toArray());
    set(this.cameraUp || [0, 0, 0], 0, 0, 1);
    this._pitch = angle(direction, this.cameraUp);
    set(BEARING, direction[0], direction[1], 0);
    this._angle = -angle(BEARING, SOUTH);
    this._zoomLevel = this.getFitZoomForCamera(coordinate, this._pitch).zoom;
    this._calcMatrices();
    return this;
  },
  getFitZoomForCamera: function getFitZoomForCamera(cameraPosition, pitch) {
    if (!isNumber(pitch)) {
      pitch = 0;
    }
    var z = Array.isArray(cameraPosition) ? cameraPosition[2] || 0 : cameraPosition.z || 0;
    var cameraAltitude = z * this._meterToGLPoint;
    var centerAltitude = this.centerAltitude || 0;
    var centerPointZ = centerAltitude * this._meterToGLPoint;
    var cz = cameraAltitude - centerPointZ;
    var pitchRadian = pitch * RADIAN;
    var cameraToGroundDistance = cz / Math.cos(pitchRadian);
    var cameraToCenterDistance = cameraToGroundDistance + centerPointZ;
    var zoom = this.getFitZoomForAltitude(cameraToCenterDistance);
    return {
      zoom: zoom,
      cameraToGroundDistance: cameraToGroundDistance
    };
  },
  getFitZoomForAltitude: function getFitZoomForAltitude(distance) {
    var ratio = this._getFovRatio();
    var res = distance * ratio * 2 / (this.height || 1) * this.getGLRes();
    return this.getZoomFromRes(res);
  },
  isTransforming: function isTransforming() {
    return !!(this._pitch || this._angle || this._terrainLayer);
  },
  getFrustumAltitude: function getFrustumAltitude() {
    return this._frustumAltitude;
  },
  _calcFrustumAltitude: function _calcFrustumAltitude() {
    var pitch = 90 - this.getPitch();
    var fov = this.getFov() / 2;
    var cameraAlt = this.cameraPosition ? this.cameraPosition[2] : 0;
    if (fov <= pitch) {
      return cameraAlt;
    }
    fov = Math.PI * fov / 180;
    var d1 = new Point(this.cameraPosition).distanceTo(new Point(this.cameraLookAt)),
      d2 = cameraAlt * Math.tan(fov * 2);
    var d = Math.tan(fov) * (d1 + d2);
    return cameraAlt + d;
  },
  _pointToContainerPoint: function _pointToContainerPoint(point, zoom, altitude = 0, out) {
    var res = this._getResolution(zoom);
    return this._pointAtResToContainerPoint(point, res, altitude, out);
  },
  _pointAtResToContainerPoint: function _pointAtResToContainerPoint(point, res, altitude = 0, out) {
    if (!out) {
      out = new Point(0, 0);
    }
    point = this._pointAtResToPoint(point, res, out);
    var isTransforming = this.isTransforming();
    var centerPoint;
    if (!isTransforming && !altitude) {
      centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD$1);
    }
    this._toContainerPoint(out, isTransforming, altitude, centerPoint);
    return out;
  },
  _pointsAtResToContainerPoints: function _pointsAtResToContainerPoints(points, targetRes, altitudes = [], resultPoints = []) {
    var pitch = this.getPitch(),
      bearing = this.getBearing();
    var scale = targetRes / this._getResolution();
    if (pitch === 0 && bearing === 0 && !altitudesHasData(altitudes)) {
      var {
        xmin: xmin,
        ymin: ymin,
        xmax: xmax,
        ymax: ymax
      } = this.get2DExtent();
      if (xmax > xmin && ymax > ymin) {
        var {
          width: width,
          height: height
        } = this.getSize();
        var dxPerPixel = (xmax - xmin) / width,
          dyPerPixel = (ymax - ymin) / height;
        for (var i = 0, len = points.length; i < len; i++) {
          if (!points[i]) {
            resultPoints[i] = null;
            continue;
          }
          var pt = resultPoints[i];
          pt.x = points[i].x;
          pt.y = points[i].y;
          pt._multi(scale);
          pt.x = (pt.x - xmin) * dxPerPixel;
          pt.y = height - (pt.y - ymin) * dyPerPixel;
        }
        return resultPoints;
      }
    }
    var altitudeIsArray = Array.isArray(altitudes);
    var isTransforming = this.isTransforming();
    var centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD$1);
    for (var _i = 0, _len = points.length; _i < _len; _i++) {
      if (!points[_i]) {
        resultPoints[_i] = null;
        continue;
      }
      var _pt = resultPoints[_i];
      _pt.x = points[_i].x;
      _pt.y = points[_i].y;
      _pt._multi(scale);
      var altitude = altitudeIsArray ? altitudes[_i] || 0 : altitudes;
      this._toContainerPoint(_pt, isTransforming, altitude, centerPoint);
    }
    return resultPoints;
  },
  _toContainerPoint: function () {
    var a = [0, 0, 0];
    return function (out, isTransforming, altitude, centerPoint) {
      var w2 = this.width / 2,
        h2 = this.height / 2;
      if (isTransforming || altitude) {
        if (!this._altitudeScale) {
          this._altitudeScale = this.altitudeToPoint(100, this.getGLRes()) / 100;
        }
        var _scale = this._glScale;
        set(a, out.x * _scale, out.y * _scale, altitude * this._altitudeScale);
        var t = this._projIfBehindCamera(a, this.cameraPosition, this.cameraForward);
        applyMatrix(t, t, this.projViewMatrix);
        out.x = t[0] * w2 + w2;
        out.y = -(t[1] * h2) + h2;
      } else {
        out._sub(centerPoint.x, centerPoint.y);
        out.set(out.x, -out.y);
        out._add(w2, h2);
      }
    };
  }(),
  _projIfBehindCamera: function () {
    var vectorFromCam = new Array(3);
    var proj = new Array(3);
    var sub = new Array(3);
    return function (position, cameraPos, camForward) {
      subtract(vectorFromCam, position, cameraPos);
      var camNormDot = dot(camForward, vectorFromCam);
      if (camNormDot <= 0) {
        scale(proj, camForward, camNormDot * 1.01);
        add(position, cameraPos, subtract(sub, vectorFromCam, proj));
      }
      return position;
    };
  }(),
  _containerPointToPoint: function _containerPointToPoint(p, zoom, out, height) {
    var res = this._getResolution(zoom);
    return this._containerPointToPointAtRes(p, res, out, height);
  },
  _containerPointToPointAtRes: function () {
    var coord0 = [0, 0, 0],
      coord1 = [0, 0, 0];
    return function (p, res, out, height) {
      if (this.isTransforming() || !!height) {
        this.getContainerPointRay(coord0, coord1, p);
        var x0 = coord0[0];
        var x1 = coord1[0];
        var y0 = coord0[1];
        var y1 = coord1[1];
        var z0 = coord0[2];
        var z1 = coord1[2];
        var glRes = this.getGLRes();
        var altitudePoint = !height ? 0 : this.altitudeToPoint(height, glRes);
        var t = z0 === z1 ? altitudePoint : (altitudePoint - z0) / (z1 - z0);
        var _x = interpolate$3(x0, x1, t);
        var _y = interpolate$3(y0, y1, t);
        if (out) {
          out.x = _x;
          out.y = _y;
        } else {
          out = new Point(_x, _y);
        }
        out._multi(1 / this._glScale);
        return this._getResolution() === res ? out : this._pointToPointAtRes(out, res, out);
      }
      var centerPoint = this._prjToPointAtRes(this._getPrjCenter(), res, out),
        scale = this._getResolution() / res;
      var x = scale * (p.x - this.width / 2),
        y = scale * (p.y - this.height / 2);
      return centerPoint._add(x, -y);
    };
  }(),
  getContainerPointRay: function () {
    var cp = [0, 0, 0],
      coord0 = [0, 0, 0, 1],
      coord1 = [0, 0, 0, 1];
    return function (from, to, containerPoint, near = 0, far = 1) {
      var w2 = this.width / 2 || 1,
        h2 = this.height / 2 || 1;
      var p = containerPoint;
      set(cp, (p.x - w2) / w2, (h2 - p.y) / h2, 0);
      set(coord0, cp[0], cp[1], near);
      set(coord1, cp[0], cp[1], far);
      coord0[3] = coord1[3] = 1;
      applyMatrix(from, coord0, this.projViewMatrixInverse);
      applyMatrix(to, coord1, this.projViewMatrixInverse);
    };
  }(),
  _calcMatrices: function () {
    var m1 = createMat4();
    return function () {
      delete this._mapRes;
      delete this._mapGlRes;
      delete this._mapExtent2D;
      delete this._mapGlExtent2D;
      var size = this.getSize();
      var w = size.width || 1,
        h = size.height || 1;
      this._glScale = this.getGLScale();
      var worldMatrix = this._getCameraWorldMatrix();
      var fov = this.getFov() * Math.PI / 180;
      var farZ = this._getCameraFar(fov, this.getPitch());
      this.cameraFar = farZ;
      this.cameraNear = this.cameraCenterDistance / 20 * this.options['cameraNearScale'];
      var projMatrix = this.projMatrix || createMat4();
      var isWebGPU = this.options.renderer === 'gpu';
      if (isWebGPU) {
        perspectiveZO(projMatrix, fov, w / h, this.cameraNear, farZ);
      } else {
        perspective(projMatrix, fov, w / h, this.cameraNear, farZ);
      }
      this.projMatrix = projMatrix;
      this.viewMatrix = invert(this.viewMatrix || createMat4(), worldMatrix);
      this.projViewMatrix = multiply(this.projViewMatrix || createMat4(), projMatrix, this.viewMatrix);
      this._calcCascadeMatrixes();
      this.projViewMatrixInverse = multiply(this.projViewMatrixInverse || createMat4(), worldMatrix, invert(m1, projMatrix));
      this.domCssMatrix = this._calcDomMatrix();
      this._frustumAltitude = this._calcFrustumAltitude();
      this._mapRes = this._getResolution();
      this._mapGlRes = this.getGLRes();
      this._mapExtent2D = this.get2DExtent();
      this._mapGlExtent2D = this.get2DExtentAtRes(this._mapGlRes);
      var renderer = this.getRenderer();
      if (renderer && renderer._updateMapStateCache) {
        renderer._updateMapStateCache();
      }
    };
  }(),
  _getCameraFar: function _getCameraFar(fov, pitch) {
    var cameraCenterDistance = this.cameraCenterDistance = distance(this.cameraPosition, this.cameraLookAt);
    var distanceInMeter = cameraCenterDistance / this._meterToGLPoint;
    pitch = Math.min(pitch, 85);
    pitch = pitch * Math.PI / 180;
    var cameraFarDistance = distanceInMeter + this.options['cameraFarUndergroundInMeter'] / Math.cos(pitch);
    return Math.max(cameraFarDistance * this._meterToGLPoint, cameraCenterDistance * 5);
  },
  _calcCascadeMatrixes: function () {
    var projMatrix = createMat4();
    function cal(curPitch, pitch, out) {
      var w = this.width;
      var h = this.height;
      var fov = this.getFov() * Math.PI / 180;
      var farZ = this._getCameraFar(fov, pitch);
      var cameraCenterDistance = this.cameraCenterDistance;
      farZ = cameraCenterDistance + (farZ - cameraCenterDistance) / Math.cos((90 - pitch) * Math.PI / 180) * Math.cos((90 - curPitch) * Math.PI / 180);
      perspective(projMatrix, fov, w / h, 0.1, farZ);
      var viewMatrix = this.viewMatrix;
      return multiply(out, projMatrix, viewMatrix);
    }
    return function () {
      var pitch = this.getPitch();
      var cascadePitch0 = this.options['cascadePitches'][0];
      var cascadePitch1 = this.options['cascadePitches'][1];
      var projViewMatrix0 = this.cascadeFrustumMatrix0 = this.cascadeFrustumMatrix0 || createMat4();
      var projViewMatrix1 = this.cascadeFrustumMatrix1 = this.cascadeFrustumMatrix1 || createMat4();
      if (pitch > cascadePitch0) {
        cal.call(this, pitch, cascadePitch0, projViewMatrix0);
      } else {
        copy$1(this.cascadeFrustumMatrix0, this.projViewMatrix);
      }
      if (pitch > cascadePitch1) {
        cal.call(this, pitch, cascadePitch1, projViewMatrix1);
      } else {
        copy$1(this.cascadeFrustumMatrix1, this.cascadeFrustumMatrix0);
      }
    };
  }(),
  _calcDomMatrix: function () {
    var m = createMat4(),
      m1 = createMat4(),
      minusY = [1, -1, 1],
      arr = [0, 0, 0];
    return function () {
      var width = this.width || 1;
      var height = this.height || 1;
      var cameraToCenterDistance = 0.5 / Math.tan(this._fov / 2) * height;
      scale$1(m, this.projMatrix, minusY);
      translate(m, m, set(arr, 0, 0, -cameraToCenterDistance));
      if (this._pitch) {
        rotateX(m, m, this._pitch);
      }
      if (this._angle) {
        rotateZ(m, m, this._angle);
      }
      identity$1(m1);
      scale$1(m1, m1, set(arr, width / 2, -height / 2, 1));
      return multiply(this.domCssMatrix || createMat4(), m1, m);
    };
  }(),
  _getFovZ: function _getFovZ(zoom) {
    var scale = this.getGLScale(zoom);
    var ratio = this._getFovRatio();
    return scale * (this.height || 1) / 2 / ratio;
  },
  _getCameraWorldMatrix: function () {
    var q = {};
    return function () {
      var glRes = this.getGLRes();
      if (!this._meterToGLPoint) {
        this._meterToGLPoint = this.altitudeToPoint(100, glRes) / 100;
      }
      var center2D = this._prjToPointAtRes(this._prjCenter, glRes, TEMP_POINT$4);
      var altitude = this.getCenter().z;
      var centerAltitude = altitude !== undefined ? altitude : this.centerAltitude || 0;
      var centerPointZ = centerAltitude * this._meterToGLPoint;
      this.cameraLookAt = set(this.cameraLookAt || [0, 0, 0], center2D.x, center2D.y, centerPointZ);
      var pitch = this.getPitch() * RADIAN;
      var bearing = this.getBearing() * RADIAN;
      var cameraToCenterDistance = this._getFovZ();
      var cameraZenithDistance = this.cameraZenithDistance === undefined ? cameraToCenterDistance : this.cameraZenithDistance;
      var cameraToGroundDistance = cameraZenithDistance - centerPointZ;
      this.cameraToGroundDistance = cameraToGroundDistance;
      var cz = cameraToGroundDistance * Math.cos(pitch);
      var dist = Math.sin(pitch) * cameraToGroundDistance;
      var cx = center2D.x - dist * Math.sin(bearing);
      var cy = center2D.y - dist * Math.cos(bearing);
      this.cameraPosition = set(this.cameraPosition || [0, 0, 0], cx, cy, cz + centerPointZ);
      this.cameraToCenterDistance = cameraToCenterDistance;
      this.cameraUp = this.cameraUp || [0, 0, 0];
      this.cameraUp = this._getCameraUp(this.cameraUp, this.cameraLookAt, this.cameraPosition, pitch, bearing);
      var m = this.cameraWorldMatrix = this.cameraWorldMatrix || createMat4();
      lookAt(m, this.cameraPosition, this.cameraLookAt, this.cameraUp);
      var cameraForward = this.cameraForward || [0, 0, 0];
      subtract(cameraForward, this.cameraLookAt, this.cameraPosition);
      this.cameraForward = normalize(cameraForward, cameraForward);
      matrixToQuaternion(q, m);
      quaternionToMatrix(m, q);
      setPosition(m, this.cameraPosition);
      return m;
    };
  }(),
  _getCameraUp: function () {
    var q = [0, 0, 0];
    var c = [0, 0, 0];
    var axis = [0, 0, 0];
    return function (out, cameraPosition, cameraLookAt, pitch, bearing) {
      set(axis, 0, 0, 1);
      if (pitch === 0) {
        set(axis, Math.sin(bearing), Math.cos(bearing), 0);
      } else if (pitch === Math.PI) {
        set(axis, -Math.sin(bearing), -Math.cos(bearing), 0);
      }
      var lookAt = subtract(q, cameraPosition, cameraLookAt);
      normalize(lookAt, lookAt);
      var right = cross(c, lookAt, axis);
      return cross(out, right, lookAt);
    };
  }(),
  updateCenterAltitude: function updateCenterAltitude() {
    this.getRenderer().setToRedraw();
    if (!this.centerAltitude && this._hasAltitudeLayer()) {
      this.centerAltitude = 0;
    }
    this._recenterOnTerrain();
  },
  _recenterOnTerrain: function _recenterOnTerrain() {
    if (this.centerAltitude === undefined) {
      return;
    }
    var queriedAltitude = this._queryTerrainByProjCoord(this._prjCenter);
    if (isNil(queriedAltitude) && this._hasAltitudeLayer()) {
      queriedAltitude = this.centerAltitude;
    }
    if (queriedAltitude >= this.centerAltitude) {
      return;
    }
    var centerAltitude = queriedAltitude > 0 && queriedAltitude || 0;
    var pitch = this.getPitch() * RADIAN;
    var bearing = this.getBearing() * RADIAN;
    var altDist = (centerAltitude - this.centerAltitude) * this._meterToGLPoint;
    var cameraToCenterDistance = this._getFovZ();
    var cameraZenithDistance = this.cameraZenithDistance === undefined ? cameraToCenterDistance : this.cameraZenithDistance;
    var cameraToGroundDistance = cameraZenithDistance - this.centerAltitude * this._meterToGLPoint;
    var newCameraToGroundDistance = cameraToGroundDistance - altDist / Math.cos(pitch);
    var cameraPosition = this.cameraPosition;
    var dist = Math.sin(pitch) * newCameraToGroundDistance;
    var center2D = TEMP_POINT$4;
    center2D.x = cameraPosition[0] + dist * Math.sin(bearing);
    center2D.y = cameraPosition[1] + dist * Math.cos(bearing);
    var centerPointZ = centerAltitude * this._meterToGLPoint;
    this.cameraZenithDistance = (cameraPosition[2] - centerPointZ) / Math.cos(pitch) + centerPointZ;
    this.centerAltitude = centerAltitude;
    var newCenter = this.pointAtResToCoordinate(center2D, this.getGLRes(), TEMP_COORD$1);
    this._eventSilence = true;
    this._suppressRecenter = true;
    this.setCenter(newCenter);
    delete this._suppressRecenter;
    delete this._eventSilence;
    if (isNil(queriedAltitude)) {
      delete this.centerAltitude;
    }
  },
  _queryTerrainByProjCoord: function _queryTerrainByProjCoord(coord) {
    var layers = this._getLayers();
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].queryTerrainByProjCoord) {
        return layers[i].queryTerrainByProjCoord(coord)[0];
      }
    }
    return 0;
  },
  _hasAltitudeLayer: function _hasAltitudeLayer() {
    var layers = this._getLayers();
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].getTerrainLayer && layers[i].getTerrainLayer()) {
        return true;
      }
    }
    return false;
  },
  _queryTerrainInfo: function _queryTerrainInfo(containerPoint) {
    if (containerPoint) {
      var terrainLayer = this._findTerrainLayer();
      if (!terrainLayer) {
        return null;
      }
      var coordinate = terrainLayer.queryTerrainAtPoint(containerPoint);
      if (coordinate) {
        return {
          coordinate: coordinate,
          altitude: coordinate.z
        };
      }
    }
    return null;
  },
  _query3DTilesInfo: function _query3DTilesInfo(containerPoint) {
    var layers = this._getLayers() || [];
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if (containerPoint && layer && layer.query3DTilesAtPoint) {
        var coordinate = layer.query3DTilesAtPoint(containerPoint);
        if (coordinate) {
          return {
            coordinate: coordinate,
            altitude: coordinate.z
          };
        } else {
          break;
        }
      }
    }
    return null;
  },
  queryPrjCoordAtContainerPoint: function queryPrjCoordAtContainerPoint(p) {
    var queryCoord = this._query3DTilesInfo(p);
    if (!queryCoord) {
      queryCoord = this._queryTerrainInfo(p);
    }
    if (queryCoord) {
      var prjCoord = this.getProjection().project(queryCoord.coordinate);
      prjCoord.z = queryCoord.altitude;
      return prjCoord;
    }
    if (this._isContainerPointOutOfMap(p)) {
      p = new Point(this.width / 2, this.height / 2);
    }
    return this._containerPointToPrj(p);
  },
  _getFovRatio: function _getFovRatio() {
    var fov = this.getFov();
    return Math.tan(fov / 2 * RADIAN);
  },
  _renderLayers: function _renderLayers() {
    if (this.isInteracting()) {
      return;
    }
    var layers = this._getLayers();
    layers.forEach(function (layer) {
      if (!layer) {
        return;
      }
      var renderer = layer._getRenderer();
      if (renderer && renderer.setToRedraw) {
        renderer.setToRedraw();
      }
    });
  }
});
function createMat4() {
  return identity$1(new Array(16));
}
function calculateBearing(start, end) {
  var lon1 = toRadian(start[0]);
  var lon2 = toRadian(end[0]);
  var lat1 = toRadian(start[1]);
  var lat2 = toRadian(end[1]);
  var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
  var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
  return toDegree(Math.atan2(a, b));
}

Map$1.include({
  _onViewChange: function _onViewChange(view) {
    if (!this._viewHistory) {
      this._viewHistory = [];
      this._viewHistoryPointer = 0;
    }
    var old = this._getCurrentView();
    for (var i = this._viewHistory.length - 1; i >= 0; i--) {
      if (equalMapView(view, this._viewHistory[i])) {
        this._viewHistoryPointer = i;
        this._fireViewChange(old, view);
        return;
      }
    }
    if (this._viewHistoryPointer < this._viewHistory.length - 1) {
      this._viewHistory.splice(this._viewHistoryPointer + 1);
    }
    this._viewHistory.push(view);
    var count = this.options['viewHistoryCount'];
    if (count > 0 && this._viewHistory.length > count) {
      this._viewHistory.splice(0, this._viewHistory.length - count);
    }
    this._viewHistoryPointer = this._viewHistory.length - 1;
    this._fireViewChange(old, view);
  },
  zoomToPreviousView: function zoomToPreviousView(options = {}) {
    if (!this.hasPreviousView()) {
      return null;
    }
    var view = this._viewHistory[--this._viewHistoryPointer];
    this._zoomToView(view, options);
    return view;
  },
  hasPreviousView: function hasPreviousView() {
    if (!this._viewHistory || this._viewHistoryPointer === 0) {
      return false;
    }
    return true;
  },
  zoomToNextView: function zoomToNextView(options = {}) {
    if (!this.hasNextView()) {
      return null;
    }
    var view = this._viewHistory[++this._viewHistoryPointer];
    this._zoomToView(view, options);
    return view;
  },
  hasNextView: function hasNextView() {
    if (!this._viewHistory || this._viewHistoryPointer === this._viewHistory.length - 1) {
      return false;
    }
    return true;
  },
  _zoomToView: function _zoomToView(view, options) {
    var _this = this;
    var old = this.getView();
    if (options['animation']) {
      this._animateTo(view, {
        'duration': options['duration']
      }, function (frame) {
        if (frame.state.playState === 'finished') {
          _this._fireViewChange(old, view);
        }
      });
    } else {
      this.setView(view);
      this._fireViewChange(old, view);
    }
  },
  getViewHistory: function getViewHistory() {
    return this._viewHistory;
  },
  _fireViewChange: function _fireViewChange(old, view) {
    this._fireEvent('viewchange', {
      'old': old,
      'new': view
    });
    this._insertUICollidesQueue();
  },
  _getCurrentView: function _getCurrentView() {
    if (!this._viewHistory) {
      return null;
    }
    return this._viewHistory[this._viewHistoryPointer];
  }
});
Map$1.mergeOptions({
  'viewHistory': true,
  'viewHistoryCount': 10
});

var UICollisionIndex = new CollisionIndex();
Map$1.include({
  getCollisionIndex: function getCollisionIndex() {
    if (!this._collisionIndex) {
      this.createCollisionIndex();
    }
    return this._collisionIndex || this.createCollisionIndex();
  },
  createCollisionIndex: function createCollisionIndex() {
    this.clearCollisionIndex();
    this._collisionIndex = new CollisionIndex();
    return this._collisionIndex;
  },
  clearCollisionIndex: function clearCollisionIndex() {
    this.collisionFrameTime = 0;
    if (this._collisionIndex) {
      this._collisionIndex.clear();
    }
    return this;
  },
  _insertUICollidesQueue: function _insertUICollidesQueue() {
    if (!this._uiCollidesQueue) {
      this._uiCollidesQueue = [];
    }
    this._uiCollidesQueue.push(1);
    return this;
  },
  uiCollides: function uiCollides() {
    if (!this.uiList || this.uiList.length === 0 || !this._uiCollidesQueue || this._uiCollidesQueue.length === 0) {
      return this;
    }
    var collisionIndex = UICollisionIndex;
    collisionIndex.clear();
    var uiList = this.uiList;
    for (var i = 0, len = uiList.length; i < len; i++) {
      var ui = uiList[i];
      var {
        collisionBufferSize: collisionBufferSize,
        collision: collision
      } = ui.options;
      if (!collision) {
        ui._collidesEffect(true);
        continue;
      }
      var dom = ui.getDOM();
      if (!ui.isVisible() || !dom) {
        continue;
      }
      if (!dom.getBoundingClientRect) {
        continue;
      }
      if (!ui.bbox) {
        ui.bbox = [0, 0, 0, 0];
      }
      var bcRect = dom.getBoundingClientRect();
      var {
        x: x,
        y: y
      } = bcRect;
      var {
        width: width,
        height: height
      } = bcRect;
      if (width === 0 || height === 0) {
        var size = ui.getSize();
        if (size) {
          width = size.width;
          height = size.height;
        }
      }
      var minX = x - collisionBufferSize,
        maxX = x + width + collisionBufferSize;
      var minY = y - collisionBufferSize,
        maxY = y + height + collisionBufferSize;
      ui.bbox[0] = minX;
      ui.bbox[1] = minY;
      ui.bbox[2] = maxX;
      ui.bbox[3] = maxY;
      if (collisionIndex.collides(ui.bbox)) {
        ui._collidesEffect(false);
        continue;
      }
      collisionIndex.insertBox(ui.bbox);
      ui._collidesEffect(true);
    }
    this._uiCollidesQueue = [];
    return this;
  },
  _addUI: function _addUI(ui) {
    if (!this.uiList) {
      this.uiList = [];
    }
    var index = this.uiList.indexOf(ui);
    if (index > -1) {
      return this;
    }
    this.uiList.push(ui);
    return this._sortUI();
  },
  _sortUI: function _sortUI() {
    this.uiList = this.uiList || [];
    this.uiList = this.uiList.sort(function (a, b) {
      return b.options['collisionWeight'] - a.options['collisionWeight'];
    });
    return this;
  },
  _removeUI: function _removeUI(ui) {
    if (!this.uiList) {
      return -1;
    }
    var index = this.uiList.indexOf(ui);
    if (index < 0) {
      return index;
    }
    this.uiList.splice(index, 1);
    return index;
  }
});

var TEMP_COORD = new Coordinate(0, 0);
Map$1.include({
  coordinateToPoint: function coordinateToPoint(coordinate, zoom, out) {
    var res = this._getResolution(zoom);
    return this.coordinateToPointAtRes(coordinate, res, out);
  },
  coordinateToPointAtRes: function () {
    var COORD = new Coordinate(0, 0);
    return function (coordinate, res, out) {
      var prjCoord = this.getProjection().project(coordinate, COORD);
      return this._prjToPointAtRes(prjCoord, res, out);
    };
  }(),
  pointToCoordinate: function () {
    var COORD = new Coordinate(0, 0);
    return function (point, zoom, out) {
      var prjCoord = this._pointToPrj(point, zoom, COORD);
      return this.getProjection().unproject(prjCoord, out);
    };
  }(),
  pointAtResToCoordinate: function () {
    var COORD = new Coordinate(0, 0);
    return function (point, res, out) {
      var prjCoord = this._pointToPrjAtRes(point, res, COORD);
      return this.getProjection().unproject(prjCoord, out);
    };
  }(),
  coordinateToViewPoint: function () {
    var COORD = new Coordinate(0, 0);
    return function (coordinate, out, altitude) {
      return this._prjToViewPoint(this.getProjection().project(coordinate, COORD), out, altitude);
    };
  }(),
  viewPointToCoordinate: function () {
    var COORD = new Coordinate(0, 0);
    return function (viewPoint, out) {
      return this.getProjection().unproject(this._viewPointToPrj(viewPoint, COORD), out);
    };
  }(),
  coordinateToContainerPoint: function coordinateToContainerPoint(coordinate, zoom, out) {
    var res = this._getResolution(zoom);
    return this.coordinateToContainerPointAtRes(coordinate, res, out);
  },
  coordinateToContainerPointAtRes: function () {
    var COORD = new Coordinate(0, 0);
    return function (coordinate, res, out) {
      var pCoordinate = this.getProjection().project(coordinate, COORD);
      return this._prjToContainerPointAtRes(pCoordinate, res, out, pCoordinate.z);
    };
  }(),
  coordinatesToContainerPoints: function coordinatesToContainerPoints(coordinates, zoom) {
    var res = this._getResolution(zoom);
    return this.coordinatesToContainerPointsAtRes(coordinates, res);
  },
  coordinatesToContainerPointsAtRes: function () {
    return function (coordinates, resolution) {
      var pts = [];
      var transformation = this._spatialReference.getTransformation();
      var res = resolution / this._getResolution();
      var projection = this.getProjection();
      var prjOut = new Coordinate(0, 0);
      var isTransforming = this.isTransforming();
      var centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD);
      for (var i = 0, len = coordinates.length; i < len; i++) {
        var pCoordinate = projection.project(coordinates[i], prjOut);
        var point = transformation.transform(pCoordinate, resolution);
        point = point._multi(res);
        this._toContainerPoint(point, isTransforming, coordinates[i].z, centerPoint);
        pts.push(point);
      }
      return pts;
    };
  }(),
  containerPointToCoordinate: function () {
    var COORD = new Coordinate(0, 0);
    return function (containerPoint, out) {
      var pCoordinate = this._containerPointToPrj(containerPoint, COORD);
      return this.getProjection().unproject(pCoordinate, out);
    };
  }(),
  containerPointToCoordinate3: function () {
    var POINT = new Point(0, 0);
    return function (containerPoint, altitude, out) {
      var res = this.getGLRes();
      var point2d = this['_containerPointToPointAtRes'](containerPoint, res, POINT, altitude);
      var coord = this.pointAtResToCoord(point2d, res, out);
      coord.z = altitude;
      return coord;
    };
  }(),
  containerToExtent: function () {
    var POINT0 = new Point(0, 0);
    var POINT1 = new Point(0, 0);
    return function (containerExtent) {
      var extent2D = new PointExtent(this._containerPointToPoint(containerExtent.getMin(POINT0), undefined, POINT0), this._containerPointToPoint(containerExtent.getMax(POINT1), undefined, POINT1));
      return this._pointToExtent(extent2D);
    };
  }(),
  distanceToPixel: function () {
    var POINT0 = new Point(0, 0);
    var POINT1 = new Point(0, 0);
    return function (xDist, yDist, zoom) {
      var projection = this.getProjection();
      if (!projection) {
        return null;
      }
      var scale = this.getScale() / this.getScale(zoom);
      var center = this.getCenter(),
        target = projection.locate(center, xDist, yDist);
      var p0 = this.coordToContainerPoint(center, undefined, POINT0),
        p1 = this.coordToContainerPoint(target, undefined, POINT1);
      p1._sub(p0)._multi(scale)._abs();
      return new Size(p1.x, p1.y);
    };
  }(),
  distanceToPoint: function distanceToPoint(xDist, yDist, zoom, paramCenter) {
    var res = this._getResolution(zoom);
    return this.distanceToPointAtRes(xDist, yDist, res, paramCenter);
  },
  distanceToPointAtRes: function () {
    var POINT = new Point(0, 0);
    var COORD = new Coordinate(0, 0);
    return function (xDist, yDist, res, paramCenter, out) {
      var projection = this.getProjection();
      if (!projection) {
        return null;
      }
      var center = paramCenter || this.getCenter(),
        target = projection.locate(center, xDist, yDist, COORD);
      var p0 = this.coordToPointAtRes(center, res, POINT),
        p1 = this.coordToPointAtRes(target, res, out);
      p1._sub(p0)._abs();
      return p1;
    };
  }(),
  altitudeToPoint: function () {
    var DEFAULT_CENTER = new Coordinate(0, 40);
    var POINT = new Point(0, 0);
    return function (altitude = 0, res, originCenter) {
      if (this._altitudeOriginDirty) {
        DEFAULT_CENTER.x = this._originLng;
        this._altitudeOriginDirty = false;
      }
      var p = this.distanceToPointAtRes(altitude, altitude, res, originCenter || DEFAULT_CENTER, POINT);
      var heightFactor = this.options['heightFactor'];
      if (heightFactor && heightFactor !== 1) {
        p.x *= heightFactor;
        p.y *= heightFactor;
      }
      return p.x * Math.sign(altitude);
    };
  }(),
  pointAtResToAltitude: function () {
    var DEFAULT_CENTER = new Coordinate(0, 40);
    return function (point = 0, res, originCenter) {
      var altitude = this.pointAtResToDistance(point, 0, res, originCenter || DEFAULT_CENTER);
      return altitude * Math.sign(point);
    };
  }(),
  pixelToDistance: function () {
    var COORD0 = new Coordinate(0, 0);
    var COORD1 = new Coordinate(0, 0);
    var TARGET0 = new Coordinate(0, 0);
    var TARGET1 = new Coordinate(0, 0);
    return function (width, height) {
      var projection = this.getProjection();
      if (!projection) {
        return null;
      }
      var fullExt = this.getFullExtent();
      var d = fullExt['top'] > fullExt['bottom'] ? -1 : 1;
      var coord0 = COORD0.set(this.width / 2, this.height / 2);
      var coord1 = COORD1.set(this.width / 2 + width, this.height / 2 + d * height);
      var target0 = this.containerPointToCoord(coord0, TARGET0);
      var target1 = this.containerPointToCoord(coord1, TARGET1);
      return projection.measureLength(target0, target1);
    };
  }(),
  pointToDistance: function pointToDistance(dx, dy, zoom) {
    var res = this.getResolution(zoom);
    return this.pointAtResToDistance(dx, dy, res);
  },
  pointAtResToDistance: function () {
    var POINT = new Point(0, 0);
    var PRJ_COORD = new Coordinate(0, 0);
    var COORD0 = new Coordinate(0, 0);
    var COORD1 = new Coordinate(0, 0);
    return function (dx, dy, res, paramCenter) {
      var projection = this.getProjection();
      if (!projection) {
        return null;
      }
      var prjCoord = paramCenter ? projection.project(paramCenter, PRJ_COORD) : this._getPrjCenter();
      var c = this._prjToPointAtRes(prjCoord, res, POINT);
      c._add(dx, dy);
      var target = this.pointAtResToCoord(c, res, COORD0);
      var src = paramCenter ? paramCenter : projection.unproject(prjCoord, COORD1);
      src.z = 0;
      target.z = 0;
      return projection.measureLength(src, target);
    };
  }(),
  locateByPoint: function () {
    var POINT = new Point(0, 0);
    return function (coordinate, px, py) {
      var point = this.coordToContainerPoint(coordinate, undefined, POINT);
      return this.containerPointToCoord(point._add(px, py));
    };
  }(),
  _get2DExtent: function _get2DExtent(zoom, out) {
    var cached;
    if ((zoom === undefined || zoom === this._zoomLevel) && this._mapExtent2D) {
      cached = this._mapExtent2D;
    }
    if (cached) {
      if (out) {
        out.set(cached['xmin'], cached['ymin'], cached['xmax'], cached['ymax']);
        return out;
      }
      return cached.copy();
    }
    var res = this._getResolution(zoom);
    return this._get2DExtentAtRes(res, out);
  },
  get2DExtent: function get2DExtent(zoom, out) {
    return this._get2DExtent(zoom, out);
  },
  _get2DExtentAtRes: function () {
    var POINT = new Point(0, 0);
    return function (res, out) {
      var _this = this;
      if (res === this._mapGlRes && this._mapGlExtent2D) {
        return this._mapGlExtent2D;
      }
      var cExtent = this.getContainerExtent();
      return cExtent.convertTo(function (c) {
        return _this._containerPointToPointAtRes(c, res, POINT);
      }, out);
    };
  }(),
  get2DExtentAtRes: function get2DExtentAtRes(res, out) {
    return this._get2DExtentAtRes(res, out);
  },
  pointToExtent: function pointToExtent(extent2D) {
    return this._pointToExtent(extent2D);
  },
  _pointToExtent: function () {
    var COORD0 = new Coordinate(0, 0);
    var COORD1 = new Coordinate(0, 0);
    return function (extent2D) {
      var min2d = extent2D.getMin(),
        max2d = extent2D.getMax();
      var fullExtent = this.getFullExtent();
      var [minx, maxx] = !fullExtent || fullExtent.left <= fullExtent.right ? [min2d.x, max2d.x] : [max2d.x, min2d.x];
      var [miny, maxy] = !fullExtent || fullExtent.top > fullExtent.bottom ? [max2d.y, min2d.y] : [min2d.y, max2d.y];
      var min = min2d.set(minx, maxy);
      var max = max2d.set(maxx, miny);
      return new Extent(this.pointToCoord(min, undefined, COORD0), this.pointToCoord(max, undefined, COORD1), this.getProjection());
    };
  }(),
  getViewPointFrameOffset: function () {
    var POINT = new Point(0, 0);
    return function () {
      if (this.isZooming()) {
        return null;
      }
      var pcenter = this._getPrjCenter();
      if (this._mapViewCoord && !this._mapViewCoord.equals(pcenter)) {
        return this._prjToContainerPoint(this._mapViewCoord)._sub(this._prjToContainerPoint(pcenter, undefined, POINT));
      }
      return null;
    };
  }(),
  _viewPointToPrj: function () {
    var POINT = new Point(0, 0);
    return function (viewPoint, out) {
      return this._containerPointToPrj(this.viewPointToContainerPoint(viewPoint, POINT), out);
    };
  }(),
  viewPointToPrj: function viewPointToPrj(viewPoint, out) {
    return this._viewPointToPrj(viewPoint, out);
  },
  _prjToContainerPoint: function _prjToContainerPoint(pCoordinate, zoom, out, altitude) {
    var res = this._getResolution(zoom);
    return this._prjToContainerPointAtRes(pCoordinate, res, out, altitude);
  },
  prjToContainerPoint: function prjToContainerPoint(pCoordinate, zoom, out, altitude) {
    return this._prjToContainerPoint(pCoordinate, zoom, out, altitude);
  },
  _prjToContainerPointAtRes: function () {
    var POINT = new Point(0, 0);
    return function (pCoordinate, res, out, altitude) {
      return this._pointAtResToContainerPoint(this._prjToPointAtRes(pCoordinate, res, POINT), res, altitude || 0, out);
    };
  }(),
  prjToContainerPointAtRes: function prjToContainerPointAtRes(pCoordinate, res, out, altitude) {
    return this.prjToContainerPointAtRes(pCoordinate, res, out, altitude);
  },
  _prjToViewPoint: function () {
    var POINT = new Point(0, 0);
    return function (pCoordinate, out, altitude) {
      var containerPoint = this._prjToContainerPoint(pCoordinate, undefined, POINT, altitude);
      return this.containerPointToViewPoint(containerPoint, out);
    };
  }(),
  prjToViewPoint: function prjToViewPoint(pCoordinate, out, altitude) {
    return this._prjToViewPoint(pCoordinate, out, altitude);
  },
  _viewPointToPoint: function () {
    var POINT = new Point(0, 0);
    return function (viewPoint, zoom, out) {
      return this._containerPointToPoint(this.viewPointToContainerPoint(viewPoint, POINT), zoom, out);
    };
  }(),
  viewPointToPoint: function viewPointToPoint(viewPoint, zoom, out) {
    return this._viewPointToPoint(viewPoint, zoom, out);
  },
  _pointToViewPoint: function () {
    var COORD = new Coordinate(0, 0);
    return function (point, zoom, out) {
      return this._prjToViewPoint(this._pointToPrj(point, zoom, COORD), out);
    };
  }(),
  pointToViewPoint: function pointToViewPoint(point, zoom, out) {
    return this._pointToViewPoint(point, zoom, out);
  }
});

var distancetool$2 = {
	start: "起点",
	units: {
		mile: " 英里",
		feet: " 英尺",
		kilometer: " 公里",
		meter: " 米"
	}
};
var areatool$2 = {
	units: {
		mile: " 平方英里",
		feet: " 平方英尺",
		kilometer: " 平方公里",
		meter: " 平方米"
	}
};
var zhCn = {
	distancetool: distancetool$2,
	areatool: areatool$2
};

var distancetool$1 = {
	start: "Inicio",
	units: {
		mile: " mi",
		feet: " ft",
		kilometer: " km",
		meter: " m"
	}
};
var areatool$1 = {
	units: {
		mile: " mi²",
		feet: " ft²",
		kilometer: " km²",
		meter: " m²"
	}
};
var esMX = {
	distancetool: distancetool$1,
	areatool: areatool$1
};

var distancetool = {
	start: "Start",
	units: {
		mile: " mi",
		feet: " ft",
		kilometer: " km",
		meter: " m"
	}
};
var areatool = {
	units: {
		mile: " mi²",
		feet: " ft²",
		kilometer: " km²",
		meter: " m²"
	}
};
var enUS = {
	distancetool: distancetool,
	areatool: areatool
};

var TranslatorError = function (_Error) {
  function TranslatorError(msg) {
    var _this;
    _this = _Error.call(this, 'Translator: ' + msg) || this;
    _this.name = 'TranslatorError';
    return _this;
  }
  _inheritsLoose(TranslatorError, _Error);
  return TranslatorError;
}(_wrapNativeSuper(Error));
var Translator = function (_Class) {
  function Translator(lang) {
    var _this2;
    _this2 = _Class.call(this) || this;
    _this2.languages = {
      'zh-CN': zhCn,
      'es-MX': esMX,
      'en-US': enUS
    };
    _this2.setLang(lang || 'zh-CN');
    return _this2;
  }
  _inheritsLoose(Translator, _Class);
  var _proto = Translator.prototype;
  _proto.setLang = function setLang(lang) {
    var newLanguageNodes = this.languages[lang];
    if (!newLanguageNodes) throw new TranslatorError('Setted Lang does not exist');
    this.nodes = newLanguageNodes;
  };
  _proto._validateNestedProps = function _validateNestedProps(nestedProps) {
    nestedProps.forEach(function (p) {
      if (p === '') throw new TranslatorError('Any of sides of a dot "." cannot be empty');
    });
  };
  _proto.translate = function translate(textNode = null) {
    if (textNode == null) throw new TranslatorError('Missing parameter textNode');
    if (typeof textNode === 'string') {
      var translatedText = null;
      if (textNode.includes('.')) {
        var nestedProps = textNode.split('.');
        if (nestedProps.length > 3) throw new TranslatorError("Translate function can only access through 3 nested properties, trying to access -> " + nestedProps.length);
        this._validateNestedProps(nestedProps);
        try {
          var _translatedText = null;
          switch (nestedProps.length) {
            case 2:
              _translatedText = this.nodes[nestedProps[0]][nestedProps[1]];
              break;
            case 3:
              _translatedText = this.nodes[nestedProps[0]][nestedProps[1]][nestedProps[2]];
              break;
          }
          return _translatedText;
        } catch (err) {
          throw new TranslatorError('Unable to find the text translated in lang json' + err.message);
        }
      } else {
        translatedText = this.nodes[textNode];
        return translatedText;
      }
    } else {
      throw new TranslatorError('Param passed has to be a String');
    }
  };
  return Translator;
}(Class);

var options$m = {
  'formatLabelContent': null,
  'decimalPlaces': 2,
  'mode': 'LineString',
  'language': 'zh-CN',
  'metric': true,
  'imperial': false,
  'symbol': {
    'lineColor': '#000',
    'lineWidth': 3,
    'lineOpacity': 1
  },
  'vertexSymbol': {
    'markerType': 'ellipse',
    'markerFill': '#fff',
    'markerLineColor': '#000',
    'markerLineWidth': 3,
    'markerWidth': 11,
    'markerHeight': 11
  },
  'labelOptions': {
    'textSymbol': {
      'textFaceName': 'monospace',
      'textLineSpacing': 1,
      'textHorizontalAlignment': 'right',
      'textDx': 15
    },
    'boxStyle': {
      'padding': [6, 2],
      'symbol': {
        'markerType': 'square',
        'markerFill': '#fff',
        'markerFillOpacity': 0.9,
        'markerLineColor': '#b4b3b3'
      }
    }
  },
  'clearButtonSymbol': [{
    'markerType': 'square',
    'markerFill': '#fff',
    'markerLineColor': '#b4b3b3',
    'markerLineWidth': 2,
    'markerWidth': 15,
    'markerHeight': 15,
    'markerDx': 20
  }, {
    'markerType': 'x',
    'markerWidth': 10,
    'markerHeight': 10,
    'markerDx': 20
  }]
};
var DistanceTool = function (_DrawTool) {
  function DistanceTool(options) {
    var _this;
    _this = _DrawTool.call(this, options) || this;
    _this.on('enable', _this._afterEnable, _this).on('disable', _this._afterDisable, _this);
    _this._measureLayers = [];
    _this.translator = new Translator(_this.options['language']);
    return _this;
  }
  _inheritsLoose(DistanceTool, _DrawTool);
  var _proto = DistanceTool.prototype;
  _proto.clear = function clear() {
    if (isArrayHasData(this._measureLayers)) {
      for (var i = 0; i < this._measureLayers.length; i++) {
        this._measureLayers[i].remove();
      }
    }
    delete this._lastMeasure;
    delete this._lastVertex;
    this._outLayers(this._measureLayers);
    this._measureLayers = [];
    return this;
  };
  _proto.getMeasureLayers = function getMeasureLayers() {
    return this._measureLayers;
  };
  _proto.getLastMeasure = function getLastMeasure() {
    if (!this._lastMeasure) {
      return 0;
    }
    return this._lastMeasure;
  };
  _proto.undo = function undo() {
    _DrawTool.prototype.undo.call(this);
    var pointer = this._historyPointer;
    if (pointer !== this._vertexes.length) {
      for (var i = pointer; i < this._vertexes.length; i++) {
        if (this._vertexes[i].label) {
          this._vertexes[i].label.remove();
        }
        this._vertexes[i].marker.remove();
      }
    }
    return this;
  };
  _proto.redo = function redo() {
    _DrawTool.prototype.redo.call(this);
    var i = this._historyPointer - 1;
    if (this._vertexes[i]) {
      if (!this._vertexes[i].marker.getLayer()) {
        if (this._vertexes[i].label) {
          this._vertexes[i].label.addTo(this._measureMarkerLayer);
        }
        this._vertexes[i].marker.addTo(this._measureMarkerLayer);
      }
    }
    return this;
  };
  _proto._formatLabelContent = function _formatLabelContent(params) {
    var formatLabelContent = this.options.formatLabelContent;
    if (formatLabelContent && isFunction(formatLabelContent)) {
      return formatLabelContent.call(this, params) + '';
    }
    return null;
  };
  _proto._measure = function _measure(toMeasure) {
    var map = this.getMap();
    var length;
    if (toMeasure instanceof Geometry) {
      length = map.computeGeometryLength(toMeasure);
    } else if (Array.isArray(toMeasure)) {
      length = map.getProjection().measureLength(toMeasure);
    }
    this._lastMeasure = length;
    var result = this._formatLabelContent(length);
    if (result) {
      return result;
    }
    var units = [this.translator.translate('distancetool.units.meter'), this.translator.translate('distancetool.units.kilometer'), this.translator.translate('distancetool.units.feet'), this.translator.translate('distancetool.units.mile')];
    var content = '';
    var decimals = this.options['decimalPlaces'];
    if (this.options['metric']) {
      content += length < 1000 ? length.toFixed(decimals) + units[0] : (length / 1000).toFixed(decimals) + units[1];
    }
    if (this.options['imperial']) {
      length *= 3.2808399;
      if (content.length > 0) {
        content += '\n';
      }
      content += length < 5280 ? length.toFixed(decimals) + units[2] : (length / 5280).toFixed(decimals) + units[3];
    }
    return content;
  };
  _proto._registerMeasureEvents = function _registerMeasureEvents() {
    this.on('drawstart', this._msOnDrawStart, this).on('drawvertex', this._msOnDrawVertex, this).on('mousemove', this._msOnMouseMove, this).on('drawend', this._msOnDrawEnd, this);
  };
  _proto._afterEnable = function _afterEnable() {
    this._registerMeasureEvents();
  };
  _proto._afterDisable = function _afterDisable() {
    this.off('drawstart', this._msOnDrawStart, this).off('drawvertex', this._msOnDrawVertex, this).off('mousemove', this._msOnMouseMove, this).off('drawend', this._msOnDrawEnd, this);
  };
  _proto._msOnDrawStart = function _msOnDrawStart(param) {
    var map = this.getMap();
    var uid = UID();
    var layerId = 'distancetool_' + uid;
    var markerLayerId = 'distancetool_markers_' + uid;
    var zIndex = this.options.zIndex;
    var enableAltitude = this.options.enableAltitude;
    if (!map.getLayer(layerId)) {
      this._measureLineLayer = new DrawToolLayer(layerId, {
        zIndex: zIndex,
        enableAltitude: enableAltitude
      }).addTo(map);
      this._measureMarkerLayer = new DrawToolLayer(markerLayerId, {
        zIndex: zIndex,
        enableAltitude: enableAltitude
      }).addTo(map);
    } else {
      this._measureLineLayer = map.getLayer(layerId);
      this._measureMarkerLayer = map.getLayer(markerLayerId);
    }
    this._measureLayers.push(this._measureLineLayer);
    this._measureLayers.push(this._measureMarkerLayer);
    this._pushLayers([this._measureLineLayer, this._measureMarkerLayer]);
    var firstCoordinate = this._getFirstCoordinate() || param.coordinate;
    var marker = new Marker(firstCoordinate.copy(), {
      'symbol': this.options['vertexSymbol']
    });
    var content = this.translator.translate('distancetool.start');
    var startLabel = new Label(content, firstCoordinate.copy(), this.options['labelOptions']);
    this._lastVertex = startLabel;
    this._addVertexMarker(marker, startLabel);
  };
  _proto._msOnMouseMove = function _msOnMouseMove(param) {
    var ms = this._measure(this._msGetCoordsToMeasure(param));
    if (!this._tailMarker) {
      var symbol = extendSymbol(this.options['vertexSymbol']);
      symbol['markerWidth'] /= 2;
      symbol['markerHeight'] /= 2;
      this._tailMarker = new Marker(param['coordinate'], {
        'symbol': symbol
      }).addTo(this._measureMarkerLayer);
      this._tailLabel = new Label(ms, param['coordinate'], this.options['labelOptions']).addTo(this._measureMarkerLayer);
    }
    var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
    this._tailMarker.setCoordinates(lastCoordinate.copy());
    this._tailLabel.setContent(ms);
    this._tailLabel.setCoordinates(lastCoordinate.copy());
  };
  _proto._msGetCoordsToMeasure = function _msGetCoordsToMeasure(param) {
    return param['geometry'].getCoordinates().concat([param['coordinate']]);
  };
  _proto._msOnDrawVertex = function _msOnDrawVertex(param) {
    var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
    var geometry = param['geometry'];
    var marker = new Marker(lastCoordinate.copy(), {
      'symbol': this.options['vertexSymbol']
    });
    var length = this._measure(geometry);
    var vertexLabel = new Label(length, lastCoordinate.copy(), this.options['labelOptions']);
    this._addVertexMarker(marker, vertexLabel);
    this._lastVertex = vertexLabel;
  };
  _proto._addVertexMarker = function _addVertexMarker(marker, vertexLabel) {
    if (!this._vertexes) {
      this._vertexes = [];
    }
    if (this._historyPointer !== undefined && this._vertexes.length > this._historyPointer - 1) {
      this._vertexes.length = this._historyPointer - 1;
    }
    this._vertexes.push({
      label: vertexLabel,
      marker: marker
    });
    this._measureMarkerLayer.addGeometry(marker);
    if (vertexLabel) {
      this._measureMarkerLayer.addGeometry(vertexLabel);
    }
  };
  _proto._msOnDrawEnd = function _msOnDrawEnd(param) {
    this._clearTailMarker();
    if (param['geometry'].getCoordinates().length < 2) {
      this._lastMeasure = 0;
      this._clearMeasureLayers();
      return;
    }
    var size = this._lastVertex.getSize();
    if (!size) {
      size = new Size(10, 10);
    }
    this._addClearMarker(this._lastVertex.getCoordinates(), this._lastVertex._getPrjCoordinates(), size['width']);
    var geo = param['geometry'].copy();
    geo.setCoordinates(param.geometry.getCoordinates());
    geo.addTo(this._measureLineLayer);
    this._lastMeasure = geo.getLength();
  };
  _proto._addClearMarker = function _addClearMarker(coordinates, prjCoord, dx) {
    var symbol = this.options['clearButtonSymbol'];
    var dxSymbol = {
      'markerDx': (symbol['markerDx'] || 0) + dx,
      'textDx': (symbol['textDx'] || 0) + dx
    };
    if (Array.isArray(symbol)) {
      dxSymbol = symbol.map(function (s) {
        if (s) {
          return {
            'markerDx': (s['markerDx'] || 0) + dx,
            'textDx': (s['textDx'] || 0) + dx
          };
        }
        return null;
      });
    }
    symbol = extendSymbol(symbol, dxSymbol);
    var endMarker = new Marker(coordinates, {
      'symbol': symbol
    });
    var measureLineLayer = this._measureLineLayer,
      measureMarkerLayer = this._measureMarkerLayer,
      drawToolLayer = this._getDrawLayer ? this._getDrawLayer() : null;
    endMarker.on('click', function () {
      measureLineLayer.remove();
      measureMarkerLayer.remove();
      if (drawToolLayer) {
        drawToolLayer.remove();
      }
      return false;
    }, this);
    endMarker.addTo(this._measureMarkerLayer);
  };
  _proto._clearTailMarker = function _clearTailMarker() {
    if (this._tailMarker) {
      this._tailMarker.remove();
      delete this._tailMarker;
    }
    if (this._tailLabel) {
      this._tailLabel.remove();
      delete this._tailLabel;
    }
  };
  _proto._clearMeasureLayers = function _clearMeasureLayers() {
    this._measureLineLayer.remove();
    this._measureMarkerLayer.remove();
  };
  _proto._getFirstCoordinate = function _getFirstCoordinate() {
    if (!this._geometry) {
      return null;
    }
    var coordinates = this._geometry.getCoordinates() || [];
    var firstCoordinate = coordinates[0];
    if (Array.isArray(firstCoordinate)) {
      return firstCoordinate[0];
    }
    return firstCoordinate;
  };
  _proto._getLasttCoordinate = function _getLasttCoordinate() {
    if (!this._geometry) {
      return null;
    }
    var coordinates = this._geometry.getCoordinates() || [];
    var lastCoordiante = coordinates[coordinates.length - 1];
    if (Array.isArray(lastCoordiante)) {
      return lastCoordiante[lastCoordiante.length - 1];
    }
    return lastCoordiante;
  };
  return DistanceTool;
}(DrawTool);
DistanceTool.mergeOptions(options$m);

var options$l = {
  'mode': 'Polygon',
  'symbol': {
    'lineColor': '#000000',
    'lineWidth': 2,
    'lineOpacity': 1,
    'lineDasharray': '',
    'polygonFill': '#ffffff',
    'polygonOpacity': 0.5
  },
  'language': 'zh-CN'
};
var AreaTool = function (_DistanceTool) {
  function AreaTool(options) {
    var _this;
    _this = _DistanceTool.call(this, options) || this;
    _this.translator = new Translator(_this.options['language']);
    _this._measureLayers = [];
    return _this;
  }
  _inheritsLoose(AreaTool, _DistanceTool);
  var _proto = AreaTool.prototype;
  _proto._measure = function _measure(toMeasure) {
    var map = this.getMap();
    var area;
    if (toMeasure instanceof Geometry) {
      area = map.computeGeometryArea(toMeasure);
    } else if (Array.isArray(toMeasure)) {
      area = map.getProjection().measureArea(toMeasure);
    }
    this._lastMeasure = area;
    var result = this._formatLabelContent(area);
    if (result) {
      return result;
    }
    var units = [this.translator.translate('areatool.units.meter'), this.translator.translate('areatool.units.kilometer'), this.translator.translate('areatool.units.feet'), this.translator.translate('areatool.units.mile')];
    var content = '';
    var decimals = this.options['decimalPlaces'];
    if (this.options['metric']) {
      content += area < 1E6 ? area.toFixed(decimals) + units[0] : (area / 1E6).toFixed(decimals) + units[1];
    }
    if (this.options['imperial']) {
      area *= Math.pow(3.2808399, 2);
      if (content.length > 0) {
        content += '\n';
      }
      var sqmi = 5280 * 5280;
      content += area < sqmi ? area.toFixed(decimals) + units[2] : (area / sqmi).toFixed(decimals) + units[3];
    }
    return content;
  };
  _proto._msGetCoordsToMeasure = function _msGetCoordsToMeasure(param) {
    return param['geometry'].getShell().concat([param['coordinate']]);
  };
  _proto._msOnDrawVertex = function _msOnDrawVertex(param) {
    var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
    var vertexMarker = new Marker(lastCoordinate.copy(), {
      'symbol': this.options['vertexSymbol']
    });
    this._measure(param['geometry']);
    this._lastVertex = vertexMarker;
    this._addVertexMarker(vertexMarker);
  };
  _proto._msOnDrawEnd = function _msOnDrawEnd(param) {
    this._clearTailMarker();
    var prjCoord;
    var map = this.getMap();
    if (param['point2d']) {
      prjCoord = map._pointToPrj(param['point2d']);
    } else {
      var prjCoords = param['geometry']._getPrjCoordinates() || [];
      prjCoords = prjCoords.slice(0, prjCoords.length - 1);
      prjCoord = prjCoords[prjCoords.length - 1];
    }
    if (param['geometry'].getShell().length < 3) {
      this._lastMeasure = 0;
      this._clearMeasureLayers();
      return;
    }
    var ms = this._measure(param['geometry']);
    var lastCoordinate = this._getLasttCoordinate();
    var endLabel = new Label(ms, lastCoordinate.copy(), this.options['labelOptions']).addTo(this._measureMarkerLayer);
    var size = endLabel.getSize();
    if (!size) {
      size = new Size(10, 10);
    }
    this._addClearMarker(lastCoordinate.copy(), prjCoord, size['width']);
    var geo = param['geometry'].copy();
    geo.setCoordinates(param.geometry.getCoordinates());
    geo.addTo(this._measureLineLayer);
    this._lastMeasure = geo.getArea();
  };
  return AreaTool;
}(DistanceTool);
AreaTool.mergeOptions(options$l);

function queryTerrainCoordinates(projection, prjCoords, mapEvent) {
  var isArray = Array.isArray(prjCoords);
  if (!isArray) {
    prjCoords = [prjCoords];
  }
  var coordinates;
  var transformCoordinate;
  if (mapEvent && mapEvent.drawTool && mapEvent.drawTool.options) {
    transformCoordinate = mapEvent.drawTool.options.transformCoordinate;
  }
  if (transformCoordinate && isFunction(transformCoordinate)) {
    coordinates = prjCoords.map(function (c) {
      return projection.unproject(c);
    });
    coordinates = coordinates.map(function (c) {
      var newCoordinata = transformCoordinate(c, mapEvent);
      return newCoordinata || c;
    });
  } else {
    if (!mapEvent || !mapEvent.target || !mapEvent.target._queryTerrainInfo) {
      coordinates = prjCoords.map(function (c) {
        return projection.unproject(c);
      });
      return isArray ? coordinates : coordinates[0];
    }
    var map = mapEvent.target;
    var enableAltitude = mapEvent.enableAltitude;
    coordinates = prjCoords.map(function (c) {
      if (enableAltitude) {
        var point = map.prjToContainerPoint(c);
        var terrain = map._queryTerrainInfo(point);
        if (terrain && terrain.coordinate) {
          return terrain.coordinate;
        }
      }
      return projection.unproject(c);
    });
  }
  return isArray ? coordinates : coordinates[0];
}
var circleHooks = {
  'create': function create(projection, prjCoord, mapEvent) {
    var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
    var circle = new Circle(center, 0);
    circle._firstClick = prjCoord[0];
    return circle;
  },
  'update': function update(projection, prjPath, geometry, mapEvent) {
    var center = geometry.getCenter();
    if (geometry._firstClick) {
      center = queryTerrainCoordinates(projection, geometry._firstClick, mapEvent);
    }
    var map = geometry.getMap();
    var prjCoord = Array.isArray(prjPath) ? prjPath[prjPath.length - 1] : prjPath;
    var nextCoord = queryTerrainCoordinates(projection, prjCoord, mapEvent);
    var radius = map.computeLength(center, nextCoord);
    geometry.setRadius(radius);
  },
  'generate': function generate(geometry) {
    return geometry;
  }
};
DrawTool.registerMode('circle', extend$2({
  'clickLimit': 2,
  'action': ['click', 'mousemove', 'click']
}, circleHooks));
DrawTool.registerMode('freeHandCircle', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, circleHooks));
var ellipseHooks = {
  'create': function create(projection, prjCoord, mapEvent) {
    var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
    var ellipse = new Ellipse(center, 0, 0);
    return ellipse;
  },
  'update': function update(projection, prjPath, geometry, mapEvent) {
    var map = geometry.getMap();
    var center = geometry.getCenter();
    var prjCoord = Array.isArray(prjPath) ? prjPath[prjPath.length - 1] : prjPath;
    var nextCoord = queryTerrainCoordinates(projection, prjCoord, mapEvent);
    var rx = map.computeLength(center, new Coordinate({
      x: nextCoord.x,
      y: center.y
    }));
    var ry = map.computeLength(center, new Coordinate({
      x: center.x,
      y: nextCoord.y
    }));
    geometry.setWidth(rx * 2);
    geometry.setHeight(ry * 2);
  },
  'generate': function generate(geometry) {
    return geometry;
  }
};
DrawTool.registerMode('ellipse', extend$2({
  'clickLimit': 2,
  'action': ['click', 'mousemove', 'click']
}, ellipseHooks));
DrawTool.registerMode('freeHandEllipse', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, ellipseHooks));
var rectangleHooks = {
  'create': function create(projection, prjCoords) {
    var rect = new Polygon([]);
    rect._firstClick = prjCoords[0];
    return rect;
  },
  'update': function update(projection, prjCoords, geometry, mapEvent) {
    var map = geometry.getMap();
    var containerPoint = mapEvent['containerPoint'];
    var firstClick = map.prjToContainerPoint(geometry._firstClick);
    var ring = [[firstClick.x, firstClick.y], [containerPoint.x, firstClick.y], [containerPoint.x, containerPoint.y], [firstClick.x, containerPoint.y]];
    var prjs = ring.map(function (c) {
      return map._containerPointToPrj(new Point(c));
    });
    var coordinates = queryTerrainCoordinates(projection, prjs, mapEvent);
    geometry.setCoordinates(coordinates);
  },
  'generate': function generate(geometry) {
    return geometry;
  }
};
DrawTool.registerMode('rectangle', extend$2({
  'clickLimit': 2,
  'action': ['click', 'mousemove', 'click']
}, rectangleHooks));
DrawTool.registerMode('freeHandRectangle', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, rectangleHooks));
var realRectangleHooks = {
  'create': function create(projection, prjCoords) {
    var rect = new Rectangle([0, 0], 0, 0);
    rect._firstClick = prjCoords[0];
    return rect;
  },
  'update': function update(projection, prjCoords, geometry, mapEvent) {
    var map = geometry.getMap();
    var containerPoint = mapEvent['containerPoint'];
    var firstClick = map.prjToContainerPoint(geometry._firstClick);
    var ring = [[firstClick.x, firstClick.y], [containerPoint.x, firstClick.y], [containerPoint.x, containerPoint.y], [firstClick.x, containerPoint.y]];
    var prjs = ring.map(function (c) {
      return map._containerPointToPrj(new Point(c));
    });
    var coordinates = queryTerrainCoordinates(projection, prjs, mapEvent);
    var sw = coordinates[0];
    var ne = coordinates[2];
    geometry.setCoordinates(sw);
    var c1 = ne.copy();
    var c2 = ne.copy();
    c1.y = sw.y;
    c2.x = sw.x;
    var w = map.computeLength(sw, c1);
    var h = map.computeLength(sw, c2);
    geometry.setWidth(w);
    geometry.setHeight(h);
  },
  'generate': function generate(geometry) {
    return geometry;
  }
};
DrawTool.registerMode('realrectangle', extend$2({
  'clickLimit': 2,
  'action': ['click', 'mousemove', 'click']
}, realRectangleHooks));
DrawTool.registerMode('freeHandRealRectangle', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, realRectangleHooks));
DrawTool.registerMode('point', {
  'clickLimit': 1,
  'action': ['click', 'mousemove'],
  'create': function create(projection, prjCoord, mapEvent) {
    var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
    var marker = new Marker(center);
    return marker;
  },
  'generate': function generate(geometry) {
    return geometry;
  },
  'update': function update(projection, prjCoord, geometry, mapEvent) {
    if (Array.isArray(prjCoord)) {
      prjCoord = prjCoord[prjCoord.length - 1];
    }
    if (!prjCoord) {
      return geometry;
    }
    var coordinate = queryTerrainCoordinates(projection, prjCoord, mapEvent);
    geometry.setCoordinates(coordinate);
    return geometry;
  }
});
var polygonHooks = {
  'create': function create(projection, prjPath, mapEvent) {
    var path = queryTerrainCoordinates(projection, prjPath, mapEvent);
    var polygon = new Polygon([path]);
    polygon.setCoordinates(path);
    return polygon;
  },
  'update': function update(projection, path, geometry, mapEvent) {
    var prjCoords;
    if (Array.isArray(path)) {
      prjCoords = path;
    } else {
      prjCoords = geometry._drawPrjs || [];
      prjCoords.push(path);
    }
    geometry._drawPrjs = prjCoords;
    var coordinates = queryTerrainCoordinates(projection, prjCoords, mapEvent);
    geometry.setCoordinates(coordinates);
  },
  'generate': function generate(geometry) {
    var polygon = new Polygon(geometry.getCoordinates(), {
      'symbol': geometry.getSymbol(),
      'properties': geometry.getProperties()
    });
    polygon._projCode = geometry._projCode;
    return polygon;
  }
};
DrawTool.registerMode('polygon', extend$2({
  'action': ['click', 'mousemove', 'dblclick']
}, polygonHooks));
DrawTool.registerMode('freeHandPolygon', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, polygonHooks));
var lineStringHooks = {
  'create': function create(projection, prjPath, mapEvent) {
    var path = queryTerrainCoordinates(projection, prjPath, mapEvent);
    var line = new LineString(path);
    line.setCoordinates(path);
    return line;
  },
  'update': function update(projection, prjPath, geometry, mapEvent) {
    var prjCoords;
    if (Array.isArray(prjPath)) {
      prjCoords = prjPath;
    } else {
      prjCoords = geometry._drawPrjs || [];
      prjCoords.push(prjPath);
    }
    geometry._drawPrjs = prjCoords;
    var path = queryTerrainCoordinates(projection, prjCoords, mapEvent);
    geometry.setCoordinates(path);
  },
  'generate': function generate(geometry) {
    return geometry;
  }
};
DrawTool.registerMode('linestring', extend$2({
  'action': ['click', 'mousemove', 'dblclick']
}, lineStringHooks));
DrawTool.registerMode('freeHandLinestring', extend$2({
  'action': ['mousedown touchstart', 'mousemove touchmove', 'mouseup touchend']
}, lineStringHooks));
DrawTool.registerMode('arccurve', {
  'action': ['click', 'mousemove', 'dblclick'],
  'create': function create(projection, prjPath) {
    var path = prjPath.map(function (c) {
      return projection.unproject(c);
    });
    var arc = new ArcCurve(path);
    arc._setPrjCoordinates(prjPath);
    return arc;
  },
  'update': lineStringHooks.update,
  'generate': function generate(geometry) {
    return geometry;
  }
});
DrawTool.registerMode('quadbeziercurve', {
  'action': ['click', 'mousemove', 'dblclick'],
  'create': function create(projection, prjPath) {
    var path = prjPath.map(function (c) {
      return projection.unproject(c);
    });
    var curve = new QuadBezierCurve(path);
    curve._setPrjCoordinates(prjPath);
    return curve;
  },
  'update': lineStringHooks.update,
  'generate': function generate(geometry) {
    return geometry;
  }
});
DrawTool.registerMode('cubicbeziercurve', {
  'action': ['click', 'mousemove', 'dblclick'],
  'create': function create(projection, prjPath) {
    var path = prjPath.map(function (c) {
      return projection.unproject(c);
    });
    var curve = new CubicBezierCurve(path);
    curve._setPrjCoordinates(prjPath);
    return curve;
  },
  'update': lineStringHooks.update,
  'generate': function generate(geometry) {
    return geometry;
  }
});
DrawTool.registerMode('boxZoom', {
  'action': ['mousedown', 'mousemove', 'mouseup'],
  'create': function create(projection, prjCoord) {
    prjCoord = prjCoord[0];
    var center = projection.unproject(prjCoord);
    var marker = new Marker(center);
    marker._firstClick = prjCoord;
    return marker;
  },
  'update': function update(projection, prjCoord, geometry, param) {
    var map = geometry.getMap();
    var p1 = map.prjToContainerPoint(geometry._firstClick),
      p2 = param['containerPoint'];
    prjCoord = map._containerPointToPrj(new Coordinate(Math.min(p1.x, p2.x), Math.min(p1.y, p2.y)));
    var center = projection.unproject(prjCoord);
    geometry.setCoordinates(center)._setPrjCoordinates(prjCoord);
    geometry.updateSymbol({
      markerWidth: Math.abs(p1.x - p2.x),
      markerHeight: Math.abs(p1.y - p2.y)
    });
  },
  'generate': function generate(geometry) {
    return geometry;
  }
});

var options$k = {
  'eventsPropagation': false,
  'eventsToStop': null,
  'dx': 0,
  'dy': 0,
  'autoPan': false,
  'autoPanDuration': 600,
  'single': true,
  'animation': 'scale',
  'animationOnHide': false,
  'animationDuration': 500,
  'pitchWithMap': false,
  'rotateWithMap': false,
  'visible': true,
  'roundPoint': false,
  'collision': false,
  'collisionBufferSize': 2,
  'collisionWeight': 0,
  'collisionFadeIn': false,
  'zIndex': 0,
  'enableScrollbar': true
};
var COLLISION_STATES = ['collision', 'collisionBufferSize', 'collisionWeight', 'collisionFadeIn'];
var UIComponent = function (_Eventable) {
  function UIComponent(options) {
    var _this;
    _this = _Eventable.call(this, options) || this;
    _this.proxyOptions();
    return _this;
  }
  _inheritsLoose(UIComponent, _Eventable);
  var _proto = UIComponent.prototype;
  _proto._appendCustomClass = function _appendCustomClass(dom) {
    if (!dom) {
      console.warn('dom is null:', dom);
      return this;
    }
    if (this.options.cssName) {
      var cssName = this.options.cssName;
      if (!Array.isArray(cssName)) {
        cssName = [cssName];
      }
      cssName.forEach(function (name) {
        dom.classList.add(name);
      });
    }
    return this;
  };
  _proto.onAdd = function onAdd() {};
  _proto.onRemove = function onRemove() {};
  _proto.onDomRemove = function onDomRemove() {};
  _proto.getEvents = function getEvents() {
    return {};
  };
  _proto.getOwnerEvents = function getOwnerEvents() {
    return {};
  };
  _proto.buildOn = function buildOn() {
    return null;
  };
  _proto.addTo = function addTo(owner) {
    this._owner = owner;
    this._switchEvents('on');
    if (this.onAdd) {
      this.onAdd();
    }
    this.fire('add');
    return this;
  };
  _proto.getMap = function getMap() {
    if (!this._owner) {
      return null;
    }
    if (this._owner.getBaseLayer) {
      return this._owner;
    }
    return this._owner.getMap();
  };
  _proto._collides = function _collides() {
    var map = this.getMap();
    if (!map) {
      return this;
    }
    map._addUI(this);
    map._insertUICollidesQueue();
    return this;
  };
  _proto._collidesEffect = function _collidesEffect(show) {
    var dom = this.getDOM();
    if (!dom) {
      return this;
    }
    var visibility = show ? 'visible' : 'hidden';
    dom.style.visibility = visibility;
    if (!dom.classList || !dom.classList.add) {
      return this;
    }
    if (!this.options['collisionFadeIn']) {
      return this;
    }
    var classList = dom.classList;
    var className = 'mtk-ui-fadein';
    var hasClass = classList.contains(className);
    if (show && !hasClass) {
      dom.classList.add(className);
    } else if (!show && hasClass) {
      dom.classList.remove(className);
    }
    return this;
  };
  _proto.show = function show(coordinate) {
    var _this2 = this;
    var map = this.getMap();
    if (!map) {
      return this;
    }
    this.options['visible'] = true;
    coordinate = coordinate || this._coordinate || this._owner.getCenter();
    if (!(coordinate instanceof Coordinate)) {
      coordinate = new Coordinate(coordinate);
    }
    var visible = this.isVisible();
    if (!this._onlyUpdatePosition) {
      this.fire('showstart');
    }
    var container = this._getUIContainer();
    this._coordinate = coordinate;
    if (!this._onlyUpdatePosition) {
      this._removePrevDOM();
    }
    if (!this._mapEventsOn) {
      this._switchMapEvents('on');
    }
    var dom;
    if (!this._onlyUpdatePosition) {
      dom = this.__uiDOM = this.buildOn();
    } else {
      dom = this.__uiDOM;
    }
    dom['eventsPropagation'] = this.options['eventsPropagation'];
    observerUIDomResize(dom, this);
    var zIndex = this.options.zIndex;
    if (!dom) {
      if (!this._onlyUpdatePosition) {
        this.fire('showend');
      }
      this._collides();
      this.setZIndex(zIndex);
      return this;
    }
    if (!this._onlyUpdatePosition) {
      this._measureSize(dom);
    }
    if (this._singleton()) {
      dom._uiComponent = this;
      map[this._uiDomKey()] = dom;
    }
    this._setPosition();
    dom.style[TRANSITION] = null;
    if (!this._onlyUpdatePosition) {
      container.appendChild(dom);
    }
    var anim = this._getAnimation();
    if (visible) {
      anim.ok = false;
    }
    if (anim.ok) {
      if (anim.fade) {
        dom.style.opacity = 0 + '';
      }
      if (anim.scale) {
        if (this.getTransformOrigin) {
          var origin = this.getTransformOrigin();
          dom.style[TRANSFORMORIGIN] = origin;
        }
        dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(0)';
      }
    }
    if (!this.isSupportZoomFilter()) {
      dom.style.display = '';
    }
    if (this.options['eventsToStop']) {
      on(dom, this.options['eventsToStop'], stopPropagation);
    }
    var transition = anim.transition;
    if (anim.ok && transition) {
      dom.offsetHeight;
      if (transition) {
        dom.style[TRANSITION] = transition;
      }
      if (anim.fade) {
        dom.style.opacity = 1 + '';
      }
      if (anim.scale) {
        dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(1)';
      }
    }
    if (!this._onlyUpdatePosition) {
      this.fire('showend');
    }
    this._collides();
    clearTimeout(this._autoPanId);
    if (this.options['autoPan']) {
      this._autoPanId = setTimeout(function () {
        _this2._autoPan();
      }, 32);
    }
    this.setZIndex(zIndex);
    return this;
  };
  _proto.hide = function hide() {
    var _this3 = this;
    if (!this.getDOM()) {
      return this;
    }
    if (this._onDomMouseout) {
      this._onDomMouseout();
    }
    this.options['visible'] = false;
    var anim = this._getAnimation(),
      dom = this.getDOM();
    if (!this.options['animationOnHide']) {
      anim.ok = false;
    }
    if (!anim.ok) {
      dom.style.display = 'none';
      this.fire('hide');
    } else {
      dom.offsetHeight;
      dom.style[TRANSITION] = anim.transition;
      setTimeout(function () {
        dom.style.display = 'none';
        _this3.fire('hide');
      }, this.options['animationDuration']);
    }
    if (anim.fade) {
      dom.style.opacity = 0 + '';
    }
    if (anim.scale) {
      dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(0)';
    }
    this._switchMapEvents('off');
    this._collides();
    return this;
  };
  _proto.isVisible = function isVisible() {
    if (!this.options['visible']) {
      return false;
    }
    var dom = this.getDOM();
    return this.getMap() && dom && dom.parentNode && dom.style.display !== 'none';
  };
  _proto.remove = function remove() {
    delete this._mapEventsOn;
    if (!this._owner) {
      return this;
    }
    var map = this.getMap();
    if (map) {
      map._removeUI(this);
    }
    this.hide();
    this._switchEvents('off');
    if (this.onRemove) {
      this.onRemove();
    }
    if (!this._singleton() && this.__uiDOM) {
      this._removePrevDOM();
    }
    delete this._owner;
    this.fire('remove');
    this._collides();
    return this;
  };
  _proto.getSize = function getSize() {
    if (this._domContentRect && this._size) {
      this._size.width = this._domContentRect.width;
      this._size.height = this._domContentRect.height;
    }
    if (this._size) {
      return this._size.copy();
    } else {
      return null;
    }
  };
  _proto.getOwner = function getOwner() {
    return this._owner;
  };
  _proto.getDOM = function getDOM() {
    return this.__uiDOM;
  };
  _proto.setZIndex = function setZIndex(zIndex) {
    if (!isNumber(zIndex)) {
      return this;
    }
    var dom = this.getDOM();
    if (!dom) {
      return this;
    }
    dom.style.zIndex = zIndex + '';
    if (zIndex !== this.options.zIndex) {
      this.options.zIndex = zIndex;
    }
    return this;
  };
  _proto._roundPoint = function _roundPoint(point) {
    if (this.options.roundPoint) {
      point = point._round();
    }
    return point;
  };
  _proto.getPosition = function getPosition() {
    if (!this.getMap()) {
      return null;
    }
    var p = this._roundPoint(this._getViewPoint());
    if (this.getOffset) {
      var o = this._roundPoint(this.getOffset());
      if (o) {
        p._add(o);
      }
    }
    return p;
  };
  _proto._getAnimation = function _getAnimation() {
    var anim = {
      'fade': false,
      'scale': false,
      'ok': false,
      'transition': ''
    };
    var animations = this.options['animation'] ? this.options['animation'].split(',') : [];
    for (var i = 0; i < animations.length; i++) {
      var trimed = trim(animations[i]);
      if (trimed === 'fade') {
        anim.fade = true;
      } else if (trimed === 'scale') {
        anim.scale = true;
      }
    }
    var transition = null;
    if (anim.fade) {
      transition = 'opacity ' + this.options['animationDuration'] + 'ms';
    }
    if (anim.scale) {
      transition = transition ? transition + ',' : '';
      transition += TRANSFORM + ' ' + this.options['animationDuration'] + 'ms';
    }
    anim.transition = transition;
    anim.ok = transition !== null;
    return anim;
  };
  _proto._getViewPoint = function _getViewPoint() {
    var altitude = 0;
    var coordinates = this._coordinate || {};
    if (isNumber(coordinates.z)) {
      altitude = coordinates.z;
    } else if (this._owner && this._owner.getAltitude) {
      altitude = this._owner.getAltitude() || 0;
      if (!isNumber(altitude)) {
        altitude = 0;
      }
    }
    if (this._owner.getLayer) {
      var layer = this._owner.getLayer();
      if (layer && layer.isVectorLayer) {
        altitude = this._owner._getAltitude() || 0;
        if (!isNumber(altitude)) {
          altitude = 0;
        }
      }
    }
    var alt = this._meterToPoint(this._coordinate, altitude);
    return this.getMap().coordToViewPoint(this._coordinate, undefined, alt)._add(this.options['dx'], this.options['dy']);
  };
  _proto._meterToPoint = function _meterToPoint(center, altitude) {
    return altitude;
  };
  _proto._autoPan = function _autoPan() {
    var map = this.getMap(),
      dom = this.getDOM();
    if (!dom || !map || map.isMoving()) {
      return;
    }
    var point = this._getViewPoint()._round();
    var mapWidth = map.width;
    var mapHeight = map.height;
    var mapContainer = map.getContainer();
    if (dom && mapContainer && dom.getBoundingClientRect) {
      var mapRect = mapContainer.getBoundingClientRect();
      var mapLeft = mapRect.left;
      var mapTop = mapRect.top;
      var _margin = 50;
      var rect = dom.getBoundingClientRect();
      var offsetX = 0,
        offsetY = 0;
      var {
        left: _left,
        right: right,
        top: _top,
        bottom: bottom
      } = rect;
      var {
        width: width,
        height: height
      } = rect;
      _left -= mapLeft;
      right -= mapLeft;
      _top -= mapTop;
      bottom -= mapTop;
      if (width > 0 && height > 0) {
        if (_left < _margin) {
          offsetX = _margin - _left;
        }
        if (offsetX === 0 && right + _margin > mapWidth) {
          offsetX = -(right + _margin - mapWidth);
        }
        if (_top < _margin) {
          offsetY = _margin - _top;
        }
        if (offsetY === 0 && bottom + _margin > mapHeight) {
          offsetY = -(bottom + _margin - mapHeight);
        }
        if (offsetX !== 0 || offsetY !== 0) {
          var cache = MapStateCache[map.id];
          var pitch = cache ? cache.pitch : map.getPitch();
          if (pitch > 40 && offsetY !== 0 && this._coordinate) {
            map.animateTo({
              center: this._coordinate
            }, {
              duration: map.options['panAnimationDuration']
            });
          } else {
            map.panBy([Math.ceil(offsetX), Math.ceil(offsetY)]);
          }
        }
        return;
      }
    }
    var containerPoint0 = map.viewPointToContainerPoint(point);
    var offset = this.getOffset();
    var containerPoint = containerPoint0.add(offset);
    var prjCoord = map.viewPointToPrj(point);
    var domWidth = parseInt(dom.clientWidth + '');
    var domHeight = parseInt(dom.clientHeight + '');
    var margin = 50;
    var left = 0,
      top = 0;
    if (containerPoint.x < 0) {
      left = -containerPoint.x + margin;
    } else if (containerPoint.x + domWidth > mapWidth) {
      left = -(containerPoint.x + domWidth - mapWidth) - margin;
    }
    if (containerPoint.y - domHeight < 0) {
      top = Math.abs(containerPoint.y - domHeight) + margin;
    } else if (containerPoint.y + domHeight > mapHeight) {
      top = mapHeight - (containerPoint.y + domHeight) - margin;
    }
    if (domWidth >= mapWidth) {
      left = mapWidth / 2 - containerPoint0.x;
    }
    if (top !== 0 || left !== 0) {
      var newContainerPoint = containerPoint0.add(left, top);
      var t = map._containerPointToPoint(newContainerPoint)._sub(map._prjToPoint(map._getPrjCenter()));
      var target = map._pointToPrj(map._prjToPoint(prjCoord).sub(t));
      map._panAnimation(target);
    }
  };
  _proto._measureSize = function _measureSize(dom) {
    var container = this._getUIContainer();
    dom.style.position = 'absolute';
    var anchor = dom.style.bottom ? 'bottom' : 'top';
    dom.style.display = '';
    container.appendChild(dom);
    if (dom.getBoundingClientRect) {
      var rect = dom.getBoundingClientRect();
      this._size = new Size(rect.width, rect.height);
    } else {
      this._size = new Size(dom.clientWidth, dom.clientHeight);
    }
    dom.style.display = 'none';
    dom.style.left = '0px';
    dom.style[anchor] = '0px';
    return this._size;
  };
  _proto._removePrevDOM = function _removePrevDOM() {
    if (this.onDomRemove) {
      this.onDomRemove();
    }
    var eventsToStop = this.options['eventsToStop'];
    unobserveUIDomResize(this.__uiDOM);
    if (this._singleton()) {
      var map = this.getMap(),
        key = this._uiDomKey();
      if (map[key]) {
        if (eventsToStop) {
          off(map[key], eventsToStop, stopPropagation);
        }
        var uiComponent = map[key]._uiComponent;
        if (uiComponent && uiComponent !== this && uiComponent.isVisible()) {
          uiComponent.fire('hide');
        }
        removeDomNode(map[key]);
        if (uiComponent && !this.hideDom) {
          uiComponent._switchMapEvents('off');
        }
        delete map[key];
      }
      delete this.__uiDOM;
    } else if (this.__uiDOM) {
      if (eventsToStop) {
        off(this.__uiDOM, eventsToStop, stopPropagation);
      }
      removeDomNode(this.__uiDOM);
      delete this.__uiDOM;
    }
    delete this._domContentRect;
  };
  _proto._uiDomKey = function _uiDomKey() {
    return '__ui_' + this._getClassName();
  };
  _proto._singleton = function _singleton() {
    return this.options['single'];
  };
  _proto._getUIContainer = function _getUIContainer() {
    return this.getMap().getPanels()['ui'];
  };
  _proto._getClassName = function _getClassName() {
    return 'UIComponent';
  };
  _proto._switchMapEvents = function _switchMapEvents(to) {
    var map = this.getMap();
    if (!map) {
      return;
    }
    this._mapEventsOn = to === 'on';
    var events = this._getDefaultEvents();
    if (this.getEvents) {
      extend$2(events, this.getEvents());
    }
    if (events) {
      for (var p in events) {
        if (events.hasOwnProperty(p)) {
          map[to](p, events[p], this);
        }
      }
    }
  };
  _proto._switchEvents = function _switchEvents(to) {
    var ownerEvents = this._getOwnerEvents();
    if (this._owner) {
      for (var p in ownerEvents) {
        if (ownerEvents.hasOwnProperty(p)) {
          this._owner[to](p, ownerEvents[p], this);
        }
      }
    }
  };
  _proto._getDefaultEvents = function _getDefaultEvents() {
    return {
      'zooming rotate pitch': this.onEvent,
      'zoomend': this.onZoomEnd,
      'moving': this.onMoving,
      'moveend': this.onMoving,
      'resize': this.onResize
    };
  };
  _proto._getOwnerEvents = function _getOwnerEvents() {
    var events = {};
    if (this._owner && this._owner instanceof Geometry) {
      events.positionchange = this.onGeometryPositionChange;
      events.symbolchange = this._updatePosition;
    }
    if (this.getOwnerEvents) {
      extend$2(events, this.getOwnerEvents());
    }
    return events;
  };
  _proto.onGeometryPositionChange = function onGeometryPositionChange(param) {
    if (this._owner && this.isVisible()) {
      this._onlyUpdatePosition = true;
      var target = param.target;
      var center = target.getCenter();
      if (target._getAltitude) {
        var altitude = target._getAltitude();
        if (isNumber(altitude)) {
          center.z = altitude;
        }
      }
      this.show(center);
      this._onlyUpdatePosition = false;
    }
  };
  _proto.onMoving = function onMoving() {
    if (this.isVisible() && this.getMap().isTransforming()) {
      this._updatePosition();
    }
  };
  _proto.onEvent = function onEvent() {
    if (this.isVisible()) {
      this._updatePosition();
    }
  };
  _proto.onZoomEnd = function onZoomEnd() {
    if (this.isVisible()) {
      this._setPosition();
    }
  };
  _proto.onResize = function onResize() {
    if (this.isVisible()) {
      this._setPosition();
    }
  };
  _proto.onDomSizeChange = function onDomSizeChange() {
    if (this.isVisible()) {
      this._setPosition();
      this._collides();
    }
  };
  _proto._updatePosition = function _updatePosition() {
    if (!this.getMap()) {
      return this;
    }
    var renderer = this.getMap()._getRenderer();
    renderer.callInNextFrame(this._setPosition.bind(this));
    return this;
  };
  _proto._setPosition = function _setPosition() {
    var dom = this.getDOM();
    if (!dom) return;
    dom.style[TRANSITION] = null;
    var p = this.getPosition();
    this._pos = p;
    dom.style[TRANSFORM] = this._toCSSTranslate(p) + ' scale(1)';
  };
  _proto._toCSSTranslate = function _toCSSTranslate(p) {
    if (!p) {
      return '';
    }
    if (Browser$1.any3d) {
      var map = this.getMap();
      var bearing = 0,
        pitch = 0;
      if (map) {
        var cache = MapStateCache[map.id];
        bearing = cache ? cache.bearing : map.getBearing();
        pitch = cache ? cache.pitch : map.getPitch();
      }
      var r = '';
      if (this.options['pitchWithMap'] && pitch) {
        r += " rotateX(" + Math.round(pitch) + "deg)";
      }
      if (this.options['rotateWithMap'] && bearing) {
        r += " rotateZ(" + Math.round(-bearing) + "deg)";
      }
      return 'translate3d(' + Math.round(p.x) + 'px,' + Math.round(p.y) + 'px, 0px)' + r;
    } else {
      return 'translate(' + Math.round(p.x) + 'px,' + Math.round(p.y) + 'px)';
    }
  };
  _proto.isSupportZoomFilter = function isSupportZoomFilter() {
    return false;
  };
  _proto.onConfig = function onConfig(config) {
    var collisionStateChange = false;
    if (config) {
      for (var i = 0, len = COLLISION_STATES.length; i < len; i++) {
        var key = COLLISION_STATES[i];
        if (key in config) {
          collisionStateChange = true;
          break;
        }
      }
    }
    this._updatePosition();
    if (collisionStateChange) {
      this._collides();
      var map = this.getMap();
      if (map && map._sortUI) {
        map._sortUI();
      }
    }
    return this;
  };
  UIComponent.isSupport = function isSupport(owner) {
    if (owner && isFunction(owner.on) && isFunction(owner.off) && isFunction(owner.getCenter)) {
      return true;
    }
    return false;
  };
  _proto._bindDomEvents = function _bindDomEvents(dom, to) {
    if (!dom) {
      return;
    }
    var events = this._getDomEvents() || {};
    var bindEvent = to === 'on' ? on : off;
    for (var eventName in events) {
      if (to === 'on') {
        off(dom, eventName, events[eventName]);
      }
      bindEvent(dom, eventName, events[eventName], this);
    }
  };
  _proto._getDomEvents = function _getDomEvents() {
    return {
      'mouseover': this._onDomMouseover,
      'mouseout': this._onDomMouseout
    };
  };
  _proto._configMapPreventWheelScroll = function _configMapPreventWheelScroll(preventWheelScroll) {
    var map = this.getMap();
    if (!map) {
      return;
    }
    if (!this.options.enableScrollbar) {
      return;
    }
    if (this.options.eventsPropagation) {
      return;
    }
    map.options['preventWheelScroll'] = preventWheelScroll;
  };
  _proto._onDomMouseover = function _onDomMouseover() {
    this._configMapPreventWheelScroll(false);
    this.fire('mouseover');
  };
  _proto._onDomMouseout = function _onDomMouseout() {
    this._configMapPreventWheelScroll(true);
    this.fire('mouseout');
  };
  return UIComponent;
}(Eventable(Class));
UIComponent.mergeOptions(options$k);
var resizeObserver;
function observerUIDomResize(dom, uiComponent) {
  if (!resizeObserver && Browser$1.resizeObserver) {
    resizeObserver = new ResizeObserver(function (entries) {
      entries = entries || [];
      entries.forEach(function (element) {
        var {
          target: target,
          borderBoxSize: borderBoxSize,
          contentRect: contentRect
        } = element;
        var uicom;
        if (target) {
          uicom = target._uiComponent;
        }
        if (!uicom) {
          return;
        }
        if (borderBoxSize && borderBoxSize.length) {
          uicom._domContentRect = {
            width: borderBoxSize[0].inlineSize,
            height: borderBoxSize[0].blockSize
          };
        } else {
          uicom._domContentRect = contentRect;
        }
        if (uicom.onDomSizeChange) {
          uicom.onDomSizeChange();
        }
      });
    });
  }
  if (resizeObserver && dom) {
    dom._uiComponent = uiComponent;
    resizeObserver.observe(dom);
  }
}
function unobserveUIDomResize(dom) {
  if (dom) {
    delete dom._uiComponent;
    if (resizeObserver) {
      resizeObserver.unobserve(dom);
    }
  }
}

var options$j = {
  'containerClass': null,
  'eventsPropagation': true,
  'draggable': false,
  'single': false,
  'content': null,
  'altitude': 0,
  'minZoom': 0,
  'maxZoom': null,
  'horizontalAlignment': 'middle',
  'verticalAlignment': 'middle'
};
var domEvents = 'mousedown ' + 'mouseup ' + 'mouseenter ' + 'mouseover ' + 'mouseout ' + 'mousemove ' + 'click ' + 'dblclick ' + 'contextmenu ' + 'keypress ' + 'touchstart ' + 'touchmove ' + 'touchend';
var UIMarker = function (_Handlerable) {
  function UIMarker(coordinate, options) {
    var _this;
    _this = _Handlerable.call(this, options) || this;
    _this._markerCoord = new Coordinate(coordinate);
    return _this;
  }
  _inheritsLoose(UIMarker, _Handlerable);
  var _proto = UIMarker.prototype;
  _proto._getClassName = function _getClassName() {
    return 'UIMarker';
  };
  _proto.setCoordinates = function setCoordinates(coordinates) {
    if (!coordinates) {
      return this;
    }
    if (!(coordinates instanceof Coordinate)) {
      try {
        coordinates = new Coordinate(coordinates);
      } catch (error) {
        console.error(error);
        return this;
      }
    }
    this._markerCoord = coordinates;
    this.fire('positionchange');
    if (this.isVisible()) {
      this._onlyUpdatePosition = true;
      this._coordinate = this._markerCoord;
      this._setPosition();
      this._collides();
      this._onlyUpdatePosition = false;
    }
    return this;
  };
  _proto.getCoordinates = function getCoordinates() {
    return this._markerCoord;
  };
  _proto.getCenter = function getCenter() {
    return this.getCoordinates();
  };
  _proto.getAltitude = function getAltitude() {
    var coordinates = this.getCoordinates() || {};
    if (isNumber(coordinates.z)) {
      return coordinates.z;
    }
    return this.options.altitude || 0;
  };
  _proto.setAltitude = function setAltitude(alt) {
    if (isNumber(alt) && this._markerCoord) {
      this._markerCoord.z = alt;
      if (this._updatePosition) {
        this._updatePosition();
        this._collides();
      }
    }
    return this;
  };
  _proto.setContent = function setContent(content) {
    var old = this.options['content'];
    this.options['content'] = content;
    this.fire('contentchange', {
      'old': old,
      'new': content
    });
    if (this.isVisible()) {
      this.show();
    }
    return this;
  };
  _proto.getContent = function getContent() {
    return this.options['content'];
  };
  _proto.onAdd = function onAdd() {
    if (this._owner && !this._owner.isMap) {
      var owner = this._owner;
      throw new Error('UIMarker Can only be added to the map, but owner is:' + owner.getJSONType && owner.getJSONType());
    }
    this.show();
    return this;
  };
  _proto.show = function show() {
    return _Handlerable.prototype.show.call(this, this._markerCoord);
  };
  _proto.flash = function flash$1(interval, count, cb, context) {
    return flash.call(this, interval, count, cb, context);
  };
  _proto.buildOn = function buildOn() {
    var oldDom = this.getDOM();
    this._bindDomEvents(oldDom, 'off');
    var dom;
    var content = this.options['content'];
    var isStr = isString(content);
    if (isStr || isFunction(content)) {
      dom = createEl('div');
      if (isStr) {
        dom.innerHTML = this.options['content'];
      } else {
        content.bind(this)(dom);
      }
    } else {
      dom = this.options['content'];
    }
    if (this.options['containerClass']) {
      dom.className = this.options['containerClass'];
    }
    this._registerDOMEvents(dom);
    this._bindDomEvents(dom, 'on');
    this._appendCustomClass(dom);
    return dom;
  };
  _proto.getOffset = function getOffset() {
    var size = this.getSize();
    var offsetX = -size.width / 2,
      offsetY = -size.height / 2;
    var {
      horizontalAlignment: horizontalAlignment,
      verticalAlignment: verticalAlignment
    } = this.options;
    if (horizontalAlignment === 'left') {
      offsetX = -size.width;
    } else if (horizontalAlignment === 'right') {
      offsetX = 0;
    }
    if (verticalAlignment === 'top') {
      offsetY = -size.height;
    } else if (verticalAlignment === 'bottom') {
      offsetY = 0;
    }
    return new Point(offsetX, offsetY);
  };
  _proto.getTransformOrigin = function getTransformOrigin() {
    return 'center center';
  };
  _proto.onDomRemove = function onDomRemove() {
    var dom = this.getDOM();
    this._removeDOMEvents(dom);
  };
  _proto.isDragging = function isDragging() {
    if (this['draggable']) {
      return this['draggable'].isDragging();
    }
    return false;
  };
  _proto._registerDOMEvents = function _registerDOMEvents(dom) {
    on(dom, domEvents, this._onDomEvents, this);
  };
  _proto._onDomEvents = function _onDomEvents(e, type) {
    var event = this.getMap()._parseEvent(e, e.type);
    type = type || e.type;
    if (type === 'mousedown') {
      this._mousedownEvent = e;
    }
    if (type === 'mouseup') {
      this._mouseupEvent = e;
    }
    if (type === 'click' && this._mouseClickPositionIsChange()) {
      return;
    }
    if (type === 'touchstart') {
      this._touchstartTime = now();
    }
    this.fire(type, event);
    if (type === 'touchend' && Browser$1.touch) {
      var clickTimeThreshold = this.getMap().options.clickTimeThreshold || 280;
      if (now() - this._touchstartTime < clickTimeThreshold) {
        this._onDomEvents(e, 'click');
      }
    }
  };
  _proto._removeDOMEvents = function _removeDOMEvents(dom) {
    off(dom, domEvents, this._onDomEvents);
  };
  _proto._mouseClickPositionIsChange = function _mouseClickPositionIsChange() {
    var {
      x: x1,
      y: y1
    } = this._mousedownEvent || {};
    var {
      x: x2,
      y: y2
    } = this._mouseupEvent || {};
    return x1 !== x2 || y1 !== y2;
  };
  _proto._getConnectPoints = function _getConnectPoints() {
    var map = this.getMap();
    var containerPoint = map.coordToContainerPoint(this.getCoordinates());
    var size = this.getSize(),
      width = size.width,
      height = size.height;
    var anchors = [map.containerPointToCoordinate(containerPoint.add(-width / 2, 0)), map.containerPointToCoordinate(containerPoint.add(width / 2, 0)), map.containerPointToCoordinate(containerPoint.add(0, height / 2)), map.containerPointToCoordinate(containerPoint.add(0, -height / 2))];
    return anchors;
  };
  _proto._getViewPoint = function _getViewPoint() {
    var alt = 0;
    if (this._owner) {
      var altitude = this.getAltitude();
      if (altitude > 0) {
        alt = this._meterToPoint(this._coordinate, altitude);
      }
    }
    return this.getMap().coordToViewPoint(this._coordinate, undefined, alt)._add(this.options['dx'], this.options['dy']);
  };
  _proto._getDefaultEvents = function _getDefaultEvents() {
    return extend$2({}, _Handlerable.prototype._getDefaultEvents.call(this), {
      'zooming zoomend': this.onZoomFilter
    });
  };
  _proto._setPosition = function _setPosition() {
    this.onZoomFilter();
    _Handlerable.prototype._setPosition.call(this);
  };
  _proto.onZoomFilter = function onZoomFilter() {
    var dom = this.getDOM();
    if (!dom) return;
    if (!this.isVisible() && dom.style.display !== 'none') {
      dom.style.display = 'none';
    } else if (this.isVisible() && dom.style.display === 'none') {
      dom.style.display = '';
    }
  };
  _proto.isVisible = function isVisible() {
    var map = this.getMap();
    if (!map) {
      return false;
    }
    if (!this.options['visible']) {
      return false;
    }
    var cache = MapStateCache[map.id];
    var zoom = cache ? cache.zoom : map.getZoom();
    var {
      minZoom: minZoom,
      maxZoom: maxZoom
    } = this.options;
    if (!isNil(minZoom) && zoom < minZoom || !isNil(maxZoom) && zoom > maxZoom) {
      return false;
    }
    var dom = this.getDOM();
    return dom && true;
  };
  _proto.isSupportZoomFilter = function isSupportZoomFilter() {
    return true;
  };
  return UIMarker;
}(Handlerable(UIComponent));
UIMarker.mergeOptions(options$j);
var EVENTS$2 = Browser$1.touch ? 'touchstart mousedown' : 'mousedown';
var UIMarkerDragHandler = function (_Handler) {
  function UIMarkerDragHandler(target) {
    return _Handler.call(this, target) || this;
  }
  _inheritsLoose(UIMarkerDragHandler, _Handler);
  var _proto2 = UIMarkerDragHandler.prototype;
  _proto2.addHooks = function addHooks() {
    this.target.on(EVENTS$2, this._startDrag, this);
  };
  _proto2.removeHooks = function removeHooks() {
    this.target.off(EVENTS$2, this._startDrag, this);
  };
  _proto2._startDrag = function _startDrag(param) {
    var domEvent = param['domEvent'];
    if (domEvent.touches && domEvent.touches.length > 1 || domEvent.button === 2) {
      return;
    }
    if (this.isDragging()) {
      return;
    }
    this.target.on('click', this._endDrag, this);
    this._lastCoord = param['coordinate'];
    this._lastPoint = param['containerPoint'];
    this._prepareDragHandler();
    this._dragHandler.onMouseDown(param['domEvent']);
    this.target.fire('dragstart', param);
  };
  _proto2._prepareDragHandler = function _prepareDragHandler() {
    this._dragHandler = new DragHandler(this.target.getDOM(), {
      'cancelOn': this._cancelOn.bind(this),
      'ignoreMouseleave': true
    });
    this._dragHandler.on('mousedown', this._onMouseDown, this);
    this._dragHandler.on('dragging', this._dragging, this);
    this._dragHandler.on('mouseup', this._endDrag, this);
    this._dragHandler.enable();
  };
  _proto2._cancelOn = function _cancelOn(domEvent) {
    var target = domEvent.srcElement || domEvent.target,
      tagName = target.tagName.toLowerCase();
    if (tagName === 'button' || tagName === 'input' || tagName === 'select' || tagName === 'option' || tagName === 'textarea') {
      return true;
    }
    return false;
  };
  _proto2._onMouseDown = function _onMouseDown(param) {
    stopPropagation(param['domEvent']);
  };
  _proto2._dragging = function _dragging(param) {
    var target = this.target,
      map = target.getMap(),
      eventParam = map._parseEvent(param['domEvent']),
      domEvent = eventParam['domEvent'];
    var touchEvent = domEvent;
    if (touchEvent.touches && touchEvent.touches.length > 1) {
      return;
    }
    if (!this._isDragging) {
      this._isDragging = true;
      return;
    }
    var coord = eventParam['coordinate'],
      point = eventParam['containerPoint'];
    if (!this._lastCoord) {
      this._lastCoord = coord;
    }
    if (!this._lastPoint) {
      this._lastPoint = point;
    }
    var coordOffset = coord.sub(this._lastCoord),
      pointOffset = point.sub(this._lastPoint);
    this._lastCoord = coord;
    this._lastPoint = point;
    this.target.setCoordinates(this.target.getCoordinates().add(coordOffset));
    eventParam['coordOffset'] = coordOffset;
    eventParam['pointOffset'] = pointOffset;
    target.fire('dragging', eventParam);
  };
  _proto2._endDrag = function _endDrag(param) {
    var target = this.target,
      map = target.getMap();
    if (this._dragHandler) {
      target.off('click', this._endDrag, this);
      this._dragHandler.disable();
      delete this._dragHandler;
    }
    delete this._lastCoord;
    delete this._lastPoint;
    this._isDragging = false;
    if (!map) {
      return;
    }
    var eventParam = map._parseEvent(param['domEvent']);
    if (target && target._mouseClickPositionIsChange && target._mouseClickPositionIsChange()) {
      target.fire('dragend', eventParam);
    }
  };
  _proto2.isDragging = function isDragging() {
    if (!this._isDragging) {
      return false;
    }
    return true;
  };
  return UIMarkerDragHandler;
}(Handler);
UIMarker.addInitHook('addHandler', 'draggable', UIMarkerDragHandler);

var PROPERTY_PATTERN = /\{ *([\w_]+) *\}/g;
var options$i = {
  'containerClass': 'maptalks-msgBox',
  'autoPan': true,
  'autoCloseOn': null,
  'autoOpenOn': 'click',
  'width': 'auto',
  'minHeight': 120,
  'custom': false,
  'title': null,
  'content': null,
  'enableTemplate': false,
  'horizontalAlignment': 'middle',
  'verticalAlignment': 'top'
};
var EMPTY_SIZE = new Size(0, 0);
var InfoWindow = function (_UIComponent) {
  function InfoWindow() {
    return _UIComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(InfoWindow, _UIComponent);
  var _proto = InfoWindow.prototype;
  _proto._getClassName = function _getClassName() {
    return 'InfoWindow';
  };
  _proto.addTo = function addTo(owner) {
    if (owner instanceof Geometry) {
      if (owner.getInfoWindow() && owner.getInfoWindow() !== this) {
        owner.removeInfoWindow();
      }
      owner._infoWindow = this;
    }
    return _UIComponent.prototype.addTo.call(this, owner);
  };
  _proto.setContent = function setContent(content) {
    var old = this.options['content'];
    this.options['content'] = content;
    this.fire('contentchange', {
      'old': old,
      'new': content
    });
    if (this.isVisible()) {
      this.show(this._coordinate);
    }
    return this;
  };
  _proto.getContent = function getContent() {
    return this.options['content'];
  };
  _proto.setTitle = function setTitle(title) {
    var old = title;
    this.options['title'] = title;
    this.fire('contentchange', {
      'old': old,
      'new': title
    });
    if (this.isVisible()) {
      this.show(this._coordinate);
    }
    return this;
  };
  _proto.getTitle = function getTitle() {
    return this.options['title'];
  };
  _proto.buildOn = function buildOn() {
    var _this = this;
    var isFunc = isFunction(this.options['content']);
    var isStr = isString(this.options['content']);
    if (this.options['custom']) {
      var oldDom = this.getDOM();
      var newDom;
      this._bindDomEvents(oldDom, 'off');
      if (isStr || isFunc) {
        var _dom = createEl('div');
        if (isStr) {
          _dom.innerHTML = this.options['content'];
          this._replaceTemplate(_dom);
        } else {
          this.options['content'].bind(this)(_dom);
        }
        newDom = _dom;
      } else {
        this._replaceTemplate(this.options['content']);
        newDom = this.options['content'];
      }
      this._bindDomEvents(newDom, 'on');
      this._appendCustomClass(newDom);
      return newDom;
    }
    this._bindDomEvents(this.getDOM(), 'off');
    var dom = createEl('div');
    if (this.options['containerClass']) {
      dom.className = this.options['containerClass'];
    }
    var width = this._getWindowWidth();
    dom.style.width = isNumber(width) ? width + 'px' : 'auto';
    dom.style.bottom = '0px';
    var content = '<em class="maptalks-ico"></em>';
    if (this.options['title']) {
      content += '<h2>' + this.options['title'] + '</h2>';
    }
    content += '<a href="javascript:void(0);" class="maptalks-close">×</a><div class="maptalks-msgContent"></div>';
    dom.innerHTML = content;
    this._replaceTemplate(dom);
    var msgContent = dom.querySelector('.maptalks-msgContent');
    if (isStr || isFunc) {
      if (isStr) {
        msgContent.innerHTML = this.options['content'];
      } else {
        this.options['content'].bind(this)(msgContent);
      }
    } else {
      msgContent.appendChild(this.options['content']);
    }
    this._onCloseBtnClick = function (event) {
      if (!_this.options.eventsPropagation) {
        preventDefault(event);
        stopPropagation(event);
      }
      _this.hide();
    };
    var closeBtn = dom.querySelector('.maptalks-close');
    addDomEvent(closeBtn, 'click touchend', this._onCloseBtnClick);
    if (!isFunc) {
      this._replaceTemplate(msgContent);
    }
    this._bindDomEvents(dom, 'on');
    this._appendCustomClass(dom);
    return dom;
  };
  _proto._replaceTemplate = function _replaceTemplate(dom) {
    var geo = this._owner;
    if (this.options['enableTemplate'] && geo && geo.getProperties && dom && dom.innerHTML) {
      var properties = geo.getProperties() || {};
      if (isObject$1(properties)) {
        var html = dom.innerHTML;
        dom.innerHTML = html.replace(PROPERTY_PATTERN, function (str, key) {
          return properties[key];
        });
      }
    }
    return this;
  };
  _proto.getTransformOrigin = function getTransformOrigin() {
    var size = this.getSize();
    return size.width / 2 + 'px bottom';
  };
  _proto.getOffset = function getOffset() {
    var size = this.getSize();
    var offsetX = -size.width / 2,
      offsetY = size.height / 2;
    var {
      horizontalAlignment: horizontalAlignment,
      verticalAlignment: verticalAlignment,
      custom: custom
    } = this.options;
    if (!custom) {
      var dom = this.getDOM();
      if (dom) {
        var icoDom = dom.querySelector('.maptalks-ico');
        if (icoDom && icoDom.classList) {
          var classList = icoDom.classList;
          var className = "maptalks-ico-" + horizontalAlignment + "-" + verticalAlignment;
          var needRemove = [];
          classList.forEach(function (item) {
            if (item !== className && item.indexOf('maptalks-ico-') > -1) {
              needRemove.push(item);
            }
          });
          if (needRemove.length) {
            needRemove.forEach(function (item) {
              classList.remove(item);
            });
          }
          if (!classList.contains(className)) {
            classList.add(className);
          }
        }
      }
    }
    var isTop = false;
    if (horizontalAlignment === 'left') {
      offsetX = -size.width;
    } else if (horizontalAlignment === 'right') {
      offsetX = 0;
    }
    if (verticalAlignment === 'top') {
      offsetY = 0;
      isTop = true;
    } else if (verticalAlignment === 'bottom') {
      offsetY = size.height;
    }
    var o = new Point(offsetX, offsetY);
    if (!custom) {
      o._sub(4, isTop ? 12 : 0);
    } else {
      o._sub(0, size['height']);
    }
    var owner = this.getOwner();
    if (owner instanceof Marker || owner instanceof MultiPoint) {
      var painter, markerSize;
      if (owner instanceof Marker) {
        painter = owner._getPainter();
        markerSize = owner.getSize();
      } else {
        var children = owner.getGeometries();
        if (!children || !children.length) {
          return o;
        }
        painter = children[0]._getPainter();
        markerSize = children[0].getSize();
      }
      if (!markerSize) {
        markerSize = EMPTY_SIZE;
      }
      if (painter) {
        var fixExtent = painter.getFixedExtent();
        var translateY = fixExtent.ymin;
        if (verticalAlignment === 'bottom') {
          translateY = fixExtent.ymax;
        }
        var translateX = 0;
        if (verticalAlignment === 'middle') {
          if (horizontalAlignment === 'left') {
            translateX = -markerSize.width / 2;
          }
          if (horizontalAlignment === 'right') {
            translateX = markerSize.width / 2;
          }
        }
        o._add(fixExtent.xmax - markerSize.width / 2 + translateX, translateY);
      } else {
        o._add(0, -markerSize.height);
      }
    }
    return o;
  };
  _proto.show = function show(coordinate) {
    if (!this.getMap()) {
      return this;
    }
    if (!this.getMap().options['enableInfoWindow']) {
      return this;
    }
    return _UIComponent.prototype.show.call(this, coordinate);
  };
  _proto.getEvents = function getEvents() {
    if (!this.options['autoCloseOn']) {
      return null;
    }
    var events = {};
    events[this.options['autoCloseOn']] = this.hide;
    return events;
  };
  _proto.getOwnerEvents = function getOwnerEvents() {
    var owner = this.getOwner();
    if (!this.options['autoOpenOn'] || !owner) {
      return null;
    }
    var events = {};
    events[this.options['autoOpenOn']] = this._onAutoOpen;
    return events;
  };
  _proto.onRemove = function onRemove() {
    this._onDomMouseout();
    this.onDomRemove();
  };
  _proto.onDomRemove = function onDomRemove() {
    if (this._onCloseBtnClick) {
      var dom = this.getDOM();
      var closeBtn = dom.childNodes[2];
      removeDomEvent(closeBtn, 'click touchend', this._onCloseBtnClick);
      delete this._onCloseBtnClick;
    }
  };
  _proto._onAutoOpen = function _onAutoOpen(e) {
    var _this2 = this;
    var owner = this.getOwner();
    setTimeout(function () {
      if (owner instanceof Marker || owner instanceof UIComponent) {
        _this2.show(owner.getCoordinates());
      } else if (owner instanceof MultiPoint) {
        _this2.show(owner.findClosest(e.coordinate));
      } else if (owner instanceof LineString || owner instanceof MultiLineString) {
        if (_this2.getMap().getScale() >= 8) {
          e.coordinate = _this2._rectifyMouseCoordinte(owner, e.coordinate);
        }
        _this2.show(e.coordinate);
      } else {
        _this2.show(e.coordinate);
      }
    }, 1);
  };
  _proto._rectifyMouseCoordinte = function _rectifyMouseCoordinte(owner, mouseCoordinate) {
    var _this3 = this;
    if (owner instanceof LineString) {
      return this._rectifyLineStringMouseCoordinate(owner, mouseCoordinate).coordinate;
    } else if (owner instanceof MultiLineString) {
      return owner.getGeometries().map(function (lineString) {
        return _this3._rectifyLineStringMouseCoordinate(lineString, mouseCoordinate);
      }).sort(function (a, b) {
        return a.dis - b.dis;
      })[0].coordinate;
    }
    return mouseCoordinate;
  };
  _proto._rectifyLineStringMouseCoordinate = function _rectifyLineStringMouseCoordinate(lineString, mouseCoordinate) {
    var map = this.getMap();
    var coordinates = lineString.getCoordinates() || [];
    var glRes = map.getGLRes();
    var pts = coordinates.map(function (coordinate) {
      var renderPoints = map.coordToPointAtRes(coordinate, glRes);
      var altitude = coordinate.z || 0;
      return map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
    });
    var mousePt = map.coordToContainerPoint(mouseCoordinate);
    var minDis = Infinity,
      coordinateIndex = -1;
    for (var i = 0, len = pts.length; i < len; i++) {
      var pt = pts[i];
      var dis = mousePt.distanceTo(pt);
      if (dis < minDis) {
        minDis = dis;
        coordinateIndex = i;
      }
    }
    var indexs = [coordinateIndex - 1, coordinateIndex, coordinateIndex + 1].filter(function (index) {
      return index >= 0 && index <= pts.length - 1;
    });
    var filterPts = indexs.map(function (index) {
      return pts[index];
    });
    var xys = [];
    var {
      width: width,
      height: height
    } = map.getSize();
    for (var _i = 0, _len = filterPts.length - 1; _i < _len; _i++) {
      var _coordinateIndex = _i;
      var pt1 = filterPts[_i],
        pt2 = filterPts[_i + 1];
      if (pt1.x === pt2.x) {
        var miny = Math.max(0, Math.min(pt1.y, pt2.y));
        var maxy = Math.min(height, Math.max(pt1.y, pt2.y));
        for (var _y = miny; _y <= maxy; _y++) {
          xys.push({
            point: new Point(pt1.x, _y),
            coordinateIndex: _coordinateIndex
          });
        }
      } else {
        var k = (pt2.y - pt1.y) / (pt2.x - pt1.x);
        var minx = Math.max(0, Math.min(pt1.x, pt2.x));
        var maxx = Math.min(width, Math.max(pt1.x, pt2.x));
        for (var _x = minx; _x <= maxx; _x++) {
          var _y2 = k * (_x - pt1.x) + pt1.y;
          xys.push({
            point: new Point(_x, _y2),
            coordinateIndex: _coordinateIndex
          });
        }
      }
    }
    var minPtDis = Infinity,
      ptIndex = -1,
      index = -1,
      containerPoint;
    for (var _i2 = 0, _len2 = xys.length; _i2 < _len2; _i2++) {
      var {
        point: point,
        coordinateIndex: _coordinateIndex2
      } = xys[_i2];
      var _dis = mousePt.distanceTo(point);
      if (_dis < minPtDis) {
        minPtDis = _dis;
        ptIndex = _i2;
        index = _coordinateIndex2;
        containerPoint = point;
      }
    }
    if (ptIndex < 0) {
      return {
        dis: minPtDis,
        coordinate: mouseCoordinate
      };
    }
    var p1 = filterPts[index],
      p2 = filterPts[index + 1];
    var distance = p1.distanceTo(p2);
    var d = containerPoint.distanceTo(p1);
    var percent = d / distance;
    var filterCoordinates = indexs.map(function (index) {
      return coordinates[index];
    });
    var c1 = filterCoordinates[index],
      c2 = filterCoordinates[index + 1];
    var x1 = c1.x,
      y1 = c1.y,
      z1 = c1.z || 0;
    var x2 = c2.x,
      y2 = c2.y,
      z2 = c2.z || 0;
    var dx = x2 - x1,
      dy = y2 - y1,
      dz = z2 - z1;
    var x = x1 + dx * percent,
      y = y1 + dy * percent,
      z = z1 + dz * percent;
    return {
      dis: minPtDis,
      coordinate: new Coordinate(x, y, z)
    };
  };
  _proto._getWindowWidth = function _getWindowWidth() {
    var defaultWidth = options$i.width;
    var width = this.options['width'];
    if (!width) {
      width = defaultWidth;
    }
    return width;
  };
  return InfoWindow;
}(UIComponent);
InfoWindow.mergeOptions(options$i);

var HIDEDOMEVENTS = 'remove hide shapechange positionchange dragend animatestart';
var options$h = {
  'width': 0,
  'height': 0,
  'animation': 'fade',
  'containerClass': 'maptalks-tooltip',
  'showTimeout': 400
};
var ToolTip = function (_UIComponent) {
  function ToolTip(content, options = {}) {
    var _this;
    _this = _UIComponent.call(this, options) || this;
    _this._content = content;
    return _this;
  }
  _inheritsLoose(ToolTip, _UIComponent);
  var _proto = ToolTip.prototype;
  _proto._getClassName = function _getClassName() {
    return 'ToolTip';
  };
  _proto.addTo = function addTo(owner) {
    if (ToolTip.isSupport(owner)) {
      owner.on('mousemove', this.onMouseMove, this);
      owner.on('mouseout', this.onMouseOut, this);
      owner.on(HIDEDOMEVENTS, this.hideDom, this);
      return _UIComponent.prototype.addTo.call(this, owner);
    } else {
      throw new Error('Invalid geometry or UIMarker the tooltip is added to.');
    }
  };
  _proto.setStyle = function setStyle(cssName) {
    this.options.containerClass = cssName;
    return this;
  };
  _proto.getStyle = function getStyle() {
    return this.options.containerClass;
  };
  _proto.getContent = function getContent() {
    return this._content;
  };
  _proto.buildOn = function buildOn() {
    var dom = createEl('div');
    var options = this.options || {};
    if (options.height) {
      dom.style.height = options.height + 'px';
    }
    if (options.width) {
      dom.style.width = options.width + 'px';
    }
    var cssName = options.containerClass || options.cssName;
    if (!cssName && options.height) {
      dom.style.lineHeight = options.height + 'px';
    }
    if (isFunction(this._content)) {
      this._content.bind(this)(dom);
    } else {
      dom.innerHTML = "<div class=\"" + cssName + "\">" + this._content + "</div>";
    }
    this._appendCustomClass(dom);
    return dom;
  };
  _proto.onMouseOut = function onMouseOut() {
    clearTimeout(this._timeout);
    if (this.isVisible()) {
      this._removePrevDOM();
    }
    this._switchMapEvents('off');
  };
  _proto.onMouseMove = function onMouseMove(e) {
    var _this2 = this;
    clearTimeout(this._timeout);
    var map = this.getMap();
    if (!map) {
      return;
    }
    var coord = map.locateByPoint(e.coordinate, -5, 25);
    if (this.options['showTimeout'] === 0) {
      this.show(coord);
    } else {
      this._timeout = setTimeout(function () {
        if (map) {
          _this2.show(coord);
        }
      }, this.options['showTimeout']);
    }
  };
  _proto.onRemove = function onRemove() {
    clearTimeout(this._timeout);
    if (this._owner) {
      this._owner.off('mousemove', this.onMouseMove, this);
      this._owner.off('mouseout', this.onMouseOut, this);
      this._owner.off(HIDEDOMEVENTS, this.hideDom, this);
    }
  };
  _proto.hideDom = function hideDom() {
    this.hide();
  };
  _proto.onEvent = function onEvent() {
    _UIComponent.prototype.onEvent.call(this);
    this.hideDom();
    return this;
  };
  _proto._getViewPoint = function _getViewPoint() {
    return this.getMap().coordToViewPoint(this._coordinate, undefined, 0)._add(this.options['dx'], this.options['dy']);
  };
  return ToolTip;
}(UIComponent);
ToolTip.mergeOptions(options$h);

var defaultOptions = {
  'containerClass': 'maptalks-menu',
  'animation': null,
  'animationDelay': 10,
  'animationOnHide': false,
  'autoPan': false,
  'width': 160,
  'maxHeight': 0,
  'custom': false,
  'items': []
};
var Menu = function (_UIComponent) {
  function Menu(options) {
    return _UIComponent.call(this, options) || this;
  }
  _inheritsLoose(Menu, _UIComponent);
  var _proto = Menu.prototype;
  _proto._getClassName = function _getClassName() {
    return 'Menu';
  };
  _proto.addTo = function addTo(owner) {
    if (owner._menu && owner._menu !== this) {
      owner.removeMenu();
    }
    owner._menu = this;
    this._owner = owner;
    return UIComponent.prototype.addTo.apply(this, [owner]);
  };
  _proto.setItems = function setItems(items) {
    this.options['items'] = items;
    return this;
  };
  _proto.getItems = function getItems() {
    return this.options['items'] || [];
  };
  _proto.buildOn = function buildOn() {
    var dom;
    if (this.options['custom']) {
      if (isString(this.options['items'])) {
        var container = createEl('div');
        container.innerHTML = this.options['items'];
        this._appendCustomClass(container);
        dom = container;
      } else {
        dom = this.options['items'];
      }
    } else {
      dom = createEl('div');
      if (this.options['containerClass']) {
        addClass(dom, this.options['containerClass']);
      }
      dom.style.width = this._getMenuWidth() + 'px';
      var menuItems = this._createMenuItemDom();
      dom.appendChild(menuItems);
      on(dom, 'contextmenu', preventDefault);
      this._appendCustomClass(dom);
    }
    if (dom) {
      this._bindDomEvents(dom, 'off');
      this._bindDomEvents(dom, 'on');
    }
    return dom;
  };
  _proto.getOffset = function getOffset() {
    if (!this.getMap()) {
      return null;
    }
    var mapSize = this.getMap().getSize(),
      p = this.getMap().viewPointToContainerPoint(this._getViewPoint()),
      size = this.getSize();
    var dx = 0,
      dy = 0;
    if (p.x + size['width'] > mapSize['width']) {
      dx = -size['width'];
    }
    if (p.y + size['height'] > mapSize['height']) {
      dy = -size['height'];
    }
    return new Point(dx, dy);
  };
  _proto.getTransformOrigin = function getTransformOrigin() {
    var p = this.getOffset()._multi(-1);
    return p.x + 'px ' + p.y + 'px';
  };
  _proto.getEvents = function getEvents() {
    return {
      '_zoomstart _zoomend _movestart _dblclick _click': this._removePrevDOM
    };
  };
  _proto._createMenuItemDom = function _createMenuItemDom() {
    var me = this;
    var map = this.getMap();
    var ul = createEl('ul');
    addClass(ul, 'maptalks-menu-items');
    var items = this.getItems();
    function onMenuClick(index) {
      return function (e) {
        var param = map._parseEvent(e, 'click');
        param['target'] = me;
        param['owner'] = me._owner;
        param['index'] = index;
        var result = this._callback(param);
        if (result === false) {
          return;
        }
        me.hide();
        if (me._owner) {
          me._owner.fire('closemenu');
        }
      };
    }
    var item, itemDOM;
    for (var i = 0, len = items.length; i < len; i++) {
      item = items[i];
      if (item === '-' || item === '_') {
        itemDOM = createEl('li');
        addClass(itemDOM, 'maptalks-menu-splitter');
      } else {
        itemDOM = createEl('li');
        var itemTitle = item['item'];
        if (isFunction(itemTitle)) {
          itemTitle = itemTitle({
            'owner': this._owner,
            'index': i
          });
        }
        itemDOM.innerHTML = itemTitle;
        itemDOM._callback = item['click'];
        on(itemDOM, 'click', onMenuClick(i));
      }
      ul.appendChild(itemDOM);
    }
    var maxHeight = this.options['maxHeight'] || 0;
    if (maxHeight > 0) {
      setStyle(ul, 'max-height: ' + maxHeight + 'px; overflow-y: auto;');
    }
    return ul;
  };
  _proto._getMenuWidth = function _getMenuWidth() {
    var defaultWidth = 160;
    var width = this.options['width'] || defaultWidth;
    return width;
  };
  return Menu;
}(UIComponent);
Menu.mergeOptions(defaultOptions);

var Menuable = {
  setMenu: function setMenu(options) {
    this._menuOptions = options;
    if (this._menu) {
      this._menu._setOptions(options);
    } else {
      this.off('contextmenu', this._defaultOpenMenu, this);
      this.on('contextmenu', this._defaultOpenMenu, this);
    }
    return this;
  },
  getMenu: function getMenu() {
    return this._menu;
  },
  openMenu: function openMenu(coordinate) {
    var map = this instanceof Map$1 ? this : this.getMap();
    if (!coordinate) {
      coordinate = this.getCenter();
    }
    if (!this._menu) {
      if (this._menuOptions && map) {
        this._bindMenu();
        this._menu.show(coordinate);
      }
    } else {
      this._menu.show(coordinate);
    }
    this.fire('openmenu', {
      coordinate: coordinate
    });
    return this;
  },
  setMenuItems: function setMenuItems(items) {
    if (!this._menuOptions) {
      this._menuOptions = {};
    }
    if (Array.isArray(items)) {
      this._menuOptions['custom'] = false;
    }
    this._menuOptions['items'] = items;
    this.setMenu(this._menuOptions);
    return this;
  },
  getMenuItems: function getMenuItems() {
    if (this._menu) {
      return this._menu.getItems();
    } else if (this._menuOptions) {
      return this._menuOptions['items'] || [];
    }
    return [];
  },
  closeMenu: function closeMenu() {
    if (this._menu) {
      this._menu.hide();
    }
    this.fire('closemenu', {});
    return this;
  },
  removeMenu: function removeMenu() {
    this.off('contextmenu', this._defaultOpenMenu, this);
    this._unbindMenu();
    delete this._menuOptions;
    this.fire('removemenu', {});
    return this;
  },
  _bindMenu: function _bindMenu() {
    if (!this._menuOptions) {
      return this;
    }
    this._menu = new Menu(this._menuOptions);
    this._menu.addTo(this);
    return this;
  },
  _unbindMenu: function _unbindMenu() {
    if (this._menu) {
      this.closeMenu();
      this._menu.remove();
      delete this._menu;
    }
    return this;
  },
  _defaultOpenMenu: function _defaultOpenMenu(param) {
    this.openMenu(param['coordinate']);
    return false;
  }
};
Map$1.include(Menuable);
Geometry.include(Menuable);

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InfoWindow: InfoWindow,
  Menu: Menu,
  Menuable: Menuable,
  ToolTip: ToolTip,
  UIComponent: UIComponent,
  UIMarker: UIMarker
});

var Control = function (_Eventable) {
  function Control(options) {
    if (options && options['position'] && !isString(options['position'])) {
      options['position'] = extend$2({}, options['position']);
    }
    return _Eventable.call(this, options) || this;
  }
  _inheritsLoose(Control, _Eventable);
  var _proto = Control.prototype;
  _proto._appendCustomClass = function _appendCustomClass(dom) {
    if (!dom) {
      console.warn('dom is null:', dom);
      return this;
    }
    if (this.options.cssName) {
      var cssName = this.options.cssName;
      if (!Array.isArray(cssName)) {
        cssName = [cssName];
      }
      cssName.forEach(function (name) {
        dom.classList.add(name);
      });
    }
    return this;
  };
  _proto.onAdd = function onAdd() {};
  _proto.onRemove = function onRemove() {};
  _proto.addTo = function addTo(map) {
    this.remove();
    if (!map.options['control']) {
      return this;
    }
    this._map = map;
    var controlContainer = map.getPanels().control;
    this.__ctrlContainer = createEl('div');
    setStyle(this.__ctrlContainer, 'position:absolute;overflow:visible;');
    this.update();
    controlContainer.appendChild(this.__ctrlContainer);
    if (this.onAdd) {
      this.onAdd();
    }
    this.fire('add', {
      'dom': controlContainer
    });
    return this;
  };
  _proto.update = function update() {
    this.__ctrlContainer.innerHTML = '';
    this._controlDom = this.buildOn(this.getMap());
    if (this._controlDom) {
      this._updatePosition();
      this.__ctrlContainer.appendChild(this._controlDom);
    }
    return this;
  };
  _proto.getMap = function getMap() {
    return this._map;
  };
  _proto.getPosition = function getPosition() {
    return extend$2({}, this._parse(this.options['position']));
  };
  _proto.setPosition = function setPosition(position) {
    if (isString(position)) {
      this.options['position'] = position;
    } else {
      this.options['position'] = extend$2({}, position);
    }
    this._updatePosition();
    return this;
  };
  _proto.getContainerPoint = function getContainerPoint() {
    var position = this.getPosition();
    var size = this.getMap().getSize();
    var x, y;
    if (!isNil(position['left'])) {
      x = parseInt(position['left'] + '');
    } else if (!isNil(position['right'])) {
      x = size['width'] - parseInt(position['right'] + '');
    }
    if (!isNil(position['top'])) {
      y = parseInt(position['top'] + '');
    } else if (!isNil(position['bottom'])) {
      y = size['height'] - parseInt(position['bottom'] + '');
    }
    return new Point(x, y);
  };
  _proto.getContainer = function getContainer() {
    return this.__ctrlContainer;
  };
  _proto.getDOM = function getDOM() {
    return this._controlDom;
  };
  _proto.show = function show() {
    this.__ctrlContainer.style.display = '';
    return this;
  };
  _proto.hide = function hide() {
    this.__ctrlContainer.style.display = 'none';
    return this;
  };
  _proto.isVisible = function isVisible() {
    return this.__ctrlContainer && this.__ctrlContainer.style.display === '';
  };
  _proto.remove = function remove() {
    if (!this._map) {
      return this;
    }
    removeDomNode(this.__ctrlContainer);
    if (this.onRemove) {
      this.onRemove();
    }
    delete this._map;
    delete this.__ctrlContainer;
    delete this._controlDom;
    this.fire('remove');
    return this;
  };
  _proto._parse = function _parse(position) {
    var p = position;
    if (isString(position)) {
      p = Control['positions'][p];
    }
    return p;
  };
  _proto._updatePosition = function _updatePosition() {
    var position = this.getPosition();
    if (!position) {
      position = {
        'top': 20,
        'left': 20
      };
    }
    if (this.__ctrlContainer) {
      Object.assign(this.__ctrlContainer.style, {
        top: null,
        bottom: null,
        right: null,
        left: null
      });
    }
    for (var p in position) {
      if (position.hasOwnProperty(p)) {
        var v = position[p] || 0;
        if (isNumber(v)) {
          v += 'px';
        }
        this.__ctrlContainer.style[p] = v;
      }
    }
    this.fire('positionchange', {
      'position': extend$2({}, position)
    });
  };
  _proto.onConfig = function onConfig(conf) {
    if (conf && 'position' in conf) {
      this._updatePosition();
    }
  };
  return Control;
}(Eventable(Class));
Control.positions = {
  'top-left': {
    'top': 20,
    'left': 20
  },
  'top-right': {
    'top': 20,
    'right': 20
  },
  'bottom-left': {
    'bottom': 20,
    'left': 20
  },
  'bottom-right': {
    'bottom': 20,
    'right': 20
  }
};
Map$1.mergeOptions({
  'control': true
});
Map$1.include({
  addControl: function addControl(control) {
    if (this._containerDOM.getContext) {
      return this;
    }
    control.addTo(this);
    return this;
  },
  removeControl: function removeControl(control) {
    if (!control || control.getMap() !== this) {
      return this;
    }
    control.remove();
    return this;
  }
});

var options$g = {
  'position': {
    'bottom': 0,
    'left': 0
  },
  'content': '<a href="http://maptalks.org" target="_blank">maptalks</a>',
  'custom': false
};
var layerEvents = 'addlayer removelayer setbaselayer baselayerremove';
var Attribution = function (_Control) {
  function Attribution() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Attribution, _Control);
  var _proto = Attribution.prototype;
  _proto.buildOn = function buildOn() {
    this._attributionContainer = createEl('div');
    this._attributionContainer.className = 'maptalks-attribution';
    this._appendCustomClass(this._attributionContainer);
    this._update();
    return this._attributionContainer;
  };
  _proto.getContent = function getContent() {
    return this.options.content;
  };
  _proto.setContent = function setContent(content) {
    this.options.content = content;
    this._update();
    return this;
  };
  _proto.onAdd = function onAdd() {
    this.getMap().on(layerEvents, this._update, this);
  };
  _proto.onRemove = function onRemove() {
    this.getMap().off(layerEvents, this._update, this);
  };
  _proto._updateContent = function _updateContent() {
    var container = this._attributionContainer;
    var content = this.options.content || '';
    if (container) {
      container.innerHTML = '';
      if (isString(content)) {
        container.innerHTML = content;
      } else if (content instanceof HTMLElement) {
        container.appendChild(container);
      }
    }
    return this;
  };
  _proto._update = function _update() {
    if (this.options.custom) {
      this._updateContent();
      return;
    }
    var map = this.getMap();
    if (!map) {
      return;
    }
    var attributions = map._getLayers(function (layer) {
      return !!layer.options['attribution'];
    }).reverse().map(function (layer) {
      return layer.options['attribution'];
    });
    var content = this.options['content'] + (attributions.length > 0 ? ' - ' + attributions.join(', ') : '');
    this._attributionContainer.innerHTML = '<span style="padding:0px 4px">' + content + '</span>';
  };
  return Attribution;
}(Control);
Attribution.mergeOptions(options$g);
Map$1.mergeOptions({
  'attribution': true
});
Map$1.addOnLoadHook(function () {
  var a = this.options['attribution'] || this.options['attributionControl'];
  if (a) {
    this.attributionControl = new Attribution(a);
    this.addControl(this.attributionControl);
  }
});

var options$f = {
  position: {
    'top': 120,
    'left': 20
  }
};
var Compass = function (_Control) {
  function Compass() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Compass, _Control);
  var _proto = Compass.prototype;
  _proto.buildOn = function buildOn(map) {
    var compass = this._getCompass();
    this._appendCustomClass(compass);
    this._compass = compass;
    this._registerDomEvents();
    map.on('resize moving moveend zooming zoomend rotate rotateend dragrotating dragrotateend viewchange', this._rotateCompass, this);
    return compass;
  };
  _proto.onAdd = function onAdd() {
    this._rotateCompass();
  };
  _proto._getCompass = function _getCompass() {
    var compass = createEl('div', 'maptalks-compass');
    return compass;
  };
  _proto._registerDomEvents = function _registerDomEvents() {
    on(this._compass, 'click', this._resetView, this);
  };
  _proto._rotateCompass = function _rotateCompass() {
    var b = this.getMap().getBearing().toFixed(1);
    var bearing = parseFloat(b);
    if (bearing <= 180) bearing *= -1;
    if (bearing !== this._bearing) {
      this._bearing = bearing;
      setStyle(this._compass, "transform: rotate(" + this._bearing + "deg);");
    }
  };
  _proto.onRemove = function onRemove() {
    this.getMap().off('resize moving moveend zooming zoomend rotate rotateend dragrotating dragrotateend viewchange', this._rotateCompass, this);
    delete this._compass;
    delete this._bearing;
  };
  _proto._resetView = function _resetView() {
    var view = {
      bearing: 0
    };
    this.getMap().animateTo(view);
  };
  return Compass;
}(Control);
Compass.mergeOptions(options$f);
Map$1.mergeOptions({
  'compassControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['compassControl']) {
    this.compassControl = new Compass(this.options['compassControl']);
    this.addControl(this.compassControl);
  }
});

var options$e = {
  'position': 'top-right',
  'baseTitle': 'Base Layers',
  'overlayTitle': 'Layers',
  'excludeLayers': [],
  'containerClass': 'maptalks-layer-switcher'
};
var LayerSwitcher = function (_Control) {
  function LayerSwitcher() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(LayerSwitcher, _Control);
  var _proto = LayerSwitcher.prototype;
  _proto.buildOn = function buildOn() {
    var container = this.container = createEl('div', this.options['containerClass']),
      panel = this.panel = createEl('div', 'panel'),
      button = this.button = createEl('button');
    container.appendChild(button);
    container.appendChild(panel);
    this._appendCustomClass(container);
    return container;
  };
  _proto.onAdd = function onAdd() {
    on(this.button, 'mouseover', this._show, this);
    on(this.panel, 'mouseleave', this._hide, this);
  };
  _proto.onRemove = function onRemove() {
    if (this.panel) {
      off(this.button, 'mouseover', this._show);
      off(this.panel, 'mouseleave', this._hide);
      removeDomNode(this.panel);
      removeDomNode(this.button);
      delete this.panel;
      delete this.button;
      delete this.container;
    }
  };
  _proto._show = function _show() {
    if (!hasClass(this.container, 'shown')) {
      addClass(this.container, 'shown');
      this._createPanel();
    }
  };
  _proto._hide = function _hide(e) {
    if (!this.panel.contains(e.toElement || e.relatedTarget)) {
      setClass(this.container, this.options['containerClass']);
    }
  };
  _proto._createPanel = function _createPanel() {
    this.panel.innerHTML = '';
    var ul = createEl('ul');
    this.panel.appendChild(ul);
    this._renderLayers(this.getMap(), ul);
  };
  _proto._renderLayers = function _renderLayers(map, elm) {
    var _this = this;
    var base = map.getBaseLayer(),
      layers = map.getLayers(),
      len = layers.length;
    if (base) {
      var baseLayers = base.layers || [base],
        li = createEl('li', 'group'),
        ul = createEl('ul'),
        label = createEl('label');
      label.innerHTML = this.options['baseTitle'];
      li.appendChild(label);
      for (var i = 0, _len = baseLayers.length; i < _len; i++) {
        var layer = baseLayers[i];
        if (this._isExcluded(layer)) {
          ul.appendChild(this._renderLayer(baseLayers[i], true));
          li.appendChild(ul);
          elm.appendChild(li);
        }
      }
    }
    if (len) {
      var _li = createEl('li', 'group'),
        _ul = createEl('ul'),
        _label = createEl('label'),
        input = createEl('input');
      input.type = 'checkbox';
      input.checked = true;
      _label.innerHTML = this.options['overlayTitle'];
      _li.appendChild(input);
      _li.appendChild(_label);
      var groupInputOnChange = function groupInputOnChange(e) {
        var checked = e.target.checked;
        var parentNode = e.target.parentNode;
        if (!parentNode) {
          return;
        }
        var ul = parentNode.getElementsByTagName('ul')[0];
        if (!ul) {
          return;
        }
        var parentLayerShow = function parentLayerShow(node) {
          var layer = node._layer;
          if (layer) {
            layer[checked ? 'show' : 'hide']();
          }
        };
        var layerShow = function layerShow(li) {
          var layer = li._layer,
            checkbox = li.childNodes[0];
          if (checkbox) {
            checkbox.checked = checked;
          }
          if (layer) {
            layer[checked ? 'show' : 'hide']();
          }
        };
        parentLayerShow(parentNode);
        ul.childNodes.forEach(function (li) {
          layerShow(li);
          var childUl = li.getElementsByTagName('ul')[0];
          if (!childUl) {
            return;
          }
          parentLayerShow(li);
          childUl.childNodes.forEach(function (li) {
            layerShow(li);
          });
        });
      };
      var _loop = function _loop() {
        var layer = layers[_i];
        if (_this._isExcluded(layer)) {
          if (layer.getLayers) {
            var groupLi = createEl('li', 'group'),
              groupUl = createEl('ul'),
              groupLabel = createEl('label'),
              groupInput = createEl('input');
            groupLabel.innerHTML = layer.getId();
            groupInput.type = 'checkbox';
            groupInput.checked = layer.isVisible();
            groupInput.onchange = groupInputOnChange;
            groupLi.appendChild(groupInput);
            groupLi.appendChild(groupLabel);
            groupLi.appendChild(groupUl);
            groupLi._layer = layer;
            _ul.appendChild(groupLi);
            var groupLayers = layer.getLayers() || [];
            groupLayers.forEach(function (layer) {
              groupUl.appendChild(_this._renderLayer(layer, false, groupInput.checked));
            });
          } else {
            _ul.appendChild(_this._renderLayer(layer));
          }
          if (layer && !layer.isVisible()) {
            input.checked = false;
          }
        }
      };
      for (var _i = 0; _i < len; _i++) {
        _loop();
      }
      _li.appendChild(_ul);
      elm.appendChild(_li);
      input.onchange = groupInputOnChange;
    }
  };
  _proto._isExcluded = function _isExcluded(layer) {
    var id = layer.getId(),
      excludeLayers = this.options['excludeLayers'];
    return !(excludeLayers.length && excludeLayers.indexOf(id) >= 0);
  };
  _proto._renderLayer = function _renderLayer(layer, isBase, parentChecked = true) {
    var _this2 = this;
    var li = createEl('li', 'layer'),
      label = createEl('label'),
      input = createEl('input'),
      map = this.getMap();
    var visible = layer.options['visible'];
    layer.options['visible'] = true;
    var enabled = layer.isVisible();
    layer.options['visible'] = visible;
    li.className = 'layer';
    var radioInput = input;
    if (isBase) {
      radioInput.type = 'radio';
      radioInput.name = 'base';
    } else {
      radioInput.type = 'checkbox';
    }
    radioInput.checked = visible && enabled;
    if (!parentChecked) {
      radioInput.checked = false;
    }
    if (!enabled) {
      radioInput.setAttribute('disabled', 'disabled');
    }
    radioInput.onchange = function (e) {
      if (e.target.type === 'radio') {
        var baseLayer = map.getBaseLayer(),
          baseLayers = baseLayer.layers;
        if (baseLayers) {
          for (var i = 0, len = baseLayers.length; i < len; i++) {
            var childLayer = baseLayers[i];
            childLayer[childLayer === layer ? 'show' : 'hide']();
          }
        } else if (!baseLayer.isVisible()) {
          baseLayer.show();
        }
        map._fireEvent('setbaselayer');
      } else {
        layer[e.target.checked ? 'show' : 'hide']();
      }
      _this2.fire('layerchange', {
        target: layer
      });
    };
    li.appendChild(input);
    label.innerHTML = layer.getId();
    li.appendChild(label);
    li._layer = layer;
    return li;
  };
  return LayerSwitcher;
}(Control);
LayerSwitcher.mergeOptions(options$e);
Map$1.mergeOptions({
  'layerSwitcherControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['layerSwitcherControl']) {
    this.layerSwitcherControl = new LayerSwitcher(this.options['layerSwitcherControl']);
    this.addControl(this.layerSwitcherControl);
  }
});

var options$d = {
  'level': 4,
  'position': {
    'right': 1,
    'bottom': 1
  },
  'size': [300, 200],
  'maximize': true,
  'symbol': {
    'lineWidth': 3,
    'lineColor': '#1bbc9b',
    'polygonFill': '#1bbc9b',
    'polygonOpacity': 0.4
  },
  'containerClass': 'maptalks-overview',
  'buttonClass': 'maptalks-overview-button'
};
var Overview = function (_Control) {
  function Overview() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Overview, _Control);
  var _proto = Overview.prototype;
  _proto.buildOn = function buildOn() {
    var size = this.options['size'];
    if (!this.options['maximize']) {
      size = [0, 0];
    }
    var container = createEl('div');
    this._appendCustomClass(container);
    var mapContainer = this.mapContainer = createEl('div');
    mapContainer.style.width = size[0] + 'px';
    mapContainer.style.height = size[1] + 'px';
    mapContainer.className = this.options['containerClass'];
    var button = this.button = createEl('div');
    button.className = this.options['buttonClass'];
    container.appendChild(mapContainer);
    container.appendChild(button);
    return container;
  };
  _proto.onAdd = function onAdd() {
    if (this.options['maximize']) {
      this._createOverview();
    }
    this.getMap().on('resize moving zooming rotate dragrotating viewchange', this._update, this).on('setbaselayer', this._updateBaseLayer, this).on('spatialreferencechange', this._updateSpatialReference, this);
    on(this.button, 'click', this._onButtonClick, this);
    this._updateButtonText();
  };
  _proto.onRemove = function onRemove() {
    this.getMap().off('resize moving zooming rotate dragrotating viewchange', this._update, this).off('setbaselayer', this._updateBaseLayer, this).off('spatialreferencechange', this._updateSpatialReference, this);
    if (this._overview) {
      this._overview.remove();
      delete this._overview;
      delete this._perspective;
    }
    off(this.button, 'click', this._onButtonClick);
  };
  _proto.maxmize = function maxmize() {
    var size = this.options['size'];
    var dom = this.mapContainer;
    dom.style.width = size[0] + 'px';
    dom.style.height = size[1] + 'px';
    this._createOverview();
    return this;
  };
  _proto.minimize = function minimize() {
    if (this._overview) {
      this._overview.remove();
    }
    delete this._overview;
    delete this._perspective;
    var dom = this.mapContainer;
    dom.style.width = 0 + 'px';
    dom.style.height = 0 + 'px';
    return this;
  };
  _proto.getOverviewMap = function getOverviewMap() {
    return this._overview;
  };
  _proto._onButtonClick = function _onButtonClick() {
    if (!this._overview) {
      this.maxmize();
    } else {
      this.minimize();
    }
    this._updateButtonText();
  };
  _proto._updateButtonText = function _updateButtonText() {
    if (this._overview) {
      this.button.innerHTML = '-';
    } else {
      this.button.innerHTML = '+';
    }
  };
  _proto._createOverview = function _createOverview() {
    var map = this.getMap(),
      dom = this.mapContainer;
    var options = map.config();
    extend$2(options, {
      'center': map.getCenter(),
      'zoom': this._getOverviewZoom(),
      'zoomAnimationDuration': 150,
      'pitch': 0,
      'bearing': 0,
      'scrollWheelZoom': false,
      'checkSize': false,
      'doubleClickZoom': false,
      'touchZoom': false,
      'control': false,
      'draggable': false,
      'maxExtent': null
    });
    this._overview = new Map$1(dom, options);
    this._updateBaseLayer();
    this._perspective = new Polygon(this._getPerspectiveCoords(), {
      'draggable': true,
      'cursor': 'move',
      'symbol': this.options['symbol']
    }).on('dragend', this._onDragEnd, this);
    new DrawToolLayer('perspective_layer', this._perspective).addTo(this._overview);
    this.fire('load');
  };
  _proto._getOverviewZoom = function _getOverviewZoom() {
    var map = this.getMap(),
      zoom = map.getZoom(),
      minZoom = map.getMinZoom(),
      level = this.options['level'];
    if (level > 0) {
      for (var i = level; i > 0; i--) {
        if (zoom - i >= minZoom) {
          return zoom - i;
        }
      }
    } else {
      for (var _i = level; _i < 0; _i++) {
        if (zoom - _i >= minZoom) {
          return zoom - _i;
        }
      }
    }
    return zoom;
  };
  _proto._onDragEnd = function _onDragEnd() {
    var center = this._perspective.getCenter();
    this._overview.setCenter(center);
    this.getMap().panTo(center);
  };
  _proto._getPerspectiveCoords = function _getPerspectiveCoords() {
    var map = this.getMap();
    var projection = map.getProjection();
    return map.getContainerExtent().toArray().map(function (c) {
      if (projection) {
        var prjCoord = map._containerPointToPrj(c);
        map._fixPrjOnWorldWide(prjCoord);
        return projection.unproject(prjCoord);
      }
      return map.containerPointToCoordinate(c);
    });
  };
  _proto._update = function _update() {
    if (!this._overview) {
      return;
    }
    computeDomPosition(this._overview.getContainer());
    var coords = this._getPerspectiveCoords();
    this._perspective.setCoordinates(coords);
    this._overview.setCenterAndZoom(this.getMap().getCenter(), this._getOverviewZoom());
  };
  _proto._updateSpatialReference = function _updateSpatialReference() {
    if (!this._overview) {
      return;
    }
    var map = this.getMap();
    var spatialRef = map.options['spatialReference'];
    this._overview.setSpatialReference(spatialRef);
  };
  _proto._updateBaseLayer = function _updateBaseLayer() {
    if (!this._overview) {
      return;
    }
    var map = this.getMap(),
      baseLayer = map.getBaseLayer();
    if (!baseLayer) {
      this._overview.setBaseLayer(null);
      return;
    }
    var layers = baseLayer.layers;
    var showIndex = 0;
    if (layers) {
      for (var i = 0, l = layers.length; i < l; i++) {
        var _layer = layers[i];
        if (_layer.isVisible()) {
          showIndex = i;
          break;
        }
      }
    }
    var json = baseLayer.toJSON();
    var options = null;
    if (layers) {
      options = json.layers[showIndex].options;
      options.visible = true;
    } else {
      options = json.options;
    }
    this._overview.setMinZoom(options.minZoom || null).setMaxZoom(options.maxZoom || null);
    delete options.minZoom;
    delete options.maxZoom;
    delete json.options.canvas;
    json.options.visible = true;
    json.options.renderer = 'canvas';
    var layer = Layer.fromJSON(json);
    for (var p in baseLayer) {
      if (isFunction(baseLayer[p]) && baseLayer.hasOwnProperty(p) && baseLayer[p] !== baseLayer.constructor.prototype[p]) {
        layer[p] = baseLayer[p];
      }
    }
    this._overview.setBaseLayer(layer);
  };
  return Overview;
}(Control);
Overview.mergeOptions(options$d);
Map$1.mergeOptions({
  'overviewControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['overviewControl']) {
    this.overviewControl = new Overview(this.options['overviewControl']);
    this.addControl(this.overviewControl);
  }
});

var options$c = {
  position: "top-right",
  draggable: true,
  custom: false,
  content: "",
  closeButton: true
};
var Panel = function (_Control) {
  function Panel() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Panel, _Control);
  var _proto = Panel.prototype;
  _proto.buildOn = function buildOn() {
    var _this = this;
    var dom;
    if (this.options["custom"]) {
      if (isString(this.options["content"])) {
        dom = createEl("div");
        dom.innerHTML = this.options["content"];
        this._appendCustomClass(dom);
      } else {
        dom = this.options["content"];
      }
    } else {
      dom = createEl("div", "maptalks-panel");
      this._appendCustomClass(dom);
      if (this.options["closeButton"]) {
        var closeButton = createEl("a", "maptalks-close");
        closeButton.innerText = "×";
        closeButton.href = "javascript:;";
        closeButton.onclick = function () {
          dom.style.display = "none";
          _this.fire("close");
        };
        dom.appendChild(closeButton);
      }
      var panelContent = createEl("div", "maptalks-panel-content");
      if (isString(this.options["content"])) {
        panelContent.innerHTML = this.options["content"];
      } else {
        panelContent.appendChild(this.options.content);
      }
      dom.appendChild(panelContent);
    }
    this.draggable = new DragHandler(dom, {
      cancelOn: this._cancelOn.bind(this),
      ignoreMouseleave: true
    });
    this.draggable.on("dragstart", this._onDragStart, this).on("dragging", this._onDragging, this).on("dragend", this._onDragEnd, this);
    if (this.options["draggable"]) {
      this.draggable.enable();
    }
    return dom;
  };
  _proto.update = function update() {
    if (this.draggable) {
      this.draggable.disable();
      delete this.draggable;
    }
    return Control.prototype.update.call(this);
  };
  _proto.setContent = function setContent(content) {
    var old = this.options["content"];
    this.options["content"] = content;
    this.fire("contentchange", {
      old: old,
      "new": content
    });
    if (this.isVisible()) {
      this.update();
    }
    return this;
  };
  _proto.getContent = function getContent() {
    return this.options["content"];
  };
  _proto._cancelOn = function _cancelOn(domEvent) {
    var target = domEvent.srcElement || domEvent.target,
      tagName = target.tagName.toLowerCase();
    if (tagName === "button" || tagName === "input" || tagName === "select" || tagName === "option" || tagName === "textarea") {
      return true;
    }
    return false;
  };
  _proto._onDragStart = function _onDragStart(param) {
    this._startPos = param["mousePos"];
    this._startPosition = extend$2({}, this.getPosition());
    this.fire("dragstart", param);
  };
  _proto._onDragging = function _onDragging(param) {
    var pos = param["mousePos"];
    var offset = pos.sub(this._startPos);
    var startPosition = this._startPosition;
    var position = this.getPosition();
    if (!isNil(position["top"])) {
      position["top"] = parseInt(startPosition["top"]) + offset.y;
    }
    if (!isNil(position["bottom"])) {
      position["bottom"] = parseInt(startPosition["bottom"]) - offset.y;
    }
    if (!isNil(position["left"])) {
      position["left"] = parseInt(startPosition["left"]) + offset.x;
    }
    if (!isNil(position["right"])) {
      position["right"] = parseInt(startPosition["right"]) - offset.x;
    }
    this.setPosition(position);
    this.fire("dragging", param);
  };
  _proto._onDragEnd = function _onDragEnd(param) {
    delete this._startPos;
    delete this._startPosition;
    this.fire("dragend", param);
  };
  _proto._getConnectPoints = function _getConnectPoints() {
    var map = this.getMap();
    var containerPoint = this.getContainerPoint();
    var dom = this.getDOM(),
      width = parseInt(dom.clientWidth + ""),
      height = parseInt(dom.clientHeight + "");
    var anchors = [map.containerPointToCoordinate(containerPoint.add(width / 2, 0)), map.containerPointToCoordinate(containerPoint.add(width, height / 2)), map.containerPointToCoordinate(containerPoint.add(width / 2, height)), map.containerPointToCoordinate(containerPoint.add(0, height / 2))];
    return anchors;
  };
  return Panel;
}(Control);
Panel.mergeOptions(options$c);

var options$b = {
  position: {
    'top': 156,
    'left': 20
  },
  view: null
};
var Reset = function (_Control) {
  function Reset() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Reset, _Control);
  var _proto = Reset.prototype;
  _proto.buildOn = function buildOn() {
    var reset = this._getReset();
    this._appendCustomClass(reset);
    this._reset = reset;
    this._registerDomEvents();
    return reset;
  };
  _proto.onAdd = function onAdd() {
    this._view = !this.options.view ? this.getMap().getView() : this.options.view;
  };
  _proto.setView = function setView(view) {
    this._view = view;
  };
  _proto._getReset = function _getReset() {
    var reset = createEl('div', 'maptalks-reset');
    return reset;
  };
  _proto._registerDomEvents = function _registerDomEvents() {
    on(this._reset, 'click', this._resetView, this);
  };
  _proto.onRemove = function onRemove() {
    delete this._reset;
    delete this._view;
  };
  _proto._resetView = function _resetView() {
    this.getMap().setView(this._view);
  };
  return Reset;
}(Control);
Reset.mergeOptions(options$b);
Map$1.mergeOptions({
  'resetControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['resetControl']) {
    this.resetControl = new Reset(this.options['resetControl']);
    this.addControl(this.resetControl);
  }
});

var options$a = {
  'position': 'bottom-left',
  'maxWidth': 100,
  'metric': true,
  'imperial': false,
  'containerClass': null
};
var EVENTS_TO_LISTEN = 'zoomend moving moveend';
var Scale = function (_Control) {
  function Scale() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Scale, _Control);
  var _proto = Scale.prototype;
  _proto.buildOn = function buildOn(map) {
    this._map = map;
    this._scaleContainer = createEl('div', this.options['containerClass']);
    this._addScales();
    map.on(EVENTS_TO_LISTEN, this._update, this);
    if (this._map.isLoaded()) {
      this._update();
    }
    this._appendCustomClass(this._scaleContainer);
    return this._scaleContainer;
  };
  _proto.onRemove = function onRemove() {
    this.getMap().off(EVENTS_TO_LISTEN, this._update, this);
  };
  _proto._addScales = function _addScales() {
    var css = 'border: 2px solid #000000;border-top: none;line-height: 1.1;padding: 0px;' + 'color: #000000;font-size: 11px;text-align:center;white-space: nowrap;overflow: hidden' + ';-moz-box-sizing: content-box;box-sizing: content-box;background: #fff; background: rgba(255, 255, 255, 0);';
    if (this.options['metric']) {
      this._mScale = createElOn('div', this.options['containerClass'] ? null : css, this._scaleContainer);
    }
    if (this.options['imperial']) {
      this._iScale = createElOn('div', this.options['containerClass'] ? null : css, this._scaleContainer);
    }
  };
  _proto._update = function _update() {
    var map = this._map;
    var maxMeters = map.pixelToDistance(this.options['maxWidth'], 0);
    this._updateScales(maxMeters);
  };
  _proto._updateScales = function _updateScales(maxMeters) {
    if (this.options['metric'] && maxMeters) {
      this._updateMetric(maxMeters);
    }
    if (this.options['imperial'] && maxMeters) {
      this._updateImperial(maxMeters);
    }
  };
  _proto._updateMetric = function _updateMetric(maxMeters) {
    var meters = this._getRoundNum(maxMeters),
      label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
    this._updateScale(this._mScale, label, meters / maxMeters);
  };
  _proto._updateImperial = function _updateImperial(maxMeters) {
    var maxFeet = maxMeters * 3.2808399;
    var maxMiles, miles, feet;
    if (maxFeet > 5280) {
      maxMiles = maxFeet / 5280;
      miles = this._getRoundNum(maxMiles);
      this._updateScale(this._iScale, miles + ' mile', miles / maxMiles);
    } else {
      feet = this._getRoundNum(maxFeet);
      this._updateScale(this._iScale, feet + ' feet', feet / maxFeet);
    }
  };
  _proto._updateScale = function _updateScale(scale, text, ratio) {
    scale['style']['width'] = Math.round(this.options['maxWidth'] * ratio) + 'px';
    scale['innerHTML'] = text;
  };
  _proto._getRoundNum = function _getRoundNum(num) {
    var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1);
    var d = num / pow10;
    d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
    return pow10 * d;
  };
  return Scale;
}(Control);
Scale.mergeOptions(options$a);
Map$1.mergeOptions({
  'scaleControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['scaleControl']) {
    this.scaleControl = new Scale(this.options['scaleControl']);
    this.addControl(this.scaleControl);
  }
});

var options$9 = {
  'height': 28,
  'vertical': false,
  'position': 'top-right',
  'reverseMenu': false,
  'items': []
};
var Toolbar = function (_Control) {
  function Toolbar() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Toolbar, _Control);
  var _proto = Toolbar.prototype;
  _proto.buildOn = function buildOn(map) {
    this._map = map;
    var dom = createEl('div');
    var ul = createEl('ul', 'maptalks-toolbar-hx');
    dom.appendChild(ul);
    if (this.options['vertical']) {
      addClass(dom, 'maptalks-toolbar-vertical');
    } else {
      addClass(dom, 'maptalks-toolbar-horizonal');
    }
    var me = this;
    function onButtonClick(fn, index, childIndex, targetDom) {
      var item = me._getItems()[index];
      return function (e) {
        stopPropagation(e);
        return fn({
          'target': item,
          'index': index,
          'childIndex': childIndex,
          'dom': targetDom
        });
      };
    }
    var items = this.options['items'];
    if (isArrayHasData(items)) {
      for (var i = 0, len = items.length; i < len; i++) {
        var item = items[i];
        var li = createEl('li');
        if (this.options['height'] !== 28) {
          li.style.lineHeight = this.options['height'] + 'px';
        }
        li.style.height = this.options['height'] + 'px';
        li.style.cursor = 'pointer';
        if (isHTML(item['item'])) {
          li.style.textAlign = 'center';
          var itemSize = measureDom('div', item['item']);
          li.innerHTML = '<div style="margin-top:' + (this.options['height'] - itemSize['height']) / 2 + 'px;">' + item['item'] + '</div>';
        } else {
          li.innerHTML = item['item'];
        }
        if (item['click']) {
          on(li, 'click', onButtonClick(item['click'], i, null, li));
        }
        if (isArrayHasData(item['children'])) {
          var dropMenu = this._createDropMenu(i);
          li.appendChild(dropMenu);
          li._menu = dropMenu;
          on(li, 'mouseover', function () {
            this._menu.style.display = '';
          });
          on(li, 'mouseout', function () {
            this._menu.style.display = 'none';
          });
        }
        ul.appendChild(li);
      }
    }
    this._appendCustomClass(dom);
    return dom;
  };
  _proto._createDropMenu = function _createDropMenu(index) {
    var me = this;
    function onButtonClick(fn, index, childIndex) {
      var item = me._getItems()[index]['children'][childIndex];
      return function (e) {
        stopPropagation(e);
        return fn({
          'target': item,
          'index': index,
          'childIndex': childIndex
        });
      };
    }
    var menuDom = createEl('div', 'maptalks-dropMenu'),
      items = this._getItems(),
      len = items.length,
      menuUL = createEl('ul'),
      children = items[index]['children'];
    if (index === len - 1 && children) {
      menuDom.style.cssText = 'right: 0px;';
      menuUL.style.cssText = 'right: 0px;position: absolute;';
      if (this.options['reverseMenu']) {
        menuUL.style.bottom = 0 + '';
      }
    }
    menuDom.appendChild(createEl('em', 'maptalks-ico'));
    var liWidth = 0;
    for (var i = 0, l = children.length; i < l; i++) {
      var size = stringLength(children[i]['item'], '12px');
      if (size.width > liWidth) {
        liWidth = size.width;
      }
    }
    for (var _i = 0, _l = children.length; _i < _l; _i++) {
      var child = children[_i];
      var li = createEl('li');
      li.innerHTML = '<a href="javascript:;">' + child['item'] + '</a>';
      li.style.cursor = 'pointer';
      li.style.width = liWidth + 24 + 'px';
      on(li.childNodes[0], 'click', onButtonClick(child['click'], index, _i));
      menuUL.appendChild(li);
    }
    if (this.options['vertical']) {
      var width = liWidth < 95 ? 95 : liWidth;
      if (this.options['reverseMenu']) {
        menuDom.style.right = -(width + 10 * 2 + 2) + 'px';
      } else {
        menuDom.style.left = -(width + 10 * 2 + 2) + 'px';
      }
    } else if (this.options['reverseMenu']) {
      menuDom.style.bottom = '28px';
    } else {
      menuDom.style.top = '29px';
    }
    menuDom.appendChild(menuUL);
    menuDom.style.display = 'none';
    return menuDom;
  };
  _proto._getItems = function _getItems() {
    return this.options['items'] || [];
  };
  return Toolbar;
}(Control);
Toolbar.mergeOptions(options$9);

var options$8 = {
  'position': 'top-left',
  'zoomLevel': true,
  'seamless': false
};
var Zoom = function (_Control) {
  function Zoom() {
    return _Control.apply(this, arguments) || this;
  }
  _inheritsLoose(Zoom, _Control);
  var _proto = Zoom.prototype;
  _proto.buildOn = function buildOn(map) {
    var options = this.options;
    var dom = createEl('div', 'maptalks-zoom');
    this._appendCustomClass(dom);
    if (options['zoomLevel']) {
      var levelWrapper = createEl('span', 'maptalks-zoom-zoomlevel');
      var levelDOM = createEl('span', 'maptalks-zoom-zoomlevel-text');
      levelWrapper.appendChild(levelDOM);
      dom.appendChild(levelWrapper);
      this._levelDOM = levelDOM;
    }
    var zoomDOM = createEl('div', 'maptalks-zoom-slider');
    var zoomInButton = createEl('a', 'maptalks-zoom-zoomin');
    zoomInButton.href = 'javascript:;';
    zoomDOM.appendChild(zoomInButton);
    this._zoomInButton = zoomInButton;
    var zoomOutButton = createEl('a', 'maptalks-zoom-zoomout');
    zoomOutButton.href = 'javascript:;';
    zoomDOM.appendChild(zoomOutButton);
    this._zoomOutButton = zoomOutButton;
    dom.appendChild(zoomDOM);
    map.on('_zoomend _zooming _zoomstart _spatialreferencechange', this._update, this);
    this._update();
    this._registerDomEvents();
    return dom;
  };
  _proto.onRemove = function onRemove() {
    this.getMap().off('_zoomend _zooming _zoomstart _spatialreferencechange', this._update, this);
  };
  _proto._update = function _update() {
    this._updateText();
  };
  _proto._updateText = function _updateText() {
    if (this._levelDOM) {
      var map = this.getMap();
      var zoom = map.getZoom();
      if (!isInteger(zoom)) {
        zoom = Math.floor(zoom * 10) / 10;
      }
      this._levelDOM.innerHTML = zoom + '';
    }
  };
  _proto._registerDomEvents = function _registerDomEvents() {
    if (this._zoomInButton) {
      on(this._zoomInButton, 'click', this._onZoomInClick, this);
    }
    if (this._zoomOutButton) {
      on(this._zoomOutButton, 'click', this._onZoomOutClick, this);
    }
  };
  _proto._onZoomInClick = function _onZoomInClick(e) {
    preventDefault(e);
    this.getMap().zoomIn();
  };
  _proto._onZoomOutClick = function _onZoomOutClick(e) {
    preventDefault(e);
    this.getMap().zoomOut();
  };
  return Zoom;
}(Control);
Zoom.mergeOptions(options$8);
Map$1.mergeOptions({
  'zoomControl': false
});
Map$1.addOnLoadHook(function () {
  if (this.options['zoomControl']) {
    this.zoomControl = new Zoom(this.options['zoomControl']);
    this.addControl(this.zoomControl);
  }
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Attribution: Attribution,
  Compass: Compass,
  Control: Control,
  LayerSwitcher: LayerSwitcher,
  Overview: Overview,
  Panel: Panel,
  Reset: Reset,
  Scale: Scale,
  Toolbar: Toolbar,
  Zoom: Zoom
});

var semiCircum = 6378137 * Math.PI;
var TileSystem = function () {
  function TileSystem(sx, sy, ox, oy) {
    if (Array.isArray(sx)) {
      this.scale = {
        x: sx[0],
        y: sx[1]
      };
      this.origin = {
        x: sx[2],
        y: sx[3]
      };
    } else {
      this.scale = {
        x: sx,
        y: sy
      };
      this.origin = {
        x: ox,
        y: oy
      };
    }
  }
  TileSystem.getDefault = function getDefault(projection) {
    var code = projection['code'].toLowerCase();
    if (code === 'baidu') {
      return 'baidu';
    } else if (code === 'EPSG:4326'.toLowerCase() || code === 'EPSG:4490'.toLowerCase()) {
      return 'global-geodetic';
    } else if (code === 'identity') {
      return [1, -1, 0, 0];
    } else {
      return 'web-mercator';
    }
  };
  return TileSystem;
}();
TileSystem['web-mercator'] = new TileSystem([1, -1, -semiCircum, semiCircum]);
TileSystem['tms-global-mercator'] = new TileSystem([1, 1, -semiCircum, -semiCircum]);
TileSystem['global-geodetic'] = new TileSystem([1, -1, -180, 90]);
TileSystem['tms-global-geodetic'] = new TileSystem([1, 1, -180, -90]);
TileSystem['baidu'] = new TileSystem([1, 1, 0, 0]);

var TileConfig = function () {
  function TileConfig(map, tileSystem, fullExtent, tileSize) {
    this.map = map;
    this.tileSize = tileSize;
    this.fullExtent = fullExtent;
    this.prepareTileInfo(tileSystem, fullExtent);
    this._xScale = fullExtent['right'] >= fullExtent['left'] ? 1 : -1;
    this._yScale = fullExtent['top'] >= fullExtent['bottom'] ? 1 : -1;
    var glRes = map.getGLRes();
    this._pointOrigin = map._prjToPointAtRes(new Point(this.tileSystem['origin']), glRes);
    this._glRes = glRes;
  }
  var _proto = TileConfig.prototype;
  _proto.prepareTileInfo = function prepareTileInfo(tileSystem, fullExtent) {
    if (isString(tileSystem)) {
      tileSystem = TileSystem[tileSystem.toLowerCase()];
    } else if (Array.isArray(tileSystem)) {
      tileSystem = new TileSystem(tileSystem);
    }
    if (!tileSystem) {
      throw new Error('Invalid TileSystem');
    }
    this.tileSystem = tileSystem;
    var a = fullExtent['right'] > fullExtent['left'] ? 1 : -1,
      b = fullExtent['top'] > fullExtent['bottom'] ? -1 : 1,
      c = tileSystem['origin']['x'],
      d = tileSystem['origin']['y'];
    this.transformation = new Transformation([a, b, c, d]);
  };
  _proto._getTileNum = function _getTileNum(point, res) {
    var tileSystem = this.tileSystem,
      tileSize = this['tileSize'],
      delta = 1E-7;
    var tileX = Math.floor(delta * tileSystem['scale']['x'] + point.x / (tileSize['width'] * res));
    var tileY = Math.ceil(delta * tileSystem['scale']['y'] + point.y / (tileSize['height'] * res));
    return {
      'x': tileSystem['scale']['x'] * tileX,
      'y': tileSystem['scale']['y'] * tileY
    };
  };
  _proto.getTileIndex = function getTileIndex(pCoord, res, repeatWorld) {
    var tileSystem = this.tileSystem;
    var point = this.transformation.transform(pCoord, 1);
    var tileIndex = this._getTileNum(point, res);
    if (tileSystem['scale']['x'] < 0) {
      tileIndex['x'] -= 1;
    }
    if (tileSystem['scale']['y'] > 0) {
      tileIndex['y'] -= 1;
    }
    return this.getNeighorTileIndex(tileIndex['x'], tileIndex['y'], 0, 0, res, repeatWorld);
  };
  _proto.getNeighorTileIndex = function getNeighorTileIndex(tileX, tileY, offsetX, offsetY, res, repeatWorld) {
    var tileSystem = this.tileSystem;
    var x = tileX + tileSystem['scale']['x'] * offsetX;
    var y = tileY - tileSystem['scale']['y'] * offsetY;
    var out = false;
    var idx = x;
    var idy = y;
    var ext = this._getTileFullIndex(res);
    if (repeatWorld) {
      if (repeatWorld === true || repeatWorld === 'x') {
        if (ext['xmax'] === ext['xmin']) {
          x = ext['xmin'];
        } else if (x < ext['xmin']) {
          x = ext['xmax'] - (ext['xmin'] - x) % (ext['xmax'] - ext['xmin']);
          if (x === ext['xmax']) {
            x = ext['xmin'];
          }
        } else if (x >= ext['xmax']) {
          x = ext['xmin'] + (x - ext['xmin']) % (ext['xmax'] - ext['xmin']);
        }
      }
      if (repeatWorld === true || repeatWorld === 'y') {
        if (ext['ymax'] === ext['ymin']) {
          y = ext['ymin'];
        } else if (y >= ext['ymax']) {
          y = ext['ymin'] + (y - ext['ymin']) % (ext['ymax'] - ext['ymin']);
        } else if (y < ext['ymin']) {
          y = ext['ymax'] - (ext['ymin'] - y) % (ext['ymax'] - ext['ymin']);
          if (y === ext['ymax']) {
            y = ext['ymin'];
          }
        }
      }
    }
    if (x < ext['xmin'] || x > ext['xmax'] || y > ext['ymax'] || y < ext['ymin']) {
      out = true;
    }
    return {
      'x': x,
      'y': y,
      'idx': idx,
      'idy': idy,
      out: out
    };
  };
  _proto._getTileFullIndex = function _getTileFullIndex(res) {
    if (!this._tileFullIndex) {
      this._tileFullIndex = {};
    }
    if (this._tileFullIndex[res]) {
      return this._tileFullIndex[res];
    }
    var ext = this.fullExtent;
    var transformation = this.transformation;
    var nwIndex = this._getTileNum(transformation.transform(new Coordinate(ext['left'], ext['top']), 1), res);
    var seIndex = this._getTileNum(transformation.transform(new Coordinate(ext['right'], ext['bottom']), 1), res);
    var tileSystem = this.tileSystem;
    if (tileSystem['scale']['x'] < 0) {
      nwIndex.x -= 1;
      seIndex.x -= 1;
    }
    if (tileSystem['scale']['y'] > 0) {
      nwIndex.y -= 1;
      seIndex.y -= 1;
    }
    this._tileFullIndex[res] = new Extent(nwIndex, seIndex, null);
    return this._tileFullIndex[res];
  };
  _proto.getTilePrjNW = function getTilePrjNW(tileX, tileY, res, out) {
    var tileSystem = this.tileSystem;
    var tileSize = this['tileSize'];
    var y = tileSystem['origin']['y'] + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 1 : 0)) * res * tileSize['height'];
    var x = tileSystem['origin']['x'] + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 0 : 1)) * res * tileSize['width'];
    if (out) {
      out.set(x, y);
      return out;
    }
    return new Coordinate(x, y);
  };
  _proto.getTilePointNW = function getTilePointNW(tileX, tileY, res, out) {
    var scale = this._glRes / res;
    var tileSystem = this.tileSystem;
    var tileSize = this['tileSize'];
    var y = this._pointOrigin.y * scale + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 1 : 0)) * tileSize['height'];
    var x = this._pointOrigin.x * scale + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 0 : 1)) * tileSize['width'];
    if (out) {
      out.set(x, y);
      return out;
    }
    return new Point(x, y);
  };
  _proto.getTilePrjSE = function getTilePrjSE(tileX, tileY, res, out) {
    var tileSystem = this.tileSystem;
    var tileSize = this['tileSize'];
    var y = tileSystem['origin']['y'] + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 0 : 1)) * res * tileSize['height'];
    var x = tileSystem['origin']['x'] + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 1 : 0)) * res * tileSize['width'];
    if (out) {
      out.set(x, y);
      return out;
    }
    return new Coordinate(x, y);
  };
  _proto.getTilePointSE = function getTilePointSE(tileX, tileY, res, out) {
    var scale = this._glRes / res;
    var tileSystem = this.tileSystem;
    var tileSize = this['tileSize'];
    var y = this._pointOrigin.y * scale + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 0 : 1)) * tileSize['height'];
    var x = this._pointOrigin.x * scale + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 1 : 0)) * tileSize['width'];
    if (out) {
      out.set(x, y);
      return out;
    }
    return new Point(x, y);
  };
  _proto.getTilePrjExtent = function getTilePrjExtent(tileX, tileY, res) {
    var nw = this.getTilePrjNW(tileX, tileY, res),
      se = this.getTilePrjSE(tileX, tileY, res);
    return new Extent(nw, se);
  };
  return TileConfig;
}();

var DEFAULT_MAXERROR = 1;
var TEMP_POINT$3 = new Point(0, 0);
var MAX_ROOT_NODES = 32;
var isSetAvailable = typeof Set !== 'undefined';
var TileHashset = function () {
  function TileHashset() {
    this._table = isSetAvailable ? new Set() : {};
  }
  var _proto = TileHashset.prototype;
  _proto.add = function add(key) {
    if (isSetAvailable) {
      this._table.add(key);
    } else {
      this._table[key] = true;
    }
  };
  _proto.has = function has(key) {
    if (isSetAvailable) {
      return this._table.has(key);
    } else {
      return this._table[key];
    }
  };
  _proto.reset = function reset() {
    if (isSetAvailable) {
      this._table.clear();
    } else {
      this._table = {};
    }
  };
  return TileHashset;
}();
var options$7 = {
  'urlTemplate': null,
  'subdomains': null,
  'errorUrl': null,
  'repeatWorld': true,
  'background': true,
  'loadingLimitOnInteracting': 3,
  'loadingLimit': 0,
  'placeholder': false,
  'crossOrigin': null,
  'tileSize': [256, 256],
  'offset': [0, 0],
  'tileSystem': null,
  'fadeAnimation': !IS_NODE,
  'fadeDuration': 1000 / 60 * 10,
  'debug': false,
  'spatialReference': null,
  'maxCacheSize': 256,
  'renderer': function () {
    return Browser$1.webgl ? 'gl' : 'canvas';
  }(),
  'clipByPitch': true,
  'maxAvailableZoom': null,
  'cascadeTiles': true,
  'zoomOffset': 0,
  'pyramidMode': 1,
  'decodeImageInWorker': false,
  'tileLimitPerFrame': 0,
  'tileStackStartDepth': 7,
  'tileStackDepth': 6,
  'awareOfTerrain': true,
  'bufferPixel': 0.5,
  'mipmapTexture': true,
  'depthMask': true,
  'currentTilesFirst': true,
  'forceRenderOnMoving': true,
  'tileErrorScale': 1
};
var URL_PATTERN = /\{ *([\w_]+) *\}/g;
var TEMP_POINT0 = new Point(0, 0);
var TEMP_POINT1$1 = new Point(0, 0);
var TEMP_POINT2$1 = new Point(0, 0);
var TEMP_POINT3 = new Point(0, 0);
var TEMP_POINT4 = new Point(0, 0);
var TEMP_POINT6 = new Point(0, 0);
var TILE_BOX = [[0, 0, 0], [0, 0, 0]];
var TILE_MIN = [0, 0, 0];
var TILE_MAX = [0, 0, 0];
var ARR3 = [0, 0, 0];
var TileLayer = function (_Layer) {
  function TileLayer(id, options) {
    return _Layer.call(this, id, options) || this;
  }
  _inheritsLoose(TileLayer, _Layer);
  TileLayer.fromJSON = function fromJSON(layerJSON) {
    if (!layerJSON || layerJSON['type'] !== 'TileLayer') {
      return null;
    }
    return new TileLayer(layerJSON['id'], layerJSON['options']);
  };
  var _proto2 = TileLayer.prototype;
  _proto2.onAdd = function onAdd() {
    this._prepareOptions();
  };
  _proto2._prepareOptions = function _prepareOptions() {
    var options = this.options;
    if (!options.tileSystem && options.tms) {
      var sr = this.getSpatialReference();
      var projection = sr.getProjection();
      var is4326 = projection.code === "EPSG:4326" || projection.code === "EPSG:4490";
      var is3857 = projection.code === "EPSG:3857";
      if (is3857) {
        options.tileSystem = TileSystem['tms-global-mercator'];
      } else if (is4326) {
        options.tileSystem = TileSystem['tms-global-geodetic'];
      }
    }
  };
  _proto2.forceReload = function forceReload() {
    this.fire('forcereloadstart');
    this.clear();
    if (this._renderer) {
      this._renderer.setToRedraw();
    }
    this.fire('forcereloadend');
    return this;
  };
  _proto2.getTileSize = function getTileSize(id) {
    if (this._tileSize) {
      return this._tileSize;
    }
    var size = this.options['tileSize'];
    if (isNumber(size)) {
      size = [size, size];
    }
    this._tileSize = new Size(size);
    return this._tileSize;
  };
  _proto2.getTiles = function getTiles(z, parentLayer) {
    var _this = this;
    this._coordCache = {};
    var result;
    if (this._isPyramidMode()) {
      result = this._getPyramidTiles(z, parentLayer);
    } else {
      result = this._getCascadeTiles(z, parentLayer);
    }
    if (!this._maskGeoJSON) {
      return result;
    }
    var tileGrids = result.tileGrids || [];
    var count = 0;
    tileGrids.forEach(function (tileGrid) {
      var tiles = tileGrid.tiles || [];
      tileGrid.tiles = tiles.filter(function (tile) {
        return _this._tileInMask(tile);
      });
      count += tileGrid.tiles.length;
      var parentIds = tileGrid.tiles.map(function (tile) {
        return tile.parent;
      });
      tileGrid.parents = (tileGrid.parents || []).filter(function (parent) {
        return parentIds.indexOf(parent.id) > -1;
      });
    });
    result.count = count;
    return result;
  };
  _proto2._isPyramidMode = function _isPyramidMode() {
    var sr = this._spatialRef || this.getSpatialReference();
    return !this._disablePyramid && !this._hasOwnSR && this.options['pyramidMode'] && sr && sr.isPyramid();
  };
  _proto2._getTileFullExtent = function _getTileFullExtent() {
    if (this._tileFullExtent) {
      return this._tileFullExtent;
    }
    var sr = this.getSpatialReference();
    var fullExtent = sr.getFullExtent();
    var res = sr.getResolution(0);
    var map = this.getMap();
    this._tileFullExtent = fullExtent.convertTo(function (c) {
      return map._prjToPointAtRes(c, res, TEMP_POINT$3);
    });
    return this._tileFullExtent;
  };
  _proto2._getRootNodes = function _getRootNodes(offset0) {
    var map = this.getMap();
    if (this._rootNodes) {
      var {
        tiles: _tiles,
        mapWidth: mapWidth,
        mapHeight: mapHeight
      } = this._rootNodes;
      if (map.width !== mapWidth || map.height !== mapHeight) {
        var _error = this._getRootError();
        for (var i = 0; i < _tiles.length; i++) {
          _tiles[i].error = _error;
        }
        this._rootNodes.mapWidth = map.width;
        this._rootNodes.mapHeight = map.height;
      }
      for (var _i = 0; _i < _tiles.length; _i++) {
        _tiles[_i].offset[0] = offset0[0];
        _tiles[_i].offset[1] = offset0[1];
      }
      return this._rootNodes;
    }
    var sr = this._spatialRef || this.getSpatialReference();
    var res = sr.getResolution(0);
    var tileConfig = this._getTileConfig();
    var fullExtent = sr.getFullExtent();
    var {
      origin: origin,
      scale: scale
    } = tileConfig.tileSystem;
    var extent000 = tileConfig.getTilePrjExtent(0, 0, res);
    var w = extent000.getWidth();
    var h = extent000.getHeight();
    var delta = 1E-5;
    var left = Math.abs((origin.x - fullExtent.left) / w);
    left = Math.ceil(left - delta);
    var right = Math.abs((fullExtent.right - origin.x) / w);
    right = Math.ceil(right - delta);
    var top = Math.ceil(Math.abs(fullExtent.top - origin.y) / h);
    top = Math.ceil(top - delta);
    var bottom = Math.ceil(Math.abs(fullExtent.bottom - origin.y) / h);
    bottom = Math.ceil(bottom - delta);
    if ((right + left) * (bottom + top) > MAX_ROOT_NODES) {
      return {
        status: 0,
        error: 'Too many root nodes'
      };
    }
    var error = this._getRootError();
    var tiles = [];
    var z = 0;
    for (var _i2 = -left; _i2 < right; _i2++) {
      for (var j = -top; j < bottom; j++) {
        var y = scale.y < 0 ? j : -(j + 1);
        tiles.push(this.createTileNode(_i2, y, z, _i2, y, res, error));
      }
    }
    this._rootNodes = {
      status: 1,
      tiles: tiles,
      mapWidth: map.width,
      mapHeight: map.height
    };
    return this._getRootNodes(offset0);
  };
  _proto2.createTileNode = function createTileNode(x, y, z, idx, idy, res, error, parentId, extent2d, tileId) {
    var map = this.map;
    var zoomOffset = this.options['zoomOffset'];
    if (!extent2d) {
      var tileConfig = this._getTileConfig();
      extent2d = tileConfig.getTilePrjExtent(x, y, res).convertTo(function (c) {
        return map._prjToPointAtRes(c, res, TEMP_POINT$3);
      });
    }
    var offset = this._getTileOffset(z);
    var url = this.getTileUrl(x, y, z + zoomOffset);
    return {
      parent: parentId,
      layer: this.getId(),
      x: x,
      y: y,
      z: z,
      idx: idx,
      idy: idy,
      res: res,
      extent2d: extent2d,
      id: tileId || this._getTileId(x, y, z),
      url: formatResourceUrl(url),
      offset: offset,
      error: error,
      children: []
    };
  };
  _proto2._getRootError = function _getRootError() {
    var map = this.getMap();
    var fov = toRadian(map.getFov());
    var aspectRatio = map.width / map.height;
    var cameraZ = map.cameraPosition[2];
    var heightZ = cameraZ * Math.tan(0.5 * fov);
    var widthZ = heightZ * aspectRatio;
    var diagonalZ = Math.sqrt(cameraZ * cameraZ + heightZ * heightZ + widthZ * widthZ);
    var fov0 = map._getFovZ(0);
    var error = fov0 * (diagonalZ / cameraZ);
    var sr = this._spatialRef || this.getSpatialReference();
    var res = sr.getResolution(0);
    return error * res / map.getResolution(0);
  };
  _proto2._getPyramidTiles = function _getPyramidTiles(z, layer) {
    var map = this.map;
    if (isNaN(+z)) {
      z = this._getTileZoom(map.getZoom());
    }
    var sr = this._spatialRef || this.getSpatialReference();
    var maxZoom = Math.min(z, this.getMaxZoom(), this.getMaxAvailableZoom() || Infinity);
    var projectionView = map.projViewMatrix;
    var fullExtent = this._getTileFullExtent();
    var offset0 = this._getTileOffset(0);
    var queue;
    if (this.options['repeatWorld']) {
      var mapContainerExtent = map.getContainerExtent();
      var mapExtent2D = this._convertToExtent2d(mapContainerExtent);
      var scale = sr.getResolution(0) / map.getResolution();
      if (!mapExtent2D.within(fullExtent.copy()._scale(scale))) {
        var pitch = map.getPitch();
        var cascadePitch1 = map.options['cascadePitches'][1];
        var visualHeight1 = Math.floor(map._getVisualHeight(cascadePitch1));
        var visualContainerExtent = pitch <= cascadePitch1 ? mapContainerExtent : new PointExtent(0, map.height - visualHeight1, map.width, map.height);
        this._visitedTiles = new TileHashset();
        var tileGrid = this._getTiles(0 - this.options['zoomOffset'], visualContainerExtent, 2, layer && layer.getRenderer(), true);
        var error = this._getRootError() * Math.pow(2, this.options['zoomOffset']);
        tileGrid.tiles.forEach(function (t) {
          t.error = error;
        });
        queue = tileGrid.tiles;
      } else {
        var rootNodes = this._getRootNodes(offset0);
        if (rootNodes.status !== 1) {
          console.warn(rootNodes.error);
          this._disablePyramid = true;
          return this.getTiles(z, layer);
        }
        queue = [...rootNodes.tiles];
      }
    } else {
      var _rootNodes = this._getRootNodes(offset0);
      if (_rootNodes.status !== 1) {
        console.warn(_rootNodes.error);
        this._disablePyramid = true;
        return this.getTiles(z, layer);
      }
      queue = [..._rootNodes.tiles];
    }
    var glRes = map.getGLRes();
    var offsets = {
      0: offset0
    };
    var extent = new PointExtent();
    var tiles = [];
    var parents = [];
    var parentRenderer = layer && layer.getRenderer();
    while (queue.length > 0) {
      var node = queue.pop();
      if (node.z === maxZoom) {
        extent._combine(node.extent2d);
        tiles.push(node);
        continue;
      }
      if (!offsets[node.z + 1]) {
        offsets[node.z + 1] = this._getTileOffset(node.z + 1);
      }
      this._splitNode(node, projectionView, queue, tiles, parents, z, extent, maxZoom, offsets[node.z + 1], parentRenderer, glRes);
    }
    parents.sort(sortingTiles);
    this._debugTile(tiles, '_getPyramidTiles');
    return {
      tileGrids: [{
        extent: extent,
        count: tiles.length,
        tiles: tiles,
        parents: parents,
        offset: [0, 0],
        zoom: z
      }],
      count: tiles.length
    };
  };
  _proto2.isParentTile = function isParentTile(currentTileZoom, maxZoom, tile) {
    var stackMinZoom = Math.max(this.getMinZoom(), currentTileZoom - this.options['tileStackStartDepth']);
    var stackMaxZoom = stackMinZoom + this.options['tileStackDepth'];
    return tile.z >= stackMinZoom && tile.z < stackMaxZoom && tile.z < maxZoom;
  };
  _proto2._splitNode = function _splitNode(node, projectionView, queue, tiles, parents, currentTileZoom, gridExtent, maxZoom, offset, parentRenderer, glRes) {
    var z = node.z + 1;
    var sr = this._spatialRef || this.getSpatialReference();
    var {
      idx: idx,
      idy: idy
    } = node;
    var renderer = parentRenderer || this.getRenderer();
    var hasCurrentIn = false;
    var children = [];
    var res = sr.getResolution(z);
    var glScale = res / glRes;
    if (!this.tileInfoCache) {
      this.tileInfoCache = new LRUCache(this.options['maxCacheSize'] * 4);
    }
    for (var i = 0; i < 4; i++) {
      var dx = i % 2;
      var dy = i >> 1;
      if (!node.children) {
        node.children = [];
      }
      var tileId = node.children[i];
      if (!tileId) {
        var childIdx = (idx << 1) + dx;
        var childIdy = (idy << 1) + dy;
        tileId = this._getTileId(childIdx, childIdy, z);
        node.children[i] = tileId;
      }
      var cached = renderer.isTileCachedOrLoading(tileId);
      var childNode = cached && cached.info;
      if (!childNode) {
        childNode = this.tileInfoCache.get(tileId);
        if (!childNode) {
          childNode = this._createChildNode(node, dx, dy, offset, tileId);
        }
      }
      childNode.error = node.error / 2;
      childNode.offset[0] = offset[0];
      childNode.offset[1] = offset[1];
      var visible = this._isTileVisible(childNode, projectionView, glScale, maxZoom, offset);
      if (visible === TileVisibility.VISIBLE) {
        hasCurrentIn = true;
      } else if (visible === TileVisibility.OUT_OF_FRUSTUM) {
        continue;
      } else if (visible === TileVisibility.SCREEN_ERROR_TOO_SMALL && z !== maxZoom) {
        tiles.push(node);
        gridExtent._combine(node.extent2d);
        return;
      }
      children.push(childNode);
    }
    if (z === maxZoom) {
      if (hasCurrentIn) {
        pushIn(queue, children);
      } else {
        tiles.push(node);
        gridExtent._combine(node.extent2d);
      }
    } else {
      pushIn(queue, children);
    }
    if (this.isParentTile(currentTileZoom, maxZoom, node)) {
      parents.push(node);
    }
  };
  _proto2._createChildNode = function _createChildNode(node, dx, dy, offset, tileId) {
    var {
      x: x,
      y: y,
      idx: idx,
      idy: idy,
      extent2d: extent2d
    } = node;
    var z = node.z + 1;
    var childX = (x << 1) + dx;
    var childY = (y << 1) + dy;
    var childIdx = (idx << 1) + dx;
    var childIdy = (idy << 1) + dy;
    var childScale = 2;
    var width = extent2d.getWidth() / 2 * childScale;
    var height = extent2d.getHeight() / 2 * childScale;
    var minx = extent2d.xmin * childScale;
    var maxy = extent2d.ymax * childScale;
    var miny = extent2d.ymin * childScale;
    var tileSystem = this._getTileConfig().tileSystem;
    var scaleY = tileSystem.scale.y;
    tileId = tileId || this._getTileId(childIdx, childIdy, z);
    var extent;
    if (scaleY < 0) {
      var nwx = minx + dx * width;
      var nwy = maxy - dy * height;
      extent = new PointExtent(nwx, nwy - height, nwx + width, nwy);
    } else {
      var swx = minx + dx * width;
      var swy = miny + dy * height;
      extent = new PointExtent(swx, swy, swx + width, swy + height);
    }
    var childNode = this.createTileNode(childX, childY, z, childIdx, childIdy, node.res / 2, node.error / 2, node.id, extent, tileId);
    this.tileInfoCache.add(tileId, childNode);
    return childNode;
  };
  _proto2._isTileVisible = function _isTileVisible(node, projectionView, glScale, maxZoom, offset) {
    if (node.z === 0) {
      return TileVisibility.VISIBLE;
    }
    if (!this._isTileInFrustum(node, projectionView, glScale, offset)) {
      return TileVisibility.OUT_OF_FRUSTUM;
    }
    var maxError = this.options['maxError'];
    if (isNil(maxError)) {
      maxError = DEFAULT_MAXERROR;
    }
    var error = this._getScreenSpaceError(node, glScale, maxZoom, offset);
    return error >= maxError ? TileVisibility.VISIBLE : TileVisibility.SCREEN_ERROR_TOO_SMALL;
  };
  _proto2._isTileInFrustum = function _isTileInFrustum(node, projectionView, glScale, offset) {
    if (!this._zScale) {
      var map = this.getMap();
      var glRes = map.getGLRes();
      this._zScale = map.altitudeToPoint(100, glRes) / 100;
    }
    var renderer = this.getRenderer();
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = node.extent2d;
    if (node.offset && node.offset[0] !== 0 && node.offset[1] !== 0 && !isFunction(this.options.offset)) {
      var [x, y] = node.offset;
      xmin += x;
      xmax += x;
      ymin += y;
      ymax += y;
    }
    TILE_BOX[0][0] = (xmin - offset[0]) * glScale;
    TILE_BOX[0][1] = (ymin - offset[1]) * glScale;
    var minAltitude = node.minAltitude || renderer && renderer.avgMinAltitude || 0;
    TILE_BOX[0][2] = minAltitude * this._zScale;
    TILE_BOX[1][0] = (xmax - offset[0]) * glScale;
    TILE_BOX[1][1] = (ymax - offset[1]) * glScale;
    var maxAltitude = node.maxAltitude || renderer && renderer.avgMaxAltitude || 0;
    TILE_BOX[1][2] = maxAltitude * this._zScale;
    return intersectsBox(projectionView, TILE_BOX);
  };
  _proto2._getScreenSpaceError = function _getScreenSpaceError(node, glScale, maxZoom, offset) {
    var geometricError = node.error;
    var map = this.map;
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = node.extent2d;
    TILE_MIN[0] = (xmin - offset[0]) * glScale;
    TILE_MIN[1] = (ymin - offset[1]) * glScale;
    TILE_MAX[0] = (xmax - offset[0]) * glScale;
    TILE_MAX[1] = (ymax - offset[1]) * glScale;
    var distanceToCamera = distanceToRect(TILE_MIN, TILE_MAX, map.cameraPosition);
    var distance = Math.max(Math.abs(distanceToCamera), 1E-7);
    var gap = Math.abs(node.z - maxZoom);
    var r;
    if (map.height < 1000) {
      r = 1;
    } else {
      r = gap <= 1 ? 1 : gap <= 2 ? 0.7 : 0.605;
    }
    var error = geometricError * r / distance * this.options['tileErrorScale'];
    var cache = MapStateCache[map.id];
    var pitch = cache ? cache.pitch : map.getPitch();
    if (pitch <= 60) {
      return error * 1.45;
    }
    return error;
  };
  _proto2._getCascadeTiles = function _getCascadeTiles(z, parentLayer) {
    var map = this.getMap();
    var pitch = map.getPitch();
    var parentRenderer = parentLayer && parentLayer.getRenderer();
    var mapExtent = map.getContainerExtent();
    var tileGrids = [];
    var count = 0;
    var minZoom = this.getMinZoom();
    var cascadePitch0 = map.options['cascadePitches'][0];
    var cascadePitch1 = map.options['cascadePitches'][1];
    var visualHeight1 = Math.floor(map._getVisualHeight(cascadePitch1));
    var tileZoom = isNil(z) ? this._getTileZoom(map.getZoom()) : z;
    this._visitedTiles = new TileHashset();
    if (!isNil(z) || !this.options['cascadeTiles'] || pitch <= cascadePitch0 || !isNil(minZoom) && tileZoom <= minZoom) {
      var containerExtent = pitch <= cascadePitch1 ? mapExtent : new PointExtent(0, map.height - visualHeight1, map.width, map.height);
      var _currentTiles = this._getTiles(tileZoom, containerExtent, 2, parentRenderer);
      if (_currentTiles) {
        count += _currentTiles.tiles.length;
        tileGrids.push(_currentTiles);
      }
      return {
        tileGrids: tileGrids,
        count: count
      };
    }
    var visualHeight0 = Math.floor(map._getVisualHeight(cascadePitch0));
    var extent0 = new PointExtent(0, map.height - visualHeight0, map.width, map.height);
    var currentTiles = this._getTiles(tileZoom, extent0, 0, parentRenderer);
    count += currentTiles ? currentTiles.tiles.length : 0;
    tileGrids.push(currentTiles);
    var cascadeHeight = extent0.ymin;
    var d = map.getSpatialReference().getZoomDirection();
    var cascadeLevels = d;
    var cascadeTiles1;
    if (pitch > cascadePitch1) {
      if (tileZoom - cascadeLevels <= minZoom) {
        cascadeLevels = 0;
      }
      var extent1 = new PointExtent(0, map.height - visualHeight1, map.width, cascadeHeight);
      cascadeTiles1 = this._getTiles(tileZoom - cascadeLevels, extent1, 1, parentRenderer);
      count += cascadeTiles1 ? cascadeTiles1.tiles.length : 0;
      cascadeHeight = extent1.ymin;
      cascadeLevels += 4 * d;
      tileGrids.push(cascadeTiles1);
    }
    var cascadeTiles2;
    if (tileZoom - cascadeLevels >= minZoom) {
      var extent2 = new PointExtent(0, mapExtent.ymin, map.width, cascadeHeight);
      cascadeTiles2 = this._getTiles(tileZoom - cascadeLevels, extent2, 2, parentRenderer);
      count += cascadeTiles2 ? cascadeTiles2.tiles.length : 0;
      tileGrids.push(cascadeTiles2);
    }
    if (cascadeTiles1 && cascadeTiles2) {
      tileGrids[1] = cascadeTiles2;
      tileGrids[2] = cascadeTiles1;
    }
    return {
      tileGrids: tileGrids,
      count: count
    };
  };
  _proto2.getTileUrl = function getTileUrl(x, y, z) {
    var urlTemplate = this.options['urlTemplate'];
    var domain = '';
    var subdomains = this.options['subdomains'];
    if (subdomains) {
      if (isArrayHasData(subdomains)) {
        var length = subdomains.length;
        var s = (x + y) % length;
        if (s < 0) {
          s = 0;
        }
        domain = subdomains[s];
      }
    }
    if (isFunction(urlTemplate)) {
      return urlTemplate(x, y, z, domain);
    }
    var data = {
      'x': x,
      'y': y,
      'z': z,
      's': domain
    };
    if (this.options.token) {
      data.token = this.options.token;
    }
    if (this.options.customTags) {
      extend$2(data, this.options.customTags);
    }
    return urlTemplate.replace(URL_PATTERN, function (str, key) {
      var value = data[key];
      if (value === undefined) {
        throw new Error('No value provided for variable ' + str);
      } else if (typeof value === 'function') {
        value = value(data);
      }
      return value;
    });
  };
  _proto2.clear = function clear() {
    if (this._renderer) {
      this._renderer.clear();
    }
    if (this.tileInfoCache) {
      this.tileInfoCache.reset();
    }
    this.fire('clear');
    return this;
  };
  _proto2.toJSON = function toJSON() {
    var profile = {
      'type': this.getJSONType(),
      'id': this.getId(),
      'options': this.config()
    };
    return profile;
  };
  _proto2.getSpatialReference = function getSpatialReference() {
    var map = this.getMap();
    if (map && (!this.options['spatialReference'] || SpatialReference.equals(this.options['spatialReference'], map.options['spatialReference']))) {
      return map.getSpatialReference();
    }
    if (this._sr) {
      return this._sr;
    }
    var config = this.options['spatialReference'];
    if (isString(config)) {
      config = SpatialReference.getPreset(config);
      if (!config) {
        throw new Error("Unsupported spatial reference: " + this.options['spatialReference'] + ", possible values: " + SpatialReference.getAllPresets().join());
      }
    }
    this._sr = new SpatialReference(config);
    this._srMinZoom = this._sr.getMinZoom();
    this._srMaxZoom = this._sr.getMaxZoom();
    this._hasOwnSR = this._sr.toJSON().projection !== map.getSpatialReference().toJSON().projection;
    return this._sr;
  };
  _proto2.getMinZoom = function getMinZoom() {
    var minZoom = this.options['minZoom'] || 0;
    var sr = this._spatialRef || this.getSpatialReference();
    if (sr !== this.getMap().getSpatialReference()) {
      return Math.max(minZoom, this._srMinZoom);
    }
    return minZoom;
  };
  _proto2.getMaxZoom = function getMaxZoom() {
    var sr = this._spatialRef || this.getSpatialReference();
    if (sr !== this.getMap().getSpatialReference()) {
      return Math.min(_Layer.prototype.getMaxZoom.call(this), this._srMaxZoom);
    }
    return _Layer.prototype.getMaxZoom.call(this);
  };
  _proto2._getTileZoom = function _getTileZoom(zoom) {
    if (!this._hasOwnSR) {
      var res0 = this.getMap().getResolution(zoom);
      var res1 = this.getSpatialReference().getResolution(zoom);
      var dz = Math.log(res1 / res0) * Math.LOG2E;
      zoom += dz;
    }
    var maxZoom = this.getMaxAvailableZoom();
    if (!isNil(maxZoom) && zoom > maxZoom) {
      zoom = maxZoom;
    }
    if (!isInteger(zoom)) {
      zoom = Math.round(zoom);
    }
    zoom = Math.max(0, zoom);
    return zoom;
  };
  _proto2.getMaxAvailableZoom = function getMaxAvailableZoom() {
    var sr = this._spatialRef || this.getSpatialReference();
    return this.options['maxAvailableZoom'] || sr && sr.getMaxZoom();
  };
  _proto2._getTiles = function _getTiles(tileZoom, containerExtent, cascadeLevel, parentRenderer, ignoreMinZoom) {
    var map = this.getMap();
    var z = tileZoom;
    var frustumMatrix = map.projViewMatrix;
    var canSplitTile = map.getResolution(tileZoom) / map.getResolution(tileZoom - 1) === 0.5;
    if (cascadeLevel < 2) {
      if (cascadeLevel === 0 && canSplitTile) {
        z -= 1;
      }
      frustumMatrix = cascadeLevel === 0 ? map.cascadeFrustumMatrix0 : cascadeLevel === 1 ? map.cascadeFrustumMatrix1 : map.projViewMatrix;
    }
    var zoom = z + this.options['zoomOffset'];
    var offset = this._getTileOffset(z),
      hasOffset = offset[0] || offset[1];
    var emptyGrid = {
      'zoom': z,
      'extent': null,
      'offset': offset,
      'tiles': []
    };
    if (zoom < 0) {
      return emptyGrid;
    }
    if (!map || !this.isVisible() || !map.width || !map.height) {
      return emptyGrid;
    }
    if (!ignoreMinZoom) {
      var minZoom = this.getMinZoom(),
        maxZoom = this.getMaxZoom();
      if (!isNil(minZoom) && z < minZoom || !isNil(maxZoom) && z > maxZoom) {
        return emptyGrid;
      }
    }
    var tileConfig = this._getTileConfig();
    if (!tileConfig) {
      return emptyGrid;
    }
    var tileOffsets = {
      zoom: offset
    };
    var sr = this._spatialRef || this.getSpatialReference();
    var res = sr.getResolution(z);
    var glScale;
    if (this._hasOwnSR) {
      glScale = map.getGLScale(z);
    } else {
      glScale = res / map.getGLRes();
    }
    var repeatWorld = !this._hasOwnSR && this.options['repeatWorld'];
    var extent2d = this._convertToExtent2d(containerExtent);
    var maskExtent = this._getMask2DExtent();
    if (maskExtent) {
      var intersection = maskExtent.intersection(extent2d);
      if (!intersection) {
        return emptyGrid;
      }
      containerExtent = intersection.convertTo(function (c) {
        return map._pointToContainerPoint(c, undefined, 0, TEMP_POINT$3);
      });
    }
    var prjCenter = map._containerPointToPrj(containerExtent.getCenter(), TEMP_POINT0);
    var centerPoint = map._prjToPoint(prjCenter, z, TEMP_POINT1$1);
    var c;
    if (hasOffset) {
      c = this._project(map._pointToPrj(centerPoint._add(offset), z, TEMP_POINT1$1), TEMP_POINT1$1);
    } else {
      c = this._project(prjCenter, TEMP_POINT1$1);
    }
    var extentScale = map.getGLScale() / map.getGLScale(z);
    TEMP_POINT2$1.x = extent2d.xmin * extentScale;
    TEMP_POINT2$1.y = extent2d.ymax * extentScale;
    TEMP_POINT3.x = extent2d.xmax * extentScale;
    TEMP_POINT3.y = extent2d.ymin * extentScale;
    var pmin = this._project(map._pointToPrj(TEMP_POINT2$1._add(offset), z, TEMP_POINT2$1), TEMP_POINT2$1);
    var pmax = this._project(map._pointToPrj(TEMP_POINT3._add(offset), z, TEMP_POINT3), TEMP_POINT3);
    var centerTile = tileConfig.getTileIndex(c, res, repeatWorld);
    var ltTile = tileConfig.getTileIndex(pmin, res, repeatWorld);
    var rbTile = tileConfig.getTileIndex(pmax, res, repeatWorld);
    var top = Math.ceil(Math.abs(centerTile.idy - ltTile.idy)),
      left = Math.ceil(Math.abs(centerTile.idx - ltTile.idx)),
      bottom = Math.ceil(Math.abs(centerTile.idy - rbTile.idy)),
      right = Math.ceil(Math.abs(centerTile.idx - rbTile.idx));
    var allCount = (top + bottom + 1) * (left + right + 1);
    var tileSize = this.getTileSize();
    var renderer = this.getRenderer() || parentRenderer,
      scale = this._getTileConfig().tileSystem.scale;
    var tiles = [],
      extent = new PointExtent();
    var tilePoint = new Point(0, 0);
    for (var i = -top; i <= bottom; i++) {
      var j = -left;
      var leftVisitEnd = -Infinity;
      var rightVisitEnd = false;
      while (j >= leftVisitEnd && j <= right) {
        var idx = tileConfig.getNeighorTileIndex(centerTile.idx, centerTile.idy, j, i, res, repeatWorld);
        if (leftVisitEnd === -Infinity) {
          j++;
        } else {
          j--;
        }
        var tileId = this._getTileId(idx.idx, idx.idy, z);
        if (idx.out || this._visitedTiles && this._visitedTiles.has(tileId)) {
          continue;
        }
        var tileInfo = renderer && renderer.isTileCachedOrLoading(tileId);
        if (tileInfo) {
          tileInfo = tileInfo.info;
        }
        var p = void 0;
        if (tileInfo) {
          var {
            extent2d: _extent2d
          } = tileInfo;
          tilePoint.set(_extent2d.xmin, _extent2d.ymax);
          p = tilePoint;
        } else if (!this._hasOwnSR) {
          p = tileConfig.getTilePointNW(idx.x, idx.y, res);
        } else {
          var pnw = tileConfig.getTilePrjNW(idx.x, idx.y, res);
          p = map._prjToPoint(this._unproject(pnw, TEMP_POINT3), z);
        }
        var width = void 0,
          height = void 0;
        if (!this._hasOwnSR) {
          width = tileSize.width;
          height = tileSize.height;
        } else {
          var pp = void 0;
          if (!this._hasOwnSR) {
            pp = tileConfig.getTilePointSE(idx.x, idx.y, res);
          } else {
            var pse = tileConfig.getTilePrjSE(idx.x, idx.y, res);
            pp = map._prjToPoint(this._unproject(pse, TEMP_POINT3), z, TEMP_POINT3);
          }
          width = Math.ceil(Math.abs(pp.x - p.x));
          height = Math.ceil(Math.abs(pp.y - p.y));
        }
        var dx = scale.x * (idx.idx - idx.x) * width,
          dy = scale.y * (idx.idy - idx.y) * height;
        if (!tileInfo && (dx || dy)) {
          p._add(dx, dy);
        }
        var tileExtent = tileInfo && tileInfo.extent2d || new PointExtent(p.x, p.y - height, p.x + width, p.y);
        if (allCount <= 4 || rightVisitEnd || this._isTileInExtent(frustumMatrix, tileExtent, offset, glScale)) {
          var tileRes = this._hasOwnSR ? map._getResolution(z) : res;
          if (this._visitedTiles && cascadeLevel === 0) {
            this._visitedTiles.add(tileId);
          }
          if (canSplitTile && cascadeLevel === 0) {
            this._splitTiles(frustumMatrix, tiles, renderer, idx, z + 1, tileRes, tileExtent, dx, dy, tileOffsets);
            extent._combine(tileExtent);
          } else {
            if (!tileInfo) {
              tileInfo = this.createTileNode(idx.x, idx.y, z, idx.idx, idx.idy, tileRes, 0, null, tileExtent, tileId);
            } else {
              tileInfo.offset[0] = offset[0];
              tileInfo.offset[1] = offset[1];
            }
            tiles.push(tileInfo);
            extent._combine(tileExtent);
          }
          if (leftVisitEnd === -Infinity) {
            leftVisitEnd = j;
            j = right;
          } else if (!rightVisitEnd) {
            rightVisitEnd = true;
          }
        }
      }
    }
    if (tiles.length) {
      var center = map._containerPointToPoint(containerExtent.getCenter(), z, TEMP_POINT$3)._add(offset);
      var point0 = new Point(0, 0);
      var point1 = new Point(0, 0);
      tiles.sort(function (a, b) {
        point0.set((a.extent2d.xmin + a.extent2d.xmax) / 2, (a.extent2d.ymin + a.extent2d.ymax) / 2);
        point1.set((b.extent2d.xmin + b.extent2d.xmax) / 2, (b.extent2d.ymin + b.extent2d.ymax) / 2);
        return point0.distanceTo(center) - point1.distanceTo(center);
      });
    }
    return {
      'offset': offset,
      'zoom': tileZoom,
      'extent': extent,
      'tiles': tiles
    };
  };
  _proto2._convertToExtent2d = function _convertToExtent2d(containerExtent) {
    var _this2 = this;
    var map = this.getMap();
    return containerExtent.convertTo(function (c) {
      var result;
      if (c.y > 0 && c.y < map.height) {
        var key = (c.x === 0 ? 0 : 1) + c.y;
        if (!_this2._coordCache[key]) {
          _this2._coordCache[key] = map._containerPointToPoint(c);
        }
        result = _this2._coordCache[key];
      }
      result = map._containerPointToPoint(c, undefined, TEMP_POINT$3);
      return result;
    });
  };
  _proto2._splitTiles = function _splitTiles(frustumMatrix, tiles, renderer, tileIdx, z, res, tileExtent, dx, dy, tileOffsets) {
    var yOrder = this._getTileConfig().tileSystem.scale.y;
    var glScale = this.getMap().getGLScale(z);
    var corner = TEMP_POINT4.set(tileExtent.xmin * 2, yOrder < 0 ? tileExtent.ymax * 2 : tileExtent.ymin * 2);
    var w = tileExtent.getWidth();
    var h = tileExtent.getHeight();
    var idx = tileIdx.idx * 2;
    var idy = tileIdx.idy * 2;
    var x = tileIdx.x * 2;
    var y = tileIdx.y * 2;
    var tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 0, 0, w, h, corner, glScale, tileOffsets);
    if (tile) tiles.push(tile);
    tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 0, 1, w, h, corner, glScale, tileOffsets);
    if (tile) tiles.push(tile);
    tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 1, 0, w, h, corner, glScale, tileOffsets);
    if (tile) tiles.push(tile);
    tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 1, 1, w, h, corner, glScale, tileOffsets);
    if (tile) tiles.push(tile);
  };
  _proto2._checkAndAddTile = function _checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, i, j, w, h, corner, glScale, tileOffsets) {
    var tileId = this._getTileId(idx + i, idy + j, z);
    if (this._visitedTiles && this._visitedTiles.has(tileId)) {
      return null;
    }
    var offset = tileOffsets[z];
    if (!offset) {
      offset = tileOffsets[z] = this._getTileOffset(z);
    }
    var yOrder = this._getTileConfig().tileSystem.scale.y;
    var childExtent = new PointExtent(corner.x + i * w, corner.y + yOrder * j * h, corner.x + (i + 1) * w, corner.y + yOrder * (j + 1) * h);
    if (!this._isSplittedTileInExtent(frustumMatrix, childExtent, offset, glScale)) {
      return null;
    }
    var childRes = res / 2;
    var tileCache = renderer && renderer.isTileCachedOrLoading(tileId);
    var tileInfo;
    if (!tileCache) {
      tileInfo = this.createTileNode(x + i, y + j, z, idx + i, idx + y, childRes, 0, null, childExtent, tileId);
    } else {
      tileInfo = tileCache.info;
    }
    return tileInfo;
  };
  _proto2._getTileOffset = function _getTileOffset(...params) {
    var offset = this.options['offset'];
    if (!offset) {
      return [0, 0];
    }
    if (isFunction(offset)) {
      offset = offset.call(this, ...params);
    }
    if (isNumber(offset)) {
      offset = [offset, offset];
    }
    return offset || [0, 0];
  };
  _proto2.getTileId = function getTileId(x, y, zoom, id) {
    return this._getTileId(x, y, zoom, id);
  };
  _proto2._getTileId = function _getTileId(x, y, zoom, id) {
    return (id || this.getId()) + "_" + x + "_" + y + "_" + zoom;
  };
  _proto2._project = function _project(pcoord, out) {
    if (this._hasOwnSR) {
      var map = this.getMap();
      var mapProjection = map.getProjection();
      var sr = this._spatialRef || this.getSpatialReference();
      var projection = sr.getProjection();
      return projection.project(mapProjection.unproject(pcoord, out), out);
    } else {
      return pcoord;
    }
  };
  _proto2._unproject = function _unproject(pcoord, out) {
    if (this._hasOwnSR) {
      var map = this.getMap();
      var sr = this._spatialRef || this.getSpatialReference();
      var mapProjection = map.getProjection();
      var projection = sr.getProjection();
      return mapProjection.project(projection.unproject(pcoord, out), out);
    } else {
      return pcoord;
    }
  };
  _proto2._initTileConfig = function _initTileConfig() {
    var map = this.getMap(),
      tileSize = this.getTileSize();
    var sr = this.getSpatialReference();
    var projection = sr.getProjection(),
      fullExtent = sr.getFullExtent();
    this._defaultTileConfig = new TileConfig(map, TileSystem.getDefault(projection), fullExtent, tileSize);
    if (this.options.hasOwnProperty('tileSystem')) {
      this._tileConfig = new TileConfig(map, this.options['tileSystem'], fullExtent, tileSize);
    }
    delete this._rootNodes;
    delete this._tileFullExtent;
    delete this._disablePyramid;
  };
  _proto2._getTileConfig = function _getTileConfig() {
    if (!this._defaultTileConfig) {
      this._initTileConfig();
    }
    return this._tileConfig || this._defaultTileConfig;
  };
  _proto2._bindMap = function _bindMap(args) {
    this._onSpatialReferenceChange();
    return _Layer.prototype._bindMap.apply(this, arguments);
  };
  _proto2._isTileInExtent = function _isTileInExtent(frustumMatrix, tileExtent, offset, glScale) {
    var map = this.getMap();
    var matrix;
    if (frustumMatrix !== map.projViewMatrix) {
      var tileCenter = tileExtent.getCenter(TEMP_POINT6)._sub(offset[0], offset[1])._multi(glScale);
      set(ARR3, tileCenter.x, tileCenter.y, 0);
      var ndc = transformMat4(ARR3, ARR3, map.projViewMatrix);
      matrix = ndc[1] < 0 ? map.projViewMatrix : frustumMatrix;
    } else {
      matrix = map.projViewMatrix;
    }
    TILE_BOX[0][0] = (tileExtent.xmin - offset[0]) * glScale;
    TILE_BOX[0][1] = (tileExtent.ymin - offset[1]) * glScale;
    TILE_BOX[1][0] = (tileExtent.xmax - offset[0]) * glScale;
    TILE_BOX[1][1] = (tileExtent.ymax - offset[1]) * glScale;
    return intersectsBox(matrix, TILE_BOX);
  };
  _proto2._isSplittedTileInExtent = function _isSplittedTileInExtent(frustumMatrix, tileExtent, offset, glScale) {
    var map = this.getMap();
    TILE_BOX[0][0] = (tileExtent.xmin - offset[0]) * glScale;
    TILE_BOX[0][1] = (tileExtent.ymin - offset[1]) * glScale;
    TILE_BOX[1][0] = (tileExtent.xmax - offset[0]) * glScale;
    TILE_BOX[1][1] = (tileExtent.ymax - offset[1]) * glScale;
    return intersectsBox(map.projViewMatrix, TILE_BOX);
  };
  _proto2.getEvents = function getEvents() {
    return {
      'spatialreferencechange': this._onSpatialReferenceChange
    };
  };
  _proto2._onSpatialReferenceChange = function _onSpatialReferenceChange() {
    delete this._tileConfig;
    delete this._defaultTileConfig;
    delete this._sr;
    delete this._srMinZoom;
    delete this._hasOwnSR;
    delete this._rootNodes;
    if (this.tileInfoCache) {
      this.tileInfoCache.reset();
    }
    var renderer = this.getRenderer();
    if (renderer) {
      renderer.clear();
    }
  };
  _proto2.getPolygonOffsetCount = function getPolygonOffsetCount() {
    return 2;
  };
  _proto2.getPolygonOffset = function getPolygonOffset() {
    return this._polygonOffset || 0;
  };
  _proto2.setPolygonOffset = function setPolygonOffset(offset) {
    this._polygonOffset = offset;
    return this;
  };
  _proto2.getRenderer = function getRenderer() {
    return _Layer.prototype.getRenderer.call(this);
  };
  _proto2._getTileBBox = function _getTileBBox(tile) {
    var map = this.getMap();
    if (!map) {
      return;
    }
    var extent2d = tile.extent2d;
    var offset = tile.offset || [0, 0];
    if (!extent2d) {
      return;
    }
    var res = tile.res;
    var [offsetX, offsetY] = offset;
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = extent2d;
    xmin -= offsetX;
    xmax -= offsetX;
    ymin -= offsetY;
    ymax -= offsetY;
    var pmin = new Point(xmin, ymin),
      pmax = new Point(xmax, ymax);
    var min = map.pointAtResToCoordinate(pmin, res, TEMP_POINT0),
      max = map.pointAtResToCoordinate(pmax, res, TEMP_POINT1$1);
    return [min.x, min.y, max.x, max.y];
  };
  _proto2._tileInMask = function _tileInMask(tile) {
    var mask = this.getMask();
    if (!mask) {
      return true;
    }
    var maskType = mask.type;
    if (!maskType || maskType.indexOf('Polygon') === -1) {
      return true;
    }
    var maskGeoJSON = this._maskGeoJSON;
    if (!maskGeoJSON || !maskGeoJSON.geometry) {
      return true;
    }
    var {
      coordinates: coordinates,
      type: type
    } = maskGeoJSON.geometry;
    if (!coordinates || !type) {
      return true;
    }
    if (type.indexOf('Polygon') === -1) {
      return true;
    }
    if (!maskGeoJSON.bbox) {
      var extent = mask.getExtent();
      if (!extent) {
        return true;
      }
      maskGeoJSON.bbox = [extent.xmin, extent.ymin, extent.xmax, extent.ymax];
    }
    var tileBBOX = this._getTileBBox(tile);
    if (!tileBBOX) {
      return true;
    }
    return bboxInMask(tileBBOX, this._maskGeoJSON);
  };
  _proto2._debugTile = function _debugTile(tile, name, debugOn) {
    if (this.options['debugTile']) {
      if (Array.isArray(tile)) {
        for (var i = 0; i < tile.length; i++) {
          if (!tile[i]) {
            continue;
          }
          this._debugTile(tile[i], name + ' at ' + i, debugOn);
        }
        return;
      }
      if (!tile) {
        return;
      }
      var {
        x: x,
        y: y,
        z: z
      } = this.options['debugTile'];
      if (tile.x === x && tile.y === y && tile.z === z) {
        console.log("Debug Tile Found in TileLayer." + name + ":", tile);
        if (debugOn) {
          debugger;
        }
      }
    }
  };
  return TileLayer;
}(Layer);
TileLayer.registerJSONType('TileLayer');
TileLayer.mergeOptions(options$7);
function distanceToRect(min, max, xyz) {
  var dx = Math.max(min[0] - xyz[0], 0, xyz[0] - max[0]);
  var dy = Math.max(min[1] - xyz[1], 0, xyz[1] - max[1]);
  var dz = Math.max(min[2] - xyz[2], 0, xyz[2] - max[2]);
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
function sortingTiles(t0, t1) {
  return t0.z - t1.z;
}
var TileVisibility;
(function (TileVisibility) {
  TileVisibility[TileVisibility["OUT_OF_FRUSTUM"] = 0] = "OUT_OF_FRUSTUM";
  TileVisibility[TileVisibility["SCREEN_ERROR_TOO_SMALL"] = 1] = "SCREEN_ERROR_TOO_SMALL";
  TileVisibility[TileVisibility["VISIBLE"] = 2] = "VISIBLE";
})(TileVisibility || (TileVisibility = {}));

var options$6 = {
  urlTemplate: '',
  'maxCacheSize': 1024
};
var DEFAULT_TILESIZE = new Size(256, 256);
var EVENTS$1 = 'show hide remove setzindex forcereloadstart';
function checkLayers(tileLayers) {
  if (!Array.isArray(tileLayers)) {
    tileLayers = [tileLayers];
  }
  return tileLayers;
}
var GroupTileLayer = function (_TileLayer) {
  function GroupTileLayer(id, layers, options) {
    var _this;
    _this = _TileLayer.call(this, id, options) || this;
    _this.layers = layers || [];
    _this._checkChildren();
    _this.layerMap = {};
    _this._groupChildren = [];
    return _this;
  }
  _inheritsLoose(GroupTileLayer, _TileLayer);
  GroupTileLayer.fromJSON = function fromJSON(layerJSON) {
    if (!layerJSON || layerJSON['type'] !== 'GroupTileLayer') {
      return null;
    }
    var layers = layerJSON['layers'].map(function (json) {
      return Layer.fromJSON(json);
    });
    return new GroupTileLayer(layerJSON['id'], layers, layerJSON['options']);
  };
  var _proto = GroupTileLayer.prototype;
  _proto.getLayers = function getLayers() {
    return this.layers;
  };
  _proto.addLayer = function addLayer(tileLayers = []) {
    var _this2 = this;
    tileLayers = checkLayers(tileLayers);
    var len = this.layers.length;
    tileLayers.forEach(function (tileLayer) {
      if (!(tileLayer instanceof TileLayer)) {
        return;
      }
      if (_this2.layers.indexOf(tileLayer) === -1 && !_this2.layerMap[tileLayer.getId()]) {
        _this2.layers.push(tileLayer);
      }
    });
    if (len !== this.layers.length) {
      this._sortLayers();
      this._refresh();
      this._renderLayers();
    }
    return this;
  };
  _proto.removeLayer = function removeLayer(tileLayers = []) {
    var _this3 = this;
    tileLayers = checkLayers(tileLayers);
    var len = this.layers.length;
    tileLayers.forEach(function (tileLayer) {
      if (!(tileLayer instanceof TileLayer)) {
        tileLayer = _this3.layerMap[tileLayer];
      }
      if (!(tileLayer instanceof TileLayer)) {
        return;
      }
      var index = _this3.layers.indexOf(tileLayer);
      if (index >= 0) {
        _this3.layers.splice(index, 1);
        tileLayer._doRemove();
        tileLayer.off(EVENTS$1, _this3._onLayerShowHide, _this3);
      }
    });
    if (len !== this.layers.length) {
      this._refresh();
      this._renderLayers();
    }
    return this;
  };
  _proto.clearLayers = function clearLayers() {
    var _this4 = this;
    this.layers.forEach(function (layer) {
      layer._doRemove();
      layer.off(EVENTS$1, _this4._onLayerShowHide, _this4);
    });
    this.layers = [];
    this._refresh();
    this._renderLayers();
    return this;
  };
  _proto.toJSON = function toJSON() {
    var profile = {
      'type': this.getJSONType(),
      'id': this.getId(),
      'layers': this.layers.map(function (layer) {
        return layer.toJSON();
      }),
      'options': this.config()
    };
    return profile;
  };
  _proto.getTileSize = function getTileSize(id) {
    var layer = this.getLayer(id);
    if (!layer) {
      return DEFAULT_TILESIZE;
    }
    return layer.getTileSize();
  };
  _proto.getTiles = function getTiles(z, parentLayer) {
    var layers = this.layers;
    var tiles = [];
    var count = 0;
    for (var i = 0, l = layers.length; i < l; i++) {
      var layer = layers[i];
      if (!layer || !layer.options['visible'] || !layer.isVisible() || !layer.getMap()) {
        continue;
      }
      var childGrid = layer.getTiles(z, parentLayer || this);
      if (!childGrid || childGrid.count === 0) {
        continue;
      }
      count += childGrid.count;
      pushIn(tiles, childGrid.tileGrids);
    }
    return {
      count: count,
      tileGrids: tiles
    };
  };
  _proto.onAdd = function onAdd() {
    this._sortLayers();
    this._refresh();
    _TileLayer.prototype.onAdd.call(this);
  };
  _proto.onRemove = function onRemove() {
    var _this5 = this;
    this.layers.forEach(function (layer) {
      layer._doRemove();
      layer.off(EVENTS$1, _this5._onLayerShowHide, _this5);
    });
    this.layerMap = {};
    this._groupChildren = [];
    _TileLayer.prototype.onRemove.call(this);
  };
  _proto.getLayer = function getLayer(id) {
    return this.getChildLayer(id);
  };
  _proto.getChildLayer = function getChildLayer(id) {
    var layer = this.layerMap[id];
    if (layer) {
      return layer;
    }
    for (var i = 0; i < this._groupChildren.length; i++) {
      var child = this._groupChildren[i].getChildLayer(id);
      if (child) {
        return child;
      }
    }
    return null;
  };
  _proto._removeChildTileCache = function _removeChildTileCache(layer) {
    if (!layer) {
      return this;
    }
    var renderer = this.getRenderer();
    if (!renderer) {
      return this;
    }
    var cache;
    var id = layer.getId();
    var validateCache = function validateCache() {
      return cache && cache.info && cache.info.layer === id;
    };
    if (renderer.tileCache) {
      var keys = renderer.tileCache.keys();
      keys.forEach(function (key) {
        cache = renderer.tileCache.get(key);
        if (validateCache()) {
          renderer.tileCache.remove(key);
        }
      });
    }
    var tilesInView = renderer.tilesInView || {};
    for (var key in tilesInView) {
      cache = tilesInView[key];
      if (validateCache()) {
        delete tilesInView[key];
      }
    }
    var tilesLoading = renderer.tilesLoading || {};
    for (var _key in tilesLoading) {
      cache = tilesLoading[_key];
      if (validateCache()) {
        renderer.abortTileLoading(cache.image, cache.info);
      }
    }
    return this;
  };
  _proto._onLayerShowHide = function _onLayerShowHide(e) {
    var {
      type: type,
      target: target
    } = e || {};
    if (type === 'remove' && target) {
      this.layers.splice(this.layers.indexOf(target), 1);
      target._doRemove();
      target.off(EVENTS$1, this._onLayerShowHide, this);
      this._refresh();
    } else if (type === 'setzindex') {
      this._sortLayers();
    } else if (type === 'forcereloadstart') {
      this._removeChildTileCache(target);
    }
    this._renderLayers();
  };
  _proto._renderLayers = function _renderLayers() {
    var renderer = this.getRenderer();
    if (renderer) {
      renderer.setToRedraw();
    }
    return this;
  };
  _proto._refresh = function _refresh() {
    var _this6 = this;
    var map = this.getMap();
    this._groupChildren = [];
    this.layerMap = {};
    this.layers.forEach(function (layer) {
      _this6.layerMap[layer.getId()] = layer;
      if (layer.getChildLayer) {
        _this6._groupChildren.push(layer);
      }
      if (!layer.getMap()) {
        layer._bindMap(map);
      }
      layer.off(EVENTS$1, _this6._onLayerShowHide, _this6);
      layer.on(EVENTS$1, _this6._onLayerShowHide, _this6);
    });
    return this;
  };
  _proto.isVisible = function isVisible() {
    if (!_TileLayer.prototype.isVisible.call(this)) {
      return false;
    }
    var children = this.layers;
    for (var i = 0, l = children.length; i < l; i++) {
      if (children[i].isVisible()) {
        return true;
      }
    }
    return false;
  };
  _proto._checkChildren = function _checkChildren() {
    var _this7 = this;
    var ids = {};
    this.layers.forEach(function (layer) {
      var layerId = layer.getId();
      if (ids[layerId]) {
        throw new Error("Duplicate child layer id (" + layerId + ") in the GroupTileLayer (" + _this7.getId() + ")");
      } else {
        ids[layerId] = 1;
      }
    });
  };
  _proto._sortLayers = function _sortLayers() {
    this.layers.sort(function (a, b) {
      return a.options.zIndex - b.options.zIndex;
    });
  };
  return GroupTileLayer;
}(TileLayer);
GroupTileLayer.registerJSONType('GroupTileLayer');
GroupTileLayer.mergeOptions(options$6);

var options$5 = {
  urlTemplate: '',
  crs: null,
  uppercase: false,
  detectRetina: false
};
var defaultWmsParams = {
  service: 'WMS',
  request: 'GetMap',
  layers: '',
  styles: '',
  format: 'image/jpeg',
  transparent: false,
  version: '1.1.1'
};
var wmsExcludeParams;
var WMSTileLayer = function (_TileLayer) {
  function WMSTileLayer(id, options) {
    var _this;
    _this = _TileLayer.call(this, id) || this;
    if (!wmsExcludeParams) {
      wmsExcludeParams = extend$2({}, _this.options);
    }
    _this.wmsParams = extend$2({}, defaultWmsParams);
    _this._setOptions(options);
    _this.setZIndex(options.zIndex);
    if (!Browser$1.proxy) {
      _this._optionsHook(options);
    }
    return _this;
  }
  _inheritsLoose(WMSTileLayer, _TileLayer);
  var _proto = WMSTileLayer.prototype;
  _proto._optionsHook = function _optionsHook(options = {}) {
    for (var p in options) {
      if (p === 'tileSize') {
        this._tileSize = null;
      }
      if (!(p in wmsExcludeParams)) {
        this.wmsParams[p] = options[p];
      }
    }
    var tileSize = this.getTileSize();
    this.wmsParams.width = tileSize.width;
    this.wmsParams.height = tileSize.height;
    this._wmsVersion = parseFloat(this.wmsParams.version);
    return this;
  };
  _proto.onAdd = function onAdd() {
    var dpr = this.getMap().getDevicePixelRatio();
    var r = options$5.detectRetina ? dpr : 1;
    this.wmsParams.width *= r;
    this.wmsParams.height *= r;
    var crs = this.options.crs || this.getMap().getProjection().code;
    var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
    this.wmsParams[projectionKey] = crs;
    _TileLayer.prototype.onAdd.call(this);
  };
  _proto.getTileUrl = function getTileUrl(x, y, z) {
    var res = this.getSpatialReference().getResolution(z),
      tileConfig = this._getTileConfig(),
      tileExtent = tileConfig.getTilePrjExtent(x, y, res);
    var max = tileExtent.getMax(),
      min = tileExtent.getMin();
    var bbox = (this._wmsVersion >= 1.3 && (this.wmsParams.crs === 'EPSG:4326' || this.wmsParams.crs === 'EPSG:4490') ? [min.y, min.x, max.y, max.x] : [min.x, min.y, max.x, max.y]).join(',');
    var url = _TileLayer.prototype.getTileUrl.call(this, x, y, z);
    return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
  };
  _proto.toJSON = function toJSON() {
    return {
      'type': 'WMSTileLayer',
      'id': this.getId(),
      'options': this.config()
    };
  };
  WMSTileLayer.fromJSON = function fromJSON(layerJSON) {
    if (!layerJSON || layerJSON['type'] !== 'WMSTileLayer') {
      return null;
    }
    return new WMSTileLayer(layerJSON['id'], layerJSON['options']);
  };
  return WMSTileLayer;
}(TileLayer);
WMSTileLayer.registerJSONType('WMSTileLayer');
WMSTileLayer.mergeOptions(options$5);
function getParamString(obj, existingUrl, uppercase) {
  var params = [];
  for (var i in obj) {
    params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
  }
  return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
}

var CanvasTileLayer = function (_TileLayer) {
  function CanvasTileLayer(id, options) {
    var _this;
    _this = _TileLayer.call(this, id, options) || this;
    if (!_this.options.hasOwnProperty('forceRenderOnMoving')) {
      _this.options['forceRenderOnMoving'] = false;
    }
    return _this;
  }
  _inheritsLoose(CanvasTileLayer, _TileLayer);
  var _proto = CanvasTileLayer.prototype;
  _proto.drawTile = function drawTile() {};
  _proto.toJSON = function toJSON() {
    return {
      'type': 'CanvasTileLayer',
      'id': this.getId(),
      'options': this.config()
    };
  };
  CanvasTileLayer.fromJSON = function fromJSON(layerJSON) {
    if (!layerJSON || layerJSON['type'] !== 'CanvasTileLayer') {
      return null;
    }
    return new CanvasTileLayer(layerJSON['id'], layerJSON['options']);
  };
  return CanvasTileLayer;
}(TileLayer);
CanvasTileLayer.registerJSONType('CanvasTileLayer');

function createGLContext(canvas, options) {
  var attributes = {
    'alpha': true,
    'stencil': true,
    'preserveDrawingBuffer': true,
    'antialias': false
  };
  var names = ['webgl', 'experimental-webgl'];
  var context = null;
  for (var i = 0; i < names.length; ++i) {
    try {
      context = canvas.getContext(names[i], options || attributes);
    } catch (e) {}
    if (context) {
      break;
    }
  }
  return context;
}
function compileShader(gl, type, source) {
  var shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
  if (!compiled) {
    var error = gl.getShaderInfoLog(shader);
    gl.deleteShader(shader);
    throw new Error('Failed to compile shader: ' + error);
  }
  return shader;
}
function createProgram(gl, vert, frag) {
  var vertexShader = compileShader(gl, gl.VERTEX_SHADER, vert);
  var fragmentShader = compileShader(gl, gl.FRAGMENT_SHADER, frag);
  if (!vertexShader || !fragmentShader) {
    return null;
  }
  var program = gl.createProgram();
  if (!program) {
    return null;
  }
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);
  return {
    program: program,
    vertexShader: vertexShader,
    fragmentShader: fragmentShader
  };
}
function enableVertexAttrib(gl, program, attributes) {
  if (Array.isArray(attributes[0])) {
    var FSIZE = Float32Array.BYTES_PER_ELEMENT;
    var STRIDE = 0;
    for (var i = 0; i < attributes.length; i++) {
      STRIDE += attributes[i][1] || 0;
    }
    var offset = 0;
    for (var _i = 0; _i < attributes.length; _i++) {
      var attr = gl.getAttribLocation(program, attributes[_i][0]);
      if (attr < 0) {
        throw new Error('Failed to get the storage location of ' + attributes[_i][0]);
      }
      gl.vertexAttribPointer(attr, attributes[_i][1], gl[attributes[_i][2] || 'FLOAT'], false, FSIZE * STRIDE, FSIZE * offset);
      offset += attributes[_i][1] || 0;
      gl.enableVertexAttribArray(attr);
    }
  } else {
    var _attr = gl.getAttribLocation(program, attributes[0]);
    gl.vertexAttribPointer(_attr, attributes[1], gl[attributes[2] || 'FLOAT'], false, 0, 0);
    gl.enableVertexAttribArray(_attr);
  }
}
var DEPTH_FUNC_CONSTANTS = {
  'never': 0x0200,
  '<': 0x0201,
  '=': 0x0202,
  '<=': 0x0203,
  '>': 0x0204,
  '!=': 0x0205,
  '>=': 0x0206,
  'always': 0x0207
};
function getDepthFunc(v) {
  return DEPTH_FUNC_CONSTANTS[v];
}

var DEFAULT_BASE_COLOR = [1, 1, 1, 1];
var TEMP_FLOAT32ARRAY = new Float32Array(8);
var TEMP_INT16ARRAY = new Int16Array(8);
var shaders = {
  'vertexShader': "\n        attribute vec2 a_position;\n\n        attribute vec2 a_texCoord;\n\n        uniform mat4 u_matrix;\n\n        varying vec2 v_texCoord;\n\n        void main() {\n            gl_Position = u_matrix * vec4(a_position, 0., 1.);\n\n            v_texCoord = a_texCoord;\n        }\n    ",
  'fragmentShader': "\n        precision mediump float;\n\n        uniform sampler2D u_image;\n\n        uniform float u_opacity;\n        uniform float u_debug_line;\n        uniform vec4 u_base_color;\n        uniform float u_alpha_test;\n        varying vec2 v_texCoord;\n\n        void main() {\n            if (u_debug_line == 1.) {\n                gl_FragColor = vec4(0., 1., 0., 1.);\n            } else {\n                gl_FragColor = texture2D(u_image, v_texCoord) * u_opacity;\n            }\n            gl_FragColor *= u_base_color;\n            if (gl_FragColor.a < u_alpha_test) {\n                discard;\n            }\n        }\n    "
};
var v2 = ['', 0],
  v3 = [0, 0, 0],
  arr16 = new Array(16);
var DEBUG_POINT = new Point(20, 20);
var ImageGLRenderable = function ImageGLRenderable(Base) {
  var renderable = function (_Base) {
    function renderable() {
      var _this;
      _this = _Base.apply(this, arguments) || this;
      _this._layerAlt = 0;
      _this._layerAltitude = 0;
      return _this;
    }
    _inheritsLoose(renderable, _Base);
    var _proto = renderable.prototype;
    _proto.drawGLImage = function drawGLImage(image, x, y, w, h, scale, opacity, resized, debugInfo, baseColor) {
      if (this.gl.program !== this.program) {
        this.useProgram(this.program);
      }
      var gl = this.gl;
      this.loadTexture(image, resized);
      var inGroup = this.canvas.gl && this.canvas.gl.wrap;
      if (inGroup) {
        var layerOpacity = this.layer && this.layer.options['opacity'];
        if (isNil(layerOpacity)) {
          layerOpacity = 1;
        }
        opacity *= layerOpacity;
      }
      v3[0] = x || 0;
      v3[1] = y || 0;
      v3[2] = 0;
      var layer = this.layer;
      var map = this.getMap();
      if (layer) {
        var {
          altitude: altitude
        } = layer.options;
        var altIsNumber = isNumber(altitude);
        if (!altIsNumber) {
          this._layerAlt = 0;
        }
        if (this._layerAltitude !== altitude && altIsNumber) {
          var z = map.altitudeToPoint(altitude, map.getGLRes());
          this._layerAltitude = altitude;
          this._layerAlt = z;
        }
      }
      v3[2] = this._layerAlt || 0;
      var uMatrix = identity$1(arr16);
      translate(uMatrix, uMatrix, v3);
      scale$1(uMatrix, uMatrix, [scale, scale, 1]);
      multiply(uMatrix, map.projViewMatrix, uMatrix);
      gl.uniformMatrix4fv(this.program['u_matrix'], false, uMatrix);
      gl.uniform1f(this.program['u_opacity'], opacity);
      gl.uniform1f(this.program['u_debug_line'], 0);
      gl.uniform4fv(this.program['u_base_color'], baseColor || DEFAULT_BASE_COLOR);
      gl.uniform1f(this.program['u_alpha_test'], this.layer.options['alphaTest'] || 0);
      var {
        glBuffer: glBuffer
      } = image;
      if (glBuffer && (glBuffer.width !== w || glBuffer.height !== h)) {
        this.saveImageBuffer(glBuffer);
        delete image.glBuffer;
      }
      if (!image.glBuffer) {
        image.glBuffer = this.bufferTileData(0, 0, w, h);
      } else {
        gl.bindBuffer(gl.ARRAY_BUFFER, glBuffer);
      }
      v2[0] = 'a_position';
      v2[1] = 2;
      v2[2] = image.glBuffer.type;
      this.enableVertexAttrib(v2);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
      v2[0] = 'a_texCoord';
      v2[1] = 2;
      v2[2] = 'UNSIGNED_BYTE';
      this.enableVertexAttrib(v2);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (debugInfo) {
        this.drawDebug(uMatrix, 0, 0, w, h, debugInfo);
      }
    };
    _proto.drawDebug = function drawDebug(uMatrix, x, y, w, h, debugInfo) {
      var gl = this.gl;
      gl.disable(gl.DEPTH_TEST);
      gl.bindBuffer(gl.ARRAY_BUFFER, this._debugBuffer);
      this.enableVertexAttrib(['a_position', 2, 'FLOAT']);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([x, y, x + w, y, x + w, y - h, x, y - h, x, y]), gl.DYNAMIC_DRAW);
      gl.uniformMatrix4fv(this.program['u_matrix'], false, uMatrix);
      gl.uniform1f(this.program['u_opacity'], 1);
      gl.uniform1f(this.program['u_debug_line'], 1);
      gl.uniform4fv(this.program['u_base_color'], DEFAULT_BASE_COLOR);
      gl.uniform1f(this.program['u_alpha_test'], this.layer.options['alphaTest'] || 0);
      gl.drawArrays(gl.LINE_STRIP, 0, 5);
      var canvas = this._debugInfoCanvas;
      if (!canvas) {
        var dpr = this.mapDPR || this.getMap().getDevicePixelRatio() > 1 ? 2 : 1;
        canvas = this._debugInfoCanvas = document.createElement('canvas');
        canvas.width = 256 * dpr;
        canvas.height = 32 * dpr;
        var _ctx = canvas.getContext('2d');
        _ctx.font = '20px monospace';
        _ctx.scale(dpr, dpr);
      }
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var color = this.layer.options['debugOutline'];
      Canvas.fillText(ctx, debugInfo, DEBUG_POINT, color);
      this.loadTexture(canvas);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
      w = 256;
      var x1 = x;
      var x2 = x + w;
      var y1 = y - h + 32;
      var y2 = y - h;
      gl.bufferData(gl.ARRAY_BUFFER, this.set8(x1, y1, x1, y2, x2, y1, x2, y2), gl.DYNAMIC_DRAW);
      gl.uniform1f(this.program['u_debug_line'], 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
      this.enableVertexAttrib(['a_texCoord', 2, 'UNSIGNED_BYTE']);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      gl.enable(gl.DEPTH_TEST);
    };
    _proto.bufferTileData = function bufferTileData(x, y, w, h, buffer) {
      var x1 = x;
      var x2 = x + w;
      var y1 = y;
      var y2 = y - h;
      var data;
      if (isInteger(x1) && isInteger(x2) && isInteger(y1) && isInteger(y2)) {
        data = this.set8Int(x1, y1, x1, y2, x2, y1, x2, y2);
      } else {
        data = this.set8(x1, y1, x1, y2, x2, y1, x2, y2);
      }
      var glBuffer = this.loadImageBuffer(data, buffer);
      glBuffer.width = w;
      glBuffer.height = h;
      glBuffer.type = data instanceof Int16Array ? 'SHORT' : 'FLOAT';
      return glBuffer;
    };
    _proto.createCanvas2 = function createCanvas2() {
      this.canvas2 = Canvas.createCanvas(this.canvas.width, this.canvas.height);
    };
    _proto.createGLContext = function createGLContext$1() {
      if (this.canvas.gl && this.canvas.gl.wrap) {
        this.gl = this.canvas.gl.wrap();
      } else {
        this.gl = createGLContext(this.canvas2 || this.canvas, this.layer.options['glOptions']);
      }
      var gl = this.gl;
      gl.clearColor(0.0, 0.0, 0.0, 0.0);
      gl.enable(gl.DEPTH_TEST);
      gl.enable(gl.STENCIL_TEST);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      this.program = this.createProgram(shaders['vertexShader'], this.layer.options['fragmentShader'] || shaders['fragmentShader']);
      this._debugBuffer = this.createBuffer();
      this.useProgram(this.program);
      this.texBuffer = this.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
      this.enableVertexAttrib(['a_texCoord', 2, 'UNSIGNED_BYTE']);
      gl.bufferData(gl.ARRAY_BUFFER, new Uint8Array([0.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
      this.enableSampler('u_image');
      gl.activeTexture(gl['TEXTURE0']);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
    };
    _proto.resizeGLCanvas = function resizeGLCanvas() {
      if (this.gl) {
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
      }
      if (!this.canvas2) {
        return;
      }
      if (this.canvas2.width !== this.canvas.width || this.canvas2.height !== this.canvas.height) {
        this.canvas2.width = this.canvas.width;
        this.canvas2.height = this.canvas.height;
      }
    };
    _proto.clearGLCanvas = function clearGLCanvas() {
      if (this.gl) {
        this.gl.clearStencil(0xFF);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.STENCIL_BUFFER_BIT);
      }
      if (!this.gl.wrap) {
        this.gl.clear(this.gl.DEPTH_BUFFER_BIT);
      }
    };
    _proto.disposeImage = function disposeImage(image) {
      if (!image) {
        return;
      }
      if (image.texture) {
        this.saveTexture(image.texture);
      }
      if (image.glBuffer) {
        this.saveImageBuffer(image.glBuffer);
      }
      delete image.texture;
      delete image.glBuffer;
    };
    _proto._createTexture = function _createTexture(image) {
      var gl = this.gl;
      var texture = this.getTexture() || gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      var genMipmap = this.layer.options['mipmapTexture'];
      if (genMipmap && (!isPowerOfTwo(image.width) || !isPowerOfTwo(image.height))) {
        image = resize(image);
      }
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
      if (genMipmap) {
        gl.generateMipmap(gl.TEXTURE_2D);
      }
      return texture;
    };
    _proto.getTexture = function getTexture() {
      if (!this._textures) {
        this._textures = [];
      }
      var textures = this._textures;
      return textures && textures.length > 0 ? textures.pop() : null;
    };
    _proto.saveTexture = function saveTexture(texture) {
      this._textures.push(texture);
    };
    _proto.loadTexture = function loadTexture(image, resized = false) {
      var gl = this.gl;
      var texture = image.texture;
      if (!texture) {
        texture = this._createTexture(image);
        image.texture = texture;
      }
      gl.bindTexture(gl.TEXTURE_2D, texture);
      var genMipmap = this.layer.options['mipmapTexture'];
      if (genMipmap) {
        var map = this.getMap();
        var dpr = this.mapDPR || map.getDevicePixelRatio();
        if (map.isMoving() && map.getRenderer().isViewChanged()) {
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        } else {
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
        if (dpr !== 1 || resized) {
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        } else {
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        }
      }
      return texture;
    };
    _proto.getImageBuffer = function getImageBuffer() {
      if (!this._imageBuffers) {
        this._imageBuffers = [];
      }
      var imageBuffers = this._imageBuffers;
      return imageBuffers && imageBuffers.length > 0 ? imageBuffers.pop() : null;
    };
    _proto.saveImageBuffer = function saveImageBuffer(buffer) {
      if (!this._imageBuffers) {
        this._imageBuffers = [];
      }
      this._imageBuffers.push(buffer);
    };
    _proto.loadImageBuffer = function loadImageBuffer(data, glBuffer) {
      var gl = this.gl;
      var buffer = glBuffer || this.createImageBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
      return buffer;
    };
    _proto.createImageBuffer = function createImageBuffer() {
      return this.getImageBuffer() || this.createBuffer();
    };
    _proto.removeGLCanvas = function removeGLCanvas() {
      var gl = this.gl;
      if (!gl) {
        return;
      }
      if (this._debugBuffer) {
        gl.deleteBuffer(this._debugBuffer);
        delete this._debugBuffer;
      }
      if (this._buffers) {
        this._buffers.forEach(function (b) {
          gl.deleteBuffer(b);
        });
        delete this._buffers;
      }
      if (this._textures) {
        this._textures.forEach(function (t) {
          return gl.deleteTexture(t);
        });
        delete this._textures;
      }
      if (this._debugInfoCanvas) {
        var texture = this._debugInfoCanvas.texture;
        if (texture) {
          gl.deleteTexture(texture);
        }
        delete this._debugInfoCanvas.texture;
        delete this._debugInfoCanvas;
      }
      var program = gl.program;
      gl.deleteShader(program.fragmentShader);
      gl.deleteShader(program.vertexShader);
      gl.deleteProgram(program);
      delete this.gl;
      delete this.canvas2;
    };
    _proto.createBuffer = function createBuffer() {
      var gl = this.gl;
      var buffer = gl.createBuffer();
      if (!buffer) {
        throw new Error('Failed to create the buffer object');
      }
      if (!this._buffers) {
        this._buffers = [];
      }
      this._buffers.push(buffer);
      return buffer;
    };
    _proto.enableVertexAttrib = function enableVertexAttrib$1(attributes) {
      enableVertexAttrib(this.gl, this.gl.program, attributes);
    };
    _proto.createProgram = function createProgram$1(vert, frag) {
      var gl = this.gl;
      var {
        program: program,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
      } = createProgram(gl, vert, frag);
      var numUniforms = gl.getProgramParameter(program, 0x8B86);
      var activeUniforms = [];
      for (var i = 0; i < numUniforms; ++i) {
        var info = gl.getActiveUniform(program, i);
        activeUniforms.push(info.name);
      }
      program.vertexShader = vertexShader;
      program.fragmentShader = fragmentShader;
      this._initUniforms(program, activeUniforms);
      return program;
    };
    _proto.useProgram = function useProgram(program) {
      var gl = this.gl;
      gl.useProgram(program);
      gl.program = program;
      return this;
    };
    _proto.enableSampler = function enableSampler(sampler, texIdx) {
      var gl = this.gl;
      var uSampler = this._getUniform(gl.program, sampler);
      if (!texIdx) {
        texIdx = 0;
      }
      gl.uniform1i(uSampler, texIdx);
      return uSampler;
    };
    _proto._initUniforms = function _initUniforms(program, uniforms) {
      for (var i = 0; i < uniforms.length; i++) {
        var name = uniforms[i];
        var uniform = uniforms[i];
        var b = name.indexOf('[');
        if (b >= 0) {
          name = name.substring(0, b);
          if (!IS_NODE) {
            uniform = uniform.substring(0, b);
          }
        }
        program[name] = this._getUniform(program, uniform);
      }
    };
    _proto._getUniform = function _getUniform(program, uniformName) {
      var gl = this.gl;
      var uniform = gl.getUniformLocation(program, uniformName);
      if (!uniform) {
        throw new Error('Failed to get the storage location of ' + uniformName);
      }
      return uniform;
    };
    _proto.set8 = function set8(a0, a1, a2, a3, a4, a5, a6, a7) {
      var out = TEMP_FLOAT32ARRAY;
      out[0] = a0;
      out[1] = a1;
      out[2] = a2;
      out[3] = a3;
      out[4] = a4;
      out[5] = a5;
      out[6] = a6;
      out[7] = a7;
      return out;
    };
    _proto.set8Int = function set8Int(a0, a1, a2, a3, a4, a5, a6, a7) {
      var out = TEMP_INT16ARRAY;
      out[0] = a0;
      out[1] = a1;
      out[2] = a2;
      out[3] = a3;
      out[4] = a4;
      out[5] = a5;
      out[6] = a6;
      out[7] = a7;
      return out;
    };
    return renderable;
  }(Base);
  return renderable;
};
function resize(image) {
  if (isPowerOfTwo(image.width) && isPowerOfTwo(image.height)) {
    return image;
  }
  var width = image.width;
  var height = image.height;
  if (!isPowerOfTwo(width)) {
    width = ceilPowerOfTwo(width);
  }
  if (!isPowerOfTwo(height)) {
    height = ceilPowerOfTwo(height);
  }
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(image, 0, 0, width, height);
  return canvas;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}

var CanvasRenderer$1 = function (_LayerAbstractRendere) {
  function CanvasRenderer() {
    return _LayerAbstractRendere.apply(this, arguments) || this;
  }
  _inheritsLoose(CanvasRenderer, _LayerAbstractRendere);
  var _proto = CanvasRenderer.prototype;
  _proto.needToRedraw = function needToRedraw() {
    var map = this.getMap();
    if (map.isInteracting() || map.getRenderer().isViewChanged()) {
      return !(!map.getPitch() && map.isMoving() && !map.isZooming() && !map.isRotating() && !this.layer.options['forceRenderOnMoving']);
    }
    return false;
  };
  _proto.createContext = function createContext() {
    if (this.gl && this.gl.canvas === this.canvas || this.context) {
      return;
    }
    this.context = Canvas.getCanvas2DPerformanceContext(this.canvas);
    if (!this.context) {
      return;
    }
    this.context.dpr = 1;
    if (this.layer.options['globalCompositeOperation']) {
      this.context.globalCompositeOperation = this.layer.options['globalCompositeOperation'];
    }
    var dpr = this.getMap().getDevicePixelRatio();
    if (dpr !== 1) {
      this._canvasContextScale(this.context, dpr);
    }
  };
  _proto.resetCanvasTransform = function resetCanvasTransform() {
    if (!this.context) {
      return;
    }
    var dpr = this.getMap().getDevicePixelRatio();
    this.context.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  _proto.clearCanvas = function clearCanvas() {
    if (!this.context) {
      return;
    }
    var map = this.getMap();
    if (!map) {
      return;
    }
    var r = this.mapDPR || map.getDevicePixelRatio();
    var rScale = 1 / r;
    var w = this.canvas.width * rScale,
      h = this.canvas.height * rScale;
    Canvas.clearRect(this.context, 0, 0, Math.max(w, this.canvas.width), Math.max(h, this.canvas.height));
  };
  _proto.clear = function clear() {
    this.clearCanvas();
    this.setToRedraw();
  };
  _proto.prepareCanvas = function prepareCanvas() {
    if (!this.canvas) {
      this.createCanvas();
      this.createContext();
      this.layer.onCanvasCreate();
      this.layer.fire('canvascreate', {
        'context': this.context,
        'gl': this.gl
      });
    } else {
      this.resetCanvasTransform();
      this.clearCanvas();
      this.resizeCanvas();
    }
    delete this._maskExtent;
    var mask = this.layer.getMask();
    if (!mask) {
      this.layer.fire('renderstart', {
        'context': this.context,
        'gl': this.gl
      });
      return null;
    }
    var maskExtent2D = this._maskExtent = mask._getMaskPainter().get2DExtent();
    if (maskExtent2D && this._extent2D && !maskExtent2D.intersects(this._extent2D)) {
      this.layer.fire('renderstart', {
        'context': this.context,
        'gl': this.gl
      });
      return maskExtent2D;
    }
    this.layer.fire('renderstart', {
      'context': this.context,
      'gl': this.gl
    });
    return maskExtent2D;
  };
  _proto.onResize = function onResize(_param) {
    delete this._extent2D;
    this.resizeCanvas();
    this.setToRedraw();
  };
  return CanvasRenderer;
}(LayerAbstractRenderer);

var options$4 = {
  renderer: Browser$1.webgl ? 'gl' : 'canvas',
  crossOrigin: null,
  alphaTest: false,
  depthMask: true,
  depthFunc: '<='
};
var TEMP_POINT$2 = new Point(0, 0);
var ImageLayer = function (_Layer) {
  function ImageLayer(id, images, options) {
    var _this;
    if (images && !Array.isArray(images) && !images.url) {
      options = images;
      images = null;
    }
    _this = _Layer.call(this, id, options) || this;
    _this._images = images;
    return _this;
  }
  _inheritsLoose(ImageLayer, _Layer);
  var _proto = ImageLayer.prototype;
  _proto.onAdd = function onAdd() {
    this._prepareImages(this._images);
  };
  _proto.setImages = function setImages(images) {
    this._images = images;
    this._prepareImages(images);
    return this;
  };
  _proto.getImages = function getImages() {
    return this._images;
  };
  _proto._prepareImages = function _prepareImages(images) {
    images = images || [];
    if (!Array.isArray(images)) {
      images = [images];
    }
    var map = this.getMap();
    var glRes = map.getGLRes();
    this._imageData = images.map(function (img) {
      var extent = new Extent(img.extent);
      return extend$2({}, img, {
        extent: extent,
        extent2d: extent.convertTo(function (c) {
          return map.coordToPointAtRes(c, glRes);
        })
      });
    });
    this._images = images;
    var renderer = this.getRenderer();
    if (renderer) {
      renderer.refreshImages();
    }
  };
  _proto.getRenderer = function getRenderer() {
    return _Layer.prototype.getRenderer.call(this);
  };
  return ImageLayer;
}(Layer);
ImageLayer.mergeOptions(options$4);
var EMPTY_ARRAY$1 = [];
var ImageLayerRenderable = function ImageLayerRenderable(Base) {
  var renderable = function (_Base) {
    function renderable() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(renderable, _Base);
    var _proto2 = renderable.prototype;
    _proto2.isDrawable = function isDrawable() {
      return true;
    };
    _proto2.checkResources = function checkResources() {
      var _this2 = this;
      if (this._imageLoaded) {
        return EMPTY_ARRAY$1;
      }
      var layer = this.layer;
      var urls = layer._imageData.map(function (img) {
        return [img.url, null, null];
      });
      if (this.resources) {
        var unloaded = [];
        var resources = getResouceCacheInstance();
        urls.forEach(function (url) {
          if (_this2.resources.isResourceLoaded(url)) {
            var img = _this2.resources.getImage(url);
            resources.addResource(url, img);
          } else {
            unloaded.push(url);
          }
        });
        this.resources.forEach(function (url, res) {
          if (!resources.isResourceLoaded(url)) {
            _this2.retireImage(res.image);
          }
        });
        this.resources = resources;
        urls = unloaded;
      }
      this._imageLoaded = true;
      return urls;
    };
    _proto2.retireImage = function retireImage(image) {
      var img = image;
      if (img.close) {
        img.close();
      }
    };
    _proto2.refreshImages = function refreshImages() {
      this._imageLoaded = false;
      this.setToRedraw();
    };
    _proto2.draw = function draw(timestamp, context) {
      if (!this.isDrawable()) {
        return;
      }
      this.prepareCanvas();
      this._painted = false;
      this.drawImages(timestamp, context);
      this.completeRender();
    };
    _proto2.drawImage = function drawImage(image, extent, opacity) {};
    _proto2.drawImages = function drawImages(timestamp, context) {
      var imgData = this.layer._imageData;
      var map = this.getMap();
      var mapExtent = map.get2DExtentAtRes(map.getGLRes());
      if (imgData && imgData.length) {
        for (var i = 0; i < imgData.length; i++) {
          var extent = imgData[i].extent2d;
          var image = this.resources && this.resources.getImage(imgData[i].url);
          if (image && mapExtent.intersects(extent)) {
            this._painted = true;
            var opacity = imgData[i].opacity;
            if (!isNumber(opacity)) {
              opacity = 1;
            }
            this.drawImage(image, extent, opacity);
          }
        }
      }
    };
    _proto2.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
      this.draw();
    };
    return renderable;
  }(Base);
  return renderable;
};
var ImageLayerCanvasRenderer = function (_ImageLayerRenderable) {
  function ImageLayerCanvasRenderer() {
    return _ImageLayerRenderable.apply(this, arguments) || this;
  }
  _inheritsLoose(ImageLayerCanvasRenderer, _ImageLayerRenderable);
  var _proto3 = ImageLayerCanvasRenderer.prototype;
  _proto3.isDrawable = function isDrawable() {
    if (this.getMap().getPitch()) {
      if (console) {
        console.warn('ImageLayer with canvas renderer can\'t be pitched, use gl renderer (\'renderer\' : \'gl\') instead.');
      }
      return false;
    }
    return true;
  };
  _proto3.drawImage = function drawImage(image, extent, opacity) {
    var globalAlpha = 0;
    var ctx = this.context;
    if (opacity < 1) {
      globalAlpha = ctx.globalAlpha;
      ctx.globalAlpha = opacity;
    }
    var map = this.getMap();
    var nw = TEMP_POINT$2.set(extent.xmin, extent.ymax);
    var point = map._pointAtResToContainerPoint(nw, map.getGLRes());
    var x = point.x,
      y = point.y;
    var cache = MapStateCache[map.id];
    var bearing = cache ? cache.bearing : map.getBearing();
    if (bearing) {
      ctx.save();
      ctx.translate(x, y);
      if (bearing) {
        ctx.rotate(-bearing * Math.PI / 180);
      }
      x = y = 0;
    }
    var scale = map.getGLScale();
    ctx.drawImage(image, x, y, extent.getWidth() / scale, extent.getHeight() / scale);
    if (bearing) {
      ctx.restore();
    }
    if (globalAlpha) {
      ctx.globalAlpha = globalAlpha;
    }
  };
  return ImageLayerCanvasRenderer;
}(ImageLayerRenderable(CanvasRenderer$1));
var ImageLayerGLRenderer = function (_ImageGLRenderable) {
  function ImageLayerGLRenderer() {
    return _ImageGLRenderable.apply(this, arguments) || this;
  }
  _inheritsLoose(ImageLayerGLRenderer, _ImageGLRenderable);
  var _proto4 = ImageLayerGLRenderer.prototype;
  _proto4.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
    this.draw(timestamp, context);
  };
  _proto4._prepareGLContext = function _prepareGLContext() {
    var gl = this.gl;
    if (gl) {
      gl.disable(gl.STENCIL_TEST);
      gl.disable(gl.POLYGON_OFFSET_FILL);
      gl.enable(gl.DEPTH_TEST);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.depthFunc(getDepthFunc(this.layer.options['depthFunc']));
      var depthMask = !!this.layer.options['depthMask'];
      gl.depthMask(depthMask);
    }
  };
  _proto4.drawImages = function drawImages(timestamp, parentContext) {
    var gl = this.gl;
    if (parentContext && parentContext.renderTarget) {
      var fbo = parentContext.renderTarget.fbo;
      if (fbo) {
        var framebuffer = parentContext.renderTarget.getFramebuffer(fbo);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      }
    }
    this._prepareGLContext();
    _ImageGLRenderable.prototype.drawImages.call(this);
    if (parentContext && parentContext.renderTarget) {
      var _fbo = parentContext.renderTarget.fbo;
      if (_fbo) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      }
    }
  };
  _proto4.isDrawable = function isDrawable() {
    return true;
  };
  _proto4.drawImage = function drawImage(image, extent, opacity) {
    var width = extent.getWidth();
    this.drawGLImage(image, extent.xmin, extent.ymax, width, extent.getHeight(), 1, opacity, image.width !== width);
  };
  _proto4.createContext = function createContext() {
    this.createGLContext();
  };
  _proto4.resizeCanvas = function resizeCanvas(canvasSize) {
    if (!this.canvas) {
      return;
    }
    _ImageGLRenderable.prototype.resizeCanvas.call(this, canvasSize);
    this.resizeGLCanvas();
  };
  _proto4.clearCanvas = function clearCanvas() {
    if (!this.canvas) {
      return;
    }
    _ImageGLRenderable.prototype.clearCanvas.call(this);
    this.clearGLCanvas();
  };
  _proto4.retireImage = function retireImage(image) {
    var img = image;
    if (img.close) {
      img.close();
    }
    this.disposeImage(image);
  };
  _proto4.onRemove = function onRemove() {
    this.removeGLCanvas();
    _ImageGLRenderable.prototype.onRemove.call(this);
  };
  return ImageLayerGLRenderer;
}(ImageGLRenderable(ImageLayerCanvasRenderer));
ImageLayer.registerRenderer('canvas', ImageLayerCanvasRenderer);
ImageLayer.registerRenderer('gl', ImageLayerGLRenderer);
var depthFuncEnum;
(function (depthFuncEnum) {
  depthFuncEnum[depthFuncEnum["never"] = 0] = "never";
  depthFuncEnum[depthFuncEnum["<"] = 1] = "<";
  depthFuncEnum[depthFuncEnum["="] = 2] = "=";
  depthFuncEnum[depthFuncEnum["<="] = 3] = "<=";
  depthFuncEnum[depthFuncEnum[" >"] = 4] = " >";
  depthFuncEnum[depthFuncEnum["!="] = 5] = "!=";
  depthFuncEnum[depthFuncEnum[">="] = 6] = ">=";
  depthFuncEnum[depthFuncEnum["always"] = 7] = "always";
})(depthFuncEnum || (depthFuncEnum = {}));

var TEMP_EXTENT$1 = new PointExtent();
var options$3 = {
  'debug': false,
  'enableSimplify': true,
  'defaultIconSize': [20, 20],
  'cacheVectorOnCanvas': true,
  'cacheSvgOnCanvas': Browser$1.gecko,
  'enableAltitude': true,
  'altitudeProperty': 'altitude',
  'drawAltitude': false,
  'sortByDistanceToCamera': false,
  'roundPoint': false,
  'altitude': 0,
  'clipBBoxBufferSize': 3,
  'collision': false,
  'collisionBufferSize': 2,
  'collisionDelay': 250,
  'collisionScope': 'layer',
  'progressiveRender': false,
  'progressiveRenderCount': 1000,
  'progressiveRenderDebug': false
};
var VectorLayer = function (_OverlayLayer) {
  function VectorLayer(id, geometries, options) {
    var _this;
    _this = _OverlayLayer.call(this, id, geometries, options) || this;
    _this.isVectorLayer = true;
    return _this;
  }
  _inheritsLoose(VectorLayer, _OverlayLayer);
  var _proto = VectorLayer.prototype;
  _proto.onConfig = function onConfig(conf) {
    _OverlayLayer.prototype.onConfig.call(this, conf);
    if (!isNil(conf['enableAltitude'])) {
      var geos = this.getGeometries() || [];
      for (var i = 0, len = geos.length; i < len; i++) {
        var geo = geos[i];
        if (geo) {
          geo._clearAltitudeCache();
          geo.fire('positionchange');
        }
      }
    }
    if (conf['enableAltitude'] || conf['drawAltitude'] || conf['altitudeProperty']) {
      var renderer = this.getRenderer();
      if (renderer && renderer.setToRedraw) {
        renderer.setToRedraw();
      }
    }
  };
  _proto.identify = function identify(coordinate, options) {
    options = options || {};
    var renderer = this.getRenderer();
    if (!(coordinate instanceof Coordinate)) {
      coordinate = new Coordinate(coordinate);
    }
    var cp = this.getMap().coordToContainerPoint(coordinate);
    if (options['onlyVisible'] && renderer && renderer.identifyAtPoint) {
      return renderer.identifyAtPoint(cp, options);
    }
    return this._hitGeos(this._geoList, cp, options);
  };
  _proto.identifyAtPoint = function identifyAtPoint(point, options) {
    options = options || {};
    var renderer = this.getRenderer();
    if (!(point instanceof Point)) {
      point = new Point(point);
    }
    if (options['onlyVisible'] && renderer && renderer.identifyAtPoint) {
      return renderer.identifyAtPoint(point, options);
    }
    return this._hitGeos(this._geoList, point, options);
  };
  _proto._hitGeos = function _hitGeos(geometries, cp, options = {}) {
    if (!geometries || !geometries.length) {
      return [];
    }
    var filterGeos = [];
    var idx = 0;
    for (var i = 0, len = geometries.length; i < len; i++) {
      var geo = geometries[i];
      if (geo.isPoint && geo._collided === true) {
        continue;
      }
      filterGeos[idx] = geo;
      idx++;
    }
    geometries = filterGeos;
    var filter = options['filter'],
      hits = [];
    var tolerance = options['tolerance'];
    var map = this.getMap();
    var renderer = this.getRenderer();
    var imageData = renderer && renderer.getImageData && renderer.getImageData();
    if (imageData) {
      var hitTolerance = 0;
      var maxTolerance = renderer.maxTolerance;
      if (isNumber(maxTolerance)) {
        hitTolerance = maxTolerance;
      } else {
        for (var _i = geometries.length - 1; _i >= 0; _i--) {
          var t = geometries[_i]._hitTestTolerance() + (tolerance || 0);
          if (t > hitTolerance) {
            hitTolerance = t;
          }
        }
      }
      var r = map.getDevicePixelRatio();
      imageData.r = r;
      var hit = false;
      var cpx = cp.x - hitTolerance;
      var cpy = cp.y - hitTolerance;
      for (var _i2 = -hitTolerance; _i2 <= hitTolerance; _i2++) {
        for (var j = -hitTolerance; j <= hitTolerance; j++) {
          var x = Math.round((cpx + _i2) * r),
            y = Math.round((cpy + j) * r);
          var _idx = y * imageData.width * 4 + x * 4;
          if (imageData.data[_idx + 3] > 0) {
            hit = true;
            break;
          }
        }
        if (hit) {
          break;
        }
      }
      if (!hit) {
        return hits;
      }
    }
    var onlyVisible = options.onlyVisible;
    for (var _i3 = geometries.length - 1; _i3 >= 0; _i3--) {
      var _geo = geometries[_i3];
      if (!_geo || !_geo.options['interactive']) {
        continue;
      }
      if (!onlyVisible && !_geo.isVisible()) {
        continue;
      }
      var painter = _geo._getPainter();
      if (!painter) {
        continue;
      }
      var bbox = painter.getRenderBBOX && painter.getRenderBBOX();
      if (bbox) {
        var {
          x: _x,
          y: _y
        } = cp;
        if (_x < bbox[0] || _y < bbox[1] || _x > bbox[2] || _y > bbox[3]) {
          continue;
        }
      }
      if (!(_geo instanceof LineString) || !_geo._getArrowStyle() && !(_geo instanceof Curve)) {
        var extent = _geo.getContainerExtent(TEMP_EXTENT$1);
        if (tolerance) {
          extent = extent._expand(tolerance);
        }
        if (!extent || !extent.contains(cp)) {
          continue;
        }
      }
      if (_geo._containsPoint(cp, tolerance) && (!filter || filter(_geo))) {
        hits.push(_geo);
        if (options['count']) {
          if (hits.length >= options['count']) {
            break;
          }
        }
      }
    }
    return hits;
  };
  _proto.getAltitude = function getAltitude() {
    return this.options['altitude'] || 0;
  };
  _proto.toJSON = function toJSON(options) {
    if (!options) {
      options = {
        'clipExtent': null,
        'geometries': null
      };
    }
    var profile = {
      'type': this.getJSONType(),
      'id': this.getId(),
      'options': this.config()
    };
    if (isNil(options['geometries']) || options['geometries']) {
      var clipExtent;
      if (options['clipExtent']) {
        var map = this.getMap();
        var projection = map ? map.getProjection() : null;
        clipExtent = new Extent(options['clipExtent'], projection);
      }
      var geoJSONs = [];
      var geometries = this.getGeometries();
      for (var i = 0, len = geometries.length; i < len; i++) {
        var geo = geometries[i];
        var geoExt = geo.getExtent();
        if (!geoExt || clipExtent && !clipExtent.intersects(geoExt)) {
          continue;
        }
        var json = geo.toJSON(options['geometries']);
        geoJSONs.push(json);
      }
      profile['geometries'] = geoJSONs;
    }
    return profile;
  };
  _proto.getRenderer = function getRenderer() {
    return _OverlayLayer.prototype.getRenderer.call(this);
  };
  VectorLayer.fromJSON = function fromJSON(json) {
    if (!json || json['type'] !== 'VectorLayer') {
      return null;
    }
    var layer = new VectorLayer(json['id'], json['options']);
    var geoJSONs = json['geometries'];
    var geometries = [];
    for (var i = 0; i < geoJSONs.length; i++) {
      var geo = Geometry.fromJSON(geoJSONs[i]);
      if (geo) {
        geometries.push(geo);
      }
    }
    layer.addGeometry(geometries);
    return layer;
  };
  VectorLayer.getPainterClass = function getPainterClass() {
    return Painter;
  };
  VectorLayer.getCollectionPainterClass = function getCollectionPainterClass() {
    return CollectionPainter;
  };
  return VectorLayer;
}(OverlayLayer);
VectorLayer.mergeOptions(options$3);
VectorLayer.registerJSONType('VectorLayer');
DrawToolLayer.setLayerClass(VectorLayer, VectorLayer, VectorLayer);

var CanvasLayerRenderer = function (_CanvasRenderer) {
  function CanvasLayerRenderer() {
    return _CanvasRenderer.apply(this, arguments) || this;
  }
  _inheritsLoose(CanvasLayerRenderer, _CanvasRenderer);
  var _proto = CanvasLayerRenderer.prototype;
  _proto.getPrepareParams = function getPrepareParams() {
    return [];
  };
  _proto.getDrawParams = function getDrawParams() {
    return [];
  };
  _proto.onCanvasCreate = function onCanvasCreate() {
    if (this.canvas && this.layer.options['doubleBuffer']) {
      this.buffer = Canvas.createCanvas(this.canvas.width, this.canvas.height, this.getMap().CanvasClass);
    }
  };
  _proto.needToRedraw = function needToRedraw() {
    if (this.layer.options['animation']) {
      return true;
    }
    var map = this.getMap();
    if (map.isInteracting() && !this.layer.drawOnInteracting) {
      return false;
    }
    return _CanvasRenderer.prototype.needToRedraw.call(this);
  };
  _proto.draw = function draw(...args) {
    this.prepareCanvas();
    this.prepareDrawContext();
    this._drawLayer(...args);
  };
  _proto.drawOnInteracting = function drawOnInteracting(...args) {
    this._drawLayerOnInteracting(...args);
  };
  _proto.getCanvasImage = function getCanvasImage() {
    var canvasImg = _CanvasRenderer.prototype.getCanvasImage.call(this);
    if (canvasImg && canvasImg.image && this.layer.options['doubleBuffer']) {
      var canvas = canvasImg.image;
      if (this.buffer.width !== canvas.width || this.buffer.height !== canvas.height) {
        this.buffer.width = canvas.width;
        this.buffer.height = canvas.height;
      }
      var bufferContext = this.buffer.getContext('2d');
      var prevent = this.layer.doubleBuffer(bufferContext, this.context);
      if (prevent === undefined || prevent) {
        Canvas.image(bufferContext, canvas, 0, 0);
        canvasImg.image = this.buffer;
      }
    }
    return canvasImg;
  };
  _proto.remove = function remove() {
    delete this._drawContext;
    return _CanvasRenderer.prototype.remove.call(this);
  };
  _proto.onZoomStart = function onZoomStart(param) {
    this.layer.onZoomStart(param);
    _CanvasRenderer.prototype.onZoomStart.call(this, param);
  };
  _proto.onZooming = function onZooming(param) {
    this.layer.onZooming(param);
    _CanvasRenderer.prototype.onZooming.call(this, param);
  };
  _proto.onZoomEnd = function onZoomEnd(param) {
    this.layer.onZoomEnd(param);
    _CanvasRenderer.prototype.onZoomEnd.call(this, param);
  };
  _proto.onMoveStart = function onMoveStart(param) {
    this.layer.onMoveStart(param);
    _CanvasRenderer.prototype.onMoveStart.call(this, param);
  };
  _proto.onMoving = function onMoving(param) {
    this.layer.onMoving(param);
    _CanvasRenderer.prototype.onMoving.call(this, param);
  };
  _proto.onMoveEnd = function onMoveEnd(param) {
    this.layer.onMoveEnd(param);
    _CanvasRenderer.prototype.onMoveEnd.call(this, param);
  };
  _proto.onResize = function onResize(param) {
    this.layer.onResize(param);
    _CanvasRenderer.prototype.onResize.call(this, param);
  };
  _proto.prepareDrawContext = function prepareDrawContext() {
    if (!this._predrawed) {
      var params = ensureParams(this.getPrepareParams());
      this._drawContext = this.layer.prepareToDraw(this.context, ...params);
      if (!this._drawContext) {
        this._drawContext = [];
      }
      if (!Array.isArray(this._drawContext)) {
        this._drawContext = [this._drawContext];
      }
      this._predrawed = true;
    }
  };
  _proto._prepareDrawParams = function _prepareDrawParams() {
    if (!this.getMap()) {
      return null;
    }
    var view = this.getViewExtent();
    if (view['maskExtent'] && !view['extent'].intersects(view['maskExtent'])) {
      this.completeRender();
      return null;
    }
    var args = [this.context, view];
    var params = ensureParams(this.getDrawParams());
    return [...args, ...params, ...this._drawContext];
  };
  _proto._drawLayer = function _drawLayer(...args) {
    var params = this._prepareDrawParams();
    if (!params) {
      return;
    }
    this.layer.draw.apply(this.layer, params.concat(args));
    this.completeRender();
  };
  _proto._drawLayerOnInteracting = function _drawLayerOnInteracting(...args) {
    if (!this.layer.drawOnInteracting) {
      return;
    }
    var params = this._prepareDrawParams();
    if (!params) {
      return;
    }
    this.layer.drawOnInteracting(...params, ...args);
    this.completeRender();
  };
  return CanvasLayerRenderer;
}(CanvasRenderer$1);
function ensureParams(params) {
  if (!params) {
    params = [];
  }
  if (!Array.isArray(params)) {
    params = [params];
  }
  return params;
}

var options$2 = {
  'doubleBuffer': false,
  'animation': false
};
var CanvasLayer = function (_Layer) {
  function CanvasLayer() {
    return _Layer.apply(this, arguments) || this;
  }
  _inheritsLoose(CanvasLayer, _Layer);
  var _proto = CanvasLayer.prototype;
  _proto.isCanvasRender = function isCanvasRender() {
    return true;
  };
  _proto.prepareToDraw = function prepareToDraw() {};
  _proto.draw = function draw(...params) {};
  _proto.redraw = function redraw() {
    if (this._getRenderer()) {
      this._getRenderer().setToRedraw();
    }
    return this;
  };
  _proto.play = function play() {
    this.config('animation', true);
    return this;
  };
  _proto.pause = function pause() {
    this.config('animation', false);
    return this;
  };
  _proto.isPlaying = function isPlaying() {
    return this.options['animation'];
  };
  _proto.clearCanvas = function clearCanvas() {
    if (this._getRenderer()) {
      this._getRenderer().clearCanvas();
    }
    return this;
  };
  _proto.requestMapToRender = function requestMapToRender() {
    var renderer = this._getRenderer();
    if (renderer && renderer.requestMapToRender) {
      renderer.requestMapToRender();
    }
    return this;
  };
  _proto.completeRender = function completeRender() {
    if (this._getRenderer()) {
      this._getRenderer().completeRender();
    }
    return this;
  };
  _proto.onCanvasCreate = function onCanvasCreate() {
    return this;
  };
  _proto.onZoomStart = function onZoomStart() {};
  _proto.onZooming = function onZooming() {};
  _proto.onZoomEnd = function onZoomEnd() {};
  _proto.onMoveStart = function onMoveStart() {};
  _proto.onMoving = function onMoving() {};
  _proto.onMoveEnd = function onMoveEnd() {};
  _proto.onResize = function onResize() {};
  _proto.doubleBuffer = function doubleBuffer(bufferContext) {
    bufferContext.clearRect(0, 0, bufferContext.canvas.width, bufferContext.canvas.height);
    return this;
  };
  _proto._getRenderer = function _getRenderer() {
    return _Layer.prototype._getRenderer.call(this);
  };
  return CanvasLayer;
}(Layer);
CanvasLayer.mergeOptions(options$2);
CanvasLayer.registerRenderer('canvas', CanvasLayerRenderer);

var TEMP_POINT$1 = new Point(0, 0);
var options$1 = {
  'animation': true
};
var ParticleLayer = function (_CanvasLayer) {
  function ParticleLayer() {
    return _CanvasLayer.apply(this, arguments) || this;
  }
  _inheritsLoose(ParticleLayer, _CanvasLayer);
  var _proto = ParticleLayer.prototype;
  _proto.getParticles = function getParticles(t) {};
  _proto.draw = function draw(context, view) {
    var points = this.getParticles(now());
    if (!points || points.length === 0) {
      var renderer = this._getRenderer();
      if (renderer) {
        this._getRenderer()._shouldClear = true;
      }
      return;
    }
    var map = this.getMap();
    var extent = view.extent;
    if (view.maskExtent) {
      extent = view.extent.intersection(view.maskExtent);
    }
    extent = extent.convertTo(function (c) {
      return map._pointToContainerPoint(c, undefined, 0, TEMP_POINT$1);
    });
    var e = 2 * Math.PI;
    for (var i = 0, l = points.length; i < l; i++) {
      var pos = points[i].point;
      if (extent.contains(pos)) {
        var color = points[i].color || this.options['lineColor'] || '#fff',
          r = points[i].r;
        if (context.fillStyle !== color) {
          context.fillStyle = color;
        }
        if (r <= 2) {
          context.fillRect(pos.x - r / 2, pos.y - r / 2, r, r);
        } else {
          context.beginPath();
          context.arc(pos.x, pos.y, r / 2, 0, e);
          context.fill();
        }
      }
    }
    this._fillCanvas(context);
  };
  _proto._fillCanvas = function _fillCanvas(context) {
    var g = context.globalCompositeOperation;
    context.globalCompositeOperation = 'destination-out';
    var trail = this.options['trail'] || 30;
    context.fillStyle = 'rgba(0, 0, 0, ' + 1 / trail + ')';
    context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    context.globalCompositeOperation = g;
  };
  return ParticleLayer;
}(CanvasLayer);
ParticleLayer.mergeOptions(options$1);
ParticleLayer.registerRenderer('canvas', function (_CanvasLayerRenderer) {
  function _class() {
    return _CanvasLayerRenderer.apply(this, arguments) || this;
  }
  _inheritsLoose(_class, _CanvasLayerRenderer);
  var _proto2 = _class.prototype;
  _proto2.draw = function draw() {
    if (!this.canvas || !this.layer.options['animation'] || this._shouldClear) {
      this.prepareCanvas();
      this._shouldClear = false;
    }
    this.prepareDrawContext();
    this._drawLayer();
  };
  _proto2.drawOnInteracting = function drawOnInteracting() {
    this.draw();
    this._shouldClear = false;
  };
  _proto2.onSkipDrawOnInteracting = function onSkipDrawOnInteracting() {
    this._shouldClear = true;
  };
  return _class;
}(CanvasLayerRenderer));

var resources = getResouceCacheInstance();
var prevX, prevY;
var EditHandle = function (_Eventable) {
  function EditHandle(target, map, options) {
    var _this;
    _this = _Eventable.call(this, options || {}) || this;
    _this.target = target;
    target.once('remove', _this["delete"], _this);
    var symbol = _this.options['symbol'];
    var lineWidth = symbol['markerLineWidth'] || 1;
    _this.w = symbol['markerWidth'] + lineWidth;
    _this.h = symbol['markerHeight'] + lineWidth;
    _this.opacity = isNil(symbol['opacity']) ? 1 : symbol['opacity'];
    _this.map = map;
    _this.events = options.events;
    _this._fetchImage();
    _this.addTo(map);
    return _this;
  }
  _inheritsLoose(EditHandle, _Eventable);
  var _proto = EditHandle.prototype;
  _proto.getCursor = function getCursor() {
    return this.options['cursor'] || 'default';
  };
  _proto._fetchImage = function _fetchImage() {
    var map = this.map;
    var symbol = this.options.symbol;
    var {
      markerFile: markerFile
    } = symbol;
    this.url = markerFile || getSymbolHash(symbol);
    var img = resources.getImage(this.url);
    if (!img) {
      var w = this.w;
      var h = this.h;
      if (markerFile) {
        img = new Image();
        img.onload = function () {
          var renderer = map.getRenderer();
          if (renderer) {
            renderer.setToRedraw();
          }
        };
        img.src = this.url;
      } else {
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        img = drawVectorMarker(ctx, {
          x: w / 2,
          y: h / 2
        }, symbol, resources);
      }
      resources.addResource([this.url, w, h], img);
    }
    resources.login(this.url);
    this._img = img;
  };
  _proto.setContainerPoint = function setContainerPoint(cp) {
    this._point = cp;
    this._point._sub(this.w / 2, this.h / 2);
  };
  _proto.getContainerPoint = function getContainerPoint() {
    return this._point.add(this.w / 2, this.h / 2);
  };
  _proto.offset = function offset(p) {
    this._point._add(p);
  };
  _proto.render = function render(ctx) {
    if (!this._img) {
      return false;
    }
    var symbol = this.options['symbol'];
    var dx = symbol['markerDx'] || 0;
    var dy = symbol['markerDy'] || 0;
    var map = this.map;
    var {
      x: x,
      y: y
    } = this._point;
    var w = this.w;
    var h = this.h;
    if (x + w > 0 && x < map.width && y + h > 0 && y < map.height) {
      var cache = MapStateCache[map.id];
      var dpr = cache ? cache.devicePixelRatio : map.getDevicePixelRatio();
      ctx.globalAlpha = this.opacity;
      ctx.drawImage(this._img, Math.round((x + dx) * dpr), Math.round((y + dy) * dpr), Math.round(w * dpr), Math.round(h * dpr));
      return true;
    }
    return false;
  };
  _proto["delete"] = function _delete() {
    if (this.map) {
      var renderer = this.map.getRenderer();
      if (renderer) {
        renderer.removeTopElement(this);
      }
    }
    resources.logout(this.url);
    if (this._dragger) {
      this._dragger.disable();
      delete this._dragger;
    }
    delete this.map;
  };
  _proto.hitTest = function hitTest(p) {
    var symbol = this.options['symbol'];
    var dx = symbol['markerDx'] || 0;
    var dy = symbol['markerDy'] || 0;
    var w = this.w;
    var h = this.h;
    var x = this._point.x + dx;
    var y = this._point.y + dy;
    return p.x >= x && p.x <= x + w && p.y >= y && p.y <= y + h;
  };
  _proto.addTo = function addTo(map) {
    this.map = map;
    var renderer = map.getRenderer();
    renderer.addTopElement(this);
  };
  _proto.onEvent = function onEvent(e) {
    this.fire(e.type, e);
  };
  _proto.mousedown = function mousedown(e) {
    var map = e.target;
    var cursor = this.options['cursor'];
    if (cursor) {
      map.setCursor(cursor);
    }
    this.onDragstart(e);
  };
  _proto.onDragstart = function onDragstart(e) {
    var {
      containerPoint: containerPoint,
      target: map
    } = e;
    var dom = map.getPanels().mapWrapper || map.getContainer();
    var dragHandler = this._dragger = new DragHandler(dom);
    dragHandler.on('dragging', this.onDragging, this).on('mouseup', this.onDragend, this).enable();
    dragHandler.onMouseDown(e['domEvent']);
    prevX = containerPoint.x;
    prevY = containerPoint.y;
    this.fire('dragstart', {
      containerPoint: containerPoint
    });
  };
  _proto.onDragging = function onDragging(e) {
    if (!this._dragger) {
      return;
    }
    var activeMap = this.map;
    var containerPoint = getEventContainerPoint(e.domEvent, activeMap.getContainer());
    var offset = {
      x: containerPoint.x - prevX,
      y: containerPoint.y - prevY
    };
    var prevCoord = activeMap.containerPointToCoord(new Point(prevX, prevY));
    var currentCoord = activeMap.containerPointToCoord(containerPoint);
    prevX = containerPoint.x;
    prevY = containerPoint.y;
    this.offset(offset);
    this.fire('dragging', {
      containerPoint: containerPoint,
      coordOffset: currentCoord._sub(prevCoord)
    });
  };
  _proto.onDragend = function onDragend(e) {
    if (!this._dragger) {
      return;
    }
    var map = this.map;
    map.resetCursor();
    var containerPoint = getEventContainerPoint(e.domEvent, map.getContainer());
    var offset = {
      x: containerPoint.x - prevX,
      y: containerPoint.y - prevY
    };
    this.offset(offset);
    this._dragger.disable();
    delete this._dragger;
    this.fire('dragend', {
      containerPoint: containerPoint
    });
  };
  _proto.needCollision = function needCollision() {
    var {
      target: target
    } = this;
    if (this.options.ignoreCollision) {
      return false;
    }
    return target && target.options && target.options.collision;
  };
  _proto.getRenderBBOX = function getRenderBBOX(dpr) {
    var {
      target: target,
      map: map
    } = this;
    if (!target || !target.options || !map) {
      return null;
    }
    var symbol = this.options['symbol'];
    var dx = symbol['markerDx'] || 0;
    var dy = symbol['markerDy'] || 0;
    var {
      x: x,
      y: y
    } = this._point;
    var w = this.w;
    var h = this.h;
    var cache = MapStateCache[map.id];
    dpr = dpr || cache ? cache.devicePixelRatio : map.getDevicePixelRatio();
    this.bbox = this.bbox || getDefaultBBOX();
    var x1 = Math.round((x + dx) * dpr);
    var y1 = Math.round((y + dy) * dpr);
    var width = Math.round(w * dpr);
    var height = Math.round(h * dpr);
    this.bbox[0] = x1;
    this.bbox[1] = y1;
    this.bbox[2] = x1 + width;
    this.bbox[3] = y1 + height;
    var {
      options: options
    } = target;
    var collisionBufferSize = options.collisionBufferSize || 0;
    bufferBBOX(this.bbox, collisionBufferSize);
    return this.bbox;
  };
  _proto.setZIndex = function setZIndex(zIndex) {
    this.options.zIndex = zIndex;
  };
  return EditHandle;
}(Eventable(Class));

var EditOutline = function () {
  function EditOutline(target, map, options) {
    this.target = target;
    target.once('remove', this["delete"], this);
    this.map = map;
    this.options = options || {};
    this.addTo(map);
  }
  var _proto = EditOutline.prototype;
  _proto.setPoints = function setPoints(points) {
    this.points = points;
    var allX = points.map(function (p) {
      return p.x;
    });
    var allY = points.map(function (p) {
      return p.y;
    });
    this.xmin = Math.min(...allX);
    this.xmax = Math.max(...allX);
    this.ymin = Math.min(...allY);
    this.ymax = Math.max(...allY);
  };
  _proto.hitTest = function hitTest() {
    return false;
  };
  _proto.render = function render(ctx) {
    var map = this.map;
    if (this.xmax <= 0 || this.xmin >= map.width || this.ymax <= 0 || this.ymin >= map.height) {
      return;
    }
    var cache = MapStateCache[map.id];
    var dpr = cache ? cache.devicePixelRatio : map.getDevicePixelRatio();
    var padding = 0.5;
    function c(v) {
      return Math.round(v) * dpr + padding;
    }
    ctx.lineWidth = 1;
    ctx.strokeStyle = '#000';
    ctx.globalAlpha = 1;
    ctx.beginPath();
    var points = this.points;
    ctx.moveTo(c(points[0].x), c(points[0].y));
    for (var i = 1; i < this.points.length; i++) {
      ctx.lineTo(c(points[i].x), c(points[i].y));
    }
    ctx.closePath();
    ctx.stroke();
  };
  _proto.addTo = function addTo(map) {
    this.map = map;
    var renderer = map.getRenderer();
    renderer.addTopElement(this);
  };
  _proto["delete"] = function _delete() {
    if (this.map) {
      var renderer = this.map.getRenderer();
      if (renderer) {
        renderer.removeTopElement(this);
      }
    }
  };
  return EditOutline;
}();

var EDIT_STAGE_LAYER_PREFIX = INTERNAL_LAYER_PREFIX + '_edit_stage_';
var SHADOW_DRAG_EVENTS = 'dragend dragstart';
function createHandleSymbol(markerType, opacity) {
  return {
    'markerType': markerType,
    'markerFill': '#fff',
    'markerLineColor': '#000',
    'markerLineWidth': 2,
    'markerWidth': 10,
    'markerHeight': 10,
    'opacity': opacity
  };
}
function coordinatesToContainerPoint(map, coordinate) {
  var glRes = map.getGLRes();
  var renderPoints = map.coordToPointAtRes(coordinate, glRes);
  var altitude = coordinate.z || 0;
  var point = map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
  return point;
}
function fixHandlePointCoordinates(geometry, vertex, dragContainerPoint, dragOnAxis) {
  var map = geometry.getMap();
  if (!vertex || vertex.z === 0) {
    var c = map.containerPointToCoord(dragContainerPoint);
    return calCoordByDragOnAxis(c, vertex, dragOnAxis);
  }
  var altitude = vertex.z;
  var glRes = map.getGLRes();
  var renderPoints = map.coordToPointAtRes(vertex, glRes);
  var point1 = map._pointAtResToContainerPoint(renderPoints, glRes, 0);
  var point2 = map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
  var offset = point2.sub(point1);
  var containerPoint = dragContainerPoint.sub(offset);
  var coordinates = map.containerPointToCoord(containerPoint);
  coordinates.z = 0;
  var isPoint = !geometry.getGeometries && geometry.isPoint;
  if (isPoint) {
    coordinates.z = altitude;
  }
  return calCoordByDragOnAxis(coordinates, vertex, dragOnAxis);
}
function onHandleDragstart(param) {
  var geometryEditor = this.target;
  var opts = this.paramOptions;
  geometryEditor._updating = true;
  if (opts.onDown) {
    opts.onDown.call(geometryEditor, param['containerPoint'], param);
    geometryEditor._geometry.fire('handledragstart');
  }
  return false;
}
function onHandleDragging(param) {
  var geometryEditor = this.target;
  var opts = this.paramOptions;
  geometryEditor._hideContext();
  if (opts.onMove) {
    opts.onMove.call(geometryEditor, param);
    geometryEditor._geometry.fire('handledragging');
  }
  return false;
}
function onHandleDragEnd(ev) {
  var geometryEditor = this.target;
  var opts = this.paramOptions;
  if (opts.onUp) {
    opts.onUp.call(geometryEditor, ev);
    geometryEditor._geometry.fire('handledragend');
  }
  geometryEditor._updating = false;
  return false;
}
function calCoordByDragOnAxis(currentCoord, preCoord, dragOnAxis) {
  if (!dragOnAxis || !preCoord) {
    return currentCoord;
  }
  var offset = currentCoord.sub(preCoord);
  offset = calCoordOffsetByDragOnAxis(offset, dragOnAxis);
  preCoord.x += offset.x;
  preCoord.y += offset.y;
  return preCoord.copy();
}
function calCoordOffsetByDragOnAxis(offset, dragOnAxis) {
  if (!dragOnAxis) {
    return offset;
  }
  if (dragOnAxis === 'x') {
    offset.y = 0;
  } else if (dragOnAxis === 'y') {
    offset.x = 0;
  }
  return offset;
}
var options = {
  'fixAspectRatio': false,
  'symbol': null,
  'removeVertexOn': 'contextmenu',
  'centerHandleSymbol': createHandleSymbol('ellipse', 1),
  'vertexHandleSymbol': createHandleSymbol('square', 1),
  'newVertexHandleSymbol': createHandleSymbol('square', 0.4),
  'collision': false,
  'collisionBufferSize': 0,
  'vertexZIndex': 0,
  'newVertexZIndex': 0,
  'shadowDraggable': false
};
var GeometryEditor = function (_Eventable) {
  function GeometryEditor(geometry, opts) {
    var _this;
    _this = _Eventable.call(this, opts) || this;
    _this._geometry = geometry;
    if (!_this._geometry) {
      return _assertThisInitialized(_this);
    }
    return _this;
  }
  _inheritsLoose(GeometryEditor, _Eventable);
  var _proto = GeometryEditor.prototype;
  _proto.getMap = function getMap() {
    return this._geometry.getMap();
  };
  _proto.prepare = function prepare() {
    var map = this.getMap();
    if (!map) {
      return;
    }
    map.on('drawtopstart', this._refresh, this);
    if (this.options['symbol']) {
      this._originalSymbol = this._geometry.getSymbol();
      this._geometry.setSymbol(this.options['symbol']);
    }
    this._prepareEditStageLayer();
  };
  _proto._prepareEditStageLayer = function _prepareEditStageLayer() {
    var layer = this._geometry.getLayer();
    if (layer.options['renderer'] !== 'canvas') {
      return;
    }
    var map = this.getMap();
    var uid = UID();
    var shadowId = EDIT_STAGE_LAYER_PREFIX + uid + '_shadow';
    this._shadowLayer = map.getLayer(shadowId);
    if (!this._shadowLayer) {
      var LayerType = layer.constructor;
      this._shadowLayer = new LayerType(shadowId);
      map.addLayer(this._shadowLayer);
    }
  };
  _proto.start = function start() {
    if (!this._geometry || !this._geometry.getMap() || this._geometry.editing) {
      return;
    }
    this.editing = true;
    this.prepare();
    var geometry = this._geometry;
    var shadow;
    var layer = this._geometry.getLayer();
    var needShadow = layer.options['renderer'] === 'canvas';
    this._geometryDraggble = geometry.options['draggable'];
    this._geometryDragOnAxis = geometry.options['dragOnAxis'];
    var dragOnAxis = this.options.dragOnAxis;
    if (needShadow) {
      geometry.config('draggable', false);
      shadow = geometry.copy();
      shadow.setSymbol(geometry._getInternalSymbol());
      shadow.copyEventListeners(geometry);
      if (geometry._getParent()) {
        shadow.copyEventListeners(geometry._getParent());
      }
      shadow._setEventTarget(geometry);
      shadow.setId(null).config({
        'draggable': this.options.shadowDraggable
      });
      this._shadow = shadow;
      shadow.config({
        dragOnAxis: dragOnAxis
      });
      geometry.hide();
    } else if (geometry instanceof Marker) {
      geometry.config('draggable', true);
      geometry.config({
        dragOnAxis: dragOnAxis
      });
    }
    this._switchGeometryEvents('on');
    if (geometry instanceof Marker || geometry instanceof Circle || geometry instanceof Rectangle || geometry instanceof Ellipse) {
      this._createOrRefreshOutline();
    }
    if (this._shadowLayer) {
      this._shadowLayer.bringToFront().addGeometry(shadow);
    }
    if (!(geometry instanceof Marker)) {
      this._createCenterHandle();
    } else if (shadow) {
      shadow.config('draggable', true);
      shadow.on('dragend', this._onMarkerDragEnd, this);
    }
    if (geometry instanceof Marker && this.options['resize'] !== false) {
      this.createMarkerEditor();
    } else if (geometry instanceof Circle) {
      this.createCircleEditor();
    } else if (geometry instanceof Rectangle) {
      this.createEllipseOrRectEditor();
    } else if (geometry instanceof Ellipse) {
      this.createEllipseOrRectEditor();
    } else if (geometry instanceof Sector) ; else if (geometry instanceof Polygon || geometry instanceof LineString) {
      this.createPolygonEditor();
    }
  };
  _proto.stop = function stop() {
    delete this._history;
    delete this._historyPointer;
    delete this._editOutline;
    this._switchGeometryEvents('off');
    var map = this.getMap();
    if (!map) {
      this.fire('remove');
      return;
    }
    map.off('drawtopstart', this._refresh, this);
    this._geometry.config('draggable', this._geometryDraggble);
    this._geometry.config('dragOnAxis', this._geometryDragOnAxis);
    if (this._shadow) {
      this._shadow.off(SHADOW_DRAG_EVENTS, this._shadowDragEvent, this);
      delete this._shadow;
      delete this._geometryDraggble;
      this._geometry.show();
    }
    if (this._shadowLayer) {
      this._shadowLayer.remove();
      delete this._shadowLayer;
    }
    this._refreshHooks = [];
    if (this.options['symbol']) {
      this._geometry.setSymbol(this._originalSymbol);
      delete this._originalSymbol;
    }
    this.editing = false;
    this.fire('remove');
  };
  _proto.isEditing = function isEditing() {
    if (isNil(this.editing)) {
      return false;
    }
    return this.editing;
  };
  _proto._getGeometryEvents = function _getGeometryEvents() {
    return {
      'symbolchange': this._onGeoSymbolChange,
      'dragstart': this._onDragStart,
      'dragend': this._onDragEnd,
      'positionchange shapechange': this._exeAndReset
    };
  };
  _proto._switchGeometryEvents = function _switchGeometryEvents(oper) {
    if (this._geometry) {
      var events = this._getGeometryEvents();
      for (var p in events) {
        this._geometry[oper](p, events[p], this);
      }
    }
  };
  _proto._onGeoSymbolChange = function _onGeoSymbolChange(param) {
    if (this._shadow) {
      this._shadow.setSymbol(param.target._getInternalSymbol());
    }
  };
  _proto._onMarkerDragEnd = function _onMarkerDragEnd() {
    this._update('setCoordinates', this._shadow.getCoordinates().toArray());
  };
  _proto._createOrRefreshOutline = function _createOrRefreshOutline() {
    var geometry = this._geometry;
    var outline = this._editOutline;
    if (!outline) {
      this._editOutline = new EditOutline(this, this.getMap());
      this._addRefreshHook(this._createOrRefreshOutline);
    }
    var points = this._editOutline.points;
    if (geometry instanceof Marker) {
      this._editOutline.setPoints(geometry.getContainerExtent().toArray(points));
    } else {
      var coordinates = geometry.getShell();
      var editCenter = geometry._getEditCenter();
      var bbox = getDefaultBBOX();
      pointsBBOX(coordinates, bbox);
      var extent = new Extent(bbox[0], bbox[1], bbox[2], bbox[3]);
      var map = this.getMap();
      var _points = extent.toArray().map(function (c) {
        c.z = editCenter.z;
        return coordinatesToContainerPoint(map, c);
      });
      this._editOutline.setPoints(_points);
    }
    return outline;
  };
  _proto._shadowDragEvent = function _shadowDragEvent(e) {
    var type = e.type;
    if (type === 'dragend') {
      this._updateCoordFromShadow();
    }
  };
  _proto._createCenterHandle = function _createCenterHandle() {
    var _this2 = this;
    var map = this.getMap();
    var symbol = this.options['centerHandleSymbol'];
    var shadow;
    if (this._shadow) {
      this._shadow.off(SHADOW_DRAG_EVENTS, this._shadowDragEvent, this);
    }
    if (this.options.shadowDraggable && this._shadow) {
      this._shadow.on(SHADOW_DRAG_EVENTS, this._shadowDragEvent, this);
    }
    var cointainerPoint = coordinatesToContainerPoint(map, this._geometry._getEditCenter());
    var handle = this.createHandle(cointainerPoint, {
      ignoreCollision: true,
      'symbol': symbol,
      'cursor': 'move',
      onDown: function onDown() {
        if (_this2._shadow) {
          shadow = _this2._shadow.copy();
          var _symbol = lowerSymbolOpacity(shadow._getInternalSymbol(), 0.5);
          shadow.setSymbol(_symbol).addTo(_this2._geometry.getLayer());
        }
      },
      onMove: function onMove(param) {
        var offset = param['coordOffset'];
        calCoordOffsetByDragOnAxis(offset, _this2.options.dragOnAxis);
        if (shadow) {
          shadow.translate(offset);
        } else {
          _this2._geometry.translate(offset);
        }
      },
      onUp: function onUp() {
        if (shadow) {
          var shadowFirst = shadow.getFirstCoordinate();
          var first = _this2._geometry.getFirstCoordinate();
          var offset = shadowFirst.sub(first);
          calCoordOffsetByDragOnAxis(offset, _this2.options.dragOnAxis);
          _this2._update('translate', offset);
          shadow.remove();
        }
      }
    });
    this._addRefreshHook(function () {
      var center = _this2._geometry._getEditCenter();
      handle.setContainerPoint(coordinatesToContainerPoint(map, center));
    });
  };
  _proto._createHandleInstance = function _createHandleInstance(containerPoint, opts) {
    opts = opts || {};
    var map = this.getMap();
    var symbol = loadFunctionTypes(opts['symbol'], function () {
      var cache = MapStateCache[map.id];
      var zoom = cache ? cache.zoom : map.getZoom();
      var pitch = cache ? cache.pitch : map.getPitch();
      var bearing = cache ? cache.bearing : map.getBearing();
      return [zoom, {
        '{bearing}': bearing,
        '{pitch}': pitch,
        '{zoom}': zoom
      }];
    });
    var removeVertexOn = this.options['removeVertexOn'];
    var handle = new EditHandle(this, map, {
      symbol: symbol,
      cursor: opts['cursor'],
      events: removeVertexOn,
      ignoreCollision: opts.ignoreCollision
    });
    handle.setContainerPoint(containerPoint);
    return handle;
  };
  _proto.createHandle = function createHandle(containerPoint, opts) {
    if (!opts) {
      opts = {};
    }
    var handle = this._createHandleInstance(containerPoint, opts);
    handle.paramOptions = opts;
    handle.on('dragstart', onHandleDragstart);
    handle.on('dragging', onHandleDragging);
    handle.on('dragend', onHandleDragEnd);
    if (opts.onRefresh) {
      handle.refresh = opts.onRefresh;
    }
    return handle;
  };
  _proto._createResizeHandles = function _createResizeHandles(blackList, onHandleMove, onHandleUp) {
    var _this3 = this;
    var cursors = ['nw-resize', 'n-resize', 'ne-resize', 'w-resize', 'e-resize', 'sw-resize', 's-resize', 'se-resize'];
    var axis = [null, 'y', null, 'x', 'x', null, 'y', null];
    var geometry = this._geometry;
    var isMarker = geometry instanceof Marker;
    var coords = [];
    function getResizeAnchors() {
      if (isMarker) {
        var ext = geometry.getContainerExtent();
        return [new Point(ext['xmin'], ext['ymin']), new Point((ext['xmax'] + ext['xmin']) / 2, ext['ymin']), new Point(ext['xmax'], ext['ymin']), new Point(ext['xmin'], (ext['ymin'] + ext['ymax']) / 2), new Point(ext['xmax'], (ext['ymin'] + ext['ymax']) / 2), new Point(ext['xmin'], ext['ymax']), new Point((ext['xmax'] + ext['xmin']) / 2, ext['ymax']), new Point(ext['xmax'], ext['ymax'])];
      }
      var coordinates = geometry.getShell();
      var editCenter = geometry._getEditCenter();
      var bbox = getDefaultBBOX();
      pointsBBOX(coordinates, bbox);
      var extent = new Extent(bbox[0], bbox[1], bbox[2], bbox[3]);
      coords = [new Coordinate(extent['xmin'], extent['ymax']), new Coordinate((extent['xmax'] + extent['xmin']) / 2, extent['ymax']), new Coordinate(extent['xmax'], extent['ymax']), new Coordinate(extent['xmin'], (extent['ymax'] + extent['ymin']) / 2), new Coordinate(extent['xmax'], (extent['ymax'] + extent['ymin']) / 2), new Coordinate(extent['xmin'], extent['ymin']), new Coordinate((extent['xmax'] + extent['xmin']) / 2, extent['ymin']), new Coordinate(extent['xmax'], extent['ymin'])];
      return coords.map(function (c) {
        c.z = editCenter.z;
        return coordinatesToContainerPoint(map, c);
      });
    }
    if (!blackList) {
      blackList = [];
    }
    var me = this;
    var resizeHandles = [],
      anchorIndexes = {},
      map = this.getMap(),
      handleSymbol = this.options['vertexHandleSymbol'];
    var fnLocateHandles = function fnLocateHandles() {
      var anchors = getResizeAnchors();
      var _loop = function _loop(i) {
        if (Array.isArray(blackList)) {
          var isBlack = blackList.some(function (ele) {
            return ele === i;
          });
          if (isBlack) {
            return 1;
          }
        }
        var anchor = anchors[i],
          point = anchor,
          coord = coords[i];
        if (resizeHandles.length < anchors.length - blackList.length) {
          var handle = _this3.createHandle(point, {
            'symbol': handleSymbol,
            'cursor': cursors[i],
            'axis': axis[i],
            onMove: function (_index) {
              return function (e) {
                me._updating = true;
                onHandleMove(e.containerPoint, _index);
                geometry.fire('resizing');
              };
            }(i),
            onUp: function onUp() {
              me._updating = false;
              onHandleUp();
            }
          });
          anchorIndexes[i] = resizeHandles.length;
          resizeHandles.push(handle);
          handle.coord = coord;
        } else {
          resizeHandles[anchorIndexes[i]].coord = coord;
          resizeHandles[anchorIndexes[i]].setContainerPoint(point);
        }
      };
      for (var i = 0; i < anchors.length; i++) {
        if (_loop(i)) continue;
      }
    };
    fnLocateHandles();
    this._addRefreshHook(fnLocateHandles);
    return resizeHandles;
  };
  _proto.createMarkerEditor = function createMarkerEditor() {
    var _this4 = this;
    var geometryToEdit = this._shadow || this._geometry,
      map = this.getMap();
    if (!geometryToEdit._canEdit()) {
      if (console) {
        console.warn('A marker can\'t be resized with symbol:', geometryToEdit.getSymbol());
      }
      return;
    }
    if (!this._history) {
      this._recordHistory(getUpdates());
    }
    var symbol = geometryToEdit._getInternalSymbol();
    var dxdy = new Point(0, 0);
    if (isNumber(symbol['markerDx'])) {
      dxdy.x = symbol['markerDx'];
    }
    if (isNumber(symbol['markerDy'])) {
      dxdy.y = symbol['markerDy'];
    }
    var blackList = null;
    var verticalAnchor = 'middle';
    var horizontalAnchor = 'middle';
    if (VectorMarkerSymbolizer.test(symbol)) {
      var type = symbol['markerType'];
      if (type === 'pin' || type === 'pie' || type === 'bar') {
        blackList = [5, 6, 7];
        verticalAnchor = 'bottom';
      } else if (type === 'rectangle') {
        blackList = [0, 1, 2, 3, 5];
        verticalAnchor = 'top';
        horizontalAnchor = 'left';
      }
    } else if (ImageMarkerSymbolizer.test(symbol) || VectorPathMarkerSymbolizer.test(symbol)) {
      verticalAnchor = 'bottom';
      blackList = [5, 6, 7];
    }
    var resizeAbilities = [2, 1, 2, 0, 0, 2, 1, 2];
    var aspectRatio;
    if (this.options['fixAspectRatio']) {
      var size = geometryToEdit.getSize();
      aspectRatio = size.width / size.height;
    }
    var resizeHandles = this._createResizeHandles(blackList, function (containerPoint, i) {
      if (blackList && blackList.indexOf(i) >= 0) {
        var newCoordinates = map.containerPointToCoordinate(containerPoint.sub(dxdy));
        var coordinates = geometryToEdit.getCoordinates();
        newCoordinates.x = coordinates.x;
        geometryToEdit.setCoordinates(newCoordinates);
        _this4._updateCoordFromShadow(true);
        var mirrorHandle = resizeHandles[resizeHandles.length - 1 - i];
        var mirror = mirrorHandle.getContainerPoint();
        containerPoint = mirror;
      }
      var viewCenter = coordinatesToContainerPoint(map, geometryToEdit._getEditCenter()).add(dxdy),
        symbol = geometryToEdit._getInternalSymbol();
      var wh = containerPoint.sub(viewCenter);
      if (verticalAnchor === 'bottom' && containerPoint.y > viewCenter.y) {
        wh.y = 0;
      }
      var vr = verticalAnchor === 'middle' ? 2 : 1;
      var hr = horizontalAnchor === 'left' ? 1 : 2;
      var width = Math.abs(wh.x) * hr,
        height = Math.abs(wh.y) * vr;
      if (aspectRatio) {
        width = Math.max(width, height * aspectRatio);
        height = width / aspectRatio;
      }
      var ability = resizeAbilities[i];
      if (!(geometryToEdit instanceof TextBox)) {
        if (aspectRatio || ability === 0 || ability === 2) {
          symbol['markerWidth'] = Math.min(width, _this4._geometry.options['maxMarkerWidth'] || Infinity);
        }
        if (aspectRatio || ability === 1 || ability === 2) {
          symbol['markerHeight'] = Math.min(height, _this4._geometry.options['maxMarkerHeight'] || Infinity);
        }
        geometryToEdit.setSymbol(symbol);
        if (geometryToEdit !== _this4._geometry) {
          _this4._geometry.setSymbol(symbol);
        }
      } else {
        if (aspectRatio || ability === 0 || ability === 2) {
          geometryToEdit.setWidth(width);
          if (geometryToEdit !== _this4._geometry) {
            _this4._geometry.setWidth(width);
          }
        }
        if (aspectRatio || ability === 1 || ability === 2) {
          geometryToEdit.setHeight(height);
          if (geometryToEdit !== _this4._geometry) {
            _this4._geometry.setHeight(height);
          }
        }
      }
    }, function () {
      _this4._update(getUpdates());
    });
    function getUpdates() {
      var updates = [['setCoordinates', geometryToEdit.getCoordinates().toArray()]];
      if (geometryToEdit instanceof TextBox) {
        updates.push(['setWidth', geometryToEdit.getWidth()]);
        updates.push(['setHeight', geometryToEdit.getHeight()]);
      } else {
        updates.push(['setSymbol', geometryToEdit.getSymbol()]);
      }
      return updates;
    }
  };
  _proto.createCircleEditor = function createCircleEditor() {
    var _this5 = this;
    var geo = this._shadow || this._geometry;
    var map = this.getMap();
    if (!this._history) {
      this._recordHistory([['setCoordinates', geo.getCoordinates().toArray()], ['setRadius', geo.getRadius()]]);
    }
    this._createResizeHandles(null, function (handleContainerPoint) {
      var center = geo.getCenter();
      var mouseCoordinate = fixHandlePointCoordinates(geo, center, handleContainerPoint);
      var wline = new LineString([[center.x, center.y], [mouseCoordinate.x, center.y]]);
      var hline = new LineString([[center.x, center.y], [center.x, mouseCoordinate.y]]);
      var r = Math.max(map.computeGeometryLength(wline), map.computeGeometryLength(hline));
      geo.setRadius(r);
      if (geo !== _this5._geometry) {
        _this5._geometry.setRadius(r);
      }
    }, function () {
      _this5._update('setRadius', geo.getRadius());
    });
  };
  _proto.createEllipseOrRectEditor = function createEllipseOrRectEditor() {
    var _this6 = this;
    var resizeAbilities = [2, 1, 2, 0, 0, 2, 1, 2];
    var geometryToEdit = this._shadow || this._geometry;
    if (!this._history) {
      this._recordHistory(getUpdates());
    }
    var map = this.getMap();
    var isRect = this._geometry instanceof Rectangle;
    var aspectRatio;
    if (this.options['fixAspectRatio']) {
      aspectRatio = geometryToEdit.getWidth() / geometryToEdit.getHeight();
    }
    var resizeHandles = this._createResizeHandles(null, function (mouseContainerPoint, i) {
      var r = isRect ? 1 : 2;
      var pointSub, w, h;
      var handle = resizeHandles[i];
      var targetPoint = handle.getContainerPoint();
      var ability = resizeAbilities[i];
      if (isRect) {
        var mirror = resizeHandles[7 - i];
        var mirrorContainerPoint = mirror.getContainerPoint();
        pointSub = targetPoint.sub(mirrorContainerPoint);
        var absSub = pointSub.abs();
        w = map.pixelToDistance(absSub.x, 0);
        h = map.pixelToDistance(0, absSub.y);
        var size = geometryToEdit.getSize();
        var geoCoord = geometryToEdit.getCoordinates();
        var width = geometryToEdit.getWidth();
        var height = geometryToEdit.getHeight();
        var mirrorCoordinate = mirror.coord;
        var mouseCoordinate = fixHandlePointCoordinates(geometryToEdit, geoCoord, mouseContainerPoint);
        var wline = new LineString([[mirrorCoordinate.x, mirrorCoordinate.y], [mouseCoordinate.x, mirrorCoordinate.y]]);
        var hline = new LineString([[mirrorCoordinate.x, mirrorCoordinate.y], [mirrorCoordinate.x, mouseCoordinate.y]]);
        w = map.computeGeometryLength(wline);
        h = map.computeGeometryLength(hline);
        if (ability === 0) {
          if (aspectRatio) {
            absSub.y = absSub.x / aspectRatio;
            size.height = Math.abs(absSub.y);
            h = w / aspectRatio;
          }
          targetPoint.y = mirrorContainerPoint.y - size.height / 2;
          mouseCoordinate.y = geoCoord.y;
          if (i === 4) {
            mouseCoordinate.x = Math.min(mouseCoordinate.x, geoCoord.x);
          } else {
            var mirrorCoord = map.locate(geoCoord, width, 0);
            mouseCoordinate.x = map.locate(new Coordinate(mirrorCoord.x, mouseCoordinate.y), -w, 0).x;
          }
        } else if (ability === 1) {
          if (aspectRatio) {
            absSub.x = absSub.y * aspectRatio;
            size.width = Math.abs(absSub.x);
            w = h * aspectRatio;
          }
          targetPoint.x = mirrorContainerPoint.x - size.width / 2;
          mouseCoordinate.x = geoCoord.x;
          mouseCoordinate.y = Math.max(mouseCoordinate.y, mirrorCoordinate.y);
        } else {
          if (aspectRatio) {
            if (w > h * aspectRatio) {
              h = w / aspectRatio;
              targetPoint.y = mirrorContainerPoint.y + absSub.x * sign(pointSub.y) / aspectRatio;
            } else {
              w = h * aspectRatio;
              targetPoint.x = mirrorContainerPoint.x + absSub.y * sign(pointSub.x) * aspectRatio;
            }
          }
          if (i === 0 || i === 5) {
            var _mirrorCoord = i === 0 ? map.locate(geoCoord, width, 0) : map.locate(geoCoord, width, -height);
            mouseCoordinate.x = map.locate(new Coordinate(_mirrorCoord.x, mouseCoordinate.y), -w, 0).x;
          } else {
            mouseCoordinate.x = Math.min(mouseCoordinate.x, mirrorCoordinate.x);
          }
          mouseCoordinate.y = Math.max(mouseCoordinate.y, mirrorCoordinate.y);
        }
        mouseCoordinate.z = geoCoord.z;
        geometryToEdit.setCoordinates(mouseCoordinate);
        _this6._updateCoordFromShadow(true);
      } else {
        var center = geometryToEdit.getCenter();
        var _mouseCoordinate = fixHandlePointCoordinates(geometryToEdit, center, mouseContainerPoint);
        var _wline = new LineString([[center.x, center.y], [_mouseCoordinate.x, center.y]]);
        var _hline = new LineString([[center.x, center.y], [center.x, _mouseCoordinate.y]]);
        w = map.computeGeometryLength(_wline);
        h = map.computeGeometryLength(_hline);
        if (aspectRatio) {
          w = Math.max(w, h * aspectRatio);
          h = w / aspectRatio;
        }
      }
      if (aspectRatio || ability === 0 || ability === 2) {
        geometryToEdit.setWidth(w * r);
        if (geometryToEdit !== _this6._geometry) {
          _this6._geometry.setWidth(w * r);
        }
      }
      if (aspectRatio || ability === 1 || ability === 2) {
        geometryToEdit.setHeight(h * r);
        if (geometryToEdit !== _this6._geometry) {
          _this6._geometry.setHeight(h * r);
        }
      }
    }, function () {
      _this6._update(getUpdates());
    });
    function getUpdates() {
      return [['setCoordinates', geometryToEdit.getCoordinates().toArray()], ['setWidth', geometryToEdit.getWidth()], ['setHeight', geometryToEdit.getHeight()]];
    }
  };
  _proto.createPolygonEditor = function createPolygonEditor() {
    var map = this.getMap(),
      geoToEdit = this._shadow || this._geometry,
      me = this;
    if (!this._history) {
      this._recordHistory('setCoordinates', Coordinate.toNumberArrays(geoToEdit.getCoordinates()));
    }
    var verticeLimit = geoToEdit instanceof Polygon ? 3 : 2;
    var propertyOfVertexIndex = 'maptalks--editor-vertex-index';
    var {
      vertexZIndex: vertexZIndex,
      newVertexZIndex: newVertexZIndex
    } = this.options;
    var vertexHandles = {
        0: []
      },
      newVertexHandles = {
        0: []
      };
    function updatePolyCoordinates(coordinates, ringIndex) {
      if (geoToEdit instanceof Polygon) {
        var rings = geoToEdit.getCoordinates();
        rings[ringIndex] = coordinates;
        geoToEdit.setCoordinates(rings);
      } else {
        geoToEdit.setCoordinates(coordinates);
      }
    }
    function getVertexCoordinates(ringIndex = 0) {
      if (geoToEdit instanceof Polygon) {
        var coordinates = geoToEdit.getCoordinates()[ringIndex] || [];
        return coordinates.slice(0, coordinates.length - 1);
      } else {
        return geoToEdit.getCoordinates();
      }
    }
    function onVertexAddOrRemove() {
      for (var ringIndex in vertexHandles) {
        for (var i = vertexHandles[ringIndex].length - 1; i >= 0; i--) {
          vertexHandles[ringIndex][i][propertyOfVertexIndex] = i;
        }
        for (var _i = newVertexHandles[ringIndex].length - 1; _i >= 0; _i--) {
          newVertexHandles[ringIndex][_i][propertyOfVertexIndex] = _i;
        }
      }
      me._updateCoordFromShadow();
    }
    function removeVertex(param) {
      me._updating = true;
      var handle = param['target'],
        index = handle[propertyOfVertexIndex];
      var ringIndex = isNumber(handle._ringIndex) ? handle._ringIndex : 0;
      var coordinates = getVertexCoordinates(ringIndex);
      if (coordinates.length <= verticeLimit) {
        console.warn(" Geometry." + geoToEdit.type + " Require at least " + verticeLimit + " vertices,Geometry: ", geoToEdit);
        return;
      }
      coordinates.splice(index, 1);
      updatePolyCoordinates(coordinates, ringIndex);
      if (index === 0) {
        newVertexHandles[ringIndex][0]["delete"]();
        newVertexHandles[ringIndex].splice(0, 1);
      } else if (index === vertexHandles[ringIndex].length - 1) {
        var len = newVertexHandles[ringIndex].length;
        newVertexHandles[ringIndex][len - 1]["delete"]();
        newVertexHandles[ringIndex].splice(len - 1, 1);
      } else {
        newVertexHandles[ringIndex][index - 1]["delete"]();
        newVertexHandles[ringIndex].splice(index - 1, 1);
        newVertexHandles[ringIndex][index - 1]["delete"]();
        newVertexHandles[ringIndex].splice(index - 1, 1);
        newVertexHandles[ringIndex].splice(index - 1, 0, createNewVertexHandle.call(me, index - 1, ringIndex));
      }
      vertexHandles[ringIndex].splice(index, 1)[0]["delete"]();
      if (ringIndex > 0) {
        var coordiantes = geoToEdit.getCoordinates();
        var ring = coordiantes[ringIndex];
        if (ring && Array.isArray(ring) && ring.length > 1) {
          if (geoToEdit !== this._geometry) {
            geoToEdit.setCoordinates(coordiantes);
          }
        }
      }
      onVertexAddOrRemove();
      me._updating = false;
      me._geometry.fire('handleremove', Object.assign({}, param, {
        coordinate: map.containerPointToCoordinate(param.containerPoint),
        vertex: param.target
      }));
    }
    function moveVertexHandle(handleConatainerPoint, index, ringIndex = 0) {
      var snapTo = me._geometry.snapTo;
      if (snapTo && isFunction(snapTo)) {
        handleConatainerPoint = me._geometry.snapTo(handleConatainerPoint) || handleConatainerPoint;
      }
      var coordinates = getVertexCoordinates(ringIndex);
      var containerPoint = handleConatainerPoint.sub(getDxDy());
      var coordinate = fixHandlePointCoordinates(me._geometry, coordinates[index], containerPoint, me.options.dragOnAxis);
      var vertex = coordinates[index];
      vertex.x = coordinate.x;
      vertex.y = coordinate.y;
      geoToEdit.setCoordinates(geoToEdit.getCoordinates());
      me._updateCoordFromShadow(true);
      var nextIndex;
      if (index === 0) {
        nextIndex = newVertexHandles[ringIndex].length - 1;
      } else {
        nextIndex = index - 1;
      }
      if (newVertexHandles[ringIndex][index]) {
        newVertexHandles[ringIndex][index].refresh();
      }
      if (newVertexHandles[ringIndex][nextIndex]) {
        newVertexHandles[ringIndex][nextIndex].refresh();
      }
    }
    var hanldeDxdy = new Point(0, 0);
    function getDxDy() {
      var compiledSymbol = geoToEdit._getCompiledSymbol();
      hanldeDxdy.x = compiledSymbol.lineDx || 0;
      hanldeDxdy.y = compiledSymbol.lineDy || 0;
      return hanldeDxdy;
    }
    function createVertexHandle(index, ringIndex = 0, ringCoordinates) {
      var vertex = (ringCoordinates || getVertexCoordinates(ringIndex))[index];
      var containerPoint = coordinatesToContainerPoint(map, vertex)._add(getDxDy());
      var handle = me.createHandle(containerPoint, {
        'symbol': me.options['vertexHandleSymbol'],
        'cursor': 'pointer',
        'axis': null,
        onMove: function onMove() {
          moveVertexHandle(handle.getContainerPoint(), handle[propertyOfVertexIndex], ringIndex);
        },
        onRefresh: function onRefresh(rIndex, ringCoordinates) {
          vertex = (ringCoordinates || getVertexCoordinates(ringIndex))[handle[propertyOfVertexIndex]];
          if (vertex) {
            var _containerPoint = coordinatesToContainerPoint(map, vertex);
            handle.setContainerPoint(_containerPoint._add(getDxDy()));
          }
        },
        onUp: function onUp() {
          me._updateCoordFromShadow();
        },
        onDown: function onDown(param, e) {
          if (e && e.domEvent && e.domEvent.button === 2) {
            return;
          }
        }
      });
      handle[propertyOfVertexIndex] = index;
      handle._ringIndex = ringIndex;
      handle.on(me.options['removeVertexOn'], removeVertex);
      handle.setZIndex(vertexZIndex);
      return handle;
    }
    var pauseRefresh = false;
    var isSplitSegment = false;
    function createNewVertexHandle(index, ringIndex = 0, ringCoordinates) {
      var vertexCoordinates = ringCoordinates || getVertexCoordinates(ringIndex);
      var nextVertex;
      if (index + 1 >= vertexCoordinates.length) {
        nextVertex = vertexCoordinates[0];
      } else {
        nextVertex = vertexCoordinates[index + 1];
      }
      var vertex = vertexCoordinates[index].add(nextVertex).multi(1 / 2);
      if (isSplitSegment) {
        vertex = coordinatesToContainerPoint(map, vertex);
      }
      var handle = me.createHandle(vertex, {
        'symbol': me.options['newVertexHandleSymbol'],
        'cursor': 'pointer',
        'axis': null,
        onDown: function onDown(param, e) {
          if (e && e.domEvent && e.domEvent.button === 2) {
            return;
          }
          var coordinates = getVertexCoordinates(ringIndex);
          var vertexIndex = handle[propertyOfVertexIndex];
          var preCoordinate = coordinates[vertexIndex];
          var nextCoordinate = coordinates[vertexIndex + 1] || coordinates[0];
          var middleCoordinate = preCoordinate.add(nextCoordinate).multi(1 / 2);
          coordinates.splice(vertexIndex + 1, 0, middleCoordinate);
          updatePolyCoordinates(coordinates, ringIndex);
          handle.opacity = 1;
          isSplitSegment = true;
          newVertexHandles[ringIndex].splice(vertexIndex, 0, createNewVertexHandle.call(me, vertexIndex, ringIndex), createNewVertexHandle.call(me, vertexIndex + 1, ringIndex));
          isSplitSegment = false;
          pauseRefresh = true;
        },
        onMove: function onMove() {
          moveVertexHandle(handle.getContainerPoint(), handle[propertyOfVertexIndex] + 1, ringIndex);
        },
        onUp: function onUp(e) {
          if (e && e.domEvent && e.domEvent.button === 2) {
            pauseRefresh = false;
            return;
          }
          var vertexIndex = handle[propertyOfVertexIndex];
          removeFromArray(handle, newVertexHandles[ringIndex]);
          handle["delete"]();
          vertexHandles[ringIndex].splice(vertexIndex, 0, createVertexHandle.call(me, vertexIndex, ringIndex));
          onVertexAddOrRemove();
          me._updateCoordFromShadow();
          pauseRefresh = false;
        },
        onRefresh: function onRefresh(rIndex, ringCoordinates) {
          vertexCoordinates = ringCoordinates || getVertexCoordinates(rIndex);
          var vertexIndex = handle[propertyOfVertexIndex];
          var nextIndex;
          if (vertexIndex === vertexCoordinates.length - 1) {
            nextIndex = 0;
          } else {
            nextIndex = vertexIndex + 1;
          }
          if (vertexCoordinates[vertexIndex] && vertexCoordinates[nextIndex]) {
            var refreshVertex = vertexCoordinates[vertexIndex].add(vertexCoordinates[nextIndex]).multi(1 / 2);
            var containerPoint = coordinatesToContainerPoint(map, refreshVertex);
            handle.setContainerPoint(containerPoint._add(getDxDy()));
          }
        }
      });
      handle[propertyOfVertexIndex] = index;
      handle.setZIndex(newVertexZIndex);
      return handle;
    }
    if (geoToEdit instanceof Polygon) {
      var rings = geoToEdit.getHoles().length + 1;
      for (var ringIndex = 0; ringIndex < rings; ringIndex++) {
        vertexHandles[ringIndex] = [];
        newVertexHandles[ringIndex] = [];
        var vertexCoordinates = getVertexCoordinates(ringIndex);
        for (var i = 0, len = vertexCoordinates.length; i < len; i++) {
          vertexHandles[ringIndex].push(createVertexHandle.call(this, i, ringIndex, vertexCoordinates));
          if (i < len - 1) {
            newVertexHandles[ringIndex].push(createNewVertexHandle.call(this, i, ringIndex, vertexCoordinates));
          }
        }
        newVertexHandles[ringIndex].push(createNewVertexHandle.call(this, vertexCoordinates.length - 1, ringIndex, vertexCoordinates));
      }
    } else {
      var _ringIndex = 0;
      var _vertexCoordinates = getVertexCoordinates(_ringIndex);
      for (var _i2 = 0, _len = _vertexCoordinates.length; _i2 < _len; _i2++) {
        vertexHandles[_ringIndex].push(createVertexHandle.call(this, _i2, _ringIndex, _vertexCoordinates));
        if (_i2 < _len - 1) {
          newVertexHandles[_ringIndex].push(createNewVertexHandle.call(this, _i2, _ringIndex, _vertexCoordinates));
        }
      }
      if (newVertexHandles[_ringIndex].length && geoToEdit.getCoordinates().length === 2) {
        newVertexHandles[_ringIndex][0].options.symbol['markerDx'] = 12;
      }
    }
    var renderer = map.getRenderer();
    if (renderer) {
      renderer.sortTopElements();
    }
    this._addRefreshHook(function () {
      if (pauseRefresh) {
        return;
      }
      for (var _ringIndex2 in newVertexHandles) {
        var ringCoordinates = getVertexCoordinates(_ringIndex2);
        for (var _i3 = newVertexHandles[_ringIndex2].length - 1; _i3 >= 0; _i3--) {
          newVertexHandles[_ringIndex2][_i3].refresh(_ringIndex2, ringCoordinates);
        }
      }
      if (newVertexHandles[0].length && geoToEdit instanceof LineString) {
        if (geoToEdit.getCoordinates().length === 2) {
          newVertexHandles[0][0].options.symbol['markerDx'] = 12;
        } else if (geoToEdit.getCoordinates().length > 2) {
          newVertexHandles[0][0].options.symbol['markerDx'] = 0;
        }
      }
      for (var _ringIndex3 in vertexHandles) {
        var _ringCoordinates = getVertexCoordinates(_ringIndex3);
        for (var _i4 = vertexHandles[_ringIndex3].length - 1; _i4 >= 0; _i4--) {
          vertexHandles[_ringIndex3][_i4].refresh(_ringIndex3, _ringCoordinates);
        }
      }
    });
  };
  _proto._refresh = function _refresh() {
    if (this._refreshHooks) {
      for (var i = this._refreshHooks.length - 1; i >= 0; i--) {
        this._refreshHooks[i].call(this);
      }
    }
  };
  _proto._hideContext = function _hideContext() {
    if (this._geometry) {
      this._geometry.closeMenu();
      this._geometry.closeInfoWindow();
    }
  };
  _proto._addRefreshHook = function _addRefreshHook(fn) {
    if (!fn) {
      return;
    }
    if (!this._refreshHooks) {
      this._refreshHooks = [];
    }
    this._refreshHooks.push(fn);
  };
  _proto._update = function _update(method, ...args) {
    this._exeHistory([method, args]);
    this._recordHistory(method, ...args);
  };
  _proto._updateCoordFromShadow = function _updateCoordFromShadow(ignoreRecord) {
    var geoToEdit = this._shadow || this._geometry;
    var coords = geoToEdit.getCoordinates();
    var geo = this._geometry;
    var updating = this._updating;
    this._updating = true;
    geo.setCoordinates(coords);
    if (!ignoreRecord) {
      this._recordHistory('setCoordinates', Coordinate.toNumberArrays(geo.getCoordinates()));
    }
    this._updating = updating;
  };
  _proto._recordHistory = function _recordHistory(method, ...args) {
    if (!this._history) {
      this._history = [];
      this._historyPointer = 0;
    }
    if (this._history.length) {
      var lastOperation = this._history[this._history.length - 1];
      if (lastOperation[0] === method && JSON.stringify(lastOperation[1]) === JSON.stringify(args)) {
        return;
      }
    }
    if (this._historyPointer < this._history.length - 1) {
      this._history.splice(this._historyPointer + 1);
    }
    this._history.push([method, args]);
    this._historyPointer = this._history.length - 1;
    this._geometry.fire('editrecord');
  };
  _proto.cancel = function cancel() {
    if (!this._history || this._historyPointer === 0) {
      return this;
    }
    this._historyPointer = 0;
    var record = this._history[0];
    this._exeAndReset(record);
    return this;
  };
  _proto.undo = function undo() {
    if (this._isundoEdit()) {
      return this;
    }
    var record = this._history[--this._historyPointer];
    this._exeAndReset(record);
    return this;
  };
  _proto.redo = function redo() {
    if (this._isRedoEdit()) {
      return this;
    }
    var record = this._history[++this._historyPointer];
    this._exeAndReset(record);
    return this;
  };
  _proto._exeAndReset = function _exeAndReset(record) {
    if (this._updating) {
      return;
    }
    this._exeHistory(record);
    var history = this._history,
      pointer = this._historyPointer;
    this.stop();
    this._history = history;
    this._historyPointer = pointer;
    this.start();
  };
  _proto._onDragStart = function _onDragStart() {
    this._updating = true;
  };
  _proto._onDragEnd = function _onDragEnd() {
    this._updating = false;
  };
  _proto._exeHistory = function _exeHistory(record) {
    if (!Array.isArray(record)) {
      return;
    }
    var updating = this._updating;
    this._updating = true;
    var geoToEdit = this._shadow || this._geometry;
    var geo = this._geometry;
    if (Array.isArray(record[0])) {
      record[0].forEach(function (o) {
        var m = o[0],
          args = o.slice(1);
        geoToEdit[m].call(geoToEdit, ...args);
        if (geoToEdit !== geo) {
          geo[m].call(geo, ...args);
        }
      });
    } else {
      geoToEdit[record[0]].call(geoToEdit, ...record[1]);
      if (geoToEdit !== geo) {
        geo[record[0]].call(geo, ...record[1]);
      }
    }
    this._updating = updating;
  };
  _proto._isRedoEdit = function _isRedoEdit() {
    if (!this._history || this._historyPointer === this._history.length - 1) {
      return true;
    }
    return false;
  };
  _proto._isundoEdit = function _isundoEdit() {
    if (!this._history || this._historyPointer === 0) {
      return true;
    }
    return false;
  };
  return GeometryEditor;
}(Eventable(Class));
GeometryEditor.mergeOptions(options);

var TextEditable = {
  startEditText: function startEditText() {
    if (!this.getMap()) {
      return this;
    }
    this._recordVisible();
    this.hide();
    this.endEditText();
    this._prepareEditor();
    this._fireEvent('edittextstart');
    return this;
  },
  endEditText: function endEditText() {
    if (this._textEditor) {
      var html = this._textEditor.innerHTML;
      html = html.replace(/<p>/ig, '').replace(/<\/p>/ig, '<br/>');
      this._textEditor.innerHTML = html;
      var content = this._textEditor.innerText.replace(/[\r\n]+$/gi, '');
      this.setContent(content);
      off(this._textEditor, 'mousedown dblclick', stopPropagation);
      this.getMap().off('mousedown', this.endEditText, this);
      this._editUIMarker.remove();
      delete this._editUIMarker;
      this._textEditor.onkeyup = null;
      delete this._textEditor;
      this._recoveryVisible();
      this.show();
      this._fireEvent('edittextend');
    }
    return this;
  },
  isEditingText: function isEditingText() {
    if (this._textEditor) {
      return true;
    }
    return false;
  },
  getTextEditor: function getTextEditor() {
    return this._editUIMarker;
  },
  _prepareEditor: function _prepareEditor() {
    var map = this.getMap();
    var editContainer = this._createEditor();
    this._textEditor = editContainer;
    map.on('mousedown', this.endEditText, this);
    var offset = this._getEditorOffset();
    this._editUIMarker = new UIMarker(this.getCoordinates(), {
      'animation': null,
      'content': editContainer,
      'dx': offset.dx,
      'dy': offset.dy
    }).addTo(map);
    this._setCursorToLast(this._textEditor);
  },
  _getEditorOffset: function _getEditorOffset() {
    var symbol = this._getInternalSymbol() || {};
    var dx = 0,
      dy = 0;
    var textAlign = symbol['textHorizontalAlignment'];
    if (textAlign === 'middle' || isNil(textAlign)) {
      dx = (symbol['textDx'] || 0) - 2;
      dy = (symbol['textDy'] || 0) - 2;
    } else {
      dx = (symbol['markerDx'] || 0) - 2;
      dy = (symbol['markerDy'] || 0) - 2;
    }
    return {
      'dx': dx,
      'dy': dy
    };
  },
  _createEditor: function _createEditor() {
    var content = this.getContent();
    var labelSize = this.getSize(),
      symbol = this._getInternalSymbol() || {},
      width = labelSize.width,
      textColor = symbol['textFill'] || '#000000',
      textSize = symbol['textSize'] || 12,
      height = labelSize.height,
      lineColor = symbol['markerLineColor'] || '#000',
      fill = symbol['markerFill'] || '#3398CC',
      spacing = symbol['textLineSpacing'] || 0;
    var editor = createEl('div');
    editor.contentEditable = true;
    editor.style.cssText = "background:" + fill + "; border:1px solid " + lineColor + ";\n            color:" + textColor + ";font-size:" + textSize + "px;width:" + (width - 2) + "px;height:" + (height - 2) + "px;margin: auto;\n            line-height:" + (textSize + spacing) + "px;outline: 0; padding:0; margin:0;word-wrap: break-word;\n            overflow: hidden;-webkit-user-modify: read-write-plaintext-only;";
    editor.innerText = content;
    on(editor, 'mousedown dblclick', stopPropagation);
    editor.onkeyup = function (event) {
      var h = editor.style.height || 0;
      if (event.keyCode === 13) {
        editor.style.height = parseInt(h) + textSize / 2 + 'px';
      }
    };
    return editor;
  },
  _setCursorToLast: function _setCursorToLast(obj) {
    var range;
    if (window.getSelection) {
      obj.focus();
      range = window.getSelection();
      range.selectAllChildren(obj);
      range.collapseToEnd();
    } else if (document.selection) {
      range = document.selection.createRange();
      range.moveToElementText(obj);
      range.collapse(false);
      range.select();
    }
  }
};
TextMarker.include(TextEditable);

Geometry.include({
  animate: function animate(styles, options, step) {
    var _this = this;
    if (this._animPlayer) {
      this._animPlayer.finish();
    }
    if (isFunction(options)) {
      step = options;
    }
    if (!options) {
      options = {};
    }
    var map = this.getMap(),
      projection = this._getProjection(),
      stylesToAnimate = this._prepareAnimationStyles(styles);
    var preTranslate;
    var isFocusing = options['focus'];
    delete this._animationStarted;
    if (map) {
      var renderer = map._getRenderer();
      var framer = function framer(fn) {
        renderer.callInNextFrame(fn);
      };
      options['framer'] = framer;
    }
    if (!projection && isFocusing) {
      console.error(GEOMETRY_NOT_FIND_PROJECTION);
      return;
    }
    var player = Animation.animate(stylesToAnimate, options, function (frame) {
      if (map && map.isRemoved()) {
        player.finish();
        return;
      }
      if (map && !_this._animationStarted && isFocusing) {
        map.onMoveStart();
      }
      var styles = frame.styles;
      for (var p in styles) {
        if (p !== 'symbol' && p !== 'translate' && styles.hasOwnProperty(p)) {
          var fnName = 'set' + p[0].toUpperCase() + p.slice(1);
          _this[fnName](styles[p]);
        }
      }
      var translate = styles['translate'];
      if (translate) {
        var toTranslate = translate;
        if (preTranslate) {
          toTranslate = translate.sub(preTranslate);
        }
        preTranslate = translate;
        _this.translate(toTranslate);
      }
      var dSymbol = styles['symbol'];
      if (dSymbol) {
        var symbol = _this.getSymbol() || {};
        _this.setSymbol(extendSymbol(symbol, dSymbol));
      }
      if (map && isFocusing) {
        var pcenter = projection.project(_this.getCenter());
        map._setPrjCenter(pcenter);
        var e = map._parseEventFromCoord(projection.unproject(pcenter));
        if (player.playState !== 'running') {
          map.onMoveEnd(e);
        } else {
          map.onMoving(e);
        }
      }
      _this._fireAnimateEvent(player.playState);
      if (step) {
        step(frame);
      }
    }, this);
    this._animPlayer = player;
    return this._animPlayer.play();
  },
  _prepareAnimationStyles: function _prepareAnimationStyles(styles) {
    var symbol = this._getInternalSymbol();
    var stylesToAnimate = {};
    for (var p in styles) {
      if (styles.hasOwnProperty(p)) {
        var v = styles[p];
        if (p !== 'translate' && p !== 'symbol') {
          var fnName = 'get' + p[0].toUpperCase() + p.substring(1);
          var current = this[fnName]();
          stylesToAnimate[p] = [current, v];
        } else if (p === 'symbol') {
          var symbolToAnimate = void 0;
          if (Array.isArray(styles['symbol'])) {
            if (!Array.isArray(symbol)) {
              throw new Error('geometry\'symbol isn\'t a composite symbol, while the symbol in styles is.');
            }
            symbolToAnimate = [];
            var symbolInStyles = styles['symbol'];
            for (var i = 0; i < symbolInStyles.length; i++) {
              if (!symbolInStyles[i]) {
                symbolToAnimate.push(null);
                continue;
              }
              var a = {};
              for (var sp in symbolInStyles[i]) {
                if (symbolInStyles[i].hasOwnProperty(sp)) {
                  a[sp] = [symbol[i][sp], symbolInStyles[i][sp]];
                }
              }
              symbolToAnimate.push(a);
            }
          } else {
            if (Array.isArray(symbol)) {
              throw new Error('geometry\'symbol is a composite symbol, while the symbol in styles isn\'t.');
            }
            symbolToAnimate = {};
            for (var _sp in v) {
              if (v.hasOwnProperty(_sp)) {
                symbolToAnimate[_sp] = [symbol[_sp], v[_sp]];
              }
            }
          }
          stylesToAnimate['symbol'] = symbolToAnimate;
        } else if (p === 'translate') {
          stylesToAnimate['translate'] = new Coordinate(v);
        }
      }
    }
    return stylesToAnimate;
  },
  _fireAnimateEvent: function _fireAnimateEvent(playState) {
    if (playState === 'finished') {
      delete this._animationStarted;
      this._fireEvent('animateend');
    } else if (playState === 'running') {
      if (this._animationStarted) {
        this._fireEvent('animating');
      } else {
        this._fireEvent('animatestart');
        this._animationStarted = true;
      }
    }
  }
});

var DRAG_STAGE_LAYER_ID = INTERNAL_LAYER_PREFIX + '_drag_stage';
var EVENTS = Browser$1.touch ? 'touchstart mousedown' : 'mousedown';
function fixDragPointCoordinates(geometry, dragContainerPoint, dragCoordinates) {
  var editCenter = geometry._getEditCenter();
  var map = geometry.getMap();
  if (!editCenter || editCenter.z === 0) {
    return dragCoordinates || map.containerPointToCoord(dragContainerPoint);
  }
  var altitude = editCenter.z;
  return map.containerPointToCoordinate3(dragContainerPoint, altitude);
}
var GeometryDragHandler = function (_Handler) {
  function GeometryDragHandler(target) {
    return _Handler.call(this, target) || this;
  }
  _inheritsLoose(GeometryDragHandler, _Handler);
  var _proto = GeometryDragHandler.prototype;
  _proto.addHooks = function addHooks() {
    this.target.on(EVENTS, this._startDrag, this);
  };
  _proto.removeHooks = function removeHooks() {
    this._endDrag();
    this.target.off(EVENTS, this._startDrag, this);
    delete this.container;
  };
  _proto._prepareDragHandler = function _prepareDragHandler() {
    this._dragHandler = new DragHandler(this.container);
    this._dragHandler.on('dragging', this._dragging, this).on('mouseup', this._endDrag, this).enable();
  };
  _proto._prepareShadow = function _prepareShadow() {
    var _this = this;
    var target = this.target;
    var needShadow = target.getLayer().options['renderer'] === 'canvas';
    if (!needShadow) {
      return;
    }
    if (!target.options.dragShadow) {
      return;
    }
    this._prepareDragStageLayer();
    if (this._shadow) {
      this._shadow.remove();
    }
    var shadow = this._shadow = target.copy();
    if (shadow.getGeometries) {
      var shadows = shadow.getGeometries();
      var geos = target.getGeometries();
      shadows.forEach(function (g, i) {
        _this._updateShadowSymbol(g, geos[i]);
      });
    } else {
      this._updateShadowSymbol(shadow, target);
    }
    shadow.setId(null);
    this._prepareShadowConnectors();
  };
  _proto._updateShadowSymbol = function _updateShadowSymbol(shadow, target) {
    shadow.setSymbol(target._getInternalSymbol());
    if (target.options['dragShadow']) {
      var symbol = lowerSymbolOpacity(shadow._getInternalSymbol(), 0.5);
      shadow.setSymbol(symbol);
    }
  };
  _proto._prepareShadowConnectors = function _prepareShadowConnectors() {
    var target = this.target;
    var shadow = this._shadow;
    var resources = this._dragStageLayer._getRenderer().resources;
    var shadowConnectors = [];
    if (ConnectorLine._hasConnectors(target)) {
      var connectors = ConnectorLine._getConnectors(target);
      for (var i = 0, l = connectors.length; i < l; i++) {
        var targetConn = connectors[i];
        var connOptions = targetConn.config(),
          connSymbol = targetConn._getInternalSymbol();
        connOptions['symbol'] = lowerSymbolOpacity(connSymbol, 0.5);
        var conn = void 0;
        if (targetConn.getConnectSource() === target) {
          conn = new targetConn.constructor(shadow, targetConn.getConnectTarget(), connOptions);
        } else {
          conn = new targetConn.constructor(targetConn.getConnectSource(), shadow, connOptions);
        }
        shadowConnectors.push(conn);
        if (targetConn.getLayer() && targetConn.getLayer()._getRenderer()) {
          resources.merge(targetConn.getLayer()._getRenderer().resources);
        }
      }
    }
    this._shadowConnectors = shadowConnectors;
    shadowConnectors.push(shadow);
    this._dragStageLayer.bringToFront().addGeometry(shadowConnectors);
  };
  _proto._onTargetUpdated = function _onTargetUpdated() {
    if (this._shadow) {
      this._shadow.setSymbol(this.target._getSymbol());
    }
  };
  _proto._prepareDragStageLayer = function _prepareDragStageLayer() {
    var map = this.target.getMap(),
      layer = this.target.getLayer();
    var prevLayer = map.getLayer(DRAG_STAGE_LAYER_ID);
    if (prevLayer) {
      prevLayer.remove();
    }
    var layerClazz = layer.constructor;
    this._dragStageLayer = new layerClazz(DRAG_STAGE_LAYER_ID, {
      enableAltitude: layer.options['enableAltitude'],
      altitudeProperty: layer.options['altitudeProperty']
    });
    map.addLayer(this._dragStageLayer);
    var resources = getResouceCacheInstance();
    resources.merge(layer._getRenderer().resources);
    this._dragStageLayer._getRenderer().resources = resources;
  };
  _proto._startDrag = function _startDrag(param) {
    var map = this.target.getMap();
    if (!map) {
      return;
    }
    var parent = this.target._getParent();
    if (parent) {
      return;
    }
    if (this.isDragging()) {
      return;
    }
    var domEvent = param['domEvent'];
    if (domEvent.touches && domEvent.touches.length > 1 || domEvent.button === 2) {
      return;
    }
    this.container = map.getPanels().mapWrapper || map.getContainer();
    this.target.on('click', this._endDrag, this);
    var coordinates = this._correctCoord(param['coordinate']);
    this._lastCoord = fixDragPointCoordinates(this.target, param['containerPoint'], coordinates);
    this._lastPoint = param['containerPoint'];
    this._prepareDragHandler();
    this._dragHandler.onMouseDown(param['domEvent']);
    on(this.container, 'mouseleave', this._endDrag, this);
    this._startParam = param;
    this._moved = false;
    return;
  };
  _proto._dragging = function _dragging(param) {
    var target = this.target;
    var map = target.getMap();
    if (!this._lastCoord.z && map._isEventOutMap(param['domEvent'])) {
      return;
    }
    var e = map._parseEvent(param['domEvent']);
    var domEvent = e['domEvent'];
    if (domEvent.touches && domEvent.touches.length > 1) {
      return;
    }
    if (!this._lastCoord.z && map._isContainerPointOutOfMap(e.containerPoint)) {
      return;
    }
    if (!this._moved) {
      this._moved = true;
      target.on('symbolchange', this._onTargetUpdated, this);
      this._isDragging = true;
      this._prepareShadow();
      if (this._shadow) {
        if (!target.options['dragShadow']) {
          target.hide();
        }
        this._shadow._fireEvent('dragstart', e);
      }
      this.target._fireEvent('dragstart', this._startParam || e);
      delete this._startParam;
      return;
    }
    var geo = this._shadow || target;
    var axis = geo.options['dragOnAxis'],
      dragOnScreenAxis = geo.options['dragOnScreenAxis'],
      point = e['containerPoint'];
    var coord = e['coordinate'];
    this._lastPoint = this._lastPoint || point;
    this._lastCoord = this._lastCoord || coord;
    if (dragOnScreenAxis) {
      if (axis === 'x') {
        point.y = this._lastPoint.y;
      } else if (axis === 'y') {
        point.x = this._lastPoint.x;
      }
    }
    var altitude = this._lastCoord.z;
    coord = map.containerPointToCoordinate3(point, altitude);
    var pointOffset = point.sub(this._lastPoint);
    var coordOffset = coord.sub(this._lastCoord);
    if (!dragOnScreenAxis) {
      if (axis === 'x') {
        pointOffset.y = coordOffset.y = 0;
        coord.y = this._lastCoord.y;
      } else if (axis === 'y') {
        pointOffset.x = coordOffset.x = 0;
        coord.x = this._lastCoord.x;
      }
    }
    this._lastPoint = point;
    this._lastCoord = coord;
    var isPoint = !geo.getGeometries && geo.isPoint;
    isPoint ? geo.setCoordinates(coord) : geo.translate(coordOffset);
    if (geo !== target && !target.options['dragShadow']) {
      isPoint ? target.setCoordinates(coord) : target.translate(coordOffset);
    }
    e['coordOffset'] = coordOffset;
    e['pointOffset'] = pointOffset;
    geo._fireEvent('dragging', e);
    if (geo !== target) {
      target._fireEvent('dragging', e);
    }
  };
  _proto._endDrag = function _endDrag(param) {
    if (this._dragHandler) {
      this._dragHandler.disable();
      delete this._dragHandler;
    }
    if (this.container) {
      off(this.container, 'mouseleave', this._endDrag);
    }
    if (!this.target) {
      return;
    }
    var target = this.target;
    target.off('click', this._endDrag, this);
    target.off('symbolchange', this._onTargetUpdated, this);
    delete this._lastCoord;
    delete this._lastPoint;
    this._isDragging = false;
    var map = target.getMap();
    if (this.enabled() && map) {
      var e = map._parseEvent(param ? param['domEvent'] : null);
      this._updateTargetAndRemoveShadow(e);
      if (this._moved) {
        target._fireEvent('dragend', e);
      }
    }
  };
  _proto.isDragging = function isDragging() {
    if (!this._isDragging) {
      return false;
    }
    return true;
  };
  _proto._updateTargetAndRemoveShadow = function _updateTargetAndRemoveShadow(eventParam) {
    if (!this._shadow) {
      return;
    }
    var target = this.target,
      map = target.getMap();
    if (!target.options['dragShadow']) {
      target.show();
    }
    var shadow = this._shadow;
    if (shadow) {
      if (target.options['dragShadow']) {
        var shadowFirst = shadow.getFirstCoordinate();
        var first = target.getFirstCoordinate();
        var offset = shadowFirst.sub(first);
        target.translate(offset);
      }
      shadow._fireEvent('dragend', eventParam);
      shadow.remove();
      delete this._shadow;
    }
    if (this._shadowConnectors) {
      map.getLayer(DRAG_STAGE_LAYER_ID).removeGeometry(this._shadowConnectors);
      delete this._shadowConnectors;
    }
    if (this._dragStageLayer) {
      this._dragStageLayer._getRenderer().resources = getResouceCacheInstance();
      this._dragStageLayer.remove();
    }
  };
  _proto._correctCoord = function _correctCoord(coord) {
    var map = this.target.getMap();
    var cache = MapStateCache[map.id];
    var pitch = cache ? cache.pitch : map.getPitch();
    if (!pitch) {
      return coord;
    }
    var target = this.target;
    if (!target.getMinAltitude()) {
      return coord;
    }
    var alt = (target.getMinAltitude() + target.getMaxAltitude()) / 2;
    return map.locateByPoint(coord, 0, -alt);
  };
  return GeometryDragHandler;
}(Handler);
Geometry.mergeOptions({
  'draggable': false,
  'dragShadow': true,
  'dragOnAxis': null,
  'dragOnScreenAxis': false
});
Geometry.addInitHook('addHandler', 'draggable', GeometryDragHandler);
Geometry.include({
  isDragging: function isDragging() {
    if (this._getParent()) {
      return this._getParent().isDragging();
    }
    if (this['draggable']) {
      return this['draggable'].isDragging();
    }
    return false;
  }
});

Geometry.include({
  startEdit: function startEdit(opts) {
    var map = this.getMap();
    if (!map || !this.options['editable']) {
      return this;
    }
    if (this._editor) {
      this.endEdit();
    }
    this._recordVisible();
    this._editor = new GeometryEditor(this, opts);
    this._editor.start();
    if (!this._getParent()) {
      this.fire('editstart');
    }
    map.getRenderer().setToRedraw();
    return this;
  },
  endEdit: function endEdit() {
    if (this._editor) {
      this._editor.stop();
      delete this._editor;
      this._recoveryVisible();
      if (!this._getParent()) {
        this.fire('editend');
      }
      var map = this.getMap();
      if (map) {
        map.getRenderer().setToRedraw();
      }
    }
    return this;
  },
  redoEdit: function redoEdit() {
    if (!this.isEditing()) {
      return this;
    }
    this._editor.redo();
    if (!this._getParent()) {
      this.fire('redoedit');
    }
    return this;
  },
  undoEdit: function undoEdit() {
    if (!this.isEditing()) {
      return this;
    }
    this._editor.undo();
    if (!this._getParent()) {
      this.fire('undoedit');
    }
    return this;
  },
  cancelEdit: function cancelEdit() {
    if (!this.isEditing()) {
      return this;
    }
    this._recoveryVisible();
    this._editor.cancel();
    if (!this._getParent()) {
      this.fire('canceledit');
    }
    return this;
  },
  isEditing: function isEditing() {
    if (this._editor) {
      return this._editor.isEditing();
    }
    return false;
  },
  undoEditcheck: function undoEditcheck() {
    if (this.isEditing()) {
      return this._editor._isundoEdit();
    }
  },
  redoEditcheck: function redoEditcheck() {
    if (this.isEditing()) {
      return this._editor._isRedoEdit();
    }
  }
});

Geometry.include({
  _onEvent: function _onEvent(event, type) {
    var map = this.getMap();
    if (!map) {
      return;
    }
    var eventType = type || this._getEventTypeToFire(event);
    if (eventType === 'contextmenu' && this.listens('contextmenu')) {
      stopPropagation(event);
      preventDefault(event);
    }
    var params = map._getEventParams(event);
    if (isNumber(this._pickGeometryIndex)) {
      params.pickGeometryIndex = this._pickGeometryIndex;
    }
    this._fireEvent(eventType, params);
  },
  _getEventTypeToFire: function _getEventTypeToFire(domEvent) {
    return domEvent.type;
  }
});

Geometry.include({
  setInfoWindow: function setInfoWindow(options) {
    this.removeInfoWindow();
    if (options instanceof InfoWindow) {
      this._infoWindow = options;
      this._infoWinOptions = extend$2({}, this._infoWindow.options);
      this._infoWindow.addTo(this);
      return this;
    }
    this._infoWinOptions = extend$2({}, options);
    if (this._infoWindow) {
      this._infoWindow._setOptions(options);
    } else if (this.getMap()) {
      this._bindInfoWindow();
    }
    return this;
  },
  getInfoWindow: function getInfoWindow() {
    if (!this._infoWindow) {
      return null;
    }
    return this._infoWindow;
  },
  openInfoWindow: function openInfoWindow(coordinate) {
    if (!this.getMap()) {
      return this;
    }
    if (!coordinate) {
      coordinate = this.getCenter();
    }
    if (!this._infoWindow) {
      if (this._infoWinOptions && this.getMap()) {
        this._bindInfoWindow();
        this._infoWindow.show(coordinate);
      }
    } else {
      this._infoWindow.show(coordinate);
    }
    return this;
  },
  closeInfoWindow: function closeInfoWindow() {
    if (this._infoWindow) {
      this._infoWindow.hide();
    }
    return this;
  },
  removeInfoWindow: function removeInfoWindow() {
    this._unbindInfoWindow();
    delete this._infoWinOptions;
    delete this._infoWindow;
    return this;
  },
  _bindInfoWindow: function _bindInfoWindow() {
    var options = this._infoWinOptions;
    if (!options) {
      return this;
    }
    this._infoWindow = new InfoWindow(options);
    this._infoWindow.addTo(this);
    return this;
  },
  _unbindInfoWindow: function _unbindInfoWindow() {
    if (this._infoWindow) {
      this.closeInfoWindow();
      this._infoWindow.remove();
      delete this._infoWindow;
    }
    return this;
  }
});

Geometry.fromJSON = function (json) {
  if (Array.isArray(json)) {
    var result = [];
    for (var i = 0, len = json.length; i < len; i++) {
      var c = Geometry.fromJSON(json[i]);
      if (Array.isArray(json)) {
        result = result.concat(c);
      } else {
        result.push(c);
      }
    }
    return result;
  }
  if (json && !json['feature']) {
    return GeoJSON.toGeometry(json);
  }
  var geometry;
  if (json['subType']) {
    geometry = Geometry.getJSONClass(json['subType']).fromJSON(json);
    if (!isNil(json['feature']['id'])) {
      geometry.setId(json['feature']['id']);
    }
  } else {
    geometry = GeoJSON.toGeometry(json['feature']);
    if (json['options']) {
      geometry.config(json['options']);
    }
  }
  if (json['symbol']) {
    geometry.setSymbol(json['symbol']);
  }
  if (json['infoWindow']) {
    geometry.setInfoWindow(json['infoWindow']);
  }
  return geometry;
};

var TEMP_POINT1 = new Point(0, 0);
var TEMP_POINT2 = new Point(0, 0);
var EMPTY_ARRAY = [];
var TileWorkerConnection = function (_Actor) {
  function TileWorkerConnection() {
    return _Actor.call(this, imageFetchWorkerKey) || this;
  }
  _inheritsLoose(TileWorkerConnection, _Actor);
  var _proto = TileWorkerConnection.prototype;
  _proto.checkUrl = function checkUrl(url) {
    if (!url || !isString(url)) {
      return url;
    }
    return getAbsoluteURL(url);
  };
  _proto.fetchImage = function fetchImage(url, workerId, cb, fetchOptions) {
    url = this.checkUrl(url);
    var data = {
      url: url,
      fetchOptions: fetchOptions
    };
    this.send(data, EMPTY_ARRAY, cb, workerId);
  };
  return TileWorkerConnection;
}(Actor);
var TileLayerRenderable = function TileLayerRenderable(Base) {
  var renderable = function (_Base) {
    function renderable() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(renderable, _Base);
    var _proto2 = renderable.prototype;
    _proto2.init = function init() {
      var _this = this;
      this.version = 0;
      this.tilesInView = {};
      this.tilesLoading = {};
      this._parentTiles = [];
      this._childTiles = [];
      this._tileQueue = [];
      this._tileQueueIds = new Set();
      var tileSize = this.layer.getTileSize().width;
      this.tileCache = new LRUCache(this.layer.options['maxCacheSize'] * tileSize / 512 * tileSize / 512, function (tile) {
        _this.deleteTile(tile);
      });
      if (Browser$1.decodeImageInWorker && this.layer.options['decodeImageInWorker'] && (this.layer.options['renderer'] === 'gl' || !Browser$1.safari && !Browser$1.iosWeixin)) {
        this._tileImageWorkerConn = new TileWorkerConnection();
      }
      this._compareTiles = compareTiles.bind(this);
    };
    _proto2.getCurrentTileZoom = function getCurrentTileZoom() {
      return this._tileZoom;
    };
    _proto2.draw = function draw(timestamp, context) {
      var map = this.getMap();
      if (this.isDrawable && !this.isDrawable()) {
        return;
      }
      var mask2DExtent = this.prepareCanvas();
      if (mask2DExtent) {
        var layer = this.layer || {};
        var layerParent = layer.parent || {};
        if (layerParent.isMap && !mask2DExtent.intersects(this.canvasExtent2D)) {
          this.completeRender();
          return;
        }
      }
      if (this._renderTimestamp !== timestamp) {
        this._consumeTileQueue();
        this._computeAvgTileAltitude();
        this._renderTimestamp = timestamp;
      }
      var currentTiles;
      var hasFreshTiles = false;
      var frameTiles = this._frameTiles;
      if (frameTiles && timestamp === frameTiles.timestamp) {
        if (frameTiles.empty) {
          return;
        }
        currentTiles = frameTiles;
      } else {
        currentTiles = this._getTilesInCurrentFrame();
        if (!currentTiles) {
          this._frameTiles = {
            empty: true,
            timestamp: timestamp
          };
          this.completeRender();
          return;
        }
        hasFreshTiles = true;
        this._frameTiles = currentTiles;
        this._frameTiles.timestamp = timestamp;
        if (currentTiles.loadingCount) {
          this.loadTileQueue(currentTiles.tileQueue);
        }
      }
      var {
        tiles: tiles,
        childTiles: childTiles,
        parentTiles: parentTiles,
        placeholders: placeholders,
        loading: loading,
        loadingCount: loadingCount,
        missedTiles: missedTiles,
        incompleteTiles: incompleteTiles
      } = currentTiles;
      this._drawTiles(tiles, parentTiles, childTiles, placeholders, context, missedTiles, incompleteTiles);
      if (!loadingCount) {
        if (!loading) {
          if (!map.isAnimating() && (this._parentTiles.length || this._childTiles.length)) {
            this._parentTiles = [];
            this._childTiles = [];
            this.setToRedraw();
          }
          this.completeRender();
        }
      }
      if (hasFreshTiles) {
        this.retireTiles();
      }
    };
    _proto2.getTileGridsInCurrentFrame = function getTileGridsInCurrentFrame() {
      return this._frameTileGrids;
    };
    _proto2.getCurrentTimestamp = function getCurrentTimestamp() {
      return this._renderTimestamp || 0;
    };
    _proto2._getTilesInCurrentFrame = function _getTilesInCurrentFrame() {
      var map = this.getMap();
      this.map = map;
      var layer = this.layer;
      layer._spatialRef = layer.getSpatialReference();
      var terrainTileMode = layer._isPyramidMode() && layer.options['terrainTileMode'];
      var tileGrids = layer.getTiles();
      this._frameTileGrids = tileGrids;
      tileGrids = tileGrids.tileGrids;
      if (!tileGrids || !tileGrids.length) {
        layer._spatialRef = null;
        this.map = null;
        return null;
      }
      var count = tileGrids.reduce(function (acc, curr) {
        return acc + (curr && curr.tiles && curr.tiles.length || 0);
      }, 0);
      if (count >= this.tileCache.max / 2) {
        this.tileCache.setMaxSize(count * 2 + 1);
      }
      var loadingCount = 0;
      var loading = false;
      var checkedTiles = {};
      var tiles = [],
        parentTiles = [],
        parentKeys = {},
        childTiles = [],
        childKeys = {},
        placeholders = [],
        placeholderKeys = {};
      var tileQueue = {};
      var preLoadingCount = this.markTiles();
      var loadingLimit = this._getLoadLimit();
      var l = tileGrids.length;
      var isFirstRender = this._tileZoom === undefined && layer.options['currentTilesFirst'] && !this._terrainHelper;
      this._tileZoom = tileGrids[0]['zoom'];
      var missingTiles = null;
      var incompleteTiles = null;
      if (terrainTileMode) {
        missingTiles = [];
        incompleteTiles = new Map();
      }
      for (var i = 0; i < l; i++) {
        var tileGrid = tileGrids[i];
        var gridTiles = tileGrid['tiles'];
        var parents = tileGrid['parents'] || EMPTY_ARRAY;
        var parentCount = parents.length;
        var allTiles = isFirstRender ? gridTiles : mergeArray(parents, gridTiles);
        var placeholder = void 0;
        if (allTiles.length) {
          placeholder = this._generatePlaceHolder(allTiles[0].res);
        }
        for (var j = 0, _l = allTiles.length; j < _l; j++) {
          var tile = allTiles[j];
          layer._debugTile(tile, '_getTilesInCurrentFrame');
          var tileId = tile.id;
          var isParentTile = !isFirstRender && j < parentCount;
          var tileLoading = false;
          var tilesCount = tiles.length;
          if (this._isLoadingTile(tileId)) {
            tileLoading = loading = true;
            this.markCurrent(this.tilesLoading[tileId], true);
          } else {
            var cached = this.getCachedTile(tile, isParentTile);
            if (cached) {
              if (!isParentTile) {
                if (cached.image && this.isTileFadingIn(cached.image)) {
                  tileLoading = loading = true;
                  this.setToRedraw();
                }
                if (this.isTileComplete(cached)) {
                  tiles.push(cached);
                } else {
                  tileLoading = true;
                  if (terrainTileMode) {
                    incompleteTiles.set(tileId, cached);
                  }
                }
              }
            } else {
              tileLoading = loading = true;
              var hitLimit = loadingLimit && loadingCount + preLoadingCount[0] > loadingLimit;
              if (!this._tileQueueIds.has(tile.id) && !hitLimit && (!map.isInteracting() || map.isMoving() || map.isRotating())) {
                loadingCount++;
                var key = tileId;
                tileQueue[key] = tile;
              }
            }
          }
          if (terrainTileMode && !isParentTile) {
            if (tiles.length === tilesCount) {
              missingTiles.push(tile);
            } else {
              checkedTiles[tile.id] = 1;
            }
          }
          if (terrainTileMode) continue;
          if (isParentTile) continue;
          if (!tileLoading) continue;
          if (checkedTiles[tileId]) continue;
          checkedTiles[tileId] = 1;
          if (placeholder && !placeholderKeys[tileId]) {
            tile.cache = false;
            placeholders.push({
              image: placeholder,
              info: tile
            });
            placeholderKeys[tileId] = 1;
          }
          var children = this._findChildTiles(tile);
          if (children.length) {
            children.forEach(function (c) {
              if (!childKeys[c.info.id]) {
                childTiles.push(c);
                childKeys[c.info.id] = 1;
              }
            });
          }
          if (!children.length || children.length !== 4) {
            var parentTile = this._findParentTile(tile);
            if (parentTile) {
              var parentId = parentTile.info.id;
              if (parentKeys[parentId] === undefined) {
                parentKeys[parentId] = parentTiles.length;
                parentTiles.push(parentTile);
              }
            }
          }
        }
      }
      var missedTiles = [];
      if (terrainTileMode) {
        for (var _i = 0; _i < missingTiles.length; _i++) {
          var _tile = missingTiles[_i].info ? missingTiles[_i].info : missingTiles[_i];
          if (!_tile.parent || checkedTiles[_tile.id]) {
            continue;
          }
          var {
            tiles: _children,
            missedTiles: childMissedTiles
          } = this._findChildTiles(_tile);
          if (_children.length) {
            pushIn(tiles, _children);
            pushIn(missedTiles, childMissedTiles);
            continue;
          } else if (incompleteTiles.has(_tile.id)) {
            tiles.push(incompleteTiles.get(_tile.id));
            incompleteTiles["delete"](_tile.id);
            continue;
          }
          checkedTiles[_tile.id] = 1;
          missedTiles.push(_tile);
        }
      }
      this.tileCache.shrink();
      layer._spatialRef = null;
      this.map = null;
      return {
        childTiles: childTiles,
        missedTiles: missedTiles,
        parentTiles: parentTiles,
        tiles: tiles,
        incompleteTiles: incompleteTiles && Array.from(incompleteTiles.values()),
        placeholders: placeholders,
        loading: loading,
        loadingCount: loadingCount,
        tileQueue: tileQueue
      };
    };
    _proto2.removeTileCache = function removeTileCache(tileId) {
      delete this.tilesInView[tileId];
      this.tileCache.remove(tileId);
    };
    _proto2.isTileCachedOrLoading = function isTileCachedOrLoading(tileId) {
      return this.tileCache.get(tileId) || this.tilesInView[tileId] || this.tilesLoading[tileId];
    };
    _proto2.isTileCached = function isTileCached(tileId) {
      return !!(this.tileCache.get(tileId) || this.tilesInView[tileId]);
    };
    _proto2.isTileFadingIn = function isTileFadingIn(tileImage) {
      return this.getTileFadingOpacity(tileImage) < 1;
    };
    _proto2._drawTiles = function _drawTiles(tiles, parentTiles, childTiles, placeholders, parentContext, missedTiles, incompleteTiles) {
      if (parentTiles.length) {
        parentTiles.sort(this._compareTiles);
        this._parentTiles = parentTiles;
      }
      if (childTiles.length) {
        this._childTiles = childTiles;
        this._childTiles.sort(this._compareTiles);
      }
      var map = this.getMap();
      var mapCanvas = map.getRenderer().canvas;
      var drawBackground = true;
      var frameTileState = mapCanvas._frameTileState;
      if (!frameTileState) {
        frameTileState = mapCanvas._frameTileState = {
          timestamp: 0,
          count: 0
        };
      }
      if (this.layer.constructor === TileLayer || this.layer.constructor === WMSTileLayer) {
        if (this._renderTimestamp === frameTileState.timestamp && frameTileState.count > map.options['tileBackgroundLimitPerFrame']) {
          drawBackground = false;
        } else {
          if (this._renderTimestamp !== frameTileState.timestamp) {
            frameTileState.timestamp = this._renderTimestamp;
            frameTileState.count = 1;
          } else {
            frameTileState.count++;
          }
        }
      }
      var context = {
        tiles: tiles,
        parentTiles: this._parentTiles,
        childTiles: this._childTiles,
        parentContext: parentContext
      };
      this.onDrawTileStart(context, parentContext);
      if (drawBackground && this.layer.options['opacity'] === 1) {
        this.layer._silentConfig = true;
        var fadingAnimation = this.layer.options['fadeAnimation'];
        this.layer.options['fadeAnimation'] = false;
        this._drawChildTiles(childTiles, parentContext);
        this._drawParentTiles(this._parentTiles, parentContext);
        this.layer.options['fadeAnimation'] = fadingAnimation;
        this.layer._silentConfig = false;
      }
      this.drawingCurrentTiles = true;
      tiles.sort(this._compareTiles);
      this._drawCurrentTiles(tiles, parentContext);
      delete this.drawingCurrentTiles;
      if (drawBackground && this.layer.options['opacity'] < 1) {
        this.layer._silentConfig = true;
        var _fadingAnimation = this.layer.options['fadeAnimation'];
        this.layer.options['fadeAnimation'] = false;
        this._drawChildTiles(childTiles, parentContext);
        this._drawParentTiles(this._parentTiles, parentContext);
        this.layer.options['fadeAnimation'] = _fadingAnimation;
        this.layer._silentConfig = false;
      }
      this.onDrawTileEnd(context, parentContext);
    };
    _proto2._drawCurrentTiles = function _drawCurrentTiles(tiles, parentContext) {
      for (var i = 0, l = tiles.length; i < l; i++) {
        this._drawTileAndCache(tiles[i], parentContext);
      }
    };
    _proto2._drawChildTiles = function _drawChildTiles(childTiles, parentContext) {
      var _this2 = this;
      this.drawingChildTiles = true;
      childTiles.forEach(function (t) {
        return _this2._drawTile(t.info, t.image, parentContext);
      });
      delete this.drawingChildTiles;
    };
    _proto2._drawParentTiles = function _drawParentTiles(parentTiles, parentContext) {
      var _this3 = this;
      this.drawingParentTiles = true;
      parentTiles.forEach(function (t) {
        return _this3._drawTile(t.info, t.image, parentContext);
      });
      delete this.drawingParentTiles;
    };
    _proto2.onDrawTileStart = function onDrawTileStart(context, parentContext) {};
    _proto2.onDrawTileEnd = function onDrawTileEnd(context, parentContext) {};
    _proto2._drawTile = function _drawTile(info, image, parentContext) {
      if (image) {
        this.drawTile(info, image, parentContext);
      }
    };
    _proto2.drawTile = function drawTile(tileInfo, tileImage, parentContext) {};
    _proto2._drawTileAndCache = function _drawTileAndCache(tile, parentContext) {
      if (this.isValidCachedTile(tile)) {
        this.tilesInView[tile.info.id] = tile;
      }
      this._drawTile(tile.info, tile.image, parentContext);
    };
    _proto2.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
      this.draw(timestamp, context);
    };
    _proto2.checkIfNeedRedraw = function checkIfNeedRedraw() {
      return !!this._tileQueue.length;
    };
    _proto2.hitDetect = function hitDetect() {
      return false;
    };
    _proto2._getLoadLimit = function _getLoadLimit() {
      var map = this.map || this.getMap();
      if (map.isInteracting()) {
        return this.layer.options['loadingLimitOnInteracting'];
      }
      return this.layer.options['loadingLimit'] || 0;
    };
    _proto2._isLoadingTile = function _isLoadingTile(tileId) {
      return !!this.tilesLoading[tileId];
    };
    _proto2.loadTileQueue = function loadTileQueue(tileQueue) {
      for (var p in tileQueue) {
        if (tileQueue.hasOwnProperty(p)) {
          var tile = tileQueue[p];
          var tileImage = this.loadTile(tile);
          if (tileImage.loadTime === undefined) {
            if (!tileImage._empty) {
              this.tilesLoading[tile['id']] = {
                image: tileImage,
                current: true,
                info: tile
              };
            }
          }
        }
      }
    };
    _proto2.loadTile = function loadTile(tile) {
      var _this4 = this;
      var tileImage = {};
      if (this.loadTileBitmap && isFunction(this.loadTileBitmap)) {
        var onLoad = function onLoad(bitmap) {
          _this4.onTileLoad(bitmap, tile);
        };
        var onError = function onError(error, image) {
          _this4.onTileError(image, tile, error);
        };
        this.loadTileBitmap(tile['url'], tile, onLoad, onError);
      } else if (this._tileImageWorkerConn && this.loadTileImage === this.constructor.prototype.loadTileImage) {
        this._fetchImage(tileImage, tile);
      } else {
        var tileSize = this.layer.getTileSize(tile.layer);
        tileImage = new Image();
        tileImage.width = tileSize['width'];
        tileImage.height = tileSize['height'];
        tileImage.onload = function () {
          if (Browser$1.decodeImageInWorker) {
            createImageBitmap(tileImage).then(function (imagebit) {
              _this4.onTileLoad(imagebit, tile);
            })["catch"](function (error) {
              console.error(error);
              _this4.onTileLoad(tileImage, tile);
            });
          } else {
            _this4.onTileLoad(tileImage, tile);
          }
        };
        tileImage.onerror = this.onTileError.bind(this, tileImage, tile);
        this.loadTileImage(tileImage, tile['url'], tile);
      }
      return tileImage;
    };
    _proto2._fetchImage = function _fetchImage(image, tile) {
      var _this5 = this;
      if (image instanceof Image) {
        image.src = tile.url;
      } else {
        var {
          x: x,
          y: y
        } = tile;
        var workerId = Math.abs(x + y) % this._tileImageWorkerConn.workers.length;
        this._tileImageWorkerConn.fetchImage(tile.url, workerId, function (err, data) {
          if (err) {
            _this5.onTileError(image, tile, err);
          } else {
            getImageBitMap(data, function (bitmap) {
              _this5.onTileLoad(bitmap, tile);
            });
          }
        }, this.layer.options['fetchOptions'] || {
          referrer: document.location.href,
          headers: {
            accept: 'image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8'
          }
        });
      }
    };
    _proto2.loadTileImage = function loadTileImage(tileImage, url, tile) {
      var crossOrigin = this.layer.options['crossOrigin'];
      if (!isNil(crossOrigin)) {
        tileImage.crossOrigin = crossOrigin;
      }
      return loadImage(tileImage, [url]);
    };
    _proto2.abortTileLoading = function abortTileLoading(tileImage, tileInfo) {
      if (tileInfo && tileInfo.id !== undefined) {
        this.removeTileLoading(tileInfo);
      }
      if (!tileImage) return;
      if (tileImage instanceof Image) {
        tileImage.onload = falseFn;
        tileImage.onerror = falseFn;
        tileImage.src = emptyImageUrl;
      }
      if (this.loadTileBitmap && isFunction(this.loadTileBitmap)) {
        var url = tileInfo.url;
        this.loadTileBitmap(url, tileInfo, function () {}, {
          command: 'abortTile'
        });
      }
    };
    _proto2.onTileLoad = function onTileLoad(tileImage, tileInfo) {
      this.removeTileLoading(tileInfo);
      this._tileQueue.push({
        tileInfo: tileInfo,
        tileData: tileImage
      });
      this._tileQueueIds.add(tileInfo.id);
      this.setToRedraw();
    };
    _proto2.removeTileLoading = function removeTileLoading(tileInfo) {
      if (this.tilesLoading[tileInfo.id]) {
        delete this.tilesLoading[tileInfo.id];
      }
      this.setToRedraw();
    };
    _proto2._consumeTileQueue = function _consumeTileQueue() {
      var count = 0;
      var limit = this.layer.options['tileLimitPerFrame'];
      var queue = this._tileQueue;
      while (queue.length && (limit <= 0 || count < limit)) {
        var {
          tileData: tileData,
          tileInfo: tileInfo
        } = queue.shift();
        if (!this._tileQueueIds.has(tileInfo.id)) {
          continue;
        }
        this._tileQueueIds["delete"](tileInfo.id);
        if (!this.checkTileInQueue(tileData, tileInfo)) {
          continue;
        }
        this.consumeTile(tileData, tileInfo);
        count++;
      }
    };
    _proto2._computeAvgTileAltitude = function _computeAvgTileAltitude() {
      var sumMin = 0;
      var sumMax = 0;
      var count = 0;
      for (var p in this.tilesInView) {
        var info = this.tilesInView[p] && this.tilesInView[p].info;
        if (info) {
          sumMin += info.minAltitude || 0;
          sumMax += info.maxAltitude || 0;
          count++;
        }
      }
      this.avgMinAltitude = sumMin / count;
      this.avgMaxAltitude = sumMax / count;
    };
    _proto2.checkTileInQueue = function checkTileInQueue(tileImage, tileInfo) {
      return true;
    };
    _proto2.consumeTile = function consumeTile(tileImage, tileInfo) {
      if (!this.layer) {
        return;
      }
      if (!this.tilesInView) {
        return;
      }
      var e = {
        tile: tileInfo,
        tileImage: tileImage
      };
      tileImage = e.tileImage;
      this.resetTileLoadTime(tileImage);
      this.removeTileLoading(tileInfo);
      this._addTileToCache(tileInfo, tileImage);
      this.layer.fire('tileload', e);
      this.setToRedraw();
    };
    _proto2.resetTileLoadTime = function resetTileLoadTime(tileImage) {
      if (tileImage.loadTime !== 0) {
        tileImage.loadTime = now();
      }
    };
    _proto2.onTileError = function onTileError(tileImage, tileInfo, error) {
      if (!this.layer) {
        return;
      }
      var reloadErrorTileFunction = this.layer.options['reloadErrorTileFunction'];
      if (reloadErrorTileFunction) {
        reloadErrorTileFunction.call(this, this.layer, this, tileInfo, tileImage);
        return;
      }
      var errorUrl = this.layer.options['errorUrl'];
      var isFetchError = !(tileImage instanceof Image);
      if (errorUrl) {
        if (tileImage instanceof Image && tileImage.src !== errorUrl) {
          tileImage.src = errorUrl;
          this.removeTileLoading(tileInfo);
          return;
        } else {
          tileImage = new Image();
          tileImage.src = errorUrl;
        }
      }
      this.abortTileLoading(tileImage, tileInfo);
      tileImage.loadTime = 0;
      if (isFetchError) {
        tileImage.fetchErrorTime = now();
      }
      this.removeTileLoading(tileInfo);
      this._addTileToCache(tileInfo, tileImage);
      this.setToRedraw();
      this.layer.fire('tileerror', {
        tile: tileInfo
      });
    };
    _proto2.getDebugInfo = function getDebugInfo(tileId) {
      var xyz = tileId.split('_');
      var length = xyz.length;
      return xyz[length - 3] + '/' + xyz[length - 2] + '/' + xyz[length - 1];
    };
    _proto2.findChildTiles = function findChildTiles(info) {
      return this._findChildTiles(info);
    };
    _proto2._findChildTiles = function _findChildTiles(info) {
      var layer = this._getLayerOfTile(info.layer);
      var isPyramidMode = layer._isPyramidMode();
      var terrainTileMode = layer && layer.options['terrainTileMode'] && isPyramidMode;
      if (!layer || !layer.options['background'] && !terrainTileMode || info.z > this.layer.getMaxZoom()) {
        return EMPTY_ARRAY;
      }
      var map = this.map || this.getMap();
      var children = [];
      if (isPyramidMode) {
        if (!terrainTileMode) {
          var _zoomDiff = 2;
          var _cx = info.x * 2;
          var _cy = info.y * 2;
          var _cz = info.z + 1;
          var queue = [];
          for (var j = 0; j < 2; j++) {
            for (var jj = 0; jj < 2; jj++) {
              queue.push(_cx + j, _cy + jj, _cz);
            }
          }
          while (queue.length) {
            var z = queue.pop();
            var y = queue.pop();
            var x = queue.pop();
            var id = layer._getTileId(x, y, z, info.layer);
            var canVisit = z + 1 <= info.z + _zoomDiff;
            var tile = this.tileCache.getAndRemove(id);
            if (tile) {
              if (this.isValidCachedTile(tile)) {
                children.push(tile);
                this.tileCache.add(id, tile);
              } else if (canVisit) {
                for (var _j = 0; _j < 2; _j++) {
                  for (var _jj = 0; _jj < 2; _jj++) {
                    queue.push(x * 2 + _j, y * 2 + _jj, z + 1);
                  }
                }
              }
            } else if (canVisit) {
              for (var _j2 = 0; _j2 < 2; _j2++) {
                for (var _jj2 = 0; _jj2 < 2; _jj2++) {
                  queue.push(x * 2 + _j2, y * 2 + _jj2, z + 1);
                }
              }
            }
          }
          return children;
        }
        var missedTiles;
        if (terrainTileMode) {
          missedTiles = [];
        }
        var cx = info.x * 2;
        var cy = info.y * 2;
        var cz = info.z + 1;
        var candidates = [];
        for (var i = 0; i < 2; i++) {
          for (var ii = 0; ii < 2; ii++) {
            var _x = cx + i;
            var _y = cy + ii;
            var _z = cz;
            var _id = layer._getTileId(_x, _y, _z, info.layer);
            var _tile2 = this.tileCache.getAndRemove(_id);
            if (_tile2 && this.isValidCachedTile(_tile2)) {
              children.push(_tile2);
              this.tileCache.add(_id, _tile2);
              candidates.push(null);
            } else {
              candidates.push(_id);
            }
          }
        }
        if (children.length < 4) {
          var index = 0;
          for (var _i2 = 0; _i2 < 2; _i2++) {
            for (var _ii = 0; _ii < 2; _ii++) {
              var _id2 = candidates[index++];
              if (!_id2) {
                continue;
              }
              var _x2 = cx + _i2;
              var _y2 = cy + _ii;
              var _z2 = cz;
              var childrenCount = children.length;
              var childCandidates = [];
              for (var _j3 = 0; _j3 < 2; _j3++) {
                for (var _jj3 = 0; _jj3 < 2; _jj3++) {
                  var xx = _x2 * 2 + _j3;
                  var yy = _y2 * 2 + _jj3;
                  var zz = _z2 + 1;
                  var _id3 = layer._getTileId(xx, yy, zz, info.layer);
                  var childTile = this.tileCache.getAndRemove(_id3);
                  if (childTile && this.isValidCachedTile(childTile)) {
                    children.push(childTile);
                    this.tileCache.add(_id3, childTile);
                    childCandidates.push(null);
                  } else {
                    childCandidates.push(_id3);
                  }
                }
              }
              if (!terrainTileMode) {
                continue;
              }
              if (children.length - childrenCount < 4) {
                var childTileInfo = layer.tileInfoCache.get(_id2) || layer._createChildNode(info, _i2, _ii, [0, 0], _id2);
                if (children.length - childrenCount === 0) {
                  missedTiles.push(childTileInfo);
                } else {
                  var _index = 0;
                  for (var _j4 = 0; _j4 < 2; _j4++) {
                    for (var _jj4 = 0; _jj4 < 2; _jj4++) {
                      var _id4 = childCandidates[_index++];
                      if (!_id4) {
                        continue;
                      }
                      var grandsonTileInfo = this.layer.tileInfoCache.get(_id4) || layer._createChildNode(childTileInfo, _j4, _jj4, [0, 0], _id4);
                      missedTiles.push(grandsonTileInfo);
                    }
                  }
                }
              }
            }
          }
        }
        return terrainTileMode ? {
          tiles: children,
          missedTiles: missedTiles
        } : children;
      }
      var zoomDiff = 1;
      var res = info.res;
      var min = info.extent2d.getMin(),
        max = info.extent2d.getMax(),
        pmin = layer._project(map._pointToPrjAtRes(min, res, TEMP_POINT1), TEMP_POINT1),
        pmax = layer._project(map._pointToPrjAtRes(max, res, TEMP_POINT2), TEMP_POINT2);
      for (var _i3 = 1; _i3 < zoomDiff; _i3++) {
        this._findChildTilesAt(children, pmin, pmax, layer, info.z + _i3);
      }
      return children;
    };
    _proto2._findChildTilesAt = function _findChildTilesAt(children, pmin, pmax, layer, childZoom) {
      var sr = layer._spatialRef || layer.getSpatialReference();
      var layerId = layer.getId(),
        res = sr.getResolution(childZoom);
      if (!res) {
        return;
      }
      var getTileConfig = layer._getTileConfig();
      var dmin = getTileConfig.getTileIndex(pmin, res),
        dmax = getTileConfig.getTileIndex(pmax, res);
      var sx = Math.min(dmin.idx, dmax.idx),
        ex = Math.max(dmin.idx, dmax.idx);
      var sy = Math.min(dmin.idy, dmax.idy),
        ey = Math.max(dmin.idy, dmax.idy);
      var id, tile;
      for (var i = sx; i < ex; i++) {
        for (var ii = sy; ii < ey; ii++) {
          id = layer._getTileId(i, ii, childZoom, layerId);
          tile = this.tileCache.getAndRemove(id);
          if (tile) {
            if (this.isValidCachedTile(tile)) {
              children.push(tile);
              this.tileCache.add(id, tile);
            }
          }
        }
      }
    };
    _proto2.findParentTile = function findParentTile(info, targetDiff) {
      return this._findParentTile(info, targetDiff);
    };
    _proto2._findParentTile = function _findParentTile(info, targetDiff) {
      var map = this.map || this.getMap(),
        layer = this._getLayerOfTile(info.layer);
      if (!layer || !layer.options['background'] && !layer.options['terrainTileMode']) {
        return null;
      }
      var minZoom = layer.getMinZoom();
      var zoomDiff = targetDiff || info.z - minZoom;
      if (layer._isPyramidMode()) {
        var endZoom = info.z - zoomDiff;
        for (var z = info.z - 1; z >= endZoom; z--) {
          var diff = info.z - z;
          var scale = Math.pow(2, diff);
          var x = Math.floor(info.x / scale);
          var y = Math.floor(info.y / scale);
          var id = void 0;
          if (z === info.z - 1) {
            id = info.parent;
          } else {
            id = layer._getTileId(x, y, z, info.layer);
          }
          var tile = this.tileCache.getAndRemove(id);
          if (tile) {
            if (this.isValidCachedTile(tile)) {
              this.tileCache.add(id, tile);
              return tile;
            }
          }
        }
        return null;
      }
      var sr = layer.getSpatialReference();
      var d = sr.getZoomDirection();
      var res = info.res;
      var center = info.extent2d.getCenter(),
        prj = layer._project(map._pointToPrjAtRes(center, res));
      for (var _diff = 1; _diff <= zoomDiff; _diff++) {
        var _z3 = info.z - d * _diff;
        var _res = sr.getResolution(_z3);
        if (!_res) continue;
        var tileIndex = layer._getTileConfig().getTileIndex(prj, _res);
        var _id5 = layer._getTileId(tileIndex.x, tileIndex.y, _z3, info.layer);
        var _tile3 = this.tileCache.getAndRemove(_id5);
        if (_tile3) {
          this.tileCache.add(_id5, _tile3);
          return _tile3;
        }
      }
      return null;
    };
    _proto2.isValidCachedTile = function isValidCachedTile(tile) {
      return !!tile.image;
    };
    _proto2.isTileComplete = function isTileComplete(tile) {
      return true;
    };
    _proto2._getLayerOfTile = function _getLayerOfTile(layerId) {
      return this.layer.getChildLayer ? this.layer.getChildLayer(layerId) : this.layer;
    };
    _proto2.getCachedTile = function getCachedTile(tile, isParent) {
      var tileId = tile.id;
      var tilesInView = this.tilesInView;
      var cached = this.tileCache.getAndRemove(tileId);
      if (cached) {
        if (!isParent) {
          tilesInView[tileId] = cached;
        }
        var tilesLoading = this.tilesLoading;
        if (tilesLoading && tilesLoading[tileId]) {
          this.markCurrent(tilesLoading[tileId], false);
          var {
            image: image,
            info: info
          } = tilesLoading[tileId];
          this.abortTileLoading(image, info);
          delete tilesLoading[tileId];
        }
      } else {
        cached = tilesInView[tileId];
      }
      if (cached) {
        cached.current = true;
        if (this.isValidCachedTile(cached)) {
          this.tileCache.add(tileId, cached);
        }
      }
      return cached;
    };
    _proto2._addTileToCache = function _addTileToCache(tileInfo, tileImage) {
      if (this.isValidCachedTile({
        info: tileInfo,
        image: tileImage
      })) {
        var cached = {
          image: tileImage,
          info: tileInfo
        };
        this.tileCache.add(tileInfo.id, cached);
      }
    };
    _proto2.getTileOpacity = function getTileOpacity(tileImage, tileInfo) {
      var opacity = this.getTileFadingOpacity(tileImage);
      if (this.layer.getChildLayer) {
        var childLayer = this.layer.getLayer(tileInfo.layer);
        if (childLayer) {
          opacity *= childLayer.options['opacity'];
        }
      }
      return opacity;
    };
    _proto2.getTileFadingOpacity = function getTileFadingOpacity(tileImage) {
      if (!this.layer.options['fadeAnimation'] || !tileImage.loadTime) {
        return 1;
      }
      return Math.min(1, (now() - tileImage.loadTime) / this.layer.options['fadeDuration']);
    };
    _proto2.clearTileCaches = function clearTileCaches() {
      this.version++;
      this.retireTiles(true);
      this.tileCache.reset();
      this.tilesInView = {};
      this.tilesLoading = {};
      this._tileQueue = [];
      this._tileQueueIds.clear();
      this._parentTiles = [];
      this._childTiles = [];
    };
    _proto2.removeTileCaches = function removeTileCaches() {
      delete this.tileCache;
      delete this._tilePlaceHolder;
      delete this._tileZoom;
    };
    _proto2.markCurrent = function markCurrent(tile, isCurrent) {
      tile.current = isCurrent;
    };
    _proto2.markTiles = function markTiles() {
      var a = 0,
        b = 0;
      if (this.tilesLoading) {
        for (var p in this.tilesLoading) {
          this.markCurrent(this.tilesLoading[p], false);
          a++;
        }
      }
      if (this.tilesInView) {
        for (var _p in this.tilesInView) {
          this.markCurrent(this.tilesInView[_p], false);
          b++;
        }
      }
      return [a, b];
    };
    _proto2.retireTiles = function retireTiles(force) {
      for (var i in this.tilesLoading) {
        var tile = this.tilesLoading[i];
        if (force || !tile.current) {
          if (tile.image) {
            this.abortTileLoading(tile.image, tile.info);
          }
          this.deleteTile(tile);
          this.removeTileLoading(tile.info);
        }
      }
      for (var _i4 in this.tilesInView) {
        var _tile4 = this.tilesInView[_i4];
        if (force || !_tile4.current) {
          delete this.tilesInView[_i4];
          if (!this.tileCache.has(_i4)) {
            this.deleteTile(_tile4);
          }
        }
      }
    };
    _proto2.deleteTile = function deleteTile(tile) {
      if (!tile || !tile.image) {
        return;
      }
      var tileId = tile.info.id;
      if (this._tileQueueIds.has(tileId)) {
        this._tileQueueIds["delete"](tileId);
      }
      if (tile.image.close) {
        tile.image.close();
      }
      if (tile.image instanceof Image) {
        tile.image.onload = null;
        tile.image.onerror = null;
      }
      var layer = this.layer;
      if (layer) {
        layer.fire('tiledelete', {
          tile: tile.info,
          tileImage: tile.image
        });
      }
    };
    _proto2._generatePlaceHolder = function _generatePlaceHolder(res) {
      var map = this.map || this.getMap();
      var placeholder = this.layer.options['placeholder'];
      if (!placeholder || map.getPitch()) {
        return null;
      }
      var tileSize = this.layer.getTileSize();
      var scale = res / map._getResolution();
      var canvas = this._tilePlaceHolder = this._tilePlaceHolder || Canvas.createCanvas(1, 1, map.CanvasClass);
      canvas.width = tileSize.width * scale;
      canvas.height = tileSize.height * scale;
      if (isFunction(placeholder)) {
        placeholder(canvas);
      } else {
        defaultPlaceholder(canvas);
      }
      return canvas;
    };
    _proto2.setTerrainHelper = function setTerrainHelper(helper) {
      this._terrainHelper = helper;
    };
    _proto2._validateTileImage = function _validateTileImage(image) {
      if (!image) {
        return;
      }
      if (image.fetchErrorTime) {
        return false;
      }
      return true;
    };
    return renderable;
  }(Base);
  return renderable;
};
function falseFn() {
  return false;
}
function defaultPlaceholder(canvas) {
  var ctx = canvas.getContext('2d'),
    cw = canvas.width,
    ch = canvas.height,
    w = cw / 16,
    h = ch / 16;
  ctx.beginPath();
  for (var i = 0; i < 16; i++) {
    ctx.moveTo(0, i * h);
    ctx.lineTo(cw, i * h);
    ctx.moveTo(i * w, 0);
    ctx.lineTo(i * w, ch);
  }
  ctx.strokeStyle = 'rgba(180, 180, 180, 0.1)';
  ctx.lineWidth = 1;
  ctx.stroke();
  ctx.beginPath();
  var path = [[0, 0], [cw, 0], [0, ch], [cw, ch], [0, 0], [0, ch], [cw, 0], [cw, ch], [0, ch / 2], [cw, ch / 2], [cw / 2, 0], [cw / 2, ch]];
  for (var _i5 = 1; _i5 < path.length; _i5 += 2) {
    ctx.moveTo(path[_i5 - 1][0], path[_i5 - 1][1]);
    ctx.lineTo(path[_i5][0], path[_i5][1]);
  }
  ctx.lineWidth = 1 * 4;
  ctx.stroke();
}
function compareTiles(a, b) {
  return Math.abs(this._tileZoom - a.info.z) - Math.abs(this._tileZoom - b.info.z);
}

var TILE_POINT$1 = new Point(0, 0);
var TEMP_POINT = new Point(0, 0);
var TileLayerCanvasRenderer = function (_TileLayerRenderable) {
  function TileLayerCanvasRenderer(layer) {
    var _this;
    _this = _TileLayerRenderable.call(this, layer) || this;
    _this.init();
    return _this;
  }
  _inheritsLoose(TileLayerCanvasRenderer, _TileLayerRenderable);
  var _proto = TileLayerCanvasRenderer.prototype;
  _proto._drawTiles = function _drawTiles(tiles, parentTiles, childTiles, placeholders, parentContext, missedTiles, incompleteTiles) {
    var _this2 = this;
    if (parentTiles.length) {
      parentTiles.sort(this._compareTiles);
      this._parentTiles = parentTiles;
    }
    if (childTiles.length) {
      this._childTiles = childTiles;
      this._childTiles.sort(this._compareTiles);
    }
    var drawBackground = true;
    var backgroundTimestamp = this.canvas._parentTileTimestamp;
    if (this.layer.constructor === TileLayer || this.layer.constructor === WMSTileLayer) {
      if (this._renderTimestamp === backgroundTimestamp) {
        drawBackground = false;
      } else {
        this.canvas._parentTileTimestamp = this._renderTimestamp;
      }
    }
    var renderInGL = this.layer.options.renderer === 'gl' && (!this.isGL || this.isGL());
    var context = {
      tiles: tiles,
      parentTiles: this._parentTiles,
      childTiles: this._childTiles,
      parentContext: parentContext
    };
    this.onDrawTileStart(context, parentContext);
    if (drawBackground && this.layer.options['opacity'] === 1) {
      this.layer._silentConfig = true;
      var fadingAnimation = this.layer.options['fadeAnimation'];
      this.layer.options['fadeAnimation'] = false;
      if (renderInGL) {
        this._drawChildTiles(childTiles, parentContext);
        this._drawParentTiles(this._parentTiles, parentContext);
      } else {
        this._drawParentTiles(this._parentTiles, parentContext);
        this._drawChildTiles(childTiles, parentContext);
      }
      this.layer.options['fadeAnimation'] = fadingAnimation;
      this.layer._silentConfig = false;
    }
    this.drawingCurrentTiles = true;
    tiles.sort(this._compareTiles);
    for (var i = 0, l = tiles.length; i < l; i++) {
      this._drawTileAndCache(tiles[i], parentContext);
    }
    delete this.drawingCurrentTiles;
    if (drawBackground && this.layer.options['opacity'] < 1) {
      this.layer._silentConfig = true;
      var _fadingAnimation = this.layer.options['fadeAnimation'];
      this.layer.options['fadeAnimation'] = false;
      if (renderInGL) {
        this._drawChildTiles(childTiles, parentContext);
        this._drawParentTiles(this._parentTiles, parentContext);
      } else {
        this._drawParentTiles(this._parentTiles, parentContext);
        this._drawChildTiles(childTiles, parentContext);
      }
      this.layer.options['fadeAnimation'] = _fadingAnimation;
      this.layer._silentConfig = false;
    }
    placeholders.forEach(function (t) {
      return _this2._drawTile(t.info, t.image, parentContext);
    });
    this.onDrawTileEnd(context, parentContext);
  };
  _proto.needToRedraw = function needToRedraw() {
    var map = this.getMap();
    if (this.checkIfNeedRedraw()) {
      return true;
    }
    if (map.getPitch()) {
      return _TileLayerRenderable.prototype.needToRedraw.call(this);
    }
    if (map.isRotating() || map.isZooming()) {
      return true;
    }
    if (map.isMoving()) {
      return !!this.layer.options['forceRenderOnMoving'];
    }
    return _TileLayerRenderable.prototype.needToRedraw.call(this);
  };
  _proto.isDrawable = function isDrawable() {
    if (this.getMap().getPitch()) {
      if (console) {
        console.warn('TileLayer with canvas renderer can\'t be pitched, use gl renderer (\'renderer\' : \'gl\') instead.');
      }
      this.clear();
      return false;
    }
    return true;
  };
  _proto.clipCanvas = function clipCanvas(context) {
    return _TileLayerRenderable.prototype.clipCanvas.call(this, context);
  };
  _proto.clear = function clear() {
    this.clearTileCaches();
    _TileLayerRenderable.prototype.clear.call(this);
  };
  _proto.onRemove = function onRemove() {
    this.clear();
    this.removeTileCaches();
    _TileLayerRenderable.prototype.onRemove.call(this);
  };
  _proto.drawTile = function drawTile(tileInfo, tileImage, parentContext) {
    if (!this._validateTileImage(tileImage)) {
      return;
    }
    var map = this.getMap();
    if (!map) {
      return;
    }
    var {
      extent2d: extent2d,
      offset: offset
    } = tileInfo;
    var point = TILE_POINT$1.set(extent2d.xmin - offset[0], extent2d.ymax - offset[1]),
      tileZoom = tileInfo.z,
      tileId = tileInfo.id;
    var cache = MapStateCache[map.id];
    var zoom = cache ? cache.zoom : map.getZoom(),
      ctx = this.context,
      cp = map._pointAtResToContainerPoint(point, tileInfo.res, 0, TEMP_POINT),
      bearing = cache ? cache.bearing : map.getBearing(),
      transformed = bearing || zoom !== tileZoom;
    var opacity = this.getTileOpacity(tileImage, tileInfo);
    var alpha = ctx.globalAlpha;
    if (opacity < 1) {
      ctx.globalAlpha = opacity;
    }
    if (!transformed) {
      cp._round();
    }
    var x = cp.x,
      y = cp.y;
    var w = tileInfo.extent2d.xmax - tileInfo.extent2d.xmin;
    var h = tileInfo.extent2d.ymax - tileInfo.extent2d.ymin;
    var layer = this.layer;
    var bufferPixel = layer ? layer.options.bufferPixel : 0;
    if (transformed) {
      ctx.save();
      ctx.translate(x, y);
      if (bearing) {
        ctx.rotate(-bearing * Math.PI / 180);
      }
      w += bufferPixel;
      h += bufferPixel;
      var res = map._getResolution();
      if (res !== tileInfo.res) {
        var scale = tileInfo.res / res;
        ctx.scale(scale, scale);
      }
      x = y = 0;
    }
    Canvas.image(ctx, tileImage, x, y, w, h);
    if (this.layer.options['debug']) {
      var color = this.layer.options['debugOutline'];
      ctx.save();
      ctx.strokeStyle = color;
      ctx.fillStyle = color;
      ctx.font = '20px monospace';
      var _point = new Point(x, y);
      Canvas.rectangle(ctx, _point, {
        width: w,
        height: h
      }, 1, 0);
      Canvas.fillText(ctx, this.getDebugInfo(tileId), _point._add(32, h - 14), color);
      Canvas.drawCross(ctx, x + w / 2, y + h / 2, 2, color);
      ctx.restore();
    }
    if (transformed) {
      ctx.restore();
    }
    if (ctx.globalAlpha !== alpha) {
      ctx.globalAlpha = alpha;
    }
    this.setCanvasUpdated();
  };
  return TileLayerCanvasRenderer;
}(TileLayerRenderable(CanvasRenderer$1));
TileLayer.registerRenderer('canvas', TileLayerCanvasRenderer);

var TILE_POINT = new Point(0, 0);
var MESH_TO_TEST = {
  properties: {}
};
var TileLayerGLRenderer = function (_ImageGLRenderable) {
  function TileLayerGLRenderer() {
    return _ImageGLRenderable.apply(this, arguments) || this;
  }
  _inheritsLoose(TileLayerGLRenderer, _ImageGLRenderable);
  var _proto = TileLayerGLRenderer.prototype;
  _proto.isDrawable = function isDrawable() {
    return true;
  };
  _proto.needToRedraw = function needToRedraw() {
    var map = this.getMap();
    if (this.isGL() && !map.getPitch() && map.isZooming() && !map.isMoving() && !map.isRotating()) {
      return true;
    }
    return _ImageGLRenderable.prototype.needToRedraw.call(this);
  };
  _proto.onDrawTileStart = function onDrawTileStart(context, parentContext) {
    var gl = this.gl;
    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
    gl.enable(gl.POLYGON_OFFSET_FILL);
    gl.enable(gl.STENCIL_TEST);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
    var depthMask = !!this.layer.options['depthMask'];
    gl.depthMask(depthMask);
    if (parentContext && parentContext.renderTarget) {
      var fbo = parentContext.renderTarget.fbo;
      if (fbo) {
        var framebuffer = parentContext.renderTarget.getFramebuffer(fbo);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      }
    }
  };
  _proto.onDrawTileEnd = function onDrawTileEnd(context, parentContext) {
    var gl = this.gl;
    if (parentContext && parentContext.renderTarget) {
      var fbo = parentContext.renderTarget.fbo;
      if (fbo) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      }
    }
  };
  _proto.drawTile = function drawTile(tileInfo, tileImage, parentContext) {
    if (!this._validateTileImage(tileImage)) {
      return;
    }
    if (parentContext && parentContext.sceneFilter) {
      if (!parentContext.sceneFilter(MESH_TO_TEST)) {
        return;
      }
    }
    var map = this.getMap();
    if (!tileInfo || !map || !tileImage) {
      return;
    }
    var scale = tileInfo._glScale = tileInfo._glScale || tileInfo.res / map.getGLRes();
    var w = tileInfo.extent2d.xmax - tileInfo.extent2d.xmin;
    var h = tileInfo.extent2d.ymax - tileInfo.extent2d.ymin;
    if (tileInfo.cache !== false) {
      this._bindGLBuffer(tileImage, w, h);
    }
    if (!this.isGL()) {
      _ImageGLRenderable.prototype.drawTile.call(this, tileInfo, tileImage);
      return;
    }
    var {
      extent2d: extent2d,
      offset: offset
    } = tileInfo;
    var point = TILE_POINT.set(extent2d.xmin - offset[0], tileInfo.extent2d.ymax - offset[1]);
    var x = point.x * scale,
      y = point.y * scale;
    var layerOpacity = this.layer.options['opacity'];
    layerOpacity = isNil(layerOpacity) ? 1 : layerOpacity;
    var opacity = this.getTileOpacity(tileImage, tileInfo) * layerOpacity;
    var debugInfo = null;
    if (this.layer.options['debug']) {
      debugInfo = this.getDebugInfo(tileInfo.id);
    }
    var gl = this.gl;
    gl.stencilFunc(gl.LEQUAL, Math.abs(this.getCurrentTileZoom() - tileInfo.z), 0xFF);
    var layerPolygonOffset = this.layer.getPolygonOffset();
    var polygonOffset = this.drawingCurrentTiles ? layerPolygonOffset : layerPolygonOffset + 1;
    gl.polygonOffset(polygonOffset, polygonOffset);
    this.drawGLImage(tileImage, x, y, w, h, scale, opacity, map._getResolution() !== tileInfo.res, debugInfo);
    if (this.getTileFadingOpacity(tileImage) < 1) {
      this.setToRedraw();
    } else {
      this.setCanvasUpdated();
    }
  };
  _proto._bindGLBuffer = function _bindGLBuffer(image, w, h) {
    if (!image.glBuffer) {
      image.glBuffer = this.bufferTileData(0, 0, w, h);
    }
  };
  _proto.loadTileImage = function loadTileImage(tileImage, url) {
    var crossOrigin = this.layer.options['crossOrigin'];
    tileImage.crossOrigin = crossOrigin !== null ? crossOrigin : '';
    tileImage.src = url;
    return;
  };
  _proto.onCanvasCreate = function onCanvasCreate() {
    if (!this.canvas.gl || !this.canvas.gl.wrap) {
      this.createCanvas2();
    }
  };
  _proto.createContext = function createContext() {
    _ImageGLRenderable.prototype.createContext.call(this);
    this.createGLContext();
  };
  _proto.resizeCanvas = function resizeCanvas(canvasSize) {
    if (!this.canvas) {
      return;
    }
    _ImageGLRenderable.prototype.resizeCanvas.call(this, canvasSize);
    this.resizeGLCanvas();
  };
  _proto.clearCanvas = function clearCanvas() {
    if (!this.canvas) {
      return;
    }
    _ImageGLRenderable.prototype.clearCanvas.call(this);
    this.clearGLCanvas();
  };
  _proto.getCanvasImage = function getCanvasImage() {
    if (!this.isGL() || !this.canvas2) {
      return _ImageGLRenderable.prototype.getCanvasImage.call(this);
    }
    var img = _ImageGLRenderable.prototype.getCanvasImage.call(this);
    if (img) {
      img.image = this.canvas2;
    }
    return img;
  };
  _proto.isGL = function isGL() {
    return true;
  };
  _proto.deleteTile = function deleteTile(tile) {
    _ImageGLRenderable.prototype.deleteTile.call(this, tile);
    if (tile && tile.image) {
      this.disposeImage(tile.image);
    }
    delete tile.image;
  };
  _proto.onRemove = function onRemove() {
    _ImageGLRenderable.prototype.onRemove.call(this);
    this.removeGLCanvas();
  };
  return TileLayerGLRenderer;
}(ImageGLRenderable(TileLayerCanvasRenderer));
TileLayer.registerRenderer('gl', TileLayerGLRenderer);

function _loadTile(tile) {
  var _this = this;
  var tileSize = this.layer.getTileSize();
  var canvasClass = this.canvas.constructor;
  var map = this.getMap();
  var r = map.getDevicePixelRatio();
  var tileCanvas = Canvas.createCanvas(tileSize['width'] * r, tileSize['height'] * r, canvasClass);
  tileCanvas['layer'] = this.layer;
  var point = new Point(tile['extent2d'].xmin, tile['extent2d'].ymax);
  var extent = new Extent(map.pointToCoordinate(point), map.pointToCoordinate(point.add(tileSize.width, tileSize.height)), map.getProjection());
  this.layer.drawTile(tileCanvas, {
    'url': tile['url'],
    'point': point,
    'center': map.pointToCoordinate(point.add(tileSize['width'] / 2, tileSize['height'] / 2)),
    'extent': extent,
    'z': tile['z'],
    'x': tile['x'],
    'y': tile['y']
  }, function (error) {
    if (error) {
      _this.onTileError(tileCanvas, tile);
      return;
    }
    _this.onTileLoad(tileCanvas, tile);
  });
  return tileCanvas;
}
var CanvasRenderer = function (_TileLayerCanvasRende) {
  function CanvasRenderer() {
    return _TileLayerCanvasRende.apply(this, arguments) || this;
  }
  _inheritsLoose(CanvasRenderer, _TileLayerCanvasRende);
  var _proto = CanvasRenderer.prototype;
  _proto.loadTile = function loadTile(...args) {
    return _loadTile.apply(this, args);
  };
  return CanvasRenderer;
}(TileLayerCanvasRenderer);
var GLRenderer = function (_TileLayerGLRenderer) {
  function GLRenderer() {
    return _TileLayerGLRenderer.apply(this, arguments) || this;
  }
  _inheritsLoose(GLRenderer, _TileLayerGLRenderer);
  var _proto2 = GLRenderer.prototype;
  _proto2.loadTile = function loadTile(...args) {
    return _loadTile.apply(this, args);
  };
  return GLRenderer;
}(TileLayerGLRenderer);
CanvasTileLayer.registerRenderer('canvas', CanvasRenderer);
CanvasTileLayer.registerRenderer('gl', GLRenderer);

var quadVertices = typeof Int8Array !== 'undefined' ? new Int8Array([-1, 1, 0, -1, -1, 0, 1, 1, 0, 1, -1, 0]) : [];
var vert = "\n    attribute vec3 a_position;\n    uniform mat4 transform;\n\n    void main()\n    {\n        gl_Position = transform * vec4(a_position, 1.0);\n    }\n";
var frag = "\n    precision mediump float;\n    uniform vec3 color;\n    void main()\n    {\n        gl_FragColor = vec4(color, 1.0);\n    }\n";
var QuadStencil = function () {
  function QuadStencil(gl, vertices, debug) {
    this.gl = gl;
    this.quadVertices = vertices || quadVertices;
    this.attributes = ['a_position', 3, getType(vertices)];
    this.debug = debug;
  }
  var _proto = QuadStencil.prototype;
  _proto.start = function start() {
    var gl = this.gl;
    gl.enable(gl.STENCIL_TEST);
    gl.stencilMask(0xFF);
    gl.stencilOp(gl.KEEP, gl.REPLACE, gl.REPLACE);
    gl.depthMask(false);
    this._save();
    if (!this.buffer) {
      this._createBuffer();
      this._createProgram();
    }
    gl.useProgram(this.program);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    enableVertexAttrib(gl, this.program, this.attributes);
    if (!this.transformLoc) {
      this.transformLoc = gl.getUniformLocation(this.program, 'transform');
    }
    if (!this.colorLoc) {
      this.colorLoc = gl.getUniformLocation(this.program, 'color');
    }
    if (this.debug) {
      return;
    }
    gl.colorMask(false, false, false, false);
  };
  _proto.end = function end() {
    var gl = this.gl;
    gl.depthMask(true);
    this._restore();
    if (this.debug) {
      return;
    }
    gl.colorMask(true, true, true, true);
  };
  _proto.draw = function draw(transform) {
    var gl = this.gl;
    gl.uniformMatrix4fv(this.transformLoc, false, transform);
    gl.uniform3fv(this.colorLoc, [Math.random(), Math.random(), Math.random()]);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };
  _proto.remove = function remove() {
    var gl = this.gl;
    if (this.buffer) {
      gl.deleteBuffer(this.buffer);
    }
    if (this.program) {
      gl.deleteShader(this.program.fragmentShader);
      gl.deleteShader(this.program.vertexShader);
      gl.deleteProgram(this.program);
    }
    delete this.transformLoc;
    delete this.gl;
    return this;
  };
  _proto.stencilMask = function stencilMask(mask) {
    this.gl.stencilMask(mask);
    return this;
  };
  _proto.stencilFunc = function stencilFunc(func, ref, mask) {
    this.ref = ref;
    this.gl.stencilFunc(func, ref, mask);
    return this;
  };
  _proto.stencilOp = function stencilOp(fail, zfail, zpass) {
    this.gl.stencilOp(fail, zfail, zpass);
    return this;
  };
  _proto.resetFunc = function resetFunc() {
    this.ref = 1;
    this.gl.stencilFunc(this.gl.ALWAYS, 1, 0xFF);
    return this;
  };
  _proto._save = function _save() {
    var gl = this.gl;
    this._savedProgram = gl.program;
  };
  _proto._restore = function _restore() {
    var gl = this.gl;
    gl.program = this._savedProgram;
    if (gl.program) {
      gl.useProgram(gl.program);
    }
  };
  _proto._createBuffer = function _createBuffer() {
    var gl = this.gl;
    this.buffer = gl.createBuffer();
    if (!this.buffer) {
      throw new Error('Failed to create the buffer object');
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.quadVertices, gl.STATIC_DRAW);
  };
  _proto._createProgram = function _createProgram() {
    var {
      program: program,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader
    } = createProgram(this.gl, vert, frag);
    program.vertexShader = vertexShader;
    program.fragmentShader = fragmentShader;
    this.program = program;
  };
  return QuadStencil;
}();
function getType(arr) {
  if (arr instanceof Float32Array) {
    return 'FLOAT';
  } else if (arr instanceof Int16Array) {
    return 'SHORT';
  } else if (arr instanceof Uint16Array) {
    return 'UNSIGNED_SHORT';
  } else if (arr instanceof Int8Array) {
    return 'BYTE';
  } else if (arr instanceof Uint8Array || arr instanceof Uint8ClampedArray) {
    return 'UNSIGNED_BYTE';
  }
  return 'FLOAT';
}

var OverlayLayerRenderable = function OverlayLayerRenderable(Base) {
  var renderable = function (_Base) {
    function renderable() {
      return _Base.apply(this, arguments) || this;
    }
    _inheritsLoose(renderable, _Base);
    var _proto = renderable.prototype;
    _proto.checkResources = function checkResources() {
      var geometries = this._geosToCheck || [];
      if (!this._resourceChecked && this.layer._geoList) {
        pushIn(geometries, this.layer._geoList);
      }
      if (!isArrayHasData(geometries)) {
        return [];
      }
      var resources = [];
      var cache = {};
      for (var i = geometries.length - 1; i >= 0; i--) {
        var geo = geometries[i];
        var res = geo._getExternalResources();
        if (!res.length) {
          continue;
        }
        if (!this.resources) {
          resources.push(...res);
        } else {
          for (var _i = 0; _i < res.length; _i++) {
            var url = res[_i][0];
            if (!this.resources.isResourceLoaded(res[_i]) && !cache[url]) {
              resources.push(res[_i]);
              cache[url] = 1;
            }
          }
        }
      }
      this._resourceChecked = true;
      delete this._geosToCheck;
      return resources;
    };
    _proto._addGeoToCheckRes = function _addGeoToCheckRes(res) {
      if (!res) {
        return;
      }
      if (!Array.isArray(res)) {
        res = [res];
      }
      if (!this._geosToCheck) {
        this._geosToCheck = [];
      }
      pushIn(this._geosToCheck, res);
    };
    _proto.onGeometryAdd = function onGeometryAdd(geometries) {
      this._addGeoToCheckRes(geometries);
      redraw(this);
    };
    _proto.onGeometryRemove = function onGeometryRemove(params) {
      this.layer.fire('removegeo', {
        'type': 'removegeo',
        'target': this,
        'geometries': params
      });
      redraw(this);
    };
    _proto.onGeometrySymbolChange = function onGeometrySymbolChange(e) {
      this._addGeoToCheckRes(e.target);
      redraw(this);
    };
    _proto.onGeometryShapeChange = function onGeometryShapeChange(params) {
      redraw(this);
    };
    _proto.onGeometryPositionChange = function onGeometryPositionChange(params) {
      redraw(this);
    };
    _proto.onGeometryZIndexChange = function onGeometryZIndexChange(params) {
      redraw(this);
    };
    _proto.onGeometryShow = function onGeometryShow(params) {
      redraw(this);
    };
    _proto.onGeometryHide = function onGeometryHide(params) {
      redraw(this);
    };
    _proto.onGeometryPropertiesChange = function onGeometryPropertiesChange(_) {
      redraw(this);
    };
    return renderable;
  }(Base);
  return renderable;
};
var OverlayLayerCanvasRenderer = function (_OverlayLayerRenderab) {
  function OverlayLayerCanvasRenderer() {
    return _OverlayLayerRenderab.apply(this, arguments) || this;
  }
  _inheritsLoose(OverlayLayerCanvasRenderer, _OverlayLayerRenderab);
  var _proto2 = OverlayLayerCanvasRenderer.prototype;
  _proto2.render = function render(...args) {
    this.layer._sortGeometries();
    return _OverlayLayerRenderab.prototype.render.apply(this, args);
  };
  return OverlayLayerCanvasRenderer;
}(OverlayLayerRenderable(CanvasRenderer$1));
var OverlayLayerGLRenderer = function (_OverlayLayerRenderab2) {
  function OverlayLayerGLRenderer() {
    return _OverlayLayerRenderab2.apply(this, arguments) || this;
  }
  _inheritsLoose(OverlayLayerGLRenderer, _OverlayLayerRenderab2);
  var _proto3 = OverlayLayerGLRenderer.prototype;
  _proto3.render = function render(...args) {
    this.layer._sortGeometries();
    return _OverlayLayerRenderab2.prototype.render.apply(this, args);
  };
  return OverlayLayerGLRenderer;
}(OverlayLayerRenderable(LayerAbstractRenderer));
function redraw(renderer) {
  if (renderer instanceof OverlayLayerCanvasRenderer && renderer.layer.options['drawImmediate']) {
    renderer.render();
  }
  renderer.setToRedraw();
}

var TEMP_EXTENT = new PointExtent();
var TEMP_VEC3 = [];
var TEMP_FIXEDEXTENT = new PointExtent();
var PLACEMENT_CENTER = 'center';
function clearCanvas(canvas) {
  if (!canvas) {
    return null;
  }
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  return ctx;
}
function isDebug(layer) {
  return layer && layer.options.progressiveRender && layer.options.progressiveRenderDebug;
}
var VectorLayerRenderer = function (_OverlayLayerCanvasRe) {
  function VectorLayerRenderer() {
    return _OverlayLayerCanvasRe.apply(this, arguments) || this;
  }
  _inheritsLoose(VectorLayerRenderer, _OverlayLayerCanvasRe);
  var _proto = VectorLayerRenderer.prototype;
  _proto.setToRedraw = function setToRedraw() {
    _OverlayLayerCanvasRe.prototype.setToRedraw.call(this);
    this._resetProgressiveRender();
    return this;
  };
  _proto._geoIsCollision = function _geoIsCollision(geo, collisionIndex) {
    if (!geo) {
      return false;
    }
    var collision = geo.options.collision;
    if (!collision) {
      return false;
    }
    if (geo.isPoint && geo.getContainerExtent) {
      if (!geo.bbox) {
        geo.bbox = [0, 0, 0, 0];
      }
      var bufferSize = this.layer.options['collisionBufferSize'];
      var extent = geo.getContainerExtent();
      if (!extent) {
        return false;
      }
      geo.bbox[0] = extent.xmin - bufferSize;
      geo.bbox[1] = extent.ymin - bufferSize;
      geo.bbox[2] = extent.xmax + bufferSize;
      geo.bbox[3] = extent.ymax + bufferSize;
      if (collisionIndex.collides(geo.bbox)) {
        geo._collided = true;
        return true;
      }
      collisionIndex.insertBox(geo.bbox);
    }
    return false;
  };
  _proto.getImageData = function getImageData() {
    if (!this._lastRenderTime || now() - this._lastRenderTime < 32) {
      return null;
    }
    if (!this.context || !this.context.canvas) {
      return null;
    }
    if (!this._imageData) {
      var {
        width: width,
        height: height
      } = this.context.canvas;
      try {
        var ctx = this.screenshotRenderResult(0, 0, width, height);
        if (ctx) {
          this._imageData = ctx.getImageData(0, 0, width, height);
        }
      } catch (error) {
        console.warn('hit detect failed with tainted canvas, some geometries have external resources in another domain:\n', error);
      }
    }
    return this._imageData;
  };
  _proto.clearImageData = function clearImageData() {
    this._imageData = null;
    delete this._imageData;
    this._lastRenderTime = now();
  };
  _proto.checkResources = function checkResources(...args) {
    var _this = this;
    var resources = _OverlayLayerCanvasRe.prototype.checkResources.apply(this, args);
    var style = this.layer.getStyle();
    if (style) {
      if (!Array.isArray(style)) {
        style = [style];
      }
      style.forEach(function (s) {
        var res = getExternalResources(s['symbol'], true);
        for (var i = 0, l = res.length; i < l; i++) {
          if (!_this.resources.isResourceLoaded(res[i])) {
            resources.push(res[i]);
          }
        }
      });
    }
    return resources;
  };
  _proto.needToRedraw = function needToRedraw() {
    if (this.isProgressiveRender() && !this.renderEnd) {
      return true;
    }
    var map = this.getMap();
    if (map.isInteracting() && this.layer.options['enableAltitude']) {
      return true;
    }
    if (map.isZooming() && !map.isRotating() && !map.getPitch() && !this._hasPoint && this.layer.constructor === VectorLayer) {
      return false;
    }
    return _OverlayLayerCanvasRe.prototype.needToRedraw.call(this);
  };
  _proto.draw = function draw() {
    if (!this.getMap()) {
      return;
    }
    if (!this.layer.isVisible() || this.layer.isEmpty()) {
      this.clearCanvas();
      this.completeRender();
      return;
    }
    this.prepareCanvas();
    this.drawGeos();
    this.completeRender();
  };
  _proto.isBlank = function isBlank() {
    if (!this.context) {
      return false;
    }
    if (this.isProgressiveRender()) {
      return false;
    }
    return !this.context.canvas._drawn;
  };
  _proto.drawOnInteracting = function drawOnInteracting() {
    if (!this._geosToDraw) {
      return;
    }
    this._updateMapStateCache();
    this._updateDisplayExtent();
    var map = this.getMap();
    var count = this.layer.getCount();
    var res = this.rendererStateCache.resolution;
    if (map.isZooming() && map.options['seamlessZoom'] && this._drawnRes !== undefined && res > this._drawnRes * 1.5 && this._geosToDraw.length < count || map.isMoving() || map.isInteracting()) {
      this.prepareToDraw();
      this._batchConversionMarkers(this.rendererStateCache.glRes);
      if (!this._onlyHasPoint) {
        this._checkGeos();
      }
      this._drawnRes = res;
    }
    this._sortByDistanceToCamera(map.cameraPosition);
    var {
      collision: collision,
      collisionDelay: collisionDelay
    } = this.layer.options;
    if (collision) {
      var time = now();
      if (!this._lastCollisionTime) {
        this._lastCollisionTime = time;
      }
      if (time - this._lastCollisionTime <= collisionDelay) {
        this._geosToDraw = this._lastGeosToDraw || this._geosToDraw;
      } else {
        this._collidesGeos();
        this._lastCollisionTime = time;
      }
    }
    for (var i = 0, l = this._geosToDraw.length; i < l; i++) {
      var geo = this._geosToDraw[i];
      if (!geo._isCheck) {
        if (!geo.isVisible()) {
          delete geo._cPoint;
          delete geo._inCurrentView;
          continue;
        }
      }
      geo._paint(this._displayExtent);
      this._geosToDraw[i]._cPoint = undefined;
      this._geosToDraw[i]._inCurrentView = undefined;
    }
    this.clearImageData();
    this._lastGeosToDraw = this._geosToDraw;
    if (isDebug(this.layer)) {
      console.log('progressiveRender on drawOnInteracting page:', this.page);
    }
  };
  _proto.show = function show(...args) {
    this.layer.forEach(function (geo) {
      geo._repaint();
    });
    _OverlayLayerCanvasRe.prototype.show.apply(this, args);
  };
  _proto.forEachGeo = function forEachGeo(fn, context) {
    this.layer.forEach(fn, context);
  };
  _proto._checkGeos = function _checkGeos() {
    var geos = this.getCurrentNeedRenderGeos();
    for (var i = 0, len = geos.length; i < len; i++) {
      this.checkGeo(geos[i]);
    }
    return this;
  };
  _proto.drawGeos = function drawGeos() {
    this._drawSnapshot();
    this._updateMapStateCache();
    this._drawnRes = this.rendererStateCache.resolution;
    this._updateDisplayExtent();
    this.prepareToDraw();
    this._batchConversionMarkers(this.rendererStateCache.glRes);
    if (!this._onlyHasPoint) {
      this._checkGeos();
    }
    this._sortByDistanceToCamera(this.getMap().cameraPosition);
    this._collidesGeos();
    for (var i = 0, len = this._geosToDraw.length; i < len; i++) {
      this._geosToDraw[i]._paint();
      this._geosToDraw[i]._cPoint = undefined;
      this._geosToDraw[i]._inCurrentView = undefined;
    }
    this.clearImageData();
    this._lastGeosToDraw = this._geosToDraw;
    if (isDebug(this.layer)) {
      console.log('progressiveRender drawGeos page:', this.page);
    }
    this._snapshot();
    this._setDrawGeosDrawTime();
  };
  _proto.prepareToDraw = function prepareToDraw() {
    this.layer._drawTime = now();
    this._hasPoint = false;
    this._geosToDraw = [];
    return this;
  };
  _proto._setDrawGeosDrawTime = function _setDrawGeosDrawTime() {
    var time = now();
    var drawTime = this.layer._drawTime;
    var painterList = this.getGeoPainterList();
    for (var i = 0, len = painterList.length; i < len; i++) {
      var painter = painterList[i];
      if (painter && painter._setDrawTime) {
        painter._setDrawTime(drawTime);
      }
    }
    if (isDebug(this.layer)) {
      console.log('_setDrawGeosDrawTime time:', now() - time + 'ms');
    }
    return this;
  };
  _proto.checkGeo = function checkGeo(geo) {
    if (geo.isPoint && this._onlyHasPoint !== undefined) {
      if (geo._inCurrentView || geo.hasAltitude()) {
        this._hasPoint = true;
        geo._isCheck = true;
        this._geosToDraw.push(geo);
      }
      return;
    }
    geo._isCheck = false;
    if (!geo || !geo.isVisible() || !geo.getMap() || !geo.getLayer() || !geo.getLayer().isCanvasRender()) {
      return;
    }
    var painter = geo._getPainter();
    if (!painter) {
      return;
    }
    var inCurrentView = true;
    if (geo._inCurrentView || !isNil(geo.options.arcDegree) || geo.hasAltitude()) {
      inCurrentView = true;
    } else if (geo._inCurrentView === false) {
      inCurrentView = false;
    } else {
      var extent2D = painter.get2DExtent(this.resources, TEMP_EXTENT);
      if (!extent2D || !extent2D.intersects(this._displayExtent)) {
        inCurrentView = false;
      }
    }
    if (!inCurrentView) {
      return;
    }
    if (painter.hasPoint()) {
      this._hasPoint = true;
    }
    geo._isCheck = true;
    this._geosToDraw.push(geo);
  };
  _proto._collidesGeos = function _collidesGeos() {
    var geos = this._geosToDraw;
    var collision = this.layer.options['collision'];
    if (!collision) {
      for (var i = 0, len = geos.length; i < len; i++) {
        var geo = geos[i];
        if (geo.isPoint) {
          geo._collided = false;
        }
      }
      return this;
    }
    var collisionScope = this.layer.options['collisionScope'];
    var collisionIndex = this.layer.getCollisionIndex();
    if (collisionScope === 'layer') {
      collisionIndex.clear();
    }
    this._geosToDraw = [];
    for (var _i = 0, _len = geos.length; _i < _len; _i++) {
      var _geo = geos[_i];
      if (_geo.isPoint) {
        _geo._collided = false;
        if (this._geoIsCollision(_geo, collisionIndex)) {
          _geo._collided = true;
          continue;
        }
      }
      this._geosToDraw.push(geos[_i]);
    }
    return this;
  };
  _proto.onZoomEnd = function onZoomEnd(...args) {
    delete this.canvasExtent2D;
    _OverlayLayerCanvasRe.prototype.onZoomEnd.apply(this, args);
  };
  _proto.onRemove = function onRemove() {
    this.forEachGeo(function (g) {
      g.onHide();
    });
    delete this._geosToDraw;
    delete this.snapshotCanvas;
    delete this.pageGeos;
    delete this.geoPainterList;
  };
  _proto.onGeometryPropertiesChange = function onGeometryPropertiesChange(param) {
    if (param) {
      this.layer._styleGeometry(param['target']);
    }
    _OverlayLayerCanvasRe.prototype.onGeometryPropertiesChange.call(this, param);
  };
  _proto._updateDisplayExtent = function _updateDisplayExtent() {
    var extent2D = this.canvasExtent2D;
    if (this._maskExtent) {
      if (!this._maskExtent.intersects(extent2D)) {
        this.completeRender();
        return;
      }
      extent2D = extent2D.intersection(this._maskExtent);
    }
    this._displayExtent = extent2D;
  };
  _proto.identifyAtPoint = function identifyAtPoint(point, options = {}) {
    var geometries = this.getGeosForIdentify();
    if (!geometries) {
      return [];
    }
    return this.layer._hitGeos(geometries, point, options);
  };
  _proto._updateMapStateCache = function _updateMapStateCache() {
    var map = this.getMap();
    var offset = map._pointToContainerPoint(this.middleWest)._add(0, -map.height / 2);
    var resolution = map.getResolution();
    var pitch = map.getPitch();
    var bearing = map.getBearing();
    var glScale = map.getGLScale();
    var glRes = map.getGLRes();
    var containerExtent = map.getGroundExtent();
    var _2DExtent = map.get2DExtent();
    var glExtent = map.get2DExtentAtRes(glRes);
    this.rendererStateCache = {
      resolution: resolution,
      pitch: pitch,
      bearing: bearing,
      glScale: glScale,
      glRes: glRes,
      _2DExtent: _2DExtent,
      glExtent: glExtent,
      containerExtent: containerExtent,
      offset: offset
    };
    return this;
  };
  _proto._batchConversionMarkers = function _batchConversionMarkers(glRes) {
    this._onlyHasPoint = undefined;
    if (!this._constructorIsThis()) {
      return [];
    }
    var cPoints = [];
    var markers = [];
    var altitudes = [];
    var altitudeCache = {};
    var layer = this.layer;
    var layerOpts = layer.options;
    var layerAltitude = layer.getAltitude ? layer.getAltitude() : 0;
    var isCanvasRender = layer.isCanvasRender();
    this._onlyHasPoint = true;
    var idx = 0;
    var geos = this.getCurrentNeedRenderGeos();
    for (var i = 0, len = geos.length; i < len; i++) {
      var geo = geos[i];
      if (geo.isPoint) {
        var painter = geo._painter;
        if (!painter) {
          painter = geo._getPainter();
        }
        var point = painter.getRenderPoints(PLACEMENT_CENTER)[0][0];
        var altitude = layerOpts['enableAltitude'] ? geo._getAltitude() : layerAltitude;
        if (altitudeCache[altitude] === undefined) {
          altitudeCache[altitude] = painter.getAltitude();
        }
        cPoints[idx] = point;
        altitudes[idx] = altitudeCache[altitude];
        markers[idx] = geo;
        idx++;
      } else {
        this._onlyHasPoint = false;
      }
    }
    if (idx === 0) {
      return [];
    }
    var map = this.getMap();
    var pts = getPointsResultPts(cPoints, '_pt');
    pts = map._pointsAtResToContainerPoints(cPoints, glRes, altitudes, pts);
    var containerExtent = map.getGroundExtent();
    var {
      xmax: xmax,
      ymax: ymax,
      xmin: xmin,
      ymin: ymin
    } = containerExtent;
    var extentCache = {};
    for (var _i2 = 0, _len2 = markers.length; _i2 < _len2; _i2++) {
      var _geo2 = markers[_i2];
      _geo2._cPoint = pts[_i2];
      if (!_geo2._cPoint) {
        _geo2._inCurrentView = false;
        continue;
      }
      var {
        x: x,
        y: y
      } = pts[_i2];
      _geo2._inCurrentView = x >= xmin && y >= ymin && x <= xmax && y <= ymax || _geo2.hasAltitude();
      if (!_geo2._inCurrentView) {
        var symbolkey = _geo2.getSymbolHash();
        var fixedExtent = void 0;
        if (symbolkey) {
          fixedExtent = extentCache[symbolkey] = extentCache[symbolkey] || _geo2._painter.getFixedExtent();
        } else {
          fixedExtent = _geo2._painter.getFixedExtent();
        }
        TEMP_FIXEDEXTENT.set(fixedExtent.xmin, fixedExtent.ymin, fixedExtent.xmax, fixedExtent.ymax);
        TEMP_FIXEDEXTENT._add(pts[_i2]);
        _geo2._inCurrentView = TEMP_FIXEDEXTENT.intersects(containerExtent);
      }
      if (_geo2._inCurrentView) {
        if (!_geo2.isVisible() || !isCanvasRender) {
          _geo2._inCurrentView = false;
        }
        if (this._onlyHasPoint && _geo2._inCurrentView) {
          this._hasPoint = true;
          _geo2._isCheck = true;
          this._geosToDraw.push(_geo2);
        }
      }
    }
    return pts;
  };
  _proto._sortByDistanceToCamera = function _sortByDistanceToCamera(cameraPosition) {
    if (!this.layer.options['sortByDistanceToCamera']) {
      return;
    }
    if (!this._geosToDraw.length) {
      return;
    }
    var map = this.getMap();
    var p = map.distanceToPoint(1000, 0, map.getGLScale()).x;
    var meterScale = p / 1000;
    var placement = 'center';
    this._geosToDraw.sort(function (a, b) {
      if (!a.isPoint || !b.isPoint) {
        return 0;
      }
      var painter0 = a._painter;
      var painter1 = b._painter;
      if (!painter0 || !painter1) {
        return 0;
      }
      var point0 = painter0.getRenderPoints(placement)[0][0];
      var point1 = painter1.getRenderPoints(placement)[0][0];
      var alt0 = painter0.getAltitude() * meterScale;
      var alt1 = painter1.getAltitude() * meterScale;
      set(TEMP_VEC3, point0.x, point0.y, alt0);
      var dist0 = distance(TEMP_VEC3, cameraPosition);
      set(TEMP_VEC3, point1.x, point1.y, alt1);
      var dist1 = distance(TEMP_VEC3, cameraPosition);
      return dist1 - dist0;
    });
  };
  _proto._constructorIsThis = function _constructorIsThis() {
    return this.constructor === VectorLayerRenderer;
  };
  _proto.isProgressiveRender = function isProgressiveRender() {
    var layer = this.layer;
    if (!layer) {
      return false;
    }
    var {
      progressiveRender: progressiveRender,
      collision: collision
    } = layer.options || {};
    if (collision) {
      return false;
    }
    return progressiveRender;
  };
  _proto.getGeosForIdentify = function getGeosForIdentify() {
    if (!this.isProgressiveRender()) {
      return this._geosToDraw || [];
    }
    return this.pageGeos || [];
  };
  _proto.getGeoPainterList = function getGeoPainterList() {
    if (!this.isProgressiveRender()) {
      var list = [];
      var geos = this._geosToDraw || [];
      for (var i = 0, len = geos.length; i < len; i++) {
        list.push(geos[i]._painter);
      }
      return list;
    }
    return this.geoPainterList || [];
  };
  _proto._checkSnapshotCanvas = function _checkSnapshotCanvas() {
    if (!this.isProgressiveRender()) {
      delete this.snapshotCanvas;
      return null;
    }
    var canvas = this.canvas;
    if (!canvas) {
      delete this.snapshotCanvas;
      return null;
    }
    if (!this.snapshotCanvas) {
      this.snapshotCanvas = Canvas.createCanvas(1, 1);
    }
    var snapshotCanvas = this.snapshotCanvas;
    var {
      width: width,
      height: height,
      style: style
    } = canvas;
    if (snapshotCanvas.width !== width || snapshotCanvas.height !== height) {
      snapshotCanvas.width = width;
      snapshotCanvas.height = height;
    }
    if (snapshotCanvas.style.width !== style.width || snapshotCanvas.style.height !== style.height) {
      snapshotCanvas.style.width = style.width;
      snapshotCanvas.style.height = style.height;
    }
    return snapshotCanvas;
  };
  _proto._getCurrentNeedRenderGeos = function _getCurrentNeedRenderGeos() {
    var geos = this.layer._geoList || [];
    if (!this.isProgressiveRender()) {
      return geos;
    }
    var layer = this.layer;
    var {
      progressiveRenderCount: progressiveRenderCount
    } = layer.options;
    var pageSize = progressiveRenderCount;
    var page = this.page;
    var start = (page - 1) * pageSize,
      end = page * pageSize;
    var pageGeos = geos.slice(start, end);
    return pageGeos;
  };
  _proto.getCurrentNeedRenderGeos = function getCurrentNeedRenderGeos() {
    return this._getCurrentNeedRenderGeos();
  };
  _proto._resetProgressiveRender = function _resetProgressiveRender() {
    if (isDebug(this.layer)) {
      console.log('progressiveRender resetProgressiveRender');
    }
    this.renderEnd = false;
    this.page = 1;
    this.pageGeos = [];
    this.geoPainterList = [];
    this.maxTolerance = 0;
    this._clearSnapshotCanvas();
  };
  _proto._clearSnapshotCanvas = function _clearSnapshotCanvas() {
    var snapshotCanvas = this._checkSnapshotCanvas();
    if (snapshotCanvas) {
      clearCanvas(snapshotCanvas);
    }
  };
  _proto._snapshot = function _snapshot() {
    var progressiveRender = this.isProgressiveRender();
    var geosToDraw = this._geosToDraw || [];
    for (var i = 0, len = geosToDraw.length; i < len; i++) {
      var geo = geosToDraw[i];
      var t = geo._hitTestTolerance() || 0;
      this.maxTolerance = Math.max(this.maxTolerance, t);
      if (progressiveRender) {
        this.pageGeos.push(geo);
        var painter = geo._painter;
        this.geoPainterList.push(painter);
      }
    }
    if (!progressiveRender) {
      return this;
    }
    var time = now();
    var snapshotCanvas = this._checkSnapshotCanvas();
    if (snapshotCanvas && this.canvas) {
      var ctx = clearCanvas(snapshotCanvas);
      ctx.drawImage(this.canvas, 0, 0);
    }
    var layer = this.layer;
    var {
      progressiveRenderCount: progressiveRenderCount
    } = layer.options;
    var geos = layer._geoList || [];
    var pages = Math.ceil(geos.length / progressiveRenderCount);
    this.renderEnd = this.page >= pages;
    if (this.renderEnd) {
      this._setDrawGeosDrawTime();
    }
    if (isDebug(this.layer)) {
      console.log('snapshot time:', now() - time + 'ms');
    }
    if (!this.renderEnd) {
      this.page++;
    }
    return this;
  };
  _proto._drawSnapshot = function _drawSnapshot() {
    if (!this.isProgressiveRender()) {
      return this;
    }
    var {
      snapshotCanvas: snapshotCanvas,
      context: context
    } = this;
    if (!snapshotCanvas || !context) {
      return this;
    }
    var map = this.getMap();
    if (!map) {
      return this;
    }
    var dpr = this.mapDPR || map.getDevicePixelRatio() || 1;
    var rScale = 1 / dpr;
    this._canvasContextScale(context, rScale);
    context.drawImage(snapshotCanvas, 0, 0);
    this._canvasContextScale(context, dpr);
    return this;
  };
  return VectorLayerRenderer;
}(OverlayLayerCanvasRenderer);
VectorLayer.registerRenderer('canvas', VectorLayerRenderer);

var MapRenderer = function (_Class) {
  function MapRenderer(map) {
    var _this;
    _this = _Class.call(this) || this;
    _this.map = map;
    _this._handlerQueue = [];
    _this._thisDocVisibilitychange = _this._onDocVisibilitychange.bind(_this);
    _this._thisDocDragStart = _this._onDocDragStart.bind(_this);
    _this._thisDocDragEnd = _this._onDocDragEnd.bind(_this);
    _this._thisDocDPRChange = _this._onDocDPRChange.bind(_this);
    return _this;
  }
  _inheritsLoose(MapRenderer, _Class);
  var _proto = MapRenderer.prototype;
  _proto._getAllLayerToRender = function _getAllLayerToRender() {
    return this.map._getLayers();
  };
  _proto.setToRedraw = function setToRedraw() {
    var layers = this._getAllLayerToRender();
    for (var i = 0, l = layers.length; i < l; i++) {
      var renderer = layers[i].getRenderer();
      if (renderer && renderer.canvas && renderer.setToRedraw) {
        renderer.setToRedraw();
      }
    }
  };
  _proto.callInNextFrame = function callInNextFrame(fn) {
    this._handlerQueue.push(fn);
  };
  _proto.executeFrameCallbacks = function executeFrameCallbacks() {
    var running = this._handlerQueue;
    this._handlerQueue = [];
    for (var i = 0, l = running.length; i < l; i++) {
      running[i]();
    }
  };
  _proto.offsetPlatform = function offsetPlatform(offset, force) {
    if (!this.map.getPanels().front) {
      return this;
    }
    if (!force && offset.x === 0 && offset.y === 0) {
      return this;
    }
    var panels = this.map.getPanels();
    var hasFront = this._frontCount = panels.back.layerDOM.childElementCount;
    var hasBack = this._backCount = panels.front.layerDOM.childElementCount;
    var hasUI = this._uiCount = panels.front.uiDOM.childElementCount;
    if (hasFront || hasBack || hasUI) {
      var pos = this.map.offsetPlatform();
      if (offset) {
        pos = pos.add(offset)._round();
      } else {
        pos = pos.round();
      }
      if (hasBack) {
        offsetDom(panels.back, pos);
      }
      if (hasFront || hasUI) {
        offsetDom(panels.front, pos);
      }
    }
    return this;
  };
  _proto.domChanged = function domChanged() {
    var panels = this.map.getPanels();
    if (!panels.front) {
      return false;
    }
    var frontCount = panels.back.layerDOM.childElementCount;
    if (this._frontCount === undefined || this._frontCount !== frontCount) {
      return true;
    }
    var backCount = panels.front.layerDOM.childElementCount;
    if (this._backCount === undefined || this._backCount !== backCount) {
      return true;
    }
    var uiCount = panels.front.uiDOM.childElementCount;
    if (this._uiCount === undefined || this._uiCount !== uiCount) {
      return true;
    }
    return false;
  };
  _proto.resetContainer = function resetContainer() {
    if (!this.map) {
      return;
    }
    this.map._resetMapViewPoint();
    if (this.map.getPanels().front) {
      var pos = new Point(0, 0);
      offsetDom(this.map.getPanels().back, pos);
      offsetDom(this.map.getPanels().front, pos);
    }
  };
  _proto.onZoomEnd = function onZoomEnd() {
    this.resetContainer();
  };
  _proto._onDocVisibilitychange = function _onDocVisibilitychange() {
    if (document.visibilityState !== 'visible') {
      return;
    }
    this.setToRedraw();
  };
  _proto._getWrapPanel = function _getWrapPanel() {
    if (!this.map) {
      return null;
    }
    var panels = this.map.getPanels();
    return panels && panels.mapWrapper;
  };
  _proto._onDocDragStart = function _onDocDragStart() {
    var wrapPanel = this._getWrapPanel();
    if (wrapPanel) {
      wrapPanel.style.overflow = 'visible';
    }
    return;
  };
  _proto._onDocDragEnd = function _onDocDragEnd() {
    var wrapPanel = this._getWrapPanel();
    if (wrapPanel) {
      wrapPanel.style.overflow = 'hidden';
    }
    return;
  };
  _proto._onDocDPRChange = function _onDocDPRChange() {
    var map = this.map;
    if (!map || !map.options || map.options['devicePixelRatio'] || !map.checkSize || !map.getRenderer) {
      return;
    }
    var renderer = map.getRenderer();
    if (renderer) {
      map.checkSize(true);
    }
  };
  _proto._containerIsOffscreen = function _containerIsOffscreen() {
    var _this2 = this;
    var container = this.map.getContainer();
    if (!container) return true;
    if (!container._resizeObserver) {
      var observer = new ResizeObserver(function (entries) {
        var {
          clientWidth: clientWidth,
          clientHeight: clientHeight
        } = entries[0].target;
        _this2._containerClientWidth = clientWidth;
        _this2._containerClientHeight = clientHeight;
      });
      observer.observe(container);
      container._resizeObserver = observer;
    }
    if (!container.style || container.style.display === 'none') {
      return true;
    }
    var minSize = Math.min(this._containerClientWidth, this._containerClientHeight);
    return minSize <= 0;
  };
  return MapRenderer;
}(Class);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var tempCollisionIndex = new CollisionIndex();
var MapAbstractRenderer = function (_MapRenderer) {
  function MapAbstractRenderer(map) {
    var _this;
    _this = _MapRenderer.call(this, map) || this;
    _this.ready = false;
    _this._containerIsCanvas = !!map.getContainer().getContext;
    _this._registerEvents();
    _this._loopTime = 0;
    _this._resizeEventList = [];
    _this._resizeTime = -Infinity;
    _this._frameCycleRenderCount = 0;
    return _this;
  }
  _inheritsLoose(MapAbstractRenderer, _MapRenderer);
  var _proto = MapAbstractRenderer.prototype;
  _proto.load = function load() {
    this.initContainer();
  };
  _proto._updateMapCurrentViewGLInfo = function _updateMapCurrentViewGLInfo() {
    var map = this.map;
    if (!map) {
      return this;
    }
    map._currentViewGLInfo = null;
    var containerExtent = map.getContainerExtent();
    if (!containerExtent) {
      return this;
    }
    var bufferSize = 100;
    var {
      xmin: xmin,
      ymin: ymin,
      xmax: xmax,
      ymax: ymax
    } = containerExtent;
    var p1 = new Point(xmin, ymin);
    var p2 = new Point(xmax, ymin);
    var p3 = new Point(xmax + bufferSize, ymax + bufferSize);
    var p4 = new Point(xmin - bufferSize, ymax + bufferSize);
    var scale = map._getResolution() / map.getGLRes();
    var ring = [p1, p2, p3, p4].map(function (p) {
      return map._containerPointToPoint(p)._multi(scale);
    });
    var RB = ring[2];
    var LB = ring[3];
    ring = ring.sort(function (a, b) {
      return b.y - a.y;
    });
    var [lp1, lp2, rp1, rp2] = ring;
    var lt, lb, rt, rb;
    if (lp1.x < lp2.x) {
      lt = lp1;
      rt = lp2;
    } else {
      lt = lp2;
      rt = lp1;
    }
    if (rp1.x < rp2.x) {
      lb = rp1;
      rb = rp2;
    } else {
      lb = rp2;
      rb = rp1;
    }
    var bbox = getDefaultBBOX();
    pointsBBOX(ring, bbox);
    var [minx, miny, maxx, maxy] = bbox;
    var center = new Point((minx + maxx) / 2, (miny + maxy) / 2);
    map._currentViewGLInfo = {
      lt: lt,
      rt: rt,
      rb: rb,
      lb: lb,
      center: center,
      RB: RB,
      LB: LB
    };
  };
  _proto._updateMapStateCache = function _updateMapStateCache() {
    var map = this.map;
    if (!map) {
      return this;
    }
    updateMapStateCache(map);
    return this;
  };
  _proto.renderFrame = function renderFrame(framestamp) {
    this._updateMapStateCache();
    this._updateMapCurrentViewGLInfo();
    var map = this.map;
    if (!map || !map.options['renderable']) {
      return false;
    }
    this._handleResizeEventList(framestamp);
    if (map.options['stopRenderOnOffscreen'] && this._containerIsOffscreen()) {
      return false;
    }
    this._updateDomPosition(framestamp);
    delete this._isViewChanged;
    map._fireEvent('framestart');
    this.updateMapDOM();
    map.clearCollisionIndex();
    var layers = this._getAllLayerToRender();
    var updated = this.drawLayers(layers, framestamp);
    if (updated) {
      this.drawTops();
    }
    map._fireEvent('frameend');
    this._recordView();
    this._mapview = this._getMapView();
    delete this._spatialRefChanged;
    this._fireLayerLoadEvents(layers);
    this.executeFrameCallbacks();
    map.uiCollides();
    return true;
  };
  _proto.getFrameTimestamp = function getFrameTimestamp() {
    return this._frameTimestamp || 0;
  };
  _proto.updateMapDOM = function updateMapDOM() {
    var map = this.map;
    if (map.isZooming()) {
      return;
    }
    var offset = map.getViewPointFrameOffset();
    if (offset) {
      map.offsetPlatform(offset);
    } else if (this.domChanged()) {
      this.offsetPlatform(null, true);
    }
  };
  _proto.checkIfNeedToRedrawLayers = function checkIfNeedToRedrawLayers(layers) {
    if (this.isSpatialReferenceChanged()) {
      return true;
    }
    for (var i = 0, len = layers.length; i < len; i++) {
      if (this._checkLayerRedraw(layers[i])) {
        return true;
      }
    }
    return false;
  };
  _proto.drawLayers = function drawLayers(layers, framestamp) {
    var needRedraw = this.checkIfNeedToRedrawLayers(layers);
    if (!needRedraw && !this.map.options['forceRedrawPerFrame']) {
      return false;
    }
    this.clearCanvas();
    var map = this.map,
      isInteracting = map.isInteracting(),
      l = layers.length;
    for (var i = 0; i < l; i++) {
      var layer = layers[i];
      if (!layer.isVisible()) {
        continue;
      }
      var isCanvas = layer.isCanvasRender();
      var renderer = layer._getRenderer();
      if (!renderer) {
        continue;
      }
      if (isCanvas) {
        this.clearLayerCanvasContext(layer);
      }
      if (isInteracting && isCanvas) {
        this._drawCanvasLayerOnInteracting(layer, 0, 0, framestamp);
      } else if (isInteracting && renderer.drawOnInteracting) {
        if (renderer.prepareRender) {
          renderer.prepareRender();
        }
        if (renderer.checkAndDraw) {
          renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
        } else {
          renderer.drawOnInteracting(this._eventParam, framestamp);
        }
      } else {
        renderer.render(framestamp);
      }
    }
    map._fireEvent('renderend', {
      'context': this.context
    });
    return true;
  };
  _proto._checkLayerRedraw = function _checkLayerRedraw(layer) {
    if (this.isSpatialReferenceChanged()) {
      return true;
    }
    var map = this.map;
    var renderer = layer._getRenderer();
    if (!renderer) {
      return false;
    }
    if (layer.isCanvasRender()) {
      return renderer.testIfNeedRedraw();
    } else {
      if (renderer.needToRedraw && renderer.needToRedraw()) {
        return true;
      }
      return map.isInteracting() || this.isViewChanged();
    }
  };
  _proto._drawCanvasLayerOnInteracting = function _drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp) {
    var renderer = layer._getRenderer();
    if (renderer.mustRenderOnInteracting && renderer.mustRenderOnInteracting()) {
      renderer.render(framestamp);
    } else if (renderer.drawOnInteracting) {
      renderer.prepareRender();
      var canvas = renderer.prepareCanvas();
      if (renderer.checkAndDraw) {
        renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
      } else {
        renderer.drawOnInteracting(this._eventParam, framestamp);
      }
      return canvas;
    }
    return null;
  };
  _proto._fireLayerLoadEvents = function _fireLayerLoadEvents(layers) {
    for (var i = layers.length - 1; i >= 0; i--) {
      var layer = layers[i];
      var renderer = layer._getRenderer();
      if (!renderer || renderer.isRenderComplete && !renderer.isRenderComplete()) {
        continue;
      }
      layer.fire('layerload');
    }
  };
  _proto.updateMapSize = function updateMapSize(size) {
    if (!size || this._containerIsCanvas) {
      return;
    }
    var width = size['width'] + 'px',
      height = size['height'] + 'px';
    var panels = this.map.getPanels();
    panels.mapWrapper.style.width = width;
    panels.mapWrapper.style.height = height;
    this._updateCanvasSize();
  };
  _proto.getMainPanel = function getMainPanel() {
    if (!this.map) {
      return null;
    }
    if (this._containerIsCanvas) {
      return this.map.getContainer();
    }
    if (this.map.getPanels()) {
      return this.map.getPanels().mapWrapper;
    }
    return null;
  };
  _proto.toDataURL = function toDataURL(mimeType, quality) {
    if (!this.canvas) {
      return null;
    }
    return this.canvas.toDataURL(mimeType, quality);
  };
  _proto.remove = function remove() {
    if (Browser$1.webgl && typeof document !== 'undefined') {
      GlobalEvent.off(EVENT_DPR_CHANGE, this._thisDocDPRChange, this);
      GlobalEvent.off(EVENT_DOC_VISIBILITY_CHANGE, this._thisDocVisibilitychange, this);
      GlobalEvent.off(EVENT_DOC_DRAGSTART, this._thisDocDragStart, this);
      GlobalEvent.off(EVENT_DOC_DRAGEND, this._thisDocDragEnd, this);
    }
    if (this._resizeInterval) {
      clearInterval(this._resizeInterval);
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
    delete this.canvas;
    delete this.map;
    delete this._spatialRefChanged;
    this._cancelFrameLoop();
  };
  _proto.hitDetect = function hitDetect(point) {
    var map = this.map;
    if (!map || !map.options['hitDetect'] || map.isInteracting()) {
      return;
    }
    var layers = map._getLayers();
    var cursor = 'default';
    var limit = map.options['hitDetectLimit'] || 0;
    var counter = 0;
    if (point && point._round) {
      point._round();
    }
    for (var i = layers.length - 1; i >= 0; i--) {
      var layer = layers[i];
      if (!layer.options['hitDetect'] || layer.isEmpty && layer.isEmpty() || !layer.options['geometryEvents']) {
        continue;
      }
      var renderer = layer._getRenderer();
      if (!renderer || !renderer.hitDetect) {
        continue;
      }
      if (renderer.isBlank && renderer.isBlank()) {
        continue;
      }
      if (layer.options['cursor'] !== 'default' && renderer.hitDetect(point)) {
        cursor = layer.options['cursor'] || 'pointer';
        break;
      }
      counter++;
      if (limit > 0 && counter > limit) {
        break;
      }
    }
    map._trySetCursor(cursor);
  };
  _proto.initContainer = function initContainer() {
    var panels = this.map.getPanels();
    function createContainer(name, className, cssText, enableSelect) {
      var c = createEl('div', className);
      if (cssText) {
        c.style.cssText = cssText;
      }
      panels[name] = c;
      if (!enableSelect) {
        preventSelection(c);
      }
      return c;
    }
    var containerDOM = this.map.getContainer();
    if (this._containerIsCanvas) {
      this.createCanvas();
      return;
    }
    containerDOM.innerHTML = '';
    var POSITION0 = 'position:absolute;top:0px;left:0px;';
    var mapWrapper = createContainer('mapWrapper', 'maptalks-wrapper', 'position:absolute;overflow:hidden;', true),
      mapAllLayers = createContainer('allLayers', 'maptalks-all-layers', POSITION0 + 'padding:0px;margin:0px;z-index:0;overflow:visible;', true),
      backStatic = createContainer('backStatic', 'maptalks-back-static', POSITION0 + 'z-index:0;', true),
      back = createContainer('back', 'maptalks-back', POSITION0 + 'z-index:1;'),
      backLayer = createContainer('backLayer', 'maptalks-back-layer', POSITION0),
      canvasContainer = createContainer('canvasContainer', 'maptalks-canvas-layer', POSITION0 + 'border:none;z-index:2;'),
      frontStatic = createContainer('frontStatic', 'maptalks-front-static', POSITION0 + 'z-index:3;', true),
      front = createContainer('front', 'maptalks-front', POSITION0 + 'z-index:4;', true),
      frontLayer = createContainer('frontLayer', 'maptalks-front-layer', POSITION0 + 'z-index:0;'),
      ui = createContainer('ui', 'maptalks-ui', POSITION0 + 'border:none;z-index:1;', true),
      control = createContainer('control', 'maptalks-control', 'z-index:1', true);
    containerDOM.appendChild(mapWrapper);
    mapAllLayers.appendChild(backStatic);
    back.appendChild(backLayer);
    back.layerDOM = backLayer;
    mapAllLayers.appendChild(back);
    mapAllLayers.appendChild(canvasContainer);
    front.appendChild(frontLayer);
    front.layerDOM = frontLayer;
    front.uiDOM = ui;
    mapAllLayers.appendChild(frontStatic);
    mapAllLayers.appendChild(front);
    front.appendChild(ui);
    mapWrapper.appendChild(mapAllLayers);
    mapWrapper.appendChild(control);
    this.createCanvas();
    this.resetContainer();
    var mapSize = this.map._getContainerDomSize();
    this.updateMapSize(mapSize);
  };
  _proto.isViewChanged = function isViewChanged() {
    if (this._isViewChanged !== undefined) {
      return this._isViewChanged;
    }
    var previous = this._mapview;
    var view = this._getMapView();
    this._isViewChanged = !previous || !equalMapView(previous, view);
    return this._isViewChanged;
  };
  _proto._recordView = function _recordView() {
    var map = this.map;
    if (!map._onViewChange || map.isInteracting() || map.isAnimating()) {
      return;
    }
    if (!equalMapView(map.getView(), map._getCurrentView())) {
      map._onViewChange(map.getView());
    }
  };
  _proto.isSpatialReferenceChanged = function isSpatialReferenceChanged() {
    return this._spatialRefChanged;
  };
  _proto._getMapView = function _getMapView() {
    var map = this.map;
    var center = map._getPrjCenter();
    return {
      x: center.x,
      y: center.y,
      zoom: map.getZoom(),
      pitch: map.getPitch(),
      bearing: map.getBearing(),
      width: map.width,
      height: map.height
    };
  };
  _proto._lockFrameRenderEnable = function _lockFrameRenderEnable() {
    var {
      maxFPS: maxFPS
    } = this.map.options || {};
    if (maxFPS <= 0 || GlobalConfig.maxFPS <= maxFPS) {
      return true;
    }
    var count = Math.ceil(GlobalConfig.maxFPS / maxFPS);
    return this._frameCycleRenderCount >= count;
  };
  _proto.onLoad = function onLoad() {
    this._frameLoop(0);
  };
  _proto._frameLoop = function _frameLoop(framestamp) {
    if (!this.map) {
      this._cancelFrameLoop();
      return;
    }
    if (!this._bindFrameLoop) {
      this._bindFrameLoop = this._frameLoop.bind(this);
    }
    if (!this.ready) {
      this._animationFrame = requestAnimFrame(this._bindFrameLoop);
      return;
    }
    this._frameCycleRenderCount++;
    if (this._lockFrameRenderEnable()) {
      framestamp = framestamp || 0;
      this._frameTimestamp = framestamp;
      this._resizeCount = 0;
      this.renderFrame(framestamp);
      this._frameCycleRenderCount = 0;
    } else if (this.map.options.debug) {
      console.log('skip framing, frameCycleRenderCount:', this._frameCycleRenderCount);
    }
    this._animationFrame = requestAnimFrame(this._bindFrameLoop);
  };
  _proto._cancelFrameLoop = function _cancelFrameLoop() {
    delete this._bindFrameLoop;
    if (this._animationFrame) {
      cancelAnimFrame(this._animationFrame);
    }
  };
  _proto._updateCanvasSize = function _updateCanvasSize() {
    if (!this.canvas || this._containerIsCanvas) {
      return;
    }
    var map = this.map,
      mapSize = map.getSize(),
      canvas = this.canvas,
      r = map.getDevicePixelRatio();
    var {
      width: width,
      height: height,
      cssWidth: cssWidth,
      cssHeight: cssHeight
    } = calCanvasSize(mapSize, r);
    if (canvas.style && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
      canvas.style.width = cssWidth;
      canvas.style.height = cssHeight;
    }
    if (width !== canvas.width || height !== canvas.height) {
      canvas.width = width;
      canvas.height = height;
    }
    var topLayer = this.topLayer;
    if (topLayer && (width !== topLayer.width || height !== topLayer.height)) {
      topLayer.width = width;
      topLayer.height = height;
      topLayer.style.width = cssWidth;
      topLayer.style.height = cssHeight;
    }
  };
  _proto.createCanvas = function createCanvas() {
    var _this2 = this;
    if (this._containerIsCanvas) {
      this.canvas = this.map.getContainer();
    } else {
      this.canvas = createEl('canvas');
      var panels = this.map.getPanels();
      var canvasContainer = panels.canvasContainer;
      canvasContainer.appendChild(this.canvas);
      this._updateCanvasSize();
    }
    this.createContext().then(function () {
      _this2.ready = true;
    });
  };
  _proto.createContext = function createContext() {
    return __awaiter(this, void 0, void 0, _regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  _proto.clearLayerCanvasContext = function clearLayerCanvasContext(_layer) {};
  _proto.clearCanvas = function clearCanvas() {};
  _proto.createTopCanvas = function createTopCanvas() {
    var topLayer = createEl('canvas');
    this.topLayer = topLayer;
    topLayer.width = this.canvas.width;
    topLayer.height = this.canvas.height;
    topLayer.style.position = 'absolute';
    topLayer.style.top = '0px';
    topLayer.style.left = '0px';
    topLayer.style.width = this.canvas.style.width;
    topLayer.style.height = this.canvas.style.height;
    var panels = this.map.getPanels();
    var canvasContainer = panels.canvasContainer;
    canvasContainer.insertBefore(topLayer, this.canvas);
    this.topCtx = topLayer.getContext('2d');
  };
  _proto.removeTopCanvas = function removeTopCanvas() {
    removeDomNode(this.topLayer);
    delete this.topLayer;
    delete this.topCtx;
  };
  _proto._updateDomPosition = function _updateDomPosition(framestamp) {
    if (this._checkPositionTime === undefined) {
      this._checkPositionTime = 0;
    }
    var dTime = Math.abs(framestamp - this._checkPositionTime);
    if (dTime >= 500) {
      computeDomPosition(this.map.getContainer());
      this._checkPositionTime = framestamp;
    }
    return this;
  };
  _proto._handleResizeEventList = function _handleResizeEventList(time) {
    if (!this._resizeEventList) {
      return this;
    }
    var len = this._resizeEventList.length;
    if (len === 0) {
      return this;
    }
    if (this._resizeTime && time - this._resizeTime < 60) {
      return this;
    }
    var contentRect = this._resizeEventList[len - 1].contentRect;
    this.map.setContainerDomRect(contentRect);
    this._resizeEventList = [];
    this._checkSize();
    this._resizeCount = this._resizeCount || 0;
    this.renderFrame((this._frameTimestamp || 0) + ++this._resizeCount / 100);
    this._resizeTime = time;
    return this;
  };
  _proto._checkSize = function _checkSize() {
    if (!this.map) {
      return;
    }
    this.map.checkSize();
  };
  _proto._setCheckSizeInterval = function _setCheckSizeInterval(interval) {
    var _this3 = this;
    if (Browser$1.resizeObserver) {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
      if (this.map) {
        this._resizeObserver = new ResizeObserver(function (entries) {
          if (!_this3.map || _this3.map.isRemoved()) {
            _this3._resizeObserver.disconnect();
          } else if (entries.length) {
            _this3._resizeEventList = _this3._resizeEventList || [];
            _this3._resizeEventList.push(entries[0]);
          }
        });
        this._resizeObserver.observe(this.map.getContainer());
      }
    } else {
      clearInterval(this._resizeInterval);
      this._checkSizeInterval = interval;
      this._resizeInterval = setInterval(function () {
        if (!_this3.map || _this3.map.isRemoved()) {
          clearInterval(_this3._resizeInterval);
        } else {
          _this3._checkSize();
        }
      }, this._checkSizeInterval);
    }
  };
  _proto._registerEvents = function _registerEvents() {
    var _this4 = this;
    var map = this.map;
    if (map.options['checkSize'] && !IS_NODE && typeof window !== 'undefined') {
      this._setCheckSizeInterval(map.options['checkSizeInterval']);
    }
    if (!Browser$1.mobile) {
      map.on('_mousemove', this._onMapMouseMove, this);
    }
    map.on('_dragrotatestart _dragrotating _dragrotateend _movestart _moving _moveend _zoomstart', function (param) {
      _this4._eventParam = param;
    });
    map.on('_zooming', function (param) {
      if (!map.getPitch()) {
        _this4._zoomMatrix = param['matrix']['container'];
      }
      _this4._eventParam = param;
    });
    map.on('_zoomend', function (param) {
      _this4._eventParam = param;
      delete _this4._zoomMatrix;
    });
    map.on('_spatialreferencechange', function () {
      _this4._spatialRefChanged = true;
    });
    if (Browser$1.webgl && typeof document !== 'undefined') {
      GlobalEvent.on(EVENT_DPR_CHANGE, this._thisDocDPRChange, this);
      GlobalEvent.on(EVENT_DOC_VISIBILITY_CHANGE, this._thisDocVisibilitychange, this);
      GlobalEvent.on(EVENT_DOC_DRAGSTART, this._thisDocDragStart, this);
      GlobalEvent.on(EVENT_DOC_DRAGEND, this._thisDocDragEnd, this);
    }
  };
  _proto._onMapMouseMove = function _onMapMouseMove(param) {
    var _this5 = this;
    var map = this.map;
    if (map.isInteracting() || !map.options['hitDetect']) {
      return;
    }
    if (this._hitDetectFrame) {
      cancelAnimFrame(this._hitDetectFrame);
    }
    this._hitDetectFrame = requestAnimFrame(function () {
      _this5.hitDetect(param['containerPoint']);
    });
  };
  _proto._getCanvasLayers = function _getCanvasLayers() {
    return this.map._getLayers(function (layer) {
      return layer.isCanvasRender();
    });
  };
  _proto.addTopElement = function addTopElement(e) {
    if (!this._tops) {
      this._tops = [];
    }
    this._tops.push(e);
  };
  _proto.removeTopElement = function removeTopElement(e) {
    if (!this._tops) {
      return;
    }
    var idx = this._tops.indexOf(e);
    if (idx >= 0) {
      this._tops.splice(idx, 1);
    }
  };
  _proto.getTopElements = function getTopElements() {
    return this._tops || [];
  };
  _proto.sortTopElements = function sortTopElements() {
    this._tops = this._tops.sort(function (top1, top2) {
      var zIndex1 = (top1.options || {}).zIndex || 0;
      var zIndex2 = (top2.options || {}).zIndex || 0;
      return zIndex2 - zIndex1;
    });
  };
  _proto.drawTops = function drawTops() {
    var tops = this.getTopElements();
    if (tops.length) {
      if (!this.topCtx) {
        this.createTopCanvas();
      }
    } else {
      if (this.topCtx) {
        this.removeTopCanvas();
      }
      return;
    }
    this.drawTopElements();
  };
  _proto.drawTopElements = function drawTopElements() {
    var tops = this.getTopElements();
    this.topCtx.clearRect(0, 0, this.topLayer.width, this.topLayer.height);
    var collisionIndex = tempCollisionIndex;
    collisionIndex.clear();
    this.map.fire('drawtopstart');
    this.map.fire('drawtops');
    var updated = false;
    var dpr = this.map.getDevicePixelRatio();
    var geos = [];
    for (var i = 0; i < tops.length; i++) {
      var top = tops[i];
      if (top.needCollision && top.needCollision()) {
        var bbox = top.getRenderBBOX(dpr);
        if (bbox) {
          if (collisionIndex.collides(bbox)) {
            var geometry = top.target && top.target._geometry;
            if (geometry && geos.indexOf(geometry) === -1) {
              geos.push(geometry);
              geometry.fire('handlecollision');
            }
            continue;
          } else {
            collisionIndex.insertBox(bbox);
          }
        }
      }
      if (top.render(this.topCtx)) {
        updated = true;
      }
    }
    if (updated && this.context && this.context.drawImage) {
      this.context.drawImage(this.topLayer, 0, 0);
    }
    this.map.fire('drawtopsend');
  };
  _proto.isWebGL = function isWebGL() {
    return false;
  };
  _proto.isWebGPU = function isWebGPU() {
    return false;
  };
  return MapAbstractRenderer;
}(MapRenderer);

var MapCanvasRenderer = function (_MapAbstractRenderer) {
  function MapCanvasRenderer() {
    return _MapAbstractRenderer.apply(this, arguments) || this;
  }
  _inheritsLoose(MapCanvasRenderer, _MapAbstractRenderer);
  var _proto = MapCanvasRenderer.prototype;
  _proto.renderFrame = function renderFrame(framestamp) {
    this._updateMapStateCache();
    this._updateMapCurrentViewGLInfo();
    var map = this.map;
    if (!map || !map.options['renderable']) {
      return false;
    }
    this._handleResizeEventList(framestamp);
    if (map.options['stopRenderOnOffscreen'] && this._containerIsOffscreen()) {
      return true;
    }
    this._updateDomPosition(framestamp);
    delete this._isViewChanged;
    map._fireEvent('framestart');
    this.updateMapDOM();
    map.clearCollisionIndex();
    var layers = this._getAllLayerToRender();
    this.drawLayers(layers, framestamp);
    var updated = this.drawLayerCanvas(layers);
    if (updated) {
      this.drawTops();
      this._drawCenterCross();
      if (map.options['debugSky']) {
        this._debugSky();
      }
    }
    this._needClear = false;
    map._fireEvent('frameend');
    this._recordView();
    this._mapview = this._getMapView();
    delete this._spatialRefChanged;
    this._fireLayerLoadEvents();
    this.executeFrameCallbacks();
    this._canvasUpdated = false;
    map.uiCollides();
    return true;
  };
  _proto._needRedrawAllLayers = function _needRedrawAllLayers(layers) {
    var _this = this;
    if (this.isSpatialReferenceChanged()) {
      return true;
    }
    var needRedrawLayers = [];
    layers.forEach(function (layer) {
      if (!layer) {
        return;
      }
      var needsRedraw = layer._toRedraw = _this._checkLayerRedraw(layer);
      if (needsRedraw) {
        needRedrawLayers.push(layer);
        var childLayers = layer.getLayers && layer.getLayers();
        if (childLayers && Array.isArray(childLayers)) {
          pushIn(needRedrawLayers, childLayers);
        }
      }
    });
    for (var i = 0, len = needRedrawLayers.length; i < len; i++) {
      var layer = needRedrawLayers[i];
      var layerOptions = layer && layer.options;
      if (layerOptions && layerOptions.collision && layerOptions.collisionScope === 'map') {
        return true;
      }
    }
    return false;
  };
  _proto.drawLayers = function drawLayers(layers, framestamp) {
    var needRedrawAllLayers = this._needRedrawAllLayers(layers);
    var map = this.map,
      isInteracting = map.isInteracting(),
      canvasIds = [],
      updatedIds = [],
      fps = map.options['fpsOnInteracting'] || 0,
      timeLimit = fps === 0 ? 0 : 1000 / fps,
      layerLimit = this.map.options['layerCanvasLimitOnInteracting'],
      l = layers.length;
    var baseLayer = map.getBaseLayer();
    var t = 0;
    for (var i = 0; i < l; i++) {
      var layer = layers[i];
      if (!layer.isVisible()) {
        continue;
      }
      var isCanvas = layer.isCanvasRender();
      if (isCanvas) {
        canvasIds.push(layer.getId());
      }
      var renderer = layer._getRenderer();
      if (!renderer) {
        continue;
      }
      var needsRedraw = needRedrawAllLayers || layer._toRedraw;
      if (isCanvas && renderer.isCanvasUpdated()) {
        if (!needsRedraw) {
          updatedIds.push(layer.getId());
        }
        this.setLayerCanvasUpdated();
      }
      var transformMatrix = renderer.__zoomTransformMatrix;
      delete renderer.__zoomTransformMatrix;
      if (!needsRedraw) {
        if (isCanvas && isInteracting) {
          if (map.isZooming() && !map.getPitch()) {
            renderer.prepareRender();
            renderer.__zoomTransformMatrix = this._zoomMatrix;
          } else if (map.getPitch() || map.isRotating()) {
            renderer.clearCanvas();
          }
        }
        continue;
      }
      if (isInteracting && isCanvas) {
        if (layerLimit > 0 && l - 1 - i > layerLimit && layer !== baseLayer) {
          layer._getRenderer().clearCanvas();
          continue;
        }
        t += this._drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp);
      } else if (isInteracting && renderer.drawOnInteracting) {
        if (renderer.prepareRender) {
          renderer.prepareRender();
        }
        if (renderer.checkAndDraw) {
          renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
        } else {
          renderer.drawOnInteracting(this._eventParam, framestamp);
        }
      } else {
        renderer.render(framestamp);
        if (isCanvas && transformMatrix && renderer.isLoadingResource()) {
          renderer.__zoomTransformMatrix = transformMatrix;
        }
      }
      if (isCanvas) {
        updatedIds.push(layer.getId());
        this.setLayerCanvasUpdated();
      }
    }
    var preCanvasIds = this._canvasIds || [];
    var preUpdatedIds = this._updatedIds || [];
    this._canvasIds = canvasIds;
    this._updatedIds = updatedIds;
    if (!this.isLayerCanvasUpdated()) {
      var sep = '---';
      if (preCanvasIds.join(sep) !== canvasIds.join(sep) || preUpdatedIds.join(sep) !== updatedIds.join(sep)) {
        this.setLayerCanvasUpdated();
      }
    }
    return true;
  };
  _proto._drawCanvasLayerOnInteracting = function _drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp) {
    var map = this.map,
      renderer = layer._getRenderer(),
      drawTime = renderer.getDrawTime(),
      inTime = timeLimit === 0 || timeLimit > 0 && t + drawTime <= timeLimit;
    if (renderer.mustRenderOnInteracting && renderer.mustRenderOnInteracting()) {
      renderer.render(framestamp);
    } else if (renderer.drawOnInteracting && (layer === map.getBaseLayer() || inTime || map.isZooming() && layer.options['forceRenderOnZooming'] || map.isMoving() && layer.options['forceRenderOnMoving'] || map.isRotating() && layer.options['forceRenderOnRotating'])) {
      renderer.prepareRender();
      renderer.prepareCanvas();
      if (renderer.checkAndDraw) {
        renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
      } else {
        renderer.drawOnInteracting(this._eventParam, framestamp);
      }
      return drawTime;
    } else if (map.isZooming() && !map.getPitch() && !map.isRotating()) {
      renderer.prepareRender();
      renderer.__zoomTransformMatrix = this._zoomMatrix;
    } else if (map.getPitch() || map.isRotating()) {
      renderer.clearCanvas();
    }
    if (renderer.drawOnInteracting && !inTime) {
      renderer.onSkipDrawOnInteracting(this._eventParam, framestamp);
    }
    return 0;
  };
  _proto._fireLayerLoadEvents = function _fireLayerLoadEvents() {
    if (this._updatedIds && this._updatedIds.length > 0) {
      var map = this.map;
      this._updatedIds.reverse().forEach(function (id) {
        var layer = map.getLayer(id);
        if (!layer) {
          return;
        }
        var renderer = layer._getRenderer();
        if (!renderer || renderer.isRenderComplete && !renderer.isRenderComplete()) {
          return;
        }
        layer.fire('layerload');
      });
    }
  };
  _proto.isLayerCanvasUpdated = function isLayerCanvasUpdated() {
    return this._canvasUpdated;
  };
  _proto.setLayerCanvasUpdated = function setLayerCanvasUpdated() {
    this._canvasUpdated = true;
  };
  _proto.drawLayerCanvas = function drawLayerCanvas(layers) {
    var map = this.map;
    if (!map) {
      return false;
    }
    if (!this.isLayerCanvasUpdated() && !this.isViewChanged() && this._needClear === false) {
      return false;
    }
    if (!this.canvas) {
      this.createCanvas();
    }
    map._fireEvent('renderstart', {
      'context': this.context
    });
    if (!this._updateCanvasSize()) {
      this.clearCanvas();
    }
    var interacting = map.isInteracting(),
      limit = map.options['layerCanvasLimitOnInteracting'];
    var len = layers.length;
    var baseLayerImage;
    var images = [];
    for (var i = 0; i < len; i++) {
      if (!layers[i].isVisible() || !layers[i].isCanvasRender()) {
        continue;
      }
      var renderer = layers[i]._getRenderer();
      if (!renderer) {
        continue;
      }
      var layerImage = this._getLayerImage(layers[i]);
      if (layerImage && layerImage['image']) {
        if (layers[i] === map.getBaseLayer()) {
          baseLayerImage = [layers[i], layerImage];
        } else {
          images.push([layers[i], layerImage]);
        }
      }
    }
    var targetWidth = this.canvas.width;
    var targetHeight = this.canvas.height;
    if (baseLayerImage) {
      this._drawLayerCanvasImage(baseLayerImage[0], baseLayerImage[1], targetWidth, targetHeight);
      this._drawFog();
    }
    len = images.length;
    var start = interacting && limit >= 0 && len > limit ? len - limit : 0;
    for (var _i = start; _i < len; _i++) {
      this._drawLayerCanvasImage(images[_i][0], images[_i][1], targetWidth, targetHeight);
    }
    map._fireEvent('renderend', {
      'context': this.context
    });
    return true;
  };
  _proto.setToRedraw = function setToRedraw() {
    var layers = this._getAllLayerToRender();
    this._needClear = true;
    for (var i = 0, l = layers.length; i < l; i++) {
      var renderer = layers[i].getRenderer();
      if (renderer && renderer.canvas && renderer.setToRedraw) {
        renderer.setToRedraw();
      }
    }
  };
  _proto.remove = function remove() {
    delete this.context;
    _MapAbstractRenderer.prototype.remove.call(this);
  };
  _proto.hitDetect = function hitDetect(point) {
    var map = this.map;
    if (!map || !map.options['hitDetect'] || map.isInteracting()) {
      return;
    }
    var layers = map._getLayers();
    var cursor = 'default';
    var limit = map.options['hitDetectLimit'] || 0;
    var counter = 0;
    if (point && point._round) {
      point._round();
    }
    for (var i = layers.length - 1; i >= 0; i--) {
      var layer = layers[i];
      if (!layer.options['hitDetect'] || layer.isEmpty && layer.isEmpty() || !layer.options['geometryEvents']) {
        continue;
      }
      var renderer = layer._getRenderer();
      if (!renderer || !renderer.hitDetect) {
        continue;
      }
      if (renderer.isBlank && renderer.isBlank()) {
        continue;
      }
      if (layer.options['cursor'] !== 'default' && renderer.hitDetect(point)) {
        cursor = layer.options['cursor'] || 'pointer';
        break;
      }
      counter++;
      if (limit > 0 && counter > limit) {
        break;
      }
    }
    map._trySetCursor(cursor);
  };
  _proto._getLayerImage = function _getLayerImage(layer) {
    var renderer = layer._getRenderer();
    if (renderer.getCanvasImage) {
      return renderer.getCanvasImage();
    }
    return null;
  };
  _proto._drawLayerCanvasImage = function _drawLayerCanvasImage(layer, layerImage, targetWidth, targetHeight) {
    var ctx = this.context;
    var point = layerImage['point'].round();
    var dpr = this.map.getDevicePixelRatio();
    if (dpr !== 1) {
      point._multi(dpr);
    }
    var canvasImage = layerImage['image'];
    var width = canvasImage.width,
      height = canvasImage.height;
    if (point.x + width <= 0 || point.y + height <= 0) {
      return;
    }
    var op = layer.options['opacity'];
    if (!isNumber(op)) {
      op = 1;
    }
    if (op <= 0) {
      return;
    }
    var imgOp = layerImage['opacity'];
    if (!isNumber(imgOp)) {
      imgOp = 1;
    }
    if (imgOp <= 0) {
      return;
    }
    var alpha = ctx.globalAlpha;
    if (layer.options.renderer === 'canvas') {
      if (op < 1) {
        ctx.globalAlpha *= op;
      }
      if (imgOp < 1) {
        ctx.globalAlpha *= imgOp;
      }
    }
    if (layer.options['cssFilter']) {
      ctx.filter = layer.options['cssFilter'];
    }
    var renderer = layer.getRenderer();
    var matrix = renderer.__zoomTransformMatrix;
    var clipped = renderer.clipCanvas(this.context);
    if (matrix) {
      ctx.save();
      ctx.setTransform(...matrix);
    }
    ctx.drawImage(canvasImage, 0, 0, width, height, point.x, point.y, targetWidth, targetHeight);
    if (matrix) {
      ctx.restore();
    }
    if (clipped) {
      ctx.restore();
    }
    if (ctx.filter !== 'none') {
      ctx.filter = 'none';
    }
    ctx.globalAlpha = alpha;
  };
  _proto._drawCenterCross = function _drawCenterCross() {
    var cross = this.map.options['centerCross'];
    if (cross) {
      var ctx = this.context;
      var p = new Point(this.canvas.width / 2, this.canvas.height / 2);
      if (isFunction(cross)) {
        cross(ctx, p);
      } else {
        Canvas.drawCross(this.context, p.x, p.y, 2, '#f00');
      }
    }
  };
  _proto._drawContainerExtent = function _drawContainerExtent() {
    var {
      cascadePitches: cascadePitches
    } = this.map.options;
    var h30 = this.map.height - this.map._getVisualHeight(cascadePitches[0]);
    var h60 = this.map.height - this.map._getVisualHeight(cascadePitches[1]);
    var extent = this.map.getGroundExtent();
    var ctx = this.context;
    ctx.beginPath();
    ctx.moveTo(0, extent.ymin);
    ctx.lineTo(extent.xmax, extent.ymin);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, h30);
    ctx.lineTo(extent.xmax, h30);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, h60);
    ctx.lineTo(extent.xmax, h60);
    ctx.stroke();
  };
  _proto._drawFog = function _drawFog() {
    var map = this.map;
    if (map.getPitch() <= map.options['maxVisualPitch'] || !map.options['fog']) {
      return;
    }
    var fogThickness = 30;
    var r = map.getDevicePixelRatio();
    var ctx = this.context,
      clipExtent = map.getGroundExtent();
    var top = (map.height - map._getVisualHeight(75)) * r;
    if (top < 0) top = 0;
    var bottom = clipExtent.ymin * r,
      h = Math.ceil(bottom - top),
      color = map.options['fogColor'].join();
    var gradient = ctx.createLinearGradient(0, top, 0, bottom + fogThickness);
    var landscape = 1 - fogThickness / (h + fogThickness);
    gradient.addColorStop(0, "rgba(" + color + ", 0)");
    gradient.addColorStop(0.3, "rgba(" + color + ", 0.3)");
    gradient.addColorStop(landscape, "rgba(" + color + ", 1)");
    gradient.addColorStop(1, "rgba(" + color + ", 0)");
    ctx.beginPath();
    ctx.fillStyle = gradient;
    ctx.fillRect(0, top, Math.ceil(clipExtent.getWidth()) * r, Math.ceil(h + fogThickness));
  };
  _proto._debugSky = function _debugSky() {
    var map = this.map;
    if (!map) {
      return this;
    }
    var height = map.getGroundExtent().ymin;
    if (height <= 0) {
      return this;
    }
    var ctx = this.context;
    ctx.strokeStyle = 'red';
    ctx.strokeRect(0, 0, map.width, height);
    return this;
  };
  _proto.clearCanvas = function clearCanvas() {
    if (!this.canvas) {
      return;
    }
    Canvas.clearRect(this.context, 0, 0, this.canvas.width, this.canvas.height);
  };
  _proto._updateCanvasSize = function _updateCanvasSize() {
    if (!this.canvas || this._containerIsCanvas) {
      return false;
    }
    var map = this.map,
      mapSize = map.getSize(),
      canvas = this.canvas,
      r = map.getDevicePixelRatio();
    var {
      width: width,
      height: height,
      cssWidth: cssWidth,
      cssHeight: cssHeight
    } = calCanvasSize(mapSize, r);
    if (canvas.style && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
      canvas.style.width = cssWidth;
      canvas.style.height = cssHeight;
    }
    if (width === canvas.width && height === canvas.height) {
      return false;
    }
    canvas.height = height;
    canvas.width = width;
    this.topLayer.width = canvas.width;
    this.topLayer.height = canvas.height;
    return true;
  };
  _proto.createCanvas = function createCanvas() {
    this.topLayer = createEl('canvas');
    this.topCtx = this.topLayer.getContext('2d');
    if (this._containerIsCanvas) {
      this.canvas = this.map.getContainer();
    } else {
      this.canvas = createEl('canvas');
      this._updateCanvasSize();
      this.map.getPanels().canvasContainer.appendChild(this.canvas);
    }
    this.context = this.canvas.getContext('2d');
    this.ready = true;
  };
  _proto.drawTops = function drawTops() {
    _MapAbstractRenderer.prototype.drawTopElements.call(this);
  };
  return MapCanvasRenderer;
}(MapAbstractRenderer);
Map$1.registerRenderer('canvas', MapCanvasRenderer);
Map$1.mergeOptions({
  'fog': false,
  'fogColor': [233, 233, 233]
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CanvasLayerRenderer: CanvasLayerRenderer,
  CanvasRenderer: CanvasRenderer$1,
  CanvasTileLayerCanvasRenderer: CanvasRenderer,
  CanvasTileLayerGLRenderer: GLRenderer,
  ImageGLRenderable: ImageGLRenderable,
  ImageLayerCanvasRenderer: ImageLayerCanvasRenderer,
  ImageLayerGLRenderer: ImageLayerGLRenderer,
  ImageLayerRenderable: ImageLayerRenderable,
  LayerAbstractRenderer: LayerAbstractRenderer,
  MapAbstractRenderer: MapAbstractRenderer,
  MapCanvasRenderer: MapCanvasRenderer,
  MapRenderer: MapRenderer,
  OverlayLayerCanvasRenderer: OverlayLayerCanvasRenderer,
  OverlayLayerGLRenderer: OverlayLayerGLRenderer,
  QuadStencil: QuadStencil,
  Renderable: Renderable,
  ResourceCache: ResourceCache,
  TileLayerCanvasRenderer: TileLayerCanvasRenderer,
  TileLayerGLRenderer: TileLayerGLRenderer,
  TileLayerRendererable: TileLayerRenderable,
  VectorLayerCanvasRenderer: VectorLayerRenderer
});

var CenterPointRenderer = {
  _getRenderPoints: function _getRenderPoints() {
    return [[this._getCenter2DPoint(this.getMap().getGLRes())], null];
  }
};
Marker.include(CenterPointRenderer);
Ellipse.include(CenterPointRenderer);
Circle.include(CenterPointRenderer);
Sector.include(CenterPointRenderer);
Rectangle.include({
  _getRenderPoints: function _getRenderPoints(placement) {
    var map = this.getMap();
    var glRes = map.getGLRes();
    if (placement === 'vertex') {
      var shell = this._trimRing(this.getShell());
      var points = [];
      for (var i = 0, len = shell.length; i < len; i++) {
        points.push(map.coordToPointAtRes(shell[i], glRes));
      }
      return [points, null];
    } else {
      var c = map.coordToPointAtRes(this.getCenter(), glRes);
      return [[c], null];
    }
  }
});
var PolyRenderer = {
  _getRenderPoints: function _getRenderPoints(placement) {
    var map = this.getMap();
    var glRes = map.getGLRes();
    var points,
      rotations = null;
    if (placement === 'point') {
      points = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes);
      if (points && points.length > 0 && Array.isArray(points[0])) {
        points = points[0].concat(points[1]);
      }
    } else if (placement === 'vertex') {
      points = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes);
      rotations = [];
      if (points && points.length > 0 && Array.isArray(points[0])) {
        for (var i = 0, l = points.length; i < l; i++) {
          for (var ii = 0, ll = points[i].length; ii < ll; ii++) {
            if (ii === 0) {
              rotations.push([points[i][ii], points[i][ii + 1]]);
            } else {
              rotations.push([points[i][ii - 1], points[i][ii]]);
            }
          }
        }
        points = points[0].concat(points[1]);
      } else {
        for (var _i = 0, _l = points.length; _i < _l; _i++) {
          if (_i === 0) {
            rotations.push([points[_i], points[_i + 1]]);
          } else {
            rotations.push([points[_i - 1], points[_i]]);
          }
        }
      }
    } else if (placement === 'line') {
      points = [];
      rotations = [];
      var vertice = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes),
        isSplitted = vertice.length > 0 && Array.isArray(vertice[0]);
      if (isSplitted) {
        var ring;
        for (var _i2 = 1, _l2 = vertice.length; _i2 < _l2; _i2++) {
          ring = vertice[_i2];
          if (this instanceof Polygon && ring.length > 0 && !ring[0].equals(ring[ring.length - 1])) {
            ring.push(ring[0]);
          }
          for (var _ii = 1, _ll = ring.length; _ii < _ll; _ii++) {
            points.push(ring[_ii].add(ring[_ii - 1])._multi(0.5));
            rotations.push([ring[_ii - 1], ring[_ii]]);
          }
        }
      } else {
        if (this instanceof Polygon && vertice.length > 0 && !vertice[0].equals(vertice[vertice.length - 1])) {
          vertice.push(vertice[0]);
        }
        for (var _i3 = 1, _l3 = vertice.length; _i3 < _l3; _i3++) {
          points.push(vertice[_i3].add(vertice[_i3 - 1])._multi(0.5));
          rotations.push([vertice[_i3 - 1], vertice[_i3]]);
        }
      }
    } else if (placement === 'vertex-first') {
      var coords = this._getPrjCoordinates();
      var _l4 = coords.length;
      var point0 = _l4 ? map._prjToPointAtRes(coords[0], glRes) : null;
      points = _l4 ? [point0] : [];
      rotations = _l4 ? [[point0, coords[1] ? map._prjToPointAtRes(coords[1], glRes) : point0]] : [];
    } else if (placement === 'vertex-last') {
      var _coords = this._getPrjCoordinates();
      var _l5 = _coords.length;
      var curretPoint = _l5 ? map._prjToPointAtRes(_coords[_l5 - 1], glRes) : null;
      points = _l5 ? [curretPoint] : [];
      var previous = _l5 > 1 ? _l5 - 2 : _l5 - 1;
      rotations = _l5 ? [[_coords[previous] ? map._prjToPointAtRes(_coords[previous], glRes) : curretPoint, curretPoint]] : [];
    } else if (placement === 'vertex-firstlast') {
      points = [];
      rotations = [];
      var _coords2 = this._getPrjCoordinates();
      var _l6 = _coords2.length;
      if (_l6) {
        var _point = map._prjToPointAtRes(_coords2[0], glRes);
        points = [_point];
        if (_l6 > 1) {
          rotations = [[_point, map._prjToPointAtRes(_coords2[1], glRes)]];
          var point1 = map._prjToPointAtRes(_coords2[_l6 - 1], glRes);
          points.push(point1);
          var _previous = _l6 > 1 ? _l6 - 2 : _l6 - 1;
          rotations.push([map._prjToPointAtRes(_coords2[_previous], glRes), point1]);
        }
      }
    } else {
      var center = this.getCenter();
      if (!center) {
        points = [];
      } else {
        var pcenter = this._getProjection().project(center);
        points = [map._prjToPointAtRes(pcenter, glRes)];
      }
    }
    return [points, rotations];
  }
};
LineString.include(PolyRenderer);
Polygon.include(PolyRenderer);

var TEMP_WITHIN = {
  within: false,
  center: [0, 0]
};
function isWithinPixel(painter) {
  if (!painter || !painter._containerBbox) {
    TEMP_WITHIN.within = false;
  } else {
    TEMP_WITHIN.within = false;
    var {
      minx: minx,
      miny: miny,
      maxx: maxx,
      maxy: maxy
    } = painter._containerBbox;
    var offsetx = Math.abs(maxx - minx);
    var offsety = Math.abs(maxy - miny);
    if (offsetx <= 1 && offsety <= 1) {
      TEMP_WITHIN.within = true;
      TEMP_WITHIN.center[0] = (minx + maxx) / 2;
      TEMP_WITHIN.center[1] = (miny + maxy) / 2;
    }
    delete painter._containerBbox;
  }
  return TEMP_WITHIN;
}
var geometryInclude = {
  _redrawWhenPitch: function _redrawWhenPitch() {
    return false;
  },
  _redrawWhenRotate: function _redrawWhenRotate() {
    return false;
  },
  _getRenderBBOX: function _getRenderBBOX(ctx, points) {
    if (!ctx.isHitTesting) {
      resetBBOX(BBOX_TEMP);
      pointsBBOX(points, BBOX_TEMP);
      return BBOX_TEMP;
    }
    return null;
  }
};
Geometry.include(geometryInclude);
function _computeRotatedPrjExtent() {
  var coord = this._getPrjShell();
  var bbox = getDefaultBBOX();
  pointsBBOX(coord, bbox);
  var [minx, miny, maxx, maxy] = bbox;
  return new Extent(minx, miny, maxx, maxy);
}
function getRotatedShell() {
  var prjs = this._getPrjShell();
  if (!prjs || !Array.isArray(prjs)) {
    return [];
  }
  var projection = this._getProjection();
  var coordinates = this.getCoordinates() || {};
  return prjs.map(function (prj) {
    var c = projection.unproject(prj);
    c.z = coordinates.z || 0;
    return c;
  });
}
var el = {
  _redrawWhenPitch: function _redrawWhenPitch() {
    return true;
  },
  _redrawWhenRotate: function _redrawWhenRotate() {
    return this instanceof Ellipse || this instanceof Sector;
  },
  _computeRotatedPrjExtent: _computeRotatedPrjExtent,
  getRotatedShell: getRotatedShell,
  _paintAsPath: function _paintAsPath() {
    if (this.isRotated()) {
      return true;
    }
    var map = this.getMap();
    var altitude = this._getAltitude();
    var cache = MapStateCache[map.id];
    var pitch = cache ? cache.pitch : map.getPitch();
    var bearing = cache ? cache.bearing : map.getBearing();
    return altitude > 0 || pitch || this instanceof Ellipse && bearing;
  },
  _getPaintParams: function _getPaintParams() {
    var map = this.getMap();
    if (this._paintAsPath()) {
      return Polygon.prototype._getPaintParams.call(this, true);
    }
    var pcenter = this._getPrjCoordinates();
    var pt = map._prjToPointAtRes(pcenter, map.getGLRes());
    var size = this._getRenderSize(pt);
    return [pt, ...size];
  },
  _paintOn: function _paintOn(...args) {
    if (this._paintAsPath()) {
      return Canvas.polygon(...args);
    } else {
      return Canvas.ellipse(...args);
    }
  },
  _getRenderSize: function _getRenderSize(pt) {
    var map = this.getMap(),
      glRes = map.getGLRes();
    var prjExtent = this._getPrjExtent();
    var pmin = map._prjToPointAtRes(prjExtent.getMin(), glRes),
      pmax = map._prjToPointAtRes(prjExtent.getMax(), glRes);
    return [Math.abs(pmax.x - pmin.x) / 2, Math.abs(pmax.y - pt.y), Math.abs(pt.y - pmin.y)];
  }
};
Ellipse.include(el);
Circle.include(el);
var rectangleInclude = {
  _getPaintParams: function _getPaintParams() {
    var map = this.getMap();
    var shell = this._getPrjShell();
    var points = this._getPath2DPoints(shell, false, map.getGLRes());
    return [points];
  },
  _paintOn: Canvas.polygon,
  _computeRotatedPrjExtent: _computeRotatedPrjExtent,
  getRotatedShell: getRotatedShell
};
Rectangle.include(rectangleInclude);
var sectorInclude = {
  _redrawWhenPitch: function _redrawWhenPitch() {
    return true;
  },
  _getPaintParams: function _getPaintParams() {
    if (this._paintAsPath()) {
      return Polygon.prototype._getPaintParams.call(this, true);
    }
    var map = this.getMap();
    var pt = map._prjToPointAtRes(this._getPrjCoordinates(), map.getGLRes());
    var size = this._getRenderSize(pt);
    var [startAngle, endAngle] = this._correctAngles();
    return [pt, size[0], [startAngle, endAngle]];
  },
  _paintOn: function _paintOn(...args) {
    if (this._paintAsPath()) {
      return Canvas.polygon(...args);
    } else {
      var map = this.getMap();
      var cache = MapStateCache[map.id];
      var r = cache ? cache.bearing : map.getBearing();
      if (r) {
        args[3] = args[3].slice(0);
        args[3][0] += r;
        args[3][1] += r;
      }
      return Canvas.sector(...args);
    }
  }
};
Sector.include(el, sectorInclude);
Path.include({
  _paintAsPath: function _paintAsPath() {
    return true;
  }
});
var lineStringInclude = {
  arrowStyles: {
    'classic': [3, 4]
  },
  _getArrowShape: function _getArrowShape(prePoint, point, lineWidth, arrowStyle, tolerance) {
    if (!prePoint || !point || prePoint.equals(point)) {
      return null;
    }
    if (!tolerance) {
      tolerance = 0;
    }
    var width = lineWidth * arrowStyle[0],
      height = lineWidth * arrowStyle[1] + tolerance,
      hw = width / 2 + tolerance;
    var normal;
    if (point.nextCtrlPoint || point.prevCtrlPoint) {
      if (point.prevCtrlPoint) {
        normal = point.sub(new Point(point.prevCtrlPoint));
      } else {
        normal = point.sub(new Point(point.nextCtrlPoint));
      }
    } else {
      normal = point.sub(prePoint);
    }
    normal._unit();
    var p1 = point.sub(normal.multi(height));
    normal._perp();
    var p0 = p1.add(normal.multi(hw));
    normal._multi(-1);
    var p2 = p1.add(normal.multi(hw));
    return [p0, point, p2, p0];
  },
  _getPaintParams: function _getPaintParams() {
    var prjVertexes = this._getPrjCoordinates();
    var points = this._getPath2DPoints(prjVertexes, false, this.getMap().getGLRes());
    return [points];
  },
  _paintOn: function _paintOn(ctx, points, lineOpacity, fillOpacity, dasharray, lineColorIn) {
    var r = isWithinPixel(this._painter);
    if (r.within) {
      Canvas.pixelRect(ctx, r.center, lineOpacity, fillOpacity);
    } else if (this.options['smoothness']) {
      Canvas.paintSmoothLine(ctx, points, lineOpacity, this.options['smoothness'], false, this._animIdx, this._animTailRatio);
    } else {
      ctx.lineColorIn = lineColorIn;
      Canvas.path(ctx, points, lineOpacity, null, dasharray);
    }
    this._paintArrow(ctx, points, lineOpacity);
    return this._getRenderBBOX(ctx, points);
  },
  _getArrowPlacement: function _getArrowPlacement() {
    return this.options['arrowPlacement'];
  },
  _getArrowStyle: function _getArrowStyle() {
    var arrowStyle = this.options['arrowStyle'];
    if (arrowStyle) {
      return Array.isArray(arrowStyle) ? arrowStyle : this.arrowStyles[arrowStyle];
    }
    return null;
  },
  _getArrows: function _getArrows(points, lineWidth, tolerance) {
    var _this = this;
    var arrowStyle = this._getArrowStyle();
    if (!arrowStyle || points.length < 2) {
      return [];
    }
    var isSplitted = points.length > 0 && Array.isArray(points[0]);
    var segments = isSplitted ? points : [points];
    var placement = this._getArrowPlacement();
    var arrows = [];
    var p1, p2;
    var createArrow = function createArrow() {
      if (p1 && p2) {
        var arrow = _this._getArrowShape(p1, p2, lineWidth, arrowStyle, tolerance);
        if (arrow) {
          arrows.push(arrow);
        }
      }
    };
    for (var i = segments.length - 1; i >= 0; i--) {
      var path = segments[i];
      var len = path.length;
      var first = path[0];
      var last = path[len - 1];
      if (placement === 'vertex-first') {
        p1 = first.arrowNextPoint || path[1];
        p2 = first;
      } else if (placement === 'vertex-last') {
        p1 = last.arrowPrePoint || path[len - 2];
        p2 = last;
      }
      createArrow();
      if (placement === 'vertex-firstlast') {
        p1 = first.arrowNextPoint || path[1];
        p2 = first;
        createArrow();
        p1 = last.arrowPrePoint || path[len - 2];
        p2 = last;
        createArrow();
      }
      if (placement === 'point') {
        this._getArrowPoints(arrows, path, lineWidth, arrowStyle, tolerance);
      }
    }
    return arrows;
  },
  _getArrowPoints: function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
    for (var ii = 0, ll = segments.length - 1; ii < ll; ii++) {
      var pre = segments[ii];
      var next = segments[ii + 1];
      var arrow = this._getArrowShape(next.arrowPrePoint || pre, next, lineWidth, arrowStyle, tolerance);
      if (arrow) {
        arrows.push(arrow);
      }
    }
  },
  _paintArrow: function _paintArrow(ctx, points, lineOpacity) {
    var lineWidth = this._getInternalSymbol()['lineWidth'];
    if (!isNumber(lineWidth) || lineWidth < 3) {
      lineWidth = 3;
    }
    var arrows = this._getArrows(points, lineWidth);
    if (!arrows.length) {
      return;
    }
    if (ctx.setLineDash) {
      ctx.setLineDash([]);
    }
    for (var i = arrows.length - 1; i >= 0; i--) {
      ctx.fillStyle = ctx.strokeStyle;
      Canvas.polygon(ctx, arrows[i], lineOpacity, lineOpacity);
    }
  }
};
LineString.include(lineStringInclude);
var polygonInclude = {
  _getPaintParams: function _getPaintParams(disableSimplify) {
    var glRes = this.getMap().getGLRes();
    var prjVertexes = this._getPrjShell();
    var points = this._getPath2DPoints(prjVertexes, disableSimplify, glRes);
    var isSplitted = points.length > 0 && Array.isArray(points[0]);
    if (isSplitted) {
      points = [[points[0]], [points[1]]];
    }
    var prjHoles = this._getPrjHoles();
    var holePoints = [];
    if (prjHoles && prjHoles.length > 0) {
      var simplified = this._simplified;
      for (var i = 0; i < prjHoles.length; i++) {
        var hole = this._getPath2DPoints(prjHoles[i], disableSimplify, glRes);
        if (Array.isArray(hole) && isSplitted) {
          if (Array.isArray(hole[0])) {
            points[0].push(hole[0]);
            points[1].push(hole[1]);
          } else {
            points[0].push(hole);
          }
        } else {
          holePoints.push(hole);
        }
      }
      if (simplified) {
        this._simplified = simplified;
      }
    }
    if (!isSplitted) {
      points = [points];
      pushIn(points, holePoints);
    }
    return [points];
  },
  _paintOn: function _paintOn(ctx, points, lineOpacity, fillOpacity, dasharray, lineColorIn) {
    var r = isWithinPixel(this._painter);
    if (r.within) {
      Canvas.pixelRect(ctx, r.center, lineOpacity, fillOpacity);
    } else {
      ctx.lineColorIn = lineColorIn;
      Canvas.polygon(ctx, points, lineOpacity, fillOpacity, dasharray, this.options['smoothness']);
    }
    return this._getRenderBBOX(ctx, points);
  }
};
Polygon.include(polygonInclude);

Map$1.VERSION = version;
var worker = {
  Actor: Actor
};
checkMTKVersion(version);

export { Ajax, ArcConnectorLine, ArcCurve, AreaTool, bbox as BBOXUtil, Browser$1 as Browser, COLOR_PROPERTIES, CRS, Canvas, CanvasLayer, CanvasTileLayer, Circle, Class, CollisionIndex, ConnectorLine, Coordinate, CubicBezierCurve, Curve, DEFAULT_TEXT_SIZE, DistanceTool, dom as DomUtil, DragHandler, DrawTool, DrawToolLayer, Ellipse, Eventable, Extent, GEOJSON_TYPES, GEOMETRY_COLLECTION_TYPES, GeoJSON, Geometry, GeometryCollection, GlobalConfig, GlobalEvent, GroupTileLayer, Handler, Handlerable, INTERNAL_LAYER_PREFIX, ImageLayer, JSONAble, LRUCache, Label, Layer, LineString, Map$1 as Map, MapStateCache, MapTool, index$7 as MapboxUtil, Marker, MicroTask, MultiLineString, MultiPoint, MultiPolygon, NUMERICAL_PROPERTIES, OverlayLayer, ParticleLayer, Point, PointExtent, Polygon, QuadBezierCurve, RESOURCE_PROPERTIES, RESOURCE_SIZE_PROPERTIES, Rectangle, ResourceProxy, Sector, Size, SpatialReference, strings as StringUtil, TextBox, TextMarker, TileConfig, TileLayer, TileSystem, Transformation, index$6 as Util, VectorLayer, WMSTileLayer, animate, Animation$1 as animation, index$1 as control, formatResourceUrl, getDefaultSpatialReference, getResouceCacheInstance, index$5 as math, index$4 as measurer, parseSVG, projections as projection, registerWorkerAdapter, index as renderer, index$3 as symbolizer, index$2 as ui, worker };
//# sourceMappingURL=maptalks.es.js.map
